// import * as versionF from '../../version';
import { cfClassDeltaInvalidate } from '@/utils/cfEval'
import { PyWorkerPool, pyWorker_poolSize } from '@/utils/pyWorkerPool' // IE 2026 09 05 / ODOO-336379: пул воркеров pyodide для python-пересчёта после правки
import { defineStore } from 'pinia'
import { cellRulesChip_is, cellRulesChip_strip, CELL_RULES_DATA_METHODS } from '@/utils/cellRules'   // IE 2026 09 20 / ODOO-5800 (Igor через ie-dm7 #32448: команда «открыть список правил» блока RULES формы ячейки)
import { listHistoryDs_overlayStripRecord } from '@/utils/listHistoryDs'   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): оверлей WHERE «Show in list» вкладки истории списка — только в памяти, в сохранение не едет
import { searchTerms, foundTerms, highlightRanges, searchPhrase, phraseRanges } from '@/utils/searchMatch' // IE 2026 09 12 / ODOO-… (заказ Игоря): поиск по частям + опечатки
import altTooltip from '@/utils/altTooltip' // IE 2026 09 07 / ODOO-337259: зажатый Alt — подсказки видны (tooltips_on)
import { saveTruncatedRetry_on, saveOutcome_answer, saveOutcome_error, SAVE_RETRY_DELAY_MS, request_isWrite, abort_allowed } from '@/utils/saveOutcome'   // IE 2026 10 13 / ODOO-5800: обрезанный / отклонённый сейв не снимает modified, один повтор (fe.ux.saveTruncatedRetry)
import { workspaceGoto } from '@/utils/workspaceGoto'   // IE 2026 09 28 / ODOO-342342: переход на стол / страницу из строки меню страницы (Launchpad ↔ «Путеводитель»)
import { tipActions_html, tipActions_bind, tipActions_callback, recordActions, pageTip_fn, pageGroupTip_fn, workspaceTip_fn, categoryTip_fn } from '@/utils/tipActions' // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках)
import recordHelp from '@/utils/recordHelp' // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: объяснения записей в подсказках — транспорт record_help, кэш, «Edit description»
import { langPendingKey, readLangPending, writeLangPending, clearLangPending, LANG_PENDING_MAX_AGE_MS } from '@/i18n/langPending' // IE 2026 10 01 / ODOO-341407: выбор языка, не дошедший до бэка, не перебивается языком USER; IE 2026 10 07 / ODOO-341407: только сохранение в полёте (ODOO-345045)
import { t, tn, getLanguage, getLocale, getUiLocale, setLanguage as i18n_setLanguage, adoptServerLanguage, adoptDbDefaultLanguage, LANGUAGES as I18N_LANGUAGES, switchLanguageLive as i18n_switchLive, switchWithoutReload as i18n_switchWithoutReload, isLanguageEnabled as i18n_isEnabled, enforceEnabledLanguage as i18n_enforceEnabled } from '@/i18n' // IE 2026 09 23 / ODOO-341407: словарь UI-строк, язык интерфейса; IE 2026 09 25 / ODOO-341407: adoptDbDefaultLanguage; IE 2026 09 26 / ODOO-341407: языки, включённые в базе
import { firstLoadDecision as i18n_firstLoadDecision, reloadNow as i18n_reloadNow, firstLoadSettled as i18n_firstLoadSettled } from '@/i18n'   // IE 2026 09 26 / ODOO-341407: fe.i18n.firstLoadHold — решение о языке на первом ответе с настройками базы, перезагрузка без сборки стола
import { durUnit, formatTimeText } from '@/utils/durationText'   // IE 2026 09 24 / ODOO-341407: единицы длительности под язык интерфейса («5 міс 19 дн», «1,1 р»); IE 2026 09 29 / ODOO-341407: formatTimeText — тело formatTimeHTML (формат 'd')
import { relocalize as i18n_relocalize, i18nPendingOnActivate as i18n_pendingOnActivate, i18nRefreshOnActivate as i18n_refreshOnActivate,
    dictPrefetch as i18n_dictPrefetch, switchFlag as i18n_switchFlag, cacheKeyLangStale as i18n_cacheKeyLangStale } from '@/i18n/relocalize'   // IE 2026 09 24 / ODOO-341407: переключение языка без перезагрузки — перелокализация подписей бэка на клиенте; + отчёты неактивных страниц при активации; IE 2026 09 25: флаги ускорения (предзагрузка словарей, ключ кэша прежнего языка)
import { loginHoldTarget as i18n_loginHoldTarget } from '@/i18n/loginHoldTarget'   // IE 2026 11 02 / ODOO-350612: адрес перезагрузки после входа при смене языка

// IE 2026 09 24 / ODOO-341407: служебные ключи локализации бэка (`_i18n` + бэкап исходника `<key>_en`, attrs._i18n_apply) не должны
// попадать в базу: строки WHERE стола локализуются НА МЕСТЕ и уезжали в user_defaults_save / workspace_defaults_save как есть,
// а через saveRecord — с любой записью, где бэк их оставил. Снимаем рекурсивно, copy-on-write: объект в памяти не трогаем (чипсы
// показывают перевод), в запрос уходит копия с английской базой (`<key>_en` → key; '' = ключа не было)
export function i18n_strip_service_keys(obj, depth = 0) {
    if (!obj || typeof obj !== 'object' || depth > 40) return obj
    if (Array.isArray(obj)) {
        let out = null
        for (let i = 0; i < obj.length; i++) {
            const v = obj[i], nv = i18n_strip_service_keys(v, depth + 1)
            if (nv !== v) { if (!out) out = obj.slice(); out[i] = nv }
        }
        return out || obj
    }
    let out = null
    if (obj._i18n) {
        out = { ...obj }
        for (const k of Object.keys(out)) {
            if (!k.endsWith('_en') || k === '_en') continue
            const key = k.slice(0, -3), src = out[k]
            delete out[k]
            if (src === '') delete out[key]; else if (typeof src === 'string') out[key] = src
        }
        delete out._i18n
    }
    const src = out || obj
    for (const k of Object.keys(src)) {
        const v = src[k]
        if (!v || typeof v !== 'object') continue
        const nv = i18n_strip_service_keys(v, depth + 1)
        if (nv !== v) { if (!out) out = { ...obj }; out[k] = nv }
    }
    return out || obj
}
import { tasksPanel_hasStatuses, tasksPanel_bareIds } from '@/utils/tasksPanel' // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): признак статусов задач в записи стола (tasksBar_fromRecord)
import { xlsxVisibleOnly_install, xlsxVisibleOnly_supported, xlsxVisibleOnly_begin, xlsxVisibleOnly_end, xlsxVisibleOnly_includeColumns, xlsxVisibleOnly_hiddenCounts } from '@/utils/xlsxVisibleOnly' // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок)
import freeWidgets from '@/utils/freeWidgets' // IE 2026 09 08 / ODOO-… (заказ Игоря): режимы поведения свободных виджетов
import { listLimitInfo, listLimitSig } from '@/utils/listLimit'   // IE 2026 09 27 / ODOO-5800: неполная выборка списка — перечитывание Ганта после вкладки List (ganttMoves_rereadOnShow)
import { hotkeyOnce_claim, hotkeyOnce_on } from '@/utils/hotkeyOnce'   // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select)
import { clipboardCommand } from '@/utils/clipboardCopy'   // IE 2026 11 03 / ODOO-349799 (clipboard target): приёмник «Буфер обміну» Compare & merge — команда copyToClipboard
import { pmHistory_recordForRequest } from '@/utils/pmHistoryRecordSlim'   // IE 2026 10 30 / ODOO-5800 (p099: pm_history record slim)
import { net_actionId as netCancel_actionId, net_requestParams as netCancel_requestParams, net_on204 as netCancel_on204 } from '@/utils/netCancel' // IE 2026 09 26 / ODOO-5800: номер действия на бэк уникален на вкладку, безопасный 204 (fe.net.*)
import { langProfile_saveDone, langProfile_readonlyWarn } from '@/utils/langProfile'   // IE 2026 10 03 / ODOO-345045 (заказ Игоря: язык — профиль перечитывать, сохранение языка не молчит): профиль перечитывается после смены языка, сбой сохранения языка не молчит
import { docsNav_panelSwap, docsNav_applyTitle, docsNav_dropStaleCaps } from '@/utils/docsNav'   // IE 2026 09 28 / ODOO-342342: + docsNav_dropStaleCaps (ревью п.5); уже открытая панель документации — на новый документ, а не активация со старым; + заголовок читалки — H1 документа при открытии (fe.help.readerTitleH1)
import { chipWidget_skipSubstituted } from '@/utils/chipWidgetOpen'   // IE 2026 10 08 / ODOO-5800
import { scheduleChip_on, scheduleChip_list, scheduleChip_answer, scheduleChip_supported, scheduleChip_delay, scheduleChip_stampChanged, scheduleChip_stale, scheduleChip_canAsk } from '@/utils/scheduleChip'   // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): чипс шапки стола «Regimen paused until …» (fe.ux.scheduleHeaderChip)
import { settingsFormLazy_on, settingsFormPrefetch_on, sfl_stubs, sfl_count, sfl_reason, sfl_denyByRole, sfl_wholeViewPatch, FLAG_WHOLE_VIEW_GUARD } from '@/utils/settingsFormLazy'   // IE 2026 10 10 / ODOO-341407: + sfl_wholeViewPatch, FLAG_WHOLE_VIEW_GUARD   // IE 2026 09 28 / ODOO-5800: форма настроек виджета по требованию // IE 2026 09 29 / ODOO-342781 (ревью F1): + sfl_denyByRole
// IE 2026 09 28 / ODOO-342342 (Use cases): «Бизнес-кейсы» на «Путеводителе» — «Open in demo», полоса пути, личные отметки (utils/guidePlay.js, guidePersonal.js, guideCases.js;
// контракт бэка v1 — ie-webscm7-2 docs/userdocs-2026-09-25/use_cases_api_contract_2026-09-28.md). Выключатель fe.guide.cases (по умолчанию вкл.)
import { guidePlay_start, guidePlay_busy, guidePlay_step, guidePlay_jump, guidePlay_back, guidePlay_end, guidePlay_current, guidePlay_applyPending, guidePlay_chipsKeepHeld, guideApi_send, guideBackup_restore, guideBackup_list, guidePlay_cta } from '@/utils/guidePlay'   // IE 2026 09 28 / ODOO-342342: + guidePlay_busy (ревью З8), guidePlay_chipsKeepHeld (ревью З4); IE 2026 09 30 / ODOO-343435: + guidePlay_cta
import { navigator_defaultState, navigator_on, NAVIGATOR_MODES, navigator_settingsFromAnswer, navigator_next, navigator_withSaved, navigator_loadSaved } from '@/utils/navigator'   // demo-webscm 2026 11 02 / ODOO-350612: правый док навигатора интерфейса; live48: настройки с бэка стенда
import { guideLink_take } from '@/utils/guideLink'   // IE 2026 09 30 / ODOO-343435: вход в тур ссылкой ?guide_path=<id>&step=<n>
import { marks_ensure, marks_localLoad, marks_fav, marks_pos, personal_set, personal_load, marks_applyRecord, marks_recordPersonal } from '@/utils/guidePersonal'   // IE 2026 09 28 / ODOO-342342: + marks_localLoad (Н1); IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): + marks_applyRecord, marks_recordPersonal (marks_done — внутри marks_recordPersonal)
import { guideCases_on, guideCases_link, guideCases_count, guideCases_tourOn } from '@/utils/guideCases'   // IE 2026 09 28 / ODOO-342342: + guideCases_count (ревью З8); IE 2026 09 30 / ODOO-343435: + guideCases_tourOn
import { guidePath_fromPlan, guidePath_fromRows, guidePath_startIndex } from '@/utils/guidePath'   // IE 2026 09 28 / ODOO-342342 (приёмка Н2): стартовый шаг пути
import { gridText_multiDisplay } from '@/utils/gridText'   // IE 2026 09 28 / ODOO-342342 (приёмка Д4): подпись мульти-значения с переводами на базовом языке
import { saveAsTest_params } from '@/utils/saveAsTest'   // IE 2026 09 28 / ODOO-342342 (п.14): страница в запросе save_as_test
import { openRecord_take, OPEN_RECORD_DELAY_BUILD, OPEN_RECORD_DELAY_BUILT } from '@/utils/openRecordLink'   // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 Д8): ссылка open_record и на уже построенной странице
import { settingsPage_on, settingsPage_materialize, settingsPage_pick, settingsPage_isTemp, SETTINGS_PAGE_ID } from '@/utils/settingsPage'   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц)
import { pageGotoChip_config, pageGotoChip_run } from '@/utils/pageGotoChip'   // IE 2026 09 30 / ODOO-343433: клик по строке REPORT2 → страница стола с чипсом из значения строки
import { RO_TEXT_DENIED, RO_TEXT_EDIT, ro_normPolicy, ro_allowsRequest, ro_allowsAction, ro_hides, ro_denial, ro_parseRequest, ro_filterMenu, ro_isQuiet, ro_localEpochFilter, ro_localEpochStamp,
    ro_storeDenies, ro_prefilterBody, ro_denialResponse, ro_startupRole, ro_applyRole } from '@/utils/readonlyPolicy'   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — чистая логика политики (признак и белые списки — от бэка) // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7): + F2 F3 F4
import { RO_ARCHIVE_TEXT_EDIT, RO_ARCHIVE_TEXT_DENIED, ro_isArchivePm, ro_archiveAllowsAction, ro_pmVersions, ro_isModelDataWidget, ro_archiveLocksGrid } from '@/utils/readonlyPolicy'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + архивная ПМ — только чтение в интерфейсе
// IE 2026 09 05 / ODOO-336379 (заказ Игоря): выключатели фронтовых доработок на уровне записи отчёта — параметр
// doc.params.fe_*_off (настройки → Params → Frontend) гасит группу perf-флагов; вне pinia-actions, т.к. actions —
// только функции (объект внутри actions терялся: FE_OFF_PARAMS = [] в прогоне 09:3x)
const FE_OFF_PARAMS = {
    fe_py_worker_off: ['py_worker', 'py_worker_pool', 'py_worker_reaggr'],
    fe_after_edit_scope_off: ['afterEdit_scope_sku', 'afterEdit_scope_warm', 'afterEdit_scope_multi', 'afterEdit_warm_idle', 'afterEdit_warm_main'],
    fe_css_wave_off: ['css_invalidate_scoped', 'css_memo_rowsig', 'frozen_clip_batch', 'css_py_raw', 'css_py_batch'],
    fe_paste_batch_off: ['paste_batch'],
    fe_save_delta_off: ['save_delta'],
    fe_reject_fast_off: ['reject_in_beginning_edit', 'reject_flash_direct'],
}
const FE_OFF_BY_FLAG = Object.fromEntries(Object.entries(FE_OFF_PARAMS).flatMap(([param, flags]) => flags.map(f => [f, param])))
import * as wjcCore from '@mescius/wijmo';
import * as wjGrid from '@mescius/wijmo.grid';
import * as wjcOlap from '@mescius/wijmo.olap';

import * as wjcGrid from '@mescius/wijmo.grid';
import * as wjcGridXlsx from '@mescius/wijmo.grid.xlsx';
import * as wjcXlsx from '@mescius/wijmo.xlsx';
import * as gridPdf from '@mescius/wijmo.grid.pdf';
import * as pdf from '@mescius/wijmo.pdf';
import { CellRange, ClipStringOptions } from '@mescius/wijmo.grid';
import { saveFile } from '@mescius/wijmo';
import { version } from 'process';
import { reactive, toRaw, markRaw } from 'vue'   // IE 2026 09 16: toRaw — поиск строки дерева по тождеству (iroot)
import { e, re, string } from 'mathjs';
import { nextTick } from "vue";
import pako from "pako";
import * as testRecorder from './testRecorder'
import { metricChip_wire, chipDict_request } from '@/utils/metricChip'   // IE 2026 10 04 / ODOO-5800 (fe-78): отбор чипса сигналов с причинами — для бэка явными комбинациями
import { enabledLanguages as i18n_enabledLanguages } from '@/i18n'   // IE 2026 10 06 / ODOO-341407: языки полей переводов — включённые в базе (i18n_fieldLangs)
import { selectorCols_map } from '@/utils/selectorCols'   // IE 2026 10 24 / ODOO-347321: канал селектора → колонка строки (по fieldSelectors виджета)
import { MFA_BASE } from '@/utils/mfa'   // Odoo 350042: двухфакторный вход
import { selOwnByWidget_filter } from '@/utils/selectorOwnByWidget'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: селектори столу у теплокартах закупівель); IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): свой Set-канал — отметка, не отбор (выкл. — только чипс этого виджета)
import { loginErrorText } from '@/utils/loginProgress'   // IE 2026 10 16 / ODOO-347204: причина отказа входа словами
import { pmParams_merge, pmParams_runtime, pmParams_linkAttrs } from '@/utils/pmParams'   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: параметры панели после смены ПМ) (pmParams-patch v3)
import { gridSaveBar_on, gridSave_baseline, gridSave_restoreRows, gridSave_diff, gridSave_payload, gridSave_dirtyList, gridSave_outcome, gridSaveGuard_on, gridSave_guardVerdict } from '@/utils/gridSaveBar'   // IE 2026 10 13 / ODOO-5800: полоса Save ленивых гридов вкладки, гард несохранённого (fe.ux.gridSaveBar)
import { lazyTab_binding } from '@/utils/lazyTabReveal'   // IE 2026 10 16 / ODOO-5800: ответ ленивой вкладки → панель чинит грид
import { selectTab_on, selectTab_plan } from '@/utils/selectTab'   // IE 2026 10 30 / ODOO-349799: ответ updateDoc с selectTab переключает вкладку панели виджета
import { refs_cellRef } from '@/utils/refsTarget'   // webscm 2026 10 25 / ODOO-4334 (шаг 1): Shift+F3 — id и модель ссылки / своей записи
import { graphRowsRef_requestParams, graphRowsRef_restore, graphPayload_take } from '@/utils/graphPayload'   // webscm 2026 10 26 / ODOO-348733: ответ сетевого графа — строки без второй копии узлов / рёбер, данные графа без глубокой реактивности
import { heatmapStep_on, heatmap_period_requestParams } from '@/utils/heatmapMatrix'   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: группировка по місяцях і роках, період)
import { itemsSourceAll_isTruncated, itemsSourceAll_keepResolved, itemsSourceAll_remember, itemsSourceAll_settle } from '@/utils/itemsSourceCap'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса): неполный ответ 'all' (потолок бэка) — словарь не считается полным
import { mtl_answered, mtl_segments, mtl_valueMulti, mtl_keepWarning } from '@/utils/multiTypeLinks'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
import { linkTextToId_on, linkLegacyTitleToId_on, linkIsRef, linkResolveText, linkLegacyResolve } from '@/utils/linkTextToId'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
import { stalePageGuard_on, inDeactivatedTree } from '@/utils/stalePage'   // IE 2026 10 17 / ODOO-5800: компонент деактивированной KeepAlive-страницы в реестры виджета не пишется (fe.ux.stalePageGuard)
import { shortcutTitle_take, shortcutTitle_ownMethod, shortcutTitle_on } from '@/utils/shortcutTitle'   // IE 2026 11 02 / ODOO-349799 (shortcut-title): заголовок окна ярлыка из ответа на его действие (fe.ux.shortcutTitle)
import { importRecordsMenu_on, importRecords_run, importRecords_emptyAction, importRecords_backendAction, importRecords_normalizeAction, importRecords_pasteThen_on, importRecords_pasteUnbuiltGrid_on, importRecords_gridBuilt, importRecords_ensureGridBuilt, importRecords_normalizeRows, importRecords_rowsFromAnswer } from '@/utils/importRecords'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка): пункт меню «Import records» (fe.ux.importRecordsMenu)   // IE 2026 10 28 / ODOO-349799 (PR5): нормализация вставки / файла в таблицу Records Import на бэке
import { KEEP_ROW_FORMS_MARK, rowForm_contentOpts } from '@/utils/rowFormGate'   // IE 2026 10 13 / ODOO-5800: фоновое обновление (опрос каскада / финиш прогона) не закрывает формы строк (fe.ux.pollKeepsRowForm)
import { relationRow_rowIndex } from '@/utils/relationRow'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
import { adf_kick } from '@/utils/auditDiff'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): D1 — форма из аудита после записи ответа в сырой WIDGET
import { cellPie_isViewButton, cellPie_flagOn } from '@/utils/cellPie'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення)
import { cellView_activeOf, cellView_fromLegacy, cellView_key, cellView_get, CELL_VIEW_ALIASES } from '@/utils/cellViews'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): активный вид — WIDGET._cellView
import { cellViewBtn_is, cellViewBtn_id, cellViewBtn_variant, cellViewState_next, cellViewState_seen, cellViewState_mark, cellViewState_sync } from '@/utils/cellViewState'
import { cellViewGate_on, cellViewBtn_headerDupes, cellViewBtn_dupesFirst } from '@/utils/cellViewState'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 кола — за натиснутим видом у смузі, без опції «Кругові за статусами»)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): одна активная кнопка вида   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): cellViewBtn_variant
import { request_isBackground } from '@/utils/signalChainsPrefetch'   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0)
import { mergeCellViews, cellViews_answerOf, cellView_dataReadyOf, cellViews_backendSupports, cellViews_deferredOn, CELL_VIEWS_METHOD } from '@/utils/cellViewsMerge'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): отложенные данные видов
import { branchConflict_fromAnswer, branchConflict_message, branchConflict_retryAction } from '@/utils/branchApplyConflict'   // IE 2026 10 30 / ODOO-345618 (apply_branch: conflict override dialog)
import { activityPing_tabId } from '@/utils/activityPing'   // IE 2026 11 03 / ODOO-350449 (activity ping): uuid вкладки (sessionStorage) → client.tab_id
import { approvalHistoryModel, approvalDoc as approval_doc, approvalMeasureTitle as approval_measureTitle, approvalFlagEdited as approval_flagEdited, approvalNotification as approval_notification, approvalCascadeRows as approval_cascadeRows } from '@/utils/approval'   // IE 2026 10 15 / ODOO-5800: cascade_rows ответа save   // IE 2026 10 09 / ODOO-345618 (F2): модель окна истории согласования (answer.approval_history)
import { localizeBinding as i18nFields_localizeBinding, fieldLangs as i18nFields_langs, autoUnmarkAt as i18nFields_autoUnmarkAt, stripAutoForSave as i18nFields_stripAutoForSave,
    i18nFieldsKind, i18nFieldsAvail, i18nFieldsOn, i18nFieldsSet } from '@/utils/i18nFields'   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1 / п.2): поля переводов в UI — путь перевода, опция «Show translation fields», словарный перевод при сохранении списка
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): состояние отложенных данных видов ячеек на виджет (вне WIDGET — не уходит в сериализацию и не реактивно):
// { ver — версия основного ответа (растёт при смене объекта record._doc), doc, pending: { вид: ver }, tried: { вид: ver } }
const _cellViewSt = new WeakMap()
const PYODIDE_CDN = 'https://cdn.jsdelivr.net/pyodide/v0.23.4/full/pyodide.js'

// DR-016: new-infra features are opt-in via build-time env flag.
// Unset/false -> OLD-infra compatibility mode: the login string contains the
// database (email / company / db), /select-database and OAuth do not exist.
export const IS_NEW_INFRA = ['1','true','yes','on'].includes(String(process.env.VUE_APP_IS_NEW_INFRA || '').toLowerCase())

// ODOO-3216: admin-словари — сегменты, тайтлы которых резолвит FE-стор (id-канон
// в данных: никаких [id,title]-пар и серверных JOIN'ов тайтлов; резолв —
// resolveTitles / get_itemsSource(by_ids)). Для этих крошечных словарей AttrLink
// делает одноразовый session full-fetch (дропдауны форм: в by_ids-режиме список
// пуст, пока не был запрошен полный словарь). Первый шаг — только словари
// admin-кокпита и визардов provision; список расширяем.
export const ADMIN_DICT_SEGMENTS = ['COMPANY', 'SERVER-BACKEND', 'SERVER-PG', 'SERVER-VM', 'REPO', 'DATABASE',
    'HETZNER-SERVER-TYPE', 'HETZNER-LOCATION']

// ODOO-3724: маркер-значение «пусто» для фильтров/чипсов/селекторов.
// Кладётся в rightValue.value вместо пустого значения строки-измерения;
// бэкенд разворачивает его в SQL-предикат пустоты по типу поля
// (my_database.py: EMPTY_VALUE_MARKER / sql_empty_predicate) и резолвит
// тайтл как 'Empty' в get_itemsSource(by_ids). Значение должно байт-в-байт
// совпадать с бэкендом.
export const EMPTY_VALUE_MARKER = '<isempty>'

// Цветовые гаммы UI — единый источник правды: из него строится подменю в
// AppTopbar и по нему валидируется значение в applyColorScheme / main.js.
// Порядок массива = порядок пунктов в меню. id → CSS-класс на body: cscheme-<id>.
// CSS каждой схемы: заголовки таблиц в AttrGrid.vue, топбар/page-фон в App.vue.
// Подписи (title) — ровно как утверждено; IE 2026 09 23 / ODOO-341407: 'Style 1c' теперь с ЛАТИНСКОЙ c —
// title служит ключом словаря i18n (t(s.title) в AppTopbar). 'classic' — дефолт (без переопределений).
export const COLOR_SCHEMES = [
    { id: 'classic', title: 'Classic' },
    { id: 'style1c', title: 'Style BAS' },   // IE 2026 09 28 / ODOO-342342: 1С → BAS в названии (id прежний);   // 1С:Предприятие — тёплый бежево-золотой; IE 2026 09 23 / ODOO-341407: латинская c — title = ключ словаря i18n
    { id: 'style2o', title: 'Style 2o' },   // Odoo — белые шапки, фиолетовый топбар
    { id: 'style3k', title: 'Style 3k' },   // Kinaxis — тёмно-синий + бирюзовый акцент
    { id: 'style4s', title: 'Style 4s' },   // SAP Fiori — серые шапки, sine-серый shell
    { id: 'style5f', title: 'Style 5f' },   // Claude (macOS) — тёплый oat/cream + clay-акцент
    { id: 'style6m', title: 'Style 6m' },   // IE 2026 08 23: McDonald's — белый фон, жёлтый акцент
    { id: 'style7w', title: 'Style 7w' },   // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): Star Wars — космос, жёлтый титр, голубой луч
]

// Валидный id гаммы: неизвестное → 'classic'. 'style2' (старый localStorage/бэк)
// мигрируем в 'style2o' для обратной совместимости.
// IE 2026 08 23 (заказ Игоря): дефолтная гамма — на мобильном профиле style6m,
// если пользователь не выбирал схему явно; условие мобильности — как в mobileUi
export function initialColorScheme() {
    try {
        const raw = localStorage.getItem('webscm_colorScheme')
        if (raw) return normalizeColorScheme(raw)
        const mu = JSON.parse(localStorage.getItem('mobileUi') || '{}')
        const auto = mobileAuto()   // IE 2026 09 04 / ODOO-336330: пороги 480/820 — настройки базы
        let on = mu.enabled == null ? auto : !!mu.enabled
        const m = /[?&#]mobile=([01])/.exec(location.href)
        if (m) on = m[1] === '1'
        // IE 2026 09 05 / ODOO-336330: гамма по умолчанию — настройки базы fe.appearance.colorSchemeMobile /
        // colorSchemeDesktop (зеркало localStorage: код идёт до createApp); кодовые дефолты style6m / classic
        return normalizeColorScheme(feSettingEarly(on ? 'fe.appearance.colorSchemeMobile' : 'fe.appearance.colorSchemeDesktop', on ? 'style6m' : 'classic'))
    } catch (e) { return 'classic' }
}

// ============ IE 2026 09 04 / ODOO-336330: глобальные настройки БАЗЫ на фронте ============
// Бэк кладёт FE-подмножество doc.params.fe.* записи SETTINGS в answer.settings
// ({version, fe}) ответов login / check_sessionKey / workspace_open; store.settings_apply
// сохраняет его и зеркалит в localStorage 'feSettings.db'. Значения читать ТОЛЬКО через
// store.setting('fe.<группа>.<ключ>', <кодовый дефолт>):
//     1) override сеанса/пользователя — URL ?fe.<ключ>=… или localStorage 'feSettings'
//        (window.feSettings.set / .reset),
//     2) значение базы,
//     3) кодовый дефолт (литерал, который стоял в коде до правки).
// Код, работающий ДО createApp (классы body в main.js), store не видит — для него
// feSettingEarly читает те же два зеркала из localStorage.
export function feSettingPath(fe, key) {
    let v = fe
    for (const part of String(key).replace(/^fe\./, '').split('.')) {
        if (!v || typeof v !== 'object') return undefined
        v = v[part]
    }
    return v
}

export function feSettingEarly(key, def_) {
    try {
        const ov = JSON.parse(localStorage.getItem('feSettings') || '{}')
        if (key in ov) return ov[key]
    } catch (e) { /* приватный режим / чужой формат — кодовый дефолт */ }
    try {
        const v = feSettingPath(JSON.parse(localStorage.getItem('feSettings.db') || '{}'), key)
        if (v !== undefined && v !== null && v !== '') return v
    } catch (e) { /* приватный режим — кодовый дефолт */ }
    return def_
}

// Единое правило авто-детекта мобильного профиля (было продублировано 4 раза литералами
// 480/820): пороги — настройки базы fe.mobile.autoMaxWidthPx / autoCoarseMaxWidthPx
export function mobileAuto() {
    try {
        const w = Number(feSettingEarly('fe.mobile.autoMaxWidthPx', 480)) || 480
        const c = Number(feSettingEarly('fe.mobile.autoCoarseMaxWidthPx', 820)) || 820
        return window.matchMedia(`(max-width: ${w}px)`).matches
            || (window.matchMedia('(pointer: coarse)').matches && window.matchMedia(`(max-width: ${c}px)`).matches)
    } catch (e) { return false }
}

export function normalizeColorScheme(scheme) {
    if (scheme === 'style2') return 'style2o'   // миграция старого значения
    return COLOR_SCHEMES.some(s => s.id === scheme) ? scheme : 'classic'
}

// ============ IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок) ============
// Схемы иконок — настройка, НЕЗАВИСИМАЯ от цветовой гаммы (своё подменю, свой ключ localStorage,
// свой ключ в USER.doc.params). Аббревиатуры те же, что у гамм: глифы в духе того же бренда,
// плюс 7w (Star Wars). id → класс на body ischeme-<id> + класс семейства шрифта ischeme-<family>
// (ms — Material Symbols, fa — Font Awesome 4, swg — Star Wars Glyph Icons). Правила — 
// src/assets/styles/ie-icon-schemes.css (генератор tools/icons/icon_schemes.py); иконки без
// соответствия в семействе остаются primeicons / ie-ico-* (фолбэк по шрифту).
export const ICON_SCHEMES = [
    { id: 'classic', title: 'Classic', family: '' },       // primeicons + ie-ico-* как есть
    { id: 'style1c', title: 'Style BAS', family: 'ms' },   // IE 2026 09 28 / ODOO-342342: 1С → BAS в названии (id прежний);    // 1С — Material Symbols Sharp, залитые; IE 2026 09 23 / ODOO-341407: латинская c — title = ключ словаря i18n
    { id: 'style2o', title: 'Style 2o', family: 'fa' },    // Odoo — Font Awesome 4 (шрифт иконок Odoo)
    { id: 'style3k', title: 'Style 3k', family: 'ms' },    // Kinaxis — Material Symbols Outlined, тонкие
    { id: 'style4s', title: 'Style 4s', family: 'ms' },    // SAP Fiori — Material Symbols Sharp, контурные
    { id: 'style5f', title: 'Style 5f', family: 'ms' },    // Claude — Material Symbols Rounded, тонкие
    { id: 'style6m', title: 'Style 6m', family: 'ms' },    // McDonald's — Material Symbols Rounded, залитые
    { id: 'style7w', title: 'Style 7w', family: 'swg' },   // Star Wars — Star Wars Glyph Icons (открытый набор, рыба)
]
export function normalizeIconScheme(scheme) {
    return ICON_SCHEMES.some(s => s.id === scheme) ? scheme : 'classic'
}
// дефолт: явный выбор (localStorage) → настройка базы fe.appearance.iconSchemeMobile / iconSchemeDesktop → classic
export function initialIconScheme() {
    try {
        const raw = localStorage.getItem('webscm_iconScheme')
        if (raw) return normalizeIconScheme(raw)
        const mu = JSON.parse(localStorage.getItem('mobileUi') || '{}')
        let on = mu.enabled == null ? mobileAuto() : !!mu.enabled
        const m = /[?&#]mobile=([01])/.exec(location.href)
        if (m) on = m[1] === '1'
        return normalizeIconScheme(feSettingEarly(on ? 'fe.appearance.iconSchemeMobile' : 'fe.appearance.iconSchemeDesktop', 'classic'))
    } catch (e) { return 'classic' }
}
export function iconSchemeClasses(id) {
    const s = ICON_SCHEMES.find(x => x.id === id) || ICON_SCHEMES[0]
    return [`ischeme-${s.id}`, ...(s.family ? [`ischeme-${s.family}`] : [])]
}
// классы на body (wijmo рисует меню/редакторы порталом в body): снять все прежние ischeme-*, повесить актуальные
export function applyIconSchemeClasses(id) {
    const body = document.body
    if (!body) return
    ICON_SCHEMES.forEach(s => { body.classList.remove(`ischeme-${s.id}`); if (s.family) body.classList.remove(`ischeme-${s.family}`) })
    iconSchemeClasses(id).forEach(c => body.classList.add(c))
}

export const useMainStore = defineStore('mainStore', {
    state: () => ({
        version_frontend: process.env.VUE_APP_CONFIG_VERSION,
        updateBannerOffset: 0, // IE 2026 08 27 / ODOO-5800: высота полосы плашки версии под шапкой (px), 0 = плашки нет
        wsAlertSig: '', // IE 2026 11 01 / ODOO-350597: подпись показанного ряда предупреждения страницы (App.vue wsAlertSig) — рейл страницы без раскладки пересчитывает отступ в том же проходе, что и шапка (иначе кадр со старой высотой шапки)
        topbarBottom: null, // IE 2026 11 01 / ODOO-350597: низ шапки .topbar (px, offsetTop + offsetHeight; App.vue: mounted / topBanners_layout / resize) — реактивный источник отступа рейла у страницы без раскладки (utils/topbarMargin)
        refBadge_by_widget: {}, // IE 2026 08 28 / ODOO-5800: id теста данных по WIDGET.id — бейдж «Reference view» (кладёт вотчер AttrChips: цепочка record.doc.params в Widget.vue не всегда реактивна)
        // ИЕ 2026-08-14: версия, которую отдаёт сервер СЕЙЧАС (meta в index.html).
        // Отличается от version_frontend — вкладка живёт на устаревшем бандле
        version_frontend_served: '',
        version_outdated: false,     // показать плашку «обновите страницу»
        version_outdated_hidden: false, // пользователь закрыл плашку для ЭТОЙ версии
        version_outdated_served_shown: '', // для какой выложенной версии плашку уже показывали
        version_backend: '',
        url_backend_login: `${process.env.VUE_APP_BACKEND_URL}/login/`,
        url_backend_api: `${process.env.VUE_APP_BACKEND_URL}/api/`,
        url: process.env.VUE_APP_WEB_URL,
        
        process_model_record: {id:''},
        // ODOO-4440: переход «легенда чарта → настройки поля серии»: чарт кладёт
        // сюда binding меры, панель полей (AttrGrid doc.viewList) выделяет строку
        legend_goto_field: null,
        // IE 2026 09 14 / ODOO-5800 (замечание Игоря): выбранная строка поля в панели полей (doc.viewList) — {widget_id, binding, ts};
        // чарт ведёт к ней стрелку легенды и подсвечивает строку серии, пока вкладка чарта скрыта
        legend_field_selection: null,
        process_model_current: '',
        process_model_menu: [
            // IE 2026 09 23 / ODOO-341407: i18n — ленивый заголовок (getter): state() строится до загрузки словаря (main.js: useMainStore() раньше i18nReady);
            // меню целиком заменяет ответ бэка при открытии базы (answer.process_model_menu)
            { get title() { return t('Current', null, 'pm') }, 'command': 'set_process_model', 'process_model': 'process-model-01' },   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)
            // { 'title': 'process-model-2026-01', 'command': 'set_process_model', 'process_model': 'process-model-2026-01' },
        ],

        user: {}, // {id:'user_admin', title:'admin'},
        user_defaults: null, // get_user_defaults: { pages, workspace_onOpening }
        tasksBar: {},   // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): снимки статусов задач столов { [workspace]: { rows, at, source, loading, seq } } — tasksBar_*
        // IE 2026 09 25 / ODOO-… (замечание Игоря: поиск по названиям на других языках): названия записей пунктов панелей-меню на всех языках { id: { en, uk, ru } | null } — menuTitles_*
        menuTitles: {},
        menuTitles_epoch: 0,
        _menuTitlesInflight: {},
        _menuTitlesStats: { requests: 0, ids: 0 },
        _favEpoch: 0, // IE 2026 09 22 / ODOO-… (заказ Игоря): счётчик сохранений личных пометок (избранные виджеты / страницы, страница по умолчанию)
        navigator: navigator_defaultState(),   // demo-webscm 2026 11 02 / ODOO-350612 (навигатор интерфейса): {open, mode dock|free|strip, width, rect, tab, steps, current, asked, skipEpoch…} — components/NavigatorDock.vue
        navigatorAtStart: false,   // demo-webscm 2026 11 02 / ODOO-350612: настройка пользователя «Відкривати навігатор при старті» (USER.doc.params.navigatorAtStart, бэк user_settings_save)
        navigatorDone: null,   // demo-webscm 2026 11 02 / ODOO-350612 (fix 3): пройденные темы навигатора с бэка (USER.doc.params.navigatorDone, список номеров); null — бэк поля не знает → только кэш браузера
        navigatorAutoOpened: false,   // demo-webscm 2026 11 02 / ODOO-350612: автооткрытие при старте — один раз за вход
        navigatorPageReady: false,   // demo-webscm 2026 11 02 / ODOO-350612 (live48): первая страница стола построена — настройки с бэка, пришедшие позже, решают об автооткрытии сами
        navigatorSettingsDb: '',   // demo-webscm 2026 11 02 / ODOO-350612 (live48): база, для которой настройки навигатора уже запрошены у бэка стенда (один раз за вход в базу)
        guideSession: null,   // IE 2026 09 28 / ODOO-342342 (Use cases): сессия показа кейса / пути — полоса пути GuideBar (utils/guidePlay.js)
        guideMarks: null,     // IE 2026 09 28 / ODOO-342342 (Use cases): личные отметки кейсов — избранное / пройдено / место в пути, оптимистично (utils/guidePersonal.js)
        guideBackups: {},     // IE 2026 09 28 / ODOO-342342 (Use cases): «мои» чипсы столов до показа — для «Restore my filters» (копия и в localStorage)
        guideChips_pending: null,   // IE 2026 09 28 / ODOO-342342 (Use cases): чипсы якоря для страницы, которая откроется показом — забирает workspace_show_widgets
        guideLink_fromURL: null,    // IE 2026 09 30 / ODOO-343435: ссылка на тур ?guide_path=<id>&step=<n> (router) — забирают workspace_show_widgets / workspace_activate
        menuTree: [],
        menuTree_model: [],
        // ODOO-3749: последние открытые столы (раздел WORKSPACES в левом баре).
        // Раньше жили как ad-hoc .items на объекте меню и терялись при каждой
        // пересборке menuTree_model (смена процессной модели и т.п.)
        recentWorkspaces: [], // [{ workspace, label, pi, img }]
        database_attrs: [],
        action_id_front: 0,
        // Test recorder — запись/воспроизведение тестовых сценариев (см. testRecorder.js)
        testRecording: { active: false, replaying: false, targetWidgetId: null, events: [], t0: 0, env: null, captureScreens: true, _pendingIndex: -1 },
        isAuthenticated: false,
        mfaSecurity_open: false,   // Odoo 350042: окно «Sign-in security» (components/MfaSecurityDialog.vue) открыто
        _checkingSession: false,
        WORKSPACES: {},
        WIDGETS:{},
        workspace_ind: 1,

        vueObjCache: {},
        
        error: '', // >> Login.vue
        version_widget_row: 'backend',
        // поколение открытий единственного widget-row попапа: инкремент при каждом
        // открытии/ретаргете Row. Отложенные selectionChanged-таймеры гридов запоминают
        // значение на момент планирования и не трогают Row, если он с тех пор переехал
        // (иначе стайл-таймер фонового грида перецепляет свежеоткрытый Row на свою строку)
        widgetRow_openSeq: 0,
        // позиции/размеры widget-row, сохранённые пользователем: ключ widgetRowRect_key
        _widgetRowRects: {},
        _ddRects: {}, // IE 2026 08 19 / ODOO-5512: ректы виджетов расшифровки, подвинутых пользователем
        // последний авторассчитанный рект (layout+fit) по тому же ключу —
        // для мгновенной отрисовки при переоткрытии (приоритет ниже пользовательского)
        _widgetRowRects_auto: {},
        // отложенный показ нового виджета (widget_deferReveal): окно смонтировано
        // и занимает своё место, но невидимо, пока не придёт ответ widget_open —
        // быстрый ответ рисуется сразу полным кадром (скелет с id пропускается);
        // по таймауту показывается скелет, чтобы была видна реакция. 0 — выключено
        widgetReveal_delay: 1200,

        // вкладки без id: AttrTabPanel передаёт вкладку объектом (initialAttr/parentAttr),
        // prepare_attr не ставит id вкладкам панели; false — прежний поиск по id (widget_attr)
        tabs_noId: false, // TODO errors

        profiling_params: {
            use: false,
            type: 'fe', // 'fe_exec', 'be'
            unit_sec: 1e-3,

            useCallGraph: true,
            max_children: 20,
            max_depth: 20,
            show_recursion: true,
            min_total_ms: 0,
            max_path_depth: 20,

            useLineProfiler: true,
            modules: 'views, db, a, pg, log, datahub, processing_mesures, processing, sales',
            functions: '',
        },
        showSQL: false,
        hide_console: true,
        showTooltip: false,
        menuHoverOpen: false,   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): опция «Open menus on hover» (меню пользователя, под Show tooltips) — в памяти вкладки, как showTooltip; выкл — формы-меню, ☰, форму ⋯ виджета и подписи рейла раскрывает только клик
        altTipEpoch: 0,   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): эхо Alt для computed (altTooltip._epoch: нажатие / отпускание Alt, границы дожития)
        // id из COLOR_SCHEMES — цветовая гамма UI (гриды/топбар/фон).
        // Инициализация ИЗ localStorage: main.js вешает класс на body до createApp,
        // но стор жил с 'classic' — меню выбора схемы показывало галку не там,
        // а user_settings_save мог УВЕЗТИ на бэк classic поверх реальной схемы
        colorScheme: (() => { try { return initialColorScheme() } catch (e) { return 'classic' } })(), // IE 2026 08 23: мобильный дефолт style6m
        // IE 2026 09 14 / ODOO-… (заказ Игоря: скрытие рейла страниц): рейл скрыт кнопкой (localStorage pagesRail) — MainArea не резервирует поле слева
        pagesRailHidden: (() => { try { return localStorage.getItem('pagesRail') === 'hidden' } catch (e) { return false } })(),
        pagesRailScroll: {},   // IE 2026 09 14 / ODOO-… (замечание Игоря: рейл не прыгает при смене страницы): прокрутка рейла по столам — компонент страницы пересоздаётся на каждый переход
        pagesPanelOpen: false,   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка): панель страниц открыта (кнопка рейла вверху подсвечена — Page.vue)
        iconScheme: (() => { try { return initialIconScheme() } catch (e) { return 'classic' } })(), // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок)
        darkThemePref: null,        // null = пользователь не выбирал, работает prefers-color-scheme
        // IE 2026 09 14 / ODOO-… (заказ Игоря: варианты страниц и фильтров стола): явный выбор вариантов на сессию (уходит в workspace_open → workspace_init)
        pageVariants: {},     // { workspace: { page: variantId | '' } } — '' = сама страница
        filtersVariant: {},   // { workspace: variantId | '' } — '' = фильтры стола
        variantsEpoch: 0,     // растёт после каждой команды панели вариантов — панель перечитывает списки
        wsReopenSerial: {},   // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): { workspace: n } — стол пересобран с нуля (defaults_save); номер — в ключе страниц (App.routeViewKey)
        copyPaste_cleanEmpty: true,
        show_JSON_parseTime: false,
        
        dragStart_widget_id: null,
        dragOver_widget_id: null,
        popoutDragging: false,
        popoutOverPageInd: false,

        // active
        activeWORKSPACE: null,
        // ODOO-3705: причина показа экрана выбора модуля (fallback вместо логина)
        moduleSelectorReason: '',
            // .activePAGE, active_page
                // .leftArea
                activeWIDGET: null,
                // .rightArea
        
        nextWidget_id: 0,
        nextExecuteWidgetMethod_id: 0,
        closedWidgets: [],
        frontHistory: [],
        openChipsDropdown: null,
        attr_dragged: null,
        attr_active: null,
        attr_activeEl: null,
        swapOnDragAndDrop: false,
        itemsSource: {},
        itemsSource_change_index: 0,
        itemsSource_change_log: [], // [{index, segment}] — какие сегменты менялись; см. get_itemsSource_changedSet

        // «Скоростной вход» (R1..R6): каждый механизм — за своей опцией, чтобы
        // перебирать варианты и изолировать последствия без пересборки.
        // Переключение: window.fastEntry.set('holdTitles', false) — пишет localStorage
        // (ключ 'fastEntry') и живой стор; window.fastEntry.reset() — дефолты + reload
        fastEntry: (() => {
            const defaults = {
                holdTitles: true,   // R1: скелетон до применения dataMap Link-колонок — нет кадра с сырыми id
                holdTitles_ms: null, // R1: страховочный потолок удержания, мс (словарь завис — показать как есть);
                                    // null = настройка базы fe.ux.holdTitlesMs (800) — IE 2026 09 05 / ODOO-336330
                inlineIS: true,     // R2: применять словари itemsSources из ответа select до данных
                knownIS: true,      // R3: слать в select уже имеющиеся словари — бэк шлёт только недостающее
                idCache: true,      // R4: пер-id Redis-кэш by_ids-резолва на бэке (id_cache=false отключает)
                openSelect: true,   // R5: select исполняется внутри widget_open (минус один round-trip)
                openLean: true,     // R19 (ODOO-5043): ответ select внутри widget_open не везёт
                                    // ВТОРОЙ раз record и view — это те же объекты, что уже
                                    // приехали в WIDGET того же ответа (на консенсусе 3,7 МБ
                                    // из 7,3). Бэк перечисляет снятые ключи в same_as_WIDGET.
                                    // Дефолт ВЫКЛ: нужен бэк, который этот флаг понимает
                snapshot: false,    // R6: мгновенный вход со снапшота IndexedDB (stale-while-revalidate).
                                    // ВЫКЛ по решению Igor 03.08 (вчерашние данные в кадре + классы
                                    // проблем реплея дороже, чем −7с повторного входа)
                snapshotWS: false,  // R6b: каркас стола со снапшота — выкл вместе с R6 (Igor 03.08)
                inlineIS_doc: true, // R7: inline-словари и для полей записи/чипсов, не только строк грида
                titleRefetch: true, // R8: не ретраить id, которых нет в сегменте (ретрай — только при обрезке ответа)
                waveGuard: true,    // R9: пустой ответ словаря не будит вотчеры (иначе те же id уходят новой волной)
                dictIdsGuard: true, // R20 (IE 2026 09 18): грид перерисовывается на by_ids-ответ словаря, только если пришедшие id есть в его
                                    // ссылочных колонках. Фоновый домонтаж вкладок (R13) запрашивает словари форм (ATTR, SEGMENTS-UNION,
                                    // FIELDS…), и каждый ответ поднимал need_set_itemsSource + полный apply_CHIPS у всех гридов страницы
                                    // с колонкой того же сегмента: на списке в 8 тыс. строк — задачи по 2,5–3 с ещё минуту после открытия
                rowEmptyPass: true, // R21 (IE 2026 09 20 / ODOO-…): признак «строка пуста» (класс cell-empty при фильтре «непустые») считается один раз на строку за проход
                                    // отрисовки, а не на КАЖДОЙ ячейке: у «Orders by documents» переключение группы строк шло 3,6 с, из них 2,3 с — isEmpty
                rowEmptyPlan: true, // R22 (IE 2026 09 20 / ODOO-…): проверка «строка пуста» идёт по плану колонок (utils/rowEmpty.js) — сырые описания колонок и прямое чтение
                                    // сырой строки вместо двух действий стора (обёртка Pinia) на каждую колонку: строка отчёта в 192 колонки 1,6 мс → доли мс
                saveSkipNoop: true, // IE 2026 08 27 / ODOO-11316: no-op ячейки (итог = исходному) не уходят в сохранение, метка _cells возвращается
                cellSkipIdentity: true, // IE 2026 08 27 / ODOO-11312: пропуск форматирования ячейки только при той же строке данных/колонке (не по позиции)
                geomPresets: true,  // R10: размеры docked-скелета из localStorage (с прошлого открытия) —
                                    // с R5 ответ widget_open едет вместе с расчётом, и без пресета виджет
                                    // ждал его клеткой 1×1 в углу; нет пресета — растянуть на страницу
                lazyPy: true,       // R11 (#77.2): Pyodide не грузится на входе — в фоне после отрисовки
                                    // страницы (первый скрипт-отчёт при нужде запускает загрузку сам)
                selectorsOnce: true,// R12 (#77.3): пересчёт селекторов стола — один на волну параллельных
                                    // открытий (redis-замок на бэке), а не в каждом widget_open
                lazyTabs: true,     // R13 (#77.1): вкладки панели настроек монтируются при первой
                                    // активации, а не все сразу (видна всё равно одна)
                dockFreeze: true,   // R14: состав up/min-дока не пересчитывается, пока страница
                                    // грузится — виджеты не прыгают между полосой и областью
                xlsxInfo: true,     // INFO-лист в XLSX-выгрузке: паспорт отчёта + ссылка
                xlsxAsync: true,    // R15: экспорт в Excel порциями строк (batched saveAsync) +
                                    // прогресс в нотификации — вкладка не «зависает» на больших гридах
                xlsxLightFormat: true, // R15d: лёгкий formatItem при экспорте — в файл из него попадает
                                    // только очистка cellTemplate-ячеек, тяжёлый DOM-путь пропускается
                reportProgress: true, // R17: полоса виджета показывает % формирования отчёта на бэке
                                    // (поллинг get_report_progress во время загрузки REPORT2)
                chipPickFromWidget: true, // Pick value селекторного чипса: кандидаты — видимые
                                    // строки виджета-селектора (его отборы/порядок);
                                    // false — прежний режим: весь словарь сегмента
                pmKeepView: true,   // смена процессной модели БЕЗ пересборки стола: вид,
                                    // несохранённые настройки виджетов и глобальные чипсы
                                    // остаются, обновляются только данные; false — прежний
                                    // полный reload (setup со сносом WORKSPACES)
                numericSort: true,  // сортировка колонок: строку, которая целиком число
                                    // ("9970.5" — меры нередко приезжают строками), сравнивать
                                    // ЧИСЛОМ, а не лексикографически ("999" выше "9975");
                                    // false — прежнее чисто текстовое сравнение строк
                syncTabReveal: true, // переключение вкладки виджета ОДНИМ кадром: отложенные
                                    // доделки контента (handleVisibility: resize/refresh/
                                    // itemsSource) выполняются синхронно ДО отрисовки, а не
                                    // после IntersectionObserver (который стреляет уже после
                                    // первого кадра — отсюда мелькание «пустой → полный»)
                tabDictPrefetch: true, // словари/тайтлы link-колонок гридов на СКРЫТЫХ
                                    // вкладках заказываются при фоновом домонтировании
                                    // (lazyTabs), а не при первом входе — вкладка
                                    // открывается без пересборки itemsSource на приход
                                    // ответов (и без запросов к бэку в момент клика)
                versionCheck: true, // ИЕ 2026-08-14: сверять версию вкладки с выложенной
                                    // (meta в index.html) и предлагать перезагрузку
                versionCheckMs: null, // IE 2026 09 04 / ODOO-336330: персональный override интервала сверки;
                                    // пусто = настройка базы fe.polling.versionCheckMs (кодовый дефолт 600000 мс)
                hoverOpenMs: null,  // ИЕ 2026-08-14: пауза перед показом ховер-форм; null = настройка базы fe.ux.hoverOpenMs (350) — IE 2026 09 05 / ODOO-336330
                                    // (попап чипса; бейджи угла грида — см. groupBadgesDelayMs) —
                                    // мимолётный проезд мышкой их не открывает. 0 —
                                    // прежнее мгновенное поведение
                groupBadgesDelayMs: null, // IE 2026 08 27 / ODOO-5800 (заказ Игоря): пауза перед показом; null = настройка базы fe.ux.groupBadgesDelayMs (1500) — IE 2026 09 05 / ODOO-336330
                                    // бейджей уровней группировок строк/колонок в углу грида —
                                    // ощутимо больше, чем у прочих ховер-форм (угол лежит на пути
                                    // к чипсам и кнопкам панели). Настройка без пересборки:
                                    // window.fastEntry.set('groupBadgesDelayMs', N); 0 — мгновенно
                // R18 (ЭКСПЕРИМЕНТ, дефолты ВЫКЛ 04.08): пакет ускорения прокрутки дал
                // визуальные регрессии (сломалась фиксация шапки — frozenSkip пропускал и
                // check_frozen; кадр данных в шапке и моргание — бюджетная дорисовка и
                // вертикальный дефер с зачисткой). Включать поштучно для доработки.
                scrollFactory: false, // R18: кастомная cell factory по умолчанию
                frozenSkip: false,  // R18a: скип пере-форматирования frozen-ячеек при прокрутке
                flushBudget: false, // R18b: бюджет кадра (8мс) для кеш-очереди deferred0
                scrollDeferV: false, // R18c: дефер форматирования и при вертикальной прокрутке
                scrollBlank: true,  // R16: зачистка переиспользованных ячеек при прокрутке + догон
                                    // кадрами. «Артефакты» оказались TypeError css_user в formatItem
                                    // (guard ce4ed981) — после фикса включён обратно 04.08
                timings: false,     // R1..R6: замеры этапов входа в консоль
                // IE 2026 09 04 / ODOO-336291 (mobile UX): горизонтальная прокрутка грида (аудит B-01: 2-3 fps)
                hdrClipCheck: 'deferred', // P-07: проверка обрезки заголовка колонки — 'deferred' (кэш по тексту+ширине,
                                    // незнакомые ячейки меряются одним rAF после отрисовки) | 'sync' (прежнее:
                                    // scrollWidth/clientWidth прямо в formatItem = forced layout на ячейку) | 'off'
                marqueeBandRaf: true, // P-08: полоса под выделением (marqueeBand_sync) — один rAF на серию updatedView,
                                    // чисто горизонтальная прокрутка пропускается (top полосы не меняется)
                linkIconCache: true, // IE 2026 09 05 / ODOO-336330 (репорт Игоря): иконка ссылки ячейки (cell-link) из кэша
                                    // и на быстром пути formatItem — свёртка/развёртка группы без кадра «значения без иконок»
                collapseOnePass: true, // IE 2026 09 05 / ODOO-336330 (заказ Игоря): свёртка/развёртка узла дерева одной
                                    // перерисовкой — высоты секций и сброс кэша ячеек до первого кадра (groupCollapsedChanged)
                tabsPrecheck: true, // IE 2026 09 06 / ODOO-336330 (заказ Игоря): пустые по данным вкладки не рисовать в первом кадре
                                    // панели — вкладки только появляются (когда данные подтвердились), а не исчезают
            }
            try {
                let saved = JSON.parse(localStorage.getItem('fastEntry') || '{}')
                // миграция v2 (04.08): экспериментальные scroll/снапшот-флаги, залипшие
                // в localStorage со времён включённых дефолтов, принудительно чистятся —
                // иначе сеанс продолжает жить со старым поведением (глюки шапки/полосы),
                // хотя дефолты давно выключены; инкогнито при этом работал правильно
                const MIGRATE_V = 2
                if ((saved._v || 0) < MIGRATE_V) {
                    for (const k of ['scrollFactory', 'frozenSkip', 'flushBudget', 'scrollDeferV',
                                     'scrollBlank', 'snapshot', 'snapshotWS']) {
                        delete saved[k]
                    }
                    saved._v = MIGRATE_V
                    try { localStorage.setItem('fastEntry', JSON.stringify(saved)) } catch (e2) { /* quota */ }
                }
                const { _v, ...savedFlags } = saved
                return { ...defaults, ...savedFlags }
            }
            catch (e) { return { ...defaults } }
        })(),

        // АН 2026 08 08: «быстрый пересчёт» — флаги уходят В ЗАПРОСЕ save правок ячеек
        // (widget_to_transfer.fast_recalc), бэк читает их в processing_save. Дефолты ВКЛ.
        // Переключение: window.fastRecalc.set('precacheOnEdit', false), .reset() — дефолты
        fastRecalc: (() => {
            const defaults = {
                precacheOnEdit: true, // A2b: предвыборка в каскаде правки (1.4 с/узел против 3.7-7.1 без неё)
                dataLimitFull: true,  // A8: каскад поднимает dataLimit до 1 ГБ и доносит до воркеров пула
                reuseFactCache: true, // АН 2026 08 09 / ODOO-4682: plan-only каскад — факт-меры из кэша документа расчёта
                snapshotOnEdit: true, // АН 2026 08 09 / ODOO-4682: снимок документа расчёта перед каскадом (Restore last snapshot)
            }
            try {
                const saved = JSON.parse(localStorage.getItem('fastRecalc') || '{}')
                return { ...defaults, ...saved }
            }
            catch (e) { return { ...defaults } }
        })(),

        // IE 2026 09 04 / ODOO-336658 (заказ Игоря): Rust-движок раскладки отчётов dl2 (WIDGET-REPORT2).
        // Флаги едут В КАЖДОМ запросе виджета (widget_to_transfer.dl2_engine), бэк читает их в
        // widgets.widget_REPORT2.select → data_layout2.report (расширение dl2rs). Переключение целиком
        // клиентское, без рестарта бэка: window.dl2Engine.set('rust', false) — прежний python-путь,
        // .reset() — дефолты; URL ?dl2-rust=false — разово. Дефолты ВКЛ. Какой движок строил отчёт —
        // doc._dl2_engine ответа (engine / reason / timings) и фазы панели «#».
        dl2Engine: (() => {
            const defaults = {
                rust: true,     // раскладка (группировка строк/колонок, ячейки) — Rust; false — python
                parallelSelect: true, // SQL источников отчёта — параллельно из Rust (tokio-postgres); false — psycopg2 по очереди
                strict: false,  // true — при ошибке Rust не откатываться на python (отладка)
                // IE 2026 09 05 / ODOO-336658 (разбор 8,4 с rust-fetch, заказ Игоря): PostgreSQL с jit=on тратил 3,6 из 3,7 с
                // запроса источника на JIT-компиляцию и столько же — зонд типов колонок; бэк по этим флагам шлёт
                // SET jit=off на сессии выборки отчёта и берёт типы через CREATE TEMP VIEW (без исполнения запроса)
                pgJitOff: true, // false — JIT PostgreSQL как настроен на сервере
                qfView: true,   // false — прежний зонд типов SELECT * INTO TEMP … LIMIT 0
                // IE 2026 09 05 / ODOO-336658 (заказ Игоря): внутренние опции без UI — выключить/понять причину при разборах
                pyParallel: true, // источники отчёта параллельно пулом потоков Python, когда Rust-выборка выключена/недоступна
                slimSelect: true, // select отчёта (Update data) без WIDGET.view (4–5 МБ вида с колонками); бэк строит вид сам,
                                  // изменившиеся ветки приходят view_patch как и раньше; в запросе — признак view_on_frontend
            }
            let saved = {}
            try { saved = JSON.parse(localStorage.getItem('dl2Engine') || '{}') } catch (e) { /* приватный режим */ }
            try {
                const qs = [location.search || '']
                const h = location.hash || ''
                if (h.includes('?')) qs.push('?' + h.slice(h.indexOf('?') + 1))
                for (const q of qs) {
                    for (const [k, v] of new URLSearchParams(q).entries()) {
                        if (k.startsWith('dl2-')) saved[k.slice(4)] = v !== 'false' && v !== '0'
                    }
                }
            } catch (e) { /* нечитаемый URL */ }
            return { ...defaults, ...saved }
        })(),

        // IE 2026 08 24 / ODOO-5884 (заказ Игоря): авто-пересчёт по изменению данных (регламент
        // триггеров, BE common_modules/task_triggers.py). enabled едет В ЗАПРОСЕ сохранения
        // (request.autoRecalc) — выключение целиком клиентское, без пересборки; poll/refresh/toast —
        // поллинг состояния и обновление виджетов с Refresh by selectors по завершении пересчёта.
        // Переключение: window.autoRecalc.set('enabled', false), .reset() — дефолты. Дефолты ВКЛ.
        autoRecalc: (() => {
            const defaults = {
                enabled: true,   // помечать драфты и запускать триггерные задачи после сохранения
                poll: true,      // поллинг состояния авто-пересчёта (auto_recalc_state)
                pollMs: null,    // период поллинга, мс; null = настройка базы fe.polling.autoRecalcPollMs (12000) — IE 2026 09 05 / ODOO-336330
                refresh: true,   // по завершении пересчёта обновить виджеты с Refresh by selectors
                toast: true,     // тост о завершении авто-пересчёта
            }
            try { return { ...defaults, ...(JSON.parse(localStorage.getItem('autoRecalc') || '{}')) } }
            catch (e) { return { ...defaults } }
        })(),
        // IE 2026 09 11 / ODOO-335246 (Igor): пошаговая отладка каскада (меню Debug → Cascade debug): режим on/off (бэк
        // cascade_debug — при on авто-пересчёт на паузе), last — ответ последнего шага (что сделано / что дальше)
        // IE 2026 09 12 / ODOO-335246 (Igor): режим отладки каскада — В РАМКАХ БАЗЫ (флаг в settings базы): состояние читается с бэка
        // при старте (cascadeDebug_sync), а не из localStorage браузера
        cascadeDebug: { on: false, busy: false, last: null },
        _autoRecalcTimer: null,
        _autoRecalcLast: {},     // version → last_done.at последнего показанного прогона

        // IE 2026 08 21 (заказ Игоря): фокус на активной странице — остановка фоновых
        // загрузок при переключении (десктоп + мобайл); window.pageFocus.set('enabled', false)
        pageFocus: (() => {
            try { return { enabled: true, ...(JSON.parse(localStorage.getItem('pageFocus')) || {}) } }
            catch (e) { return { enabled: true } }
        })(),
        // IE 2026 08 26 / ODOO-5800 (заказ Игоря «слетают все чипсы»): активные чипсы стола живут
        // только в памяти вкладки — любая перезагрузка/переоткрытие (HMR dev-сервера, ChunkLoadError
        // после выкатки, F5, fastEntry-reload) возвращала личные дефолты. Снимок чипсов в localStorage
        // при каждом применении (workspace_applySelector) и восстановление при открытии стола.
        // Приоритет: ссылка &where= > локальный снимок > личные дефолты > стол.
        // window.chipsKeep.set('enabled', false) — выключить, .reset() — дефолты. Дефолт ВКЛ.
        chipsKeep: (() => {
            try { return { enabled: true, ...(JSON.parse(localStorage.getItem('chipsKeep')) || {}) } }
            catch (e) { return { enabled: true } }
        })(),
        // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.2, решение В1): личная опция «Show translation fields» по сегменту данных — рабочее состояние
        // (map: { '<сегмент>': true }) для пользователя и базы key = 'i18nFields:<user>:<db>'; запоминание — localStorage под тем же ключом
        // (utils/i18nFields.js: i18nFieldsOn / i18nFieldsSet). Запись виджета не трогается
        i18nFields: { key: '', map: {} },
        // IE 2026 08 27 / ODOO-5800 (заказ Игоря): линии дерева в гридах. mode: '' = плавная
        // Г-рамка (дефолт, как «Settings tree»), 'dotted' = прежний пунктир с зазорами секций.
        // Глобальный флаг ниже параметра вида грида (viewParams.<grid>.tree_lines).
        // window.treeLines.get()/.set('mode','dotted')/.reset(); URL ?treeLines=dotted (сеанс).
        // Дефолт ВКЛ (рамка). Счётчики сравнения вариантов — store._treeLinesStats.
        treeLines: (() => {
            let flags = { mode: '' }
            try { flags = { ...flags, ...(JSON.parse(localStorage.getItem('treeLines')) || {}) } } catch (e) { /* дефолты */ }
            const m = /[?&#]treeLines=(dotted|frame|)/.exec(location.href)
            if (m) flags.mode = m[1] === 'dotted' ? 'dotted' : ''
            return flags
        })(),
        _treeLinesStats: { formatItem_break_ms: 0, formatItem_break_calls: 0, autoSizeRows_ms: 0, autoSizeRows_calls: 0 },
        // IE 2026 08 29 / ODOO-5828 (заказ Игоря): подсветка остальных вхождений выделенного текста
        // (как в VS Code) — чтение терминала виджета и логов. Скоуп — виджет выделения.
        // window.selectionHighlight.get()/.set('enabled', false)/.reset(); URL ?selectionHighlight=0|1
        // (сеанс). Дефолт ВКЛ. Цена — в .get().stats (matches/ms/repaints).
        selectionHighlight: (() => {
            let flags = { enabled: true }
            try { flags = { ...flags, ...(JSON.parse(localStorage.getItem('selectionHighlight')) || {}) } } catch (e) { /* дефолты */ }
            const m = /[?&#]selectionHighlight=([01])/.exec(location.href)
            if (m) flags.enabled = m[1] === '1'
            return flags
        })(),
        _selectionHighlightStats: { supported: null, requests: 0, repaints: 0, matches: 0, ms: 0, text: '', scope: '' },
        // IE 2026 08 28 / ODOO-5828 (заказ Игоря «мгновенное открытие»): тайтлы ссылок формы записи
        // приходят готовыми в ответе widget_open (record._doc.by_ids) и вливаются в словари стора ДО
        // рендера — форма не ждёт волн точечных get_itemsSource. Переключение целиком клиентское:
        // window.recordOpenTitles.get()/.set('enabled', false)/.reset(); URL ?recordOpenTitles=0|1
        // (сеанс). Дефолт ВКЛ. Замеры — в .get().stats (opens/ids_applied/ids_unmatched/ms).
        recordOpenTitles: (() => {
            let flags = { enabled: true, adaptive: true }
            try { flags = { ...flags, ...(JSON.parse(localStorage.getItem('recordOpenTitles')) || {}) } } catch (e) { /* дефолты */ }
            const m = /[?&#]recordOpenTitles=([01])/.exec(location.href)
            if (m) flags.enabled = m[1] === '1'
            return flags
        })(),
        _recordOpenTitlesStats: { opens: 0, ids_applied: 0, ids_unmatched: 0, ms: 0, skipped_segments: 0 },
        // IE 2026 08 29 / ODOO-5828: сегменты, где обогащение не закрывает все ссылки (остаются
        // сырые guid на сущности вне WebSCM) — для них titles_by_ids не запрашиваем: цена есть, пользы нет
        _recordOpenTitlesSkip: new Set(),
        _pageFocusStopped: 0,
        mobileCellDropdownTick: 0,
        mobileCellOpenTick: 0,     // IE 2026 08 20 / ODOO-336291 (mobile UX), 21.08: сигнал «открыть ссылку/документ из активной ячейки»
        mobileCell: null,          // 21.08: {wid, has, isRef, canOpen} — что умеет активная ячейка (кнопки правого стека)
        _mobTapStats: {},          // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31 — задержки тапа по командам (main.js: window.mobTapDone / mobileUi.stats())
        _mobPageLoading: null,     // IE 2026 09 04 / ODOO-336291 (mobile UX): B-05 — {workspace, page} плитка страницы в состоянии загрузки (Page.vue onClick)
        mobileChartLegend: null,   // IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — {wid, tick} сигнал «открыть лист серий графика»
        mobileChartAxes: null,     // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4195): {wid,on} — тумблер осей вернул/убрал авто-поля чарта // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4193): сигнал «открыть dropdown текущей ячейки активного грида»
        chartHoverLink: null,      // IE 2026 09 13 / ODOO-5800 (заказ Игоря): {page, wid, name, ts} — серия под курсором в чарте с опцией «Series highlight: Linked on the page»; чарты той же страницы с этой опцией подсвечивают у себя серию с тем же именем (AttrChart.hoverLinkReceive)
        // IE 2026 08 20 / ODOO-336291 (mobile UX): мобильный профиль UI. on — итог сеанса:
        // enabled (null = авто по экрану) + URL ?mobile=1|0 (не персистится).
        // Переключение: window.mobileUi.set('enabled', true|false|null), .reset()
        // IE 2026 09 04 / ODOO-336330: настройки БАЗЫ для фронта (см. хелперы над useMainStore)
        settings: null,             // подмножество doc.params.fe.* записи SETTINGS: {mobile:{…}, polling:{…}, …}
        settings_version: '',       // хэш значений с бэка — меняется, значит настройки переприменили
        _settingsOverride: null,    // ленивая склейка URL ?fe.<ключ>=… и localStorage 'feSettings'
        _settingsMirror: undefined, // IE 2026 09 05 / ODOO-336330: зеркало localStorage 'feSettings.db' — до первого ответа бэка
        _settingsEpoch: 0,          // счётчик применений: по нему перезапускаются таймеры
        mobileUi: (() => {
            const defaults = {
                enabled: null,       // null = авто: ширина ≤480 или coarse pointer + ширина ≤820
                readOnlyGrids: true, // гриды без редактирования (dblclick пальцем недоступен)
                collapseRail: true,  // рейл страниц свёрнут в плавающую кнопку
                bigTargets: true,    // класс body.mobile-ui: крупные тап-цели, поля ≥16px
                railOpen: false,     // runtime: мобильный рейл страниц раскрыт (не персистится)
                widgetsOpen: false,  // runtime: мобильное меню виджетов раскрыто (#4198)
                fabsLeft: false,     // runtime (#4205): левый стек кнопок выдвинут
                fabsRight: false,    // runtime (#4205): правый стек кнопок выдвинут
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone, research 20.08):
                share: true,     // ссылки через системный share sheet (Web Share API)
                kbdAware: true,  // клавиатура iOS поверх fixed — прятать плавающие кнопки
                wakeLock: true,  // не гасить экран, пока виджет максимизирован
                haptics: true,   // тактильный отклик (switch-контрол Safari 17.4+)
                backGuard: true, // свайп «назад» закрывает меню, а не выходит из приложения
                shellLock: true, // фикс-оболочка: гасит pull-to-refresh и резиновый скролл
                // IE 2026 08 23 (заказ Игоря, референс McDonald's): стол — лента
                // карточек: вертикальный скролл, виджеты во всю ширину
                cardsBoard: true,
                // IE 2026 08 23: пан грида (режим просмотра) применяется не чаще
                // кадра (rAF) — иначе wijmo рендерит на каждый touchmove
                panRaf: true,
                // IE 2026 09 04 / ODOO-336291 (mobile UX): флаги правок аудита 03.09 (дефолты ВКЛ — правило опций;
                // выключение без пересборки: window.mobileUi.set('<flag>', false), см. main.js)
                selectMode: false,      // runtime: режим выделения ячеек (кнопка нижнего ряда); в дефолтах — чтобы set() его знал
                settingsDeferred: true, // P-16: лист настроек виджета показывается сразу, сборка списка/грида — после первого кадра
                cellSyncFast: true,     // P-20: кнопки ячейки (Cell menu / Open) — в следующем кадре, dropdown без паузы 80 мс
                gridPanChain: true,     // P-10 / B-02 / B-19: вертикальный свайп, которому гриду/чарту некуда, отдаётся ленте (body.mob-chain)
                dataLimits: true,       // U2: слать client.mobile в widget_open / executeWidgetMethod — бэк берёт лимиты settings › Mobile
                tapStats: true,         // P-31: статистика «pointerdown → видимый результат» по командам (window.mobileUi.stats())
                // IE 2026 09 04 / ODOO-336291 (mobile UX): пакет FE-2 (навигация / топбар / меню / листы / tap-feedback), дефолты ВКЛ
                fabsOneTap: true,       // B-06 / P-13: тап по сложенному FAB выдвигает стек И выполняет действие кнопки (body.mob-onetap)
                menuExclusive: true,    // B-08: рейл / список виджетов / «⋮» / гамбургер — открытие одного закрывает остальные
                hamburgerTap: true,     // B-26 / P-19: гамбургер на таче — по click; совместимые mouseenter/mouseleave игнорируются
                activateVisible: true,  // B-17: после загрузки страницы (лента карточек) активен первый виджет в кадре
                fabsPad: true,          // B-11: отступ содержимого активной карточки от колонок FAB (body.mob-fabspad)
                pressFeedback: true,    // P-25: :active-отклик на плитках/строках/кнопках + touch-action: manipulation (body.mob-press)
                fastTransitions: true,  // P-26: транзиции FAB/панели ≤ .08 с, карточка анимирует только тень/рамку (body.mob-fast)
                topbarPollStop: true,   // P-22: опрос высоты топбара раз в 1.5 с останавливается, когда есть ResizeObserver
                edgeSwipePassive: true, // P-27: non-passive touchmove для свайпа от края — только пока идёт касание у края (при загрузке)
                pageSwitchYield: true,  // B-05 / P-12: плитка страницы — состояние загрузки сразу, workspace_open через кадр
                settingsEditable: true, // B-24: грид полей настроек (AttrTabGrid) редактируется на телефоне (исключение из readOnlyGrids)
                rowHeight: true,        // B-21: строки грида ≥ 32 px на телефоне
                stickyFirstCol: true,   // B-22: первая замороженная колонка остаётся на телефоне (1 вместо 0)
                frozenCloneHold: true,  // R-2 (верификация 04.09): пока палец ведёт грид, клон frozen-ячеек (wijmo cloneFrozenCells) не пересобирается на каждый кадр (AttrGrid.initialized)
                hdrWordWrap: true,      // B-34: заголовки колонок без разрыва внутри слова (body.mob-hdrwrap)
                railRowHit: true,       // IE 2026 09 04 / ODOO-336291 (mobile UX): строка раскрытого рейла страниц ловит тап по всей своей полосе (body.mob-railhit)
                // IE 2026 09 04 / ODOO-336291 (mobile UX): пакет FE-4 (графики / грид / рейл / косметика), дефолты ВКЛ
                chartTapValues: true,   // B-23 / B-29 / P-29 / P-30: тап по точке графика читает значение НА МЕСТЕ (пузырёк), drill-down — долгим нажатием или кнопкой «Open row»
                chartLegendSheet: true, // B-41: легенда графика — лист снизу со строками 44 px, серия гасится напрямую (без пересборки виджета)
                chartCompact: true,     // B-40: читаемая раскладка графика на 390 px (легенда снизу, заголовки осей сняты, подписи X прорежены, минимум высоты plot)
                activateAndAct: true,   // B-36: тап, активирующий виджет, выполняет и само действие (раскрыть группу, выделить ячейку, сорт)
                topbarSearch: true,     // B-42: «поле поиска» чипсов в шапке — живая цель (открывает панель чипсов), а не мёртвый элемент
                gridGlyphTouch: true,   // B-21 / B-39: глиф дерева и тумблер ссылки в ячейке — под палец (body.mob-gridglyph)
                settingsCompact: true,  // B-39: грид полей настроек на телефоне — свой шрифт / высота строк / шапка (body.mob-setgrid)
                railGroupStyle: true,   // группа страниц в рейле читается как группа, дочерние — с отступом (body.mob-railgrp)
                fabUniform: true,       // B-32: один стиль кнопок в одной колонке FAB (body.mob-fabuni)
                rotateSync: true,       // B-35: после поворота размеры карточки и грида пересчитываются в том же проходе (без 200 мс дебаунса)
                moreOpen: false,        // runtime: панель «⋮» открыта (AppTopbar) — для взаимоисключения меню
                sidebarOpen: false,     // runtime: гамбургер-сайдбар открыт (App.vue) — для взаимоисключения меню
                standalone: !!(window.matchMedia?.('(display-mode: standalone)').matches
                    || window.navigator.standalone === true), // runtime: запущено с Home Screen
            }
            try {
                const saved = JSON.parse(localStorage.getItem('mobileUi') || '{}')
                const merged = { ...defaults, ...saved }
                const auto = mobileAuto()   // IE 2026 09 04 / ODOO-336330: пороги 480/820 — настройки базы
                let on = merged.enabled == null ? auto : !!merged.enabled
                const m = /[?&#]mobile=([01])/.exec(location.href)
                if (m) on = m[1] === '1'
                // standalone — runtime-факт, из localStorage не восстанавливать
                return { ...merged, on, standalone: defaults.standalone }
            }
            catch (e) { return { ...defaults, on: false } }
        })(),

        cssClasses: {}, // реестр CSS-CLASS: id → {id, title, name, styles, group, schemes, map_color}; см. resolve_cssClasses
        cssClassesByName: {}, // IE 2026 09 18 / ODOO-…: тот же реестр по ИМЕНИ класса (правила оформления несут имена, вкладка Styles — заголовки)
        cssClasses_change_index: 0,

        PATH_CACHE: new Map(),

        attr_findDragSourceEl: () => document.querySelector('.attr.drag-source'),
        attr_findDragTargetEl: () => document.querySelector('.attr.drag-over'),
        attr_findClosestWidgetEl: event => wjcCore.closest(event.target, '.attr'),

        findDragSourceEl: () => document.querySelector('.WIDGET.drag-source'),
        findDragTargetEl: () => document.querySelector('.WIDGET.drag-over'),
        findClosestWidgetEl: event => wjcCore.closest(event.target, '.WIDGET'),

        setDragSourceEl: el => wjcCore.addClass(el, 'drag-source'),
        setDragTargetEl: el => wjcCore.addClass(el, 'drag-over'),
        unsetDragSourceEl: el => wjcCore.removeClass(el, 'drag-source'),
        unsetDragTargetEl: el => wjcCore.removeClass(el, 'drag-over'),
        setActiveEl: el => wjcCore.addClass(el, 'active'),
        unsetActiveEl: el => wjcCore.removeClass(el, 'active'),

        headerWidgetHeight: 37,
        minMode_WidgetHeight: 37,
        minWidgetWidth: 320,
        minWidgetHeight: 320,
        minMode_WidgetWidth: 320,
        popout_baseZ: 900,
        marginWidget: 2,

        chipsBarPosition: 'topbar', // 'none' | 'page-top' | 'topbar'

        def_stylePage: {
            marginTop: 42+6-3,
            marginRight: 6-3,
            marginBottom: 6-3,
            marginLeft: 45+6-3,

            height_rem: 2, // 2
            width_rem: 4, // 4

            scaleDockWidget: 0.2,

            showDock: false,
            dock_main_countItems: 0,
            dock_up_countItems: 0,
            dock_min_countItems: 0,
            dock_down_countItems: 0,

            freeScrollWidget: true,
        },

        palette: [
            '#8e99f3',
            '#ffca28',
            '#5c6bc0',
            '#bbdefb',
        ],
        dateFormats: [
            // 'WORKSPACE',
            // 'dd',
            // 'DD.MM.YYYY hh:mm:ss',
            'yyyy/MM/dd', 'yyyy-MM-dd', 'yyyy.MM.dd', 'dd/MM/yyyy', 'yyyyMMdd', 'yyMMdd',
            'yyyy-MM-dd/ffff-ff-ff',
            'yyyy/MM', 'yyyy-MM', 'yyyy.MM', 'yyyy MM',
            'yyyy/M', 'yyyy-M', 'yyyy.M', 'yyyy M',
            'yyyy/M/dd', 'yyyy-M-dd', 'yyyy.M.dd', 'dd/M/yyyy',
            'MM/dd/yy', 'MM-dd-yy', 'MM.dd.yy', 'MM dd yy', 'MM dd, yy',
            'dd MM yyyy', 'dd-MM-yyyy', 'dd.MM.yyyy', 'dd MM yyyy',
            'MM/dd/yyyy', 'MM-dd-yyyy', 'MM.dd.yyyy', 'MM dd yyyy', 'MM dd, yyyy',
            'D',
            'M',
            'yyyy',
            'yyyy-MM-dd HH:mm:ss.ffffff',
            'yyyy-MM-dd HH:mm:ss',
            'yyyy.MM.dd HH:mm:ss',
            'dd.MM.yyyy HH:mm:ss',
        ],

        // IE 2026 08 23 / ODOO-5884 (заказ Игоря): модальное окно прогресса команды с action.progress
        // (Create/Discard branch): после Yes в окне подтверждения — текст без кнопок, закрывается по ответу бэка
        progress: {
            visible: false,
            header: '',
            text: '',
        },
        // IE 2026 08 23 / ODOO-5884 (заказ Игоря): подтверждение с полем ввода (action.confirm_input:
        // {field, label, value}) — напр. имя создаваемой ветки; Yes кладёт значение в action.params[field]
        confirmInput: {
            visible: false,
            header: '',
            message: '',
            label: '',
            value: '',
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте — Return / Reopen / Skip с обязательным комментарием и одной категорией возврата): опции confirm_input
            // required (текст обязателен), exclusive (чекбоксы — выбор одной, params[field] — строка), optionsRequired (нужна отметка); invalid — подсветка незаполненного. Без опций — как раньше
            required: false,
            exclusive: false,
            optionsRequired: false,
            invalid: false,
            _action: null,
            _vueObj: null,
        },
        // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте, F2): окно «History» единицы согласования — ответ approval_history бэка (answer.approval_history) рисует components/ApprovalHistory.vue;
        // units — модель utils/approval.approvalHistoryModel, current — открытая единица (вкладки при нескольких). Выключатель fe.ux.approval
        approvalHistory: {
            visible: false,
            units: [],
            current: 0,
        },
        notification: {
            header: '',
            text: '',
            status: false,
            visible: false,
            fading: false,
            closing: false,
            timerId: null,
            action: null, // IE 2026 08 23 / ODOO-5884: кликабельная ссылка в тосте (напр. «Open log» → виджет лога прогона)
            progress: null, // IE 2026 08 26 / ODOO-5800: ход прогона 0..100 — полоса над текстом (null — нет)
            statuses: { // timeout
                info: 10001,
                warning: 10002,
                error: 10003,
                critical: 10004,
                success: 10005,
                pending: null,
            }
        },

        // test
        i_test:0,

        pyodide: null,

        fetchMode: 'by_ids', // 'all' | 'by_ids' | 'justGet'

        // ODOO-3705: переключение базы — { title } пока идёт, иначе null.
        // Инициализация целевой базы занимает секунды; без индикации пользователь
        // продолжает работать, думая, что он ещё в прежней базе.
        dbSwitching: null,
    }),
    actions: {
        dbSwitching_start(title) {
            const store = this
            store._dbSwitchSeq = (store._dbSwitchSeq || 0) + 1
            store.dbSwitching = { title: title || '' }
            if (store._dbSwitching_timer) clearTimeout(store._dbSwitching_timer)
            // страховка: оверлей не должен пережить неудавшуюся навигацию — иначе
            // вместо ошибки пользователь получит вечную заглушку
            store._dbSwitching_timer = setTimeout(() => store.dbSwitching_stop(), store.setting('fe.polling.dbSwitchOverlayMs', 120000))   // IE 2026 09 05 / ODOO-336330
        },
        dbSwitching_stop() {
            const store = this
            if (store._dbSwitching_timer) {
                clearTimeout(store._dbSwitching_timer)
                store._dbSwitching_timer = null
            }
            store.dbSwitching = null
        },
        initAjaxDefaults() {
            const store = this
            $.ajaxSetup({
                // 10 мин: save с каскадом пересчёта (консенсус #4117/#4244) легально
                // живёт минуты — при 180 с фронт рвал запрос, показывал «Backend error»,
                // а бэкенд досчитывал, и UI расходился с БД. Долгосрочное решение —
                // асинхронный каскад (pollTask), таймаут лишь страховка.
                // IE 2026 09 05 / ODOO-336330: настройка базы fe.polling.ajaxTimeoutMs (на старте — зеркало прошлого входа)
                timeout: store.setting('fe.polling.ajaxTimeoutMs', 600000),
            })
            // ajaxPrefilter runs BEFORE per-request beforeSend, cannot be overridden.
            // Даёт nginx маршрут через X-Database.
            //
            // ODOO-3705: источник истины — ТЕКУЩАЯ база store, а хэш лишь запасной вариант.
            // Раньше бралось из хэша, но в router.beforeEach он ещё указывает на ПРЕЖНЮЮ
            // базу: setup-запросы переключения уходили на её backend с dbid целевой базы
            // в теле. Тенант-в-тенанта это переживал (чужую запись backend добирает через
            // ядро), а переход В ЯДРО падал всегда: запись ядра наружу не отдаётся, и
            // workspace_open молча вставал — переключение не доходило до конца.
            // store.user.database.dbid обе точки переключения выставляют ДО навигации;
            // пока база не выбрана (первый заход, восстановление сессии) он пуст — тогда хэш.
            $.ajaxPrefilter(function(options, originalOptions, xhr) {
                try {
                    var h = window.location.hash || ''
                    var hashDbid = (h.match(/\/(database_[^?/]+)/) || [])[1] || ''
                    var cur = (store.user && store.user.database && store.user.database.dbid) || ''
                    var target = cur || hashDbid
                    if (target) {
                        // Запоздавший запрос ПРЕЖНЕЙ базы получает заголовок текущей и уходит
                        // на её backend со старым dbid в теле. Если в теле база ядра, backend
                        // тенанта идёт за её записью в ядро, а ядро запись ядра наружу не
                        // отдаёт — в ней креды подключения. Такой запрос не выполним ни при
                        // каком исходе, гасим. Условие узкое намеренно: широкая сверка «тело
                        // против маршрута» обрывала само переключение (проверено).
                        if (target !== 'database_coredatabases'
                            && typeof options.data === 'string'
                            && /"dbid"\s*:\s*"database_coredatabases"/.test(options.data.slice(0, 4000))) {
                            return xhr.abort()
                        }
                        if (!options.headers) options.headers = {}
                        options.headers['X-Database'] = target
                        // Also setRequestHeader as fallback if headers are sent late
                        var oldBeforeSend = options.beforeSend
                        options.beforeSend = function(jqXHR, settings) {
                            jqXHR.setRequestHeader('X-Database', target)
                            if (oldBeforeSend) return oldBeforeSend.apply(this, arguments)
                        }
                    }
                } catch (e) { /* noop */ }
            })
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — СТРАХОВКА для путей отправки без своего предохранителя (их ~50 $.ajax в сторе и компонентах).
            // Только при роли (без неё — ни разбора тела, ни обёртки): запрос записи, которого политика бэка не разрешает, до сети не доходит; разрешённый запрос,
            // на который бэк всё же ответил 403 read_only (список фронта отстал), получает один понятный тост вместо «Backend error» (обработчики ошибок jQuery
            // вешаются ПОСЛЕ префильтров — обёртка options.error срабатывает). Основной предохранитель — readonly_deny в saveRecord / executeXxx / defaults_save /
            // variants_call (состояние виджета остаётся чистым)
            // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F3): отказ — НЕ xhr.abort() (обрыв в префильтре случается до установки колбэков jQuery: success / error / complete
            // не вызывались, промис вызывающего висел — settingsForm_ensure). Префильтр помечает запрос (options.roDenied = тело отказа), $.ajaxTransport ниже отдаёт
            // синтетический 403 БЕЗ сети: сработают error / complete / глобальный ajaxError, jqXHR.responseJSON — тело {status:'error', error:'read_only', reason, command,
            // method, notification}, как от настоящего бэка; тост — один на серию (readonly_onDenied в обёртке error), тихий метод — без тоста
            $.ajaxPrefilter(function(options) {   // IE 2026 09 29 / ODOO-342781 (ревью F3): xhr.abort() больше не нужен — параметры originalOptions / xhr убраны
                try {
                    if (!store.readonly_on()) return
                    if (String(options.type || options.method || 'GET').toUpperCase() !== 'POST') return
                    const req = ro_parseRequest(options.data)
                    if (!req || !req.command) return
                    const policy = store.readonly_policy()
                    const body = ro_prefilterBody(policy, req, t((policy && policy.text) || RO_TEXT_DENIED))   // IE 2026 09 29 / ODOO-342781 (ревью F3): решение и тело — чистая функция
                    if (body) {
                        options.roDenied = body
                        store._roStats = { ...(store._roStats || {}), aborted: ((store._roStats || {}).aborted || 0) + 1 }
                        if (!store.hide_console) console.log(`[readonly] prefilter denied ${req.command} ${req.method || ''}${req.quiet ? ' (quiet)' : ''}`)
                    }
                    const orig = typeof options.error === 'function' ? options.error : null
                    options.error = function(jqXHR) {
                        const denied = store.readonly_onDenied(jqXHR, req.quiet)
                        if (denied) jqXHR._roHandled = true
                        if (!orig) return
                        if (!denied) return orig.apply(this, arguments)
                        // отказ роли: штатный обработчик снимает своё состояние (loading …), красный «Backend error» не нужен — тост уже показан
                        store._roMuteBackendError = true
                        try { return orig.apply(this, arguments) } finally { store._roMuteBackendError = false }
                    }
                } catch (e) { /* страховка не должна ломать запросы */ }
            })
            // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F3): транспорт синтетического отказа роли «только чтение» — только для запросов, помеченных префильтром (options.roDenied);
            // прочие запросы (и все — без роли) проходят к обычному XHR-транспорту без изменений. '+*' — первым в списке транспортов. Ответ асинхронный (как у сети): вызывающий
            // успевает присвоить свой промис / состояние до колбэков (синхронный error снимал бы состояние раньше, чем оно выставлено); async: false — сразу
            $.ajaxTransport('+*', function(options, originalOptions, jqXHR) {
                const body = options.roDenied
                if (!body) return
                jqXHR._roSynthetic = true
                let timer = null
                return {
                    send(headers, complete) {
                        const r = ro_denialResponse(body)
                        const fire = () => { timer = null; complete(r.status, r.statusText, r.responses, r.headers) }
                        if (options.async === false) fire(); else timer = setTimeout(fire, 0)
                    },
                    abort() { if (timer) { clearTimeout(timer); timer = null } },
                }
            })
            // Global AJAX error handler for timeouts
            $(document).ajaxError((event, jqXHR, settings, thrownError) => {
                if (thrownError === 'timeout' || jqXHR.statusText === 'timeout') {
                    this.showConnectionError()
                }
                // IE 2026 09 29 / ODOO-342781: 403 read_only на запросе, который не разобрал префильтр (не JSON) и у которого нет своей обёртки, — один тост
                if (jqXHR && jqXHR.status === 403 && !jqXHR._roHandled && this.readonly_on()) this.readonly_onDenied(jqXHR, false)
            })
        },
        showConnectionError() {
            const store = this
            if (store._connectionErrorShown) return
            store._connectionErrorShown = true
            store.TERMINAL(null, null, {
                text: t('The server is not responding. Please try again later or contact your administrator.'),   // IE 2026 09 23 / ODOO-341407: i18n
                status: 'critical'
            })
            // Reset flag after 10 seconds so it can show again if needed
            setTimeout(() => { store._connectionErrorShown = false }, store.setting('fe.polling.connectionErrorRearmMs', 10000))   // IE 2026 09 05 / ODOO-336330
        },
        setup(to, next) {
            const store = this
            if (store._i18nReloading) return   // IE 2026 09 26 / ODOO-341407: fe.i18n.firstLoadHold — страница перезагружается на язык базы, запросов не слать

            // ODOO-3749: было `WORKSPACES.length = 0` — на ОБЪЕКТЕ это только добавляет
            // свойство length и ничего не чистит. Столы прежней модели переживали
            // переинициализацию, workspace_open возвращался по раннему выходу с чужим
            // контентом и не восстанавливал пункт меню.
            store.WORKSPACES = {}
            store.activeWORKSPACE = null
            store.activeWIDGET = null

            store.get_startup(to, next)
            store.get_itemsSource_bySegment('SEGMENTS')

            store.WORKSPACES['workspace-store'] = {
                PAGES: {
                    'page-store': {
                        WIDGETS: store.WIDGETS,
                    },
                }
            }

            if (store.fastEntry.lazyPy) {
                // R11 (#77.2, решение Igor): движок py не конкурирует с входом —
                // загрузка стартует в фоне, когда primary-запросы входа отработали
                // (страница отрисована); потолок 60с. Виджет, которому py нужен
                // раньше, запустит загрузку сам (attr_loadPyodide)
                //
                // IE 2026 08 30 / ODOO-5800 (заказ Игоря): фоновый прогрев запускается
                // ТОЛЬКО если py кому-то нужен. Раньше движок грузился на каждом входе —
                // несколько мегабайт wasm плюс инициализация, — даже когда ни одному
                // виджету стола скрипты не нужны (типовой случай: столы с гридами и
                // отчётами без пользовательского кода). Кому нужен — тот будит сам
                // (store.attr_loadPyodide, ветка _import_modules / code-eval), так что
                // отложенная загрузка ничего не ломает, только откладывает.
                // Откат: window.perf.set('lazyPyOnDemand', false) — прежний безусловный прогрев.
                const t0 = Date.now()
                const idle = setInterval(() => {
                    const quiet = (store._primary_inflight || 0) === 0 && Date.now() - t0 > 8000
                    const onDemand = !store.perf_flag || store.perf_flag('lazyPyOnDemand')
                    if (quiet || Date.now() - t0 > 60000) {
                        if (onDemand && !store.pyNeededNow()) {
                            // никому не нужен — не греем; ждём дальше: виджет со скриптом
                            // может открыться позже (переход на другую страницу стола)
                            if (Date.now() - t0 > 60000) clearInterval(idle)
                            return
                        }
                        clearInterval(idle)
                        store.loadPyodide()
                    }
                }, 1000)
            } else {
                store.loadPyodide()
            }

            // store.widget_open({
            //     widget: 'widget-dropdown',
            //     id: 'dropdown',
            //     workspace: 'workspace-store',
            //     page: 'page-store',
            //     parentAction: { 'action_name':'action-front-001' },
            // })
        },
        async widget_open(WIDGET={}, parent_vueObj={}, callback=null, callback_params=null, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this

            if (!WIDGET.workspace) {
                if (WIDGET.parentAction?.workspace === 'workspace-store') {
                    WIDGET.workspace = 'workspace-store'
                    WIDGET.page = 'page-store'
                } else {
                    WIDGET.workspace = store.activeWORKSPACE.workspace
                }
            }
            const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            if (!WIDGET.page) {
                WIDGET.page = WORKSPACE.active_page
            }
            const PAGE = WORKSPACE.PAGES[WIDGET.page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)

            store.widget_setup(WIDGET)


            let parentWIDGET = parent_vueObj?.WIDGET
            if (parentWIDGET?.widget === 'widget-row' && WIDGET.widget !== 'widget-row') {
                // ссылочный/элементный виджет открыт ИЗ Row: родителем ставим родителя Row
                // (виджет живёт на уровне workspace, не вложен в попап), но помним Row-источник —
                // чтобы активация этого виджета не закрывала Row (задача 7)
                WIDGET._openedFromWidgetRow = parentWIDGET.id
                parentWIDGET = parentWIDGET.parentWIDGET
            }
            if (parentWIDGET) {
                if (parentWIDGET.workspace !== 'workspace-store') {
                    WIDGET.workspace = parentWIDGET.workspace
                }
                WIDGET.workspace = WIDGET.workspace || store.activeWORKSPACE.workspace

                WIDGET.parentWIDGET = store.getWIDGET_info(parentWIDGET)

                // if (parentWIDGET.record?.segment === "TASKS-transform") {
                //     WIDGET.parentWIDGET.record = parentWIDGET.record
                // }
            }

            // find unique WIDGET with props (1)
            let exsistWIDGET = store.findWidget_byProps(WIDGET)
            // IE 2026 09 28 / ODOO-342342 (дефект «прежний документ»): найденная панель документации показывает ДРУГОЙ документ, чем просит
            // «?» другого виджета / ссылка docs: не из читалки — findWidget_byProps сравнивает только id виджета и записи, и ниже она лишь
            // активировалась со старым текстом. Теперь листается на месте (open_doc, с историей) или, скрытая / на бэке без open_doc,
            // закрывается и открывается заново. Флаг fe.help.inPlaceDocs выключен или документ тот же — как раньше (utils/docsNav.js)
            if (exsistWIDGET && !WIDGET.parentAction?.new && !WIDGET.parentAction?.params?.clone) {
                const _docsSwap = docsNav_panelSwap(store, exsistWIDGET, WIDGET, () => store.widget_open(WIDGET, parent_vueObj, callback, callback_params))
                if (_docsSwap === 'nav') return
                if (_docsSwap === 'reopen') exsistWIDGET = null
            }
            // АН 2026 07 20 / ODOO-2692
            // Клонирование: record приходит сюда ещё с id оригинала (id обнуляет только бэкенд,
            // attrs.validate_newRecord по parentAction.params.clone). Без этой проверки
            // findWidget_byProps находит уже открытый виджет ИСХОДНОЙ записи и клон не открывается вовсе —
            // визуально "подлипает" и вместо клона показывается основная карточка.
            if (exsistWIDGET && !WIDGET.parentAction?.new && !WIDGET.parentAction?.params?.clone) {
                // Search "search more": widget-search already exists, so widget_open would just
                // re-activate it with the previous (stale) query. Propagate the new category chips
                // + search text into the existing record and re-run select so the grid updates.
                const reopenCHIPS = WIDGET.parentAction?.params?.CHIPS
                const isSearchReopen = !!reopenCHIPS && !!exsistWIDGET.record?.doc?.params
                if (isSearchReopen) {
                    exsistWIDGET.record.doc.params.CHIPS = reopenCHIPS.filter(c => c.segment !== 'CHIP-Search')
                    const searchCHIP = reopenCHIPS.find(c => c.segment === 'CHIP-Search')
                    if (searchCHIP) exsistWIDGET.title = searchCHIP.title
                }
                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P5: монитор согласования (список approval-monitor, отбор сегмента — parentAction.params.approval_filter) открыт повторно —
                // прежний виджет (припаркованный Esc / ✕ или ещё открытый) показывал старые данные до Refresh: берём новый отбор и перечитываем список. Выключатели: fe.ux.approval, fe.ux.approvalMonitorRefresh (по умолчанию вкл.)
                const apprMonitorReopen = !!WIDGET.parentAction?.params?.approval_filter && store.setting('fe.ux.approval', true) !== false && store.setting('fe.ux.approvalMonitorRefresh', true) !== false
                if (apprMonitorReopen) { exsistWIDGET.parentAction = WIDGET.parentAction; if (WIDGET.parentAction.title) exsistWIDGET.title = WIDGET.parentAction.title }
                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ): пункт «My approvals…» (список approval-my, parentAction.approval_refresh) — список «ждут меня» устаревает после каждого Approve / Return,
                // повторное открытие перечитывает его так же (тот же выключатель fe.ux.approvalMonitorRefresh); у списка нет отбора и заголовка действия — только select
                const apprMyReopen = WIDGET.parentAction?.approval_refresh === true && store.setting('fe.ux.approval', true) !== false && store.setting('fe.ux.approvalMonitorRefresh', true) !== false
                if (exsistWIDGET._softClosed) {
                    store._widget_restoreSoftClosed(exsistWIDGET)
                    store.widget_activate(exsistWIDGET, 'widget_open::restore_softClosed', true, true)
                    // store.executeStoreMethod(exsistWIDGET.vueObj, { command: 'executeWidgetMethod', method: 'reload', record_sendToBackend_exclude: ['_doc'] })
                    if (isSearchReopen || apprMonitorReopen || apprMyReopen) store.executeStoreMethod(exsistWIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                    return
                }
                if (!this.hide_console) console.log(`exsistWIDGET (1): ${exsistWIDGET.id}`)
                console.log(`widget_activate1: ${exsistWIDGET?.id}`)
                store.widget_activate(exsistWIDGET, 'widget_open::findWidget_byProps', true, true)
                if (isSearchReopen || apprMonitorReopen || apprMyReopen) store.executeStoreMethod(exsistWIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                // IE 2026 08 18 / ODOO-5555 (заказ Игоря): расшифровка в УЖЕ открытый
                // виджет — не переоткрывать: активирован выше, теперь обновить его
                // фильтры (fieldsMapping -> doc.params.WHERE) и перевыбрать
                if (WIDGET.parentAction?.drilldown) {
                    store.drilldown_applyToWidget(exsistWIDGET, WIDGET.fieldsMapping, WIDGET.parentAction.drilldown, true)
                }
                return
            }

            // open_in_children_widget
            let close_widget = null
            // if ('parentWIDGET' in WIDGET) {
            //     const parent = store.findWidget(WIDGET.parentWIDGET.id)
            //     if (parent.WIDGET.area === 'left-area' && WIDGET.parentAction && WIDGET.parentAction.open_in_children_widget && parent.WIDGET.children_widget_id) {
            //         close_widget = store.findWidget(parent.WIDGET.children_widget_id).WIDGET
            //         if (close_widget) {
            //             close_widget.loading = true
            //         }
            //     }
            // }

            WIDGET.title = WIDGET?.record?.title || WIDGET.title || WIDGET.parentAction?.title || WIDGET.record?.id
            WIDGET.component = 'WidgetAttrs'
            // IE 2026 08 18 / ODOO-5555: открыт расшифровкой — помним фильтры-ключ и
            // источник (сравнение при обновлении по выделению)
            if (WIDGET.parentAction?.drilldown) {
                WIDGET._drilldown_where_key = WIDGET.parentAction.drilldown.where_key
                WIDGET._drilldown_source = WIDGET.parentAction.drilldown.source_widget_id
                WIDGET.drilldown_cache = true // IE 2026 08 18 / ODOO-5512: бэк кэширует источники цели
                WIDGET.drilldown_period = WIDGET.parentAction.drilldown.period || null // IE 2026 08 19: период расшифровки → период отчёта цели
            }

            if (!WIDGET.externalLink_method) {
                store.widgets_created(WIDGET)
            }

            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): виджет ЯЧЕЙКИ (расшифровка) при
            // первом открытии — четверть экрана (½ × ½ рабочей области) в углу,
            // ПРОТИВОПОЛОЖНОМ расшифровываемой ячейке (она остаётся видна); подвинутый/
            // растянутый пользователем рект запоминается по цели (store._ddRects)
            if (WIDGET.parentAction?.drilldown && WIDGET.widget !== 'widget-row') {
                try {
                    const _ddKey = 'dd::' + (WIDGET.widget || WIDGET.record?.id || '')
                    const _savedDD = store._ddRects[_ddKey]
                    WIDGET.styleWidget = { ...(WIDGET.styleWidget || {}), dock: 'popout' }
                    WIDGET._ddRectKey = _ddKey
                    if (_savedDD) {
                        WIDGET.styleWidget.setWidgetRect = 'px'
                        WIDGET.styleWidget._savedRect = _savedDD
                    } else {
                        Object.assign(WIDGET.styleWidget, { setWidgetRect: 'pct' }, store.quarterRect_oppositeCell(parent_vueObj, WIDGET))
                        delete WIDGET.styleWidget._savedRect
                    }
                } catch (e) { console.warn('drilldown rect', e) }
            }

            if (WIDGET.widget === 'widget-row') {
                WIDGET.styleWidget.dock = 'popout'

                let cascadeDepth = 0
                let pw = parentWIDGET
                while (pw?.widget === 'widget-row') { cascadeDepth++; pw = pw.parentWIDGET }
                WIDGET._cascadeDepth = cascadeDepth

                const _rectKey = store.widgetRowRect_key(WIDGET)
                WIDGET._rectKey = _rectKey // для сравнения смены источника в reuse-ветке
                const _saved = store._widgetRowRects[_rectKey] || store._widgetRowRects_auto[_rectKey]
                const wrp = WIDGET.parentAction?.widgetRow_params
                if (_saved) {
                    WIDGET.styleWidget.setWidgetRect = 'px'
                    WIDGET.styleWidget._savedRect = _saved
                } else if (cascadeDepth === 0 && wrp) {
                    const w_pct = wrp?.width_pct ?? .2
                    WIDGET.styleWidget.setWidgetRect = 'pct'
                    WIDGET.styleWidget.top_pct = wrp?.top_pct ?? .1
                    WIDGET.styleWidget.left_pct = (wrp?.left_pct ?? .8) - cascadeDepth * w_pct
                    WIDGET.styleWidget.width_pct = w_pct
                    WIDGET.styleWidget.height_pct = wrp?.height_pct ?? .8
                } else if (cascadeDepth === 0 && WIDGET.parentAction?.source_attr_type === 'AttrChart') {
                    // оптимистичный компакт (= дефолты layout бэка): сразу нужный
                    // размер справа-вверху, без флеша «0.9 у левого-верха → компакт
                    // после ответа»; apply_widgetRow_layout применит те же значения
                    WIDGET.styleWidget.setWidgetRect = 'pct'
                    WIDGET.styleWidget.top_pct = .1
                    WIDGET.styleWidget.left_pct = .8
                    WIDGET.styleWidget.width_pct = .2
                    WIDGET.styleWidget.height_pct = .2
                } else if (cascadeDepth === 0) {
                    // IE 2026 08 19 / ODOO-5512 (заказ Игоря): то же правило, что у виджета
                    // ячейки — первое открытие: четверть экрана в углу напротив строки/ячейки
                    Object.assign(WIDGET.styleWidget, { setWidgetRect: 'pct' }, store.quarterRect_oppositeCell(parent_vueObj, WIDGET))
                }
             
                if (store.version_widget_row === 'frontend') {
                    store.set_widgetRow_view(WIDGET)
                    if (WIDGET.parentAction?.activeAttr?.binding) {
                        store.set_activeAttr(WIDGET.view, WIDGET.parentAction.activeAttr, WIDGET)
                    }
                    nextTick(() => {
                        store.widget_finishSetup(WIDGET)
                    })
            
                    return
                }
            }

            store.checkWIDGET_dock(WIDGET, parentWIDGET)

            // дальше — запрос к бэку: скрыть окно до ответа/таймаута (см. widget_deferReveal)
            if (!WIDGET.externalLink_method && WIDGET.workspace !== 'workspace-store') {
                store.widget_deferReveal(WIDGET)
            }

            // _itemsSourcesView_cache — фронтовый кэш реестра, на бэкенд не отправляется
            // IE 2026 09 28 / ODOO-342342 (ревью п.5): + docs_capabilities — признак методов читалки бэку не шлём: любой бэк вернул бы его эхом
            const { attrs_vueObj, _nav, _itemsSourcesView_cache, _revealPending, _revealTimer, _revealStart, _widgetOpen_repeat, docs_capabilities, ...widget_init } = WIDGET
            if (widget_init.record?._doc?.itemsSourcesView || widget_init.record?._doc?.itemsSourcesView_target) {
                widget_init.record = store.exclude_itemsSourcesView(widget_init.record)
            }
            // IE 2026 09 22 / ODOO-5800 (замечание Игоря: подбор чипса-селектора не должен показывать сам виджет — «скрытым, как по Esc»):
            // скрытое открытие — виджет создан и грузит данные, но на экран не выходит: _softClosed с создания (как после Esc — остаётся в
            // ALL_WIDGETS, v-show прячет, раскладка и сохранение стола его пропускают). В closedWidgets не регистрируется («последний
            // закрытый» — не он, таймера удаления нет), в историю не попадает (_hiddenOpen), пока пользователь сам его не откроет
            // (widget_open существующего / дерево виджетов страницы → _widget_restoreSoftClosed). Флаги ставятся ПОСЛЕ сборки widget_init —
            // бэку не уходят и эхом не возвращаются
            if (WIDGET.parentAction?._hidden && WIDGET.workspace !== 'workspace-store') {
                const W = store.findWidget(WIDGET.id)?.WIDGET || WIDGET
                W._softClosed = true
                W._hiddenOpen = true
            }
            try {
                // R6 (fastEntry.snapshot): мгновенный кадр из снапшота прошлого входа
                // (stale-while-revalidate). Требует формата R5 (openSelect) — в снапшоте
                // ответ widget_open уже с данными в actions_after. Реальный ответ идёт
                // следом и перекрывает (guard _gotRealOpen; после него снапшот не применяется)
                if (store.fastEntry.snapshot && store.fastEntry.openSelect
                        && WIDGET._firstLoading && !WIDGET._widgetOpen_repeat && !WIDGET._gotRealOpen) {
                    store.snapshot_get(store.snapshot_key(WIDGET, widget_init)).then(str => {
                        if (!str || WIDGET._gotRealOpen || WIDGET.close) return
                        try { store.widget_snapshot_apply(WIDGET, JSON.parse(str)) }
                        catch (e) { console.warn('[fastEntry:R6] apply failed', e) }
                    })
                }
                // повтор исходного запроса «как он был» из меню скелет-кадра
                // (case 'widget_open_repeat'), пока ответ бэка ещё не получен;
                // widget_init зафиксирован выше, timestamp обновляется при повторе
                const send_widgetOpen = () => {
                let send_start
                // R17 (dm 2026 08 04): openSelect исполняет select внутри widget_open —
                // для REPORT2 заводим ключ и поллинг прогресса формирования отчёта
                // класс виджета до ответа widget_open может быть неизвестен — тогда
                // поллим оптимистично, автостоп по пустым ответам (report_progress_start)
                let _rpKey = null
                const _wCls = WIDGET.widget_class || WIDGET.record?.segment || ''
                if (store.fastEntry.openSelect && !WIDGET._open_view_only
                    && (/REPORT2/.test(_wCls) || !_wCls)) {
                    _rpKey = store.report_progress_start(WIDGET, WIDGET.vueObj)
                }
                // отменяемость первого открытия: свой action_id_front, как у
                // executeWidgetMethod — Stop шлёт del_last_backend_action, бегущая
                // выборка внутри widget_open видит log.stopped_ и завершается.
                // ⚠ храним ОТДЕЛЬНО от last_backend_action: тот участвует в guard'е
                // «поздний ответ отбрасываем» (lba > action_id_front → BREAK), и
                // повышение его здесь роняло параллельные ответы виджета
                // (переоткрытие после смены настройки теряло панель кнопок)
                const _open_action_id = ++store.action_id_front
                WIDGET._open_action_id = _open_action_id
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'widget_open',
                    action_id_front: store.net_actionId(_open_action_id), // IE 2026 09 26 / ODOO-5800: '<вкладка>-<N>' (fe.net.actionIdUnique)
                    ...store.net_requestParams(), // IE 2026 09 26 / ODOO-5800: выключатель ключа отмены бэка (fe.net.cancelKeyScoped)
                    dl2_engine: { ...store.dl2Engine }, // IE 2026 09 05 / ODOO-336658: флаги Rust-движка отчётов и для select внутри widget_open (openSelect)
                    ...(_rpKey ? { _progress_key: _rpKey } : {}),
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    ...store.client_requestParams(), // IE 2026 09 04 / ODOO-336291 (mobile UX): client.mobile → мобильные лимиты данных
                    ...store.ganttMoves_requestParams(WIDGET), // IE 2026 09 26 / ODOO-5800: select внутри widget_open — строки только для Ганта движений (fe.gantt.serverFilter)
                    // R2/R5: словари ссылочных колонок в ответе / select внутри widget_open
                    // (#77.3: selectorsOnce=false — выключатель одного пересчёта селекторов,
                    // бэк по умолчанию считает его включённым)
                    ...(store.fastEntry.inlineIS || store.fastEntry.openSelect || store.fastEntry.selectorsOnce === false ? { fast_entry: {
                        ...(store.fastEntry.inlineIS ? store.fast_entry_requestParams() : {}),
                        ...(store.fastEntry.openSelect ? { openSelect: true } : {}),
                        ...(store.fastEntry.selectorsOnce === false ? { selectorsOnce: false } : {}),
                        // R19: сам факт флага в запросе = «этот фронт понимает same_as_WIDGET»
                        ...(store.fastEntry.openLean ? { openLean: true } : {}),
                    } } : {}),
                    // IE 2026 08 28 / ODOO-5828 (заказ Игоря «мгновенное открытие»): бэк вернёт
                    // готовые тайтлы ссылок записи в record._doc.by_ids (см. apply_record_byIds)
                    ...(store.recordOpenTitles_ask(WIDGET) ? { params: { titles_by_ids: 1 } } : {}),
                    process_model: store.process_model_record.id,
                    workspace: WIDGET.workspace, // 2024-07-31
                    // текущие чипсы стола с клиента: без них бэк резолвит стол из БД
                    // (+личный снапшот), и селектор-флаги открытия сеются по чипсам,
                    // отличным от видимых в топбаре (несохранённые изменения сессии)
                    widget_init: store.settingsForm_widgetInit(WIDGET, (store.WORKSPACES[WIDGET.workspace]?.record?.doc?.params
                        ? { ...widget_init, workspace_params: store.workspace_params_for(WIDGET, store.WORKSPACES[WIDGET.workspace].record.doc.params, widget_init) }   // IE 2026 09 15 (замечание Игоря): тираж — без своего селектора
                        : widget_init)),   // IE 2026 09 28 / ODOO-5800: признак каркаса формы — по заглушкам вида виджета
                    user: store.user,
                    // после Stop на скелет-кадре: переоткрыть только view (без
                    // автоселекта данных) — бэк вернёт WIDGET.loading=false
                    open_view_only: !!WIDGET._open_view_only,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                // P0: открытие виджета — primary-запрос, отложенная очередь (P2) ждёт
                store._primary_inflight = (store._primary_inflight || 0) + 1
                let _wo_counted = true
                const _release_primary = () => {
                    if (_wo_counted) {
                        _wo_counted = false
                        store._primary_inflight = Math.max(0, (store._primary_inflight || 1) - 1)
                    }
                }
                WIDGET._openRequest = $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        _release_primary()
                        store.report_progress_stop(WIDGET) // R17
                        if (WIDGET.close) { return }
                        // IE 2026 09 26 / ODOO-5800: 204 — открытие отменено на бэке, а фронт его не обрывал: без TypeError, из загрузки (fe.net.cancel204Safe)
                        if (jqXHR?.status === 204 && store.net_on204(WIDGET, { where: 'widget_open', actionId: _open_action_id })) return
                        // R6: реальный ответ получен — снапшот больше не применяется
                        WIDGET._gotRealOpen = true
                        const _wasStaleOpen = !!WIDGET._staleOpen // кадр снапшота на экране
                        if (WIDGET._staleOpen) WIDGET._staleOpen = false
                        // ответ применяется в этом же тике до отрисовки кадра: при
                        // быстром ответе скелет-кадр не рисуется вовсе (сразу полный)
                        store.widget_reveal(WIDGET)
                        const notification_frontend = null // {
                        store.TERMINAL(WIDGET, answer, notification_frontend, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (!store.check_loginAfterAjax(null, answer)) return
                        if (['critical'].includes(answer.notification?.status) || !answer.WIDGET) {
                            // открытие не удалось (например «Record not found»): пустой
                            // скелет-виджет не оставляем. Признак «ещё не наполнялся с
                            // бэка» — живой маркер _widgetOpen_repeat (удаляется только
                            // при успешном ответе); наполненный виджет не трогаем
                            if (!answer.WIDGET && WIDGET._widgetOpen_repeat) {
                                store.widget_close(WIDGET.id)
                            }
                            return
                        }

                        if (WIDGET.externalLink_method) {
                            store.externalLink({
                                method: WIDGET.externalLink_method,
                                action_id: answer.WIDGET.record._meta.action_id,
                                // родной стол виджета — как в диспетчере externalLink
                                workspace: answer.WIDGET.workspace || WIDGET.workspace,
                                page: answer.WIDGET.page || WIDGET.page,
                            })
                            return
                        }

                        // R6: обновить снапшот виджета (только ответы формата R5 —
                        // с данными в actions_after; сырой responseText, без сериализации)
                        if (store.fastEntry.snapshot && answer.WIDGET && answer.actions_after?.length) {
                            store.snapshot_put(store.snapshot_key(WIDGET, widget_init), jqXHR.responseText)
                        }

                        // if ('props' in answer.WIDGET && answer.WIDGET.record?.segment) {
                        //     answer.WIDGET.props.segment = answer.WIDGET.record.segment
                        // }
                        
                        const _activeAttr = WIDGET.parentAction?.activeAttr

                        // R2/R5: словари ссылочных колонок из ответа widget_open —
                        // в кэш ДО наполнения WIDGET, чтобы первый кадр был с тайтлами
                        if (answer.itemsSources && store.fastEntry.inlineIS) {
                            store.apply_inline_itemsSources(answer.itemsSources)
                        }
                        // IE 2026 08 28 / ODOO-5828 (заказ Игоря «мгновенное открытие»): готовые
                        // тайтлы ссылок записи — в словари ДО наполнения WIDGET (тем же путём R2)
                        if (answer.WIDGET.record?._doc?.by_ids) {
                            store.apply_record_byIds(answer.WIDGET.record, answer.WIDGET.view)
                        }

                        // R6: на экране кадр со снапшота, свежие данные приедут из
                        // actions_after ЭТОГО же ответа. Подмена записи здесь давала
                        // ЛИШНЮЮ пересборку грида (пустая секунда между снапшотом и
                        // финалом) — запись не трогаем вовсе: целиком её принесёт
                        // updateDoc из actions_after (одна пересборка «старые → новые»)
                        if (_wasStaleOpen && answer.actions_after?.length
                                && WIDGET.record?._doc && answer.WIDGET.record) {
                            delete answer.WIDGET.record
                        }
                        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): рект/док виджета — фронтовое
                        // состояние; бэк лишь ЭХОМ возвращает styleWidget, каким он был при
                        // запросе. Пока ждали данные, пользователь мог подвинуть/растянуть
                        // окно — эхо откатывало его к исходному. Не перетираем
                        delete answer.WIDGET.styleWidget
                        // АН 2026 10 25 / ODOO-347310: журнал «#» (TERMINAL) — тоже фронтовое состояние; бэк эхом возвращает его из widget_init
                        // (на момент запроса — пустым) и затирал строку widget_open, только что дописанную store.TERMINAL выше: время открытия
                        // (select внутри widget_open, openSelect) и протокол SQL в журнал виджета не попадали
                        delete answer.WIDGET.TERMINAL
                        docsNav_dropStaleCaps(WIDGET, answer.WIDGET)   // IE 2026 09 28 / ODOO-342342 (ревью п.5): признак читалки — только из этого ответа
                        graphPayload_take(answer.WIDGET.record)   // webscm 2026 10 26 / ODOO-348733: граф DataHub, открытый с чипсом (select внутри widget_open) — данные сетевого графа без глубокой реактивности
                        Object.assign(WIDGET, answer.WIDGET)
                        adf_kick(WIDGET)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): D1 — audit_diff пришёл в сырой WIDGET, бейдж «⇄ N» формы — сразу при открытии
                        store.settingsForm_countOpen(WIDGET, answer, jqXHR)   // IE 2026 09 28 / ODOO-5800: замер формы по требованию (каркас / полная)
                        store.tasksBar_fromRecord(WIDGET.record)   // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): пришла запись стола со статусами задач — в снимок панели
                        store.guide_personalTake(WIDGET)   // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): форма кейса — личное итогом слоёв (браузер Н1), как в навигаторе
                        // IE 2026 09 15 / ODOO-… (заказ Игоря): фиксированный виджет с селектором шапки (selector_header) открылся под своим
                        // активным селектором — перечитать без него (запись пришла только сейчас, при открытии её ещё не было)
                        // IE 2026 09 15 (замечание Игоря, вечер): то же для полей Set-без-Get (серии графиков «by …» — свой чипс не режет)
                        // IE 2026 09 19 / ODOO-5800: то же, когда приём глобального чипса метрик в записи отличается от предположенного при открытии
                        const _metricReopen = store.metricChipG_openMismatch?.(WIDGET)
                        if (((!WIDGET._multiply && (store.headerSel_active?.(WIDGET) || store.selSetOnly_active?.(WIDGET))) || _metricReopen) && WIDGET.vueObj) {
                            setTimeout(() => store.executeStoreMethod(WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] }), 0)
                        }
                        if (WIDGET._multiply?.title) WIDGET.title = WIDGET._multiply.title   // IE 2026 09 15 / ODOO-… (заказ Игоря): заголовок экземпляра тиража — из строки источника
                        docsNav_applyTitle(store, WIDGET)   // IE 2026 09 28 / ODOO-342342: читалка документации — заголовок H1 документа (doc.docs_title), а не подпись строки страницы, которую бэк вернул эхом
                        // данные получены — меню скелет-кадра сменится бэковским groupMenu
                        delete WIDGET._widgetOpen_repeat
                        // parents_tree приехал в сырой WIDGET: дропдаун настроек,
                        // открытый ДО ответа, сам не пересчитается (кэш computed) —
                        // пнуть резолв (внутри resolveIndex++, живое дообновление)
                        WIDGET.attrs_vueObj?.WIDGET?._resolveDropdownAttrLinks?.()
                        // IE 2026 09 10 / ODOO-… (замечание Игоря «после выбора настройки иногда пропадает иерархия»): панель Settings tree
                        // открыта, а данные виджета (новая запись + parents_tree) пришли только что — список настроек
                        // пересобрать заново (resolveIndex++ выше лишь перемонтирует грид со старыми/пустыми строками)
                        WIDGET.attrs_vueObj?.WIDGET?.settingsList_onRecordReplaced?.()
                        WIDGET.vueObj?.source_sync?.()   // IE 2026 10 19 / ODOO-347310 (ревью ie-webscm7): запись пришла в сырой WIDGET — полоса «изображение / открыть в источнике» формы (WidgetAttrs) без опроса
                        // WIDGET.attrs_popupTab = store.get_field(WIDGET.view, 'attrs_popupTab', ['name'])?.attrs

                        if (WIDGET.record?.doc?.cssClassW) {
                            WIDGET.cssClassW = WIDGET.record.doc.cssClassW
                        }
                        if (WIDGET.record?.doc?.cssClassH) {
                            WIDGET.cssClassH = WIDGET.record.doc.cssClassH
                        }

                        // ?is closed
                        const current = store.findWidget(WIDGET.id)
                        if (current.ind === null) {
                            return
                        }

                        store.sync_WORKSPACE(WIDGET, '>>WIDGET')

                        if (WIDGET.widget === 'widget-row') {
                            store.apply_widgetRow_layout(WIDGET)
                        }

                        const _cb_params = Array.isArray(callback_params) ? callback_params : (callback_params?.params || [])
                        const _cb_before = !Array.isArray(callback_params) && !!callback_params?.before_setup
                        if (callback && _cb_before) {
                            callback(WIDGET, ..._cb_params)
                            if (WIDGET.loading?.widget_cache_key) {
                                delete WIDGET.loading.widget_cache_key
                            }
                        }

                        store.widget_finishSetup(WIDGET)
                        store._upsertFrontHistory(WIDGET)
                        // IE 2026 09 26 / ODOO-5800: скелет переоткрыт «только вид» после 204 (net_on204) — плашка ставится ПОСЛЕ ответа: Object.assign выше заменил notification
                        if (WIDGET._net204Notice) { WIDGET.notification = { ...(WIDGET.notification || {}), visible: true, status: 'warning', header: '', text: WIDGET._net204Notice }; delete WIDGET._net204Notice }
                        // _noActivate: открытие/обновление вслед за выделением
                        // не крадёт активность у виджета-источника
                        if (WIDGET.widget !== 'widget-selection' && !WIDGET.parentAction?._noActivate) {
                            nextTick(() => {
                                // IE 2026 08 21 (замечание Игоря): активный виджет страницы
                                // задаётся ОДИН раз — ответы top-level виджетов при загрузке
                                // страницы не перетягивают рамку (и не дёргают scroll);
                                // дочерние открытия пользователя активируются как раньше
                                const _act = store.activeWIDGET
                                const _settled = _act && !_act.close && !_act._softClosed
                                    && _act !== WIDGET
                                    && _act.workspace === WIDGET.workspace
                                    && _act.page === WIDGET.page
                                const _pageOpen = WIDGET.parentAction?.action_name === 'action-front-1'
                                    && !WIDGET.parentWIDGET
                                // IE 2026 09 04 / ODOO-336291 (mobile UX): B-17 activateVisible — в ленте карточек ответы виджетов страницы не активируют
                                // «кто первый ответил» (на R1h_001 активным оказывался виджет за экраном): активным становится
                                // первый виджет в кадре. Выкл: window.mobileUi.set('activateVisible', false)
                                if (_pageOpen && store.mobileUi?.on && store.mobileUi.cardsBoard !== false && store.mobileUi.activateVisible !== false) {
                                    store.mobileActivateVisible_schedule(WIDGET)
                                } else if (!_pageOpen || !_settled) {
                                    store.widget_activate(WIDGET, 'widget_open', true, true)
                                }
                            })
                        }

                        if (_activeAttr?.binding) {
                            nextTick(() => {
                                store.set_activeAttr(WIDGET.view, _activeAttr, WIDGET)
                                // trigger content_Changed on AttrTabPanel
                                WIDGET.vueObj?.content_Changed()
                            })
                        }

                        if (WIDGET.widget === 'widget-selection') {
                            PAGE.WIDGET_selection = WIDGET
                        }
                        if (callback && !_cb_before) {
                            callback(WIDGET, ..._cb_params)
                        }

                        // R5 (openSelect): в actions_after приезжает ответ select —
                        // его командам (updateDoc и пр.) нужен контекст виджета:
                        // WIDGET и content_Changed (компонент мог не смонтироваться —
                        // суррогат делегирует живому vueObj, когда он появится)
                        const _aa_ctx = store.fastEntry.openSelect
                            ? { WIDGET, content_Changed: () => WIDGET.vueObj?.content_Changed?.() }
                            : {}
                        for (const action_after of answer.actions_after || []) {
                            if (action_after.deferred) { store.schedule_deferredAction({}, action_after); continue }
                            store.executeStoreMethod(_aa_ctx, action_after)
                        }
                    },
                    error: function (error, textStatus) {
                        _release_primary()
                        store.report_progress_stop(WIDGET) // R17
                        if (textStatus === 'abort') { // Stop: остановлено пользователем
                            return
                        }
                        store.widget_reveal(WIDGET, 'error')
                        store.TERMINAL(WIDGET, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                })
                } // send_widgetOpen
                WIDGET._widgetOpen_repeat = send_widgetOpen
                send_widgetOpen()
            } catch (error) {
                store.widget_reveal(WIDGET, 'error')
                store.TERMINAL(WIDGET, null, {text:error, status:'error'})
            }
        },
        // скрыть новый виджет до ответа widget_open, но не дольше widgetReveal_delay:
        // быстрый ответ → первый видимый кадр сразу полный (без скелета с id),
        // медленный → по таймауту показывается скелет (title/чип уже из ячейки)
        // ⚠ reveal-tradeoff: механизм «отложенного показа» СОХРАНЁН (флаги
        // _revealPending/таймер widgetReveal_delay), но CSS-класс
        // .widget-reveal-pending теперь НЕ прячет окно (opacity:1 + скелетон,
        // перф-задача «мгновенный отклик»). Анти-моргание сырого виджета
        // обеспечивает .widget-first-loading .widget-content (visibility:hidden)
        // + CSS-скелетон. НЕ удалять этот механизм как «мёртвый» и НЕ возвращать
        // opacity:0 без сверки обеих задач — см. маркер reveal-tradeoff в Widget.vue.
        widget_deferReveal(WIDGET) {
            const store = this
            if (!store.widgetReveal_delay) return
            WIDGET._revealPending = true
            WIDGET._revealStart = performance.now() // TEMP: замер фактического ожидания
            WIDGET._revealTimer = setTimeout(() => {
                store.widget_reveal(WIDGET, 'timeout')
            }, store.widgetReveal_delay)
        },
        widget_reveal(WIDGET, reason = 'answer') {
            // мутация через реактивную обёртку (findWidget): caller держит raw-объект,
            // а снятие флага из таймера без прочих реактивных изменений иначе
            // не перерисует виджет (окно осталось бы невидимым)
            const W = this.findWidget(WIDGET.id)?.WIDGET || WIDGET
            // TEMP: сигнализация фактического времени ожидания (убрать после проверки)
            if (W._revealStart) {
                const ms = Math.round(performance.now() - W._revealStart)
                if (reason === 'timeout') {
                    // console.log(`[reveal] WIDGET#${W.id} «${W.title || ''}»: бэк не успел за ${ms}ms (лимит ${this.widgetReveal_delay}ms) — показан скелет-кадр`)
                } else {
                    // console.log(`[reveal] WIDGET#${W.id} «${W.title || ''}»: ${reason} за ${ms}ms — ${W._revealPending ? 'скелет пропущен, сразу полный кадр' : 'скелет уже был показан по таймауту'}`)
                    W._revealStart = null
                }
            }
            if (W._revealTimer) {
                clearTimeout(W._revealTimer)
                W._revealTimer = null
            }
            if (W._revealPending) {
                W._revealPending = false
            }
        },
        // IE 2026 09 20 / ODOO-5800 (Igor через ie-dm7 #32448: команда «открыть список правил» блока RULES формы ячейки). Списочный виджет правил открывается с чипсом-фильтром
        // «правила ячейки» над таблицей (CHIP-Where, место Input — отбор делает бэк на входе выборки): список уже открыт на странице — активировать и ЗАМЕНИТЬ
        // чипс (второй не плодим); иначе открыть «только вид» (open_view_only — без автовыборки всех строк) и сделать ОДИН select уже с чипсом.
        // Чипс живёт в памяти вкладки: в запись списка и в стол не сохраняется (cellRulesChip_strip выше по коду)
        cellRulesList_open(parent_vueObj, target, chip) {
            const store = this
            if (!target?.widget || !chip) return
            const GRID = 'dataSheet'
            const put = (W) => {
                const rec = W?.record
                if (!rec || typeof rec !== 'object') return false
                if (!rec.doc) rec.doc = {}
                if (!rec.doc.viewParams) rec.doc.viewParams = {}
                if (!rec.doc.viewParams[GRID]) rec.doc.viewParams[GRID] = {}
                const vp = rec.doc.viewParams[GRID]
                if (!Array.isArray(vp.CHIPS)) vp.CHIPS = []
                for (let i = vp.CHIPS.length - 1; i >= 0; i--) if (cellRulesChip_is(vp.CHIPS[i])) vp.CHIPS.splice(i, 1)
                vp.CHIPS.push(chip)
                return true
            }
            // select — когда компонент виджета смонтирован и прежняя загрузка закончилась (короткий опрос, до ~8 с)
            const select = (W, n = 110) => {
                if (!W || W.close) return
                if (W.vueObj && !W.loading) {
                    store._cellRulesListOpens = (store._cellRulesListOpens || 0) + 1
                    // IE 2026 10 22 / ODOO-5800 (versions widget; бот dev02 22.10: у свежеоткрытого виджета версий чипс не вставал — CHIPS [] после открытия): чипс кладётся
                    // ещё раз В МОМЕНТ отправки select — между колбэком widget_open (before_setup) и монтированием компонента запись виджета могла быть заменена
                    // (widget_finishSetup / ответ открытия); put идемпотентен (свой чипс заменяется, второй не плодится)
                    put(W)
                    store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                    return
                }
                if (n > 0) setTimeout(() => select(W, n - 1), 75)
            }
            const WS = store.activeWORKSPACE, pageId = WS?.activePAGE?.page
            // отчёт-источник развёрнут на всю страницу (Alt F: position fixed поверх страницы) — список, открытый «под ним», пользователь бы не увидел:
            // список разворачивается тоже (ложится поверх; Esc возвращает его размер и открывает отчёт, каким он был). Состояние источника не трогаем
            const srcMax = !!parent_vueObj?.WIDGET?.styleWidget?._mobileMax
            const open = (WS?.ALL_WIDGETS || []).find(w => w && w.page === pageId && !w.close && w.widget === target.widget && !w.multiply_key)
            if (open) {
                if (open._softClosed) store._widget_restoreSoftClosed(open)
                if (srcMax && open !== parent_vueObj.WIDGET) { if (!open.styleWidget) open.styleWidget = {}; open.styleWidget._mobileMax = true }
                store.widget_activate(open, 'cellRulesList_open', true, true)
                if (put(open)) select(open)
                return
            }
            const widget_init = {
                record: { _meta: {} }, widget: target.widget, fieldsMapping: [], styleWidget: srcMax ? { _mobileMax: true } : {},
                parentAction: { command: 'widget_open', widget: target.widget, _activate: true, _cellRules: true },
                _open_view_only: true,   // без автовыборки: данные придут одним select уже с чипсом
                _gotRealOpen: true,      // кадр из снапшота прошлого входа (весь список без отбора) не показываем
            }
            store.widget_open(widget_init, parent_vueObj, (W0) => {
                const W = store.findWidget(W0.id)?.WIDGET || W0   // реактивный объект виджета
                delete W._open_view_only
                if (put(W)) select(W)
            }, { before_setup: true })
        },
        widgets_created(WIDGET) {
            let store = this
            if (WIDGET.workspace === 'workspace-store') {
                store.WIDGETS[WIDGET.id] = WIDGET
                store.globalSearch.show(WIDGET.id)
                return
            }

            let WORKSPACE = store.WORKSPACES[WIDGET.workspace],
            parent_ind = null

            if ('parentWIDGET' in WIDGET && !(WIDGET.parentWIDGET?.id || false)) {
                delete WIDGET.parentWIDGET
            }

            WORKSPACE.ALL_WIDGETS = WORKSPACE.ALL_WIDGETS ?? []

            // повторное открытие существующего виджета (reload/updateRelatedWidgets)
            // не должно регистрировать его вторым экземпляром: дубль id в
            // renderedWidgets давал «Duplicate keys» и задвоенные окна в кадре.
            // ⚠ Если под тем же id лежит ДРУГОЙ объект (счётчик id обнулился при
            // пересоздании стола) — старую запись заменяем, а не пропускаем новую:
            // незарегистрированный виджет ронял компоненты «findWidget → null»
            // (attrs_vueObj of null на dev02)
            {
                const _ex = WORKSPACE.ALL_WIDGETS.findIndex(w => w.id === WIDGET.id)
                if (_ex !== -1) {
                    if (WORKSPACE.ALL_WIDGETS[_ex] === WIDGET) return
                    WORKSPACE.ALL_WIDGETS.splice(_ex, 1)
                }
            }

            if ('parentWIDGET' in WIDGET) {
                //place the WIDGET after the parent
                const parent = store.findWidget(WIDGET.parentWIDGET.id)
                parent.WIDGET.children_widget_id = WIDGET.id

                const parentAllInd = WORKSPACE.ALL_WIDGETS.findIndex(w => w.id === parent.WIDGET.id)
                if (parent.workspace === WIDGET.workspace && parentAllInd < WORKSPACE.ALL_WIDGETS.length - 1) {
                    // find index in ALL_WIDGETS just after the parent, within same page
                    const nextSamePage = WORKSPACE.ALL_WIDGETS.findIndex((w, i) => i > parentAllInd && w.page === WIDGET.page)
                    if (nextSamePage !== -1) {
                        parent_ind = nextSamePage
                    }
                }
            }

            if (parent_ind === null) {
                // find position in ALL_WIDGETS: first widget on same page with id > WIDGET.id
                for (let i = 0; i < WORKSPACE.ALL_WIDGETS.length; i++) {
                    const w = WORKSPACE.ALL_WIDGETS[i]
                    if (w.page === WIDGET.page && w.id > WIDGET.id) {
                        if (parent_ind === null || w.id < WORKSPACE.ALL_WIDGETS[parent_ind].id) {
                            parent_ind = i
                        }
                    }
                }
            }

            WIDGET.isVisible = false

            if (parent_ind !== null) {
                WORKSPACE.ALL_WIDGETS.splice(parent_ind, 0, WIDGET)
            } else {
                WORKSPACE.ALL_WIDGETS.push(WIDGET)
            }

            this.preventVerticalScroll(document.body)

            // const pageYOffset = window.scrollY
            // PAGE.mainArea?.vueObj.$nextTick(() => {
            //     window.scrollTo(0, pageYOffset)
            // })

        },
        widget_setup(WIDGET) {
            const store = this
            
            WIDGET.id = store.nextWidget_id++
            WIDGET.class = { WIDGET: true }
            
            WIDGET.nodes_svg = {} // info
            WIDGET.attrs_vueObj = []
            WIDGET._view = {}

            WIDGET.TERMINAL = ''
            WIDGET.notification = {
                header: '',
                text: '',
                status: false,
                visible: false,
                fading: false,
                closing: false,
                timerId: null,
                statuses: { // timeout
                    info: 10001,
                    warning: 10002,
                    error: 10003,
                    critical: 10004,
                    success: 10005,
                    pending: null,
                }
            }
            WIDGET.editAttrs = false
            WIDGET.attrsResize = []
            WIDGET.applys_CHIPS = {}
            WIDGET.timerId = null
            WIDGET.style = ``
            // прятать до раскладки — только при первом рендере страницы; уже показанную
            // страницу не гасим (пересоздание набора виджетов давало «появление → скрытие
            // → появление»), на новые места виджеты доводит transition
            WIDGET.hidden = !store.WORKSPACES[WIDGET.workspace]?.PAGES?.[WIDGET.page]?._widgetsShown
            // префилл чипа шапки (иконка + аббревиатура сегмента) из фронтового реестра
            // SEGMENTS — правильная иконка видна сразу, не дожидаясь ответа бэка
            // (бэк затем перезапишет своими значениями через updateWIDGET)
            if (!WIDGET.shortTitle) {
                // сначала widget, затем сегмент записи (открытие из ячейки:
                // widget определит бэк, но сегмент ссылки известен сразу)
                for (const segment_ of [WIDGET.widget, WIDGET.record?._meta?.segment, WIDGET.record?.segment]) {
                    if (typeof segment_ !== 'string' || !segment_) continue
                    const shortTitle_ = store.get_value_segment(segment_, 'shortTitle', '')
                    if (shortTitle_) {
                        WIDGET.shortTitle = shortTitle_
                        if (!WIDGET.pi) WIDGET.pi = store.get_value_segment(segment_, 'pi', '')
                        break
                    }
                }
            }
            // «фриз» тела до конца цепочки первичной загрузки (первый ответ может нести
            // только структуру, данные приходят следующим запросом — см. executeWidgetMethod)
            WIDGET._firstLoading = true
            WIDGET.styleWidget = {
                marginTop: 3,
                marginRight: 3,
                marginBottom: 3,
                marginLeft: 3,
        
                top_rem: 0,
                left_rem: 0,
                width_rem: 1,
                height_rem: 1,

                setWidgetRect: '',
                top_pct: 0,
                left_pct: 0,
                width_pct: 0,
                height_pct: 0,
                
                dock: 'popout',

                // widthMin_rem:1, in doc
                // heightMin_rem:1,

                ...WIDGET.styleWidget,
            }
            WIDGET.firstBackendCheck = true
        },
        widget_finishSetup(WIDGET) {
            const store = this
            const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            const PAGE = WORKSPACE.PAGES[WIDGET.page]

            WIDGET.firstBackendCheck = false
            // сырой WIDGET первого открытия: снять «спиннерные» элементы
            // (кнопка Stop, полоса) даже если объект ещё не реактивен
            WIDGET.vueObj?.$forceUpdate?.()

            // R10: запомнить минимумы виджета для скелета следующего открытия
            if (store.fastEntry.geomPresets && WIDGET.widget && WIDGET.widget !== 'widget-row') {
                store.geom_preset_put(WIDGET.widget, WIDGET.record?.doc)
            }

            // store.clear_frontend_markers(WIDGET.record)
            store.set_nonEmptyWidget(WIDGET)
            store.set_isMappedWidget(WIDGET)
            WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel()
            if (WIDGET._nav?.siblings?.length && WIDGET.parentWIDGET?.id) {
                const _parentW = store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
                if (_parentW) store.addEdgeWidgetRecord(_parentW, WIDGET)
            }

            // store.widgets_created(WIDGET) ...2
            store.check_childWidgets(null, WIDGET)
            store.check_childWidgets(WIDGET)
            if (WIDGET.vueObj) {
                // WIDGET.vueObj?.content_Changed()
                store.widget_checkLoading(WIDGET.vueObj)
            }
            // цепочки загрузки данных нет (локальный контент — напр., widget-row
            // frontend-сборки) — снять «фриз» тела; при активной цепочке (loading —
            // экшен/true) фриз снимет success последнего ответа в executeWidgetMethod
            if (WIDGET._firstLoading && !WIDGET.loading) {
                WIDGET._firstLoading = false
            }
            if (WIDGET.workspace !== 'workspace-store') {
                WIDGET.styleWidget.setVisible = true
                PAGE?.mainArea?.vueObj.checkWorkspaceScroll()
            }
            
            {
                const vp = WIDGET.record?.doc?.viewParams
                if (vp && 'zenMode' in vp) {
                    const z = vp.zenMode
                    if (!('hideHeader' in vp))    vp.hideHeader    = z === 1
                    if (!('hideTabs' in vp))      vp.hideTabs      = (z === 2 || z === 20 || z === 3)
                    if (!('hideGridPanel' in vp)) vp.hideGridPanel = z === 3
                    delete vp.zenMode
                }
                if (vp) {
                    // IE 2026 09 26 / ODOO-5800: запись через реактивный прокси — WIDGET здесь бывает сырым (первое открытие), а computed Widget.floatHeaderOn,
                    // вычисленный до этой записи, оставался false: Float у записей с viewParams.floatHeader: true не включался при открытии (с fe.ux.tabsLazyHidden —
                    // раньше пересчёт давала фоновая монтировка выключенных вкладок). reactive() сырого объекта отдаёт его существующий прокси.
                    const swR = reactive(WIDGET).styleWidget
                    for (const key of ['hideHeader', 'hideTabs', 'hideGridPanel', 'floatHeader']) {   // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): floatHeader — шапка островками
                        if (key in vp) swR[key] = vp[key]
                    }
                }
                WIDGET.styleWidget.show_hidden = false
            }

            // contextWidgetMenu
            if (WIDGET.groupMenu) {
                WIDGET.groupMenu.contextWidgetMenu = []
                if (WIDGET.groupMenu.actionMenu) {
                    // Open up menu ‘action’ in contextWidgetMenu
                    let indMemu = 0
                    while (indMemu < WIDGET.groupMenu.actionMenu.length) {
                        let itemMenu = WIDGET.groupMenu.actionMenu[indMemu]
                        if (itemMenu.title === '-') {
                            indMemu++;
                            break
                        }
                        WIDGET.groupMenu.contextWidgetMenu.push(itemMenu)
                        indMemu++;
                    }
                    if (indMemu < WIDGET.groupMenu.actionMenu.length) {
                        let itemMenu2 = { 'title': t('Action'), _key: 'Action', 'attrs': [] }   // IE 2026 09 23 / ODOO-341407: i18n (_key — языконезависимый ключ избранного)
                        while (indMemu < WIDGET.groupMenu.actionMenu.length) {
                            let itemMenu = WIDGET.groupMenu.actionMenu[indMemu]
                            itemMenu2.attrs.push(itemMenu)
                            indMemu++;
                        }
                        WIDGET.groupMenu.contextWidgetMenu.push(itemMenu2)
                    }
                }
            }

            store.WRow_finishSetup(WIDGET)
            store.settingsForm_prefetchIfVisible(WIDGET, 'visible')   // IE 2026 09 28 / ODOO-5800: полоса вкладок видна — форма настроек фоном (бейджи и скрытие пустых вкладок)
        },
        WRow_finishSetup(WIDGET, parentWIDGET) {
            const store = this
            if (WIDGET.widget === 'widget-row') {
                parentWIDGET = parentWIDGET || store.findWidget(WIDGET.parentWIDGET.id).WIDGET
                const _meta = WIDGET.record?._meta
               
                store.addEdgeWidgetRow(parentWIDGET, WIDGET, _meta)
               
                if (_meta?.type === 'widget-row-viewParams') {
                    WIDGET.record._data = store.get_value(parentWIDGET.record, _meta.binding) || []
                    // дерево Fields (грид binding 'attrs') читает из корня записи:
                    // для синтетических конфигов (список ячеек печати) attrs приходят
                    // только в _record — прокидываем, штатный поток не трогаем
                    if (WIDGET.record.attrs === undefined && WIDGET.record._record?.attrs) {
                        WIDGET.record.attrs = WIDGET.record._record.attrs
                    }
                } else if (_meta?.type === 'widget-row-chip') {
                    WIDGET.record._record = store.get_chip(parentWIDGET, _meta) || {}
                } else if (_meta?.type === 'widget-row-record-embed' && WIDGET.record._record) {
                    // _record passed directly as object reference — no binding/backend fetch needed
                }
                store.set_widgetRow_shortTitle(WIDGET, _meta)
            }
        },
        validate_newRecord(WIDGET, type='clone') {
            const store = this

            let record = WIDGET.record || {};
            WIDGET.record = record
        
            let _meta = record._meta = record._meta || {};
            let meta = record.meta = record.meta || {};
        
            if (type === 'clone') {
                _meta.new = true;
                _meta.modified = true;
                _meta.clone = true;
                _meta.cloned_record = record.id || '';
                record.id = '';
        
                if (record.title) {
                    WIDGET.title = record.title = store.increment_name(record.title)
                }

                delete meta.predefined;
                delete meta.noupdate; // look >> transfer to another base on predefined
            
            } else if (type === 'paste') {
                _meta.new = true;
                _meta.modified = true;
                _meta.cloned_record = record.id || '';
                
                _meta.pasted = true;
            }
        },
        copyWidget_JSON(parentWIDGET) {
            const store = this
        
            const WIDGET = store.structuredCloneWithSelectedKeys(parentWIDGET, [
                "area", "page", "class", "component", "groupMenu",
                "INFO", "INFO_id", "INFO_title", "isVisible",
                "parentAction", "pi", "pi2", "record", "pi", "recordTitle", "segmentTitle",
                "title", "tooltip", "view", "widget", "widget_class", "workspace"
            ]);

            // const WIDGET = store.structuredCloneWithoutKeys(parentWIDGET, [
            //     "id", "_view", "nodes_svg", "attrs_vueObj", "_view", "notification", 
            //     "editAttrs", "attrsResize", "applys_CHIPS", "timerId", "style", 
            //     "hidden", "styleWidget", "firstBackendCheck",
            //     attr_isMappedWidget, childrenWidgets, fieldsMapping, getSelectionWorkspace_date
            // ]);

            return WIDGET
        },
        pasteWidget_JSON(WIDGET, type='paste') {
            const store = this
        
            store.widget_setup(WIDGET)
            store.checkWIDGET_dock(WIDGET, null)

            store.prepare_attrs(WIDGET.view, `clone-view${WIDGET.id}`)
            store.prepare_attrs([WIDGET.groupMenu], `clone-groupMenu${WIDGET.id}`)

            store.widgets_created(WIDGET)

            store.validate_newRecord(WIDGET, type)

            nextTick(() => {
                store.widget_finishSetup(WIDGET)
            })
        },
        _upsertFrontHistory(WIDGET) {
            const store = this
            if (!WIDGET) return   // IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): widget_activate(null) при пустом activeWIDGET звал историю с null — TypeError обрывал widget_close до отметки _softClosed
            if (WIDGET.widget === 'widget-row' || WIDGET._hiddenOpen) return   // IE 2026 09 22 / ODOO-5800: скрыто открытый виджет пользователь не видел
            const idx = store.frontHistory.findIndex(e => e._WIDGET === WIDGET)
            if (idx >= 0) store.frontHistory.splice(idx, 1)
            store.frontHistory.unshift({
                _frontendEntry: true,
                _WIDGET: WIDGET,
                _workspace: WIDGET.workspace,
                _page: WIDGET.page,
                record_id: WIDGET.record?.id || '',
                highlightedTitle: WIDGET.title || WIDGET.record?.title || '',
                viewed_at: new Date().toISOString(),
                segment: WIDGET.record?.segment || '',
                'segment.title': WIDGET.record?.['segment.title'] || '',
                widget: WIDGET.widget || '',
                'widget.title': WIDGET.widget || '',
            })
        },
        _seedFrontHistory() {
            const store = this
            const PAGE = store.activeWORKSPACE?.activePAGE
            if (!PAGE) return
            const WORKSPACE = store.activeWORKSPACE
            const _pageWidgets = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)
            for (const WIDGET of _pageWidgets) {
                if (WIDGET.widget === 'widget-row') continue
                if (store.frontHistory.find(e => e._WIDGET === WIDGET)) continue
                store.frontHistory.push({
                    _frontendEntry: true,
                    _WIDGET: WIDGET,
                    _workspace: WIDGET.workspace,
                    _page: WIDGET.page,
                    record_id: WIDGET.record?.id || '',
                    highlightedTitle: WIDGET.title || WIDGET.record?.title || '',
                    viewed_at: new Date().toISOString(),
                    segment: WIDGET.record?.segment || '',
                    'segment.title': WIDGET.record?.['segment.title'] || '',
                    widget: WIDGET.widget || '',
                    'widget.title': WIDGET.widget || '',
                })
            }
        },
        // при восстановлении: синхронно пересчитать layout страницы (размеры всех
        // виджетов + рект восстанавливаемого) пока элемент скрыт; display вернёт
        // v-show на следующем тике — виджет появится сразу в нужном месте/размере
        _widget_layoutBeforeShow(WIDGET) {
            const mainArea = this.WORKSPACES[WIDGET.workspace]?.PAGES?.[WIDGET.page]?.mainArea?.vueObj
            if (!mainArea) return
            if (mainArea.setStyle_timeout) {
                clearTimeout(mainArea.setStyle_timeout)
                mainArea.setStyle_timeout = null
            }
            // если на странице есть другие виджеты — они «переезжают» на новые места
            // transition: all 200ms (.WIDGET); показать восстанавливаемый после этого.
            // Реактивный флаг -> класс widget-restoring в :class Widget.vue
            // (classList.add нельзя: Vue при патче перезаписывает класс целиком).
            // Свободные (popout) виджеты layout не двигают — задержка не нужна;
            // widget-row — исключение: он позиционируется от родителя/строки,
            // поэтому ждёт перестройку даже будучи popout
            const isFree = (w) => w.styleWidget?.dock === 'popout' && w.widget !== 'widget-row'
            const hasOthers = !isFree(WIDGET) && (this.WORKSPACES[WIDGET.workspace]?.ALL_WIDGETS ?? [])
                .some(w => w !== WIDGET && w.page === WIDGET.page && !w._softClosed && !w.close && !isFree(w))
            if (hasOthers) {
                WIDGET._restoring = true
                setTimeout(() => {
                    WIDGET._restoring = false
                }, 250) // 200ms transition + запас
            }
            // элемент ещё display:none (widget_close); setWIDGET_style display не чистит,
            // v-show снимет его на следующем тике — виджет появится сразу с готовым ректом
            mainArea.setStyle_afterTimeout()
        },
        _widget_restoreSoftClosed(WIDGET) {
            const store = this
            const idx = store.closedWidgets.findIndex(e => e.WIDGET === WIDGET)
            if (idx >= 0) {
                clearTimeout(store.closedWidgets[idx].timerId)
                store.closedWidgets.splice(idx, 1)
            }
            delete WIDGET._softClosed
            delete WIDGET._hiddenOpen   // IE 2026 09 22 / ODOO-5800: скрыто открытый (подбор чипса) виджет показан пользователем — дальше как обычный
            // IE 2026 09 09 / ODOO-…: вернулась задача трансформации / форма с привязкой — пересчитать привязки страницы
            if (WIDGET.record?.segment === 'TASKS-transform' || WIDGET.attr_isMappedWidget) store.set_isMappedWidgets(WIDGET)
            store._widget_layoutBeforeShow(WIDGET)
            if (WIDGET._selector_refresh_needed) {
                delete WIDGET._selector_refresh_needed
                const PAGE = store.WORKSPACES[WIDGET.workspace]?.PAGES?.[WIDGET.page]
                store.executeStoreMethod(WIDGET.vueObj, {
                    command: 'executeWidgetMethod',
                    method: 'select',
                    record_sendToBackend_exclude: ['_doc'],
                    record_sendToFrontend_exclude: PAGE?.refresh_needed ? [] : ["view"],
                })
            }
            store._upsertFrontHistory(WIDGET)
            store.refresh_pageWidgets(WIDGET.workspace, WIDGET.page)
        },
        pasteWidgetFromClipboard() {
            const store = this
            // IE 2026 09 23 / ODOO-341407: i18n (тосты функции)
            navigator.clipboard.readText()
                .then(text => {
                    if (!text) { store.show_notification({ text: t('Clipboard is empty'), status: 'warning' }); return }
                    let content
                    try { content = store.parseClipboardWidget(text) } catch (e) {
                        store.show_notification({ text: t('Clipboard does not contain valid JSON: {error}', { error: e.message }), status: 'error' }); return
                    }
                    if (content?.doc?.WIDGET) {
                        const WIDGET1 = content.doc.WIDGET
                        WIDGET1.page = store.activeWORKSPACE.active_page
                        WIDGET1.workspace = store.activeWORKSPACE.workspace
                        WIDGET1.process_model = store.process_model_record.id
                        store.pasteWidget_JSON(WIDGET1, 'paste')
                        store.show_notification({ text: t('Pasted widget from clipboard!') })
                    } else {
                        store.show_notification({ text: t('Clipboard does not contain a valid WIDGET'), status: 'error' })
                    }
                })
                .catch(err => store.show_notification({ text: t('Failed to paste from clipboard: {error}', { error: err.message }), status: 'error' }))
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка): пункт меню пользователя «Import records» — записи из буфера (Deep copy / Copy record / Copy rows) → бэк records_import_prepare
        // создаёт задачу TASKS-records-import с ними и отвечает widget_open (форма открывается заполненной); буфер пуст / не записи / нет доступа →
        // пустая форма задачи и подсказка. Открытие — без родительского виджета (vueObj {}), как ссылка open_record: меню живёт и на пустой странице; в case copyPaste ветка importRecords стоит до чтения WIDGET
        importRecords_fromClipboard(source = 'clipboard') {   // IE 2026 10 28 / ODOO-349799 (PR5): source 'file' — текст из выбранного файла (importRecords_fromFile), подсказки про файл
            const store = this
            if (!importRecordsMenu_on((k, d) => store.setting?.(k, d))) return Promise.resolve({ kind: 'off', count: 0 })
            const fileText = typeof source === 'object' && source ? source.fileText : undefined   // IE 2026 10 28 / ODOO-349799 (PR5)
            return importRecords_run({
                source: fileText !== undefined ? 'file' : 'clipboard',   // IE 2026 10 28 / ODOO-349799 (PR5)
                readText: () => fileText !== undefined ? fileText : navigator.clipboard.readText(),   // IE 2026 10 28 / ODOO-349799 (PR5)
                openEmpty: (hint) => {
                    store.executeStoreMethod({}, importRecords_emptyAction())
                    store.show_notification({ text: t(hint), status: 'warning' })
                },
                prepare: (r, onAnswer) => store.executeBackendMethod({}, importRecords_backendAction(r), onAnswer),   // IE 2026 10 27 / ODOO-5800 (ревью p068 N8): JSON → params.chip, python-литерал → сырой params.text
                openAnswer: (answer) => store.executeStoreMethod({}, answer),
            }).catch(err => {
                store.show_notification({ text: t('Failed to import records from clipboard: {error}', { error: err?.message || String(err) }), status: 'error' })
                return { kind: 'error', count: 0 }
            })
        },
        // IE 2026 10 28 / ODOO-349799 (PR5): пункт меню «Import records from file» — файл (тот же CHIP-Widget / CHIP-Records / запись из predefined/) → форма Records Import как из буфера; отмена диалога — молча
        importRecords_fromFile() {
            const store = this
            if (!importRecordsMenu_on((k, d) => store.setting?.(k, d))) return Promise.resolve({ kind: 'off', count: 0 })
            return store.pickTextFile({ accept: '.json,.txt,.py,application/json,text/plain', multiple: false })
                .then(({ text }) => store.importRecords_fromClipboard({ fileText: text || '' }))
                .catch(err => {
                    if (err && err.code === 'USER_CANCEL') return { kind: 'cancel', count: 0 }
                    store.show_notification({ text: t('Failed to import from file: {error}', { error: err?.message || String(err) }), status: 'error' })
                    return { kind: 'error', count: 0 }
                })
        },
        // IE 2026 10 28 / ODOO-349799 (PR5): вставка / файл в таблицу Records Import (грид chip-records): формат разбирает бэк (records_import_normalize), строки — insertAction как у Deep copy
        importRecords_intoGrid(vueObj, attr_vueObj, text, notificationOptions, action = null) {   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix): action — имя выбранного файла (_importFileName) и цепочка then
            const store = this
            store.executeBackendMethod({}, importRecords_normalizeAction(text, { file_name: action?._importFileName }), (answer) => {   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix): имя файла — бэку (в строки как _source_name)
                const { rows, warning, skipped, error } = importRecords_rowsFromAnswer(answer)   // IE 2026 10 28 / ODOO-349799
                if (error) return   // IE 2026 10 28 / ODOO-349799: ошибку бэка уже показал executeBackendMethod — второй тост не нужен
                if (!rows.length) {
                    store.show_notification({ text: warning || t('The backend did not normalize the content'), status: 'warning' })
                    return
                }
                if (typeof attr_vueObj?.insertAction !== 'function') return   // IE 2026 10 28 / ODOO-349799: грид уже размонтирован — молча пропустить
                const doInsert = () => {
                    attr_vueObj.insertAction({ attrs: rows })
                    store.show_notification(notificationOptions)
                    if (skipped > 0) store.show_notification({ text: t('{n} linked records skipped', { n: skipped }), status: 'warning' })   // IE 2026 10 28 / ODOO-349799
                    vueObj?.content_Changed?.()   // IE 2026 10 28 / ODOO-349799
                    if (action?.then && importRecords_pasteThen_on((k, d) => store.setting(k, d))) store.executeStoreMethod(vueObj, action.then)   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix): цепочка «вставить → следующее действие» одним кликом (fe.ux.pasteThen)
                }
                // IE 2026 11 02 / ODOO-349799 (insert-unbuilt-grid): грид ниже сгиба не построен (строится по v-visible) — прокрутить в кадр и дождаться построения, иначе insertAction падает (fe.ux.pasteUnbuiltGrid)
                if (importRecords_pasteUnbuiltGrid_on((k, d) => store.setting(k, d)) && !importRecords_gridBuilt(attr_vueObj)) {
                    importRecords_ensureGridBuilt(attr_vueObj).then(built => {
                        if (built) doInsert()
                        else store.show_notification({ text: t('The grid is not ready yet, scroll it into view and paste again'), status: 'warning' })
                    })
                    return
                }
                doInsert()
            })
        },
        restoreLastClosedWidget() {
            const store = this
            if (store.closedWidgets.length === 0) return
            const entry = store.closedWidgets.pop()
            clearTimeout(entry.timerId)
            if (store.closedWidgets.length > 0) {
                const newLast = store.closedWidgets[store.closedWidgets.length - 1]
                clearTimeout(newLast.timerId)
                newLast.timerId = null
            }
            delete entry.WIDGET._softClosed
            if (entry.WIDGET.record?.segment === 'TASKS-transform' || entry.WIDGET.attr_isMappedWidget) store.set_isMappedWidgets(entry.WIDGET)   // IE 2026 09 09 / ODOO-…
            store._widget_layoutBeforeShow(entry.WIDGET)
            store._upsertFrontHistory(entry.WIDGET)
            store.widget_activate(entry.WIDGET, 'restore', true, true)
        },
        preventVerticalScroll(e) {
            const hasScroll = e.scrollHeight > e.clientHeight
            if (!hasScroll && !e.classList.contains('no-scroll')) {
                e.classList.add('no-scroll')
            }
        },
        widget_activate(WIDGET, from = '', run_scrollInWorkspace = true, focus_activeChips=false) {
            const store = this
            // console.log(`widget_activate::${from} : ${WIDGET?.id}`)

            // if (!WIDGET?.close && WIDGET?._softClosed) {
            //     store._widget_restoreSoftClosed(WIDGET)
            // }

            if (WIDGET?.close) {
                return
            } else if (store.activeWIDGET === WIDGET) {
                if (focus_activeChips) {
                    WIDGET.attrs_vueObj?.WIDGET?._focus_activeChips?.(true)
                    WIDGET.attrs_vueObj?.WIDGET?._flash_border?.()
                }
                store._upsertFrontHistory(WIDGET)
                return
            } else if (WIDGET?.widget_activate === false) {
                return
            // } else if (WIDGET?.area === 'right-area') {
            //     return
            // } else if (WIDGET?.area === 'left-area') {
            //     return
            } else if (WIDGET?.workspace === 'workspace-store') {
                1 // pass
            } else if (WIDGET?.workspace) {
                // if (!this.hide_console) console.log('widget_activate ' + WIDGET.id)
                let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
                let PAGE = WORKSPACE.PAGES[WIDGET.page]

                // activeWORKSPACE
                if (store.activeWORKSPACE !== WORKSPACE) {
                    store.activeWORKSPACE = WORKSPACE
                }

                // (задача 6) НЕ делать ранний return, когда WORKSPACE.activeWIDGET === WIDGET.
                // Раньше при клике по заголовку родителя (пока активен Row-попап, у которого
                // store.activeWIDGET != WORKSPACE.activeWIDGET) код выставлял activeWIDGET и
                // возвращался, минуя визуальную отметку активного заголовка ниже — родитель
                // не подсвечивался активным. Теперь проваливаемся в блок визуальной активации.
                if (store.activeWIDGET !== WORKSPACE.activeWIDGET) {
                    store.activeWIDGET = WORKSPACE.activeWIDGET
                }

                // // deactivate WIDGET
                // if (store.activeWIDGET && store.activeWIDGET.workspace==workspace && $('#widget_title'+store.activeWIDGET.id)[0]) {
                //     $('#widget_title'+store.activeWIDGET.id)[0].classList.toggle("widget-active")
                // } else if (WORKSPACE.activeWIDGET && WORKSPACE.activeWIDGET !== WIDGET && $('#widget_title'+WORKSPACE.activeWIDGET.id)[0]) {
                //     $('#widget_title'+WORKSPACE.activeWIDGET.id)[0].classList.toggle("widget-active")
                // }

                // activate WIDGET
                if (WIDGET) {
                    store.activeWIDGET = WIDGET
                    if (focus_activeChips) {
                        WIDGET.attrs_vueObj?.WIDGET?._focus_activeChips?.()
                    }
                    const active_WidgetHeader = $('#widget_title' + store.activeWIDGET.id)[0]
                    const WidgetContainer = $('#WIDGET' + store.activeWIDGET.id)[0]

                    if (store.dropdown && store.dropdown.WIDGET !== store.activeWIDGET) {
                        if (store.dropdown.cellForm_keepForeign?.()) store.dropdown.cellForm_keepCount?.('foreignKeep')   // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): активирован другой виджет (открытая из формы запись) — форма ячейки, которую держит пользователь, остаётся, пока её грид на экране (Dropdown.cellForm_keepForeign)
                        else store.dropdown.hide()
                    }                    

                    // console.log(`widget_activate: ${WIDGET.id} {WidgetContainer}`)
                    if (WidgetContainer) {
                        PAGE.activeWIDGET = store.activeWIDGET
                        // // activate
                        // active_WidgetHeader.classList.toggle("widget-active")

                        // // focus
                        // const flex = store.activeWIDGET.vueObj.get_flex()
                        // if (flex) {
                        //     flex.focus()
                        // }

                        // // cancel minimization
                        // let WidgetContainer = $('#WIDGET'+WIDGET.id)[0] // document.querySelector(`#WIDGET${WIDGET.id}`)
                        // if (WidgetContainer.classList.contains('widget-h0')) {
                        //     WidgetContainer.classList.remove('widget-h0')
                        // }

                        // scroll
                        if (run_scrollInWorkspace) {
                            store.scrollInWorkspace(WIDGET)
                        } else {
                            // if (!this.hide_console) console.log('// scrollInWorkspace')
                        }
                    } else {
                        store.activeWIDGET = null
                    }
                    
                    store.checkPopout()

                    // закрыть widget-row, если активный виджет — не его родитель и не его потомок
                    // (исключение — виджет, открытый ИЗ этого Row по ссылке/элементу: задача 7)
                    const WRow = store.get_widgetRow()
                    if (WRow && WRow.id !== WIDGET.id && WRow.parentWIDGET?.id !== WIDGET?.id
                        && WIDGET?._openedFromWidgetRow !== WRow.id) {
                        let isDescendantOfWRow = false
                        let pw = WIDGET?.parentWIDGET
                        while (pw?.id) {
                            if (pw.id === WRow.id) { isDescendantOfWRow = true; break }
                            pw = store.findWidget(pw.id)?.WIDGET?.parentWIDGET
                        }
                        if (!isDescendantOfWRow) {
                            store.close_childrenWidgets(WRow)
                            store.widget_close(WRow.id)
                        }
                    }
                }
            } else {
                store.activeWIDGET = null
            }

            // store.rightArea_hide()
        },
        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114842: форма ячейки закрывается при обновлении отчёта): ответ заменил данные виджета (executeStoreMethod: updateDoc с record, updateWIDGET,
        // updateWidget) — открытая форма ячейки ЭТОГО отчёта устарела, закрыть. Решение — utils/reportCellFormClose + Dropdown.reportRefresh_close; fe.ux.reportCellFormCloseOnReload
        reportCellForm_closeOnReload(WIDGET, action) {
            try { return !!this.dropdown?.reportRefresh_close?.(WIDGET, action) } catch (e) { return false }
        },
        widget_close(widget_id_toRemove, reloadParent = false, _hardClose = false) {
            const store = this
            const WIDGET = store.findWidget(widget_id_toRemove).WIDGET

            if (!WIDGET) {
                // pass
            // } else if (WIDGET.area === 'right-area') {
            //     store.rightArea_hide(true)
            // } else if (WIDGET.area === 'left-area') {
            //     store.leftArea_hide(true)
            } else {
                // мгновенно скрыть DOM-элемент: v-show в transition-group ждёт
                // окончания transition .WIDGET (200ms) перед display:none
                const _el = document.getElementById('WIDGET' + widget_id_toRemove)
                if (_el) _el.style.display = 'none'
                // IE 2026 10 12 / ODOO-5800 (заказ Игоря: форма ячейки не закрывается при открытии из неё записей): закрывается виджет-родитель формы ячейки — форма закрывается сразу
                // (раньше её прятала активация следующего виджета; теперь чужая активация держимую форму не прячет, а IntersectionObserver грида отзывается асинхронно)
                if (store.dropdown?.visible && (store.dropdown.WIDGET === WIDGET || store.dropdown.widget_id === WIDGET.id)) store.dropdown.hide()

                let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
                let PAGE = WORKSPACE.PAGES[WIDGET.page]
                const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET.page)

                if (WIDGET.widget === 'widget-selection') {
                    PAGE.WIDGET_selection = null
                }

                PAGE.vueObj.removeNodes(WIDGET)

                // activate parent,...
                if (PAGE.activeWIDGET === WIDGET) {
                    let widget_toActivate = null
                    if ('parentWIDGET' in WIDGET) {
                        widget_toActivate = store.findWidget(WIDGET.parentWIDGET.id).WIDGET
                        if (widget_toActivate && reloadParent && widget_toActivate.page === 'WidgetFlexGrid') { // reloadAfterChangeChild
                            store.executeStoreMethod(widget_toActivate.vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'] })
                        }
                    }
                    if (!widget_toActivate) {
                        widget_toActivate = WIDGETS.find(w => w !== WIDGET && !w._softClosed) || null
                    }

                    store.widget_activate(widget_toActivate, 'widget_close')
                }

                if (!_hardClose) {
                    // soft-close: mark hidden (widget stays in ALL_WIDGETS)
                    if (store.closedWidgets.length > 0) {
                        const _prev = store.closedWidgets[store.closedWidgets.length - 1]
                        if (!_prev.timerId) {
                            _prev.timerId = setTimeout(() => {
                                store._widget_hardClose(_prev.WIDGET)
                                const _idx = store.closedWidgets.indexOf(_prev)
                                if (_idx >= 0) store.closedWidgets.splice(_idx, 1)
                            }, 5 * 60 * 1000)
                        }
                    }
                    store.closedWidgets.push({ WIDGET, timerId: null })
                    WIDGET._softClosed = true
                    store._upsertFrontHistory(WIDGET)
                } else {
                    // hard-close: immediately remove from ALL_WIDGETS
                    WIDGET.close = true
                    WIDGET.vueObj = null
                    const _allInd = (WORKSPACE.ALL_WIDGETS ?? []).findIndex(w => w.id === widget_id_toRemove)
                    if (_allInd !== -1) WORKSPACE.ALL_WIDGETS.splice(_allInd, 1)
                }

                // Clear nav state from widget-record children opened from this widget
                store.update_childrenWidgets(WIDGET)
                for (const child_id of [...(WIDGET.childrenWidgets || [])]) {
                    const childWIDGET = store.findWidget(child_id, WIDGET.workspace)?.WIDGET
                    if (childWIDGET?.widget === 'widget-record' && childWIDGET._nav?.siblings?.length) {
                        if (childWIDGET._nav.shortTitle_base !== undefined) {
                            childWIDGET.shortTitle = childWIDGET._nav.shortTitle_base
                        }
                        delete childWIDGET._nav
                        childWIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.()
                        PAGE.vueObj?.removeNodes?.(childWIDGET)
                    }
                }

                store.close_childrenWidgets(WIDGET, 'widget-row')
                store.check_childWidgets(null, WIDGET)

                store.set_isMappedWidgets(WIDGET)
                store.refresh_pageWidgets(WIDGET.workspace, WIDGET.page)
            }
            this.preventVerticalScroll(document.body)
        },
        _widget_hardClose(WIDGET) {
            const store = this
            WIDGET.close = true
            WIDGET.vueObj = null
            const res = store.findWidget(WIDGET.id)
            if (res?.ind !== null && res.workspace) {
                const _ws = store.WORKSPACES[res.workspace]
                const _allInd = (_ws.ALL_WIDGETS ?? []).findIndex(w => w.id === WIDGET.id)
                if (_allInd !== -1) _ws.ALL_WIDGETS.splice(_allInd, 1)
            }
            const fIdx = store.frontHistory.findIndex(e => e._WIDGET === WIDGET)
            if (fIdx >= 0) store.frontHistory.splice(fIdx, 1)
            store.set_isMappedWidgets(WIDGET)
        },

        // ----------------------- workspace -----------------------
        async workspace_open(workspace, page='', FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this
            if (store._i18nReloading) return   // IE 2026 09 26 / ODOO-341407: fe.i18n.firstLoadHold — страница перезагружается на язык базы
            const WORKSPACE = store.WORKSPACES[workspace]
            if (store.activeWORKSPACE?.workspace === workspace) {
                if (store.activeWORKSPACE.active_page === page || !page) {
                    return WORKSPACE // FIXIT is error case
                } else {
                    return store.workspace_route(workspace, page)
                }
            } else if (WORKSPACE) {
                if (!page) {
                    page = WORKSPACE.active_page
                }
                // ODOO-3749: стол уже загружен (ранний выход не дойдёт до success),
                // но в «последних» он фигурировать должен
                store.touch_recentWorkspace(workspace, WORKSPACE.title || WORKSPACE.record?.title,   // IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): название в группе — на языке интерфейса (WORKSPACE.title бэк локализует, record.title — на языке базы)
                    WORKSPACE.record?.pi, WORKSPACE.record?.img)
                return store.workspace_route(workspace, page)
            }

            // R6b (fastEntry.snapshotWS): каркас стола из снапшота прошлого входа —
            // маршрут и открытие виджетов стартуют, не дожидаясь ответа бэкенда
            if (store.fastEntry.snapshotWS && !store.WORKSPACES[workspace]) {
                store.snapshot_get(store.workspace_snapshot_key(workspace, page)).then(str => {
                    if (!str || store.WORKSPACES[workspace]) return
                    try { store.workspace_snapshot_apply(workspace, page, JSON.parse(str)) }
                    catch (e) { console.warn('[fastEntry:R6b] apply failed', e) }
                })
            }
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'workspace_open',
                    // R10b: попросить минимумы виджетов страниц вместе с каркасом —
                    // скелеты встают в свою геометрию с первого кадра
                    ...(store.fastEntry.geomPresets ? { fast_entry: { geom: true } } : {}),
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    process_model: store.process_model_record.id,
                    workspace_init: {
                        workspace: workspace,
                        active_page: page,
                        workspaceClass: 'workspace_main',
                        // IE 2026 09 14 / ODOO-… (заказ Игоря: варианты страниц и фильтров стола): явный выбор вариантов на сессию (иначе бэк берёт дефолты «для меня» → «для всех»)
                        ...(store.pageVariants[workspace] ? { page_variants: store.pageVariants[workspace] } : {}),
                        ...(store.filtersVariant[workspace] !== undefined ? { filters_variant: store.filtersVariant[workspace] } : {}),
                    },
                    user: store.user,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        // IE 2026 09 26 / ODOO-341407 (fe.i18n.firstLoadHold): на свежем профиле настройки базы (язык по умолчанию) приходят впервые
                        // здесь; нужна перезагрузка на язык базы — стол не строим (ни виджетов, ни их запросов), перезагрузка сразу, на адрес этого стола
                        if (store.i18n_firstLoadHold(answer, 'workspace_open', { workspace, page })) return
                        if (!store.check_loginAfterAjax(null, answer)) return
                        if (['critical'].includes(answer.notification?.status)) {
                            // ODOO-3241: critical-ответ бэкенда — НЕ auth-fail (auth-fail уже
                            // обработан check_loginAfterAjax строкой выше). Полный logout здесь
                            // выкидывал пользователя из системы из-за разовой ошибки бэкенда.
                            // Показываем ошибку (TERMINAL выше) и остаёмся: если открытого
                            // workspace нет (свежий вход) — на селектор баз (сессия жива),
                            // на старой инфре селектора нет — логин, как раньше.
                            console.warn(`[workspace_open] critical notification (stay logged in): ${answer.notification?.text || ''}`)
                            if (!store.activeWORKSPACE) {
                                store.router.push({ name: IS_NEW_INFRA ? 'selectDatabase' : 'login' })
                            }
                            return
                        }

                        if (answer.database_menu) {
                            // до change_route-return: иначе чип баз в топбаре остаётся пустым
                            // («Current: …» без списка), пока не отработает повторный workspace_open (ODOO-3482)
                            store.database_attrs = answer.database_menu
                        }

                        if (answer.process_model_current) {
                            // до change_route-return: redirect ниже решает по нему,
                            // писать ли модель в адрес (ODOO-3749)
                            store.process_model_current = answer.process_model_current
                        }

                        if (answer.change_route) { // workspace !== answer.workspace || process_model !== answer.process_model) { // 2025-11-19
                            let to = store.router.currentRoute
                            // ODOO-3749: текущая модель в URL не пишется
                            const _pm_q = (answer.process_model && answer.process_model !== store.process_model_current)
                                ? { process_model: answer.process_model } : {}
                            store.router.push({ name:'db',
                                params: {
                                    // ...to.params
                                    dbid: store.user.database.dbid,
                                    process_model: answer.process_model,
                                    workspace: answer.workspace,
                                    page: answer.page,
                                    action: answer.action || '',
                                },
                                query: {
                                    // ...to.query,
                                    ..._pm_q,
                                    workspace: answer.workspace,
                                    page: answer.page,
                            }})
                            return
                        }
                        if (answer.process_model_menu) {
                            store.process_model_menu = answer.process_model_menu
                        }

                        // R10b: серверные минимумы виджетов — в реестр геометрии
                        if (answer.widget_geom) {
                            store._widget_geom = { ...store._widget_geom, ...answer.widget_geom }
                        }
                        // R6b: снапшот каркаса — на следующий вход
                        if (store.fastEntry.snapshotWS && answer.WORKSPACE) {
                            store.snapshot_put(store.workspace_snapshot_key(workspace, page), jqXHR.responseText)
                        }
                        // R6b: кадр уже нарисован со снапшота — если каркас тот же,
                        // сохраняем его (виджеты уже открываются), обновив запись стола;
                        // разошёлся — пересобираем стол из настоящего ответа
                        const _staleWS = store.WORKSPACES[workspace]?._staleWS
                        if (_staleWS) {
                            if (_staleWS === store.workspace_snapshot_fingerprint(answer.WORKSPACE)) {
                                const _W = store.WORKSPACES[workspace]
                                _W.record = answer.WORKSPACE.record
                                // IE 2026 08 26 / ODOO-5800: запись стола подменена настоящей — чипсы из
                                // локального снимка (chipsKeep, применены на кадре со снапшота) переносим
                                if (_W._chipsRestoredRows && _W.record?.doc?.params) {
                                    store.chipsKeep_applyRows(_W.record.doc.params, _W._chipsRestoredRows)
                                }
                                store.scheduleHeaderChip_init(workspace, answer.WORKSPACE)   // IE 2026 10 10 / ODOO-345813: чипс окон остановки — из настоящего ответа (снапшот несёт прошлый вход)
                                delete _W._staleWS
                                if (store.fastEntry.timings) console.log(`[fastEntry:R6b] workspace ${workspace}: snapshot confirmed`)
                                return
                            }
                            // каркас реально изменился (добавили/убрали виджет или
                            // страницу): снятый со снапшота кадр не «доводим» —
                            // смонтированные компоненты держат ссылки на прежний
                            // WORKSPACE, и подмена объекта роняла их. Перезагрузка
                            // страницы даёт честный кадр; случай редкий (правка стола)
                            console.warn(`[fastEntry:R6b] workspace ${workspace}: каркас изменился — перезагрузка`)
                            store.snapshot_put(store.workspace_snapshot_key(workspace, page), jqXHR.responseText)
                            window.location.reload()
                            return
                        }

                        // WORKSPACE++
                        let WORKSPACE = store.WORKSPACES[workspace] = {
                            // attrs: []
                            notification: {
                                header: '',
                                text: '',
                                status: false,
                                visible: false,
                                fading: false,
                                closing: false,
                                timerId: null,
                                statuses: { // timeout
                                    info: 10001,
                                    warning: 10002,
                                    error: 10003,
                                    critical: 10004,
                                    success: 10005,
                                }
                            },
                            selectionWorkspace: {},
                            ...answer.WORKSPACE,
                        }

                        store.update_CHIPS_from_WHERE(WORKSPACE.record.doc.params)
                        store.scheduleHeaderChip_init(workspace)   // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): header_chips / schedule_stamp пришли в WORKSPACE — момент и язык ответа, таймер

                        // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): запрошена страница настроек (адрес …&page=page-settings, workspace_goto), а в списке страниц стола её нет —
                        // клон шаблона WORKSPACE.settings_page последней страницей; иначе — страница, выбранная бэком (как было)
                        page = store.settingsPage_on() ? settingsPage_pick(WORKSPACE, page, WORKSPACE.active_page) : WORKSPACE.active_page
        
                        // menu++ (ODOO-3749: через state, переживает пересборку меню)
                        store.touch_recentWorkspace(workspace, WORKSPACE.title || WORKSPACE.record.title,   // IE 2026 09 26 / ODOO-… (дефект Игоря: группа Workspaces в списке столов): название в группе — на языке интерфейса (WORKSPACE.title бэк локализует, record.title — на языке базы)
                            WORKSPACE.record.pi, WORKSPACE.record.img)

                        return store.workspace_route(workspace, page)
                    },
                    error: function (error) {
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                })
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'})
            }
        },
        // IE 2026 09 30 / ODOO-343433: клик по строке грида REPORT2 → страница того же стола с чипсом из значения строки (конфиг doc.params.row_click, utils/pageGotoChip.js)
        pageGotoChip(WIDGET, cfg, dataItem, display = undefined) {
            const store = this
            return pageGotoChip_run(store, WIDGET, cfg, dataItem, { t, display, notify: (text, status) => store.show_notification({ text, status }) })
        },
        workspace_route(workspace, page) {
            const store = this,
                WORKSPACE = store.WORKSPACES[workspace]
            if (page === SETTINGS_PAGE_ID) store.settingsPage_ensure(workspace)   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): личный дефолт / active_page = page-settings — клон шаблона в PAGES до маршрута
            const PAGE = WORKSPACE.PAGES[page]

            let to = store.workspace_route_to(workspace, page)
            const pathName = `${workspace}/${page}`

            // // router++
            // if (!store.router.hasRoute(pathName)) {
            //     store.router.addRoute('app', {
            //         path: path_to,
            //         name: pathName,
            //         component: () => import('../pages/Page.vue'), // `../pages/${PAGE.component}.vue`
            //         props: {
            //             workspace: workspace,
            //             page: page,
            //             dbid: store.user.database.dbid
            //         },
            //     })
            // }

            // go
            store.router.push(to)
        },
        workspace_route_to(workspace, page='') {
            const store = this
            
            // check PAGES.length
            if (page) {
                let WORKSPACE = store.WORKSPACES[workspace]
                if (Object.keys(WORKSPACE.PAGES).length < 2){
                    page = ''
                }
            }

            // ODOO-3749: текущая (дефолтная) модель в URL не пишется — ссылки без модели
            // всегда открывают актуальную. Явная модель в ссылке остаётся только когда
            // работаем в исторической: навигация внутри неё не должна сменить модель.
            const pm = store.process_model_record.id
            const pm_part = (pm && pm !== store.process_model_current) ? `process_model=${pm}&` : ''
            if (!page) {
                return `/${store.user.database.dbid}?${pm_part}workspace=${workspace}`
                //     `/${workspace}`,
            } else {
                return`/${store.user.database.dbid}?${pm_part}workspace=${workspace}&page=${page}`
                    // `/${workspace}/${page}`,
            }
        },
        workspace_activate(workspace, page) {
            const store = this
            const WORKSPACE = store.WORKSPACES[workspace]
            const PAGE = WORKSPACE.PAGES[page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === page)
            // IE 2026 09 24 / ODOO-341407: отчёты страницы, помеченные живым переключением языка, пока она была неактивна, и кто из них
            // уже грузился ДО активации (запрос на прежнем языке) — перезапрос ниже, после штатных обработчиков активации
            const i18nPending = i18n_pendingOnActivate(WIDGETS)
            // const leftArea = PAGE.leftArea

            // закрыть widget-row на старом пейдже
            const oldPAGE = WORKSPACE.activePAGE
            if (oldPAGE && oldPAGE !== PAGE) {
                const oldPageWidgets = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === oldPAGE.page)
                const WRow = oldPageWidgets.find(w => w?.widget === 'widget-row')
                if (WRow) {
                    store.close_childrenWidgets(WRow)
                    store.widget_close(WRow.id)
                }
            }

            // set active
            store.activeWORKSPACE = WORKSPACE
            WORKSPACE.active_page = page
            WORKSPACE.activePAGE = PAGE
            store.scheduleHeaderChip_activate(WORKSPACE)   // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): таймер чипса «Regimen paused until …» на этот стол; чипс старше минуты — один перезапрос
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-05 pageSwitchYield — новая страница смонтирована и активна: снять состояние загрузки плитки после отрисовки
            if (store._mobPageLoading) requestAnimationFrame(() => requestAnimationFrame(() => store.mobilePageLoading_clear()))

            // IE 2026 08 21 (заказ Игоря): сосредоточиться на новой области — фоновые
            // загрузки других страниц/столов останавливаются (их страницы перезапросятся
            // при возврате через refresh_needed). Флаг window.pageFocus, дефолт ВКЛ.
            if (store.pageFocus?.enabled !== false) {
                try { store.pageFocus_stopBackground(workspace, page) }
                catch (e) { console.warn('pageFocus:', e) }
            }

            if (WIDGETS.length) {
                const selectors_changed = PAGE.last_refresh_selector_version !== (WORKSPACE.selector_version ?? 0)
                // IE 2026 09 07 / ODOO-4997 (заказ Игоря: M03 · CF с «Refresh by selectors» не обновился при возврате на
                // страницу после смены чипса на другой странице): чипсы стола менялись с последнего обновления этой
                // страницы → участники обмена селекторами (params.selector_get) перечитываются при активации БЕЗ флага
                // страницы «Refresh widgets on page activation» (он с 05.2026 гейтил и их). Флаг страницы остаётся
                // как был; выключатель нового поведения — perf-флаг page_activate_selector_refresh (дефолт ВКЛ).
                const selectorsRefresh = selectors_changed && store.perf_flag('page_activate_selector_refresh', true)
                if (PAGE.refresh_needed || (PAGE.refreshWidgetsOnPageActivate && selectors_changed) || selectorsRefresh) {
                    store.updateRelatedWidgets(workspace, page)
                    PAGE.refresh_needed = false
                }
                // IE 2026 08 24 / ODOO-5884 (заказ Игоря): после смены модели/ветки виджеты ЗАПИСЕЙ этой
                // страницы перечитываются (updateRelatedWidgets обновляет только участников селекторов)
                for (const w of WIDGETS) {
                    if (w._pm_reload_needed && w.vueObj && w.record?.id) {
                        delete w._pm_reload_needed
                        store.executeStoreMethod(w.vueObj, { command: 'executeWidgetMethod', method: 'reload', record_sendToBackend_exclude: ['_doc'] })
                    }
                    // IE 2026 09 15 / ODOO-… (замечание Игоря): потребитель периода, помеченный при смене периода с другой страницы
                    if (w._period_refresh_needed && w.vueObj && !w._softClosed) {
                        delete w._period_refresh_needed
                        store.periodSel_select(w)
                    }
                }
                // IE 2026 09 24 / ODOO-341407: подписи в данных отчётов (строки DL2, литералы раскладки) — на языке, выбранном, пока страница
                // была неактивна: select тем, у кого нет несохранённых правок и кого активация выше не перезапросила (fe.i18n.switchRefreshData)
                if (i18nPending.length) i18n_refreshOnActivate(store, i18nPending)
            } else {
                store.workspace_show_widgets(workspace, page)
            }
            // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 Д8): страница уже построена (смена hash со ссылкой open_record на открытой странице или на странице,
            // открытой раньше) — workspace_show_widgets не зовётся, и ссылка висела в сторе: забираем здесь, если это страница цели ссылки
            if (store.openRecord_fromURL?.id) openRecord_take(store, { workspace, page, delay: OPEN_RECORD_DELAY_BUILT })
            guideLink_take(store, { delay: OPEN_RECORD_DELAY_BUILT })   // IE 2026 09 30 / ODOO-343435: стол уже открыт — тур по ссылке; IE 2026 10 09 / ODOO-343435: без проверки стора — ссылку после входа гостя берёт и запомненная вкладкой

            // activate WIDGET
            if (store.activeWIDGET !== PAGE.activeWIDGET) {
                store.activeWIDGET = PAGE.activeWIDGET
            }

            return WORKSPACE
        },

        // IE 2026 08 21 (заказ Игоря): остановить загрузки всех виджетов, кроме виджетов
        // активной страницы: abort xhr + del_last_backend_action (widget_stopLoading —
        // бэкенд останавливает select на ближайшем checkpoint, воркер освобождается)
        pageFocus_stopBackground(workspace, page) {
            const store = this
            // 1) виджеты активируемой страницы, остановленные ранее — полный повтор
            // исходного widget_open (updateRelatedWidgets их не покрывает: он
            // обновляет только участников обмена селекторами)
            for (const w of (store.WORKSPACES[workspace]?.ALL_WIDGETS || [])) {
                if (w.page !== page || w.close || !w._pageFocusReopen) continue
                delete w._pageFocusReopen
                if (typeof w._widgetOpen_repeat === 'function') {
                    // тихий стоп (widget_stopLoading opts.quiet) снял _firstLoading, а
                    // виджет грузится ЗАНОВО и записи с минимумами у него всё ещё нет.
                    // Без флага раскладка не заходит в ветку геометрии скелета
                    // (MainArea.widgetMin_rem: geomPresets && _firstLoading && !_gotRealOpen)
                    // и берёт 1 rem — виджет появляется временной клеткой и переезжает
                    // на своё место, когда придёт ответ. Это ровно тот прыжок, который
                    // снял R10 (fd862e686); возвращаем флаг вместе с повтором open.
                    w._firstLoading = true
                    try { w._widgetOpen_repeat() } catch (e) { console.warn('pageFocus reopen:', e) }
                }
            }
            // 2) фоновые загрузки других страниц/столов — тихий стоп + метка
            let n = 0
            for (const wsId of Object.keys(store.WORKSPACES || {})) {
                const WS = store.WORKSPACES[wsId]
                for (const w of (WS?.ALL_WIDGETS || [])) {
                    if (w.close) continue
                    if (w.workspace === workspace && w.page === page) continue
                    const busy = (w._openRequest && w._openRequest.readyState !== 4)
                        || (w._activeRequest && w._activeRequest.readyState !== 4)
                        || (w._pollActiveRequest && w._pollActiveRequest.readyState !== 4)
                    if (!busy) continue
                    store.widget_stopLoading(w, { quiet: true })
                    if (typeof w._widgetOpen_repeat === 'function') {
                        w._pageFocusReopen = true
                    } else {
                        // фолбэк: повторить open нечем — перезапрос страницы целиком
                        const P = WS.PAGES?.[w.page]
                        if (P) P.refresh_needed = true
                    }
                    n++
                }
            }
            if (n) {
                store._pageFocusStopped = (store._pageFocusStopped || 0) + n
                console.log(`pageFocus: stopped ${n} background load(s)`)
            }
        },

        workspace_show_widgets(workspace, page) {
            const store = this
            if (store._i18nReloading) return   // IE 2026 09 26 / ODOO-341407: fe.i18n.firstLoadHold — страница перезагружается на язык базы
            const WORKSPACE = store.WORKSPACES[workspace]
            const PAGE = WORKSPACE.PAGES[page]
            try { store.variantMenu_sync(workspace, page) } catch (e) { console.warn('variantMenu:', e) }   // IE 2026 10 01 / ODOO-5800: меню варианта страницы — из основной
            store.periodSel_default(WORKSPACE)
            if (!WORKSPACE._whereSig) store.whereChanged_take(WORKSPACE)   // IE 2026 09 16: снимок чипсов при открытии — первая же смена селектора считается по разнице   // IE 2026 09 15 / ODOO-… (заказ Игоря: чипс периода): пустая строка периода — период по умолчанию
            // фильтры стола из ссылки (…&where=, лист INFO выгрузки): пользовательские
            // чипсы заменяются на зашитые в ссылку, служебные (hidden/calc) остаются
            // и пересчитаются (метка селекторов снимается) — открывшийся отчёт
            // совпадает с тем, из которого делалась выгрузка
            if (store.where_fromURL && WORKSPACE?.record?.doc?.params) {
                try {
                    const rows = JSON.parse(decodeURIComponent(escape(atob(store.where_fromURL))))
                    if (Array.isArray(rows)) {
                        const params = WORKSPACE.record.doc.params
                        const service = (params.WHERE || []).filter(r => r?.hidden)
                        // IE 2026 09 13 / ODOO-335246 (разбор с ie-dm7): строки из старых ссылок без widget — берём его из определения строки стола
                        // по leftValue (иначе бэк такую строку пропускал и отбор по селектору не применялся)
                        for (const row of rows) {
                            if (!row || row.widget) continue
                            const lv = row.leftValue?.value ?? row.leftValue
                            const def = (params.WHERE || []).find(x => x && x.widget && (x.leftValue?.value ?? x.leftValue) === lv)
                            if (def) row.widget = def.widget
                        }
                        params.WHERE = [...rows, ...service]
                        delete params.calc_selectors_mark
                        store.update_CHIPS_from_WHERE?.(params)
                        // флаг в store: обработка &action= может идти в ДРУГОМ вызове
                        // workspace_show_widgets, локальную переменную он не увидит
                        store._whereFromLink = true
                    }
                } catch (e) { console.warn('where= link param ignored:', e) }
                store.where_fromURL = null
                if (window.location.href.includes('where=')) {
                    window.history.replaceState(window.history.state, '', window.location.href.replace(/&where=[^&]*/g, ''))
                }
            }
            // IE 2026 08 26 / ODOO-5800 (заказ Игоря «слетают все чипсы»): чипсы из локального
            // снимка (последнее применение в этом браузере) — один раз на объект стола, если
            // фильтры не пришли ссылкой; дальше как у ссылки: applySelector на открытии
            if (!WORKSPACE._chipsRestored && WORKSPACE?.record?.doc?.params && store.chipsKeep?.enabled !== false) {
                WORKSPACE._chipsRestored = true
                if (!store._whereFromLink) {
                    const rows = store.chipsKeep_read(workspace)
                    if (rows && store.chipsKeep_applyRows(WORKSPACE.record.doc.params, rows)) {
                        WORKSPACE._chipsRestoredRows = rows
                        store._whereFromLink = true
                        if (!store.hide_console) console.log(`chipsKeep: ${rows.length} chip row(s) restored for ${workspace}`)
                    }
                }
            }
            // IE 2026 09 28 / ODOO-342342 (Use cases): «Open in demo» на страницу, которая ещё не открывалась (fe.guide.chipsOnOpen) — чипсы якоря здесь, поверх строк
            // стола (мои уже подняты снимком выше): «мои» — копия для «Restore my filters», прочие мои строки выключаются, период и служебные — как есть; дальше как у
            // фильтров ссылки: applySelector до открытия виджетов — страница грузится один раз (utils/guidePlay.guidePlay_applyPending)
            if (store.guideChips_pending && store.guideChips_pending.workspace === workspace && WORKSPACE?.record?.doc?.params) {
                const _gpend = store.guideChips_pending
                store.guideChips_pending = null
                try { if (guidePlay_applyPending(store, WORKSPACE, _gpend)) store._whereFromLink = true } catch (e) { console.warn('guide: demo filters on open ignored', e) }
            }
            // IE 2026 08 20 / ODOO-336291 (mobile UX): deep link из письма — открыть форму записи
            // (шаг S&OP и т.п.) после того, как страница стола начала строиться
            // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 Д8): тот же код вынесен в utils/openRecordLink — его зовёт и workspace_activate (страница уже построена)
            if (store.openRecord_fromURL?.id) openRecord_take(store, { delay: OPEN_RECORD_DELAY_BUILD })
            store.navigator_autoOpen()   // demo-webscm 2026 11 02 / ODOO-350612: «Відкривати навігатор при старті» — один раз после первой построенной страницы
            guideLink_take(store)   // IE 2026 09 30 / ODOO-343435: тур по ссылке — после старта виджетов страницы; IE 2026 10 09 / ODOO-343435: без проверки стора — ссылку после входа гостя берёт и запомненная вкладкой
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === page)
            let widgets_onOpening = []
            // группы виджетов (ит.4 п.2): собираются при скане, применяются в calculatePage
            const layoutGroups = {}
            let gidCounter = 0

            // единый сканер дерева: строки doc.pages (node.value) и строки
            // «Copy widgets as JSON/link» (widget) — один формат обхода.
            // Виджет — node с relation_segment (AttrLink) или поле widget;
            // группа — строка с attrs + onOpening и node без relation_segment
            // (AttrStr, prepare_pagesTree поднимает title в node — be ит.4 №3)
            let favSet = null   // IE 2026 09 22 / ODOO-… (заказ Игоря): личные избранные виджеты страницы — вместо набора по умолчанию
            function scan_widgets_onOpening(attrs, fromURL = false, parentGid = '') {
                attrs.forEach((row, ind) => {
                    if (row.use === false) return

                    const widget_id = row.widget || (row.node?.relation_segment ? row.node?.value : null)
                    const wantOpen = favSet ? favSet.has(String(widget_id)) : (row.onOpening || fromURL)   // IE 2026 09 22: избранные главнее onOpening
                    if (widget_id && wantOpen && row.multiply?.widget) {
                        // IE 2026 09 15 / ODOO-… (заказ Игоря): строка с настройкой Multiply — виджет тиражируется по строкам виджета-списка (widgets_multiply)
                        widgets_onOpening.push({ action_name: 'action-front-1', command: 'widgets_multiply', widget: widget_id, row, workspace, page, gid: parentGid || undefined })
                    } else if (widget_id && wantOpen) {
                        widgets_onOpening.push({
                            action_name: 'action-front-1',
                            command: 'widget_open',
                            widget: widget_id,
                            title: row.node?.valueStr || row.title || undefined,
                            workspace,
                            page,
                            styleWidget: {
                                dock: 'dock',
                                group: parentGid || undefined,
                                ...row.styleWidget,
                                ...store.layout_to_styleWidget(row.layout),
                            },
                            layoutTab: row.layout?.tab || undefined,   // IE 2026 09 11 / ODOO-… (заказ Игоря): сохранённая активная вкладка
                        })
                    }

                    // строка-группа: onOpening на строке без своего виджета
                    // (регистрируется и без детей — сохранённая заготовка)
                    let gid = parentGid
                    if (!widget_id && (row.onOpening || fromURL)) {
                        gid = `g${gidCounter++}`
                        layoutGroups[gid] = {
                            gid,
                            parent: parentGid,
                            ind,
                            // AttrTab — «сверху-вниз, слева-направо», иначе row-поток;
                            // тип — на строке или на node (колонка Type грида)
                            dir: (row.attr_type || row.node?.attr_type) === 'AttrTab' ? 'col' : 'row',
                            title: row.title || row.node?.valueStr || row.node?.value || '',
                            layout: row.layout || {},
                        }
                    }
                    if (row.attrs) {
                        scan_widgets_onOpening(row.attrs, fromURL, gid)
                    }
                })
            }

            if (store.action_id_onOpening) {
                const _action_id = store.action_id_onOpening
                store.action_id_onOpening = null
                const _openAction = () => store.executeBackendMethod({}, {
                    method: 'get_action',
                    params: {
                        action_id: _action_id,
                    }
                }, (answer) => {
                    // виджет, открытый по ссылке (…&action=): в ДОК на всю страницу,
                    // а не свободным окном — стиль правим до исполнения actions_after
                    for (const act of answer?.actions_after || []) {
                        if (act.command === 'widget_open') {
                            act.styleWidget = { dock: 'dock', ...(act.styleWidget || {}) }
                        }
                    }
                    // фильтры пришли из ссылки: widget_open отдаёт снапшот/кэш отчёта,
                    // построенный ДО отбора — после открытия перечитываем данные виджета
                    // по свежим селекторам (select через updateRelatedWidgets)
                    if (store._whereFromLink) {
                        store._whereFromLink = false
                        let _tries = 0
                        const _t = setInterval(() => {
                            const _ws_widgets = (store.WORKSPACES[workspace]?.ALL_WIDGETS || [])
                            const W = _ws_widgets.find(w => w.record?._meta?.action_id === _action_id)
                                // открытый по ссылке виджет — единственный на странице
                                || (_ws_widgets.length === 1 ? _ws_widgets[0] : null)
                            if (W?.vueObj && !W.loading) {
                                clearInterval(_t)
                                store.updateRelatedWidgets(workspace, page)
                            // отчёт с прогрессом может строиться минуты (loading всё время):
                            // ждём до ~4 мин, дальше сдаёмся молча
                            } else if (++_tries > 480) clearInterval(_t)
                        }, 500)
                    }
                })
                // виджет по ссылке открывается МИМО widgets_onOpening — фильтры из
                // &where= (и свежие calc_selectors, #74) надо применить ДО его select,
                // иначе чипсы на месте, а данные без отбора
                const _eventsA = store.get_events(WORKSPACE.record)
                if (store._whereFromLink || _eventsA?.workspace?.workspace_applySelector) {
                    // не промис (он резолвится на отправке!), а хук ответа: get_action
                    // должен уйти ПОСЛЕ пересчёта селекторов бэком, иначе отчёт строится
                    // по старому отбору (гонка ~1мс, реальный случай dev02)
                    let _opened = false
                    const _openOnce = () => { if (!_opened) { _opened = true; _openAction() } }
                    store.workspace_applySelector(workspace, page, null, { _onResponse: _openOnce })
                    // страховка: ответ не пришёл/потерялся — виджет всё равно открываем
                    setTimeout(_openOnce, 8000)
                } else {
                    _openAction()
                }
            } else if (store.widgets_fromURL) {
                // набор из ссылки «Copy widgets as link» (ит.3 п.4.3) —
                // вместо открываемых по умолчанию, дефолты не применяются
                scan_widgets_onOpening(store.widgets_fromURL, true)
                store.widgets_fromURL = null
                // убрать параметр из адресной строки (без перезапуска роутера)
                if (window.location.href.includes('widgets=')) {
                    window.history.replaceState(window.history.state, '', window.location.href.replace(/&widgets=[^&]*/g, ''))
                }
            } else {

                if (WIDGETS.length === 0) {
                    // IE 2026 09 22 / ODOO-… (заказ Игоря): у пользователя есть избранные виджеты этой страницы — открываются они
                    // (пометок нет — набор по умолчанию, как раньше); выключатель fe.ux.favoritesOpen
                    // IE 2026 09 22 (уточнение Игоря): звезда — только избранное; набор открытия — личный opens (пометка «открывается со страницей»)
                    const opens = store.favorites_opens(workspace, page)
                    favSet = opens && store.setting('fe.ux.favoritesOpen', true) !== false ? new Set(opens) : null
                    scan_widgets_onOpening(PAGE.attrs || [])
                    favSet = null
                }
            }
            PAGE._layoutGroups = layoutGroups
            const _openAll = () => {
                widgets_onOpening.forEach(action => {
                    store.executeStoreMethod({}, action)
                })
            }
            // КРИТИЧНО (#74): свежие отборы по документам калькуляции ДО первого
            // select виджетов — после входа/перезагрузки страницы и после смены
            // процессной модели сохранённые calc_selectors воркспейса могли
            // остаться от другой модели/сессии (отчёты открывались пустыми,
            // пока пользователь не трогал чипсы)
            const _events = store.get_events(WORKSPACE.record)
            // фильтры пришли из ссылки (&where=) — применяем селекторы и перечитываем
            // данные виджетов ВСЕГДА, а не только при наличии row-event на бэке:
            // иначе чипсы менялись, а гриды открывались со старой выборкой
            if (widgets_onOpening.length && (store._whereFromLink || _events?.workspace?.workspace_applySelector)) {
                // IE 2026 09 04 / ODOO-4997 (Igor: «после reload отчёт без глобального чипса»):
                // чипсы восстановлены из снимка/ссылки — виджеты открываем ПОСЛЕ ОТВЕТА
                // applySelector, а не после его отправки. Промис резолвится на отправке, и
                // первая волна widget_open уходила с восстановленными чипсами, но БЕЗ метки
                // calc_selectors_mark и со старыми calc*-строками записи стола; бэк считал
                // их устаревшими и брал calc*-множества из shared-кэша волны (redis, 60 с,
                // ключ стол+модель, БЕЗ учёта чипсов) — туда только что положил результат
                // «без чипсов» workspace_open этой же перезагрузки. Отчёт по `id in selector
                // (calc)` открывался по всем объектам; updateRelatedWidgets из actions_after
                // приходил раньше, чем у виджета появлялась запись, и не перечитывал его.
                // После ответа applySelector в сторе свежая метка + calc*-строки под чипсы —
                // widget_open идут с ними, бэк ничего не пересчитывает. Страховка: ответ
                // потерялся — виджеты всё равно откроются через 8 с (как у &action=).
                // Без снимка/ссылки (_whereFromLink=false) — прежний порядок.
                if (store._whereFromLink) {
                    let _opened = false
                    const _openOnce = () => { if (!_opened) { _opened = true; _openAll() } }
                    Promise.resolve(store.workspace_applySelector(workspace, page, null, { _onResponse: _openOnce }))
                        .catch(() => { _openOnce() })
                    setTimeout(_openOnce, 8000)
                } else {
                    Promise.resolve(store.workspace_applySelector(workspace, page))
                        .catch(() => {})
                        .then(_openAll)
                }
            } else {
                _openAll()
            }
        },

        // IE 2026 09 11 / ODOO-… (заказ Игоря): активная вкладка открытого виджета для сохранения раскладки — вкладка ГЛАВНОЙ панели
        // (AttrTabPanel, attr из WIDGET.view); идентификатор — name, иначе title, иначе tooltip (у вкладок-иконок только он;
        // индекс хрупок при смене состава вкладок); вложенные панели (под-вкладки настроек, печати) не сохраняются;
        // панель с одной вкладкой — тоже
        widget_activeTab(WIDGET) {
            const viewIds = new Set((WIDGET?.view || []).map(a => a?.id).filter(id => id != null))
            const reg = WIDGET?.attrs_vueObj || {}
            for (const key in reg) {
                const v = reg[key]
                if (!v || v._unmounted || !v.tabPanel || typeof v.tabKeep_key !== 'function') continue
                if (v.attr?.id == null || !viewIds.has(v.attr.id)) continue
                const tabs = (('tabAttrs' in v) ? v.tabAttrs : null) || []   // IE 2026 09 12 / ODOO-335246 (Igor): у Widget нет tabAttrs — без Vue warn при рендере
                if (tabs.length < 2) continue
                const t = tabs[v.tabPanel.selectedIndex]
                const ident = t ? (t.name || t.title || t.tooltip || '') : ''
                if (ident) return ident
            }
            return ''
        },

        // IE 2026 10 30 / ODOO-349799 (заказ Игоря: кнопка Graph вкладки Addons настроек): переключить вкладку по ответу бэка (updateDoc.selectTab) —
        // name → title → tooltip, у любой живой панели виджета (главной и вложенной; для вложенной сначала родительская вкладка); после клика пользователя тоже
        widget_selectTab(WIDGET, ident) {   // IE 2026 10 30 / ODOO-349799
            const live = []   // IE 2026 10 30 / ODOO-349799: живые смонтированные панели: реестр держит последний экземпляр attr, остальные — _attrsLive
            for (const v of [...Object.values(WIDGET?.attrs_vueObj || {}), ...Object.values(WIDGET?._attrsLive || {}).flatMap(x => [...x])]) {   // IE 2026 10 30 / ODOO-349799
                if (v && !v._unmounted && v.tabPanel && typeof v.selectTab_set === 'function' && v.tabPanel.hostElement?.isConnected && !live.includes(v)) live.push(v)   // IE 2026 10 30 / ODOO-349799
            }   // IE 2026 10 30 / ODOO-349799
            const hostOf = (v) => v.tabPanel.hostElement   // IE 2026 10 30 / ODOO-349799
            const panels = live.map((v, id) => {   // IE 2026 10 30 / ODOO-349799
                const tabs = (v.tabAttrs || []).map(t => ({ name: t?.name, title: t?.title, tooltip: t?.tooltip, visible: !!t && v.isTabVisible(t) }))   // IE 2026 10 30 / ODOO-349799
                // родитель — самая вложенная из панелей, чей хост содержит этот; parentTab — вкладка, чья область (pane) содержит хост
                const outer = live.map((q, qi) => ({ q, qi })).filter(({ q }) => q !== v && hostOf(q) !== hostOf(v) && hostOf(q).contains(hostOf(v)))   // IE 2026 10 30 / ODOO-349799
                const depth = (x) => outer.filter(y => y !== x && hostOf(y.q).contains(hostOf(x.q))).length   // IE 2026 10 30 / ODOO-349799
                const par = outer.sort((a, b) => depth(b) - depth(a))[0]   // IE 2026 10 30 / ODOO-349799
                const parentTab = par ? Array.from(par.q.tabPanel.tabs || []).findIndex(t => t?.pane?.contains(hostOf(v))) : -1   // IE 2026 10 30 / ODOO-349799
                return { id, tabs, parentId: par && parentTab >= 0 ? par.qi : null, parentTab }   // IE 2026 10 30 / ODOO-349799
            })   // IE 2026 10 30 / ODOO-349799
            const steps = selectTab_plan(panels, ident)   // IE 2026 10 30 / ODOO-349799
            for (const st of steps) live[st.id].selectTab_set(st.index)   // IE 2026 10 30 / ODOO-349799: только вкладка панели; record и _meta.modified не трогаем
            return steps.length > 0   // IE 2026 10 30 / ODOO-349799
        },   // IE 2026 10 30 / ODOO-349799

        // IE 2026 09 24 / ODOO-341407: якоря раздела документации для кнопки «?» — активные вкладки ВИДИМЫХ панелей виджета, от вложенной
        // к главной (ключ AttrTabPanel.tabAnchorKey: name вкладки или английская база подписи). Событие selectedIndexChanged не годится:
        // вложенные панели скрытых вкладок монтируются фоном (lazyTabs) и перетирали WIDGET.activeTabAnchor — у отчёта на вкладке Grid
        // уходил якорь «sources» вложенной панели вкладки Source. Видимость — по хост-элементу wijmo (у скрытой вкладки getClientRects пуст)
        widget_tabAnchors(WIDGET) {
            const reg = WIDGET?.attrs_vueObj || {}
            const found = []
            for (const key in reg) {
                const v = reg[key]
                if (!v || v._unmounted || !v.tabPanel || typeof v.tabAnchorKey !== 'function') continue
                const host = v.tabPanel.hostElement
                if (!host || !host.isConnected || !host.getClientRects().length) continue
                const tabs = (('tabAttrs' in v) ? v.tabAttrs : null) || []
                const k = tabs[v.tabPanel.selectedIndex] ? v.tabAnchorKey(tabs[v.tabPanel.selectedIndex]) : ''
                if (k) found.push({ host, k })
            }
            // глубина — сколько найденных панелей содержат эту: вложенная раньше главной
            const depth = (x) => found.reduce((n, y) => n + (y !== x && y.host.contains(x.host) ? 1 : 0), 0)
            const keys = found.map(x => ({ k: x.k, d: depth(x) })).sort((p, q) => q.d - p.d).map(x => x.k)
            if (!keys.length && WIDGET?.activeTabAnchor) keys.push(WIDGET.activeTabAnchor)   // панели не нашлись — прежний ключ события
            return [...new Set(keys)]
        },

        // layout строки doc.pages (проценты рабочей области, п.1.3) -> styleWidget,
        // чтобы onOpening-виджет открылся сразу с нужными размерами, без «прыжков».
        // Значения 0-100 с любой точностью (ит.3 п.2), без квантования в rem-сетку
        layout_to_styleWidget(layout) {
            if (!layout || typeof layout !== 'object') return {}

            const pct = (value) => {
                const n = Number(value)
                return Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : null
            }

            if (layout.free) {
                const styleWidget = { dock: 'popout' }
                if (layout.width || layout.height) {
                    styleWidget.setWidgetRect = 'pct'
                    styleWidget.width_pct = (pct(layout.width) || 40) / 100
                    styleWidget.height_pct = (pct(layout.height) || 30) / 100
                    styleWidget.left_pct = (pct(layout.left) ?? 0) / 100
                    styleWidget.top_pct = (pct(layout.top) ?? 0) / 100
                }
                return styleWidget
            }

            // docked: точные проценты рабочей области, применяются в calculatePage_rem0
            const layout_pct = {}
            const width = pct(layout.width)
            const height = pct(layout.height)
            if (width) layout_pct.width = width
            if (height) layout_pct.height = height
            if (layout.new_row) layout_pct.new_row = true // старт с новой горизонтали (ит.4 п.1)
            return Object.keys(layout_pct).length ? { dock: 'dock', layout_pct } : {}
        },

        // точная настройка размеров/позиции виджета в % рабочей области (ит.3 п.3.3-3.4):
        // vals = { width?, height?, left?, top?, free? } — не переданные оси не меняются
        set_widgetLayout_pct(WIDGET, vals = {}) {
            const store = this
            const PAGE = store.WORKSPACES[WIDGET.workspace]?.PAGES[WIDGET.page]
            if (!PAGE) return
            const num = (value, min = 0) => {
                if (value === '' || value === null || value === undefined) return null
                const n = Number(value)
                return Number.isFinite(n) ? Math.max(min, Math.min(100, n)) : null
            }

            const free = 'free' in vals ? !!vals.free : WIDGET.styleWidget.dock === 'popout'
            if (free) {
                const size = store.getWIDGET_size(WIDGET)
                if (WIDGET.styleWidget.dock !== 'popout') {
                    WIDGET.styleWidget.dock = 'popout'
                    store.setWIDGET_style(WIDGET, { zIndex: store.popout_baseZ + 100 }, false)
                }
                WIDGET.styleWidget.setWidgetRect = 'pct'
                WIDGET.styleWidget.width_pct = (num(vals.width, 1) ?? size.width_pct * 100) / 100
                WIDGET.styleWidget.height_pct = (num(vals.height, 1) ?? size.height_pct * 100) / 100
                WIDGET.styleWidget.left_pct = (num(vals.left) ?? size.left_pct * 100) / 100
                WIDGET.styleWidget.top_pct = (num(vals.top) ?? size.top_pct * 100) / 100
                store.checkPopout()
            } else {
                if (WIDGET.styleWidget.dock === 'popout') {
                    WIDGET.styleWidget.dock = 'dock'
                    WIDGET.styleWidget.setWidgetRect = ''
                    store.setWIDGET_style(WIDGET, { zIndex: '' }, false)
                }
                const layout_pct = { ...WIDGET.styleWidget.layout_pct }
                const width = num(vals.width, 1)
                const height = num(vals.height, 1)
                if (width !== null) layout_pct.width = width
                if (height !== null) layout_pct.height = height
                if ('new_row' in vals) {
                    if (vals.new_row) layout_pct.new_row = true
                    else delete layout_pct.new_row
                }
                if (Object.keys(layout_pct).length) {
                    WIDGET.styleWidget.layout_pct = layout_pct
                }
            }
            PAGE.mainArea?.vueObj.setStyle()
        },

        // управляющий грид «Page widgets» (ит.4 п.3): открытые виджеты страницы
        // в формате doc.pages; view отдаёт бэкенд по сегменту PAGE-WIDGETS,
        // любые правки в гриде применяются сразу (apply_pageWidgets)
        pageWidgets_open() {
            const store = this
            const WORKSPACE = store.activeWORKSPACE
            if (!WORKSPACE) return
            const workspace = WORKSPACE.workspace
            const page = WORKSPACE.active_page
            const pages = store.get_pageWidgets_layout(workspace, page, { tree: true })

            // уже открыт — обновить дерево актуальным состоянием и активировать
            const existing = (WORKSPACE.ALL_WIDGETS ?? []).find(w => w.page === page && w.widget === 'widget-page-widgets')
            if (existing) {
                if (existing._softClosed) store._widget_restoreSoftClosed(existing)
                existing._pageWidgets_applying = true
                if (existing.record?.doc) existing.record.doc.pages = pages
                nextTick(() => { existing._pageWidgets_applying = false })
                store.widget_activate(existing, 'pageWidgets_open', true, true)
                return
            }

            store.widget_open({
                widget: 'widget-page-widgets',
                title: t('Page widgets'),   // IE 2026 09 23 / ODOO-341407: i18n
                workspace,
                page,
                // синтетический record: без этого флага бэк перечитает его
                // по id из базы и вернёт пустым (be ит.4, уточнение №1)
                doc_take_from_front: true,
                record: {
                    id: `page-widgets::${workspace}::${page}`,
                    title: t('Page widgets'),
                    segment: 'PAGE-WIDGETS',
                    doc: { pages },
                    _meta: {},
                },
                styleWidget: {
                    dock: 'popout',
                    setWidgetRect: 'pct',
                    left_pct: .58, top_pct: .04, width_pct: .4, height_pct: .85,
                },
            }, {}, (WIDGET_mgr) => {
                // теневые строки (use:false) должны быть видны при активном
                // фильтре непустых (be ит.4 п.4): nonEmpty_ignore_use на гриде
                // pages — use не участвует в проверке пустоты строки (ит.2 §4);
                // callback с before_setup — до первой фильтрации в widget_finishSetup
                for (const attr of store.get_fieldAll(WIDGET_mgr.view || [], 'doc.pages', 'binding')) {
                    attr.nonEmpty_ignore_use = true
                }
            }, { before_setup: true })
        },
        // экран -> грид (be ит.4 п.3): пока «Page widgets» открыт, изменения
        // раскладки страницы отражаются в его record.doc.pages (с дебаунсом);
        // программная запись не триггерит action_afterChange — цикла нет
        refresh_pageWidgets(workspace, page) {
            const store = this
            const WORKSPACE = store.WORKSPACES[workspace]
            if (!WORKSPACE) return
            const WIDGET_mgr = (WORKSPACE.ALL_WIDGETS ?? []).find(w =>
                w.page === page && w.widget === 'widget-page-widgets' && !w._softClosed && !w.close)
            if (!WIDGET_mgr?.record?.doc) return

            clearTimeout(store._refresh_pageWidgets_timer)
            store._refresh_pageWidgets_timer = setTimeout(() => {
                if (WIDGET_mgr.close || WIDGET_mgr._pageWidgets_applying) return
                const pages = store.get_pageWidgets_layout(workspace, page, { tree: true })
                if (JSON.stringify(pages) === JSON.stringify(WIDGET_mgr.record.doc.pages)) return
                WIDGET_mgr._pageWidgets_applying = true
                WIDGET_mgr.record.doc.pages = pages
                WIDGET_mgr.vueObj?.content_Changed?.()
                nextTick(() => { WIDGET_mgr._pageWidgets_applying = false })
            }, 300)
        },
        // применить дерево грида «Page widgets» к открытым виджетам: группы,
        // порядок, use (теневое скрытие), layout (free/размеры/new_row),
        // новые строки -> widget_open, удалённые -> мягкое закрытие
        apply_pageWidgets(WIDGET_mgr) {
            const store = this
            if (!WIDGET_mgr || WIDGET_mgr.widget !== 'widget-page-widgets') return
            const workspace = WIDGET_mgr.workspace
            const page = WIDGET_mgr.page
            const WORKSPACE = store.WORKSPACES[workspace]
            const PAGE = WORKSPACE?.PAGES[page]
            if (!PAGE) return
            if (WIDGET_mgr._pageWidgets_applying) return
            WIDGET_mgr._pageWidgets_applying = true
            nextTick(() => { WIDGET_mgr._pageWidgets_applying = false })

            // 1) группы и порядок из дерева грида
            const layoutGroups = {}
            let gidCounter = 0
            const orderedRows = [] // { row, gid }
            const walk = (attrs, parentGid) => {
                (attrs || []).forEach((row, ind) => {
                    // виджет — relation_segment/widget/_wid; любая другая строка —
                    // группа (в т.ч. ещё без детей — не терять заготовку при refresh);
                    // направление: attr_type строки или node (колонка Type грида)
                    const widget_id = row.widget || (row.node?.relation_segment ? row.node?.value : null)
                    if (widget_id || row._wid) {
                        orderedRows.push({ row, gid: parentGid })
                        return
                    }
                    const gid = `g${gidCounter++}`
                    layoutGroups[gid] = {
                        gid,
                        parent: parentGid,
                        ind, // позиция строки в родителе — для порядка пустых групп при выгрузке
                        // node.* приоритетен: юзер правит колонки Node (Title/Type),
                        // row.title/attr_type — эхо прошлой выгрузки / формат Copy JSON
                        dir: (row.node?.attr_type || row.attr_type) === 'AttrTab' ? 'col' : 'row',
                        title: row.node?.valueStr || row.node?.value || row.title || '',
                        layout: row.layout || {},
                    }
                    if (row.attrs) {
                        walk(row.attrs, gid)
                    }
                })
            }
            walk(WIDGET_mgr.record?.doc?.pages || [], '')
            PAGE._layoutGroups = layoutGroups

            // 2) применить к открытым виджетам
            const pageWidgets = (WORKSPACE.ALL_WIDGETS ?? []).filter(w =>
                w.page === page && w.id !== WIDGET_mgr.id
                && !['widget-row', 'widget-raw-record', 'widget-page-widgets'].includes(w.widget))
            const used = new Set()
            const desiredOrder = []
            for (const { row, gid } of orderedRows) {
                const widget_id = row.node?.value || row.widget
                // IE 2026 09 15 / ODOO-… (заказ Игоря): строка с Multiply — экземпляры тиража считаются занятыми, недостающий тираж запускается
                if (row.multiply?.widget && widget_id) {
                    const mkey = store.multiply_key(page, widget_id, row.multiply)
                    const inst = pageWidgets.filter(w => w._multiply?.key === mkey)
                    for (const w of inst) { used.add(w.id); desiredOrder.push(w.id); w.styleWidget.group = gid || undefined }
                    if (!inst.length && row.use !== false) store.widgets_multiply({ widget: widget_id, row, workspace, page, gid: gid || undefined })
                    continue
                }
                let WIDGET = row._wid ? pageWidgets.find(w => w.id === row._wid) : null
                if (!WIDGET && widget_id) {
                    WIDGET = pageWidgets.find(w => !used.has(w.id) && (w.record?.id === widget_id || w.widget === widget_id))
                }
                if (!WIDGET) {
                    if (widget_id && row.use !== false) {
                        // новая строка -> открыть виджет с её layout
                        store.widget_open({
                            widget: widget_id,
                            title: row.node?.valueStr || row.title || undefined,
                            workspace,
                            page,
                            styleWidget: {
                                dock: 'dock',
                                group: gid || undefined,
                                ...store.layout_to_styleWidget(row.layout),
                            },
                            layoutTab: row.layout?.tab || undefined,   // IE 2026 09 11 / ODOO-…
                        })
                    }
                    continue
                }
                used.add(WIDGET.id)
                desiredOrder.push(WIDGET.id)
                WIDGET.styleWidget.group = gid || undefined

                if (row.use === false) {
                    if (!WIDGET._softClosed) store.widget_close(WIDGET.id)
                } else if (WIDGET._softClosed) {
                    store._widget_restoreSoftClosed(WIDGET)
                }

                const layout = row.layout || {}
                store.set_widgetLayout_pct(WIDGET, {
                    free: !!layout.free,
                    width: layout.width,
                    height: layout.height,
                    left: layout.left,
                    top: layout.top,
                    new_row: !layout.free && !!layout.new_row,
                })
            }

            // 3) виджеты, удалённые из дерева, — мягко закрыть
            for (const WIDGET of pageWidgets) {
                if (!used.has(WIDGET.id) && !WIDGET._softClosed) {
                    store.widget_close(WIDGET.id)
                }
            }

            // 4) порядок ALL_WIDGETS = порядок дерева
            const orderInd = (w) => {
                const i = desiredOrder.indexOf(w.id)
                return i === -1 ? desiredOrder.length + w.id : i
            }
            const positions = []
            WORKSPACE.ALL_WIDGETS.forEach((w, i) => {
                if (w.page === page && w.id !== WIDGET_mgr.id) positions.push(i)
            })
            const sorted = positions.map(i => WORKSPACE.ALL_WIDGETS[i]).sort((a, b) => orderInd(a) - orderInd(b))
            positions.forEach((pos, k) => { WORKSPACE.ALL_WIDGETS[pos] = sorted[k] })

            // правки применены к экрану — record не персистится, кнопку Save не зажигать
            if (WIDGET_mgr.record?._meta?.modified) {
                WIDGET_mgr.record._meta.modified = false
            }

            PAGE.mainArea?.vueObj.setStyle()
        },

        // Copy widgets (п.3.1): полное описание отображённых виджетов страницы —
        // id, порядок, группы (ит.4), состояние (docked/free), размеры и позиция
        // в % рабочей области. title/segment — для вставки строк в грид doc.pages.
        // opts.tree — строки формата doc.pages (node/use/_wid, включая теневые)
        // для управляющего грида «Page widgets»
        get_pageWidgets_layout(workspace, page, opts = {}) {
            const store = this
            const WORKSPACE = store.WORKSPACES[workspace]
            const PAGE = WORKSPACE.PAGES[page]
            const stylePage = PAGE?.stylePage || store.def_stylePage
            const pct = (value) => Math.round(value * 10000) / 100
            const widgets = []

            // строки-группы восстанавливаются из PAGE._layoutGroups в позиции
            // первого своего виджета; пустые группы в выгрузку не попадают
            const groups = PAGE?._layoutGroups || {}
            const groupRows = {}
            const rowsOf = (gid) => {
                if (!gid || !groups[gid]) return widgets
                let groupRow = groupRows[gid]
                if (!groupRow) {
                    const g = groups[gid]
                    const attr_type = g.dir === 'col' ? 'AttrTab' : 'AttrTabRow'
                    groupRow = groupRows[gid] = {
                        title: g.title || '',
                        attr_type,
                        onOpening: true,
                        attrs: [],
                    }
                    if (g.ind !== undefined) {
                        groupRow._ord = g.ind // желаемая позиция среди строк родителя
                    }
                    if (opts.tree) {
                        // node-форма группы (без relation_segment); attr_type node —
                        // по направлению, чтобы колонка Type грида показывала
                        // и сохраняла выбор AttrTab/AttrTabRow (не сбрасывать в Text)
                        groupRow.node = { value: g.title || '', valueStr: g.title || '', attr_type }
                        groupRow.use = true
                    }
                    if (g.layout && Object.keys(g.layout).length) {
                        groupRow.layout = { ...g.layout }
                    }
                    rowsOf(g.parent).push(groupRow)
                }
                return groupRow.attrs
            }

            const _mkeys = new Set()   // IE 2026 09 15 / ODOO-… (заказ Игоря): экземпляры тиража — одной строкой исходного виджета с настройкой Multiply
            for (const WIDGET of (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === page)) {
                if (WIDGET._softClosed && !opts.tree) continue
                if (['widget-row', 'widget-raw-record', 'widget-page-widgets'].includes(WIDGET.widget)) continue
                if (WIDGET._multiply?.key) { if (_mkeys.has(WIDGET._multiply.key)) continue; _mkeys.add(WIDGET._multiply.key) }

                const widget_id = WIDGET.record?.id || WIDGET.widget
                let row
                if (opts.tree) {
                    row = {
                        node: {
                            value: widget_id,
                            valueStr: WIDGET.record?.title || WIDGET.title || widget_id,
                            attr_type: 'AttrLink',
                            relation_segment: WIDGET.record?.segment || '',
                        },
                        use: !WIDGET._softClosed,
                        onOpening: true,
                        _wid: WIDGET.id, // соответствие строка -> открытый инстанс
                    }
                } else {
                    row = { widget: widget_id }
                    if (WIDGET.record?.title) row.title = WIDGET.record.title
                    if (WIDGET.record?.segment) row.segment = WIDGET.record.segment
                }
                if (WIDGET._multiply?.key) {   // IE 2026 09 15 / ODOO-… (заказ Игоря): тираж
                    if (opts.tree) row.node.valueStr = WIDGET._multiply.baseTitle || row.node.valueStr
                    else if (WIDGET._multiply.baseTitle) row.title = WIDGET._multiply.baseTitle
                    row.multiply = { ...(WIDGET._multiply.settings || {}) }
                }

                if (WIDGET.styleWidget?.dock === 'popout') {
                    const size = store.getWIDGET_size(WIDGET)
                    row.layout = {
                        free: true,
                        width: pct(size.width_pct),
                        height: pct(size.height_pct),
                        left: pct(size.left_pct),
                        top: pct(size.top_pct),
                    }
                } else {
                    const layout = {}
                    // точные проценты текущего layout (ит.3) приоритетнее rem-пресета
                    const layout_pct = WIDGET.styleWidget?.layout_pct || {}
                    const width_rem = WIDGET.record?.doc?.widthMin_rem || WIDGET.styleWidget?.width_rem
                    const height_rem = WIDGET.record?.doc?.heightMin_rem || WIDGET.styleWidget?.height_rem
                    if (layout_pct.width) {
                        layout.width = Math.round(layout_pct.width * 100) / 100
                    } else if (width_rem) {
                        layout.width = pct(Math.min(width_rem, stylePage.width_rem) / stylePage.width_rem)
                    }
                    if (layout_pct.height) {
                        layout.height = Math.round(layout_pct.height * 100) / 100
                    } else if (height_rem) {
                        layout.height = pct(Math.min(height_rem, stylePage.height_rem) / stylePage.height_rem)
                    }
                    if (layout_pct.new_row) {
                        layout.new_row = true
                    }
                    if (Object.keys(layout).length) {
                        row.layout = layout
                    }
                }
                // IE 2026 09 11 / ODOO-… (заказ Игоря): вместе с положением и размерами — активная вкладка виджета (главная панель вкладок,
                // name/title вкладки) → layout.tab; при открытии стола виджет встаёт на неё
                // (scan_widgets_onOpening → widget_open layoutTab → AttrTabPanel)
                const _tab = store.widget_activeTab(WIDGET)
                if (_tab) row.layout = { ...(row.layout || {}), tab: _tab }

                rowsOf(WIDGET.styleWidget?.group).push(row)
            }
            // группы без виджетов (заготовки из грида) — тоже в выгрузку,
            // иначе refresh потеряет только что созданную строку-группу
            for (const gid in groups) {
                rowsOf(gid)
            }
            // вернуть группы на их позиции среди строк родителя (_ord из walk/скана):
            // порядок виджетов синхронизирован с деревом (apply_pageWidgets),
            // поэтому индекс строки — валидный якорь
            const reorder_groups = (rows) => {
                const withOrd = rows.filter(r => r._ord !== undefined).sort((a, b) => a._ord - b._ord)
                for (const groupRow of withOrd) {
                    const from = rows.indexOf(groupRow)
                    rows.splice(from, 1)
                    rows.splice(Math.min(groupRow._ord, rows.length), 0, groupRow)
                }
                for (const r of rows) {
                    delete r._ord
                    if (r.attrs) reorder_groups(r.attrs)
                }
            }
            reorder_groups(widgets)
            return widgets
        },

        // IE 2026 09 15 / ODOO-… (заказ Игоря): ТИРАЖ ВИДЖЕТА по строкам виджета-списка. Строка doc.pages с настройкой
        // multiply {widget: <виджет-список>, fields: 'subject,country', limit?: N}: строки списка берутся ПОВТОРОМ запроса widget_open
        // источника (widget_fetch: отборы стола workspace_params и селекторы — как будто пользователь открыл его сам), для каждой
        // строки открывается экземпляр виджета с фильтром (doc.params.WHERE через fieldsMapping: поле in [значение строки] — чипсы
        // экземпляра) и заголовком из значений полей (title + флаг страны doc.flag — метод бэка catalog_titles, иначе словарь
        // itemsSource сегмента поля); экземпляры различаются multiply_key (findWidget_byProps). Помещается не всё — показывается
        // страница экземпляров (limit или floor(100/W%)·floor(100/H%) по layout строки), листание — чипс CHIP-WidgetsPage в глобальном
        // контейнере чипсов (AttrChips mode Page → multiply_nav). Состояние — PAGE._multiply[key]; смена отборов стола
        // (updateRelatedWidgets) перечитывает строки источника и согласует экземпляры (multiply_refresh). Грид «Page widgets» и
        // выгрузка раскладки показывают тираж одной строкой исходного виджета (get_pageWidgets_layout / apply_pageWidgets).
        // Выкл: window.feSettings.set('fe.ux.widgetsMultiply', false)
        multiply_key(page, widget_id, m) { return `${page}::${widget_id}::${m?.widget || ''}::${m?.fields || ''}` },
        multiply_perPage(st) {
            const lim = +(st?.settings?.limit) || 0
            if (lim > 0) return lim
            const w = +(st?.layout?.width) || 100, h = +(st?.layout?.height) || 100
            return Math.max(1, Math.floor(100 / w + 1e-6) * Math.floor(100 / h + 1e-6))
        },
        async widgets_multiply(action) {
            const store = this
            if (store.setting?.('fe.ux.widgetsMultiply', true) === false) return
            const { workspace, page, widget: widget_id, row } = action || {}
            const WORKSPACE = store.WORKSPACES[workspace]; const PAGE = WORKSPACE?.PAGES?.[page]
            const m = row?.multiply
            if (!PAGE || !m?.widget || !widget_id) return
            PAGE._multiply = PAGE._multiply || {}
            const key = store.multiply_key(page, widget_id, m)
            const prev = PAGE._multiply[key]
            PAGE._multiply[key] = {
                key, workspace, pageId: page, widget: widget_id, baseTitle: row.node?.valueStr || row.title || widget_id,
                settings: { ...m }, layout: row.layout || {}, layoutTab: row.layout?.tab || undefined,
                styleWidget: row.styleWidget || {}, gid: action.gid || undefined,
                pageNo: prev?.pageNo || 0, items: prev?.items || [], loading: true, epoch: (prev?.epoch || 0) + 1,
                calls: (prev?.calls || 0) + 1, done: prev?.done || 0,   // диагностика: сколько раз запускался тираж / завершился
            }
            const st = PAGE._multiply[key]   // реактивный прокси (тождество raw-объекта с прокси Vue ложно — актуальность по epoch)
            const epoch = st.epoch
            if (!store.hide_console) console.log(`[multiply] ${key} start #${st.calls} (epoch ${epoch})`)
            const [items, dims] = await Promise.all([store.multiply_fetchItems(st), store.multiply_dimensions(st)])
            if (PAGE._multiply[key]?.epoch !== epoch) { if (!store.hide_console) console.log(`[multiply] ${key} superseded (epoch ${epoch})`); return }   // тираж перезапущен
            st.items = items; st.dims = dims; st.loading = false; st.done = (st.done || 0) + 1
            if (!store.hide_console) console.log(`[multiply] ${key} done: ${items.length} rows`)
            store.multiply_apply(st)
        },
        // запись виджета с данными «как будто пользователь открыл его»: повтор запроса widget_open без регистрации виджета на странице
        // (отборы стола — workspace_params, селекторы — как у обычного открытия, select — внутри открытия: fast_entry.openSelect)
        widget_fetch(widget, workspace, page, opts = {}) {
            const store = this
            const widget_init = { id: store.nextWidget_id++, record: { _meta: {} }, widget, workspace, page, styleWidget: {}, fieldsMapping: [], title: widget,
                parentAction: { command: 'widget_open', widget, _fetch: true }, _open_view_only: !!opts.viewOnly }
            const ws_params = store.WORKSPACES[workspace]?.record?.doc?.params
            const payload = JSON.stringify({
                frontend_sent_timestamp: Date.now(), command: 'widget_open', action_id_front: store.net_actionId(++store.action_id_front), ...store.net_requestParams(), // IE 2026 09 26 / ODOO-5800
                dl2_engine: { ...store.dl2Engine }, showSQL: store.showSQL, profiling_params: store.profiling_params,
                variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                ...store.dl2_requestParams(), ...store.client_requestParams(),
                fast_entry: { ...(store.fastEntry.inlineIS ? store.fast_entry_requestParams() : {}), openSelect: !opts.viewOnly },
                process_model: store.process_model_record?.id, workspace,
                widget_init: ws_params ? { ...widget_init, workspace_params: ws_params } : widget_init,
                user: store.user, open_view_only: !!opts.viewOnly,
            })
            return new Promise((resolve) => {
                $.ajax({ url: store.url_backend_api, type: 'POST', data: payload, contentType: 'application/json', dataType: 'json',
                    success: (answer) => { try { if (answer?.itemsSources && store.fastEntry.inlineIS) store.apply_inline_itemsSources(answer.itemsSources) } catch (e) { /* словари не обязательны */ } resolve(answer) },
                    error: () => resolve(null) })
            })
        },
        // измерения сегмента виджета (WIDGET-LIST: doc.params.segment / grid_binding / collection) — их значения из записи виджета
        // уходят в fieldsMapping экземпляра: бэк подбирает виджет по измерениям при любом fieldsMapping (check_widget_dimension) и без
        // совпадения подменял запись первым списком без измерений; с равными значениями подбора нет (гард multiply_key на бэке — позже)
        async multiply_dimensions(st) {
            const store = this
            try {
                const a = await store.widget_fetch(st.widget, st.workspace, st.pageId, { viewOnly: true })
                const rec = a?.WIDGET?.record
                if (!rec?.id) return []
                const seg = store.itemsSource?.SEGMENTS?.ids?.[rec.segment] || (store.itemsSource?.SEGMENTS?.data || []).find(x => x?.id === rec.segment)
                const dims = Array.isArray(seg?.doc?.dimensions) ? seg.doc.dimensions : [{ binding: 'doc.params.segment' }, { binding: 'doc.params.grid_binding' }, { binding: 'doc.params.collection' }]
                return dims.filter(d => d?.binding).map(d => ({ attr: { binding: d.binding, value: store.get_value(rec, d.binding) ?? '', valueAsIs: true } }))
            } catch (e) { return [] }
        },
        async multiply_fetchItems(st) {
            const store = this
            const m = st.settings
            const answer = await store.widget_fetch(m.widget, st.workspace, st.pageId)
            const W = answer?.WIDGET || {}
            const rec = W.record || {}
            // поля селектора списка-источника (selection_fields с selector_set / selector_set_fields) — для чекбокса селектора экземпляра
            const _sf = rec.doc?.params?.selection_fields
            st.selectorFields = Array.isArray(_sf) && _sf.length
                ? _sf.filter(f => f && f.use !== false && f.selector_set && f.binding).map(f => f.binding)
                : String(rec.doc?.params?.selector_set_fields || '').split(',').map(x => x.trim()).filter(Boolean)
            let rows = (answer?.actions_after || []).map(a => a?.record?._doc?.data).find(Array.isArray)
            if (!rows) rows = Array.isArray(rec._doc?.data) ? rec._doc.data : []
            // определения полей источника: view (собранное бэком) и viewList записи
            const defs = {}
            const walk = (attrs) => { for (const a of (Array.isArray(attrs) ? attrs : [])) { if (a?.binding && !defs[a.binding]) defs[a.binding] = a; if (a?.attrs) walk(a.attrs) } }
            walk(W.view); walk(rec.doc?.viewList); walk(rec.viewList)
            // поле строки списка и (через двоеточие) поле фильтра виджета: 'subject,country' или 'country_from:country'
            let fields = String(m.fields || '').split(',').map(s => s.trim()).filter(Boolean).map(f => { const [src, dst] = f.split(':').map(x => x.trim()); return { src, dst: dst || src } })
            if (!fields.length) fields = Object.values(defs).filter(a => a.attr_type === 'AttrLink' && a.use !== false && a.binding && !a.binding.includes('.')).map(a => ({ src: a.binding, dst: a.binding })).slice(0, 2)
            const items = [], seen = new Set()
            rows.forEach((r, ind) => {
                const values = fields.map(f => ({ binding: f.dst, source: f.src, value: r?.[f.src], attr: defs[f.src] || {} }))
                if (!values.some(v => v.value !== undefined && v.value !== null && v.value !== '')) return
                const ikey = values.map(v => String(v.value ?? '')).join('|')
                if (seen.has(ikey)) return   // одинаковые строки (напр. несколько строк одного склада) — один экземпляр
                seen.add(ikey)
                items.push({ ind, ikey, values })
            })
            await store.multiply_resolveTitles(items)
            for (const it of items) {
                it.title = it.values.map(v => (v.flag ? v.flag + ' ' : '') + (v.title || String(v.value ?? ''))).join(' · ')
                it.where = it.values.filter(v => v.value !== undefined && v.value !== null && v.value !== '').map(v => store.multiply_whereRow(v))
            }
            return items
        },
        // заголовки значений: catalog_titles бэка (title + флаг по id, любой сегмент), недостающие — словарь itemsSource сегмента поля
        async multiply_resolveTitles(items) {
            const store = this
            // любое строковое значение может быть id записи справочника (UUID, 'stock.warehouse-2', предопределённые id)
            const isId = (v) => typeof v.value === 'string' && v.value.length > 0 && v.value.length <= 200 && !/\s/.test(v.value)
            const ids = [...new Set(items.flatMap(it => it.values).filter(isId).map(v => v.value))]
            let byId = {}
            if (ids.length) {
                byId = await new Promise((resolve) => {
                    let done = false
                    const fin = (x) => { if (!done) { done = true; resolve(x && typeof x === 'object' ? x : {}) } }
                    try { store.executeBackendMethod({}, { method: 'catalog_titles', params: { ids } }, (answer) => fin(answer?.titles)) } catch (e) { fin({}) }
                    setTimeout(() => fin({}), 8000)
                })
            }
            const pending = []
            for (const it of items) for (const v of it.values) {
                const hit = isId(v) ? byId[v.value] : null
                if (hit) { v.title = hit.title || v.title; v.flag = hit.flag || ''; continue }
                const seg = v.attr?.relation_segment
                if (seg && typeof seg === 'string' && isId(v)) pending.push({ v, seg })
            }
            if (!pending.length) return
            const bySeg = {}
            for (const p of pending) (bySeg[p.seg] = bySeg[p.seg] || new Set()).add(p.v.value)
            for (const seg in bySeg) { try { store.get_itemsSource({}, {}, { attr_type: 'AttrLink', relation_segment: seg }, { ids: [...bySeg[seg]] }) } catch (e) { /* словарь недоступен */ } }
            const look = (seg, id) => { const IS = store.itemsSource?.[seg]; return IS?.ids?.[id] || (IS?.data || []).find(x => String(x?.id) === id) || null }
            const t0 = Date.now()
            while (Date.now() - t0 < 6000) {
                let missing = 0
                for (const p of pending) { if (p.v.title) continue; const rec = look(p.seg, p.v.value); if (rec) { p.v.title = rec.title || ''; if (rec.flag) p.v.flag = rec.flag } else missing++ }
                if (!missing) break
                await new Promise(r => setTimeout(r, 120))
            }
        },
        // строка WHERE (чипс экземпляра): ссылочное значение — «поле in [значение]», прочее — «поле = значение»
        multiply_whereRow(v) {
            const attr = v.attr || {}
            const isLink = attr.attr_type === 'AttrLink' || (typeof v.value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(v.value))
            const seg = typeof attr.relation_segment === 'string' ? attr.relation_segment : ''
            const leftValue = { pi: '', value: v.binding, valueStr: attr.title || v.binding, attr_type: 'AttrLink', component: 'AttrLink', valueStr_fix: true, relation_segment: '' }
            if (isLink) {
                return { use: true, attr_type: 'AttrChipWhere', condition: 'in', leftValue,
                    rightValue: { pi: 'pi pi-arrow-right', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: seg },
                    attrs: [{ use: true, leftValue: { pi: '', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', hideTitle: true, relation_segment: '' },
                        rightValue: { value: v.value, valueStr: v.title || String(v.value), attr_type: 'AttrLink', relation_segment: seg } }], _multiply: true }
            }
            return { use: true, attr_type: 'AttrChipWhere', condition: '=', leftValue,
                rightValue: { pi: '', title: '', value: v.value, valueStr: String(v.value), attr_type: attr.attr_type === 'AttrNumber' ? 'AttrNumber' : 'AttrStr', component: 'AttrLink', relation_segment: '' },
                attrs: [], _multiply: true }
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря): селектор поля тиража (subject — чекбоксы в шапках экземпляров) не должен отбирать данные
        // самих экземпляров — только флаги; как у виджета-списка-источника, чей собственный селектор исключается из его отбора. Параметры
        // стола для запросов экземпляра — копия, где производный селектор calc заменён на calc::<поле>::false (расчёт бэка «без этой грани»),
        // а строка чипса самого поля выключена; стол и остальные виджеты не трогаются (только этот запрос)
        workspace_params_for(WIDGET, params, widget_init = null) {
            params = this.metricChipG_paramsFor(WIDGET, params, widget_init)   // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом)
            const m = this.headerSel_of(WIDGET) || widget_init?._multiply
            // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): поля, которые виджет ТОЛЬКО ставит в селектор стола (Selection → Fields: Set без Get —
            // серии графиков «by …»), — тоже свои: чипсом по такому полю виджет не режется (иначе все графики страницы схлопывались
            // до одной серии, стоило отметить её в любом из них)
            const own = this.selSetOnly_ownFields(WIDGET, params?.WHERE)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: селектори столу у теплокартах закупівель); IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): чипс своего канала от любого виджета — отметка, строка уходит выключенной (fe.data.selectorOwnByWidget выкл. — от другого виджета включённой)
            const fields = [...(m?.selectorFields || []).filter(Boolean), ...own.filter(f => !(m?.selectorFields || []).includes(f))]
            if (!fields.length || !params?.WHERE?.length) return params
            const rows = params.WHERE
            const isOn = (f) => rows.some(r => r && r.leftValue?.value === f && r.use !== false && (r.condition || 'in') === 'in' && (r.attrs || []).length)
            const f = fields.find(isOn) || fields[0]   // канал calc::<поле>::false исключает одно поле — берём поле с активным чипсом
            // IE 2026 09 19 / ODOO-5800 (облегчённые каналы граней, см. calcSlim_on): у грани без действующего чипса строки канала нет — её значение
            // (общий набор СО ВСЕМИ чипсами) лежит строкой calc_all. Именно calc_all, а не calc: строку calc выше уже переписал приём Table chip
            // Строка канала ДЕЙСТВУЮЩЕЙ грани у бэка есть всегда (пусть очищенная = «без отбора»), поэтому calc_all берётся только у недействующей
            // (нет её набора calc::<поле>::true): иначе виджет со своим Set-полем порезался бы собственным чипсом
            const chan = rows.find(r => r && r.leftValue?.value === `calc::${f}::false`)
            const facetOn = rows.some(r => r && r.leftValue?.value === `calc::${f}::true` && r.use !== false)
            const excl = chan || (!facetOn ? rows.find(r => r && r.leftValue?.value === 'calc_all') : undefined)
            const WHERE = rows.map(r => {
                if (!r || !r.leftValue) return r
                const v = r.leftValue.value
                if (fields.includes(v) && r.condition !== 'between') return { ...r, use: false }
                if (v === 'calc' && excl) return { ...r, use: excl.use, attrs: excl.attrs || [] }
                return r
            })
            return { ...params, WHERE }
        },
        // показать страницу экземпляров: лишние закрыть, недостающие открыть, чипс пейджинга обновить
        multiply_apply(st) {
            const store = this
            const WORKSPACE = store.WORKSPACES[st.workspace]; const PAGE = WORKSPACE?.PAGES?.[st.pageId]
            if (!PAGE) return
            const perPage = store.multiply_perPage(st)
            const pages = Math.max(1, Math.ceil(st.items.length / perPage))
            st.pageNo = Math.min(Math.max(0, st.pageNo || 0), pages - 1)
            const from = st.pageNo * perPage
            const wanted = st.items.slice(from, from + perPage)
            const wantedKeys = new Set(wanted.map(it => it.ikey))
            const open = (WORKSPACE.ALL_WIDGETS || []).filter(w => w.page === st.pageId && !w.close && w._multiply?.key === st.key)
            for (const w of open) if (!wantedKeys.has(w._multiply.ikey)) store.widget_close(w.id, false, true)
            for (const it of wanted) {
                const ex = open.find(w => w._multiply.ikey === it.ikey)
                if (ex) { if (ex._softClosed) store._widget_restoreSoftClosed(ex); if (ex.title !== it.title) ex.title = it.title; continue }
                store.executeStoreMethod({}, {
                    action_name: 'action-front-1', command: 'widget_open', widget: st.widget, title: it.title, workspace: st.workspace, page: st.pageId,
                    styleWidget: { dock: 'dock', group: st.gid, ...st.styleWidget, ...store.layout_to_styleWidget(st.layout) },
                    layoutTab: st.layoutTab,
                    fieldsMapping: [{ attr: { binding: 'doc.params.WHERE', value: it.where, valueAsIs: true } }, ...(st.dims || [])],   // valueAsIs — иначе get_value_AttrMulti бэка вычисляет и стирает значения строк
                    multiply_key: st.key + '::' + it.ikey,
                    _multiply: { key: st.key, ikey: it.ikey, ind: it.ind, title: it.title, widget: st.widget, baseTitle: st.baseTitle, settings: { ...st.settings }, selectorFields: st.selectorFields || [],
                        values: it.values.map(v => ({ binding: v.binding, source: v.source || v.binding, value: v.value, title: v.title || '', fieldTitle: v.attr?.title || '', relation_segment: (typeof v.attr?.relation_segment === 'string' ? v.attr.relation_segment : '') })) },
                })
            }
            store.multiply_chips(PAGE)
        },
        // IE 2026 09 15 / ODOO-… (заказ Игоря): чекбокс селектора экземпляра тиража — значения строки-источника в глобальный селектор
        // виджета-списка (строка WHERE стола по полю, widget = список-источник — как onApplySelector__Click списка): клик — добавить /
        // снять значение, set (Alt/Ctrl/Meta) — оставить только его; затем workspace_applySelector — связанные виджеты перечитываются
        // IE 2026 09 15 / ODOO-… (заказ Игоря): чекбокс селектора в шапке ФИКСИРОВАННОГО виджета — настройка записи виджета
        // doc.params.selector_header {widget: список-селектор, field: поле селектора, value: значение, title}: то же описание, что у
        // экземпляра тиража (_multiply): под каким виджетом-селектором и какое значение ставится; данные виджета этим селектором не отбираются
        headerSel_of(WIDGET) {
            if (WIDGET?._multiply?.values?.length) return WIDGET._multiply
            const h = WIDGET?.record?.doc?.params?.selector_header
            if (!h || !h.widget || !h.field || h.value === undefined || h.value === null || h.value === '') return null
            const key = JSON.stringify([h.widget, h.field, h.value, h.title || '', WIDGET.title || ''])
            if (WIDGET._headerSel && WIDGET._headerSel.key === key) return WIDGET._headerSel
            const title = h.title || WIDGET.title || String(h.value)
            WIDGET._headerSel = { key, selectorFields: [h.field], settings: { widget: h.widget },
                values: [{ binding: h.field, source: h.field, value: h.value, title, fieldTitle: h.field_title || h.field, relation_segment: h.segment || '' }] }
            return WIDGET._headerSel
        },
        // селектор шапки активен (значение виджета стоит в строке стола) — тогда данные, полученные при открытии с обычными
        // параметрами стола, перечитываются без своего селектора
        // IE 2026 09 15 / ODOO-… (замечание Игоря, вечер): поля Selection → Fields с Set без Get (виджет только ставит чипс) — не 'date'
        // (период — своя строка between) и не поля селектора шапки / тиража (они учтены отдельно)
        selSetOnly_fields(WIDGET) {
            const out = []
            for (const r of this.selFields_rows(WIDGET)) {
                if (!r || r.use === false || !r.selector_set || r.selector_get) continue
                const n = String(r.source || r.binding || '').trim()
                if (n && n !== 'date' && !out.includes(n)) out.push(n)
            }
            return out
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: селектори столу у теплокартах закупівель; проба dev02 p165): Set-без-Get каналы, которые виджет считает СВОИМИ
        // (им не режется, при их смене не перечитывается). Режим doc.params.selector_own_by_widget (теплокарты закупок): свой — только канал, чью строку
        // чипса стола поставил этот виджет (как бэк attrs.selector_own_chip_by_widget); иначе соседняя карта считала чипс Object «своим», не перечитывалась
        // и уходила бэку с выключенной строкой. rows — строки WHERE запроса (по умолчанию — стола). Выключатель fe.data.selectorOwnByWidget (вкл.)
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): смысл выключателя fe.data.selectorOwnByWidget (вкл.) — «свой канал = отметка, не отбор»: входящий чипс своего Set-канала от любого
        // виджета выборку не сужает (строка уходит бэку выключенной, перечитывания нет) — совпадающие строки виджет отмечает и подсвечивает; ВЫКЛ — правило p165b выше
        selSetOnly_ownFields(WIDGET, rows) {
            const own = this.selSetOnly_fields(WIDGET)
            if (!own.length) return own
            const mark = this.setting('fe.data.selectorOwnByWidget', true) !== false   // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор)
            return selOwnByWidget_filter(WIDGET, own, rows ?? this.WORKSPACES[WIDGET?.workspace]?.record?.doc?.params?.WHERE, { mark })   // IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор)
        },
        // IE 2026 10 23 / ODOO-347321: канал Set-без-Get поля (source || binding, имя строки чипса стола) → колонка строки выдачи (binding || source)
        // IE 2026 10 24 / ODOO-347321 (Demo7, DataHub, Connectors: канал connector публикует поле id — F_id с selector_binding connector): сначала соответствие
        // из doc.params.fieldSelectors (канал leftValue.value / selector_binding → binding поля), иначе как выше (source → binding); логика — utils/selectorCols
        selSetOnly_cols(WIDGET) {
            return selectorCols_map(this.selFields_rows(WIDGET), WIDGET?.record?.doc?.params?.fieldSelectors)   // IE 2026 10 24 / ODOO-347321
        },
        // по такому полю в столе стоит активный чипс — данные, полученные при открытии параметрами стола, перечитываются без него
        // IE 2026 09 16 (замечание Игоря): изменившиеся с прошлого применения строки чипсов стола (по подписи строки); первый вызов —
        // снимок без «изменений» (все виджеты перечитываются как раньше)
        // подпись строки чипса стола: состояние, от которого зависит отбор (у строки чипса метрик условия вложенные — смену отбора видно по её doc)
        whereRow_sig(r) {
            return JSON.stringify([r?.condition || 'in', r?.use !== false, (r?.attrs || []).map(a => [a?.use !== false, a?.rightValue?.value]), r?.rightValue?.value, r?.rightValue?.valueTo, r?.chip_segment === 'CHIP-Metric' ? r.doc : undefined])
        },
        // ---- IE 2026 09 19 / ODOO-5800 (находка ie-dm7 #30048: гонка ответов применения селекторов) ----
        // Строку чипса стола меняет фронт (⊗, флажок списка, новый отбор чипса метрик), а ответ БОЛЕЕ РАННЕГО запроса, ушедшего с прежним
        // состоянием строки, может прийти позже. Замер dev02 (tools/probes/chiprace_check.mjs, ответ первого applySelector задержан):
        // ⊗ Object и следом ⊗ чипс метрик → чипс метрик оживал (use true, calc 2 550); в обратном порядке оживал Object; обычный чипс,
        // поставленный и сразу снятый, возвращался; новый отбор чипса метрик откатывался к прежнему. Пути: «в сторе нет пользовательских
        // значений → принять workspace_params ответа целиком» и «действующая производная строка ответа заменяет строку стора».
        // Порядковые отметки: whereFront_stamp — каждое изменение строки на фронте получает номер (сверка подписей при каждой отправке
        // запроса и перед мержем ответа); запрос запоминает номер своей отправки и подпись чипсов стола на этот момент. При мерже:
        //   · строка, изменённая после отправки запроса, из его ответа не берётся (остаётся строка стора);
        //   · наборы calc, метка и признак пустого пересечения берутся, только если чипсы стола с момента отправки не менялись —
        //     иначе они посчитаны под прежний состав чипсов (свежие принесёт ответ запроса, ушедшего с новым составом).
        // Выключатель fe.data.wsParamsStaleGuard (по умолчанию вкл.), счётчики store._staleGuard {rows, calc}
        whereFront_stamp(WORKSPACE) {
            const rows = WORKSPACE?.record?.doc?.params?.WHERE
            if (!Array.isArray(rows)) return null
            const st = WORKSPACE._whereFront = WORKSPACE._whereFront || markRaw({ sig: {}, seq: {} })   // служебное состояние — вне реактивности
            const seen = new Set()
            for (const r of rows) {
                const k = String(r?.leftValue?.value || '')
                if (!k || k.startsWith('calc')) continue
                seen.add(k)
                const sg = this.whereRow_sig(r)
                if (st.sig[k] === undefined) { st.sig[k] = sg; continue }   // первое наблюдение — не изменение
                if (st.sig[k] !== sg) { st.sig[k] = sg; st.seq[k] = this._wsSeq = (this._wsSeq || 0) + 1 }
            }
            for (const k of Object.keys(st.sig)) if (!seen.has(k)) { delete st.sig[k]; st.seq[k] = this._wsSeq = (this._wsSeq || 0) + 1 }   // строку убрали со стола
            return st
        },
        // подпись состава чипсов стола (все не-calc строки): под неё считаются наборы calc
        whereUser_sig(WORKSPACE) {
            const rows = WORKSPACE?.record?.doc?.params?.WHERE || []
            return rows.filter(r => r && !String(r?.leftValue?.value || '').startsWith('calc')).map(r => String(r?.leftValue?.value || '') + '=' + this.whereRow_sig(r)).sort().join('\n')
        },
        whereChanged_take(WORKSPACE) {
            const rows = WORKSPACE?.record?.doc?.params?.WHERE || []
            const sig = (r) => this.whereRow_sig(r)
            const cur = {}
            for (const r of rows) { const k = r?.leftValue?.value; if (k) cur[k] = sig(r) }
            const prev = WORKSPACE._whereSig
            WORKSPACE._whereSig = cur
            if (!prev) return null
            const out = new Set()
            for (const k of Object.keys(cur)) if (cur[k] !== prev[k]) out.add(k)
            for (const k of Object.keys(prev)) if (!(k in cur)) out.add(k)
            return out
        },
        // все изменившиеся поля — поля, которые виджет только ставит (Set без Get) → перечитывать его не нужно; производные строки
        // (calc, calc::<поле>::true/false, calc_object …) бэк пересчитывает по чипсам сами — их изменение считается по исходным чипсам
        selSetOnly_covers(WIDGET, changed) {
            const own = this.selSetOnly_ownFields(WIDGET)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: селектори столу у теплокартах закупівель); IE 2026 11 01 / ODOO-350449 (заказ Игоря через ie-webscm7-2 #122315: легенда вимк., колонка прапорців у Числах, чіп як селектор): чипс соседа по своему Set-каналу — без перечитывания, отметка строк (выкл. — перечитать)
            if (!own.length) return false
            let ownHit = false
            for (const f of changed) {
                if (f === 'calc' || f.startsWith('calc::') || f.startsWith('calc_')) continue
                if (!own.includes(f)) return false
                ownHit = true
            }
            return ownHit
        },
        // флаги отбора строк виджета по чипсам его Set-полей — на фронте, без запроса (строка отобрана, если её значения всех активных
        // чипсов своих полей входят в чипсы); графики читают состояние серий из чипсов стола сами
        selectorFlags_refresh(WIDGET) {
            const own = this.selSetOnly_fields(WIDGET)
            if (!own.length) return
            // IE 2026 10 23 / ODOO-347321 (находка odoo-killer, шина #101690: 25 фасетов Unitsoft_fin теряли флажки строк при стоящем чипсе): имя КАНАЛА
            // (source, напр. an2_project) ищет строку чипса стола — верно; а значение строки выдачи лежит в колонке по binding (project_id) — читалось
            // по имени канала → null → флажки снимались у всех строк. При source == binding (эталоны, myts) разницы нет. Колонка строки — selSetOnly_cols
            const colOf = this.selSetOnly_cols(WIDGET)   // IE 2026 10 23 / ODOO-347321
            const rows = this.WORKSPACES[WIDGET.workspace]?.record?.doc?.params?.WHERE || []
            // IE 2026 10 14 / ODOO-343342 (заказ Игоря: строка пустого селектора в списке): чипс «Empty» несёт маркер EMPTY_VALUE_MARKER ('<isempty>', ставится в onApplySelector__Click), строка — null / '' /
            // undefined / zero-UUID (та же тройка, что порождает маркер) — String() их не уравнивает; пустое значение строки считается попаданием
            // в чипс с маркером. Выключатель fe.ux.selectorEmptyMatch (по умолчанию ВКЛ; выкл — как до правки). Счётчик window.__selectorEmptyMatch
            const emptyOn = this.setting('fe.ux.selectorEmptyMatch', true) !== false   // IE 2026 10 14 / ODOO-343342 (заказ Игоря: строка пустого селектора в списке)
            const selEmpty_isEmpty = (v) => v == null || v === '' || v === '00000000-0000-0000-0000-000000000000'   // IE 2026 10 14 / ODOO-343342 (заказ Игоря: строка пустого селектора в списке)
            const active = own.map(f => {
                const r = rows.find(x => x?.leftValue?.value === f && x.use !== false && (x.condition || 'in') === 'in')
                const vals = new Set((r?.attrs || []).filter(a => a && a.use !== false && a.rightValue?.value !== undefined && a.rightValue?.value !== null && a.rightValue?.value !== '').map(a => String(a.rightValue.value)))
                return { f, vals, empty: emptyOn && vals.has(EMPTY_VALUE_MARKER) }   // IE 2026 10 14 / ODOO-343342 (заказ Игоря: строка пустого селектора в списке)
            }).filter(x => x.vals.size)
            // IE 2026 09 22 (замечание Игоря: «чипс Object стоит, а флажок в строке Objects::Balance by horizon не стоит»): строки СПИСКА лежат
            // в record._doc.data (doc.data — у записей с данными в документе), дерево — в attrs строк; поле Set С Get у того же виджета флагирует
            // бэк — без активных чипсов своих полей его флаги не гасим. Возвращает число изменённых строк (вызывающий перерисовывает грид)
            const data = WIDGET.record?._doc?.data ?? WIDGET.record?.doc?.data
            if (!Array.isArray(data)) return 0
            if (!active.length && this.selFields_names(WIDGET, 'selector_set').some(f => !own.includes(f))) return 0
            let changed = 0
            const walk = (list, depth) => {
                for (const row of list) {
                    if (!row || typeof row !== 'object') continue
                    const on = active.length > 0 && active.every(({ f, vals, empty }) => {   // IE 2026 10 14 / ODOO-343342 (заказ Игоря: строка пустого селектора в списке)
                        const v = this.get_value(row, colOf[f] || f)   // IE 2026 10 23 / ODOO-347321: значение строки — по binding, чипс — по source
                        if (vals.has(String(v))) return true
                        if (empty && selEmpty_isEmpty(v)) { const C = window.__selectorEmptyMatch || (window.__selectorEmptyMatch = { rows: 0 }); C.rows++; return true }   // IE 2026 10 14 / ODOO-343342 (заказ Игоря: строка пустого селектора в списке)
                        return false
                    })
                    if (!!row.selector !== on) { row.selector = on; changed++ }
                    if (depth < 8 && Array.isArray(row.attrs) && row.attrs.length && typeof row.attrs[0] === 'object') walk(row.attrs, depth + 1)
                }
            }
            walk(data, 0)
            return changed
        },
        // перерисовать грид данных виджета после смены флагов отбора строк (wijmo за данными не следит)
        selectorFlags_repaint(WIDGET) {
            for (const g of Object.values(WIDGET?.applys_CHIPS || {})) {
                if (g && g.flex && g.attr?.name === 'dataSheet') { try { g.flex.invalidate() } catch (e) { /* грид пересоздаётся */ } }
            }
        },
        selSetOnly_active(WIDGET) {
            const fields = this.selSetOnly_ownFields(WIDGET)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: селектори столу у теплокартах закупівель)
            if (!fields.length) return false
            const rows = this.WORKSPACES[WIDGET.workspace]?.record?.doc?.params?.WHERE || []
            return fields.some(f => rows.some(r => r?.leftValue?.value === f && r.use !== false && (r.condition || 'in') === 'in' && (r.attrs || []).some(a => a && a.use !== false && a.rightValue?.value)))
        },
        headerSel_active(WIDGET) {
            const m = this.headerSel_of(WIDGET); if (!m) return false
            const rows = this.WORKSPACES[WIDGET.workspace]?.record?.doc?.params?.WHERE || []
            return m.values.some(v => { const r = rows.find(x => x?.leftValue?.value === (v.source || v.binding)); return !!(r && r.use !== false && (r.attrs || []).some(a => a?.rightValue?.value === v.value)) })
        },
        // IE 2026 09 17 (заказ Игоря «если я отключаю PO* / Ex-Distr* — можно ли просто быстро скрыть-показать строки на фронте»):
        // строки уже построенной группы прячутся / показываются мгновенно (без reload отчёта: 7–8 с на клик); reload остаётся только
        // для группы, которой в данных нет (была выключена при открытии). Флаг use группы в записи и кнопка шапки меняются в памяти,
        // как это делал бы бэк; печать / экспорт идут по состоянию записи. Выкл: window.feSettings.set('fe.ux.optionGroupsFast', false)
        optionGroup_toggleFast(WIDGET, group) {
            const store = this
            group = String(group || '').trim()
            if (!WIDGET || !group) return false
            try { if (store.setting('fe.ux.optionGroupsFast', true) === false) return false } catch (e) { /* нет настройки */ }
            const params = WIDGET.record?.doc?.params
            if (!params) return false
            // IE 2026 09 24 / ODOO-5800 (группы КОЛОНОК Qty / Sum $ / Pallets отчёта 1fxa_001): быстрый путь прячет только СТРОКИ — колонки выключенной
            // группы оставались на экране до перечитывания (0 строк, 0 запросов). Группа с узлом под корнем колонок раскладки (или с признаком
            // columns в option_groups) идёт штатным путём бэка (toggle_option_group → reload), как при включении; строковые группы (PO / Sales / …)
            // — по-прежнему на фронте. Выкл: window.feSettings.set('fe.ux.optionGroupColumnsReload', false)
            // IE 2026 10 22 / ODOO-5800 (заказ Игоря: кнопки групп опций отчётов согласования — мгновенно, «по сути включив precache»): группа
            // КОЛОНОК идёт быстрым путём тоже — AttrGrid.optionGroup_setColsHidden прячет / показывает её колонки (и заголовок группы) на месте,
            // если колонки уже построены (precache или группа была включена при открытии). Флаг fe.ux.optionGroupColumnsFast (по умолчанию ВКЛ):
            // false — прежнее поведение (reload бэка для групп колонок)
            const isCols = store.optionGroup_isColumns(WIDGET, group)
            if (isCols && !store.optionGroup_colsFast()) return false   // IE 2026 10 22 / ODOO-5800
            const grids = Object.values(WIDGET.attrs_vueObj || {}).filter(x => x && x.flex && typeof x.optionGroup_apply === 'function')
            const grid = grids.find(x => x.attr?.name === 'dataSheet') || grids[0]
            if (!grid) return false
            const rows = params.option_groups = Array.isArray(params.option_groups) ? params.option_groups : []
            let row = rows.find(r => String(r?.title || '').trim() === group)
            const curOn = !!(row && row.use)
            if (!curOn && !(isCols ? grid.optionGroup_hasCols(group) : grid.optionGroup_hasRows(group))) return false   // группы нет в данных — строит бэк; IE 2026 10 22 / ODOO-5800: колонки
            if (!row) { row = { use: false, title: group }; rows.push(row) }
            row.use = !curOn
            // IE 2026 09 19 / ODOO-… (находка: группа, выключенная на фронте, «возвращалась» после Update data / смены чипса стола): состояние групп живёт
            // в записи НА ФРОНТЕ, а select отчёта с ключом серверного кэша виджета запись не шлёт (ODOO-336658) — бэк брал свою копию записи с прежним
            // use, строил строки группы, и они показывались при неактивной кнопке. Отметка «запись на фронте новее кэша»: ближайший select повезёт
            // запись (без _doc; ключ кэша и вид остаются — как ветка has_frontChips), бэк перекеширует виджет, отметку снимет ответ.
            // Выкл: fe.data.optionGroupsSyncRecord = false
            WIDGET._ogFrontDirty = (WIDGET._ogFrontDirty || 0) + 1
            const n = grid.optionGroup_apply(group, row.use)
            for (const b of store.optionGroup_panelButtons(WIDGET)) {   // кнопка шапки — состояние на месте (reload перечитал бы меню); // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): и кнопки в панели над таблицей
                if (b?.method === 'toggle_option_group' && String(b.params?.group || '').trim() === group) b.active = row.use
            }
            if (!store.hide_console) console.log(`option group «${group}» ${row.use ? 'on' : 'off'} on the front end: ${n?.rows ?? n} rows, ${n?.cols ?? 0} columns`)   // IE 2026 10 22 / ODOO-5800: + колонки
            return true
        },
        // IE 2026 10 22 / ODOO-5800: группы колонок переключаются на фронте (флаг fe.ux.optionGroupColumnsFast, по умолчанию ВКЛ;
        // выкл: window.feSettings.set('fe.ux.optionGroupColumnsFast', false) — группы колонок снова через reload бэка)
        optionGroup_colsFast() {
            try { return this.setting('fe.ux.optionGroupColumnsFast', true) !== false } catch (e) { return true }
        },
        // IE 2026 09 24 / ODOO-5800: группа опций относится к КОЛОНКАМ — узел с option_group = group лежит под корнем колонок раскладки
        // (attr_type / template AttrGridColumns в doc.params.data_layout2; option_group наследуется вглубь, как в AttrGrid.optionGroup_nodeMap),
        // либо у строки группы в params.option_groups стоит признак columns. Набор групп колонок кэшируется на виджете по ссылке на data_layout2.
        // Флаг fe.ux.optionGroupColumnsReload (по умолчанию ВКЛ): false — прежнее поведение (быстрый путь и для групп колонок)
        optionGroup_isColumns(WIDGET, group) {
            const store = this
            try { if (store.setting('fe.ux.optionGroupColumnsReload', true) === false) return false } catch (e) { /* нет настройки */ }
            group = String(group || '').trim()
            const params = WIDGET?.record?.doc?.params
            if (!params || !group) return false
            const row = (Array.isArray(params.option_groups) ? params.option_groups : []).find(r => String(r?.title || '').trim() === group)
            if (row && row.columns) return true
            const dl2 = params.data_layout2
            if (!Array.isArray(dl2)) return false
            let cache = WIDGET._ogCols
            if (!cache || cache.src !== dl2) {
                cache = { src: dl2, groups: new Set() }
                const isCols = r => r.attr_type === 'AttrGridColumns' || r.template === 'AttrGridColumns' || r.component === 'AttrGridColumns'
                const walk = (rows, inCols, depth) => {
                    for (const r of rows || []) {
                        if (!r || typeof r !== 'object') continue
                        const cols = inCols || isCols(r)
                        const g = String(r.option_group || '').trim()
                        if (cols && g) cache.groups.add(g)
                        if (depth < 16) walk(r.attrs, cols, depth + 1)
                    }
                }
                walk(dl2, false, 0)
                WIDGET._ogCols = cache
            }
            return cache.groups.has(group)
        },
        // IE 2026 09 24 / ODOO-5800 (заказ Игоря: «при включении / выключении нескольких опций корректно применялись ВСЕ изменения»):
        // поколение запросов групп опций. Бэк переворачивает use группы В ПРИСЛАННОЙ записи (views.py toggle_option_group → reload), а запись
        // фронта менялась только ответом (reload ~3 с + select ~10 с у «Палети»): второй клик во время ожидания вёз устаревший набор — первое
        // переключение терялось; двойной клик по одной группе включал её дважды; группа строк, переключённая на фронте во время ожидания,
        // перетиралась ответом. Теперь состояние групп ведёт ФРОНТ: клик сразу меняет use в записи и кнопку шапки, поднимает поколение
        // (WIDGET._ogSeq), обрывает ожидание ответа по данным (abort + del_last_backend_action бэку — слово Игоря: «сбросить ожидание и
        // сделать новый запрос с учётом нового набора») и через паузу fe.ux.optionGroupRequestDebounceMs (200 мс; быстрые переключения
        // подряд — один запрос) шлёт reload с ПОЛНЫМ текущим набором (WIDGET.doc_take_from_front: бэк берёт запись как прислана, без
        // переворота). Ответ устаревшего поколения не применяется (гейт _ogSeq в executeWidgetMethod). Набор вернулся к применённому
        // (вкл → выкл за время ожидания) — запроса нет. Группа строк без ожидания — по-прежнему быстрый путь фронта (optionGroup_toggleFast,
        // 0 запросов); во время ожидания она прячется / показывается на месте и уезжает в общий запрос. Reload, оборванный не новым кликом
        // (Stop, чужой запрос виджета) или упавший, — набор возвращается к применённому (optionGroup_revert), чтобы кнопки не расходились
        // с данными. Флаг fe.ux.optionGroupRequestSeq (по умолчанию ВКЛ): false — прежнее поведение. Возвращает true, если клик обработан здесь
        optionGroup_toggleSeq(vueObj, group) {
            const store = this, WIDGET = vueObj?.WIDGET
            group = String(group || '').trim()
            if (!WIDGET || !group || WIDGET.close) return false
            try { if (store.setting('fe.ux.optionGroupRequestSeq', true) === false) return false } catch (e) { return false }
            const params = WIDGET.record?.doc?.params
            if (!params) return false
            const base = store.optionGroup_base(WIDGET)   // применённое состояние — снимок ДО правки в памяти
            const rows = params.option_groups = Array.isArray(params.option_groups) ? params.option_groups : []
            const findRow = () => rows.find(r => String(r?.title || '').trim() === group)
            let row = findRow()
            const on = !(row && row.use)
            const isCols = store.optionGroup_isColumns(WIDGET, group)
            const grid = store.optionGroup_grid(WIDGET)
            const colsFast = isCols && store.optionGroup_colsFast()   // IE 2026 10 22 / ODOO-5800: группа колонок — на фронте
            const hasRows = !!grid && (!on || (colsFast ? grid.optionGroup_hasCols(group) : grid.optionGroup_hasRows(group)))   // строки (колонки) группы есть в данных (выключение — всегда; включение — прекеш)
            const waiting = !!WIDGET._ogTimer || store.optionGroup_dataInFlight(WIDGET) || Object.keys(WIDGET._ogWant || {}).length > 0
            if ((!isCols || colsFast) && hasRows && !waiting && store.optionGroup_toggleFast(WIDGET, group)) {
                base.state[group] = !!findRow()?.use   // чистый быстрый путь (ничего не ждём): применено на месте, без запроса
                return true
            }
            if (!row) { row = { use: false, title: group }; rows.push(row) }
            row.use = on
            WIDGET._ogWant = { ...(WIDGET._ogWant || {}), [group]: on }
            store.optionGroup_button(WIDGET, group, on)
            if ((!isCols || colsFast) && grid && hasRows) { try { grid.optionGroup_apply(group, on) } catch (e) { /* строки перестроит ответ */ } }   // на месте, пока идёт запрос; IE 2026 10 22 / ODOO-5800: и колонки
            const seq = WIDGET._ogSeq = (WIDGET._ogSeq || 0) + 1   // поколение — ДО обрыва: обрыв своего запроса не должен читаться как чужой (optionGroup_aborted)
            const aborted = store.optionGroup_abortWait(WIDGET)
            const ms = Math.max(0, Number(store.setting('fe.ux.optionGroupRequestDebounceMs', 200)) || 0)
            if (WIDGET._ogTimer) clearTimeout(WIDGET._ogTimer)
            WIDGET._ogTimer = setTimeout(() => { WIDGET._ogTimer = null; store.optionGroup_send(WIDGET) }, ms)
            if (!store.hide_console) console.log(`option group «${group}» ${on ? 'on' : 'off'}: generation ${seq}${aborted ? ', the pending data request is cancelled' : ''} → reload in ${ms} ms with the full set`)
            return true
        },
        // грид данных виджета с быстрым путём групп (AttrGrid.optionGroup_apply)
        optionGroup_grid(WIDGET) {
            const grids = Object.values(WIDGET?.attrs_vueObj || {}).filter(x => x && x.flex && typeof x.optionGroup_apply === 'function')
            return grids.find(x => x.attr?.name === 'dataSheet') || grids[0] || null
        },
        // состояние групп записи: {title: use}
        optionGroup_state(WIDGET) {
            const out = {}
            for (const r of (WIDGET?.record?.doc?.params?.option_groups || [])) { const t = String(r?.title || '').trim(); if (t) out[t] = !!r.use }
            return out
        },
        // применённое состояние групп: снимок записи, действующий, пока запись не заменил ответ (новая запись = применённое состояние)
        optionGroup_base(WIDGET) {
            const rec = WIDGET.record
            if (!WIDGET._ogBase || WIDGET._ogBase.rec !== rec) WIDGET._ogBase = { rec, state: this.optionGroup_state(WIDGET) }
            return WIDGET._ogBase
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення)
        // кнопки опций среза виджета: шапка (WIDGET.groupMenu.commandPanel) и панели над таблицей гридов (attr.groupMenu.commandPanel — кнопки с place 'panel'
        // бэк кладёт туда, как «Open doc»; и показанная копия панели грида — после updateCommandPanelInPlace это могут быть другие объекты). Без повторов
        optionGroup_panelButtons(WIDGET) {
            const out = [], seen = new Set()
            const add = (arr) => { for (const b of (Array.isArray(arr) ? arr : [])) if (b && typeof b === 'object' && !seen.has(b)) { seen.add(b); out.push(b) } }
            add(WIDGET?.groupMenu?.commandPanel)
            for (const g of Object.values(WIDGET?.attrs_vueObj || {})) {
                if (!g || !g.flex || !g.attr) continue
                add(g.attr.groupMenu?.commandPanel)
                add(g.commandPanel)
            }
            return out
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p191 кола — за натиснутим видом у смузі, без опції «Кругові за статусами»)
        // кнопки шапки — дубли кнопок вида полосы над таблицей (utils/cellViewState.cellViewBtn_headerDupes): не показываются (Widget.set_commandPanel),
        // их active вид не нажимает (cellView_syncButtons). Полоса — панели гридов и панель dataSheet из WIDGET.view (грид мог ещё не смонтироваться).
        // Выключатель fe.ux.cellViewsGateByView ВЫКЛ — пусто
        cellView_headerDupes(WIDGET) {
            if (!WIDGET || !cellViewGate_on((k, d) => this.setting(k, d))) return []
            const header = Array.isArray(WIDGET?.groupMenu?.commandPanel) ? WIDGET.groupMenu.commandPanel : []
            if (!header.some(b => cellViewBtn_is(b))) return []
            const strip = []
            for (const g of Object.values(WIDGET?.attrs_vueObj || {})) {
                if (!g || !g.attr) continue
                for (const arr of [g.attr.groupMenu?.commandPanel, g.commandPanel]) if (Array.isArray(arr)) strip.push(...arr)
            }
            try { const ds = this.get_field(WIDGET.view, 'dataSheet'); if (Array.isArray(ds?.groupMenu?.commandPanel)) strip.push(...ds.groupMenu.commandPanel) } catch (e) { /* нет dataSheet */ }
            return cellViewBtn_headerDupes(header, strip)
        },
        // вид ячеек отчёта (status_pie): состояние — в памяти виджета (WIDGET._cellViews), в запись не пишется и на бэк не уходит. До первого клика —
        // признак active кнопки из set_menu (дефолт отчёта)
        cellView_on(WIDGET, view) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): активный вид — WIDGET._cellView (строка; алиас status_pie → status_zones), иначе прежний _cellViews
            const k = cellView_key(view)
            return !!k && cellView_activeOf(WIDGET) === k
        },
        // состояние кнопок вида — по WIDGET._cellViews (ответ reload / set_menu приносит кнопку заново с active бэка); первое появление кнопки задаёт
        // начальное состояние. Изменилось — гриды перерисовываются
        cellView_syncButtons(WIDGET) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): взаимоисключение — один активный вид (utils/cellViewState)
            if (!WIDGET || !cellPie_flagOn((k, d) => this.setting(k, d))) return false
            const views = WIDGET._cellViews || (WIDGET._cellViews = {})
            const before = cellView_activeOf(WIDGET)
            const prev = typeof WIDGET._cellView === 'string' ? WIDGET._cellView : (Object.keys(views).length ? cellView_fromLegacy(views) : undefined)
            const dupes = this.cellView_headerDupes(WIDGET)   // IE 2026 11 02 / ODOO-350449 (p191 правка координатора: use строки status_pie нажимает «Статуси й зони» при открытии): спрятанный дубль шапки (status_pie) — первым: его active (use строки) при открытии
            // нажимает свой вид в полосе («Статуси й зони»), как прежде; use=false — ничего не нажато. Сам дубль не показывается (Widget.set_commandPanel)
            const btns = cellViewBtn_dupesFirst(this.optionGroup_panelButtons(WIDGET).filter(b => cellViewBtn_is(b) || cellPie_isViewButton(b)), dupes)   // IE 2026 11 02 / ODOO-350449 (p191 правка координатора: use строки status_pie нажимает «Статуси й зони» при открытии)
            const a = cellViewState_sync(prev, views, btns, WIDGET._cellViewVar)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): вариант активной кнопки режима
            if (WIDGET._cellView !== a) WIDGET._cellView = a
            const changed = cellView_activeOf(WIDGET) !== before
            if (changed) this.cellView_refreshGrids(WIDGET)
            return changed
        },
        cellView_refreshGrids(WIDGET, dataChanged = false) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): dataChanged — в ячейки слиты спутники (кеш слоёв грида по версии сбрасывается)
            for (const g of Object.values(WIDGET?.attrs_vueObj || {})) {
                const rf = g && g.flex && (g.cellView_refresh || g.cellPie_refresh)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
                if (typeof rf === 'function') { try { rf.call(g, dataChanged) } catch (e) { /* грид пересоздаётся */ } }
            }
        },
        // клик по кнопке вида: мгновенно, без запроса. false — флаг fe.ux.cellStatusPie выключен (кнопка идёт обычным путём опции среза)
        cellView_toggle(vueObj, btn) {
            const WIDGET = vueObj?.WIDGET
            if (!WIDGET || !cellPie_isViewButton(btn) || !cellPie_flagOn((k, d) => this.setting(k, d))) return false
            // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): кнопки вида взаимоисключающие — клик по неактивной включает её вид, по активной — «Числа» ('')
            const views = WIDGET._cellViews || (WIDGET._cellViews = {})
            const id = cellViewBtn_id(btn)
            const cur = typeof WIDGET._cellView === 'string' ? cellView_key(WIDGET._cellView) : (btn.active ? id : cellView_fromLegacy(views))
            const panel = this.optionGroup_panelButtons(WIDGET)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
            const curBtn = cur ? panel.find(b => cellViewBtn_is(b) && b.active && cellViewBtn_id(b) === cur) : null   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
            const av = WIDGET._cellViewVar || (curBtn ? cellViewBtn_variant(curBtn) : '')   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by): вариант активной кнопки (composition / composition со split_by)
            const next = cellViewState_next(cur, btn, av)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
            WIDGET._cellView = next
            WIDGET._cellViewVar = next ? cellViewBtn_variant(btn) : ''   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
            WIDGET._cellViewUserSeq = (WIDGET._cellViewUserSeq || 0) + 1   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): смена вида пользователем (клик / меню / команда) — utils/gridRows.gridRows_syncState
            cellViewState_seen(views, next, [btn])
            cellViewState_mark([...panel, btn], next, WIDGET._cellViewVar)   // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p182: підлеглі рядки — підписи шарів зі значень фіксованих колонок, split_by)
            WIDGET._cellViewNote = ''
            if (WIDGET._cellViewWait && WIDGET._cellViewWait !== next) WIDGET._cellViewWait = ''
            try { WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.() } catch (e) { /* шапку перерисует следующий ответ */ }
            this.cellView_refreshGrids(WIDGET)
            if (!this.hide_console) console.log(`cell view «${next || 'numbers'}» on the front end`)
            if (next) this.cellView_requestNow(WIDGET, next, { force: true })   // данных вида нет — немедленный select_cell_views
            return true
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2)
        // Отложенные данные видов ячеек (§1.3, §1.5 плана p149). Версия основного ответа — по тождеству объекта record._doc (новый select / reload
        // приносит новую запись): ответ select_cell_views, отправленный при другой версии, не сливается. Состояние — _cellViewSt (WeakMap вне WIDGET)
        cellView_state(WIDGET) {
            const W = toRaw(WIDGET)
            if (!W || typeof W !== 'object') return null
            const doc = toRaw(W.record?._doc) || null
            let st = _cellViewSt.get(W)
            if (!st) { st = { ver: 1, doc, pending: Object.create(null), tried: Object.create(null) }; _cellViewSt.set(W, st); return st }
            if (st.doc !== doc) { st.doc = doc; st.ver++; st.pending = Object.create(null); st.tried = Object.create(null) }
            return st
        },
        // данные вида готовы (utils/cellViewsMerge.cellView_dataReadyOf): вид без данных бэка; основной ответ считал вид; пришли отложенные данные
        cellView_dataReady(WIDGET, view) {
            const e = cellView_get(view)
            if (!e) return true
            const aliases = Object.keys(CELL_VIEW_ALIASES).filter(a => CELL_VIEW_ALIASES[a] === e.key)
            return cellView_dataReadyOf(toRaw(WIDGET?.record?._doc), e, { aliases })
        },
        // немедленный запрос данных вида (не deferred); защита от повтора того же вида в той же версии ответа. Пока ждём — класс виджета
        // widget-cellview-wait (WIDGET._cellViewWait = вид): грид приглушён, карточка «Computing data for the view …». Старый бэк (в основном ответе
        // нет _doc.cell_views_stats) — запроса нет. Идёт запрос данных виджета — ждём его ответ (cellView_afterDoc повторит проверку).
        // opts.force — повтор после отброшенного ответа (клик по кнопке). → true — запрос ушёл
        cellView_requestNow(WIDGET, view, opts = {}) {
            const store = this, k = cellView_key(view), e = cellView_get(k)
            if (!WIDGET || WIDGET.close || !e || !e.needsData || !WIDGET.vueObj) return false
            if (!cellViews_deferredOn((kk, d) => store.setting(kk, d))) return false
            if (!cellViews_backendSupports(toRaw(WIDGET.record?._doc))) return false
            if (store.cellView_dataReady(WIDGET, k)) { if (WIDGET._cellViewWait === k) WIDGET._cellViewWait = ''; return false }
            const st = store.cellView_state(WIDGET)
            if (st.pending[k] === st.ver) { WIDGET._cellViewWait = k; return false }
            if (st.tried[k] === st.ver && !opts.force) return false
            if (store.optionGroup_dataInFlight(WIDGET)) { WIDGET._cellViewWait = k; return false }
            st.pending[k] = st.tried[k] = st.ver
            WIDGET._cellViewWait = k
            const ver = st.ver
            setTimeout(() => {   // страховка: ответ потерян (обрыв, BREAK) — карточка не висит
                const s2 = store.cellView_state(WIDGET)
                if (s2 && s2.pending[k] === ver) delete s2.pending[k]
                if (WIDGET._cellViewWait === k && !(s2 && s2.pending[k])) WIDGET._cellViewWait = ''
            }, store.setting('fe.ux.cellViewsWaitMs', 120000))
            window.__cellView = window.__cellView || { calc: 0, scale: 0 }
            window.__cellView.requests = (window.__cellView.requests || 0) + 1
            store.executeStoreMethod(WIDGET.vueObj, { command: 'executeWidgetMethod', method: CELL_VIEWS_METHOD, params: { views: [k] }, _cellViewFront: true,
                record_sendToBackend_exclude: ['_doc'], no_del_last_backend_action: true, action_name: 'action-front-cellViews-2026-11-01' })
            return true
        },
        // перед отправкой select_cell_views (свой немедленный и отложенный из actions_after бэка): флаг; у отложенного — убрать виды, что уже пришли /
        // в полёте; отметка версии на ответе (_response_callback зовётся до применения ответа). false — запрос не нужен
        cellView_beforeSend(vueObj, action) {
            const store = this, WIDGET = vueObj?.WIDGET
            if (!WIDGET) return true
            if (!cellViews_deferredOn((k, d) => store.setting(k, d))) return false
            const st = store.cellView_state(WIDGET)
            if (!st) return true
            const ver = st.ver
            let views = (Array.isArray(action.params?.views) ? action.params.views : []).map(v => String(v ?? '')).filter(Boolean)
            if (!action._cellViewFront) {
                views = views.filter(v => { const k = cellView_key(v); return st.pending[k] !== ver && !store.cellView_dataReady(WIDGET, k) })
                if (!views.length) return false
                for (const v of views) st.pending[cellView_key(v)] = ver
                action.params = { ...(action.params || {}), views }
                if (!action.command) action.command = 'executeWidgetMethod'
                if (!action.record_sendToBackend_exclude) action.record_sendToBackend_exclude = ['_doc']
                action.no_del_last_backend_action = true
            }
            const keys = views.map(cellView_key)
            const done = () => {
                const s2 = store.cellView_state(WIDGET)
                for (const k of keys) if (s2 && s2.pending[k] === ver) delete s2.pending[k]
            }
            const prevCb = action._response_callback, prevOn = action._onResponse
            action._response_callback = (answer) => {
                if (answer && typeof answer === 'object') answer._cellViewVer = ver
                done()
                if (typeof prevCb === 'function') prevCb(answer)
            }
            action._onResponse = (a) => {
                done()
                if (a === null && keys.includes(WIDGET._cellViewWait)) WIDGET._cellViewWait = ''
                if (typeof prevOn === 'function') prevOn(a)
            }
            return true
        },
        // ответ select_cell_views (updateDoc с set_value record._doc.cell_views): слияние по пути строки в ячейки-даты (utils/cellViewsMerge), без замены
        // записи и без полной перерисовки (content_Changed); ответ устаревшей версии основного ответа — отброшен. false — не ответ видов ячеек
        cellView_takeAnswer(WIDGET, action) {
            const store = this
            if (!WIDGET || !action || 'record' in action || 'updates' in action) return false
            const a = cellViews_answerOf(action)
            if (!a) return false
            const st = store.cellView_state(WIDGET)
            const clearWait = () => { const w = WIDGET._cellViewWait; if (w && !(st && st.pending[w] === st.ver)) WIDGET._cellViewWait = '' }
            if (!cellViews_deferredOn((k, d) => store.setting(k, d))) { clearWait(); return true }
            if (action._cellViewVer !== undefined && st && action._cellViewVer !== st.ver) {
                if (!store.hide_console) console.log(`cell views answer dropped: main response version ${st.ver}, request ${action._cellViewVer}`)
                clearWait()
                return true
            }
            const doc = toRaw(WIDGET.record?._doc)
            if (!doc || !Array.isArray(doc.data)) { clearWait(); return true }
            const cv = (doc.cell_views && typeof doc.cell_views === 'object') ? doc.cell_views : (doc.cell_views = {})
            let applied = 0
            const dropped = []
            for (const view of Object.keys(a.views)) {
                const r = mergeCellViews(doc.data, a.views[view], { rows: a.stats.rows })
                if (typeof r === 'number') {
                    applied += r
                    cv[view] = a.views[view]
                    if (cellView_key(view) !== view) cv[cellView_key(view)] = a.views[view]
                } else dropped.push(`${view}: ${r.reason}${r.path ? ' ' + r.path : ''}`)
            }
            const paletteNew = !!(a.stats.palette && typeof a.stats.palette === 'object' && !Array.isArray(a.stats.palette) && Object.keys(a.stats.palette).length)
            if (paletteNew) doc.cell_views_palette = a.stats.palette   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe): палитра статусов бэка — замена при каждом ответе, где она есть (utils/cellViews cellView_paletteOf)
            doc.cell_views_stats_deferred = a.stats   // основная статистика (_doc.cell_views_stats основного ответа) не перетирается
            for (const r of a.rest) store.set_value(WIDGET, r.binding, r.value)
            if (dropped.length) console.warn('cell views dropped:', dropped.join('; '))
            if (a.partial) {
                WIDGET._cellViewNote = 'partial'
                const seq = WIDGET._cellViewNoteSeq = (WIDGET._cellViewNoteSeq || 0) + 1
                setTimeout(() => { if (WIDGET._cellViewNoteSeq === seq) WIDGET._cellViewNote = '' }, store.setting('fe.ux.cellViewsNoteMs', 8000))
            }
            clearWait()
            window.__cellView = window.__cellView || { calc: 0, scale: 0 }
            window.__cellView.merged = (window.__cellView.merged || 0) + applied
            window.__cellView.dropped = (window.__cellView.dropped || 0) + dropped.length
            if (applied || paletteNew) store.cellView_refreshGrids(WIDGET, true)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe): новая палитра — перекраска
            if (!store.hide_console) console.log(`cell views merged: ${applied} cells${dropped.length ? `, dropped ${dropped.length}` : ''}${a.partial ? ' (partial)' : ''}`)
            return true
        },
        // новый основной ответ (запись целиком): версия растёт (кеш слоёв грида сбрасывает load_data); активный вид без данных — немедленный запрос
        cellView_afterDoc(WIDGET) {
            if (!WIDGET) return
            this.cellView_state(WIDGET)
            if (WIDGET._cellViewNote) WIDGET._cellViewNote = ''
            const k = cellView_activeOf(WIDGET)
            if (!k) { if (WIDGET._cellViewWait) WIDGET._cellViewWait = ''; return }
            if (!this.cellView_requestNow(WIDGET, k) && WIDGET._cellViewWait && !this.optionGroup_dataInFlight(WIDGET)) {
                const st = this.cellView_state(WIDGET)
                if (!(st && st.pending[WIDGET._cellViewWait] === st.ver)) WIDGET._cellViewWait = ''
            }
        },
        // кнопка группы в шапке — состояние на месте (панель перерисовать: после reload её объекты отделены от groupMenu)
        optionGroup_button(WIDGET, group, on) {
            for (const b of this.optionGroup_panelButtons(WIDGET)) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення): и кнопки в панели над таблицей (place 'panel')
                if (b?.method === 'toggle_option_group' && String(b.params?.group || '').trim() === group) b.active = on
            }
            try { WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.() } catch (e) { /* шапку перерисует ответ */ }
        },
        // идёт запрос ДАННЫХ виджета (select / reload — в т.ч. сам reload групп и select его цепочки); save и прочие методы не считаются
        optionGroup_dataInFlight(WIDGET) {
            const rq = WIDGET?._activeRequest
            return !!rq && rq.readyState !== 4 && rq.readyState !== 0 && ['select', 'reload'].includes(WIDGET._activeMethod)
        },
        // сбросить ожидание ответа по данным: abort на фронте + del_last_backend_action бэку (widget_stopLoading, тихо)
        optionGroup_abortWait(WIDGET) {
            if (!this.optionGroup_dataInFlight(WIDGET)) return false
            this.widget_stopLoading(WIDGET, { quiet: true })
            return true
        },
        // отправка после паузы: желаемое состояние — поверх записи (её мог заменить чужой ответ), отличий от применённого нет — запроса нет
        optionGroup_send(WIDGET) {
            const store = this, vueObj = WIDGET?.vueObj
            if (!WIDGET || WIDGET.close || !vueObj) return
            const want = WIDGET._ogWant || {}
            const params = WIDGET.record?.doc?.params
            if (!params) { delete WIDGET._ogWant; return }
            const base = store.optionGroup_base(WIDGET)
            const rows = params.option_groups = Array.isArray(params.option_groups) ? params.option_groups : []
            const changes = []
            for (const [g, on] of Object.entries(want)) {
                let row = rows.find(r => String(r?.title || '').trim() === g)
                if (!row) { row = { use: false, title: g }; rows.push(row) }
                row.use = on
                if (!!base.state[g] !== on) changes.push(`${g}:${on ? 'on' : 'off'}`)
            }
            const seq = WIDGET._ogSeq
            if (!changes.length) {
                delete WIDGET._ogWant
                if (!store.hide_console) console.log(`option groups: generation ${seq} is back to the applied set — no request`)
                return
            }
            const action = { command: 'executeWidgetMethod', method: 'reload', record_sendToBackend_exclude: ['_doc'], _unsaved_ok: true, _doc_take_from_front: true, _ogSeq: seq,
                action_name: 'action-front-optionGroups-2026-09-24',
                _onResponse: (answer) => {
                    if (WIDGET._ogSeq !== seq) return   // с тех пор переключали ещё — судьбу набора решит следующий запрос
                    if (!answer) { store.optionGroup_revert(WIDGET, 'backend error'); return }
                    delete WIDGET._ogWant
                    WIDGET._ogBase = null   // применённое состояние — из записи ответа (снимок возьмётся заново)
                } }
            if (!store.hide_console) console.log(`option groups reload #${seq}: ${changes.join(', ')}`)
            store.executeStoreMethod(vueObj, action)
        },
        // reload групп оборван НЕ новым кликом (Stop, чужой запрос виджета): желаемое не применится — вернуть набор к применённому
        optionGroup_aborted(WIDGET, action) {
            if (!WIDGET || action?._ogSeq == null || WIDGET._ogSeq !== action._ogSeq) return
            this.optionGroup_revert(WIDGET, 'request aborted')
        },
        optionGroup_revert(WIDGET, why) {
            const store = this, want = WIDGET._ogWant
            if (!want || !Object.keys(want).length) return false
            const base = store.optionGroup_base(WIDGET)
            const rows = Array.isArray(WIDGET.record?.doc?.params?.option_groups) ? WIDGET.record.doc.params.option_groups : []
            const grid = store.optionGroup_grid(WIDGET)
            for (const g of Object.keys(want)) {
                const on = !!base.state[g]
                const row = rows.find(r => String(r?.title || '').trim() === g)
                if (row) row.use = on
                store.optionGroup_button(WIDGET, g, on)
                if (grid && !store.optionGroup_isColumns(WIDGET, g) && grid.optionGroup_hasRows(g)) { try { grid.optionGroup_apply(g, on) } catch (e) { /* строк нет */ } }
            }
            delete WIDGET._ogWant
            if (!store.hide_console) console.log(`option groups: reload cancelled (${why}) — the set is back to the applied state`)
            return true
        },
        multiply_selector(WIDGET, opts = {}) {
            const store = this
            const m = store.headerSel_of(WIDGET)   // IE 2026 09 15: тираж или настройка selector_header
            const WORKSPACE = store.WORKSPACES[WIDGET?.workspace]
            const params = WORKSPACE?.record?.doc?.params
            if (!m?.values?.length || !params) return
            const fields = (m.selectorFields && m.selectorFields.length) ? m.selectorFields : [m.values[0].source || m.values[0].binding]
            const vals = m.values.filter(v => fields.includes(v.source || v.binding) && v.value !== undefined && v.value !== null && v.value !== '')
            if (!vals.length) return
            const srcW = { widget: m.settings?.widget || WIDGET.widget, record: { segment: 'WIDGET-LIST' } }
            for (const v of vals) {
                const binding = v.source || v.binding
                const fieldSelector = { binding, leftValue: { value: binding, valueStr: v.fieldTitle || binding, attr_type: 'AttrLink', component: 'AttrLink', valueStr_fix: true }, attr_type: 'AttrLink', relation_segment: v.relation_segment || '' }   // заголовок чипса — название поля списка
                const row = store.get_rowWHERE(srcW, params, fieldSelector)
                if (!Array.isArray(row.attrs)) row.attrs = []
                if (row.use === false) row.attrs.length = 0   // выключенная строка — прежние значения не поднимать
                const idx = row.attrs.findIndex(a => a?.rightValue?.value === v.value)
                const attr = { use: true, rightValue: { value: v.value, valueStr: v.title || String(v.value), attr_type: 'AttrLink', relation_segment: v.relation_segment || row.rightValue?.relation_segment || '' } }
                if (opts.set) { row.attrs.splice(0, row.attrs.length, attr); row.use = true }
                else if (idx >= 0) { row.attrs.splice(idx, 1); row.use = row.attrs.length > 0 }
                else { row.attrs.push(attr); row.use = true }
            }
            store.update_CHIPS_from_WHERE?.(params)
            store.workspace_applySelector(WIDGET.workspace, WIDGET.page, WIDGET)
        },
        multiply_chips(PAGE) {
            const chips = []
            for (const st of Object.values(PAGE._multiply || {})) {
                const perPage = this.multiply_perPage(st), total = st.items.length
                if (total <= perPage) continue
                const pages = Math.ceil(total / perPage), from = st.pageNo * perPage + 1, to = Math.min(total, (st.pageNo + 1) * perPage)
                chips.push({ key: st.key, title: st.baseTitle, from, to, total, pageNo: st.pageNo, pages, tooltip: t('{title}: widgets {from}–{to} of {total}', { title: st.baseTitle, from, to, total }) })   // IE 2026 09 23 / ODOO-341407: i18n
            }
            PAGE._multiplyChips = chips
        },
        multiply_nav(key, dir) {
            const store = this
            const PAGE = store.activeWORKSPACE?.activePAGE
            const st = PAGE?._multiply?.[key]
            if (!st) return
            const pages = Math.max(1, Math.ceil(st.items.length / store.multiply_perPage(st)))
            const next = Math.min(pages - 1, Math.max(0, (st.pageNo || 0) + dir))
            if (next === st.pageNo) return
            st.pageNo = next
            store.multiply_apply(st)
        },
        multiply_refresh(workspace, page) {
            const store = this
            const PAGE = store.WORKSPACES[workspace]?.PAGES?.[page]
            if (!PAGE?._multiply || !Object.keys(PAGE._multiply).length) return
            clearTimeout(PAGE._multiplyTimer)
            PAGE._multiplyTimer = setTimeout(async () => {
                for (const st of Object.values(PAGE._multiply)) {
                    if (st.loading) continue   // первый проход ещё идёт (активация страницы сразу за открытием) — он и покажет экземпляры
                    const epoch = st.epoch = (st.epoch || 0) + 1
                    const items = await store.multiply_fetchItems(st)
                    if (PAGE._multiply[st.key]?.epoch !== epoch) continue
                    const same = items.length === st.items.length && items.every((it, i) => it.ikey === st.items[i].ikey && it.title === st.items[i].title)
                    if (same) continue
                    st.items = items
                    store.multiply_apply(st)
                }
            }, 400)
        },

        // подменю «Page» (п.3.2): user_defaults_save / page_defaults_save / workspace_defaults_save
        // IE 2026 09 22 / ODOO-… (заказ Игоря): личные пометки в панелях функций — избранные виджеты страницы (открываются при открытии
        // страницы вместо набора по умолчанию), избранные страницы стола (рейл показывает только их), страница по умолчанию стола.
        // Хранение — личные умолчания USER.doc.pages (user_defaults_save: fav_widgets / fav_pages / default_page / reset_default_page),
        // на фронте — store.user_defaults.pages (ответ сохранения кладётся туда же, _favEpoch перечитывает computed)
        favorites_wsRow(workspace) {
            void this._favEpoch
            const rows = this.user_defaults?.pages || []
            return rows.find(r => r && (r.node?.value || r.workspace) === workspace && r.use !== false) || null
        },
        favorites_pageRow(workspace, page) {
            const ws = this.favorites_wsRow(workspace)
            return (ws?.attrs || []).find(r => r && (r.node?.value || r.page) === page && r.use !== false) || null
        },
        favorites_pages(workspace) { return (this.favorites_wsRow(workspace)?.favorites || []).map(String) },
        favorites_widgets(workspace, page) { return (this.favorites_pageRow(workspace, page)?.favorites || []).map(String) },
        favorites_defaultPage(workspace) {
            const ws = this.favorites_wsRow(workspace)
            const r = (ws?.attrs || []).find(r => r && r.onOpening && r.use !== false)
            return r ? String(r.node?.value || r.page || '') : ''
        },
        favorites_save(params, cb) {
            const store = this
            store.executeBackendMethod({}, { method: 'user_defaults_save', params }, (answer) => {
                if (answer?.status === 'ok' && Array.isArray(answer.pages)) {
                    store.user_defaults = { ...(store.user_defaults || {}), pages: answer.pages }
                    store._favEpoch = (store._favEpoch || 0) + 1
                }
                cb?.(answer)
            })
        },
        favorites_toggleWidget(workspace, page, widgetId, on) {
            const id = String(widgetId || ''); if (!id) return
            const cur = this.favorites_widgets(workspace, page).filter(x => x !== id)
            this.favorites_save({ workspace, page, fav_widgets: on ? [...cur, id] : cur })
        },
        favorites_togglePage(workspace, page, on) {
            const id = String(page || ''); if (!id) return
            const cur = this.favorites_pages(workspace).filter(x => x !== id)
            this.favorites_save({ workspace, fav_pages: on ? [...cur, id] : cur })
        },
        favorites_setDefaultPage(workspace, page, on) {
            this.favorites_save(on ? { workspace, page, default_page: true } : { workspace, reset_default_page: true })
        },
        // IE 2026 09 22 / ODOO-… (уточнение Игоря): набор открытия страницы — ОТДЕЛЬНАЯ пометка (звезда = только избранное): личный набор opens
        // (null — нет: действуют умолчания страницы onOpening; [] — не открывать ничего); первое изменение фиксирует набор целиком
        favorites_opens(workspace, page) {
            const r = this.favorites_pageRow(workspace, page)
            return Array.isArray(r?.opens) ? r.opens.map(String) : null
        },
        page_openIds(PAGE) {   // виджеты, открываемые по умолчанию (строки страницы с onOpening; группы раскрываются)
            const out = []
            const walk = (rows) => { for (const r of rows || []) { if (!r || r.use === false) continue; const id = r.widget || (r.node?.relation_segment ? r.node?.value : null); if (id && r.onOpening) out.push(String(id)); if (r.attrs) walk(r.attrs) } }
            walk(PAGE?.attrs)
            return out
        },
        page_openSet(workspace, page) {   // действующий набор: { ids, custom } — личный, иначе умолчания страницы
            const own = this.favorites_opens(workspace, page)
            if (own) return { ids: own, custom: true }
            return { ids: this.page_openIds(this.WORKSPACES?.[workspace]?.PAGES?.[page]), custom: false }
        },
        favorites_toggleOpen(workspace, page, widgetId, on) {
            const id = String(widgetId || ''); if (!id) return
            const cur = this.page_openSet(workspace, page).ids.filter(x => x !== id)
            this.favorites_save({ workspace, page, open_widgets: on ? [...cur, id] : cur })
        },
        favorites_resetOpens(workspace, page) { this.favorites_save({ workspace, page, reset_open_widgets: true }) },
        // IE 2026 09 23 / ODOO-… (заказ Игоря: «добавь нумерацию пейджев, как на скрине 2» — те же номера в панели страниц): ОДНО правило состава
        // и сквозной нумерации рейла страниц — для рейла (Page.vue railRows) и для бейджей панели страниц в шапке (AppTopbar pagesPanelItems →
        // MenuPanel num). Строки: { kind: 'group', key, title, tooltip, badge, pages } — без номера, и { kind: 'page', PAGE, grouped, num }.
        // Страницы — избранные стола + текущая (fe.ux.favoritesRail), без пометок — все; порядок по PAGE.ind; свёртка групп на номер не влияет
        // (строки свёрнутой группы прячет сам рейл). page — текущая страница (у рейла своя: экземпляры страниц живут в KeepAlive), по умолчанию —
        // активная страница стола.
        // IE 2026 09 23 / ODOO-… (заказ Игоря: «в форме-меню не во всех страничках вижу нумерацию; ожидаю, что она будет соответствовать номерам слева в списке
        // страниц»): номер страницы = её место в ПОЛНОМ списке страниц стола (pageRail_numbers: все PAGES по ind, группы не считаются), а НЕ позиция
        // в отфильтрованном рейле — раньше у неизбранных страниц номера не было вовсе, а номера остальных плыли от того, какая страница текущая.
        // Строки отфильтрованного рейла несут «полный» номер (пропуски ожидаемы), pageRail_num отдаёт номер ЛЮБОЙ странице стола: номер одной
        // страницы одинаков в рейле и в панели и не меняется при переходах и звёздах
        pageRail_numbers(workspace) {
            const WS = this.WORKSPACES?.[workspace]
            const all = Object.values(WS?.PAGES || {}).filter(P => P).sort((a, b) => (a.ind ?? 0) - (b.ind ?? 0))
            const byPage = new Map(), byId = new Map()
            all.forEach((P, i) => { byPage.set(P, i + 1); byId.set(String(P.node?.value), i + 1) })
            return { all, byPage, byId }
        },
        pageRail_rows(workspace, page) {
            void this._favEpoch
            const WS = this.WORKSPACES?.[workspace]
            const cur = page ?? WS?.active_page
            const favs = this.favorites_pages(workspace)
            const favSet = favs.length && this.setting('fe.ux.favoritesRail', true) !== false ? new Set(favs) : null
            const { all, byPage } = this.pageRail_numbers(workspace)
            // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 1): служебная плитка «+» (page-new — бэк дописывает её последней строкой pages) в рейле ВСЕГДА: при звёздах она
            // выпадала вместе с неизбранными страницами (замер dev02: избранные в памяти — 5 строк рейла, «+» нет)
            const pages = all.filter(P => !favSet || favSet.has(String(P.node?.value)) || P.node?.value === cur || P.node?.value === 'page-new')
            const rows = []
            let hdr = null
            for (const PAGE of pages) {
                const g = PAGE.group, num = byPage.get(PAGE)
                if (g?.key) {
                    if (!hdr || hdr.key !== g.key) { hdr = { kind: 'group', key: g.key, title: g.title || g.key, tooltip: g.tooltip || '', badge: 0, pages: 0 }; rows.push(hdr) }
                    hdr.pages++
                    if (typeof PAGE.badge === 'number' && PAGE.badge > 0) hdr.badge += PAGE.badge
                    rows.push({ kind: 'page', PAGE, grouped: true, num })
                } else {
                    hdr = null
                    rows.push({ kind: 'page', PAGE, grouped: false, num })
                }
            }
            return rows
        },
        pageRail_num(workspace, pageId) {   // номер страницы в полном списке страниц стола либо null — такой страницы у стола нет
            const id = String(pageId ?? '')
            if (!id) return null
            return this.pageRail_numbers(workspace).byId.get(id) ?? null
        },
        // IE 2026 09 25 / ODOO-… (заказ Игоря: бейдж открытых страниц у стола): ОТКРЫТЫЕ страницы стола — для бейджа строки списка столов (RailMenu.wsBadge)
        // и строки «Open pages» её подсказки (utils/tipActions.workspaceTip_fn). Одно понятие «открыт» с бейджем плитки рейла страниц (Page.vue pageBadge →
        // page_openWidgets): виджет открыт, когда он в ALL_WIDGETS стола, не закрыт (close) и не закрыт мягко ✕ / Esc (_softClosed — остаётся в
        // ALL_WIDGETS до 5 минут ради Alt+Esc; скрытое открытие _hiddenOpen — тоже _softClosed); тем же правилом виджеты страницы считает сам стол
        // (workspace_activate, clientTest_pageWidgets). Страница открыта, если у неё есть хотя бы один открытый виджет ЛИБО она — активная страница
        // АКТИВНОГО стола (открыта и без виджетов). Стол, не открывавшийся в сеансе (нет WORKSPACES[ws]), — пусто. Порядок — как в рейле (PAGE.ind).
        // Реактивно: читает ALL_WIDGETS / флаги виджетов / activeWORKSPACE.active_page — рендер RailMenu пересчитывается при открытии / закрытии
        // виджетов и смене страницы / стола. Выключатель fe.ux.workspaceOpenPagesBadge (по умолчанию включено).
        page_openWidgets(workspace, pageId) {
            const WS = this.WORKSPACES?.[workspace]
            return (WS?.ALL_WIDGETS || []).filter(w => w && w.page === pageId && !w.close && !w._softClosed)
        },
        workspaceOpenPages(workspace) {
            const WS = this.WORKSPACES?.[workspace]
            if (!WS) return []
            const open = new Set()
            for (const w of (WS.ALL_WIDGETS || [])) if (w && w.page && !w.close && !w._softClosed) open.add(String(w.page))
            const cur = this.activeWORKSPACE
            if (cur && (cur === WS || cur.workspace === workspace) && WS.active_page) open.add(String(WS.active_page))
            if (!open.size) return []
            return this.pageRail_numbers(workspace).all.filter(P => open.has(String(P.node?.value)))
        },
        workspaceOpenPages_on() { return this.setting('fe.ux.workspaceOpenPagesBadge', true) !== false },
        // IE 2026 09 22 / ODOO-… (заказ Игоря): избранные команды меню пользователя / ≡ виджета / ≡ таблицы — строка '@menus' личных умолчаний
        // (menus: { 'user' | 'widget:<сегмент>' | 'grid:<сегмент>' | 'page': [ключ команды] }); ключ команды — действие шапки / command / method / значение узла / название
        menuFav_key(raw) {
            if (!raw) return ''
            if (raw._rightAction) return 'right:' + String(raw._rightAction.action || raw._rightAction.label || '')
            // IE 2026 09 23 / ODOO-341407: i18n — _key: английский ключ папки/пункта, чей title переведён (ключ избранного не зависит от языка; для en совпадает с прежним)
            return String(raw.command || raw.method || raw.node?.value || raw.name || raw._key || raw.titleAction || raw.title || raw.tooltip || '')
        },
        menuFav_list(kind) {
            void this._favEpoch
            const row = (this.user_defaults?.pages || []).find(r => r && r.node?.value === '@menus')
            return ((row?.menus || {})[kind] || []).map(String)
        },
        menuFav_has(kind, raw) {
            const k = this.menuFav_key(raw)
            return k ? this.menuFav_list(kind).includes(k) : null
        },
        menuFav_toggle(kind, raw, on) {
            const k = this.menuFav_key(raw); if (!k || !kind) return
            const cur = this.menuFav_list(kind).filter(x => x !== k)
            this.favorites_save({ fav_menu: { key: kind, items: on ? [...cur, k] : cur } })
        },
        // ===== IE 2026 09 28 / ODOO-342342 (Use cases): «Бизнес-кейсы» — связка стора с utils/guidePlay.js / guidePersonal.js (логика и юнит-тесты — там).
        // Методы бэка — widget_USE_CASE через executeWidgetMethod (guideApi_send); «Open in demo», шаги пути, «Back to the case», «Restore my filters»;
        // личные отметки — оптимистично с откатом. Компоненты: components_core/AttrUseCaseMenu.vue (вкладка Contents), components/GuideBar.vue (полоса)
        guide_ctx(vueObj = null) {
            const store = this
            return {
                vueObj, t,
                notify: (text, status = 'info') => store.show_notification({ text, status }),
                confirm: (text) => store.guide_confirm(text),   // IE 2026 09 28 / ODOO-342342 (ревью З6): диалог платформы, не window.confirm
                setPos: (path, step) => store.guide_mark('pos', path, step),
                getControl: (el) => wjcCore.Control.getControl(el),   // IE 2026 10 08 / ODOO-343435: Wijmo-контрол по хосту DOM — грид цели тура в production (там нет __vueParentComponent), utils/guideTarget.js
            }
        },
        // IE 2026 09 28 / ODOO-342342 (ревью З6): вопрос показа (смена процессной модели) — диалогом платформы (ConfirmDialog в App.vue): окно не блокируется,
        // кнопки платформы. Промис: Yes — true; No, ✕, Esc — false. Диалога ещё нет (App не смонтирован) — window.confirm, как раньше
        guide_confirm(text) {
            const store = this
            const $c = store.App?.$confirm
            if (!$c || typeof $c.require !== 'function') {
                try { return Promise.resolve(!!window.confirm(text)) } catch (e) { return Promise.resolve(false) }
            }
            return new Promise((resolve) => {
                let done = false
                const fin = (v) => { if (!done) { done = true; resolve(v) } }
                try {
                    $c.require({ message: text, header: t('Open in demo'), icon: 'pi pi-question-circle', acceptLabel: t('Yes'), rejectLabel: t('No'),
                        accept: () => fin(true), reject: () => fin(false), onHide: () => fin(false) })
                } catch (e) { fin(false) }
            })
        },
        guide_play(vueObj, params) {
            // IE 2026 09 28 / ODOO-342342 (ревью З8): показ уже открывается — повторный запуск (двойной клик по кнопке бэка) не начинаем; отменить — ✕ полосы
            if (guidePlay_busy(this)) { guideCases_count('busySkipped'); return Promise.resolve({ ok: false, status: 'busy' }) }
            return guidePlay_start(this, params || {}, this.guide_ctx(vueObj))
        },
        guide_step(dir) { return guidePlay_step(this, dir, this.guide_ctx(null)) },
        guide_jump(n) { return guidePlay_jump(this, n, this.guide_ctx(null)) },
        guide_back() { return guidePlay_back(this, this.guide_ctx(null)) },
        guide_end() { return guidePlay_end(this) },
        guide_cta(item) { return guidePlay_cta(this, item, this.guide_ctx(null)) },   // IE 2026 09 30 / ODOO-343435: кнопка cta полосы тура
        guide_current() { return guidePlay_current(this.guideSession) },
        guide_backups() { void this.guideBackups; void this.guideSession; return guideBackup_list(this) },
        guide_restoreFilters(workspace = null) {
            const n = guideBackup_restore(this, workspace)
            this.guideBackups = { ...(this.guideBackups || {}) }   // реактивность списка копий (кнопки «Restore my filters»)
            if (n) this.show_notification({ text: t('Your filters are back') })
            return n
        },
        guide_send(method, params, recordId) { return guideApi_send(this, method, params || {}, { recordId }) },
        guide_marks() { return this.guide_marksEnsure() },   // IE 2026 09 28 / ODOO-342342 (Н1): + слой local из браузера
        // IE 2026 09 28 / ODOO-342342 (слово координатора: роль «только чтение», Odoo 342781 — позже): ЕДИНСТВЕННАЯ точка, через которую уходят личные отметки
        // (избранное / пройдено / место в пути) и их снимок. Сейчас — методы бэка (строка @guide в USER.doc.pages); хранение только в браузере — подмена
        // транспорта здесь одним флагом, остальной код (utils/guidePersonal.js, форма-меню, полоса) о месте хранения не знает
        guide_personalSend(recordId) {
            const store = this
            // IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Н1): тихо — бэк не принял отметку (роль «только чтение», фильтр учётки показа): без тоста
            // «Backend error» / ошибки бэка; значение остаётся в браузере (guidePersonal.personal_set → guide_localSave)
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — методы записи отметок (toggle_favorite / set_passed / set_position) на бэк не шлём (он ответил бы 403): «нет ответа» =
            // «не принято бэком», значение клика остаётся в браузере (слой local, guide_localSave), молча; get_personal (чтение, у роли пустое) идёт как обычно
            return (method, params) => (store.readonly_on() && method !== 'get_personal')
                ? Promise.resolve(null)
                : guideApi_send(store, method, params, { recordId, quiet: true })
        },
        // IE 2026 09 28 / ODOO-342342 (Н1): слой личных отметок, не принятых бэком, — в localStorage (по пользователю и базе); поднимается при первом обращении
        guide_localKey() {
            const u = this.user?.id || this.user?.email || 'user', db = this.user?.database?.dbid || ''
            return `guideMarksLocal:${u}:${db}`
        },
        guide_localSave(local) {
            try {
                const empty = !local || ['fav', 'done', 'pos'].every(k => !local[k] || !Object.keys(local[k]).length)
                if (empty) localStorage.removeItem(this.guide_localKey())
                else localStorage.setItem(this.guide_localKey(), JSON.stringify(ro_localEpochStamp(local, this.readonly_localEpoch())))   // IE 2026 09 29 / ODOO-342781: роль — отметки с «эпохой» копии (fe.guide.local_epoch); без роли / без эпохи — как было
            } catch (e) { /* хранилище недоступно — слой живёт в памяти */ }
        },
        guide_marksEnsure() {
            const store = this
            const m = marks_ensure(store)
            const key = store.guide_localKey()
            if (m._localKey !== key) {
                m._localKey = key
                let data = null
                try { data = JSON.parse(localStorage.getItem(key) || 'null') } catch (e) { data = null }
                data = ro_localEpochFilter(data, store.readonly_localEpoch())   // IE 2026 09 29 / ODOO-342781: роль — отметки прежней эпохи копии (сброс Demo) не поднимаем; без роли / без эпохи — как было
                marks_localLoad(m, data)
            }
            return m
        },
        // kind: fav | done | pos; id — кейс / путь (у pos — путь); от его имени идёт метод
        guide_mark(kind, id, value) {
            const store = this
            // IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Н1): не принятое бэком — в браузер (guide_localSave), молча
            const p = personal_set(store.guide_marksEnsure(), kind, id, value, store.guide_personalSend(id),
                { t, saveLocal: (local) => store.guide_localSave(local) })
            store.guide_syncPersonal(id)   // значение клика уже стоит (до ответа) — кнопки формы кейса (v-if по _doc.personal) переключаются сразу
            return p.then((r) => { store.guide_syncPersonal(id); return r })
        },
        // открытые формы кейса с этим id — их _doc.personal (fav / done / pos) по личным отметкам: кнопки командной панели бэка и вкладка My progress
        guide_syncPersonal(id) {
            const store = this, m = store.guideMarks, key = String(id || '')
            if (!m || !key) return
            for (const WS of Object.values(store.WORKSPACES || {})) {
                for (const W of (WS?.ALL_WIDGETS || [])) {
                    if (!W || W.close || W.widget_class !== 'widget_USE_CASE' || String(W.record?.id || '') !== key || !W.record) continue
                    const next = marks_recordPersonal(m, key, W.record._doc?.personal)   // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): тот же итог, что при приходе записи (guide_personalTake)
                    if (!next) continue
                    store.set_value(W.record, '_doc.personal', next, null, null, null, false)   // личное — не правка записи (без _meta.modified)
                    try { W.attrs_vueObj?.WIDGET?.set_commandPanel?.() } catch (e) { /* панель обновится со следующим content_Changed */ }
                    try { W.vueObj?.content_Changed?.() } catch (e) { /* no-op */ }
                }
            }
        },
        // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): запись формы кейса пришла с бэка (открытие, перечитывание) — её _doc.personal (снимок бэка) в слой base,
        // а в _doc.personal — итог слоёв, как у навигатора: клики сеанса → браузер (Н1: не принятое бэком) → бэк. Кнопки шапки ★ / «Mark as done» (v-if бэка по
        // _doc.personal) показывают то же, что навигатор, и после перезагрузки — при любой открытой вкладке формы. Панель и содержимое формы строит вызывающий
        // (ответ widget_open / updateWIDGET / updateDoc). fe.guide.cases выключен — кнопки идут в бэк напрямую, запись не трогаем
        guide_personalTake(WIDGET) {
            const store = this, rec = WIDGET?.record
            const cur = rec?._doc?.personal
            if (!rec || WIDGET.widget_class !== 'widget_USE_CASE' || !rec.id || !cur || typeof cur !== 'object') return false
            try { if (!guideCases_on(store)) return false } catch (e) { return false }
            const m = store.guide_marksEnsure()
            marks_applyRecord(m, rec.id, cur)
            const next = marks_recordPersonal(m, rec.id, cur)
            if (!next) return false
            rec._doc.personal = next   // личное — не правка записи: без set_value и _meta.modified; форму по записи строит вызывающий
            return true
        },
        guide_marksLoad(ids = null, recordId = '') {
            const store = this
            return personal_load(store.guide_marksEnsure(), store.guide_personalSend(recordId || (ids && ids[0]) || ''), ids)   // IE 2026 09 28 / ODOO-342342 (Н1)
        },
        guide_copyLink(id) {
            const store = this
            const url = guideCases_link(store, id)
            if (!url) return false
            try {
                navigator.clipboard.writeText(url)
                    .then(() => store.show_notification({ text: t('Copied to clipboard!') }))
                    .catch(err => store.show_notification({ text: t('Failed to copy to clipboard: {error}', { error: err.message }), status: 'error' }))
            } catch (e) { store.show_notification({ text: t('Failed to copy to clipboard: {error}', { error: String(e) }), status: 'error' }) }
            return url
        },
        defaults_save(action) {
            const store = this
            if (store.readonly_deny(action?.backend_command || 'user_defaults_save')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — умолчания стола / страницы не сохраняем
            const WORKSPACE = store.activeWORKSPACE
            if (!WORKSPACE) return
            const workspace = WORKSPACE.workspace
            const page = WORKSPACE.active_page

            const params = { workspace }
            if (action.withPage) {
                params.page = page
            }
            if (action.withWidgets) {
                params.widgets = store.get_pageWidgets_layout(workspace, page)
            }
            if (action.reset_widgets) {
                params.reset_widgets = true
            }
            if (action.withWhere) {
                // снапшот чипсов целиком, без фильтрации служебных строк (calc, calc::* …)
                // IE 2026 09 24 / ODOO-341407: без служебных ключей локализации бэка (`_i18n`, `valueStr_en` …) — в USER.doc.pages /
                // WORKSPACE.doc.params.WHERE уходит английская база (копия; строки стола в памяти остаются локализованными)
                params.where = i18n_strip_service_keys(WORKSPACE.record?.doc?.params?.WHERE ?? [])
            }
            if (action.reset_where) {
                params.reset_where = true
            }
            // IE 2026 08 26 / ODOO-5800: явное «сохранить/сбросить фильтры» главнее локального
            // снимка чипсов (chipsKeep) — иначе «Use workspace default filters» тут же перекрывался снимком
            if (action.withWhere || action.reset_where) store.chipsKeep_clear(workspace)
            if (action.default_page) {
                params.default_page = true
            }
            if (action.default_workspace) {
                params.default_workspace = true
            }
            // IE 2026 09 04 / ODOO-5828 (заказ Игоря): «Save as new page» — имя новой страницы спрашиваем,
            // по умолчанию «<название текущей> (copy)»; отмена диалога — ничего не сохраняем
            if (action.ask_title) {
                const curRow = (WORKSPACE.record?.doc?.pages || []).find(p => p?.node?.value === page)
                const curTitle = curRow?.node?.valueStr || ''
                const def = curTitle ? t('{title} (copy)', { title: curTitle }) : t('New page')   // IE 2026 09 23 / ODOO-341407: i18n
                const title = window.prompt(t('New page title'), def)
                if (title === null) return
                params.title = (title || '').trim() || def
            }

            // method, НЕ command: executeBackendMethod кладёт action поверх
            // payload'а — action.command перетирал command:'executeBackendMethod',
            // бек получал неизвестную команду и молча не сохранял дефолты
            store.executeBackendMethod({}, { method: action.backend_command, params }, (answer) => {
                // page_defaults_save: страница склонирована (принадлежала другому
                // workspace) — вернулся новый id, перечитать workspace
                if (answer?.status === 'ok' && answer.page && answer.page !== page) {
                    store.wsReopen_mark(workspace)   // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): страницы из кэша KeepAlive — заново
                    delete store.WORKSPACES[workspace]
                    store.activeWORKSPACE = null
                    store.workspace_open(workspace, answer.page)
                } else if (answer?.status === 'ok' && action.reset_where) {
                    // вернуть на экран чипсы записи workspace
                    store.wsReopen_mark(workspace)   // IE 2026 09 26 / ODOO-…: та же страница — с новым номером в ключе она создаётся заново и активируется
                    delete store.WORKSPACES[workspace]
                    store.activeWORKSPACE = null
                    store.workspace_open(workspace, page)
                }
            })
        },

        calc_widget_position(workspace, page) {
            const store = this,
                staticMenuActive = !(this.staticMenuInactive && this.layoutMode === 'static'),
                left = staticMenuActive ? '170px' : ''
            let WORKSPACE = store.WORKSPACES[workspace]
            let PAGE = WORKSPACE.PAGES[page]
            let WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === page)


            if (WIDGETS.length === 1) {
                WIDGETS[0].style = `
                    position: absolute;
                    top: calc(42px);
                    height: calc(-42px + 100%);
                    left: calc(0px);
                    width: calc(100%);
                    margin: 0.5rem;
                `
            } else if (WIDGETS.length === 2) {
                1
            }
            // for (let i=0; i<WIDGETS.length; i++) {

            // }
        },
        findWidget(widget_id, workspace='', page='', callID=0) {
            const store = this
            let result = null
            if (callID > 10) {
                if (!this.hide_console) console.log(12)
            }

            if (widget_id in store.WIDGETS) {
                // WIDGET.workspace === 'workspace-store'
                return { workspace: null, page: null, ind: null, WIDGET: store.WIDGETS[widget_id] }
            } else if (workspace === 'workspace-store') {
                1 // pass
            } else if (!workspace) {
                if (widget_id in store.WORKSPACES) {
                    return { workspace: null, page: null, ind: null, WIDGET: store.WORKSPACES[widget_id] }
                } 
                if (store.activeWORKSPACE) {
                    workspace = store.activeWORKSPACE.workspace
                    page = store.activeWORKSPACE.active_page
                    
                    result = store.findWidget(widget_id, workspace, page, ++callID)
                    if (result.WIDGET) { 
                        return result
                    }
                    
                    result = store.findWidget(widget_id, workspace)
                    if (result.WIDGET) { 
                        return result
                    }

                    for (workspace in store.WORKSPACES) {
                        result = store.findWidget(widget_id, workspace)
                        if (result.WIDGET) { 
                            return result
                        }
                    }
                }
            } else if (!page) {
                // стол мог быть пересоздан (смена процессной модели) — его уже нет в сторе
                const WORKSPACE = store.WORKSPACES[workspace]
                const ind = (WORKSPACE?.ALL_WIDGETS ?? []).findIndex(w => w.id === widget_id)
                if (ind !== -1) {
                    const W = WORKSPACE.ALL_WIDGETS[ind]
                    return { workspace, page: W.page, ind, WIDGET: W }
                }
            } else {
                const WORKSPACE = store.WORKSPACES[workspace]
                const ind = (WORKSPACE?.ALL_WIDGETS ?? []).findIndex(w => w.id === widget_id && w.page === page)
                if (ind !== -1) {
                    const W = WORKSPACE.ALL_WIDGETS[ind]
                    return { workspace, page: W.page, ind, WIDGET: W }
                }
            }

            return { workspace: null, page: null, ind: null, WIDGET: null }
        },
        // IE 2026 08 18 / ODOO-5555: расшифровка в указанный виджет — хелперы
        drilldown_findOpen(widget_id) {
            // открытый на АКТИВНОЙ странице виджет с данным id (тот же критерий,
            // что у findWidget_byProps: widget/record.id), не soft-closed
            const WORKSPACE = this.activeWORKSPACE
            const PAGE = WORKSPACE?.activePAGE
            if (!WORKSPACE || !PAGE) return null
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)
            for (let i = WIDGETS.length - 1; i >= 0; i--) {
                const w = WIDGETS[i]
                if (w.close || w._softClosed) continue
                if (w.widget === widget_id || w.record?.id === widget_id) return w
            }
            return null
        },
        drilldown_hasOpenTargets(WIDGET) {
            // есть ли на странице открытые цели с refresh для этого отчёта
            const rows = WIDGET?.record?.doc?.params?.drilldown_widgets
            if (!Array.isArray(rows) || !rows.length) return false
            for (const r of rows) {
                if (!r || r.use === false || !r.refresh) continue
                const wid = (r.widget && typeof r.widget === 'object') ? r.widget.value : r.widget
                if (wid && this.drilldown_findOpen(wid)) return true
            }
            return false
        },
        drilldown_applyToWidget(target, fieldsMapping, drilldown, activate) {
            // фильтры ячейки -> doc.params.WHERE цели: строки прежней расшифровки
            // (fieldsMapping:true) заменяем, собственные фильтры виджета не трогаем —
            // как processing_fieldsMapping на бэке для привязок WHERE; затем select
            const store = this
            const rows = (fieldsMapping || []).find(fm => (fm?.attr?.binding || fm?.leftValue) === 'doc.params.WHERE')
            const where_new = rows?.attr?.value ?? rows?.rightValue?.value ?? rows?.rightValue
            if (!target?.record?.doc) return
            target.record.doc.params = target.record.doc.params || {}
            const own = (target.record.doc.params.WHERE || []).filter(r => !r?.fieldsMapping)
            const mapped = Array.isArray(where_new) ? where_new.map(r => ({ ...r, use: true, fieldsMapping: true })) : []
            target.record.doc.params.WHERE = [...own, ...mapped]
            // IE 2026 08 19 / ODOO-5512 (заказ Игоря): период расшифровки — период отчёта
            // цели (колонки дат только за расшифровываемый период); хранится в виджете
            // и уходит с каждым select (бэк применяет на запрос, в запись не пишет)
            target.drilldown_period = drilldown?.period || null
            target._drilldown_where_key = drilldown?.where_key
            target._drilldown_source = drilldown?.source_widget_id
            if (activate) store.widget_activate(target, 'drilldown_applyToWidget', true, false)
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): «классическая» связь — линия от
            // строки-источника к виджету и область ячеек в чипе шапки
            store.drilldown_link(target, drilldown?.source_widget_id)
            if (target.vueObj) {
                // drilldown_cache — бэк материализует источники цели в кэш (быстрый повтор)
                store.executeStoreMethod(target.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'], drilldown_cache: true, drilldown_period: target.drilldown_period || null })
            }
        },
        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): рект «четверть экрана в углу напротив
        // ячейки-источника» — общий для виджета ячейки (расшифровка) и виджета строки.
        // Якорь — выделенная ячейка грида родителя (нет — контейнер родителя)
        quarterRect_oppositeCell(parent_vueObj, WIDGET) {
            const store = this
            let right = true, bottom = true
            try {
                const gridV = parent_vueObj?.get_vueObj?.('_doc.data')
                const flex = gridV?.flex
                const sel = flex?.selection
                const cell = (sel && sel.row >= 0 && sel.col >= 0) ? flex.cells.getCellElement(sel.row, sel.col) : null
                const el = cell || document.getElementById('WIDGET' + (parent_vueObj?.WIDGET?.id ?? ''))
                const PAGE0 = store.WORKSPACES[WIDGET.workspace]?.PAGES?.[WIDGET.page]
                const ps = store.getPAGE_size(PAGE0)
                const rc = el?.getBoundingClientRect?.()
                if (rc && rc.width) {
                    const cx = rc.left + rc.width / 2, cy = rc.top + rc.height / 2
                    right = cx < ps.page_left + ps.page_width / 2   // ячейка слева → окно справа
                    bottom = cy < ps.page_top + ps.page_height / 2  // ячейка сверху → окно снизу
                }
            } catch (e) { /* без геометрии — правый нижний угол */ }
            return { width_pct: .5, height_pct: .5, left_pct: right ? .5 : 0, top_pct: bottom ? .5 : 0 }
        },
        drilldown_link(target, source_widget_id) {
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): связь расшифровочного виджета с
            // ЯЧЕЙКАМИ-источником — как у виджета строки: пунктирная линия от строки
            // (якорь — заголовок строки, как nodeRow) к виджету и подпись области
            // ячеек в чипе шапки: Cells[30:21] или Cells[30:21-33:25] (номера строк/
            // колонок как в шапке грида). Перевешивается при смене выделения
            const store = this
            if (!target || source_widget_id == null) return
            const src = store.findWidget(source_widget_id)?.WIDGET
            const gridV = src?.vueObj?.get_vueObj?.('_doc.data')
            const flex = gridV?.flex
            if (!flex) return
            const sel = flex.selection
            if (!sel || sel.row < 0 || sel.col < 0) return
            const r1 = Math.min(sel.row, sel.row2), r2 = Math.max(sel.row, sel.row2)
            const c1 = Math.min(sel.col, sel.col2), c2 = Math.max(sel.col, sel.col2)
            target._dd_label = (r1 === r2 && c1 === c2) ? `${r1 + 1}:${c1 + 1}` : `${r1 + 1}:${c1 + 1}-${r2 + 1}:${c2 + 1}`
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): НЕСОХРАНЁННЫЕ правки ячеек-
            // источника видны в расшифровке — информационный чипс над таблицей цели
            // (жёлтый, pi-pencil) со списком: строка · колонка : было → стало
            try {
                const colIdx = new Map()
                flex.columns.forEach((c, i) => { if (c.binding) colIdx.set(c.binding, i) })
                const cellText = (i, c) => { const el = flex.cells.getCellElement(i, c); return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : '' }
                const rowTitle = (i) => {   // IE 2026 09 23 / ODOO-341407: i18n (локальная t → txt)
                    let txt = ''
                    for (let c = 0; c < Math.min(6, flex.columns.length) && !txt; c++) txt = cellText(i, c)
                    return txt || t('row {n}', { n: i + 1 })
                }
                const colTitle = (ci) => {
                    const col = flex.columns[ci]
                    const b = String(col?.binding || '')
                    const m = /^(\d{4}-\d{2}-\d{2})/.exec(b)
                    return m ? m[1] : (col?.header || b)
                }
                const fmt = (v) => (v === null || v === undefined || v === '' || (typeof v === 'number' && Number.isNaN(v))) ? '—' : (typeof v === 'number' ? store.formatCount(v) : String(v))
                const rows = []
                for (const [k, rs] of Object.entries(gridV.changesStack || {})) {
                    const p = k.indexOf(':'); if (p < 0) continue
                    const ir = +k.slice(0, p), b = k.slice(p + 1)
                    const ci = colIdx.get(b)
                    if (ci == null || ir < r1 || ir > r2 || ci < c1 || ci > c2) continue
                    if (rs.method && rs.method !== 'val' && rs.method !== 'aggEdit') continue
                    rows.push([`${rowTitle(ir)} · ${colTitle(ci)}`, `${fmt(rs.val)} → ${fmt(rs.newVal)}${(rs.indirect || rs.related) && !rs.user ? ' ' + t('(linked)') : ''}`])
                }
                target._dd_info_chips = rows.length ? [{
                    title: t('Unsaved edits: {n}', { n: rows.length }), pi: 'pi-pencil', cssClass: 'chip-unsaved-edits',
                    tooltip: [[t('Source'), src.record?.title || src.title || ''], ...rows.slice(0, 40)],
                    _dd: true,
                }] : []
            } catch (e) { target._dd_info_chips = [] }

            const WORKSPACE = store.WORKSPACES[target.workspace]
            const PAGE = WORKSPACE?.PAGES?.[target.page]
            if (!PAGE?.vueObj || !src.nodes_svg) return
            // прежний якорь (другая ячейка) — снять
            if (target._dd_node_key) {
                if (PAGE.nodes_svg?.[target._dd_node_key]) PAGE.vueObj.removeNode(target._dd_node_key)
                if (target._dd_item?._fe?.['@@dd_node']?.key === target._dd_node_key) delete target._dd_item._fe['@@dd_node']
                target._dd_node_key = null; target._dd_item = null
            }
            const item = flex.rows[r1]?.dataItem
            if (!item) return
            const node_key1 = `${src.id}-dd-${target.id}`
            // IE 2026 08 19 (заказ Игоря): якорь — САМА ЯЧЕЙКА (строка × колонка), а не
            // заголовок строки; formatItem грида перевешивает node.div на элемент ячейки
            // при перерисовке/прокрутке (ключ в _fe['@@dd_node'] строки + binding колонки)
            if (!item._fe) item._fe = {}
            const cellBinding = flex.columns[c1]?.binding || ''
            item._fe['@@dd_node'] = { key: node_key1, binding: cellBinding }
            const node1 = PAGE.nodes_svg[node_key1] = src.nodes_svg[node_key1] = {
                type: 'nodeCell', key: node_key1, widget_id: src.id, WIDGET: src, edges_svg: {},
                binding: cellBinding, row: r1, col: c1, join: 'top-left',
                div: (() => { try { return flex.cells.getCellElement(r1, c1) || null } catch (e) { return null } })(),
            }
            const node_key2 = '' + target.id
            target.nodes_svg = target.nodes_svg || {}
            let node2 = PAGE.nodes_svg[node_key2]
            if (!node2) {
                node2 = PAGE.nodes_svg[node_key2] = target.nodes_svg[node_key2] = {
                    key: node_key2, widget_id: target.id, WIDGET: target,
                    div: document.getElementById('WIDGET' + target.id), join: 'widget', edges_svg: {},
                }
            } else if (!node2.div) {
                node2.div = document.getElementById('WIDGET' + target.id)
            }
            const edge_key = node_key1 + ';' + node_key2
            const edge = PAGE.edges_svg[edge_key] = { type: 'edgeWidgetRow', key: edge_key, source_key: node_key1, target_key: node_key2 }
            node1.edges_svg[edge_key] = edge
            node2.edges_svg[edge_key] = edge
            target._dd_node_key = node_key1
            target._dd_item = item
            // строка-источник перерисуется — заголовок строки станет якорем линии
            try { flex.refreshCells(false, true) } catch (e) { /* noop */ }
            PAGE.vueObj.refreshe_svg?.()
        },
        findWidget_byProps(WIDGET) { // props, widget
            const store = this

            if (WIDGET.widget === 'widget-list') return null
            if (WIDGET.widget === 'widget-row') return null
            if (WIDGET.record?.audit_id) return null
            
            if (store.activeWORKSPACE) {
                const WORKSPACE = store.activeWORKSPACE
                const PAGE = WORKSPACE.activePAGE
                const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)

                for (let i = WIDGETS.length - 1; i >= 0; i--) {
                    let exsistWIDGET = WIDGETS[i]
                    if (WIDGET.widget !== exsistWIDGET.widget) continue
                    if (chipWidget_skipSubstituted(WIDGET, exsistWIDGET)) continue   // IE 2026 10 08 / ODOO-5800: явное открытие — окно с подменённой «Я»/«Всі» записью не переиспользовать (utils/chipWidgetOpen)
                    if ((WIDGET.record?.id || false) && WIDGET.record?.id !== exsistWIDGET.record?.id) continue
                    if ((WIDGET.record?.segment || false) && WIDGET.record?.segment !== exsistWIDGET.record?.segment) continue
                    // IE 2026 09 15 / ODOO-… (заказ Игоря): экземпляры тиража одного виджета различаются ключом строки-источника
                    if ((WIDGET.multiply_key || '') !== (exsistWIDGET.multiply_key || '')) continue
                    // IE 2026 08 23 / ODOO-5884 (заказ Игоря): тот же id в ДРУГОЙ версии — отдельный виджет. Только для явного
                    // открытия слоя: строка списка «Record versions» (record._meta.version === '*') или рабочая версия из
                    // бейджа COW (working_version). Обычное открытие ссылки версией не различаем (как раньше)
                    const _exactVer = WIDGET.record?._meta?.version === '*' || !!WIDGET.parentAction?.params?.working_version
                    if (_exactVer) {
                        if ((WIDGET.record?.version || '') !== (exsistWIDGET.record?.version || '')) continue
                        if (!!WIDGET.parentAction?.params?.working_version !== !!exsistWIDGET.parentAction?.params?.working_version) continue
                    }

                    // && JSON.stringify(exsistWIDGET.props) === JSON.stringify(WIDGET.props)
                    return exsistWIDGET
                }
            }
            return null
        },
        concat_params(params_in = {}, source = {}, sourceName = '', params_excluding = []) {
            let params = { ...params_in }
            if (source.params) {
                for (let param in source.params) {
                    if (!params_excluding.includes(param)) {
                        params[param] = source.params[param]
                    }
                }
            }
            return params
        },
        attr_activate(payload) {
            const { event, widget_id, attr } = payload;
            const store = this
            if (store.attr_active) {
                store.unsetActiveEl(store.attr_activeEl)
            }
            store.attr_active = attr;
            store.attr_activeEl = store.attr_findClosestWidgetEl(event)
            store.setActiveEl(store.attr_activeEl)

            const WIDGET = store.findWidget(widget_id).WIDGET

            store.widget_open({
                workspace: WIDGET.workspace,
                page: WIDGET.page,
                area: 'right-area',
                widget_class: 'widget_Attr',
                parentWIDGET: { id: WIDGET.id, title: WIDGET.title },
                parentAction: { 'action_name':'action-front-6', method: 'store.attr_activate' },
                cssClassW: 'widget-w4',
                record: attr,
            })

            // if (!this.hide_console) console.log('################# attr_activate ')
        },
        attr_dragStart(payload) {
            const { event, widget_id, attr } = payload;
            const store = this
            store.attr_activate(payload)
            store.attr_dragged = attr;
            event.dataTransfer.effectAllowed = 'move';
            store.setDragSourceEl(store.attr_findClosestWidgetEl(event))
            // if (!this.hide_console) console.log('################# attr_dragStart ')
        },
        attr_dragOver(payload) {
            // if (!this.hide_console) console.log('################# attr_dragOver')
            const { event } = payload;
            const store = this
            const attr_widget = store.attr_findClosestWidgetEl(event);
            const dragTarget = store.attr_findDragTargetEl();
            if (attr_widget !== dragTarget) {
                store.unsetDragTargetEl(dragTarget);
            }
            const dragSource = store.attr_findDragSourceEl();
            if (dragSource && attr_widget !== dragSource) {
                event.preventDefault();
                event.dataTransfer.dropEffect = 'move';
                store.setDragTargetEl(attr_widget);
            }
        },
        attr_dragFinish(payload) {
            // if (!this.hide_console) console.log('################# attr_dragFinish')
            const { event, widget_id, attr } = payload;
            const store = this
            const dragSource = store.attr_findDragSourceEl();
            const dragTarget = store.attr_findDragTargetEl();
            if (dragSource && dragTarget) {
                event.preventDefault();
                const WIDGET = store.findWidget(widget_id).WIDGET
                const sourceIndex = store.attrs_find(WIDGET.view, store.attr_dragged)
                const targetIndex = store.attrs_find(WIDGET.view, attr)
                if (store.swapOnDragAndDrop) {
                    // store.WORKSPACES[sourceIndex.workspace].PAGES[sourceIndex.page].WIDGETS.splice(sourceIndex.ind, 1, targetIndex.WIDGET);
                    // store.WORKSPACES[targetIndex.workspace].PAGES[targetIndex.page].WIDGETS.splice(targetIndex.ind, 1, sourceIndex.WIDGET);
                } else {
                    sourceIndex.attrs.splice(sourceIndex.ind, 1);
                    targetIndex.attrs.splice(targetIndex.ind, 0, store.attr_dragged);
                }
                wjcCore.Control.invalidateAll(); // invalidate Wijmo controls after layout updates
            }
        },
        attr_dragEnd() {
            // if (!this.hide_console) console.log('################# attr_dragEnd')
            const store = this
            store.unsetDragSourceEl(store.attr_findDragSourceEl());
            store.unsetDragTargetEl(store.attr_findDragTargetEl());
        },
        attrs_find(attrs, attr) {
            const store = this
            for (let ind in attrs) {
                if (attrs[ind] === attr) {
                    return { attrs: attrs, ind: ind }
                }
            }
            for (let ind in attrs) {
                if (attrs[ind].attrs) {
                    let res = store.attrs_find(attrs[ind].attrs, attr)
                    if (res) {
                        return res
                    }
                }
            }
        },
        JSON_sort(content1) {
            if (this.isinstance_dict(content1)) {
                let content_template_start = {
                    id: '',
                    title: '',
                    header: '',
                    widget_class: '',
                    page: '',
                    component: '',
                    class: '',
                    segment: '',
                    attr_type: '',
                    parentType: '',
                    parentWIDGET: '',
                    parentAction: '',
    
                    params: '',
                    workspace: '',
                    record: '',
                    doc: '',
    
                    action: '',
                    dateDoc: '',
                    number: '',
                    version: '',
                    status: '',
                    date: '',
                    date_cor: '',
                    period_from: '',
                    period_to: '',
                    object: '',
                    subject: '',
                    subject_cor: '',
    
                    quantity: '',
                    price: '',
                    amount: '',
    
                    order: '',
                    archived: '',
                    comment: '',
    
                    keys: '',
                    attr: '',
                    dataSource: '',
                    query_text: '',
                }
                let content_template_end = {
                    workgroup: '',
                    changes_info: '',
                    source_info: '',
                    groupMenu: '',
                }
    
                let content_template_expert = {
                    META_params: '',
                }
    
                let content2 = {}
                try {
                    for (let key in content_template_start) {
                        if (key in content1) {
                            content2[key] = content1[key]
                        }
                    }
                    for (let key in content1) {
                        if (!(key in content_template_start || key in content_template_end || key in content_template_expert)) {
                            content2[key] = content1[key]
                        }
                    }
                    for (let key in content_template_end) {
                        if (key in content1) {
                            content2[key] = content1[key]
                        }
                    }
                } catch (error) {
                    store.TERMINAL(null, null, {text:error, status:'error'})
                }

                return content2
            } else {
                return content1
            }
        },
        str_toJSON(WIDGET, str, format='') {
            const store = this
            let json = {}
            if (format === '') {
                const JSON5 = require('json5')
                
                str = str.replace(/True/g, 'true').replace(/'/g, '"')
                str = str.replace(/False/g, 'false').replace(/'/g, '"')

                // del comments
                str = this.removeComments(str)

                // // Removing extra commas
                // str = str.replace(/,(\s*[}\]])/g, '$1')

                try {
                    json = JSON5.parse(`{${str}}`)
                    // json = JSON.parse(`{${str}}`)
                } catch (e) {
                    store.TERMINAL(WIDGET, null, {header: t('Error parsing JSON: {error}', { error: e }), text:`{${str}}`, status:'error'})   // IE 2026 09 23 / ODOO-341407: i18n
                }
                
            } else if (format === 'cell') {
                // str = 'Date:2023-02;Sum forecast:0;'

                const pairs = str.split(';')
                pairs.forEach(pair => {
                    const [key, value] = pair.split(':')

                    if (key) {
                        const cleanKey = key.trim()
                        const cleanValue = value.trim()

                        json[cleanKey] = cleanValue
                    }
                })
            }
            return json
        },
        removeComments(str) {
            // str = str.replace(/#.*$/gm, '')
            str = str.replace(/(^|\s)#.*$/gm, (match, p1) => {
              const preMatch = str.substring(0, match.index).split('\n').pop();
              if (preMatch.includes('"') && !preMatch.split('"').pop().includes('"')) {
                return match
              }
              return p1
            });
          
            str = str.replace(/(?<=\s)#.*$/gm, '')

            str = str.replace(/\/\/.*$/gm, '')

            return str
        },
        columns_set(flex, grid_data, columns) {
            flex.columns.clear()
            if (columns) {
                for (let attr of columns) {
                    if (attr.visible !== false) {
                        let c = new wjGrid.Column();
                        c.binding = attr.binding;
                        c.header = attr.title;
                        c.width = attr.width;
                        c.cssClass = attr.cssClass
                        flex.columns.push(c);
                    }
                }
            } else if (grid_data.length) {
                flex.autoGenerateColumns = true
            } else {
                let c = new wjGrid.Column();
                c.binding = 'title';
                c.header = t('Title');   // IE 2026 09 23 / ODOO-341407: i18n
                c.width = '*';
                flex.columns.push(c);
            }
        },
        scan_element(content_grid, from) {
            const store = this
            for (let key in from) {
                if (from[key] instanceof Object) {
                    let data2 = []
                    store.scan_element(data2, from[key])
                    content_grid.push({ key: key, value: JSON.stringify(from[key]), children_nodes: data2 })
                } else {
                    content_grid.push({ key: key, value: from[key] })
                }
            }
        },
        // INFO-лист выгрузки XLSX: паспорт отчёта (кто/когда/откуда сформировал,
        // параметры виджета, фильтры стола, ссылка для открытия отчёта в WebSCM)
        xlsx_infoSheet(WIDGET, opts = {}) {   // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): opts.hidden — что стало со скрытыми строками / колонками
            const store = this
            const sheet = new wjcXlsx.WorkSheet()
            sheet.name = 'INFO'
            // rows/columns у wijmo — getter-only (assignment в strict-бандле кидает):
            // наполняем существующие массивы через push
            sheet.columns.push(
                Object.assign(new wjcXlsx.WorkbookColumn(), { width: 200 }),
                Object.assign(new wjcXlsx.WorkbookColumn(), { width: 480 }),
            )
            const rows = sheet.rows
            const addRow = (label, value, opts = {}) => {
                const r = new wjcXlsx.WorkbookRow()
                const c1 = new wjcXlsx.WorkbookCell()
                c1.value = label
                c1.style = Object.assign(new wjcXlsx.WorkbookStyle(), {
                    font: Object.assign(new wjcXlsx.WorkbookFont(), { bold: !!opts.header || !!opts.label, size: opts.size || 11, color: opts.label ? '#607d8b' : undefined }),
                    fill: opts.header ? Object.assign(new wjcXlsx.WorkbookFill(), { color: '#eceff1' }) : undefined,
                })
                r.cells.push(c1)
                if (value !== undefined) {
                    const c2 = new wjcXlsx.WorkbookCell()
                    c2.value = value == null ? '' : String(value)
                    // wijmo пишет Target гиперссылки в *.rels БЕЗ экранирования —
                    // сырой '&' ломает XML, Excel открывает файл только «с починкой»
                    // и выбрасывает ссылку. Экранируем сами (значение ячейки не трогаем)
                    if (opts.link) c2.link = opts.link.replace(/&/g, '&amp;')
                    c2.style = Object.assign(new wjcXlsx.WorkbookStyle(), {
                        font: Object.assign(new wjcXlsx.WorkbookFont(), { color: opts.link ? '#1565c0' : undefined, underline: !!opts.link }),
                    })
                    r.cells.push(c2)
                } else if (opts.header) {
                    const c2 = new wjcXlsx.WorkbookCell()
                    c2.value = ''
                    c2.style = c1.style
                    r.cells.push(c2)
                }
                rows.push(r)
            }
            const blank = () => { rows.push(new wjcXlsx.WorkbookRow()) }

            const rec = WIDGET?.record || {}
            const ws = store.WORKSPACES[WIDGET?.workspace]
            const pm = store.process_model_record || {}
            const dbid = store.user?.database?.dbid || ''

            // IE 2026 09 23 / ODOO-341407: i18n (подписи паспорта листа INFO)
            addRow(t('Report'), rec.title || WIDGET?.title || '', { header: true, size: 14 })
            blank()
            addRow(t('Generated at'), new Date().toLocaleString('sv-SE'), { label: true })
            addRow(t('Generated by'), `${store.user?.title || store.user?.id || ''}${store.user?.email ? ' (' + store.user.email + ')' : ''}`, { label: true })
            addRow(t('Database'), store.user?.database?.title || dbid, { label: true })
            addRow(t('Process model'), `${pm.title || ''} (${pm.id || ''})`, { label: true })
            addRow(t('Workspace'), `${ws?.record?.title || ''} (${WIDGET?.workspace || ''})`, { label: true })
            addRow(t('Page'), WIDGET?.page || '', { label: true })
            addRow(t('Widget'), `${rec.id || ''}${rec.segment ? ' / ' + rec.segment : ''}${rec.version ? ' / ' + rec.version : ''}`, { label: true })
            // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): по умолчанию скрытые строки (чипсы, свёрнутые группы) и колонки в файл не идут — паспорт говорит об этом явно
            if (opts.hidden) {
                const _h = { rows: opts.hidden.rows || 0, cols: opts.hidden.cols || 0 }
                addRow(t('Hidden rows and columns'), opts.hidden.included ? t('included ({rows} rows, {cols} columns hidden)', _h) : t('not exported ({rows} rows, {cols} columns hidden)', _h), { label: true })
            }
            blank()
            const _pmPart = pm.id ? `process_model=${pm.id}&` : ''
            // фильтры стола зашиваются в ссылку (без служебных hidden/calc-строк):
            // открытие по ссылке восстановит те же чипсы → тот же отчёт
            const _wherePart = store.where_linkParam(WIDGET?.workspace)
            const _url = `${window.location.origin}${window.location.pathname}#/${dbid}?${_pmPart}workspace=${WIDGET?.workspace || ''}&page=${WIDGET?.page || ''}`
                + (rec._meta?.action_id ? `&action=${rec._meta.action_id}` : '') + _wherePart
            addRow(t('Open in WebSCM'), _url, { label: true, link: _url })
            blank()

            // параметры виджета: скалярные значения doc.params (объекты/массивы и
            // служебные ключи пропускаем — это паспорт, а не дамп)
            const params = rec.doc?.params || {}
            const scalar = Object.entries(params).filter(([k, v]) =>
                !k.startsWith('_') && v !== '' && v != null
                && (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean')
                && String(v).length <= 200)
            if (scalar.length) {
                addRow(t('Widget parameters'), undefined, { header: true })
                for (const [k, v] of scalar.slice(0, 60)) addRow(k, v, { label: true })
                blank()
            }

            // фильтры стола (чипсы): читаемые строки как в тултипе чипса
            const WHERE = ws?.record?.doc?.params?.WHERE || []
            const chipRows = []
            for (const row of WHERE) {
                if (row?.use === false || row?.hidden) continue
                const lv = row?.leftValue?.valueStr || row?.leftValue?.value
                if (!lv) continue
                const vals = []
                const resolve = (V) => (V?.relation_segment && store.itemsSource[V.relation_segment]?.ids?.[V.value]?.title) || V?.title || V?.valueStr || V?.value
                if (row.rightValue?.value || row.rightValue?.valueStr) vals.push(resolve(row.rightValue))
                for (const r of row.attrs || []) if (r?.rightValue?.value || r?.rightValue?.valueStr) vals.push(resolve(r.rightValue))
                if (vals.length) chipRows.push([`${lv} ${row.condition || ''}`.trim(), vals.join(', ')])
            }
            if (chipRows.length) {
                addRow(t('Workspace filters'), undefined, { header: true })
                for (const [k, v] of chipRows) addRow(k, v, { label: true })
            }
            return sheet
        },
        sync_sequence_id(record_id, sequence_id, except_record=null) {
            if (!record_id || !sequence_id) return
            for (const WS of Object.values(this.WORKSPACES || {})) {
                for (const W of WS.ALL_WIDGETS || []) {
                    const r = W.record
                    if (!r || r === except_record || r.id !== record_id) continue
                    // копию с несохранёнными правками не трогаем: пусть честно
                    // получит конфликт, и пользователь решит, что делать
                    if (r._meta?.modified) continue
                    if (r.sequence_id !== sequence_id) r.sequence_id = sequence_id
                }
            }
        },
        sync_moved_records(rows) {
            // IE 2026 09 25 / ODOO-341407 (решение Игоря, вариант A): перенос в дереве настроек (бэк move_record) пишет parent / order
            // перенесённой записи и перенумерованным соседям — у каждой новая версия. Открытые копии этих записей, совпадавшие с базой
            // до переноса (sequence_id === seq_before), получают новые parent / order / sequence_id / updated_at: перенос менял только
            // эти поля, поэтому и несохранённые правки формы остаются в силе. Иначе следующий Save вернул бы старые parent / order
            // (кэш бэка) или упёрся бы в «changed by another user». Копия, отстававшая от базы ещё до переноса, не трогается
            if (!Array.isArray(rows) || !rows.length) return
            const byId = new Map(rows.filter(x => x?.id).map(x => [x.id, x]))
            for (const WS of Object.values(this.WORKSPACES || {})) {
                for (const W of WS.ALL_WIDGETS || []) {
                    const r = W.record
                    const m = r?.id ? byId.get(r.id) : null
                    if (!m || (m.segment && r.segment && m.segment !== r.segment)) continue
                    if (r.sequence_id !== m.seq_before) continue
                    r.parent = m.parent || ''
                    r.order = m.order
                    r.sequence_id = m.sequence_id
                    if (m.updated_at) r.updated_at = m.updated_at
                }
            }
        },
        async saveRecord(vueObj, record, action, params = {}, FRONTEND_start=null, saveAttempt = 0) {   // IE 2026 10 13 / ODOO-5800: saveAttempt — номер повтора после обрезанного тела / обрыва сети
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this, WIDGET = vueObj.WIDGET
            if (store.readonly_deny('saveRecord')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — сохранение не шлём (тост), состояние виджета не трогаем
            // эфемерная визуальная таблица печати (_doc.printTemplate): слить
            // отложенный write-back в канон doc.printTemplate ДО отправки
            // (сохраняется только канон, _doc исключён из send)
            for (const _mvt of Object.values(WIDGET?._mvtObjs || {})) {
                if (_mvt?._printTpl_wbT) _mvt.printTpl_writeBack?.()
            }
            // let workspace_record = store.activeWORKSPACE.record

            const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            if (WIDGET.record && WORKSPACE.record && WIDGET.record.id === WORKSPACE.record.id) {
                WORKSPACE.record = WIDGET.record
            }

            WIDGET.loading = true;
            WIDGET.notification = WIDGET.notification || {}
            store.notification_softClear(WIDGET)

            params.update = params.update || false
            params.row = params.row || null
            params.closeAfterSave = params.closeAfterSave || false
            params.reloadAfterSave = params.reloadAfterSave || false
            params.content_reloadAfterSave = params.content_reloadAfterSave || false

            let widget_to_transfer = {
                title: WIDGET.title,
                id: WIDGET.id,
                widget: WIDGET.widget,
                widget_class: WIDGET.widget_class,
                parentAction: WIDGET.parentAction,
            }

            let record_to_transfer
            if (Array.isArray(record)) {
                record_to_transfer = record.map(r => store.get_record_to_transfer(vueObj, r, action))
            } else {
                record_to_transfer = store.get_record_to_transfer(vueObj, record, action)
            }
            this.remove_keys_in_place(record_to_transfer, ['_widget', '_quantity_map', '_fe']) // , '_meta' LOOK , _meta.iroot, modified
            // IE 2026 09 20 / ODOO-5800 (Igor через ie-dm7 #32448: команда «открыть список правил» блока RULES формы ячейки): чипс «правила ячейки» (meta._cellRules) живёт только в памяти вкладки —
            // в сохраняемую запись не едет (копия по пути doc.viewParams.<грид>.CHIPS, сама запись на фронте не меняется)
            record_to_transfer = Array.isArray(record_to_transfer) ? record_to_transfer.map(r => cellRulesChip_strip(r)) : cellRulesChip_strip(record_to_transfer)
            // IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): оверлей WHERE «Show in list» (params.WHERE, строка _lhOverlay) живёт в памяти вкладки — в сохраняемую запись не едет (копия, запись в памяти цела)
            record_to_transfer = Array.isArray(record_to_transfer) ? record_to_transfer.map(r => listHistoryDs_overlayStripRecord(r)) : listHistoryDs_overlayStripRecord(record_to_transfer)
            // IE 2026 09 24 / ODOO-341407: служебные ключи локализации (`_i18n`, `<key>_en`) в базу не едут — копия с английской базой
            record_to_transfer = i18n_strip_service_keys(record_to_transfer)

            // IE 2026 10 13 / ODOO-5800: один повтор того же сейва через 2 с (обрезанное тело — бэк запрос не обработал; обрыв сети); флаг fe.ux.saveTruncatedRetry
            const _retryOn = saveTruncatedRetry_on((k, d) => store.setting(k, d))   // IE 2026 10 13 / ODOO-5800
            const _saveRetry = (text) => {   // IE 2026 10 13 / ODOO-5800
                store.TERMINAL(WIDGET, null, { text: t('Not saved') + (text ? ': ' + text : '') + '. ' + t('Retrying in 2 s…'), status: 'warning' })   // IE 2026 10 13 / ODOO-5800
                setTimeout(() => { if (!WIDGET.close) store.saveRecord(vueObj, record, action, params, null, saveAttempt + 1) }, SAVE_RETRY_DELAY_MS)   // IE 2026 10 13 / ODOO-5800
            }
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'saveRecord',
                    // IE 2026 08 24 / ODOO-5884 (заказ Игоря): контекст для авто-пересчёта по изменению
                    // данных (workspace/process_model — версия и стол запуска; autoRecalc — клиентский
                    // выключатель, дефолты ВКЛ)
                    workspace: WIDGET.workspace || store.activeWORKSPACE?.workspace || '',
                    process_model: store.process_model_record?.id || '',
                    autoRecalc: { ...store.autoRecalc },
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    record: record_to_transfer,
                    WIDGET: widget_to_transfer,
                    ...params,
                    user: store.user,
                    // workspace_record: workspace_record, // look widget_FORECAST.beforeSave(...)
                    action_from_frontend: true,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    // async: false,

                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        if (WIDGET.close) { return }            
                        const notification_frontend = null // {
                        //     text: (WIDGET?.title || '') + ', saveRecord time: ' + Math.round(performance.now() - vueObj.time) / 1000,
                        //     status: 'info',
                        // }
                        store.TERMINAL(WIDGET, answer, notification_frontend, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (!store.check_loginAfterAjax(vueObj, answer)) return
                        // сейв отклонён (конфликт версий и т.п.) — правки НЕ сохранены:
                        // не гасим _meta.modified, иначе жёлтая Save исчезает и запись
                        // выглядит сохранённой (реальный случай «changed by another user»)
                        // IE 2026 10 13 / ODOO-5800: и уведомление critical без id (исключение бэка до записи, прежний ответ на обрезанное тело) — тоже не сохранено
                        const _so = saveOutcome_answer(answer, { on: _retryOn, attempt: saveAttempt })   // IE 2026 10 13 / ODOO-5800
                        if (!_so.saved) {
                            WIDGET.loading = false
                            if (_so.retry) _saveRetry(_so.text)   // IE 2026 10 13 / ODOO-5800
                            return
                        }
                        try { recordHelp.onSaved(record) } catch (e) { /* кэш объяснений вспомогательный */ }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: сохранён элемент RECORD-HELP — объяснение цели перечитается
                        if (!Array.isArray(record) && !params.multi) {
                            record._meta = record._meta || {}
                            delete record._meta.new
                            delete record._meta.modified
                            delete record._meta.dublicate
                            
                            if (answer.id) {
                                if (params.row && params.row.id !== answer.id) {
                                    params.row.id = answer.id
                                }
                                if (record.id !== answer.id) {
                                    record.id = answer.id
                                }
                                if (record.sequence_id !== answer.sequence_id) {
                                    record.sequence_id = answer.sequence_id
                                }
                                // та же запись может быть открыта в других виджетах
                                // (форма + список): копиям БЕЗ несохранённых правок
                                // раздаём новый sequence_id — иначе их следующий сейв
                                // ловит ложный «changed by another user» (сам на себя)
                                store.sync_sequence_id(answer.id, answer.sequence_id, record)
                                if (answer.segment && answer.title) {
                                    store.refresh_itemsSource(answer.segment, { id: answer.id, title: answer.title })
                                }
                            }
                            if (answer.action_id) {
                                record._meta.action_id = answer.action_id
                            }
                            if (answer.updated_at) {
                                record.updated_at = answer.updated_at
                            }
                            // IE 2026 09 25 / ODOO-341407 (вариант A): место записи в дереве (parent / order) — как записал бэк: новой записи
                            // order = max+1 среди соседей назначает бэк; без этого следующий Save той же формы вернул бы прежний order
                            if (answer.id && 'order' in answer && record.id === answer.id) {
                                record.order = answer.order
                                if ('parent' in answer) record.parent = answer.parent || ''
                            }
                            if (answer.parents_tree) {
                                WIDGET.parents_tree = answer.parents_tree
                            }
                            if (Array.isArray(answer.variants_tree)) {
                                WIDGET.variants_tree = answer.variants_tree // IE 2026 09 04 / ODOO-336331
                            }
                            // IE 2026 09 04 / ODOO-336331: метка шапки «· variant: …» приходит с ответом сохранения —
                            // select после reloadAfterSave блок initialize не проходит, без этого метка ждала полной перезагрузки
                            if ('variant_label' in answer && (WIDGET.record === record || WIDGET.record?.id === record.id)) {
                                WIDGET.variant_label = answer.variant_label || ''
                                WIDGET.variant_main = answer.variant_main || null
                            }
                            // IE 2026 09 11 / ODOO-335246 (Igor): запись-узел каскада сохранена — индикатор в чипе сегмента (шапка)
                            // и вкладка узла обновляются из ответа сразу (узел помечен грязным бэком); гаснет по штампу опроса
                            if (answer.cascade_ind && typeof answer.cascade_ind === 'object' && (WIDGET.record === record || WIDGET.record?.id === record.id)) {
                                if (!record._doc) record._doc = {}
                                for (const [k, v] of Object.entries(answer.cascade_ind)) record._doc[k] = v
                                WIDGET.vueObj?.$forceUpdate?.()
                            }
                        }

                        WIDGET.loading = false;
                        if (params.closeAfterSave) {
                            store.widget_close(vueObj.widget_id, true)
                            if (params.reloadAfterSave) {
                                store.executeStoreMethod(vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'], params:{'selectRowID': record.id} })
                            }
                        } else if (params.reloadAfterSave) {
                            store.executeStoreMethod(vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'], params:{'selectRowID': record.id} })
                        } else if (params.content_reloadAfterSave) {
                            vueObj.content_Changed()
                        }
                        if (params.parentWidget_reloadAfterSave && params.parentWIDGET) {
                            const widget_parent = store.findWidget(params.parentWIDGET.id).WIDGET
                            if (widget_parent?.widget_class === "widget_LIST" || widget_parent?.widget_class === "widget_TREE") {
                                store.executeStoreMethod(widget_parent.vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'], params:{'selectRowID': record.id} })
                            }
                        }

                        for (const action_after of action.actions_after || []) {
                            store.executeStoreMethod(vueObj, action_after)
                        }
                        for (const action_after of answer.actions_after || []) {
                            if (action_after.deferred) { store.schedule_deferredAction(vueObj, action_after); continue }
                            store.executeStoreMethod(vueObj, action_after)
                        }
                    },
                    error: function (jqXHR, textStatus) {
                        // IE 2026 10 13 / ODOO-5800: HTTP ≥ 400 / сеть — modified остаётся (как было); текст ошибки бэка (обрезанное тело: «request body truncated (N of M bytes) — not saved»)
                        const _so = saveOutcome_error(jqXHR, textStatus, { on: _retryOn, attempt: saveAttempt })   // IE 2026 10 13 / ODOO-5800
                        WIDGET.loading = false
                        if (_so.retry && !WIDGET.close) { _saveRetry(_so.text); return }   // IE 2026 10 13 / ODOO-5800
                        store.TERMINAL(WIDGET, null, { text: _so.text ? t('Not saved') + ': ' + _so.text : t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n · IE 2026 10 13 / ODOO-5800: текст бэка
                    },
                });
            } catch (error) {
                store.TERMINAL(WIDGET, null, {text:error, status:'error'})
            }
        },
        async archive_settingsTreeNode(vueObj, node) {
            // Пометка настройки из дерева настроек (dropdown заголовка) на удаление, только админ.
            // Вся логика на бэкенде — команда archive_record: перенос прямых детей (в т.ч.
            // архивных) на уровень выше, meta.archived + '*' в title; в ответе — обновлённое
            // parents_tree (уже без архивных). Ошибки приходят в стандартном notification
            const store = this, WIDGET = vueObj.WIDGET
            if (store.readonly_deny('archive_record')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение»
            WIDGET.loading = true
            try {
                const answer = await $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    data: JSON.stringify({
                        frontend_sent_timestamp: Date.now(),
                        command: 'archive_record',
                        showSQL: store.showSQL, profiling_params: store.profiling_params,
                        variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                        ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                        params: { id: node.id, segment: node.segment || 'WIDGET' },
                        user: store.user,
                    }),
                    contentType: "application/json",
                    dataType: 'json',
                })
                store.TERMINAL(WIDGET, answer) // notification из ответа (в т.ч. ошибки) показывает TERMINAL
                if (!store.check_loginAfterAjax(vueObj, answer)) return
                if (['error', 'critical'].includes(answer?.notification?.status)) return

                if (answer.parents_tree) {
                    WIDGET.parents_tree = answer.parents_tree
                }
                if (Array.isArray(answer.variants_tree)) {
                    WIDGET.variants_tree = answer.variants_tree // IE 2026 09 04 / ODOO-336331: архив варианта
                }
                if (WIDGET.record?.id === node.id) { // текущая открытая настройка остаётся открытой
                    WIDGET.record.meta = WIDGET.record.meta || {}
                    WIDGET.record.meta.archived = true
                    if ('variant_label' in answer) { // IE 2026 09 04 / ODOO-336331: архив открытого варианта снимает метку шапки
                        WIDGET.variant_label = answer.variant_label || ''
                        WIDGET.variant_main = answer.variant_main || null
                    }
                }
                if (answer.segment && answer.title) {
                    store.refresh_itemsSource(answer.segment, { id: answer.id, title: answer.title })
                }
            } catch (error) {
                store.show_notification({
                    text: t('Archive "{title}" failed: {error}', { title: node.title, error: error?.statusText || error?.message || error }),   // IE 2026 09 23 / ODOO-341407: i18n
                    status: 'error',
                })
            } finally {
                WIDGET.loading = false
            }
        },
        async move_settingsTreeNode(vueObj, node, target, position) {
            // Drag&Drop настройки в дереве настроек (dropdown заголовка), только админ.
            // position: 'inside' — сделать дочерней target, 'before' / 'after' — поставить
            // соседом target до/после него. Вся логика на бэкенде — команда move_record;
            // в ответе — обновлённое parents_tree. Ошибки приходят в стандартном notification
            const store = this, WIDGET = vueObj.WIDGET
            if (store.readonly_deny('move_record')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение»
            WIDGET.loading = true
            try {
                const answer = await $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    data: JSON.stringify({
                        frontend_sent_timestamp: Date.now(),
                        command: 'move_record',
                        showSQL: store.showSQL, profiling_params: store.profiling_params,
                        variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                        ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                        params: {
                            id: node.id, segment: node.segment || 'WIDGET',
                            target_id: target.id, target_segment: target.segment || 'WIDGET',
                            position,
                        },
                        user: store.user,
                    }),
                    contentType: "application/json",
                    dataType: 'json',
                })
                store.TERMINAL(WIDGET, answer) // notification из ответа (в т.ч. ошибки) показывает TERMINAL
                if (!store.check_loginAfterAjax(vueObj, answer)) return
                if (['error', 'critical'].includes(answer?.notification?.status)) return

                if (answer.parents_tree) {
                    WIDGET.parents_tree = answer.parents_tree
                }
                // IE 2026 09 25 / ODOO-341407 (вариант A): записанные переносом строки (parent / order / sequence_id) — в открытые копии
                store.sync_moved_records(answer.moved_records)
            } catch (error) {
                store.show_notification({
                    text: t('Move "{title}" failed: {error}', { title: node.title, error: error?.statusText || error?.message || error }),   // IE 2026 09 23 / ODOO-341407: i18n
                    status: 'error',
                })
            } finally {
                WIDGET.loading = false
            }
        },
        async Save_PIVOT_TOOL(vueObj, rows_modify, params = {}, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this, WIDGET = vueObj.WIDGET
            if (store.readonly_deny('Save_PIVOT_TOOL')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение»
            // let workspace_record = store.activeWORKSPACE.record
            WIDGET.loading = true;
            params.update = params.update || false
            params.row = params.row || null
            params.closeAfterSave = params.closeAfterSave || false
            params.reloadAfterSave = params.reloadAfterSave || false
            params.content_reloadAfterSave = params.content_reloadAfterSave || false
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'Save_PIVOT_TOOL',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    rows_modify: rows_modify,
                    ...params,
                    user: store.user,
                    // workspace_record: workspace_record, // look widget_FORECAST.beforeSave(...)
                    action_from_frontend: true,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    // async: false,

                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        if (WIDGET.close) { return }            
                        const notification_frontend = null // {
                        //     text: (WIDGET?.title || '') + ', Save_PIVOT_TOOL time: ' + Math.round(performance.now() - vueObj.time) / 1000,
                        //     status: 'info',
                        // }
                        store.TERMINAL(WIDGET, answer, null, notification_frontend, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (!store.check_loginAfterAjax(vueObj, answer)) return
                        WIDGET.loading = false
                        // if (params.reloadAfterSave) {
                            store.executeStoreMethod(vueObj, { 'tooltip': t('Update data'), 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'], 'cssClass':'pi pi-sync' })   // IE 2026 09 23 / ODOO-341407: i18n
                        // }
                    },
                    error: function (error) {
                        store.TERMINAL(WIDGET, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                        WIDGET.loading = false
                    },
                });
            } catch (error) {
                store.TERMINAL(WIDGET, null, {text:error, status:'error'});
            }
        },
        check_loginAfterAjax(vueObj = null, answer) {
            const store = this
            // IE 2026 09 28 / ODOO-342342 (ревью З5): пустой ответ (тело «null») — применять нечего; раньше answer.isAuthenticated падал TypeError
            if (answer === null || answer === undefined) return false
            if (answer.isAuthenticated === false) {
                if (!this.hide_console) console.log('isAuthenticated false')
                console.warn('[check_loginAfterAjax] full answer:', JSON.stringify(answer))
                store.logout(null, null, false, '', `check_loginAfterAjax: command=${answer?.command || '?'}`)
                return false
            }
            return true
        },
        // ---------------- i18n: локализация отображения переводимых полей (I18N.md) ----------------
        // Данные записи не изменяются: переводы подставляются только при отображении
        // (по флагу attr.translate), редактирование пишет текст в базовое поле, как раньше.
        get_lang() {
            // язык пользователя для правила отображения переводов ('' = базовый en)
            // IE 2026 09 23 / ODOO-341407: язык — тот, что выбран на фронте (меню пользователя / URL), не только запись USER
            const language = getLanguage()
            return language && language !== 'en' ? language : ''
        },
        // IE 2026 09 23 / ODOO-341407: BCP-47 локаль форматов чисел/дат для Intl.* (настройка fe.i18n.formatsCulture)
        locale() {
            return getLocale()
        },
        // IE 2026 09 24 / ODOO-341407: локаль языка интерфейса — названия месяцев на осях чартов и в подписях дат (текст, не формат)
        ui_locale() {
            return getUiLocale()
        },
        // IE 2026 09 23 / ODOO-341407: выбор языка интерфейса (меню пользователя): запись в USER через user_settings_save + перезагрузка
        // IE 2026 09 24 / ODOO-341407 (поручение Игоря: без перезагрузки интерфейса): при флаге fe.i18n.switchWithoutReload (по умолчанию вкл.)
        // страница не перезагружается — user.language уходит в последующие запросы, язык сохраняется в USER без reload, словарь / культура
        // wijmo / локаль PrimeVue меняются вживую (switchLanguageLive), подписи бэка перелокализуются на клиенте (relocalize: i18n_dict_get),
        // отчёты активной страницы без правок делают select; открытое и несохранённое остаётся. Выкл: window.feSettings.set('fe.i18n.switchWithoutReload', false)
        set_language(language) {
            const store = this
            if (!I18N_LANGUAGES.some(l => l.id === language)) return ''
            if (!i18n_isEnabled(language)) return ''   // IE 2026 09 26 / ODOO-341407: язык выключен в этой базе (сегмент I18N-LANGUAGES)
            const prev = getLanguage()
            let _live = null   // IE 2026 10 11 / ODOO-5800: обещание живого переключения (для колбэка сохранения)
            if (i18n_switchWithoutReload() && language !== prev) {
                const t0 = performance.now()   // IE 2026 09 25 / ODOO-341407: момент клика — замеры фаз переключения (window.i18nSwitch.last())
                if (store.user && typeof store.user === 'object') store.user.language = language
                // IE 2026 09 25 / ODOO-341407 (замер dev02: словари бэка запрашивались только ПОСЛЕ смены строк интерфейса — +0,1…0,9 с к каждому
                // переключению): запрос словарей нового и прежнего языка — сразу по клику, параллельно; relocalize ждёт тот же запрос (флаг switchDictPrefetch)
                if (i18n_switchFlag(store, 'switchDictPrefetch')) i18n_dictPrefetch(store, [language, prev])
                // IE 2026 10 01 / ODOO-341407: метка «выбор не сохранён на бэке» — adoptServerLanguage не откатывает страницу на прежний язык USER после F5
                // IE 2026 10 07 / ODOO-341407 (слияние с ODOO-345045, слова Игоря «язык берется при перезагрузке из пользователя, а не из куки»): метка только на время
                // сохранения в полёте — роль «только чтение» её не ставит, ЛЮБОЙ ответ снимает (не ok — язык откатится при перезагрузке, о чём предупреждает langProfile_saveDone)
                const _pk = store.readonly_on() ? '' : langPendingKey(store.user)   // IE 2026 10 07 / ODOO-341407
                writeLangPending(_pk, language)
                if (!store.readonly_on()) store.executeBackendMethod({}, { command: 'user_settings_save', params: { language } }, (answer) => { clearLangPending(_pk, language); return Promise.resolve(_live).catch(() => {}).then(() => langProfile_saveDone(store, answer)) })   // IE 2026 10 11 / ODOO-5800 (QUEUE, ODOO-341407): тост ошибки сохранения строит t() — ждём конца переключения, иначе текст на ПРЕЖНЕМ языке   // IE 2026 10 07 / ODOO-341407: + снятие метки; IE 2026 10 03 / ODOO-345045 (заказ Игоря: язык — профиль перечитывать, сохранение языка не молчит): колбэк — ошибка ответа = уведомление (fe.i18n.saveLanguageWarn), удача = перечитать открытый «My profile» (fe.i18n.profileFollowsLanguage); без await   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — язык только локально (localStorage feSettings, уезжает в запросах как user.language)
                _live = i18n_switchLive(language)
                _live
                    .then((info) => i18n_relocalize(store, { from: (info && info.prev) || prev, to: language, refreshData: store.setting('fe.i18n.switchRefreshData', true) !== false,
                        relabelData: store.setting('fe.i18n.switchRelabelData', true) !== false, t0, ui: info }))   // IE 2026 09 24 / ODOO-341407: подписи записей по id (рейка столов, панель страниц, дерево настроек, строки гридов); IE 2026 09 25: + t0, ui (замеры)
                    .then(() => { if (store.readonly_on()) langProfile_readonlyWarn(store) })   // IE 2026 10 03 / ODOO-345045 (заказ Игоря: язык — профиль перечитывать, сохранение языка не молчит): роль «только чтение» — вызова нет, язык только до перезагрузки
                    .then(() => store.scheduleHeaderChip_langChanged())   // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): текст чипса «Regimen paused until …» строит бэк на языке запроса — перечитать у активного стола
                    .catch((e) => console.warn('[i18n] switch', e))
                return 'switching'
            }
            const _pk2 = store.readonly_on() ? '' : langPendingKey(store.user)   // IE 2026 10 01 / ODOO-341407: метка «выбор не сохранён на бэке» — как в пути без перезагрузки; IE 2026 10 07 / ODOO-341407: read-only — без метки
            writeLangPending(_pk2, language)
            i18n_setLanguage(language, { beforeReload: (go) => {
                if (store.readonly_on()) { go(); return }   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — язык только локально, бэк не зовём: перезагрузку исполняем сами
                store.executeBackendMethod({}, { command: 'user_settings_save', params: { language } }, (answer) => { clearLangPending(_pk2, language); go() })   // IE 2026 10 07 / ODOO-341407: любой ответ снимает метку (ODOO-345045: несохранённый язык после перезагрузки берётся из USER)
            } })
            return 'reloading'
        },
        localize_binding(binding, lang, raw_binding = binding) {
            // биндинг перевода: перевод реляционной колонки title записи лежит в JSONB meta
            // (meta.title_{lang}), у остальных полей — суффикс к самому биндингу
            // IE 2026 09 24 / ODOO-341407 (проверка dev02, форма строки колонки): title СТРОКИ конфигурации записи — путь формы строки
            // widget-row (doc.viewList.3.title, attrs.2.title, doc.params.…) — переводится суффиксом рядом с ключом (title_{lang}, как пишет
            // карточка Translations и бэк i18n_values_set); meta.title_{lang} — у самой записи ('title') и у строк-записей реестров (_doc.*)
            return i18nFields_localizeBinding(binding, lang, raw_binding)   // IE 2026 10 06 / ODOO-341407: правило — в utils/i18nFields.js (одно на стор и поля переводов: виртуальные строки / колонки берут путь оттуда же)
        },
        get_value_localized(record, binding, raw_binding = binding) {
            // правило отображения: {binding}_{lang} непустой → показываем его, иначе базовое {binding}
            const lang = this.get_lang()
            if (lang) {
                const translated = this.get_value(record, this.localize_binding(binding, lang, raw_binding))
                if (translated && typeof translated === 'string') {
                    return translated
                }
            } else if (raw_binding === 'title' && (binding === 'title' || String(binding).startsWith('_'))) {
                // IE 2026 09 25 / ODOO-341407 (этап 1 переводов данных 1С): под en — английский вариант названия ЗАПИСИ с не английской базой
                // (meta.title_en: поле 1С / CLDR / ручной — бэк common_modules/i18n_titles.py); строки конфигурации (title_en = бэкап локализации) не трогаем
                const title_en = this.get_value(record, this.localize_binding(binding, 'en', raw_binding))
                if (title_en && typeof title_en === 'string') {
                    return title_en
                }
            }
            return this.get_value(record, binding)
        },
        sync_translation(record, binding, value, raw_binding = binding) {
            // локальное зеркало правила записи (I18N.md, Шаг 7): перевод есть → обновляется перевод.
            // Без этого после редактирования отображение откатилось бы к старому переводу
            const lang = this.get_lang()
            if (!lang || typeof value !== 'string') return
            const binding_lang = this.localize_binding(binding, lang, raw_binding)
            const translated = this.get_value(record, binding_lang)
            if (translated && typeof translated === 'string') {
                this.set_value(record, binding_lang, value)
            }
        },
        // ---- IE 2026 09 24 / ODOO-341407 (заказ Игоря): карточка «Translations» (components_core/I18nTitles.vue, одна на приложение,
        // store.i18nCard ставит App.vue) — просмотр / правка названий на трёх языках у виджета, колонки, параметра, поля с флагом Multilingual ----
        // opts: { label, record, fields: [{ key, label, multiline, basePath, langPaths: {uk, ru} }], anchorEl, memoryOnly, readOnly, afterApply }
        i18n_card_open(opts) {
            const card = this.i18nCard
            if (!card || typeof card.open !== 'function') { console.warn('i18n card is not mounted'); return false }
            return card.open(opts)
        },
        // языки перевода (кроме английской базы): [{id, title}]
        i18n_otherLangs() {
            return I18N_LANGUAGES.filter(l => l.id !== 'en')
        },
        // поля записи «Title / Tooltip»: title → meta.title_{lang} (перевод реляционной колонки лежит в JSONB meta), doc.tooltip → doc.tooltip_{lang}
        i18n_recordFields() {
            const title = { key: 'title', label: t('Title'), multiline: false, basePath: 'title', langPaths: {} }
            const tooltip = { key: 'tooltip', label: t('Tooltip'), multiline: true, basePath: 'doc.tooltip', langPaths: {} }
            for (const L of I18N_LANGUAGES) {
                if (L.id === 'en') continue
                title.langPaths[L.id] = 'meta.title_' + L.id
                tooltip.langPaths[L.id] = 'doc.tooltip_' + L.id
            }
            return [title, tooltip]
        },
        // заголовок записи для шапки после Apply: перевод текущего языка → словарный вариант (карточка его знает) → английская база
        i18n_record_title(record, dict = null) {
            const lang = this.get_lang()
            const base = record?.title || ''
            if (!lang) return base
            const stored = this.get_value(record, 'meta.title_' + lang)
            if (stored && typeof stored === 'string') return stored
            const d = dict?.[lang]
            return (d && typeof d === 'string') ? d : base
        },
        // путь объекта-строки внутри корня (массив / дерево записи) по тождеству: [2, 'fields', 1] | null; служебные ветки (_meta, _doc …) не обходим
        i18n_pathOf(root, target, depth = 0) {
            if (!root || typeof root !== 'object' || !target || depth > 12) return null
            if (Array.isArray(root)) {
                for (let i = 0; i < root.length; i++) {
                    if (root[i] === target) return [i]
                    const p = this.i18n_pathOf(root[i], target, depth + 1)
                    if (p) return [i, ...p]
                }
                return null
            }
            for (const k of Object.keys(root)) {
                if (k.startsWith('_') || k === 'itemsSource') continue
                const v = root[k]
                if (!v || typeof v !== 'object') continue
                if (v === target) return [k]
                const p = this.i18n_pathOf(v, target, depth + 1)
                if (p) return [k, ...p]
            }
            return null
        },
        // биндинг элемента формы → запись-владелец и полный путь в ней: у всплывающей формы строки (widget-row) запись — родительская,
        // путь = meta.binding.iroot.binding (как attr_get_link); nested = поле принадлежит СТРОКЕ записи (перевод — суффиксом рядом с ключом)
        i18n_linkBinding(WIDGET, binding) {
            const store = this
            let nested = false, iter = 0
            while (WIDGET?.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 5) {
                const parent = store.findWidget(WIDGET.parentWIDGET.id)
                const meta = WIDGET.record?._meta
                if (!parent?.WIDGET || !meta) break
                if (meta.type === 'widget-row-viewParams' && binding?.startsWith('doc.params.')) { WIDGET = parent.WIDGET; continue }
                if (meta.binding === undefined || meta.iroot === undefined) break
                binding = meta.binding + '.' + meta.iroot + (binding ? '.' + binding : '')
                nested = true
                WIDGET = parent.WIDGET
            }
            return { WIDGET, record: WIDGET?.record || null, binding, nested }
        },
        // ---- IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1 / п.2): поля переводов в UI — логика в utils/i18nFields.js, здесь обёртки стора ----
        // языки полей переводов: включённые в базе (сегмент I18N-LANGUAGES), без английской базы; { withEn: true } — en первым. [{ id, title }].
        // i18n_otherLangs (все языки) не меняем — у него свои вызывающие
        i18n_fieldLangs(opts = {}) {
            void this._settingsEpoch   // зависимость для computed: настройки базы переприменены — список языков перечитывается
            return i18nFields_langs(i18n_enabledLanguages(), opts)
        },
        // правка meta.title_<L> строки / записи снимает его из пометки словарного перевода meta._i18n_auto (key: 'title_uk' | 'meta.title_uk';
        // IE 2026 10 06 / ODOO-341407 (ревью U9): и путь от записи-владельца '_doc.data.3.meta.title_uk' — пометка строки списка под карточкой Alt+F2)
        i18n_autoUnmark(record, key) {
            return i18nFields_autoUnmarkAt(record, key)   // IE 2026 10 06 / ODOO-341407: было i18nFields_autoUnmark (тот же результат для 'title_uk' / 'meta.title_uk')
        },
        // опция «Show translation fields»: сегмент данных виджета (ключ состояния), доступность пункта, состояние (реактивно), переключение —
        // только память стора и localStorage, запись виджета не метится (_meta.modified), doc.viewParams не трогается
        i18nFields_kind(W) { return i18nFieldsKind(this, W) },
        i18nFields_avail(W) { return i18nFieldsAvail(this, W) },
        i18nFields_on(W) { return i18nFieldsOn(this, W) },
        i18nFields_set(W, on) { return i18nFieldsSet(this, W, on) },
        get_valueStr_translated(V) {
            // мультитайп: непустой valueStr_{lang} отображается вместо valueStr
            const lang = this.get_lang()
            const translated = lang && V ? V['valueStr_' + lang] : ''
            return (translated && typeof translated === 'string') ? translated : ''
        },
        reset_valueStr_translations(V) {
            // значение мультитайпа изменено пользователем — переводы старого значения не актуальны
            for (const key of Object.keys(V)) {
                if (/^valueStr_[a-z]{2}$/.test(key)) delete V[key]
            }
        },
        async check_sessionKey(to, next, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            if (!this.hide_console) console.log('check_sessionKey')
            const store = this,
                csrftoken = store.getCookie('csrftoken'),
                session_key = store.getCookie(`session_key_${to.params.dbid}`) // store.user.database.dbid
            if (!session_key || !csrftoken) {
                return store.logout(to, next, false, '', `check_sessionKey: missing ${!session_key ? 'session_key' : 'csrftoken'}`)
            }
            try {
                $.ajaxSetup({
                    timeout: store.setting('fe.polling.ajaxTimeoutMs', 180000),   // IE 2026 09 05 / ODOO-336330: пусто = прежние 180 с на проверке сессии
                    headers: {
                        'X-Company': store.extractCompany('', to.params.dbid),
                        'X-Database': to.params.dbid || '',
                        'X-CSRFToken': csrftoken
                    },
                    xhrFields: {
                        withCredentials: true
                    }
                })

                let send_start
                // ODOO-3705: поколение переключения базы на момент отправки — см. проверку
                // в success. Сравнивать с location.hash нельзя: в beforeEach он ещё старый.
                const _switchSeq = store._dbSwitchSeq || 0
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    version_frontend: store.version_frontend,
                    command: 'check_sessionKey',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    // user: { session_key: session_key }
                    user: { database: {dbid:to.params.dbid} }
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        try {
                            store.check_versions(answer)
                            store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                            store.isAuthenticated = !!(answer && answer.isAuthenticated)
                            store._checkingSession = false
                            if (store.isAuthenticated) {
                                if ((store._dbSwitchSeq || 0) !== _switchSeq) {
                                    // пока запрос был в полёте, пользователь сменил базу.
                                    // get_user() отдаёт user ВЕРБАТИМ вместе с .database
                                    // прежней базы: применив ответ, откатили бы и название
                                    // в шапке, и dbid в телах всех последующих запросов —
                                    // они ушли бы на backend новой базы с чужим dbid.
                                    return
                                }
                                store.user = store.get_user(answer)
                                // IE 2026 09 26 / ODOO-341407 (fe.i18n.firstLoadHold): явный язык USER (get_user) или настройки базы этого ответа требуют
                                // перезагрузки — навигацию дальше не ведём (get_startup / workspace_open не уходят), перезагрузка сразу
                                if (store.i18n_firstLoadHold(answer, 'check_sessionKey', to?.fullPath ? { fullPath: to.fullPath } : null)) return
                                return next(to)
                            }
                            const _sessionStart = localStorage.getItem(`session_start_${to.params.dbid}`)
                            const _sessionAge = _sessionStart ? Math.round((Date.now() - Number(_sessionStart)) / 1000) : null
                            console.warn(`[check_sessionKey] session age: ${_sessionAge}s | backend response:`, JSON.stringify(answer))
                            localStorage.removeItem(`session_start_${to.params.dbid}`)
                        } catch (e) { /* fall through to defensive logout */ }
                        // Auth failed OR exception during success handler — clean all session cookies and redirect to login
                        store.isAuthenticated = false
                        store._checkingSession = false
                        store.clearSessionCookies(to && to.params && to.params.dbid)
                        return store.logout(to, next, false, '', 'check_sessionKey: isAuthenticated=false or success handler threw')
                    },
                    error: function (error, textStatus) {
                        if (textStatus === 'timeout') {
                            store.showConnectionError()
                        }
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                        store.isAuthenticated = false
                        store._checkingSession = false
                        store.clearSessionCookies(to && to.params && to.params.dbid)
                        return store.logout(to, next, false, '', `check_sessionKey: ajax error status=${error?.status} ${error?.statusText}`)
                    },
                });
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'});
            }
        },
        // IE 2026 09 04 / ODOO-336330: применить настройки базы из ответа бэка (answer.settings).
        settings_apply(payload) {
            const store = this
            const fe = payload && payload.fe
            if (!fe || typeof fe !== 'object') return
            const ver = payload.version || ''
            if (store.settings && store.settings_version === ver) return   // значения не менялись
            store.settings = fe
            store.settings_version = ver
            // зеркало для кода, который выполняется ДО createApp (main.js: классы body,
            // мобильный профиль): на ЭТОЙ загрузке он читал прошлое зеркало, со следующей — новое
            try { localStorage.setItem('feSettings.db', JSON.stringify(fe)) } catch (e) { /* приватный режим */ }
            store._settingsEpoch++
            store.settings_applyEffects()   // IE 2026 09 05 / ODOO-336330
            // IE 2026 09 25 / ODOO-341407: вместе с настройками пришёл язык базы по умолчанию (fe.i18n.languageDefault) — принять, если язык страницы
            // выбран регионом (не URL, не выбор пользователя, не явный язык USER). Отложено на такт: get_user того же ответа (login / check_sessionKey)
            // отмечает явный язык USER; выбор базы на странице баз приносит настройки только в workspace_open (TERMINAL, без get_user).
            // Сверка — один раз за загрузку страницы (adoptDbDefaultLanguage), смена базы внутри страницы язык не перезагружает
            // IE 2026 09 26 / ODOO-341407: сначала — язык страницы выключен в этой базе (fe.i18n.languages) → перезагрузка на язык цепочки; тогда язык
            // базы по умолчанию отдельно не принимается (цепочка его уже учла)
            setTimeout(() => {
                // IE 2026 09 26 / ODOO-341407 (fe.i18n.firstLoadHold, по умолчанию вкл.): то же решение, но перезагрузка сразу, без таймера 1500 мс.
                // На ответах workspace_open / get_startup / check_sessionKey / login оно уже принято синхронно (i18n_firstLoadHold) — сторожа вернут null
                if (i18n_switchFlag(store, 'firstLoadHold')) {
                    try { store.i18n_firstLoadHold({ settings: payload }, 'settings_apply') } catch (e) { /* язык страницы не меняем */ }
                    return
                }
                try { if (i18n_enforceEnabled({ trigger: 'settings_apply' })) return } catch (e) { /* язык страницы не меняем */ }   // IE 2026 09 26 / ODOO-341407: meta — для замера
                try { if (adoptDbDefaultLanguage(!!store._i18nExplicit, { trigger: 'settings_apply' })) return } catch (e) { /* язык страницы не меняем */ }   // IE 2026 09 26 / ODOO-341407: meta — для замера
                try { i18n_firstLoadSettled({ trigger: 'settings_apply', flag: false }) } catch (e) { /* без замера */ }   // IE 2026 09 26 / ODOO-341407: замер «без перезагрузки» (флаг выключен)
            }, 0)
            if (!store.hide_console) console.log('feSettings:', ver, fe)
            return store.settings
        },
        // IE 2026 09 26 / ODOO-341407 (разбор docs/audit-2026-09-04/i18n_first_login_reload_2026-09-26.md, вариант b; флаг fe.i18n.firstLoadHold,
        // по умолчанию вкл.: window.i18nSwitch.set('firstLoadHold', false) / URL ?fe.i18n.firstLoadHold=false — прежний путь с таймером 1500 мс).
        // Синхронно на ответе с настройками базы (workspace_open, get_startup, check_sessionKey, login; отложенно — settings_apply): нужна смена
        // языка (язык страницы выключен в базе / язык базы по умолчанию / явный язык USER из get_user) → true: вызывающий дальше НЕ идёт (стол
        // не строится, виджеты не открываются), перезагрузка сразу; guard _i18nReloading в setup / workspace_open / workspace_show_widgets
        // не даёт отправить ничего нового до выгрузки. false — язык остаётся, работа как обычно. Замер — window.i18n.stats().firstLoad
        i18n_firstLoadHold(answer, trigger, target = null) {
            const store = this
            if (store._i18nReloading) return true
            let d = store._i18nUserDecision || null   // явный язык USER (get_user с флагом): перезагрузку исполняем здесь
            if (!d) {
                // как у settings_apply (прежний путь решал только там): настройки базы — объект fe; ответ без fe решение не расходует
                const fe = answer?.settings?.fe
                if (!fe || typeof fe !== 'object') return false
                if (!i18n_switchFlag(store, 'firstLoadHold')) return false
                try { d = i18n_firstLoadDecision(!!store._i18nExplicit) } catch (e) { d = null }
            }
            // запросов в полёте: внутри success jQuery свой запрос ещё считается в jQuery.active — вычесть; settings_apply — отложен (таймер)
            let inFlight = null
            try { if (window.jQuery) inFlight = Math.max(0, window.jQuery.active - (trigger === 'settings_apply' ? 0 : 1)) } catch (e) { inFlight = null }
            if (!d) {
                try { i18n_firstLoadSettled({ trigger, flag: true, inFlight }) } catch (e) { /* без замера */ }
                return false
            }
            store._i18nUserDecision = null
            store._i18nReloading = true
            i18n_reloadNow(d, { trigger, inFlight, url: store.i18n_firstLoadUrl(target), held: trigger !== 'settings_apply' })
            return true
        },
        // IE 2026 09 26 / ODOO-341407: адрес перезагрузки — цель ещё НЕ подтверждённой навигации. Стол открывается из router.beforeEach
        // (router.js: workspace_open и return без next), пока location.hash прежний — с выбора базы это #/select-database (DatabaseSelector.vue;
        // проверено на dev 26.09: в момент ответа workspace_open адрес #/select-database). Перезагрузка «как есть» открыла бы страницу 2 на выборе
        // базы. target: { workspace, page } (путь как у workspace_route_to) или { fullPath } (to.fullPath). Адрес уже тот (прямая ссылка, F5 —
        // вместе с where= и прочими параметрами) или цели нет → '' (перезагрузка текущего адреса, как у прежнего пути)
        i18n_firstLoadUrl(target) {
            const store = this
            try {
                if (!target) return ''
                const h = location.hash || ''
                let fullPath = target.fullPath || ''
                if (!fullPath && target.workspace) {
                    const dbid = store.user?.database?.dbid
                    if (!dbid) return ''
                    const q = new URLSearchParams(h.includes('?') ? h.slice(h.indexOf('?') + 1) : '')
                    if (h.startsWith(`#/${dbid}?`) && q.get('workspace') === target.workspace) return ''
                    const pm = store.process_model_record?.id
                    const pm_part = (pm && pm !== store.process_model_current) ? `process_model=${encodeURIComponent(pm)}&` : ''
                    fullPath = `/${dbid}?${pm_part}workspace=${encodeURIComponent(target.workspace)}` + (target.page ? `&page=${encodeURIComponent(target.page)}` : '')
                }
                if (!fullPath || h === '#' + fullPath) return ''
                return location.pathname + location.search + '#' + fullPath
            } catch (e) { return '' }
        },
        // IE 2026 09 22 / ODOO-… (предложение Игоря, шаг 2): панели функций в стиле 1С вместо выпадающих меню — общий выключатель fe.ux.menuPanel и по местам
        // fe.ux.menuPanelPage / menuPanelUser / menuPanelWidget / menuPanelGrid (по умолчанию вкл.); мобильный профиль — прежние wj-menu
        // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): СНИМОК СТАТУСОВ ЗАДАЧ СТОЛА для панели задач в шапке (AppTopbar, у администратора):
        // tasksBar[workspace] = { rows, at, source, loading, seq, ms, bytes }. Откуда строки и когда обновляются:
        //   (1) без снимка — строки записи стола, пришедшей со столом (workspace_open / reopen): статусы последнего СОХРАНЕНИЯ формы стола (могут быть
        //       устаревшими) — поэтому
        //   (2) при открытии / смене стола — один запрос «только вид» записи стола (widget_open widget-record + open_view_only, как widget_fetch: бэк
        //       widget_WORKSPACE.initialize кладёт статусы log.scan_log_multi без статистики, данных виджет не выбирает, в сторе не регистрируется);
        //   (3) любая запись стола, пришедшая в ответах бэка (форма стола открыта / Update data → select_log / updateDoc), подхватывается — tasksBar_fromRecord;
        //   (4) при открытии панели снимок старше fe.data.tasksBarStaleSec (60 с) перечитывается; кнопка ↻ панели — всегда (force).
        // Выключатели: fe.ux.menuPanelTasks (сама панель — menuPanel_on('Tasks')), fe.ux.tasksBarAutoFetch (запросы при открытии стола / панели)
        tasksBar_state(workspace) { return (workspace && this.tasksBar[workspace]) || null },
        tasksBar_rows(workspace) {
            const st = this.tasksBar[workspace]
            if (st && Array.isArray(st.rows)) return st.rows
            const rows = this.WORKSPACES[workspace]?.record?.doc?.data_tasks
            return Array.isArray(rows) ? rows : []
        },
        tasksBar_take(workspace, rows, source) {
            if (!workspace || !Array.isArray(rows)) return
            const prev = this.tasksBar[workspace]
            // строки — как пришли (markRaw: дерево большое, реактивность внутри не нужна — снимок заменяется целиком, computed следят за объектом снимка)
            // IE 2026 09 26 / ODOO-… (дефект: undo после Alt+drag в подчинённые): под markRaw — КОПИЯ верхнего массива, не массив
            // записи: markRaw(record.doc.data_tasks) навсегда снимал реактивность с живых данных формы стола (дерево задач), и undo переноса строк
            // в нём дублировал строку. Узлы общие с записью (toRaw — без прокси), снимок по-прежнему без реактивности внутри
            this.tasksBar[workspace] = { rows: markRaw(toRaw(rows).slice()), at: Date.now(), source: String(source || ''), loading: false, seq: (prev?.seq || 0) + 1, ms: prev?.ms, bytes: prev?.bytes,
                titles: prev?.titles || {}, titlesMiss: prev?.titlesMiss || {} }   // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия): кэш названий узлов по id живёт между снимками
            this.tasksBar_resolveTitles(workspace)   // IE 2026 09 23 (заказ Игоря: панель задач в шапке — названия): узлы без названия → названия пачкой
        },
        tasksBar_done(workspace) {
            const st = this.tasksBar[workspace]
            if (st) this.tasksBar[workspace] = { ...st, loading: false }
        },
        // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке — названия): НАЗВАНИЯ УЗЛОВ-ССЫЛОК СНИМКА. Факт (замер 23.09, dev и dev02): в ответе
        // «только вид» widget_open записи стола у ВСЕХ узлов-ссылок node.valueStr = id (dev02 109 из 109, dev 98 из 98) — attrs.prepare_attrs (set_view) →
        // prepare_AttrMulti_itemsSource_row → prepare_AttrMulti без select_valueStr переписывает valueStr значением (attrs.py, код 2024-10); флаг
        // open_view_only ни при чём (обычный widget_open через API — то же), а форма стола получает названия ВТОРЫМ запросом select_log (loading формы),
        // которого у снимка панели нет. Поэтому после каждого снимка: узлы без названия (valueStr пуст / равен id, utils/tasksPanel.tasksPanel_bareIds) →
        // ОДИН запрос catalog_titles (title по id, любые сегменты, как у тиража виджета 15.09; бэк отдаёт локализованный title — как у формы), недостающие →
        // словарь сегмента (get_itemsSource by_ids, обычно 0 запросов; читается через ctx.titleFor → dictRow, когда придёт); кэш по id в tasksBar[ws].titles
        // живёт между снимками (↻ — 0 запросов), id без записи — titlesMiss (не переспрашиваются). Название → пункт панели через ctx.titleFor
        // (utils/tasksPanel.tasksPanel_titleOf), фолбэк — id. Выключатель fe.ux.tasksBarTitles; счётчики store._tasksBarTitlesStats
        tasksBar_title(workspace, id) { const st = this.tasksBar[workspace]; return (st && st.titles && st.titles[id]) || '' },
        tasksBar_titlesPut(workspace, hits, miss) {
            const st = this.tasksBar[workspace]
            if (!st) return
            this.tasksBar[workspace] = { ...st, titles: { ...(st.titles || {}), ...(hits || {}) }, titlesMiss: { ...(st.titlesMiss || {}), ...(miss || {}) } }
        },
        tasksBar_resolveTitles(workspace) {
            const store = this, st = store.tasksBar[workspace]
            if (!st || !Array.isArray(st.rows) || store.setting('fe.ux.tasksBarTitles', true) === false) return Promise.resolve(0)
            const known = st.titles || {}, miss = st.titlesMiss || {}
            const need = tasksPanel_bareIds(st.rows).filter(x => !known[x.id] && !miss[x.id])
            if (!need.length) return Promise.resolve(0)
            store._tasksBarTitlesInflight = store._tasksBarTitlesInflight || {}
            if (store._tasksBarTitlesInflight[workspace]) return store._tasksBarTitlesInflight[workspace]
            const ids = need.map(x => x.id)
            const p = new Promise((resolve) => {
                let done = false
                const fin = (titles) => {
                    if (done) return
                    done = true
                    delete store._tasksBarTitlesInflight[workspace]
                    const hits = {}, rest = []
                    for (const x of need) { const h = titles && titles[x.id]; const t = h && (typeof h === 'string' ? h : h.title); if (t) hits[x.id] = String(t); else rest.push(x) }
                    // недостающие — словарь сегмента (названия прочтёт ctx.titleFor через dictRow, когда словарь придёт); второй раз не спрашиваются
                    const bySeg = {}, missNow = {}
                    for (const x of rest) { missNow[x.id] = 1; if (x.segment) (bySeg[x.segment] = bySeg[x.segment] || []).push(x.id) }
                    for (const seg in bySeg) { try { store.get_itemsSource({ WIDGET: { workspace, page: store.WORKSPACES[workspace]?.active_page || '' }, attr: null }, {}, { attr_type: 'AttrLink', relation_segment: seg }, { fetchMode: 'by_ids', ids: bySeg[seg] }) } catch (e) { /* словарь недоступен — id */ } }
                    store.tasksBar_titlesPut(workspace, hits, missNow)
                    const S = store._tasksBarTitlesStats || { requests: 0, dictRequests: 0, asked: 0, resolved: 0 }
                    store._tasksBarTitlesStats = { requests: S.requests + 1, dictRequests: S.dictRequests + Object.keys(bySeg).length, asked: S.asked + ids.length, resolved: S.resolved + Object.keys(hits).length, lastAsked: ids.length, lastResolved: Object.keys(hits).length }
                    resolve(Object.keys(hits).length)
                }
                try { store.executeBackendMethod({}, { method: 'catalog_titles', params: { ids } }, (answer) => fin(answer?.titles || {})) } catch (e) { fin({}) }
                setTimeout(() => fin({}), 10000)
            })
            store._tasksBarTitlesInflight[workspace] = p
            return p
        },
        // запись стола (id = загруженный стол) со статусами задач — в снимок: форма стола открыта / Update data (select_log) / ответ «только вид»
        tasksBar_fromRecord(record, source = 'record') {
            try {
                const id = record?.id
                if (!id || !this.WORKSPACES[id] || !Array.isArray(record?.doc?.data_tasks) || !tasksPanel_hasStatuses(record.doc.data_tasks)) return false
                this.tasksBar_take(id, record.doc.data_tasks, source)
                return true
            } catch (e) { return false }
        },
        tasksBar_stale(workspace, sec) {
            const st = this.tasksBar[workspace]
            const max = Number(sec ?? this.setting('fe.data.tasksBarStaleSec', 60)) * 1000
            return !st || !st.at || (Date.now() - st.at) > max
        },
        // свежие статусы: запрос «только вид» записи стола (виджет не регистрируется, данных не выбирает); один запрос на стол за раз
        tasksBar_refresh(workspace, opts = {}) {
            const store = this, WS = store.WORKSPACES[workspace], rec = WS?.record
            if (!rec?.id) return Promise.resolve(null)
            if (!opts.force && !store.tasksBar_stale(workspace, opts.staleSec)) return Promise.resolve(store.tasksBar[workspace])
            store._tasksBarInflight = store._tasksBarInflight || {}
            if (store._tasksBarInflight[workspace]) return store._tasksBarInflight[workspace]
            const prev = store.tasksBar[workspace]
            store.tasksBar[workspace] = { ...(prev || { rows: null, at: 0, source: '', seq: 0 }), loading: true }
            const widget_init = { id: store.nextWidget_id++, record: { id: rec.id, segment: rec.segment, _meta: {} }, widget: 'widget-record', workspace, page: WS.active_page,
                styleWidget: {}, fieldsMapping: [], title: rec.title || rec.id, parentAction: { command: 'widget_open', widget: 'widget-record', _fetch: true, _tasksBar: true }, _open_view_only: true }
            const payload = JSON.stringify({
                frontend_sent_timestamp: Date.now(), command: 'widget_open', action_id_front: store.net_actionId(++store.action_id_front), ...store.net_requestParams(), // IE 2026 09 26 / ODOO-5800
                dl2_engine: { ...store.dl2Engine }, showSQL: store.showSQL, profiling_params: store.profiling_params,
                variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                ...store.dl2_requestParams(), ...store.client_requestParams(),
                process_model: store.process_model_record?.id, workspace, widget_init, user: store.user, open_view_only: true,
            })
            const t0 = performance.now()
            const p = new Promise((resolve) => {
                $.ajax({ url: store.url_backend_api, type: 'POST', data: payload, contentType: 'application/json', dataType: 'json',
                    success: (answer, _s, jqXHR) => {
                        delete store._tasksBarInflight[workspace]
                        const r = answer?.WIDGET?.record
                        if (r && String(r.id) === String(rec.id) && Array.isArray(r.doc?.data_tasks)) store.tasksBar_take(workspace, r.doc.data_tasks, 'scan')
                        else store.tasksBar_done(workspace)
                        const st = store.tasksBar[workspace]
                        if (st) { st.ms = Math.round(performance.now() - t0); st.bytes = (jqXHR?.responseText || '').length }   // замер: время и размер ответа «только вид»
                        resolve(st || null)
                    },
                    error: () => { delete store._tasksBarInflight[workspace]; store.tasksBar_done(workspace); resolve(null) } })
            })
            store._tasksBarInflight[workspace] = p
            return p
        },
        // IE 2026 09 25 / ODOO-… (замечание Игоря 25.09: «если поиск не дал списка … поиск по позициям только на другом языке»): названия ЗАПИСЕЙ пунктов панелей-меню
        // (страницы, виджеты, задачи, столы) на ВСЕХ языках интерфейса — бэк catalog_titles(langs='all') → { id: { en, uk, ru } }: кэш на сеанс по id (menuTitles; null —
        // записи нет либо бэк без langs: в ответе нет titles), ОДИН запрос на новые id (панель просит при первом «пустом» результате поиска), ответ поднимает
        // menuTitles_epoch → панели перечитывают имена; без ответа 30 с — id снова можно спросить. Счётчики _menuTitlesStats {requests, ids}
        menuTitles_get(id) {
            void this.menuTitles_epoch
            const v = this.menuTitles[String(id ?? '')]
            return v || null
        },
        menuTitles_fetch(ids) {
            const store = this
            const want = []
            for (const raw of (ids || [])) {
                const id = String(raw ?? '').trim()
                if (id && !(id in store.menuTitles) && !store._menuTitlesInflight[id] && !want.includes(id)) want.push(id)
            }
            if (!want.length) return Promise.resolve(0)
            const now = Date.now()
            for (const id of want) store._menuTitlesInflight[id] = now
            store._menuTitlesStats.requests++; store._menuTitlesStats.ids += want.length
            return new Promise((resolve) => {
                let done = false
                const tm = setTimeout(() => { if (done) return; done = true; for (const id of want) delete store._menuTitlesInflight[id]; resolve(0) }, 30000)
                const fin = (titles) => {
                    if (done) return
                    done = true; clearTimeout(tm)
                    for (const id of want) {
                        delete store._menuTitlesInflight[id]
                        const e = titles && titles[id]
                        store.menuTitles[id] = (e && e.titles && typeof e.titles === 'object') ? { ...e.titles } : null
                    }
                    store.menuTitles_epoch++
                    resolve(want.length)
                }
                try { store.executeBackendMethod({}, { method: 'catalog_titles', params: { ids: want, langs: 'all' } }, (answer) => fin((answer && answer.titles) || {})) } catch (e) { fin({}) }
            })
        },
        menuTitles_reset() { this.menuTitles = {}; this._menuTitlesInflight = {}; this.menuTitles_epoch++ },   // пробы
        menuPanel_on(kind) {
            void this._settingsEpoch
            if (this.mobileUi?.on) return false
            if (this.setting('fe.ux.menuPanel', true) === false) return false
            return this.setting('fe.ux.menuPanel' + (kind || ''), true) !== false
        },
        // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.1–3.2): панель страниц открывается наведением на кнопку скрытия рейла (кнопка — ВВЕРХУ рейла), название стола
        // освобождается под панель задач. Одно правило для Page.vue (где кнопка) и AppTopbar (где триггер панели страниц). Выключатель
        // fe.ux.pagesPanelOnRailToggle (по умолчанию вкл.; false — кнопка внизу, панель на названии стола, как раньше); без панелей функций и в мобильном профиле — нет
        pagesPanel_onRailToggle() {
            return this.menuPanel_on('Page') && this.setting('fe.ux.pagesPanelOnRailToggle', true) !== false
        },
        // IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню):
        // кнопка «Страницы» — в шапке (AppTopbar), а не вверху рейла (Page.vue): одно правило для обоих. Выключатель fe.ux.pagesButtonInTopbar (по умолчанию вкл.);
        // нужна панель страниц на кнопке (pagesPanel_onRailToggle) — иначе открывать из шапки нечего, и всё остаётся как было
        pagesButtonInTopbar_on() {
            void this._settingsEpoch
            return this.pagesPanel_onRailToggle() && this.setting('fe.ux.pagesButtonInTopbar', true) !== false
        },
        // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): одна форма меню рабочей области (кнопка ⊞ шапки, «⋮», правая кнопка по столу) с вкладками Menu / Pages / Tasks — меню страницы, страницы стола, задачи;
        // кнопки «Страницы» в шапке нет, список страниц — вкладкой формы и пунктом «All pages…» внизу рейла (Page.vue). Выключатель fe.ux.workspaceMenuTabs (дефолт ВКЛ;
        // false — прежние три формы и кнопка «Страницы»); без панелей функций (мобильный профиль, fe.ux.menuPanelPage = false) — нет
        workspaceMenuTabs_on() {
            void this._settingsEpoch
            return this.menuPanel_on('Page') && this.setting('fe.ux.workspaceMenuTabs', true) !== false
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2 — «Показывать ее по нажатию на … заголовок с тайтлом рабочей области»): форма меню рабочей области —
        // на названии стола в шапке (клик; наведение не открывает), без отдельной кнопки ⊞, без прежней панели задач на названии и без панели страниц / кнопки вверху рейла
        // (скрыть / показать рейл — последняя строка вкладки Pages формы). Выключатель fe.ux.workspaceMenuOnTitle (дефолт ВКЛ; false — как в этапе 1); нужна сама форма (workspaceMenuTabs_on)
        workspaceMenuOnTitle_on() {
            void this._settingsEpoch
            return this.workspaceMenuTabs_on() && this.setting('fe.ux.workspaceMenuOnTitle', true) !== false
        },
        // открыть форму меню рабочей области на вкладке tab ('menu' | 'pages' | 'tasks'); at { x, y } — у точки (пункт рейла), иначе под кнопкой ⊞. Форма живёт в AppTopbar; нет её — false
        workspaceMenu_open(tab, at) {
            const tb = this.AppTopbar
            if (!tb || typeof tb.workspaceMenu_show !== 'function') return false
            return tb.workspaceMenu_show(tab, at)
        },
        // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): раскрывать ли меню наведением мыши — опция пользователя store.menuHoverOpen (по умолчанию выкл: только клик); выключатель базы
        // fe.ux.menuHoverOption (дефолт ВКЛ; false — прежнее поведение: наведение раскрывает, пункта в меню пользователя нет). Подсказки (Alt / Show tooltips) от опции не зависят
        menuHoverOption_flag() { void this._settingsEpoch; try { return this.setting('fe.ux.menuHoverOption', true) !== false } catch (e) { return true } },   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
        menuHoverOpen_on() { return !this.menuHoverOption_flag() || this.menuHoverOpen === true },   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
        // пауза наведения (мс) перед открытием форм-меню шапки (MenuPanel openDelay): fe.ux.menuHoverOpenMs, по умолчанию 350; 0 — только клик
        menuHoverOpenMs() {
            void this._settingsEpoch
            const v = Number(this.setting('fe.ux.menuHoverOpenMs', 350))
            return Number.isFinite(v) && v >= 0 ? v : 350
        },
        // скрыть / показать рейл страниц — ЕДИНАЯ реализация (строка панели страниц в шапке, кнопка рейла, прежняя кнопка внизу): состояние store.pagesRailHidden
        // и localStorage pagesRail (на все столы); Page.vue следит за store.pagesRailHidden; раскладку текущей страницы пересчитываем сразу (setStyle без дебаунса)
        pagesRail_toggle() {
            this.pagesRailHidden = !this.pagesRailHidden
            try { localStorage.setItem('pagesRail', this.pagesRailHidden ? 'hidden' : 'shown') } catch (e) { /* приватный режим */ }
            nextTick(() => {
                const WS = this.activeWORKSPACE
                const MA = WS && WS.PAGES && WS.PAGES[WS.active_page]?.mainArea?.vueObj
                if (MA?.setStyle) MA.setStyle(0)
                else window.dispatchEvent(new Event('resize'))
            })
        },
        // Значение настройки: override сеанса → значение базы → кодовый дефолт (см. хелперы выше)
        setting(key, def_) {
            const store = this
            if (!store._settingsOverride) {
                let saved = {}
                try { saved = JSON.parse(localStorage.getItem('feSettings') || '{}') } catch (e) { /* приватный режим */ }
                try {
                    // роутер hash-овый: параметры живут и в location.search, и в хвосте hash (как perf_flag)
                    const qs = [location.search || '']
                    const h = location.hash || ''
                    if (h.includes('?')) qs.push('?' + h.slice(h.indexOf('?') + 1))
                    for (const q of qs) {
                        for (const [k, v] of new URLSearchParams(q).entries()) {
                            if (!k.startsWith('fe.')) continue
                            saved[k] = v === 'true' ? true : v === 'false' ? false
                                : (v !== '' && !isNaN(Number(v)) ? Number(v) : v)
                        }
                    }
                } catch (e) { /* нечитаемый URL — без override */ }
                store._settingsOverride = saved
            }
            if (key in store._settingsOverride) return store._settingsOverride[key]
            // IE 2026 09 05 / ODOO-336330: до первого ответа бэка (старт, проверка сессии) — зеркало прошлого входа
            if (!store.settings && store._settingsMirror === undefined) {
                try { store._settingsMirror = JSON.parse(localStorage.getItem('feSettings.db') || 'null') } catch (e) { store._settingsMirror = null }
            }
            const v = feSettingPath(store.settings || store._settingsMirror, key)
            return (v === undefined || v === null || v === '') ? def_ : v
        },
        // IE 2026 09 26 / ODOO-5800: отмена запросов бэка (utils/netCancel.js) — номер действия в виде для бэка ('<вкладка>-<N>', fe.net.actionIdUnique),
        // выключатель ключа отмены бэка (fe.net.cancelKeyScoped → debug_flags), ответ 204 без TypeError (fe.net.cancel204Safe)
        net_actionId(n, kind = 'action') { return netCancel_actionId(this, n, kind) },
        net_requestParams() { return netCancel_requestParams(this) },
        net_on204(WIDGET, opts = {}) { return netCancel_on204(this, WIDGET, opts) },
        // IE 2026 09 05 / ODOO-336330: настройки, которые действуют не таймером, а состоянием стора — применить сразу
        settings_applyEffects() {
            const store = this
            try { store.chipsBarPosition = store.setting('fe.appearance.chipsBarPosition', 'topbar') } catch (e) { /* без эффекта */ }
        },
        check_versions(answer) {
            const store = this
            store.version_backend = answer.version_backend
            if (answer?.settings) store.settings_apply(answer.settings)   // IE 2026 09 04 / ODOO-336330
            if (!this.hide_console) console.log(`versions: ${store.version_frontend} ${store.version_backend}`)
        },
        // Clear a session cookie across ALL domain scopes. Backend set_cookie()
        // sets an explicit Domain=<host> attribute (views.py set_cookie), and a JS
        // clear WITHOUT a Domain attribute only expires the host-only cookie — the
        // domain-scoped one survives, so the router guard keeps seeing a stale
        // session_key and loops logout->check_sessionKey forever (ODOO-1757 family).
        clearSessionCookies(dbid=null) {
            const host = location.hostname
            const parent = host.split('.').slice(-2).join('.')
            const scopes = ['', `; Domain=${host}`, `; Domain=.${host}`, `; Domain=.${parent}`]
            const names = ['session_key']
            if (dbid) names.push(`session_key_${dbid}`)
            for (const name of names)
                for (const scope of scopes)
                    document.cookie = `${name}=; Max-Age=0; path=/${scope}`
        },
        logout(to=null, next=null, isLogout=false, error='', _reason='') {
            const store = this
            store.error = error

            const _stack = new Error().stack?.split('\n').slice(2, 5).join(' ← ') || ''
            console.warn(`[logout] reason="${_reason || error || 'n/a'}" isLogout=${isLogout} to=${to?.fullPath || to?.name || null} | ${_stack}`)

            store.isAuthenticated = false
            // csrftoken intentionally kept (LOOK other connections)
            store.clearSessionCookies(store.user?.database?.dbid || (to && to.params && to.params.dbid))

            if (next) {
                if (to.params.dbid) {
                    return next({ name: 'dbLogin', query:to.query, params:to.params })
                } else {
                    return next({ name: 'login' })
                }
            } else {
                if (store.user?.database?.dbid) {
                    store.router.push({ name: 'dbLogin', params:{ dbid:store.user.database.dbid } })
                } else {
                    store.router.push({ name: 'login' })
                }
            }
        },
        // Odoo 350042: mfa = { action, body } — тот же вход, но запрос идёт на POST /auth/mfa/<action> (второй фактор, passkey,
        // подключение фактора по enroll-тикету): успешный ответ у них тот же, что у /login/, и дальше путь общий
        async login(vueObj, user, dbid, rememberMe, FRONTEND_start=null, mfa=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this
            try {
                // const csrftoken = store.getCookie('csrftoken')
                // if (!this.hide_console) console.log(csrftoken)
                let send_start
                vueObj.error = null   // IE 2026 10 16 / ODOO-347204: было '...' (голое многоточие) — теперь прогресс на кнопке входа (Login.vue: loggingIn)
                vueObj.loggingIn = true   // IE 2026 10 16 / ODOO-347204
                // Inject rememberMe into user object so backend can honor cookie persistence
                const userWithRemember = Object.assign({}, user, { rememberMe: !!rememberMe })
                const payload = mfa ? JSON.stringify(mfa.body || {}) : JSON.stringify({   // Odoo 350042
                    frontend_sent_timestamp: Date.now(),
                    // command: 'login',
                    version_frontend: store.version_frontend,
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: userWithRemember,
                    dbid: dbid,
                    route: vueObj.$route.query,
                    isForgotPassword: vueObj.isForgotPassword,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: mfa ? MFA_BASE + mfa.action : store.url_backend_login,   // Odoo 350042
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    // dataType: 'json',
                    // // crossDomain: true,
                    contentType: 'application/json',
                    xhrFields: {
                        withCredentials: true
                    },
                    headers: { // django.middleware.csrf.CsrfViewMiddleware (2)
                        'X-Company': store.extractCompany(user.email),
                        'X-Database': dbid || '',
                    },
                    beforeSend: function (xhr) {
                        send_start = performance.now()
                        // Ensure X-Database is set for nginx route_resolver
                        if (dbid) xhr.setRequestHeader('X-Database', dbid)
                    },
                    success: function (answer, textStatus, jqXHR) {
                        if (!answer || !answer.isAuthenticated) vueObj.loggingIn = false   // IE 2026 10 16 / ODOO-347204: при успехе кнопка остаётся занятой до перехода со страницы
                        // Odoo 350042: пароль принят, нужен второй фактор (или подключение фактора) — сессии нет, куки не трогаем, экран входа ведёт шаг сам
                        if (answer && answer.mfa_required && answer.mfa && typeof vueObj.mfa_start === 'function') {
                            vueObj.mfa_start(answer.mfa)
                            return
                        }
                        if (mfa && !user.email && answer?.user?.email) user.email = answer.user.email   // Odoo 350042: вход passkey без логина — email из ответа
                        store.check_versions(answer)
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        // if (!store.check_loginAfterAjax(vueObj, answer)) return
                        store.isAuthenticated = answer.isAuthenticated
                        if (store.isAuthenticated) {
                            const csrftoken = store.getCookie('csrftoken'),
                                session_key = store.getCookie('session_key')
                            $.ajaxSetup({
                                headers: {
                                    'X-Company': store.extractCompany(user.email),
                                    'X-Database': (user && user.database && user.database.dbid) || '',
                                    'X-CSRFToken': csrftoken
                                },
                                xhrFields: {
                                    withCredentials: true
                                }
                            })

                            store.$reset()
                            store.isAuthenticated = answer.isAuthenticated
                            store.user = store.get_user(answer)
                            // ODOO-5049: отметка времени входа — телеметрия, 13 байт. Без
                            // try/catch переполненный localStorage (QuotaExceededError) роняет
                            // ВЕСЬ обработчик успешного логина: пользователь остаётся на форме
                            // входа с красной плашкой Uncaught runtime error и войти не может.
                            // Причина квоты — не эта запись, а накопившиеся ключи (chipHistory
                            // и т.п.); здесь важно, что необязательная запись не блокирует вход.
                            // Тот же приём уже стоит на fastEntry (см. миграцию v2 выше).
                            try {
                                localStorage.setItem(`session_start_${store.user.database.dbid}`, Date.now())
                            } catch (e) {
                                console.warn('[login] session_start не сохранён (localStorage переполнен):', e?.name || e)
                            }
                            // if (rememberMe) {
                            //     document.cookie = `session_key_${store.user.database.dbid}=${session_key}` // answer.user.session_key
                            // }

                            // ODOO-3733: возврат к исходному запросу после логина. Вход из
                            // документации (docs.webscm.ai) идёт через наш OIDC: /oidc/authorize
                            // без живой сессии уводит на форму логина с ?next=<authorize-url>.
                            // Без обработки next пользователь после ввода пароля попадал на
                            // выбор базы вместо возврата в документацию.
                            // Безопасность: разрешаем ТОЛЬКО свой origin и путь /oidc/ —
                            // иначе параметр стал бы открытым редиректом на чужой сайт.
                            const _next = vueObj.$route.query.next
                            if (_next) {
                                try {
                                    const _u = new URL(_next, window.location.origin)
                                    if (_u.origin === window.location.origin && _u.pathname.startsWith('/oidc/')) {
                                        window.location.href = _u.href
                                        return
                                    }
                                } catch (e) { /* некорректный next — идём обычным путём */ }
                            }

                            // IE 2026 09 26 / ODOO-341407 (fe.i18n.firstLoadHold): явный язык USER (get_user) или настройки базы этого ответа требуют
                            // перезагрузки — выбор базы / get_user_defaults и переход не делаем, перезагрузка сразу (адрес текущий, как у прежнего
                            // пути). Стоит ПОСЛЕ возврата OIDC (next=/oidc/…): уход в документацию важнее, язык уже сохранён как выбор браузера
                            // IE 2026 11 02 / ODOO-350612 (fe.i18n.loginHoldTarget): цель перезагрузки — маршрут базы с тем же query, иначе перезагрузка
                            // того же #/<db>/login снова показывала форму (роутер на маршруте входа сессию не восстанавливает)
                            if (store.i18n_firstLoadHold(answer, 'login', i18n_switchFlag(store, 'loginHoldTarget') ? i18n_loginHoldTarget(vueObj.$route, dbid || store.user?.database?.dbid, answer) : null)) return

                            // NEW infra (webscm.ai): Backend core sends show_database_selector=true
                            // when user logs in without specifying a database.
                            // OLD infra (web-scm.com): flag is never set — users specify database
                            // via "email / company / database" login format.
                            if (answer.show_database_selector && IS_NEW_INFRA) {
                                vueObj.$router.push('/select-database')
                                return
                            }

                            // Fallback: resolve dbid from URL param or login response.
                            // On old infra without show_database_selector, this path handles
                            // direct database entry from the login format.
                            const resolved_dbid = dbid || store.user?.database?.dbid
                            if (!resolved_dbid) {
                                if (IS_NEW_INFRA && store.database_attrs && store.database_attrs.length) {
                                    vueObj.$router.push('/select-database')
                                } else {
                                    store.TERMINAL(null, null, {text: t('No database selected. Please login with a database URL.'), status: 'error'})   // IE 2026 09 23 / ODOO-341407: i18n
                                    vueObj.loggingIn = false   // IE 2026 10 16 / ODOO-347204
                                }
                                return
                            }

                            // ODOO-3749: модель в адрес после логина попадает только если
                            // она была явной в ссылке (историческая). Без неё бэкенд сам
                            // разрешит текущую модель базы — хардкод-фолбэк убран.
                            const process_model = vueObj.$route.query.process_model || ''
                            const pm_part = process_model ? `process_model=${process_model}&` : ''
                            // приоритет workspace при входе (п.2.1):
                            // url > личная настройка (get_user_defaults) > DATABASE (user.workspace_onOpening)
                            store.get_user_defaults((user_defaults) => {
                                const workspace = vueObj.$route.query.workspace || user_defaults.workspace_onOpening || store.user.workspace_onOpening
                                setTimeout(() => {
                                    if (workspace) {
                                        // page из query — доставка ссылок на конкретную страницу через логин (ит.3 п.4.3)
                                        const page = vueObj.$route.query.workspace ? vueObj.$route.query.page : ''
                                        vueObj.$router.push(`/${resolved_dbid}?${pm_part}workspace=${workspace}` + (page ? `&page=${page}` : ''))
                                    } else {
                                        vueObj.$router.push(`/${resolved_dbid}` + (pm_part ? `?${pm_part.slice(0, -1)}` : ''))
                                    }
                                }, 100)
                            })
                        } else {
                            if (answer.requirePasswordChange) {
                                vueObj.requirePasswordChange = true
                                vueObj.enablePasswordChange = true
                            }
                            // ODOO-5710: отказ входа обязан (1) погасить протухшие куки
                            // сессии и (2) сказать словами, что случилось. Раньше не делал
                            // ни того, ни другого: мёртвый session_key оставался в браузере
                            // и уходил со следующим запросом — круг «вход ок → badCookie →
                            // снова вход» не размыкался, а на экране висело поставленное в
                            // начале login() многоточие (answer.notification?.text приходит
                            // не всегда, тогда error становился undefined). Разбор жалобы
                            // 19.08: лечилось только ручной чисткой куков.
                            store.clearSessionCookies(dbid || store.user?.database?.dbid)
                            vueObj.error = answer.notification?.text
                                || t('Sign-in failed. Check your email and password, then try again.')   // IE 2026 09 23 / ODOO-341407: i18n
                        }
                    },
                    error: function (error) {
                        vueObj.loggingIn = false   // IE 2026 10 16 / ODOO-347204
                        if (mfa && typeof vueObj.mfa_fail === 'function') { vueObj.mfa_fail(error); return }   // Odoo 350042: отказ второго фактора — словами на шаге, не «Backend error»
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'critical' })   // IE 2026 09 23 / ODOO-341407: i18n
                        vueObj.error = loginErrorText(error);   // IE 2026 10 16 / ODOO-347204: причина словами (было общее «Backend error»)
                    },
                });
            } catch (error) {
                vueObj.loggingIn = false   // IE 2026 10 16 / ODOO-347204
                store.TERMINAL(null, null, {text:error, status:'error'});
                vueObj.error = t('Backend error (2)');   // IE 2026 09 23 / ODOO-341407: i18n
            }
        },
        async get_menuTree(to, next, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            if (!this.hide_console) console.log('get_menuTree')
            const store = this
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'get_menuTree',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: store.user,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    xhrFields: { withCredentials: true },
                    // crossDomain: true,

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        store.menuTree = answer.menuTree

                        next(to)

                        // pages_menu
                        store.menuTree_model = []
                        for (let i in store.menuTree) {
                            store.menu_push(store.menuTree_model, store.menuTree[i])
                        }
                    },
                    error: function (error) {
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                });
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'});
            }
        },
        menu_push(model_items, menuNode) {
            const store = this

            if (menuNode.use !== false) {
                let to = menuNode.to
                if (menuNode.node?.value && menuNode.node?.attr_type === 'AttrLink') {
                    to = store.workspace_route_to(menuNode.node.value)
                }

                let menu_str = {
                    to: to,
                    label: menuNode.node.valueStr,
                    pi: menuNode.pi,
                    img: menuNode.img,
                }
                // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): id и сегмент записи стола — для подсказки строки списка столов (RailMenu: workspaceTip_fn)
                if (menuNode.node?.value && menuNode.node?.attr_type === 'AttrLink') { menu_str.workspace = menuNode.node.value; menu_str.segment = menuNode.node.relation_segment || '' }
                model_items.push(menu_str)

                if (menuNode.node.name === 'node-WORKSPACES') {
                    store.menu_model_WORKSPACES = menu_str
                }

                if (menuNode.attrs) {
                    let items = []
                    for (let i in menuNode.attrs) {
                        store.menu_push(items, menuNode.attrs[i])
                    }
                    if (items.length)
                        menu_str.items = items // for WORKSPACE
                }

                if (menuNode.node.name === 'node-WORKSPACES') {
                    // ODOO-3749: пересборка меню раньше выбрасывала накопленные
                    // «последние столы» (они висели ad-hoc на прежнем объекте).
                    // Восстанавливаем из state ПОСЛЕ attrs-блока (он присваивает
                    // items заново); ссылки строим по ТЕКУЩЕЙ модели. Столы, уже
                    // присутствующие в дереве меню, не дублируем.
                    for (const rw of store.recentWorkspaces) {
                        if (!store.find_menuNode(rw.workspace)) {
                            menu_str.items = menu_str.items || []
                            menu_str.items.push({
                                workspace: rw.workspace,
                                to: store.workspace_route_to(rw.workspace),
                                label: rw.label, pi: rw.pi, img: rw.img,
                            })
                        }
                    }
                }
            }
        },
        touch_recentWorkspace(workspace, label, pi, img) {
            // ODOO-3749: запомнить стол в «последних» (state, переживает пересборку
            // меню) и показать его в разделе WORKSPACES, если его нет в дереве меню
            const store = this
            if (!workspace || store.find_menuNode(workspace)) return
            if (!store.recentWorkspaces.some(rw => rw.workspace === workspace)) {
                store.recentWorkspaces.push({ workspace, label, pi, img })
            }
            const m = store.menu_model_WORKSPACES
            if (m) {
                m.items = m.items || []
                if (!m.items.some(it => it.workspace === workspace)) {
                    const menu_str = { workspace, to: store.workspace_route_to(workspace), label, img }
                    if (!menu_str.img) menu_str.pi = pi || `pi pi-globe`
                    m.items.push(menu_str)
                }
            }
        },
        find_menuNode(workspace, attrs) {
            const store = this
            if (!attrs)
                attrs = store.menuTree
            for (let menuNode of attrs) {
                if (menuNode.node?.value === workspace) {
                    return menuNode
                }
                if (menuNode.id === workspace) {
                    return menuNode
                }
            }
            for (let menuNode of attrs)
                if (menuNode.attrs) {
                    let menuNode2 = this.find_menuNode(workspace, menuNode.attrs)
                    if (menuNode2)
                        return menuNode2
                }
            return null
        },
        // Пользовательские настройки открытия (USER.doc.pages, п.2.1).
        // callback вызывается всегда (в т.ч. при ошибке бэкенда), чтобы не блокировать вход
        // Стоп-кнопка шапки виджета (Widget.vue): оборвать текущий запрос и
        // погасить серверную выборку. Работает и на скелет-кадре (первый
        // widget_open, view ещё не пришёл). Механика: abort xhr здесь +
        // fire-and-forget запрос с del_last_backend_action → бэк ставит
        // cache[action]=False → select останавливается на ближайшем
        // checkpoint (log.stopped_). Лёгкая команда get_user_defaults —
        // только носитель del_last_backend_action.
        // IE 2026 08 21 (заказ Игоря, pageFocus): opts.quiet — остановка фонового
        // виджета при переключении страницы: те же аборты и отмена на бэке, но без
        // warning-нотификаций и переоткрытия «view без данных» (это UX кнопки Stop);
        // полный повтор open сделает активация его страницы (_pageFocusReopen)
        widget_stopLoading(WIDGET, opts = {}) {
            const store = this
            // прогресс-поллер глушим ПЕРВЫМ и безусловно: иначе он держит
            // loadingPct (кнопка Stop не гаснет) и дёргает $forceUpdate
            // каждые 700мс — мерцание вкладок/виджета после остановки
            store.report_progress_stop(WIDGET)
            // id для отмены на бэке снимаем ДО абортов: widget_open несёт свой
            // (_open_action_id), обычные запросы — last_backend_action
            const _cancelIds = new Set()
            if (WIDGET._openRequest && WIDGET._openRequest.readyState !== 4 && WIDGET._open_action_id) {
                _cancelIds.add(WIDGET._open_action_id)
            }
            const _keepWrite = !abort_allowed(WIDGET._activeRequest, saveTruncatedRetry_on((k, d) => store.setting(k, d)))   // IE 2026 10 13 / ODOO-5800: запись в полёте не обрываем и на бэке не отменяем
            if (WIDGET.last_backend_action && !_keepWrite) _cancelIds.add(WIDGET.last_backend_action)   // IE 2026 10 13 / ODOO-5800: !_keepWrite
            try {
                if (!_keepWrite && WIDGET._activeRequest && WIDGET._activeRequest.readyState !== 4) {   // IE 2026 10 13 / ODOO-5800: !_keepWrite
                    WIDGET._activeRequest.abort()
                }
            } catch (e) { console.warn('widget_stopLoading: abort error', e) }
            try {
                // запрос первого открытия (widget_open) живёт отдельно от _activeRequest
                if (WIDGET._openRequest && WIDGET._openRequest.readyState !== 4) {
                    WIDGET._openRequest.abort()
                }
            } catch (e) { /* no-op */ }
            try {
                WIDGET._pollTask = null
                if (WIDGET._pollActiveRequest && WIDGET._pollActiveRequest.readyState !== 4) {
                    WIDGET._pollActiveRequest.abort()
                }
            } catch (e) { /* no-op */ }
            for (const _cancelId of _cancelIds) {
                try {
                    $.ajax({
                        url: store.url_backend_api,
                        type: 'POST',
                        data: JSON.stringify({
                            frontend_sent_timestamp: Date.now(),
                            command: 'get_user_defaults',
                            del_last_backend_action: store.net_actionId(_cancelId, 'cancel'), // IE 2026 09 26 / ODOO-5800: тот же вид номера, что ушёл с запросом
                            ...store.net_requestParams(), // IE 2026 09 26 / ODOO-5800
                            user: store.user,
                        }),
                        contentType: 'application/json',
                        dataType: 'json',
                    })
                } catch (e) { /* fire-and-forget */ }
            }
            WIDGET.loading = false
            if (opts.quiet) { // pageFocus: тихо, без нотификаций и переоткрытия view
                WIDGET._firstLoading = false
                WIDGET._gridTitlesPending = 0
                return
            }
            // ответ уже пришёл и идёт первичная ОТРИСОВКА тела (грид строит кадр
            // из десятков тысяч ячеек): прерываем построение — данные остаются в
            // записи, виджет остаётся управляемым (параметры, повторный запуск)
            if (!WIDGET.firstBackendCheck && (WIDGET._firstLoading || WIDGET._gridTitlesPending > 0)) {
                WIDGET._renderStopped = true
                WIDGET._firstLoading = false
                WIDGET._gridTitlesPending = 0
                store.report_progress_stop(WIDGET)
                WIDGET.notification = {
                    ...(WIDGET.notification || {}),
                    visible: true,
                    status: 'warning',
                    header: '',
                    text: t('Rendering stopped — data is loaded but not drawn. Change parameters or press Refresh to draw it.'),   // IE 2026 09 23 / ODOO-341407: i18n
                }
                WIDGET.vueObj?.$forceUpdate?.()
                console.log(`[${WIDGET.id}] rendering stopped by user`)
                return
            }
            // скелет-кадр (view так и не пришёл): после остановки настроить виджет
            // нельзя — переоткрываем его БЕЗ автоселекта данных (open_view_only:
            // бэк вернёт view с loading=false), настройки становятся доступны
            if (WIDGET.firstBackendCheck && typeof WIDGET._widgetOpen_repeat === 'function') {
                WIDGET.notification = {
                    ...(WIDGET.notification || {}),
                    visible: true,
                    status: 'warning',
                    header: '',
                    text: t('Loading stopped — opening widget settings without data'),   // IE 2026 09 23 / ODOO-341407: i18n
                }
                WIDGET._open_view_only = true
                try { WIDGET._widgetOpen_repeat() } finally { WIDGET._open_view_only = false }
                // firstBackendCheck остаётся true до ответа view — спиннер и
                // Stop-кнопка видны, повторный Stop снова оборвёт запрос
            } else {
                WIDGET.firstBackendCheck = false
                WIDGET.notification = {
                    ...(WIDGET.notification || {}),
                    visible: true,
                    status: 'warning',
                    header: '',
                    text: t('Loading stopped by user'),   // IE 2026 09 23 / ODOO-341407: i18n
                }
            }
            // сырой (нереактивный) WIDGET первого открытия: без пинка компонент
            // не перерисуется — кнопка Stop «зависает» при погашенных флагах
            WIDGET.vueObj?.$forceUpdate?.()
            console.log(`[${WIDGET.id}] loading stopped by user`)
        },

        async get_user_defaults(callback, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            if (!this.hide_console) console.log('get_user_defaults')
            const store = this
            const apply = (answer) => {
                store.user_defaults = {
                    pages: answer?.pages || [],
                    workspace_onOpening: answer?.workspace_onOpening || '',
                }
                callback?.(store.user_defaults)
            }
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'get_user_defaults',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: store.user,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        apply(answer)
                    },
                    error: function (error) {
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                        apply(null)
                    },
                });
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'});
                apply(null)
            }
        },
        // pmKeepView: смена процессной модели БЕЗ пересборки стола. Контекст новой
        // модели берётся тем же get_startup (record + menuTree), но WORKSPACES не
        // сносятся: вид, несохранённые настройки виджетов и глобальные чипсы
        // остаются, данные страницы переселектируются под новую модель.
        // Пересчёт множеств селекторов случится сам: calc_selectors_mark несёт id
        // модели, несовпадение → ensure_selectors_actual на первом же select
        switch_process_model(pm) {
            const store = this
            const workspace = store.activeWORKSPACE?.workspace
            const page = store.activeWORKSPACE?.active_page
            // IE 2026 08 23 / ODOO-5884 (заказ Игоря): модель ДО переключения — по ней найдём открытый виджет процессной модели
            const _oldPmId = store.process_model_record?.id
            const send_start = performance.now()
            $.ajax({
                url: store.url_backend_api,
                type: 'POST',
                data: JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'get_startup',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: store.user,
                    process_model: pm || '',
                }),
                contentType: 'application/json',
                dataType: 'json',
                xhrFields: { withCredentials: true },
                success: function (answer, textStatus, jqXHR) {
                    store.TERMINAL(null, answer, null, send_start, send_start, 1, jqXHR)
                    try { setTimeout(() => store.cascadeDebug_sync(), 1500) } catch (e) { /* режим отладки не критичен */ }   // IE 2026 09 12 (Igor): режим отладки каскада — по базе
                    if (!answer.process_model_record?.id) {
                        // бэк модель не разрешил — честный полный путь через router/setup
                        store.process_model_record = { id: '' }
                        store.router.push({ name: 'db',
                            params: { dbid: store.user.database.dbid },
                            query: { process_model: pm, workspace, page } })
                        return
                    }
                    store.process_model_record = answer.process_model_record
                    // IE 2026 08 22 / ODOO-5884: меню ярлыка модели (Current, What-if
                    // Create/Discard) — под новую модель, иначе висит стартовое
                    if (answer.process_model_menu) store.process_model_menu = answer.process_model_menu
                    if (answer.process_model_current) {
                        store.process_model_current = answer.process_model_current
                    }
                    if (Array.isArray(answer.menuTree)) {
                        store.menuTree = answer.menuTree
                        store.menuTree_model = []
                        for (let i in store.menuTree) {
                            store.menu_push(store.menuTree_model, store.menuTree[i])
                        }
                    }
                    // URL: модель уже в сторе — гвард роутера видит совпадение и
                    // НЕ уходит в setup (стол не сносится)
                    const _resolved = answer.process_model_record.id
                    const _isCurrent = _resolved === store.process_model_current
                    store.router.replace({ name: 'db',
                        params: { dbid: store.user.database.dbid },
                        query: { ...(_isCurrent ? {} : { process_model: _resolved }), workspace, page },
                    }).catch(() => { /* дубль навигации не страшен */ })

                    // все страницы всех столов — пометить к обновлению при активации
                    for (const wsk in store.WORKSPACES) {
                        const WS = store.WORKSPACES[wsk]
                        if (!WS?.PAGES) continue
                        for (const pk in WS.PAGES) {
                            if (WS.PAGES[pk]) WS.PAGES[pk].refresh_needed = true
                        }
                        // IE 2026 08 24 / ODOO-5884 (заказ Игоря): открытые виджеты ЗАПИСЕЙ читают слой
                        // прежней модели/ветки — пометить к перечитыванию (reload при активации страницы)
                        for (const w of (WS.ALL_WIDGETS || [])) {
                            // IE 2026 08 28 / ODOO-5884 (баг Игоря: после Discard branch у отчёта остался
                            // бейдж «Branch copy»): COW-бейдж принадлежит ПРЕЖНЕЙ модели/ветке — в новом
                            // контексте он неверен всегда; снимаем, корректный придёт со следующим widget_open
                            if (w.cow) w.cow = null
                            if (w.close || w.widget === 'widget-selectors') continue
                            const _hasData = w.record?._doc && ('data' in w.record._doc)
                            if (!_hasData && w.record?.id && w.record?.segment) w._pm_reload_needed = true
                        }
                    }
                    // текущая страница: данные — сейчас, вид — на месте
                    const WORKSPACE = store.WORKSPACES[workspace]
                    if (!WORKSPACE) return
                    if (WORKSPACE.record?.doc?.params) {
                        // метка несёт id модели — снимаем явно, чтобы множества
                        // пересчитались первым же select
                        delete WORKSPACE.record.doc.params.calc_selectors_mark
                    }
                    // IE 2026 10 12 / ODOO-345618 (заказ Игоря: параметры панели после смены ПМ): значения параметров стола (раздел «Params» панели ⌄) — под новую модель
                    if (store.pmParams_on()) store.pmParams_refresh(workspace, page, answer.process_model_record.id)
                    const PAGE = WORKSPACE.PAGES?.[page]
                    if (PAGE) PAGE.refresh_needed = false
                    const _newPmId = answer.process_model_record.id
                    for (const W of (WORKSPACE.ALL_WIDGETS || []).filter(w => w.page === page)) {
                        if (W.widget === 'widget-selectors') {
                            W.record.doc.params.WHERE = WORKSPACE.record.doc.params.WHERE
                            W.vueObj?.content_Changed?.()
                            continue
                        }
                        // IE 2026 08 23 / ODOO-5884 (заказ Игоря): виджет процессной модели (страница настроек) привязан к
                        // конкретной модели (widget = pm id). При смене модели (в т.ч. Create/Discard branch) под pmKeepView
                        // он оставался на старой записи (нет вкладки BRANCH, старый заголовок) до refresh — переоткрываем его
                        // под новую модель на том же месте (виджет лёгкий, живёт только на этой странице)
                        if (W.widget_class === 'widget_PROCESS_MODEL' && _newPmId && _newPmId !== _oldPmId
                            && (W.widget === _oldPmId || W.record?.id === _oldPmId)) {
                            const _style = { ...(W.styleWidget || {}) }
                            const _ws = W.workspace, _pg = W.page
                            store.widget_close(W.id, false, true)  // hard-close: убрать старый виджет модели из ALL_WIDGETS, не оставлять скрытым
                            store.executeStoreMethod({}, { command: 'widget_open', widget: _newPmId, workspace: _ws, page: _pg, styleWidget: _style })
                            continue
                        }
                        if (!W.vueObj || W.widget === 'widget-row') continue
                        const hasData = W.record?._doc && ('data' in W.record._doc)
                        if (!hasData) {
                            // IE 2026 08 24 / ODOO-5884 (заказ Игоря): виджет ЗАПИСИ — перечитать запись из
                            // слоя новой модели/ветки (данные могли отличаться в этой витрине)
                            if (W._pm_reload_needed && W.record?.id && W.record?.segment) {
                                delete W._pm_reload_needed
                                store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'reload', record_sendToBackend_exclude: ['_doc'] })
                            } else W.vueObj?.content_Changed?.()
                            continue
                        }
                        if (W.record?.doc?.offset) W.record.doc.offset = 0
                        store.executeStoreMethod(W.vueObj, {
                            command: 'executeWidgetMethod',
                            method: 'select',
                            record_sendToBackend_exclude: ['_doc'],
                            record_sendToFrontend_exclude: [],
                        })
                    }
                    for (const action_after of answer.actions_after || []) {
                        if (action_after.deferred) { store.schedule_deferredAction({}, action_after); continue }
                        store.executeStoreMethod({}, action_after)
                    }
                },
                error: function () {
                    store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                },
            })
        },
        // IE 2026 10 12 / ODOO-345618 (заказ Игоря: параметры панели после смены ПМ): смена модели без пересборки стола (pmKeepView) оставляла запись стола прежней — значения строк параметров
        // (doc.params.fieldsMapping[].attr.value / valueStr) и runtime record.params считал бэк под ПРЕЖНЕЙ моделью. Фоновый workspace_open того же стола
        // под новой моделью (как variantMenu_fetch): из ответа берутся только значения параметров; чипсы, страницы и виджеты не трогаются.
        // Выключатель fe.ux.pmParamsRefresh (false — прежнее поведение); счётчик window.__pmParamsRefresh
        pmParams_on() { return this.setting('fe.ux.pmParamsRefresh', true) !== false },
        pmParams_refresh(workspace, page, pm) {
            const store = this
            const WS = store.WORKSPACES?.[workspace]
            if (!WS?.record || !pm) return
            const payload = JSON.stringify({
                frontend_sent_timestamp: Date.now(), command: 'workspace_open',
                showSQL: store.showSQL, profiling_params: store.profiling_params,
                variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                ...store.dl2_requestParams(),
                process_model: pm,
                workspace_init: {
                    workspace, active_page: page, workspaceClass: 'workspace_main',
                    ...(store.pageVariants[workspace] ? { page_variants: store.pageVariants[workspace] } : {}),
                    ...(store.filtersVariant[workspace] !== undefined ? { filters_variant: store.filtersVariant[workspace] } : {}),
                },
                user: store.user,
            })
            $.ajax({
                url: store.url_backend_api, type: 'POST', data: payload, contentType: 'application/json', dataType: 'json', xhrFields: { withCredentials: true },
                success: function (answer) {
                    if (!answer || !store.check_loginAfterAjax(null, answer)) return
                    // модель успели сменить ещё раз / стол пересобран — ответ устарел
                    if (store.process_model_record?.id !== pm || store.WORKSPACES?.[workspace] !== WS || !WS.record) return
                    const NR = answer?.WORKSPACE?.record
                    if (!NR || NR.id !== WS.record.id) return
                    const rows = WS.record.doc?.params?.fieldsMapping
                    const changedAttrs = []
                    const n = pmParams_merge(rows, NR.doc?.params?.fieldsMapping, changedAttrs)
                    // IE 2026 10 12 / ODOO-345618 (заказ Игоря: параметры панели после смены ПМ) (pmParams-patch v3): ответ бэка несёт у ссылок сырой id — название тем же путём, что панель (AttrChips._resolveChipAttrLinks):
                    // get_valueStr → get_itemsSource по ids; в кэше — сразу, нет — запрос пачкой по сегменту, ответ поднимает itemsSource_change_index,
                    // и панель (watch → _resolveChipValues) подставляет название в те же attr
                    for (const A of pmParams_linkAttrs(changedAttrs)) { try { store.get_valueStr({}, A, A) } catch (e) { /* название — не критично */ } }
                    if (NR.params) WS.record.params = pmParams_runtime(WS.record.params, NR.params)
                    // новый массив — computed панели (AttrChips.dropdownTabs) пересчитывается и при правке значений внутри строк
                    if (n && Array.isArray(rows)) WS.record.doc.params.fieldsMapping = [...rows]
                    try { window.__pmParamsRefresh = { pm, workspace, changed: n, at: Date.now() } } catch (e) { /* счётчик не критичен */ }
                    if (!store.hide_console) console.log(`pmParamsRefresh: ${workspace} under ${pm} — ${n} param rows updated`)
                },
            })
        },
        // Агрегированный старт (−2 RTT): process model + user defaults + menuTree
        // одним запросом вместо цепочки get_process_model → get_user_defaults →
        // get_menuTree. menuTree в ответе построен для РАЗРЕШЁННОЙ модели, поэтому
        // в redirect-кейсе (pm в URL ≠ актуальной) повторный запрос меню не нужен.
        // Fallback: если бэк не знает get_startup (нет menuTree в ответе) — старая цепочка.
        async get_startup(to, next, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            if (!this.hide_console) console.log('get_startup')
            const store = this
            store.navigator_settingsLoad()   // demo-webscm 2026 11 02 / ODOO-350612 (live48): настройки навигатора — у бэка стенда, параллельно старту, один раз за вход в базу
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'get_startup',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: store.user,
                    process_model: to.query.process_model||'',
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    xhrFields: { withCredentials: true },

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        // IE 2026 09 26 / ODOO-341407 (fe.i18n.firstLoadHold): бэк пока не кладёт сюда настройки базы (no-op); начнёт (шаг a разбора) —
                        // решение о языке уедет раньше workspace_open: перезагрузка сразу, навигация дальше не идёт
                        if (store.i18n_firstLoadHold(answer, 'get_startup', to?.fullPath ? { fullPath: to.fullPath } : null)) return

                        if (!answer.process_model_record) {
                            if (answer.isAuthenticated === false) {
                                store.isAuthenticated = false
                                next({ path: "/" })
                                return
                            }
                            // старый бэк / ошибка — прежняя пошаговая цепочка
                            store.get_process_model(to, next)
                            return
                        }
                        // IE 2026 09 29 / ODOO-342781 (ревью F2): роль «только чтение» ОТКРЫТОЙ базы — из ответа get_startup (readonly / readonly_policy; нет полей — без роли);
                        // применяем до next() / workspace_open, без await. switch_process_model базу не меняет — ему не нужно
                        try { if (ro_applyRole(store.user, ro_startupRole(answer))) store.readonly_afterChange() } catch (e) { /* роль по базе не применили — вход не ломаем */ }
                        store.process_model_record = answer.process_model_record
                        if (answer.process_model_current) {
                            store.process_model_current = answer.process_model_current
                        }

                        if (answer.user_defaults) {
                            store.user_defaults = {
                                pages: answer.user_defaults.pages || [],
                                workspace_onOpening: answer.user_defaults.workspace_onOpening || '',
                            }
                        }
                        if (Array.isArray(answer.menuTree)) {
                            store.menuTree = answer.menuTree
                            store.menuTree_model = []
                            for (let i in store.menuTree) {
                                store.menu_push(store.menuTree_model, store.menuTree[i])
                            }
                        }

                        // ODOO-3749: дефолтная модель в URL не пишется. Явную модель
                        // в адресе трогаем только если бэк разрешил ДРУГУЮ (запрошенной
                        // нет — фолбэк): тогда адрес чистим/меняем. Совпавшую явную
                        // НЕ вычищаем — это легитимная историческая ссылка.
                        const _resolved = answer.process_model_record.id
                        const _urlPm = (to.query.process_model === _resolved) ? _resolved
                            : (_resolved !== store.process_model_current ? _resolved : '')
                        if ((to.query.process_model || '') !== _urlPm) {
                            // workspace: личная настройка > DATABASE > URL — user_defaults
                            // уже в ответе, RTT не нужен
                            const query = _urlPm ? { process_model: _urlPm } : {}
                            const workspace = (answer.user_defaults || {}).workspace_onOpening || answer.workspace || to.query.workspace
                            if (workspace) {
                                query.workspace = workspace
                            }
                            next({ name:to.name, params:to.params, query })
                        } else if (!Array.isArray(answer.menuTree)) {
                            store.get_menuTree(to, next)
                        } else {
                            next(to)
                        }

                        for (const action_after of answer.actions_after || []) {
                            if (action_after.deferred) { store.schedule_deferredAction({}, action_after); continue }
                            store.executeStoreMethod({}, action_after)
                        }
                    },
                    error: function (error) {
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                });
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'});
            }
        },
        async get_process_model(to, next, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            if (!this.hide_console) console.log('get_process_model')
            const store = this
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'get_process_model',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: store.user,
                    process_model: to.query.process_model||'',
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    xhrFields: { withCredentials: true },
                    // crossDomain: true,

                    beforeSend: function () {
                        send_start = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)

                        if (!answer.process_model_record) {
                            // Auth failed or backend error - redirect to login
                            if (answer.isAuthenticated === false) {
                                store.isAuthenticated = false
                                next({ path: "/" })
                            }
                            return
                        }
                        store.process_model_record = answer.process_model_record
                        if (answer.process_model_current) {
                            store.process_model_current = answer.process_model_current
                        }

                        // ODOO-3749: та же конвенция, что в get_startup — дефолтная
                        // модель в URL не пишется, совпавшую явную не вычищаем
                        const _resolved = answer.process_model_record.id
                        const _urlPm = (to.query.process_model === _resolved) ? _resolved
                            : (_resolved !== store.process_model_current ? _resolved : '')
                        if ((to.query.process_model || '') !== _urlPm) {
                            // приоритет workspace при входе (п.2.1):
                            // личная настройка (get_user_defaults) > DATABASE (answer.workspace)
                            store.get_user_defaults((user_defaults) => {
                                const query = _urlPm ? { process_model: _urlPm } : {}
                                const workspace = user_defaults.workspace_onOpening || answer.workspace || to.query.workspace
                                if (workspace) {
                                    query.workspace = workspace
                                }

                                next({ name:to.name, params:to.params, query: {
                                    // ...to.query,
                                    ...query
                                }})
                            })
                        } else {
                            store.get_menuTree(to, next)
                        }

                        for (const action_after of answer.actions_after || []) {
                            if (action_after.deferred) { store.schedule_deferredAction({}, action_after); continue }
                            store.executeStoreMethod({}, action_after)
                        }
                    },
                    error: function (error) {
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                });
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'});
            }
        },
        getCookie(name) {
            //eslint-disable-next-line
            let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        async printPDF(vueObj, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this, WIDGET = vueObj.WIDGET
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'printPDF',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    record: store.exclude_itemsSourcesView(vueObj.WIDGET.record),
                    user: store.user,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    // async: false,

                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        if (WIDGET.close) { return }            
                        store.TERMINAL(WIDGET, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (!store.check_loginAfterAjax(vueObj, answer)) return
                        if (answer.file_dounloadToFrontend) {
                            let fileWindow = window.open("")
                            fileWindow.document.write(
                                "<iframe width='100%' height='100%' src='" + encodeURI(answer.file_dounloadToFrontend) + "'></iframe>"
                            )
                        }
                    },
                    error: function (error) {
                        store.TERMINAL(WIDGET, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                        WIDGET.loading = false
                    },
                })
            } catch (error) {
                store.TERMINAL(WIDGET, null, {text:error, status:'error'})
            }
        },
        // IE 2026 09 03 / ODOO-11316 (заказ Игоря): универсальный гард несохранённых правок.
        // Обновление данных виджета (select/reload — кнопкой, каскадом селекторов после
        // смены чипсов, активацией страницы, восстановлением свёрнутого) при наличии
        // несохранённых правок сначала спрашивает пользователя диалогом НА САМОМ виджете
        // (Widget.vue, WIDGET._unsavedAsk). Признаки «есть несохранённое»: правленные рукой
        // ячейки грида (corrChip_cells — отчёты/списки) или record._meta.modified (запись).
        unsavedGuard_dirtyInfo(WIDGET) {
            try {
                if (!WIDGET || WIDGET.close || !WIDGET.record) return null
                let gridV = WIDGET.vueObj?.get_vueObj?.('dataSheet')
                if (typeof gridV?.corrChip_cells !== 'function') {
                    const g2 = WIDGET.vueObj?.get_vueObj?.('_doc.data')
                    gridV = (typeof g2?.corrChip_cells === 'function') ? g2 : null
                }
                const cells = gridV ? gridV.corrChip_cells().length : 0
                const recMod = !!(WIDGET.record._meta?.modified && WIDGET.record.id)
                const lazy = this.gridSave_dirty(WIDGET)   // IE 2026 10 13 / ODOO-5800: несохранённые строки гридов ленивых вкладок (saveMethod) — [{ binding, count }]
                const lazyRows = lazy.reduce((a, x) => a + x.count, 0)
                if (!cells && !recMod && !lazyRows) return null
                return { cells, recMod, gridV, lazy, lazyRows }
            } catch (e) { return null }
        },
        unsavedGuard_check(vueObj, action) {
            const store = this, WIDGET = vueObj?.WIDGET
            const info = store.unsavedGuard_dirtyInfo(WIDGET)
            if (!info) return false
            // IE 2026 09 03 / ODOO-11316 (замечание Игоря): «обновление данных» (select)
            // ЗАПИСЬ виджета не трогает — несохранённые настройки при нём не теряются,
            // спрашиваем только про правки ДАННЫХ (corrections). reload перечитывает
            // запись целиком — там спрашиваем и про настройки
            if ((action.method === 'select' || action.approval_code) && !info.cells && !info.lazyRows) return false   // IE 2026 10 09 / ODOO-345618 (F2): и команды согласования — только про правки данных; IE 2026 10 13 / ODOO-5800: + строки ленивых гридов (ответ select подменяет _doc)
            WIDGET._unsavedAsk = {
                text: info.cells   // IE 2026 09 23 / ODOO-341407: i18n
                    ? tn(info.cells, '{n} unsaved correction in this widget. Refreshing will discard it.', '{n} unsaved corrections in this widget. Refreshing will discard them.')
                    : info.lazyRows   // IE 2026 10 13 / ODOO-5800
                        ? tn(info.lazyRows, '{n} unsaved row change in a list of this widget. Refreshing will discard it.', '{n} unsaved row changes in lists of this widget. Refreshing will discard them.')
                        : t('This widget has unsaved settings. Reloading will discard them.'),
                canSave: !!WIDGET.record?.id || !!info.lazyRows,   // IE 2026 10 13 / ODOO-5800: ленивые гриды сохраняются своим saveMethod и без id записи
                _vueObj: vueObj, _action: action,
            }
            return true
        },
        unsavedAsk_answer(WIDGET, what) {
            const store = this, ask = WIDGET._unsavedAsk
            delete WIDGET._unsavedAsk
            if (!ask || !ask._action) return
            const action = { ...ask._action, _unsaved_ok: true }
            if (action.approval_code && action.confirm) action._confirm_accepted = true   // IE 2026 10 09 / ODOO-345618 (F2): окно комментария согласования уже принято — повторно не открывается
            if (what === 'keep') return
            // IE 2026 10 13 / ODOO-5800: строки ленивых гридов (saveMethod): Save — сначала они (по очереди), при успехе — прежний путь (запись / действие);
            // ошибка сохранения — стоп (тост, полоса остаётся). Discard — строки последней загрузки обратно, затем действие
            if (this.gridSave_dirty(WIDGET).length) {
                if (what === 'save') {
                    store.gridSave_saveAll(WIDGET, (ok) => {
                        if (!ok || WIDGET.close) return
                        const rest = store.unsavedGuard_dirtyInfo(WIDGET)
                        const needRecord = !ask.lazyOnly && rest && (rest.cells || (rest.recMod && action.method !== 'select')) && WIDGET.record?.id
                        if (needRecord) {
                            store.executeStoreMethod(WIDGET.vueObj, { command: 'onSaveRecord__Click', params: { closeWindow: false }, record_sendToBackend_exclude: ['_doc'], actions_after: [action] })
                        } else {
                            store.executeStoreMethod(ask._vueObj || WIDGET.vueObj, action)
                        }
                    })
                    return
                }
                store.gridSave_discardAll(WIDGET)
                if (ask.lazyOnly) { store.executeStoreMethod(ask._vueObj || WIDGET.vueObj, action); return }
            }
            if (what === 'save') {
                if (!ask.canSave) return
                // сохранение записи (корректировки отчёта уезжают вместе с ней — undoStack
                // в send), обновление — ТОЛЬКО после успешного сохранения (actions_after
                // выполняется в success-ветке saveRecord; при ошибке сейва правки остаются)
                store.executeStoreMethod(WIDGET.vueObj, {
                    command: 'onSaveRecord__Click', params: { closeWindow: false },
                    record_sendToBackend_exclude: ['_doc'],
                    actions_after: [action],
                })
                return
            }
            // refresh without saving: снять dirty-состояние (данные заместит ответ select/reload)
            const info = store.unsavedGuard_dirtyInfo(WIDGET)
            if (info?.gridV) {
                info.gridV.undoStack.length = 0
                info.gridV.redoStack && (info.gridV.redoStack.length = 0)
                info.gridV.changesStack = {}
                info.gridV.corrChip_update?.()
            }
            // IE 2026 09 03 / ODOO-11316 (замечание Игоря): флаг записи не гасим —
            // select настройки не сохраняет и не теряет (жёлтая дискета шапки должна
            // остаться), а reload перечитает запись и снимет флаг сам
            store.executeStoreMethod(ask._vueObj || WIDGET.vueObj, action)
        },
        // IE 2026 10 13 / ODOO-5800 (Igor: «я ожидаю, что смогу менять такие динамические списки с возникновением кнопки сохранить над ними»): гриды ленивых вкладок с saveMethod.
        // Состояние — WIDGET._gridSave[binding] (markRaw, бэку не уходит: get_widget_to_transfer берёт поля WIDGET по списку): base — снимок последней загрузки
        // (utils/gridSaveBar.gridSave_baseline), saveMethod, keyField, rowsOf / setRows — строки грида, vm — компонент грида (полоса)
        gridSave_on() {
            return gridSaveBar_on((k, d) => this.setting(k, d))
        },
        gridSave_state(WIDGET, binding, attr, saveMethod) {
            if (!WIDGET || !binding) return null
            if (!WIDGET._gridSave) WIDGET._gridSave = markRaw({})
            let st = WIDGET._gridSave[binding]
            if (!st) {
                const store = this
                st = WIDGET._gridSave[binding] = markRaw({
                    base: null, saveMethod, keyField: attr?.saveKey || 'id', vm: null, saving: false,
                    rowsOf: () => { try { const v = store.attr_get(WIDGET, attr); return Array.isArray(v) ? v : [] } catch (e) { return [] } },
                    setRows: (rows) => store.attr_set(WIDGET, attr, rows, null, null, false),
                })
                this.gridSave_unloadGuard()
            }
            return st
        },
        gridSave_dirty(WIDGET) {
            if (!WIDGET?._gridSave || !this.gridSave_on()) return []
            const map = WIDGET._gridSave
            return gridSave_dirtyList(map, (b) => map[b].rowsOf(), { raw: toRaw })
        },
        // IE 2026 10 13 / ODOO-5800 (бот prod ie-dm-app7 ev21: «Confirm» панели при несохранённой правке грида стёр правку и полосу): пока у виджета есть несохранённые строки ленивого
        // грида, команда панели (executeWidgetMethod: Confirm, Refresh грида …) не выполняется — предупреждение «Save or discard the changes first». Флаг fe.ux.gridSaveGuard (дефолт ВКЛ)
        gridSave_guardBlocks(WIDGET, action) {
            try {
                if (!WIDGET || WIDGET.close || !WIDGET._gridSave || !this.gridSave_on() || !gridSaveGuard_on((k, d) => this.setting(k, d))) return false
                if (!gridSave_guardVerdict(action, this.gridSave_dirty(WIDGET), true).block) return false
                this.show_notification({ text: t('Save or discard the changes first'), status: 'warning' })
                return true
            } catch (e) { return false }
        },
        gridSave_vm(st) {
            const vm = st?.vm
            return vm && !vm.$?.isUnmounted ? vm : null
        },
        // строки грида = сохранённое / загруженное состояние: признаки правок строк сняты, новый снимок, перерисовка грида
        gridSave_rebase(WIDGET, binding) {
            const st = WIDGET?._gridSave?.[binding]
            if (!st) return
            const rows = st.rowsOf()
            for (const r of rows) { if (r?._meta) { delete r._meta.modified; delete r._meta.new } }
            st.base = gridSave_baseline(toRaw(rows), toRaw)
            st.pend = null   // IE 2026 10 13 / ODOO-5800: правок против нового снимка нет — возвращать нечего
            this.gridSave_vm(st)?.gridSave_resetView?.()
        },
        // Save одного грида: executeWidgetMethod(saveMethod, params { binding, changed, added, deleted }); успех — строки ответа (rows / updateDoc
        // record.<binding>) заменяют _doc.<binding>; ошибка / обрыв — тост (TERMINAL), полоса остаётся. onDone(ok)
        gridSave_saveOne(WIDGET, binding, onDone = null) {
            const store = this, st = WIDGET?._gridSave?.[binding]
            const done = (ok) => { if (typeof onDone === 'function') { try { onDone(ok) } catch (e) { console.warn('gridSave onDone', e) } } }
            if (!st?.base || !st.saveMethod || st.saving || WIDGET.close) { done(false); return }
            const d = gridSave_diff(st.rowsOf(), st.base, { raw: toRaw, keyField: st.keyField })
            if (!d.count) { done(true); return }
            const setSaving = (on) => { st.saving = on; const vm = store.gridSave_vm(st); if (vm) vm.gridSave_saving = on }
            setSaving(true)
            const action = {
                command: 'executeWidgetMethod', method: st.saveMethod, binding,
                params: gridSave_payload(binding, d),
                record_sendToBackend_exclude: ['_doc'],
                _gridSave: true,
                _onResponse: (answer) => {
                    setSaving(false)
                    // IE 2026 10 13 / ODOO-5800: успех — ТОЛЬКО со свежими строками в ответе; иначе (в т.ч. ответ с одними errors, без rows и notification) — полоса и правки остаются + тост
                    const o = gridSave_outcome(answer, binding)
                    if (!o.ok) {
                        if (!o.shown) store.show_notification({ text: o.text, status: 'error' })
                        store.gridSave_vm(st)?.gridSave_refresh?.(); done(false); return
                    }
                    st.pend = null   // IE 2026 10 13 / ODOO-5800: сохранённые правки назад поверх ответа не возвращать (fe.ux.gridSaveGuard)
                    if (toRaw(st.rowsOf()) !== toRaw(o.rows)) st.setRows(o.rows)
                    store.gridSave_rebase(WIDGET, binding)
                    if (o.hint) store.show_notification({ text: o.hint, status: 'info' })   // IE 2026 10 13 / ODOO-5800: hint ответа — один info-тост
                    done(true)
                },
                // обрыв (abort) — _onResponse не зовётся: снять «сохраняется», полоса остаётся
                _onAbort: () => { setSaving(false); store.gridSave_vm(st)?.gridSave_refresh?.(); done(false) },
            }
            store.executeStoreMethod(WIDGET.vueObj || store.gridSave_vm(st), action)
        },
        gridSave_discardOne(WIDGET, binding) {
            const st = WIDGET?._gridSave?.[binding]
            if (!st?.base || st.saving) return
            st.pend = null   // IE 2026 10 13 / ODOO-5800: Discard — возвращать правки поверх строк снимка не нужно (fe.ux.gridSaveGuard)
            st.setRows(gridSave_restoreRows(st.base))
            this.gridSave_rebase(WIDGET, binding)
        },
        // все несохранённые ленивые гриды виджета — по очереди (запросы виджета не параллелятся); первый неуспех — стоп
        gridSave_saveAll(WIDGET, onDone = null) {
            const list = this.gridSave_dirty(WIDGET).map((x) => x.binding)
            const next = (i) => {
                if (i >= list.length) { if (typeof onDone === 'function') onDone(true); return }
                this.gridSave_saveOne(WIDGET, list[i], (ok) => { if (!ok) { if (typeof onDone === 'function') onDone(false); return } next(i + 1) })
            }
            next(0)
        },
        gridSave_discardAll(WIDGET) {
            for (const x of this.gridSave_dirty(WIDGET)) this.gridSave_discardOne(WIDGET, x.binding)
        },
        // закрытие виджета (Close Widget / Alt W) при несохранённых строках ленивых гридов — тот же диалог на виджете: Save & close / Close without saving / Keep editing
        gridSave_closeGuard(vueObj, action) {
            const WIDGET = vueObj?.WIDGET
            if (!WIDGET || action?._unsaved_ok) return false
            const n = this.gridSave_dirty(WIDGET).reduce((a, x) => a + x.count, 0)
            if (!n) return false
            WIDGET._unsavedAsk = {
                text: tn(n, '{n} unsaved row change in a list of this widget. Closing will discard it.', '{n} unsaved row changes in lists of this widget. Closing will discard them.'),
                canSave: true, lazyOnly: true,
                saveLabel: t('Save & close'), discardLabel: t('Close without saving'),
                _vueObj: vueObj, _action: action,
            }
            return true
        },
        // закрытие / перезагрузка вкладки браузера при несохранённых строках ленивых гридов — штатное предупреждение браузера (регистрируется один раз)
        gridSave_unloadGuard() {
            if (this._gridSaveUnload || typeof window === 'undefined') return
            this._gridSaveUnload = true
            const store = this
            window.addEventListener('beforeunload', (e) => {
                try {
                    if (!store.gridSave_on()) return
                    for (const WS of Object.values(store.WORKSPACES || {})) {
                        for (const W of (WS?.ALL_WIDGETS || [])) {
                            if (W && !W.close && W._gridSave && store.gridSave_dirty(W).length) { e.preventDefault(); e.returnValue = ''; return '' }
                        }
                    }
                } catch (err) { /* предупреждение не роняет выгрузку */ }
            })
        },
        confirm_command(vueObj, action, form_attr, FRONTEND_start, event) {
            const store = this,
            message = typeof action.confirm === 'string'
                ? action.confirm
                : `${String(action.title || action.tooltip || '').trim()}?`
            store.App.$confirm.require({
                message: message,
                header: t('Confirmation'),   // IE 2026 09 23 / ODOO-341407: i18n
                icon: 'pi pi-exclamation-triangle',
                acceptClass: 'p-button-danger',
                accept: () => {
                    action._confirm_accepted = true
                    store.executeStoreMethod(vueObj, action, form_attr, FRONTEND_start, event)
                },
            })
        },
        executeStoreMethod(vueObj, action, form_attr=null, FRONTEND_start=null, event=null) {
            if (vueObj === null || vueObj === undefined) {
                return
            }
            // IE 2026 11 01 / ODOO-350449 (заказ Игоря: кругові діаграми за статусами у клітинках REPORT2, опції зрізу і їх розміщення):
            // кнопка вида ячеек (поля view + front_only из set_menu) переключается на фронте — без запроса и без записи в отчёт; флаг fe.ux.cellStatusPie ВЫКЛ — обычная опция
            if (cellPie_isViewButton(action) && this.cellView_toggle(vueObj, action)) return
            if (action?.method === CELL_VIEWS_METHOD && !this.cellView_beforeSend(vueObj, action)) return   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): отложенный / немедленный запрос данных видов ячеек
            if (this.user?.readonly === true && this.readonly_denyStore(action)) return   // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F4 + F6): роль «только чтение» — фронтовые команды записи (клон, сохранение, импорт, Paste / Import rows …) отклоняются ДО confirm и до любого изменения локального состояния (клон портил живую запись раньше, чем saveRecord отказывал); без роли — как было
            if (action?.confirm) {
                // универсальная опция confirm: команда выполняется только после
                // подтверждения; accept — повторный вызов с одноразовым маркером
                if (action._confirm_accepted) {
                    delete action._confirm_accepted
                } else if (action.confirm_input) {
                    // IE 2026 08 23 / ODOO-5884 (заказ Игоря): подтверждение с редактируемым полем (имя ветки)
                    const store = this
                    store.confirmInput.header = action.title || t('Confirmation')   // IE 2026 09 23 / ODOO-341407: i18n
                    store.confirmInput.message = typeof action.confirm === 'string' ? action.confirm : ''
                    store.confirmInput.label = action.confirm_input.label || ''
                    store.confirmInput.value = action.confirm_input.value || ''
                    // IE 2026 08 24 / ODOO-5884 (заказ Игоря «частичная полная версия»): чекбоксы состава
                    store.confirmInput.options = (action.confirm_input.options || []).map(o => ({ ...o, checked: !!o.default }))
                    store.confirmInput.required = !!action.confirm_input.required   // IE 2026 10 09 / ODOO-345618
                    store.confirmInput.exclusive = !!action.confirm_input.exclusive
                    store.confirmInput.optionsRequired = !!action.confirm_input.optionsRequired
                    store.confirmInput.date = action.confirm_input.date ? { field: String(action.confirm_input.date.field || 'date'), label: action.confirm_input.date.label || '', value: action.confirm_input.date.value || '' } : null   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-ci1 FE1: поле даты (Set due)
                    store.confirmInput.invalid = false
                    store.confirmInput._action = action
                    store.confirmInput._vueObj = vueObj
                    store.confirmInput.visible = true
                    return
                } else {
                    this.confirm_command(vueObj, action, form_attr, FRONTEND_start, event)
                    return
                }
            }
            if (action?.prompt) {
                // IE 2026 08 19 / ODOO-… (S&OP cycle): универсальная опция prompt —
                // текст запрашивается у пользователя перед командой и уезжает на бэк
                // в params[prompt_field || 'comment'] (Approve/Return шага цикла S&OP)
                const promptText = window.prompt(typeof action.prompt === 'string' ? action.prompt : (action.title || t('Comment')), '')   // IE 2026 09 23 / ODOO-341407: i18n
                if (promptText === null) return
                action.params = { ...(action.params || {}), [action.prompt_field || 'comment']: promptText }
            }
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this, WIDGET = vueObj.WIDGET
            // IE 2026 08 23 / ODOO-5884 (заказ Игоря): универсальная опция progress — окно прогресса на время
            // синхронной команды бэка (executeBackendMethod снимает его по ответу/ошибке)
            if (action?.progress && action.command === 'executeBackendMethod') {
                store.show_progress({ header: action.title || action.tooltip || '', text: action.progress })
            }
            action.action_id_front = ++store.action_id_front
            if (!this.hide_console) console.log(`[${WIDGET?.id}][${action.action_id_front}]${action.command} ${action.method} START`)
            if (store.testRecording.active) testRecorder.onAction(store, WIDGET, action)
            let action_binding = action.binding
            if (!action_binding && form_attr !== null) {
                action_binding = action.binding = form_attr.binding
            }
            // if (!form_attr !== null) { is error for grid.commandPalete
            //     form_attr = vueObj.get_vueObj?.(action.source_name || action.binding).attr
            // }
            switch (action.command) {
                case 'attrFrontMethod': {   // IE 2026 09 13 / ODOO-335246 (Igor): кнопка командной панели зовёт метод vue-компонента attr (масштаб графа)
                    const v = WIDGET?.attrs_vueObj?.[action.attr_target]
                    if (v && typeof v[action.method] === 'function') v[action.method](...(action.args || []))
                    return
                }
                // --- Test recorder: запись/стоп/прогон/список (см. testRecorder.js) ---
                case 'test_record_start':
                    testRecorder.start(store, { targetWidgetId: WIDGET?.id }); return
                case 'test_record_stop':
                    testRecorder.stop(store); return
                case 'test_replay':
                    testRecorder.replay(store, WIDGET, { test: true }); return
                case 'test_open_list':
                    testRecorder.openList(store); return
                case 'cascade_debug_toggle':   // IE 2026 09 11 / ODOO-335246 (Igor): меню Debug → Cascade debug
                    store.cascadeDebug_toggle(); return
                case 'settingsForm_prefetch':   // IE 2026 09 28 / ODOO-5800: отложенная (P2) догрузка формы настроек виджета
                    if (WIDGET) store.settingsForm_ensure(WIDGET, action.reason || 'prefetch')
                    return
                case 'widgets_multiply': {   // IE 2026 09 15 / ODOO-… (заказ Игоря): тираж виджета страницы по строкам виджета-списка
                    this.widgets_multiply(action)
                    break
                }
                case 'widget_open': {
                    // Кнопка «?» (документация): в бэкенд уезжает вкладка, на
                    // которой человек стоял В МОМЕНТ нажатия — по ней виджет
                    // документации прокручивается к нужному разделу
                    if (action.pass_activeTab) {
                        // IE 2026 09 24 / ODOO-341407: кандидаты — активные вкладки видимых панелей, от вложенной к главной (widget_tabAnchors);
                        // бэк (widget_DOCS) дописывает якорь самой ссылки, AttrMD прокручивает к первому найденному
                        const _anchors = this.widget_tabAnchors(WIDGET)
                        action.params = { ...(action.params || {}), anchor: _anchors.length > 1 ? _anchors : (_anchors[0] || '') }
                    }
                    let widget_init = {
                        record:{
                            _meta: {},
                        },
                        widget: action.widget,
                        fieldsMapping: action.fieldsMapping || [],
                        widget_class: action.widget_class,
                        parentAction: action,
                        styleWidget: action.styleWidget || {},
                        area: action.area,
                        externalLink_method: action.externalLink_method,
                        // запрошенная вкладка (по name) — активирует AttrTabPanel после открытия
                        selectTab: action.selectTab,
                        // IE 2026 09 11 / ODOO-… (заказ Игоря): вкладка из сохранённой раскладки страницы (layout.tab) — применяет AttrTabPanel
                        layoutTab: action.layoutTab,
                        // IE 2026 09 15 / ODOO-… (заказ Игоря): экземпляр тиража — ключ строки-источника и описание (widgets_multiply)
                        ...(action.multiply_key ? { multiply_key: action.multiply_key, _multiply: action._multiply } : {}),
                    }
                    delete action.externalLink_method

                    if (action.get_currentRow) {
                        let selectedRow = action.selectedRow || vueObj.get_selectedRow(action_binding)
                        widget_init.record._record = structuredClone(selectedRow?.dataItem || {})
                        
                        widget_init.record._meta.binding = action_binding
                        widget_init.record._meta.col_binding = action.col_binding
                        widget_init.record._meta.attrs = store.clear_attrItemsSource(action.attrs)
                        widget_init.record._meta.viewParams = action.viewParams
                        widget_init.record._meta.iroot = selectedRow?.iroot
                        widget_init.record._meta.range = action.range
                        widget_init.record._meta.x = selectedRow?.x
                        widget_init.record._meta.y = selectedRow?.y
                    }

                    // Guided task flows: шаг ведёт на СВОЙ объект — id виджета лежит
                    // в поле строки (action.widget_binding), а не в статичном action.
                    // Пустое поле = шагу некуда вести, кнопка ничего не делает
                    if (action.widget_binding) {
                        const target = vueObj.get_selectedRow(action_binding)?.dataItem?.[action.widget_binding]
                        if (!target) break
                        widget_init.widget = target
                    }

                    if (action.item) {
                        widget_init.record = action.item
                        if (!widget_init.record.id) {
                            widget_init.record._meta = widget_init.record._meta || {}
                            widget_init.record._meta.new = true
                            widget_init.record._meta.modified = true
                        }

                    } else if (action.get_currentRow_with_meta) {
                        let get_selectedRow = vueObj.get_selectedRow(action_binding)
                        widget_init.record = get_selectedRow?.dataItem || {}

                        if (action.binding2) {
                            const V = widget_init.record[action.binding2]
                            if (!store.isinstance_dict(V) || V.attr_type !== 'AttrLink') {
                                break
                            }
                            widget_init.record = {
                                title: widget_init.record[action.binding2].valueStr,
                                id: widget_init.record[action.binding2].value,
                                segment: widget_init.record[action.binding2].relation_segment,
                            }
                        }
                    } else if (widget_init.widget === 'widget-row') {
                        const _meta = widget_init.record._meta
                        _meta.type = action.type || 'widget-row'
                        _meta.name = action.source_name || ''
                        _meta.attr_type = action.source_attr_type || null

                        if (_meta.type === 'widget-row-viewParams') {
                            _meta.binding = action_binding
                            _meta.x = action.selectedCog?.x
                            _meta.y = action.selectedCog?.y

                            // параметры конфига грида (view) с актуальными значениями:
                            // база — attr без структурных/служебных ключей, поверх — viewParams-оверрайды;
                            // при сохранении JSON set_viewParam пишет только изменённые (prev через get_viewParam)
                            const skip_attrKeys = new Set(['attrs', 'id', 'html_id', 'component', 'attr_type', 'binding', 'name', 'template', 'title', 'tooltip', 'use', 'groupMenu', 'view', 'CHIPS'])
                            const attr_params = {}
                            for (const [key, val] of Object.entries(form_attr)) {
                                // _DLRow — исключение из _-фильтра: оформление вида с бэка (cond_format), не служебный ключ
                                if ((!skip_attrKeys.has(key) && !key.startsWith('_')) || key === '_DLRow') {
                                    attr_params[key] = val
                                }
                            }
                            widget_init.record._record = {
                                ...attr_params,
                                ...store.get_value(WIDGET.record, `doc.viewParams.${form_attr.name}`),
                                attrs: form_attr.attrs,
                                // режим привязки с узла грида — бэк по нему добавляет вкладку
                                // tab-itemsSourcesView (ит.2 §1); не зависит от сохранённости записи
                                use_itemsSourcesView: form_attr.use_itemsSourcesView,
                                // ит.4 §2/§3: явный выбор корня реестра; по _target бэк
                                // добавляет вкладку tab-itemsSourcesView-target
                                itemsSourcesView_source: form_attr.itemsSourcesView_source,
                                itemsSourcesView_target: form_attr.itemsSourcesView_target,
                            }
                        
                        } else if (_meta.type === 'widget-row-chip') {
                            _meta.binding = action_binding
                            _meta.x = action.selectedCog?.x
                            _meta.y = action.selectedCog?.y
                            Object.assign(_meta, action.source)
                        }

                        const WRow = (WIDGET.widget === 'widget-row')
                            ? store.get_childrenWidget(WIDGET, 'widget-row')
                            : store.get_widgetRow()

                        // поколение открытия Row: любой открывший/ретаргетящий попап
                        // помечает его новым seq — отложенные selectionChanged-таймеры
                        // других гридов по нему поймут, что Row уже не «их», и не тронут
                        store.widgetRow_openSeq = (store.widgetRow_openSeq || 0) + 1

                        if (_meta.type === 'widget-row-cell') {
                            // номер строки уже в чипе (Row[N]) — префикс [iroot-col] в тайтле не дублируем
                            widget_init.title = _meta.binding
                        } else if (_meta.type === 'widget-row-viewParams') {
                            widget_init.title = _meta.binding
                        } else if (_meta.type === 'widget-row-chip') {
                            widget_init.title = action.source.title
                        } else {
                            widget_init.title = `${WIDGET.title}::${_meta.binding}`
                        }
                        // чип Row[N] известен локально (тип + номер строки из _meta) —
                        // рисуем с первого кадра, не дожидаясь ответа бэка; позже
                        // set_widgetRow_shortTitle пересчитает номер по видимой сортировке
                        store.set_widgetRow_shortTitle(widget_init, _meta)

                        if (WRow) {
                            // IE 2026 10 24 / ODOO-348842 (заказ Игоря: карточка строки открывается на вкладке ⚙ Params): НОВОЕ открытие карточки — после ✕ / Esc (мягкое закрытие),
                            // из другого грида / привязки или другого вида карточки — AttrTabPanel начнёт с вкладки ⚙ заново; ‹ › и клик по другой строке того же грида метки не ставят
                            if (WRow._softClosed || WRow.parentWIDGET?.id !== WIDGET.id || WRow.parentAction?.binding !== action_binding || WRow.record?._meta?.type !== _meta.type) WRow._rowCardTabReset = true   // IE 2026 10 24 / ODOO-348842
                            if (WRow._softClosed) {
                                store._widget_restoreSoftClosed(WRow)
                            }
                            store.addEdgeWidgetRow(WIDGET, WRow, _meta)

                            const isEqualParams = (WRow.parentWIDGET.id === WIDGET.id 
                                && WRow.parentAction.binding === action_binding
                                && (WRow.record._record?.calculationModel||'') === (widget_init.record._record?.calculationModel||'')
                                && ((WRow.record?._meta?.type) === (_meta.type))
                                && ((WRow.record?._meta?.index||0) === (_meta.index||0))
                            )

                            if (action.activeAttr?.binding) {
                                store.set_activeAttr(WRow.view, action.activeAttr, WRow)
                            }

                            if (_meta?.type === 'widget-row-chip') {
                                widget_init.record._record = store.get_chip(WIDGET, _meta) || {}
                            } else {
                                widget_init.record._data = store.get_value(WIDGET.record, _meta.binding) || []
                            }
                            
                            if (isEqualParams) {
                                // store.WRow_finishSetup(widget_init, WIDGET)
                                store.set_widgetRow_shortTitle(WRow, _meta)
                                store.executeStoreMethod(WRow.vueObj, {
                                    command: 'updateDoc',
                                    record: widget_init.record,
                                    title: widget_init.title,
                                })

                                // store.widget_finishSetup(WRow)

                                // const set_attr_binding = (attrs) => {
                                //     attrs.forEach(attr => {
                                //         if (attr.raw_binding) {
                                //             attr.binding = attr.raw_binding;
                                //         }

                                //         if (attr.binding && attr.binding.includes("{col_binding}")) {
                                //             attr.raw_binding = attr.binding;
                                //             attr.binding = attr.binding.replace("{col_binding}", _meta.col_binding);
                                //         }

                                //         if (attr.attrs) {
                                //             set_attr_binding(attr.attrs);
                                //         }
                                //     });
                                // };
                                // set_attr_binding(WRow.vueObj.WIDGET.view || []);

                            } else {
                                WRow.parentWIDGET = store.getWIDGET_info(WIDGET)
                                WRow.parentAction = action
                                WRow.title = widget_init.title
                                store.set_widgetRow_shortTitle(WRow, _meta)

                                // close child widget-rows — content changed, deeper levels are stale
                                store.close_childrenWidgets(WRow, 'widget-row')

                                // рект трогаем ТОЛЬКО при смене источника (ключа):
                                // reuse по тому же источнику (другая строка/точка, restore
                                // после soft-close) сохраняет текущий рект — иначе флеш
                                // «текущий → дефолт/компакт → fit» на каждом клике
                                const _rectKey = store.widgetRowRect_key(WRow)
                                if (WRow._rectKey !== _rectKey) {
                                    WRow._rectKey = _rectKey
                                    const _savedRect = store._widgetRowRects[_rectKey] || store._widgetRowRects_auto[_rectKey]
                                    if (_savedRect) {
                                        WRow.styleWidget.setWidgetRect = 'px'
                                        WRow.styleWidget._savedRect = _savedRect
                                        store.checkPopout()
                                    } else {
                                        // новый источник без сохранённого размера — дефолт
                                        // нового источника, иначе наследуется прежний
                                        // (например, компактный из AttrChart)
                                        const wrp = action.widgetRow_params
                                        WRow.styleWidget.setWidgetRect = ''
                                        if ((WRow._cascadeDepth || 0) === 0 && wrp) {
                                            const w_pct = wrp.width_pct ?? .2
                                            WRow.styleWidget.setWidgetRect = 'pct'
                                            WRow.styleWidget.top_pct = wrp.top_pct ?? .1
                                            WRow.styleWidget.left_pct = wrp.left_pct ?? .8
                                            WRow.styleWidget.width_pct = w_pct
                                            WRow.styleWidget.height_pct = wrp.height_pct ?? .8
                                        } else if ((WRow._cascadeDepth || 0) === 0 && action.source_attr_type !== 'AttrChart') {
                                            // IE 2026 08 19 / ODOO-5512: новый источник — четверть экрана
                                            // в углу напротив ячейки (то же правило, что при первом открытии)
                                            Object.assign(WRow.styleWidget, { setWidgetRect: 'pct' }, store.quarterRect_oppositeCell(vueObj, WRow))
                                            store.checkPopout()
                                        } else {
                                            store.checkWIDGET_dock(WRow, store.findWidget(WRow.parentWIDGET.id)?.WIDGET)
                                        }
                                        // компактный кейс AttrChart: layout с бэка (если уже есть
                                        // на WRow) применится с учётом guard'а по source_attr_type
                                        store.apply_widgetRow_layout(WRow)
                                        store.checkPopout()
                                    }
                                }

                                if (store.version_widget_row === 'frontend') {
                                    store.set_widgetRow_view(WRow)
                                } else {
                                    store.executeWidgetMethod(WRow.vueObj, { 'action_name':'action-front-widget-row-2025-01-19',
                                        command: 'executeWidgetMethod',
                                        method: 'reload',
                                        chosenItem: widget_init.record,
                                        parentAction: action,
                                    }, form_attr, FRONTEND_start)
                                }
                            }

                            // активация: явная команда открытия (_activate — кнопки/меню/cog)
                            // передаёт активность Row; каскадное обновление от кликов по
                            // строкам активного родителя (в т.ч. экшены с бэка) — нет
                            if (action._activate || (!action._noActivate && store.activeWIDGET?.id !== WIDGET.id)) {
                                store.widget_activate(WRow, 'widget-row-viewParams')
                            }
                            break
                        }

                    } else if (action.widget === 'widget-list') {
                        if (action.get_widgetRecord_forParams) {
                            widget_init.props = { id: WIDGET.record?.id }
                            widget_init.fieldsMapping = [
                                {'leftValue':'doc.params.segment', 'rightValue':WIDGET.record?.id},
                            ]
                        } else if (action.get_currentRow_forParams) {
                            const item = vueObj.get_selectedRow(action_binding)?.dataItem
                            if (item) {
                                widget_init.props = { id: item.id || item.segment }
                                widget_init.fieldsMapping = [
                                    {'leftValue':'doc.params.segment', 'rightValue':item.id || item.segment},
                                    {'leftValue':'doc.params.version', 'rightValue':item.version},
                                    {'leftValue':'doc.params.collection', 'rightValue':item._meta?.collection},
                                ]
                            } else {
                                break
                            }
                        } else if (action.new) {
                            // IE 2026 09 25 / ODOO-341407 (№17): пункт страницы More → List (бэк attrs.prepare_pagesTree: widget-list, new: true,
                            // segment WIDGET-LIST) — НОВЫЙ лист: запись сегмента без id, как new у widget-record. Флаг new здесь не читался:
                            // уходил record без сегмента, и бэк (views.widget_open) открывал саму запись-виджет widget-list (список сегментов),
                            // а не новый лист без источника (тот получает WIDGET.activeTab = 'tabSource')
                            widget_init.record = {
                                id: '',
                                segment: action.segment || 'WIDGET-LIST',
                                version: action.version || '',
                                _meta: { new: true, modified: true },
                            }
                        // } else if (action.get_currentRowID_forParams) {
                        //     const item = vueObj.get_selectedRow(action_binding)?.dataItem
                        //     if (item) {
                        //         widget_init.props = { id: item.id }
                        //         widget_init.fieldsMapping = [
                        //             {'leftValue':'doc.params.segment', 'rightValue':item.id},
                        //         ]
                        //     } else {
                        //         break
                        //     }
                        }
                    } else if (action.widget === 'widget-record') {
                        if (action.new) {
                            if (action.segment) {
                                widget_init.record = {
                                    id: '',
                                    segment: action.segment,
                                    version: action.version || '',
                                    _meta: {
                                        new: true,
                                        modified: true,
                                    }
                                }
                            } else {
                                widget_init.record = {
                                    id: '',
                                    segment: WIDGET.record.doc.params?.segment,
                                    version: WIDGET.record.doc.params?.version,
                                    _meta: {
                                        new: true,
                                        modified: true,
                                    }
                                }
                            }
                            if (vueObj.WIDGET?.widget_class === 'widget_TREE') {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка): ?. — пустая форма задачи импорта открывается без родительского виджета (vueObj {})
                                let tree = vueObj.get_flex(action_binding),
                                    node = tree.selectedNode
                                if (node) {
                                    widget_init.record.doc.parent = node.dataItem.id
                                    widget_init.record.doc.order = node.dataItem.order || 0 + 1
                                }
                            }
                        } else {
                            const item = vueObj.get_selectedRow(action_binding)?.dataItem
                            if (item) {
                                widget_init.record = { 
                                    id: item.id,
                                    segment: item.segment,
                                    version: item.version,
                                    '_meta': item._meta,
                                }
                            } else {
                                break
                            }
                        }
                        if (WIDGET?.widget_class === 'widget_LIST') { //  && !widget_init.record.segment   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка): ?. — открытие без родительского виджета
                            // widget_init.record.segment = widget_init.record.segment || WIDGET.record.doc.params?.segment
                            // widget_init.record.version = widget_init.record.version || WIDGET.record.doc.params?.version
                            widget_init.record._meta = widget_init.record._meta || {}
                            widget_init.record._meta.segment = WIDGET.record.doc.params?.segment
                            widget_init.record._meta.version = WIDGET.record.doc.params?.version
                            widget_init.record._meta.collection = WIDGET.record.doc.params?.collection

                            if (!action.new) {
                                const listData = WIDGET.record._doc?.data || []
                                const siblings = listData.map(row => ({ id: row.id, segment: row.segment, version: row.version }))
                                const currentIndex = listData.findIndex(row => row.id === widget_init.record.id)
                                if (siblings.length > 0 && currentIndex >= 0) {
                                    widget_init._nav = { siblings, currentIndex }
                                }
                            }
                        }
                    }

                    store.widget_open(widget_init, vueObj)
                    break
                } case 'executeWidgetMethod_inNewWidget': {
                    let widget = action.widget
                    if (!widget) {
                        const item = vueObj.get_selectedRow(action.name || action_binding)?.dataItem
                        if (item) {
                            widget = item.widget
                    
                            item.date_start = '...'
                            item.created_at = '...'
                            const flex = vueObj.get_flex(action.name || action_binding)
                            flex.refresh()
                        } else {
                            break
                        }
                    }
                    let request = {
                        method: action.method,
                        widget_init: {
                            title: action.title || action.tooltip || '',
                            widget: widget,
                            parentAction: action,
                            process_model: store.process_model_record.id,
                        }
                    }
                    let workspace_record = store.activeWORKSPACE.record
                    if (workspace_record) {
                        // request.widget_init.workspace_record = workspace_record
                        request.widget_init.workspace = workspace_record.id
                    }
                    if (WIDGET?.record) {
                        request.widget_init.execute_from_doc = store.exclude_itemsSourcesView(WIDGET.record)
                    }
                    store.executeWidgetMethod_inNewWidget(vueObj, request, action, FRONTEND_start)
                    break
                } case 'workspace_goto': {
                    // IE 2026 09 28 / ODOO-342342: строка меню страницы с goto {workspace, page} — ссылки Launchpad ↔ «Путеводитель» (бэк: workspaces.help_page_links)
                    workspaceGoto(store, action)
                    break
                } case 'guide_play': {
                    // IE 2026 09 28 / ODOO-342342 (Use cases): «Open in demo» / «Start path» кнопкой командной панели или пункта: params {id?, step?, anchor?} (контракт §6.1);
                    // без id — запись виджета (форма кейса). Выключатель fe.guide.cases
                    if (!guideCases_on(store)) break
                    const _gp = { ...(action.params || {}) }
                    if (!_gp.id && WIDGET?.record?.id) _gp.id = WIDGET.record.id
                    // путь с сохранённым местом — продолжить с него (кнопка «Start path» формы пути)
                    if (!_gp.step && WIDGET?.record?.doc?.kind === 'path' && _gp.id === WIDGET.record.id) {
                        const _pos = marks_pos(store.guide_marksEnsure(), _gp.id, WIDGET.record?._doc?.personal?.pos)   // IE 2026 09 28 / ODOO-342342 (Н1)
                        if (_pos > 1) _gp.step = _pos
                        // IE 2026 09 28 / ODOO-342342 (приёмка Н2): без места в пути — первый показываемый шаг (не Planned / Idea; с якорем, если есть), номер — явно
                        if (!_gp.step) {
                            const _d = WIDGET.record?._doc || {}
                            const _st = Array.isArray(_d.steps) && _d.steps.length ? guidePath_fromPlan({ steps: _d.steps }) : guidePath_fromRows(Array.isArray(_d.items_view) ? _d.items_view : [])
                            const _i = guidePath_startIndex(_st, null)
                            if (_i >= 0 && _st[_i].n) _gp.step = _st[_i].n
                        }
                    }
                    store.guide_play(vueObj, _gp)
                    break
                } case 'guide_restore_filters': {
                    // IE 2026 09 28 / ODOO-342342 (Use cases): «Restore my filters» — мои чипсы столов, заменённые показом (action.workspace — один стол)
                    store.guide_restoreFilters(action.workspace || null)
                    break
                } case 'page_goto_chip': {
                    // IE 2026 09 30 / ODOO-343433: команда «перейти на страницу этого стола, поставив чипс из значения строки»: {page, chip_binding, row_binding};
                    // строка — action.dataItem (клик по строке грида) либо выбранная строка vueObj; чипс только в памяти, стол не сохраняется
                    const _cfg = pageGotoChip_config({ row_click: { ...action, action: 'page_goto_chip' } })
                    const _row = action.dataItem || vueObj.get_selectedRow?.(action_binding)?.dataItem
                    if (_cfg && _row) store.pageGotoChip(WIDGET, _cfg, _row, action.display)
                    break
                } case 'workspace_open': {
                    const item = vueObj.get_selectedRow(action_binding)?.dataItem
                    if (item && item.node?.value && store.menu_model_WORKSPACES) {
                        store.workspace_open(item.node?.value)
                    } else if (item && item.widget) { // TODO open widget in workspace_open ??
                        store.executeStoreMethod(vueObj, { 'command':'widget_open', widget:'widget-record', item:{id:item.widget} })
                    }
                    break
                // } case 'rightArea_setVisible': {
                //     store.rightArea_setVisible(vueObj, action)
                //     break
                } case 'pollTask': {
                    const _pollKey = JSON.stringify([action.pollTask?.method, action.pollTask?.params ?? null])
                    // дедуп: эта задача уже поллится (save и select кладут одинаковый
                    // pollTask; повторные select — ещё) — второй цикл не заводим,
                    // иначе отставшие ответы оживляют pending-плашку после финала
                    if (action.pollTask && WIDGET._pollTask?.key === _pollKey) { /* уже поллится */ } else if (action.pollTask) {
                        const startTime = Date.now()
                        const interval  = action.pollTask.interval ?? store.setting('fe.polling.pollTaskIntervalMs', 5000)   // IE 2026 09 05 / ODOO-336330
                        const maxTime   = action.pollTask.maxTime  ?? store.setting('fe.polling.pollTaskMaxMin', 30) * 60 * 1000
                        const pollAction = {
                            ...action.pollTask,
                            _isPoll: true,
                            _pollMeta: { startTime, interval, maxTime },
                        }
                        WIDGET._pollTask = { startTime, sequence_id: null, key: _pollKey }
                        if (!action.no_notification) {
                            WIDGET.notification = WIDGET.notification || {}
                            WIDGET.notification.text = action.title || t('Waiting for task...')   // IE 2026 09 23 / ODOO-341407: i18n
                            WIDGET.notification.status = 'pending'
                            WIDGET.notification.visible = true
                        }
                        window.$cg.setTimeout(vueObj, 'pollTask', () => {
                            if (WIDGET._pollTask) store.executeWidgetMethod(vueObj, pollAction)
                        }, interval)
                    }
                    break
                } case 'widget_open_repeat': {
                    // скелет-кадр (ответа бэка нет): повторить исходный запрос
                    // widget_open как он был отправлен — бэковский reload
                    // (executeWidgetMethod) без полученной записи невозможен
                    WIDGET._widgetOpen_repeat?.()
                    break
                } case 'client_test_run': {
                    // IE 2026 08 28 / ODOO-5828 (заказ Игоря): прогон теста данных В ЭТОЙ вкладке (кнопка «TEST in browser»)
                    store.clientTest_run(vueObj)
                    break
                } case 'client_tests_run': {
                    // IE 2026 08 28 / ODOO-5828: пакетный прогон тестов задачи в этой вкладке («Run tests in this browser»)
                    store.clientTests_run(vueObj)
                    break
                } case 'executeWidgetMethod': {
                    // IE 2026 09 28 / ODOO-342342 (Use cases): кнопки формы кейса (бэк guide.command_panel: избранное / «пройдено» методами toggle_favorite / set_passed) —
                    // через личные отметки фронта: оптимистично, с откатом, одна правда с формой-меню и полосой (utils/guidePersonal.js); fe.guide.cases выключен — как было
                    if (WIDGET?.widget_class === 'widget_USE_CASE' && (action.method === 'toggle_favorite' || action.method === 'set_passed') && WIDGET.record?.id && guideCases_on(store)) {
                        const _gid = String(action.params?.id || WIDGET.record.id)
                        if (action.method === 'toggle_favorite') {
                            const _on = (action.params && 'on' in action.params) ? !!action.params.on : !marks_fav(store.guide_marksEnsure(), _gid, WIDGET.record?._doc?.personal?.fav)   // IE 2026 09 28 / ODOO-342342 (Н1)
                            store.guide_mark('fav', _gid, _on)
                        } else store.guide_mark('done', _gid, action.params?.passed !== false)
                        break
                    }
                    // IE 2026 10 13 / ODOO-5800: несохранённые строки ленивого грида — команды панели (Confirm …) не выполняются, пока их не сохранят или не отменят (fe.ux.gridSaveGuard)
                    if (!action._unsaved_ok && store.gridSave_guardBlocks(WIDGET, action)) return
                    // IE 2026 09 03 / ODOO-11316 (заказ Игоря): у виджета есть несохранённые
                    // правки — select/reload (кнопкой, каскадом селекторов, активацией
                    // страницы) не теряет их молча: диалог на самом виджете (unsavedGuard_check)
                    // IE 2026 10 09 / ODOO-345618 (F2): команды согласования, после которых бэк перечитывает отчёт (approval_submit … close_cycle), не теряют несохранённые корректировки молча — тот же диалог
                    if ((action.method === 'select' || action.method === 'reload' || (action.approval_code && /^approval_(submit|recall|approve|return|reopen|skip|start_cycle|close_cycle)$/.test(String(action.method || '')) && store.setting('fe.ux.approval', true) !== false)) && !action._unsaved_ok
                        && store.unsavedGuard_check(vueObj, action)) {
                        return
                    }
                    // if (WIDGET.area === 'right-area') {
                    //     const WORKSPACE = store.activeWORKSPACE
                    //     const PAGE = WORKSPACE.activePAGE
                    //     const rightArea = PAGE.rightArea

                    //     vueObj = rightArea.parentWIDGET.vueObj
                    // }
                    if (action.method === 'select') {
                        // АН 2026 07 20 / ODOO-2692
                        // selectRowID, заданный вызывающим кодом (saveRecord после сохранения клона),
                        // имеет приоритет. Раньше action.params перезаписывался целиком текущим
                        // выделением грида — и после reload выделялась исходная строка, а не новый клон.
                        if (!action.params?.selectRowID) {
                            // IE 2026 09 28 / ODOO-5800: выделенную строку знает компонент виджета (WidgetAttrs.get_selectedRow). Вызов с другим объектом
                            // (компонент реквизита по «WIDGET.vueObj || this», когда vueObj виджета уже снят жёстким закрытием) ронял промис TypeError-ом —
                            // теперь это «выделенной строки нет», команда идёт дальше (закрытому виджету executeWidgetMethod запрос не шлёт — WIDGET.close)
                            if (typeof vueObj.get_selectedRow !== 'function') console.warn(`[${WIDGET?.id}][${action.action_id_front}] select: vueObj without get_selectedRow — no selected row`)
                            const item = typeof vueObj.get_selectedRow === 'function' ? vueObj.get_selectedRow(action_binding)?.dataItem : null   // IE 2026 09 28 / ODOO-5800
                            if (item) {
                                action.params = {...action.params, selectRowID: item.id}
                            }
                        }
                    }
                    if (action.mark_selectedItem) {
                        const item = typeof vueObj.get_selectedRow === 'function' ? vueObj.get_selectedRow(action_binding)?.dataItem : null   // IE 2026 09 28 / ODOO-5800: без get_selectedRow — строки нет (см. select)
                        if (item) {
                            item._meta = item._meta || {}
                            item._meta.selected = true
                        }
                    }
                    // IE 2026 09 17 (заказ Игоря «PO* / Ex-Distr* — просто скрыть-показать строки на фронте»): Option group, строки которой
                    // уже построены, переключается на фронте без перечитывания отчёта; иначе — бэк (toggle_option_group → reload)
                    if (action.method === 'toggle_option_group') {
                        // IE 2026 09 24 / ODOO-5800 (заказ Игоря): поколение запросов групп опций — состояние групп ведёт фронт, переключения во время
                        // ожидания ответа обрывают его и уезжают одним reload с полным набором (mainStore.optionGroup_toggleSeq; флаг fe.ux.optionGroupRequestSeq)
                        if (store.optionGroup_toggleSeq(vueObj, action.params?.group)) break
                        if (store.optionGroup_toggleFast(vueObj?.WIDGET || WIDGET, action.params?.group)) break
                    }
                    store.executeWidgetMethod(vueObj, action, form_attr, FRONTEND_start)
                    break
                } case 'executeVueObjMethod': {
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action.target_binding || action_binding)
                    // мульти-вертикальная таблица: реестр может держать устаревший
                    // attr.id (updateDoc пересобрал view) — фолбэк на координатор,
                    // он делегирует методы активной секции
                    if ((!attr_vueObj || typeof attr_vueObj[action.method] !== 'function') && WIDGET._mvtObjs) {
                        const _mvt = WIDGET._mvtObjs[action.binding || action_binding]
                            || Object.values(WIDGET._mvtObjs)[0]
                        if (_mvt && typeof _mvt[action.method] === 'function') attr_vueObj = _mvt
                    }
                    // кнопки командной панели ЯЧЕЙКИ (dropdown: Edit value, Add
                    // comment, цвета…) не несут binding — резолв уходит в дефолт
                    // '_doc.data'. В виджетах, где такого грида нет (форма
                    // настроек виджета, Record), это давало TypeError
                    // «attr_vueObj[action.method] is not a function». Владелец
                    // открытого dropdown знает себя сам — берём его.
                    if (!attr_vueObj || typeof attr_vueObj[action.method] !== 'function') {
                        const _dd = store.dropdown
                        for (const _cand of [_dd?.vueObj, _dd?.vueObj_content]) {
                            if (_cand && typeof _cand[action.method] === 'function') { attr_vueObj = _cand; break }
                        }
                    }
                    // IE 2026 09 24 / ODOO-341407: команды уровня виджета (пункт меню «Translations…» → i18n_titles_open) живут на
                    // компоненте Widget.vue / WidgetAttrs — резолв к ним, когда у attr-компонента такого метода нет
                    if (!attr_vueObj || typeof attr_vueObj[action.method] !== 'function') {
                        for (const _cand of [WIDGET?.attrs_vueObj?.WIDGET, vueObj]) {
                            if (_cand && typeof _cand[action.method] === 'function') { attr_vueObj = _cand; break }
                        }
                    }
                    if (!attr_vueObj || typeof attr_vueObj[action.method] !== 'function') {
                        // мягкая деградация: раньше падало необработанным TypeError
                        console.warn(`executeVueObjMethod: метод '${action.method}' не найден`,
                            {binding: action.binding || action_binding, source_name: action.source_name})
                        break
                    }
                    if (action.method === 'onFillColor' || action.method === 'onRowStyleColor' || action.method === 'onRowStyleCustom') {
                        // sync event
                        attr_vueObj[action.method](event, action)
                    } else {
                        attr_vueObj[action.method](action)
                    }
                    break
                } case 'executeWidgetObjMethod': {
                    WIDGET.attrs_vueObj.WIDGET[action.method](event, action)
                    break
                } case 'collapseToLevel': {
                    let tree = vueObj.get_flex(action_binding)
                    tree.collapseToLevel(action.collapseToLevel)
                    break
                } case 'onChoice': {
                    const item = vueObj.get_selectedRow(action_binding)?.dataItem
                    if (item) {
                        let parent_attr = WIDGET.parent_attr,
                        parentWIDGET = store.findWidget(WIDGET.parentWIDGET.id).WIDGET

                        if (WIDGET.parentAction.params?.isChoiseWidget) {
                            store.executeStoreMethod(parentWIDGET.vueObj, { 'command': 'executeWidgetMethod', 'method': 'reload', 'chosenItem':item, 'record_sendToBackend_exclude': ['_doc'], 'action_name':'action-front-onChoice-2025-01-11' })
                        } else {
                            let parent_attr_vueObj = parentWIDGET.attrs_vueObj[parent_attr.id]
                            parent_attr_vueObj.choiceFinish(parent_attr, item)
                        }
                        store.widget_close(vueObj.widget_id)
                    }
                    break
                } case 'popupTab-onChoice': {
                    const item = vueObj.get_selectedRow(action_binding)?.dataItem
                    if (item) {
                        WIDGET['@@data'].parent_attr_vueObj.choiceFinish(WIDGET['@@data'].parent_attr, item)
                        // WIDGET.hide()        
                    }
                    break
                } case 'onShowArchived__Click': { // TODEL
                    WIDGET.record.doc.params.showArchived = !(WIDGET.record.doc.params?.showArchived)
                    store.executeStoreMethod(vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'] })
                    break
                } case 'onSave_PIVOT_TOOL__Click': {
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    if (WIDGET.record.doc.rows_modify && WIDGET.record.doc.rows_modify.length) {
                        store.Save_PIVOT_TOOL(vueObj, WIDGET.record.doc.rows_modify, {
                            action: action,
                            content_reloadAfterSave: true,
                            parentWidget_reloadAfterSave: true,
                            parentWIDGET: WIDGET.parentWIDGET,
                        })

                        attr_vueObj.set_commandPanel(true)
                    }
                    break
                } case 'navigate_record': {
                    if (WIDGET.widget === 'widget-row' && WIDGET.record?._meta?.type === 'widget-row') {
                        const meta = WIDGET.record._meta
                        const parentWidget = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
                        if (!parentWidget?.vueObj) break
                        const flex = parentWidget.vueObj.get_flex(meta.binding)
                        if (!flex?.rows?.length) break
                        // Плаский перехід по видимих рядках (без урахування ієрархії):
                        // елемент по полному iroot, позиция — индекс в flex.rows
                        const currentItem = store.get_widgetRow_currentItem(meta, parentWidget)
                        if (!currentItem) break
                        const currentIdx = flex.rows.findIndex(r => r.dataItem === currentItem)
                        if (currentIdx < 0) break
                        const delta = action.direction === 'next' ? 1 : -1
                        let newIdx = currentIdx + delta
                        // пропускаем скрытые (свёрнутые) строки и строку-заглушку без dataItem
                        while (newIdx >= 0 && newIdx < flex.rows.length && (!flex.rows[newIdx].dataItem || !flex.rows[newIdx].isVisible)) {
                            newIdx += delta
                        }
                        if (newIdx < 0 || newIdx >= flex.rows.length) break
                        flex.select(new wjGrid.CellRange(newIdx, Math.max(0, flex.selectedRanges?.[0]?.col ?? 0)))
                        break
                    }
                    const nav = WIDGET._nav
                    if (!nav?.siblings?.length) break
                    const delta = action.direction === 'next' ? 1 : -1
                    const newIndex = nav.currentIndex + delta
                    if (newIndex < 0 || newIndex >= nav.siblings.length) break
                    const sibling = nav.siblings[newIndex]
                    WIDGET.record.id = sibling.id
                    WIDGET.record.segment = sibling.segment
                    WIDGET.record.version = sibling.version || ''
                    nav.currentIndex = newIndex
                    store.set_widgetRecord_nav_shortTitle(WIDGET)
                    if (WIDGET.parentWIDGET?.id) {
                        const _parentW = store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
                        if (_parentW) store.addEdgeWidgetRecord(_parentW, WIDGET)
                    }
                    store.executeStoreMethod(vueObj, {
                        command: 'executeWidgetMethod',
                        method: 'reload',
                        record_sendToBackend_exclude: ['doc', '_doc'],
                    })
                    break
                } case 'onCloseWindow__Click': {
                    if (store.gridSave_closeGuard(vueObj, action)) break   // IE 2026 10 13 / ODOO-5800: несохранённые строки ленивых гридов — сначала диалог на виджете
                    store.widget_close(vueObj.widget_id)
                    break
                } case 'onCloseOthersWindow__Click': {
                    const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
                    const WIDGETS = [...((WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET.page))]

                    for (const WIDGET0 of WIDGETS) {
                        if (WIDGET0 !== WIDGET) {
                            // IE 2026 10 13 / ODOO-5800: виджет с несохранёнными строками ленивых гридов не закрывается молча — на нём диалог закрытия
                            // (Save & close / Close without saving / Keep editing), как у его ✕; остальные закрываются как раньше. Флаг fe.ux.gridSaveBar
                            if (!WIDGET0.close && !WIDGET0._softClosed && WIDGET0.vueObj
                                    && store.gridSave_closeGuard(WIDGET0.vueObj, { command: 'onCloseWindow__Click' })) continue
                            store.widget_close(WIDGET0.id)
                        }
                    }
                    break
                } case 'onChoose_inList__Click': {
                    const item = vueObj.get_selectedRow(action_binding)?.dataItem
                    if (item) {
                        // const widget_parent = store.findWidget(WIDGET.parentWIDGET.id).WIDGET
                        // widget_parent.workspace_record = {'id':item.id, 'title':item.title}

                        store.widget_close(vueObj.widget_id)
                    }
                    break
                } case 'onSaveRecord__Click': {
                    const record = WIDGET.record
                    if (action.params?.archive) {
                        record.meta = record.meta || {}
                        record.meta.archived = !record.meta.archived
                    }
                    if (action.params?.delete) {
                        record._meta = record._meta || {}
                        record._meta.delete = true
                    }
                    // closeWindow действует при архивации; при восстановлении из архива
                    // (тот же archive-тоггл, флаг снялся) виджет не закрываем
                    const restoreFromArchive = action.params?.archive && !record.meta.archived
                    store.saveRecord(vueObj, record, action, {
                        closeAfterSave: (action.params && action.params.closeWindow && !restoreFromArchive),
                        action: action,
                        content_reloadAfterSave: true,
                        parentWidget_reloadAfterSave: true,
                        parentWIDGET: WIDGET.parentWIDGET,
                    })
                    break
                } case 'onSaveRecords__Click': {
                    const items = vueObj.get_selectedItems()
                    let records = []
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i],
                        record = {
                            id: item.id,
                            segment: WIDGET.record.doc.params?.segment,
                            version: WIDGET.record.doc.params?.version,
                        }
                        records.push(record)

                        if (action.params?.archive) {
                            record.meta = record.meta || {}
                            record.meta.archived = !record.meta.archived // WIDGET.record.doc.params?.showArchived
                        }
                        if (action.params?.delete) {
                            record._meta = record._meta || {}
                            record._meta.delete = true
                        }
                    }
                    store.saveRecord(vueObj, records, action, {
                        update: true,
                        reloadAfterSave: true,
                        multi: true,
                    })
                    break
                } case 'onCloneRecord__Click': {

                    if (action.openInPlace) {
                        const record = WIDGET.record
                        record._meta = record._meta || {}
                        record._meta.new = true
                        record._meta.modified = true
                        record._meta.clone = true
                        record._meta.cloned_record = record.id || ''
                        record.parent = record.id
                        record.id = ''
                        // IE 2026 08 19 / ODOO-5512 (заказ Игоря): «Save current as my
                        // copy» — копия сразу МОЯ и скрытая от других (doc.private)
                        if (action.params?.private) {
                            record.doc = record.doc || {}
                            record.doc.private = true
                        }
                        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): варианты настроек.
                        // as_variant — копия под ОСНОВНОЙ настройкой (doc.variant_of), родитель — выбранный
                        // вариант либо исходная запись; make_default — бэк после сохранения назначит копию
                        // основным вариантом (_meta.make_default_variant → saveRecord2).
                        // as_setting — копия в ОСНОВНОЕ дерево ребёнком основной настройки, без признаков варианта
                        if (action.params?.as_variant || action.params?.as_setting) {
                            record.doc = record.doc || {}
                            const _mainId = record.doc.variant_of || record._meta.cloned_record
                            delete record.doc.default_variant
                            if (action.params.as_setting) {
                                delete record.doc.variant_of
                                record.parent = _mainId
                            } else {
                                record.doc.variant_of = _mainId
                                record.parent = action.params.parent || record._meta.cloned_record
                                if (action.params.make_default) record._meta.make_default_variant = true
                            }
                        }
                        if (record.meta?.archived) {
                            // клон архивной настройки — пометку на удаление не переносим;
                            // префикс '*' в title бэкенд сам синхронизирует с флагом при сохранении
                            record.meta.archived = false
                        }
                        if (record.title) {
                            const collectTitles = (nodes, result) => {
                                for (const n of nodes || []) {
                                    if (n.title) result.push(n.title)
                                    if (n.attrs) collectTitles(n.attrs, result)
                                }
                                return result
                            }
                            const existingTitles = collectTitles(WIDGET.variants_tree, collectTitles(WIDGET.parents_tree, [])) // IE 2026 09 04 / ODOO-336331: + варианты
                            WIDGET.title = record.title = store.increment_name(record.title, existingTitles)
                        }
                        if (action.saveAfterClone) {
                            store.saveRecord(vueObj, record, action, { reloadAfterSave: true })
                        } else {
                            store.executeStoreMethod(vueObj, {
                                command: 'executeWidgetMethod',
                                method: 'reload',
                                record_sendToBackend_exclude: ['_doc'],
                            })
                        }
                        break
                    }

                    // TODO
                    // const widget__afterClone_name = `widget__afterClone`;
                    // const have____widget__afterClone = code.includes(`def ${widget__afterClone_name}(`)

                    const have____widget__afterClone = WIDGET.record.segment === "FIN-CALC"

                    if (!have____widget__afterClone) {
                        const WIDGET1 = store.copyWidget_JSON(WIDGET)
                        WIDGET1.record.parent = WIDGET.record.id

                        store.pasteWidget_JSON(WIDGET1, 'clone')

                    } else {
                        const record1 = store.JSON_sort(WIDGET.record)
                        record1.parent = WIDGET.record.id

                        store.widget_open({
                            workspace: WIDGET.workspace, widget_class: action.widget_class || WIDGET.widget_class,
                            parentAction: action,
                            clone: true,
                            record: record1,
                        })
                    }
                    break
                } case 'onShowLogInList__Click': {
                    store.widget_open({
                        workspace: WIDGET.workspace, widget_class: 'widget_Logs_list',
                        parentAction: action,
                    });
                    break
                } case 'onViewRecord__Click': {
                    if (!this.hide_console) console.log(WIDGET)
                    const formInfo = store.filterSerializable(WIDGET)
                    const content = store.JSON_sort(formInfo)
                    const title = t('Raw record for: {widget}', { widget: `${WIDGET.widget_class}[${WIDGET.id}]` })   // IE 2026 09 23 / ODOO-341407: i18n

                    // если виджет уже был открыт ранее — обновляем в нём контент,
                    // а не просто переактивируем его со старым содержимым
                    const existing = store.findWidget_byProps({ widget: 'widget-raw-record' })
                    if (existing) {
                        if (existing._softClosed) {
                            store._widget_restoreSoftClosed(existing)
                        }
                        existing.parentWIDGET = { id: WIDGET.id, title: WIDGET.title }
                        store.set_value(existing.record, 'doc.params.content', content, null, null, null, false)
                        store.executeStoreMethod(existing.vueObj, { command: 'updateDoc', title })
                        store.widget_activate(existing, 'onViewRecord__Click::refresh', true, true)
                        break
                    }

                    store.widget_open({
                        workspace: WIDGET.workspace,
                        widget: 'widget-raw-record',
                        title,
                        parentWIDGET: { id: WIDGET.id, title: WIDGET.title },
                        parentAction: action,
                        fieldsMapping:[
                            {leftValue:'doc.params.content', rightValue:{value:content, valueAsIs:true}},
                        ],
                    })
                    break
                } case 'onPrintPDF__Click': {
                    store.printPDF(vueObj)
                    break
                } case 'onSubmit__Click': {
                    const widget_parent = store.findWidget(WIDGET.parentWIDGET.id).WIDGET
                    let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
                    if (WORKSPACE.record) {
                        // widget_parent.workspace_record = 2024-07-31
                        WORKSPACE.record = store.JSON_sort(WIDGET.record)
                    }

                    if (action.params && action.params.closeWindow) {
                        store.widget_close(vueObj.widget_id)
                    }
                    store.executeStoreMethod(widget_parent.vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'] })
                    break
                } case 'onScale__Click': {
                    store.Scale(vueObj, action.params)

                    // scroll
                    store.scrollInWorkspace(WIDGET)
                    break
                } case 'onMinimizeWidget__Click': {
                    const WORKSPACE = store.activeWORKSPACE
                    const PAGE = WORKSPACE.activePAGE
    
                    // WIDGET.styleWidget.dock = 'min'

                    let style = store.getWIDGET_style(WIDGET)
                    
                    if (!WIDGET.styleWidget.minMode) {
                        WIDGET.styleWidget.minMode = true

                        WIDGET.styleWidget.minMode_before = {
                            dock: WIDGET.styleWidget.dock,
                            top: style.top,
                            left: style.left,
                            width: style.width,
                            height: style.height,
                        }

                        const ps = this.getPAGE_size(PAGE)

                        WIDGET.styleWidget.dock = 'popout'
                        style.top = ps.page_bottom - store.minMode_WidgetHeight + 'px'
                        style.left = ps.page_left + 'px'
                        style.width = store.minMode_WidgetWidth + 'px'
                        style.height = store.minMode_WidgetHeight + 'px'

                    } else {
                        WIDGET.styleWidget.minMode = false

                        if (WIDGET.styleWidget.minMode_before) {
                            WIDGET.styleWidget.dock = WIDGET.styleWidget.minMode_before.dock
                            style.top = WIDGET.styleWidget.minMode_before.top
                            style.left = WIDGET.styleWidget.minMode_before.left
                            style.width = WIDGET.styleWidget.minMode_before.width
                            style.height = WIDGET.styleWidget.minMode_before.height
                        }
                    }
                    
                    store.setWIDGET_style(WIDGET, style)

                    PAGE.mainArea?.vueObj.setStyle()

                    break

                } case 'onPopOut_DockBack__Click': {
                    const WORKSPACE = store.activeWORKSPACE
                    const PAGE = WORKSPACE.activePAGE
    
                    if (WIDGET.styleWidget.dock === 'popout') {
                        WIDGET.styleWidget.dock = 'dock'
                        
                        setTimeout(() => {
                            if (WIDGET.styleWidget.dock === 'dock') {
                                let style = {}
                                style.zIndex = ''
                                store.setWIDGET_style(WIDGET, style, false)
                            }
                        }, 1000)

                    } else {
                        WIDGET.styleWidget.dock = 'popout'

                        let style = store.getWIDGET_style(WIDGET)
                        
                        style.top = parseInt(style.top||0, 10) -20
                        if (style.top <= PAGE.stylePage.marginTop) {
                            style.top = PAGE.stylePage.marginTop + 20
                        }
                        style.top += 'px'
                        
                        style.left = parseInt(style.left||0, 10) -20
                        if (style.left <= PAGE.stylePage.marginLeft) {
                            style.left = PAGE.stylePage.marginLeft + 20
                        }
                        style.left += 'px'
                        style.zIndex = store.popout_baseZ + 100

                        // style.transform = `scale(1) translateX(0) translateY(0)`

                        store.setWIDGET_style(WIDGET, style)
                    }
                    PAGE.mainArea?.vueObj.setStyle()

                    break

                } case 'onFullscreen__Click': {
                    let elem

                    if (action.window) {
                        // IE 2026 09 23 / ODOO-… (замечание Игоря: «в режиме "Full screen" не видны формы-меню»): полноэкран получал элемент #app,
                        // а панели функций (MenuPanel), форма ячейки, окна легенд и прочие оверлеи телепортированы в body ВНЕ #app — браузер рисует
                        // только поддерево полноэкранного элемента. Теперь в полноэкран уходит весь документ (html): вид тот же (#app и так на всё
                        // окно), оверлеи в body видны и ловят мышь. Выключатель fe.ux.fullscreenOverlays = false — прежний #app
                        elem = store.setting('fe.ux.fullscreenOverlays', true) !== false ? document.documentElement : document.querySelector('#app')
                    } else {
                        elem = document.querySelector(`#WIDGET${vueObj.widget_id}`)
                    }

                    if (action.currentVueObj) {
                        const attr_vueObj = vueObj.get_vueObj(action.source_name || action.name || action_binding)
                        elem = document.querySelector(`#vueObj${attr_vueObj.attr_id}`)
                    }

                    // IE 2026 08 20 / ODOO-336291 (mobile UX): iPhone Safari не даёт полноэкран
                    // страницам (только видео) — честно говорим вместо молчания
                    if (!(elem.requestFullscreen || elem.webkitRequestFullscreen
                          || elem.mozRequestFullScreen || elem.msRequestFullscreen)) {
                        store.show_notification({ text: t('Full screen is not supported by this browser (iPhone Safari allows it only for video)'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n
                        break
                    }

                    // ===== TOGGLE (SMART) =====
                    const fsEl =
                        document.fullscreenElement ||
                        document.webkitFullscreenElement ||
                        document.mozFullScreenElement ||
                        document.msFullscreenElement

                    const isSameTarget = fsEl === elem

                    if (fsEl) {
                        if (!isSameTarget) {
                            // fullscreen уже есть, но на другом элементе -> переключаем на elem
                            if (elem.requestFullscreen) {
                                elem.requestFullscreen()
                            } else if (elem.webkitRequestFullscreen) {
                                elem.webkitRequestFullscreen()
                            } else if (elem.mozRequestFullScreen) {
                                elem.mozRequestFullScreen()
                            } else if (elem.msRequestFullscreen) {
                                elem.msRequestFullscreen()
                            }
                        } else {
                            // fullscreen именно на elem -> выходим (toggle)
                            if (document.exitFullscreen) {
                                document.exitFullscreen()
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen()
                            } else if (document.mozCancelFullScreen) {
                                document.mozCancelFullScreen()
                            } else if (document.msExitFullscreen) {
                                document.msExitFullscreen()
                            }
                        }
                    } else {
                        // fullscreen нет -> входим на elem
                        if (elem.requestFullscreen) {
                            elem.requestFullscreen()
                        } else if (elem.webkitRequestFullscreen) {
                            elem.webkitRequestFullscreen()
                        } else if (elem.mozRequestFullScreen) {
                            elem.mozRequestFullScreen()
                        } else if (elem.msRequestFullscreen) {
                            elem.msRequestFullscreen()
                        }
                    }

                    break
                } case 'onToggleView__Click': {
                    // IE 2026 08 17 / ODOO-4997 (баг Игоря): у части виджетов записи
                    // ещё нет (record/doc undefined) — клик по Header/Tabs/Panel падал
                    // с «Cannot read properties of undefined (reading 'viewParams')»
                    const _rec = WIDGET.record = WIDGET.record || {}
                    const _doc = _rec.doc = _rec.doc || {}
                    WIDGET.styleWidget = WIDGET.styleWidget || {}
                    _doc.viewParams = _doc.viewParams || {}
                    const key = action.param  // 'hideHeader' | 'hideTabs' | 'hideGridPanel' | 'floatHeader'
                    // IE 2026 09 14 / ODOO-… (замечание Игоря: парящий заголовок): у карты без полосы табов режим островков включён по умолчанию —
                    // первый клик по Float его выключает, а не «включает» уже включённое
                    const cur = _doc.viewParams[key] ?? (key === 'floatHeader' ? !!(WIDGET._geomap && WIDGET.styleWidget.hideTabs) : false)
                    _doc.viewParams[key] = !cur
                    WIDGET.styleWidget[key] = !cur
                    if (key === 'hideHeader' || key === 'hideTabs' || key === 'hideGridPanel') WIDGET.styleWidget.show_hidden = false
                    if (key === 'hideTabs' && cur) store.settingsForm_prefetchIfVisible(WIDGET, 'tabs-shown', true)   // IE 2026 09 28 / ODOO-5800: полоса вкладок показана — форма настроек
                    break
                } case 'onWidgetMaxToggle__Click': {
                    // IE 2026 08 22 (заказ Игоря): разворот виджета на всю
                    // страницу из hover-формы настроек (тумблер _mobileMax;
                    // WIDGET.vueObj всегда null — логика прямо здесь)
                    const sw = WIDGET.styleWidget = WIDGET.styleWidget || {}
                    sw._mobileMax = !sw._mobileMax
                    if (sw._mobileMax) store.widget_activate(WIDGET, 'mobileMax')
                    window.mobileWakeLock?.(sw._mobileMax)
                    break
                } case 'onZenMode__Click': {
                    break
                } case 'onCancel__Click': {
                    store.widget_close(vueObj.widget_id)
                    break
                } case 'onshowGroupPanel__Click': {
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    WIDGET.record.doc.showGroupPanel = attr_vueObj.attr.showGroupPanel = !attr_vueObj.attr.showGroupPanel
                    break
                } case 'onFlexGrid_isEditable__Click': {
                    WIDGET.flexGrid_isEditable = !(WIDGET?.flexGrid_isEditable)
                    WIDGET.flexGrid_allowAddNew = WIDGET.flexGrid_isEditable
                    WIDGET.flexGrid_allowDelete = WIDGET.flexGrid_isEditable
                    break
                } case 'onFlexGrid_showAllColumns__Click': {
                    const flex = vueObj.get_flex()
                    const grid_data = flex.itemsSource
                    let row = null
                    if (grid_data.length) {
                        row = grid_data[0]
                    } else if (grid_data.items.length) {
                        row = grid_data.items[0]
                    }
                    if (row) {
                        for (let binding in row) {
                            let column = flex.columns.find(x => x.binding === binding)
                            if (!column) {
                                let c = new wjGrid.Column();
                                c.binding = binding;
                                flex.columns.push(c);
                            } else if (!column.visible) {
                                column.visible = true
                            }
                        }
                    }
                    break
                } case 'onExportChart__Click': {
                    const flex = vueObj.get_flex(action.name || action_binding)
                    flex.saveImageToFile(`${WIDGET.title}.svg`)
                    break
                } case 'onExportSheet__Click': {
                    const flex = vueObj.get_flex(action.name || action_binding)
                    flex.saveAsync(`${WIDGET.title}.xlsx`)
                    break
                } case 'onPrint__Click': {
                    break
                } case 'onImporttGrid__Click': {
                    const attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    const flex = vueObj.get_flex(action_binding)

                    // создаём "виртуальный" input
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.accept = '.xlsx,.xls'; // фильтр для Excel файлов
                    input.style.display = 'none';

                    // добавляем обработчик
                    input.addEventListener('change', (event) => {
                        const file = event.target.files[0];
                        if (file) {
                            const tempFlex = new wjcGrid.FlexGrid(document.createElement('div'));

                            // загружаем Excel в FlexGrid
                            wjcGridXlsx.FlexGridXlsxConverter.loadAsync(
                                tempFlex,
                                file,
                                { includeColumnHeaders: false },
                                () => {
                                    console.log('Excel загружен в FlexGrid');

                                    // читаем стили асинхронно
                                    const reader = new FileReader();
                                    reader.onload = () => {
                                        const buffer = reader.result; // ArrayBuffer
                                        const wb = new wjcXlsx.Workbook();

                                        // корректный асинхронный вызов
                                        wb.loadAsync(buffer, (loadedWorkbook) => {
                                            const sh = loadedWorkbook.sheets && loadedWorkbook.sheets[0];
                                            if (!sh) {
                                                console.warn('Нет листов в книге');
                                                return;
                                            }

                                            const data = [];
    
                                            // // объединённые диапазоны
                                            // const merges = sh.mergedRanges || [];
                                            // merges.forEach((range, i) => {
                                            //     console.log(
                                            //         `Merge ${i}: R${range.topRow}-${range.bottomRow}, C${range.leftCol}-${range.rightCol}`
                                            //     );
                                            // });

                                            // === Формируем данные и стили ===
                                            let irow = -1
                                            for (let r = 0; r < (sh.rows?.length || 0); r++) {
                                                const row = sh.rows[r];
                                                if (row?.visible === false) continue; // 👈 пропускаем скрытые строки
                                                irow += 1
                                                
                                                const dataItem = data[irow] = data[irow] || {_cells:{}};

                                                // Устанавливаем высоту строки, если есть
                                                if (row && row.height) {
                                                    // Excel высота ≈ FlexGrid height * 1.333 (зависит от шрифта)
                                                    attr_vueObj.set_height({dataItem, height: row.height})
                                                }

                                                let icol = -1
                                                const cells = row?.cells || [];
                                                for (let c = 0; c < cells.length; c++) {
                                                    const col = sh.columns[c];
                                                    if (col?.visible === false) continue; // 👈 пропускаем скрытые колонки
                                                    icol += 1
                                            
                                                    // === Устанавливаем ширины колонок ===
                                                    if (irow === 0 && col?.width) {
                                                        // Excel ширина ≈ FlexGrid width * 6 (зависит от DPI и шрифта)
                                                        attr_vueObj.set_width(icol, col.width)
                                                    }

                                                    const cell = cells[c];
                                                    const attr_col = attr_vueObj.get_attr_col(icol)
                                                    if (!attr_col || !cell) continue
            
                                                    const spanR = cell.rowSpan || 0;
                                                    const spanC = cell.colSpan || 0;
                                                    if (spanR > 0 || spanC > 0) {
                                                        const range = {
                                                            topRow: r,
                                                            leftCol: c,
                                                            bottomRow: r + (spanR - 1),
                                                            rightCol: c + (spanC - 1)
                                                        };
                                            
                                                        let irow1 = irow, irow2 = irow, icol1 = icol, icol2 = icol

                                                        // видимые строки в merge-диапазоне
                                                        for (let rr = range.topRow + 1; rr <= range.bottomRow; rr++) {
                                                            const row = sh.rows[r];
                                                            if (row?.visible === false) continue; // 👈 пропускаем скрытые строки
                                                            irow2 += 1

                                                        }
                                                        for (let cc = range.leftCol + 1; cc <= range.rightCol; cc++) {
                                                            const col = sh.columns[c];
                                                            if (col?.visible === false) continue; // 👈 пропускаем скрытые колонки
                                                            icol2 += 1
                                                        }

                                                        // помечаем все ячейки внутри объединения
                                                        attr_vueObj.set_merge(data, irow1, irow2, icol1, icol2)
                                                    }
                                                                                                        
                                                    if (cell.value) {
                                                        dataItem[attr_col?.binding] = cell.value;
                                                    }

                                                    const style = store.workbookStyleToCSS(cell.style)
                                                    if (!store.isEmpty(style)) {
                                                        const _cells = dataItem._cells[attr_col?.binding] = dataItem._cells[attr_col?.binding] || {}
                                                        _cells.fields = [{
                                                            title: cell.value || '',
                                                            style: style,
                                                        }]
                                                    }


                                                    // const s = styles[r][c] = cells[c]?.style || null;

                                                    // // formula, isDate, isNumber, link, textRuns, value
                                                    // numberFormat: s.format || null,
                                                    // fillColor: s.fill?.color || null,
                                                    // fontColor: s.font?.color || null,
                                                    // bold: !!s.font?.bold,
                                                    // italic: !!s.font?.italic,
                                                    // underline: !!s.font?.underline,

                                                    // borders =
                                                    //     bottom =
                                                    //     color = '#000000'
                                                    //     style = 2

                                                }
                                            }

                                            // обновляем грид
                                            store.attr_set(attr_vueObj.WIDGET, attr_vueObj.attr, data)
                                            attr_vueObj.content_Changed()


                                            // // выводим значения и стили
                                            // for (let r = 0; r < tempFlex.rows.length; r++) {
                                            //     const rowValues = [];
                                            //     const rowStyles = [];
                                            //     for (let c = 0; c < tempFlex.columns.length; c++) {
                                            //         const val = tempFlex.getCellData(r, c, true);
                                            //         rowValues.push(val);

                                            //         const s = styles[r]?.[c];
                                            //         rowStyles.push(
                                            //         s
                                            //             ? {
                                            //                 numberFormat: s.format || null,
                                            //                 fillColor: s.fill?.color || null,
                                            //                 fontColor: s.font?.color || null,
                                            //                 bold: !!s.font?.bold,
                                            //                 italic: !!s.font?.italic,
                                            //                 underline: !!s.font?.underline,
                                            //             }
                                            //             : null
                                            //         );
                                            //     }
                                            //     console.log(`Row ${r}:`, rowValues);
                                            //     console.log(`Row ${r} styles:`, rowStyles);
                                            // }
                                        });
                                    };
                                    reader.readAsArrayBuffer(file);
                                }
                            );


                        }
                    });

                    // инициируем диалог
                    input.click();
      
                    break

                } case 'onImportFile__Click': {
                    var input = document.createElement('input');
                    input.type = 'file';

                    input.onchange = e => {
                        var file = e.target.files[0];
                        var file_name = file.name;
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = readerEvent => {
                            WIDGET.record.doc.file_dounloadToBackend = readerEvent.target.result
                            WIDGET.record.doc.file_name = file_name
                            // vueObj.content_Changed()
                            store.executeWidgetMethod(vueObj, { 'command': 'executeWidgetMethod', 'method': 'import_analysis_attrs' }, form_attr, FRONTEND_start)
                            // store.import_file(vueObj)
                        }
                    }
                    input.click();

                    break
                } case 'onChartTypeChanged__Click': {
                    vueObj.pivotChart.chartType = wjcOlap.PivotChartType[action.chartType];
                    break
                } case 'onShowDatail__Click': {
                    break
                } case 'onApplySelector__Click': { // selector
                    let fieldSelectors = WIDGET.record.doc.params?.fieldSelectors
                    if (!fieldSelectors) break

                    let WORKSPACE = store.WORKSPACES[WIDGET.workspace],
                    // rowGROUP = store.get_rowGROUP(WIDGET.record.doc.params),
                    data = WIDGET.record._doc.data

                    const _selectorDocFields = store.fieldsNoHierarchy(
                        WIDGET.record.doc.viewList || WIDGET.record.doc.fields || []
                    )

                    for (let fieldSelector of fieldSelectors) {
                        if (_selectorDocFields.length && (!fieldSelector.attr_type || !fieldSelector.relation_segment)) {
                            const _field = _selectorDocFields.find(f =>
                                f.binding === fieldSelector.binding || f.binding0 === fieldSelector.binding
                            )
                            if (_field) {
                                fieldSelector = {
                                    ...fieldSelector,
                                    attr_type: fieldSelector.attr_type ?? _field.attr_type,
                                    relation_segment: fieldSelector.relation_segment ?? _field.relation_segment,
                                }
                            }
                        }
                        const rowWHERE = store.get_rowWHERE(WIDGET, WORKSPACE.record.doc.params, fieldSelector)

                        if (action.selctor_currentRow) {
                            const item = vueObj.WIDGET.vueObj.get_selectedRow(action_binding)?.dataItem,
                                flex = vueObj.WIDGET.vueObj.get_flex(action_binding)
                            if (item) {
                                for (let row of data) {
                                    row.selector = false
                                }
                                item.selector = true
                                flex.refresh()
                            }
                        }     

                        rowWHERE.use = false
                        rowWHERE.attrs.length = 0
                        if (action.selector_values && typeof action.selector_values === 'object') {   // IE 2026 10 13 / ODOO-5800: значения заданы явно (клик по столбику / дольке AttrChart, utils/chartClickSelectors) — канал без значения снимается
                            const _sv = Object.prototype.hasOwnProperty.call(action.selector_values, fieldSelector.binding) ? action.selector_values[fieldSelector.binding] : []   // IE 2026 10 13 / ODOO-5800
                            for (const value of (Array.isArray(_sv) ? _sv : [_sv])) {   // IE 2026 10 13 / ODOO-5800
                                if (value === null || value === undefined || value === '') continue   // IE 2026 10 13 / ODOO-5800
                                rowWHERE.use = true   // IE 2026 10 13 / ODOO-5800
                                rowWHERE.attrs.push({ use: true, rightValue: { value, attr_type: fieldSelector.attr_type, relation_segment: fieldSelector.relation_segment } })   // IE 2026 10 13 / ODOO-5800
                            }   // IE 2026 10 13 / ODOO-5800
                        } else if (WIDGET.record.doc.params['#graph-eval']) {
                            if (WIDGET.record.doc.selector_values) {
                                rowWHERE.use = true
                                for (let value of WIDGET.record.doc.selector_values) {
                                    rowWHERE.attrs.push({
                                        use: true,
                                        rightValue: {
                                            value: value,
                                            attr_type: fieldSelector.attr_type,
                                            relation_segment: fieldSelector.relation_segment,
                                        }
                                    })
                                }
                            }
                        } else if (WIDGET.record.doc.params['pre-select-KPIs']) {
                            store.scan_selector_values(data, rowWHERE, fieldSelector)
                        } else {
                            // IE 2026 09 15 / ODOO-… (замечание Игоря): одно значение измерения у нескольких отобранных строк (две точки
                            // пузырька одного склада) попадало в чипс дважды — «Subject (2): X, X»; значение добавляется один раз
                            const seenVals = new Set()
                            const addSelectorAttrs = function(data, parent) {
                                for (let row of data) {
                                    if (row.selector) {
                                        let value = store.get_value(row, fieldSelector.binding)
                                        if (!value && parent) {
                                            value = store.get_value(parent, fieldSelector.binding)
                                        }
                                        // ODOO-3724: выбор «пустой» строки измерения (NULL/''/zero-UUID)
                                        // → маркер <isempty>; бэкенд построит предикат пустоты по типу поля.
                                        // 0/false не трогаем — для чисел ноль не «пусто».
                                        if (value == null || value === '' || value === '00000000-0000-0000-0000-000000000000') {
                                            value = EMPTY_VALUE_MARKER
                                        }
                                        const seenKey = (value && typeof value === 'object') ? JSON.stringify(value) : String(value)
                                        if (seenVals.has(seenKey)) { if (Array.isArray(row.attrs) && row.attrs.length) addSelectorAttrs(row.attrs, row); continue }
                                        seenVals.add(seenKey)

                                        rowWHERE.use = true
                                        rowWHERE.attrs.push({
                                            use: true,
                                            rightValue: {
                                                value: value,
                                                // valueStr: row[fieldSelector.binding + '.title'],
                                                attr_type: fieldSelector.attr_type,
                                                relation_segment: fieldSelector.relation_segment,
                                            }
                                        })
                                    }
                                    if (Array.isArray(row.attrs) && row.attrs.length) {
                                        addSelectorAttrs(row.attrs, row)
                                    }
                                }
                            }
                            addSelectorAttrs(data)
                        }
                        WIDGET.record.doc.params.flex_havActiveSelectors = rowWHERE.use
                    }

                    WORKSPACE.WIDGET?.vueObj?.content_Changed?.()
                    
                    WIDGET.attrs_vueObj.WIDGET.set_commandPanel()

                    store.workspace_applySelector(WIDGET.workspace, WIDGET.page, WIDGET)
                    break
                } case 'onClearSelector__Click': { // selector
                    let fieldSelectors = WIDGET.record.doc.params?.fieldSelectors
                    if (!fieldSelectors) break

                    let WORKSPACE = store.WORKSPACES[WIDGET.workspace],
                    // rowGROUP = store.get_rowGROUP(WIDGET.record.doc.params),
                    data = WIDGET.record._doc.data

                    let workspace_applySelector_
                    for (let fieldSelector of fieldSelectors) {
                        const rowWHERE = store.get_rowWHERE(WIDGET,WORKSPACE.record.doc.params, fieldSelector)

                        if (WIDGET.record.doc.params['#graph-eval']) {
                            WIDGET.record.doc.params.flex_havActiveSelectors = false
                            WIDGET.attrs_vueObj.WIDGET.set_commandPanel()
                            
                            WIDGET.record.doc.selector_values = []
                            let attr_vueObj = vueObj.get_vueObj("_doc.data_graph")
                            attr_vueObj?.set_highlighted?.()
                            attr_vueObj?.refresh()

                        } else if (rowWHERE.use) {
                            rowWHERE.use = false
                            for (let row of data) {
                                if (row.selector) {
                                    row.selector = false
                                }
                            }

                            WIDGET.record.doc.params.flex_havActiveSelectors = false
                            WIDGET.attrs_vueObj.WIDGET.set_commandPanel()

                            // store.executeStoreMethod(vueObj, { 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'] })
                            // сброс может прийти с вкладки без грида (Bubble/TreeMap) — flex там нет
                            const flex = vueObj.WIDGET.vueObj.get_flex?.(action_binding)
                            flex?.refreshCells()

                            workspace_applySelector_ = true
                        }
                    }
                    if (workspace_applySelector_) {
                        store.workspace_applySelector(WIDGET.workspace, WIDGET.page, WIDGET)
                    }

                    break
                } case 'updateRelatedWidgets': {
                    store.updateRelatedWidgets(WIDGET.workspace, WIDGET.page, WIDGET, action)
                    break
                } case 'onAttrOpen__Click': {
                    vueObj.onAttrOpen__Click(vueObj.active_attr)
                    break
                } case 'onAttrChooseInList__Click': {
                    vueObj.onAttrChooseInList__Click(vueObj.active_attr)
                    break
                } case 'onShowInList__Click': {
                    let widget_init = {
                        widget: 'widget-list',
                        parentAction: action,
                        props: { record_id: WIDGET.record.id },
                        fieldsMapping:[
                            {'leftValue':'doc.params.segment', 'rightValue':WIDGET.record.segment},
                            {'leftValue':'doc.params.record_id', 'rightValue':WIDGET.record.id},
                        ],
                    }

                    if (WIDGET.record.segment == 'WIDGET-LIST') { // dimensions
                        const dimensions = [
                            {'binding':'doc.params.segment'},
                            {'binding':'doc.params.grid_binding'},
                            {'binding':'doc.params.collection'},
                        ]

                        const WHERE = []
                        for (const dimension of dimensions) {
                            const value = store.get_value(WIDGET.record, dimension.binding)
                            if (value) {
                                WHERE.push({
                                    leftValue: dimension.binding,
                                    condition: '=',
                                    rightValue: value,
                                })
                            }
                        }

                        widget_init.fieldsMapping.push({leftValue:'doc.params.WHERE', rightValue:{value:WHERE, valueAsIs:true}})
                    }

                    // IE 2026 08 20 / ODOO-5512 (заказ Игоря): «Open in list widget» из
                    // списка настроек — список открывается с тем же ИЕРАРХИЧЕСКИМ видом
                    // (чипс дерева Parent) и сортировкой order, title
                    if (action.settings_tree_view) {
                        const chips = [
                            { segment: 'CHIP-Tree', title: 'Parent', meta: { use: true, pi: 'pi-sitemap' },   // IE 2026 09 24 / ODOO-341407: в viewParams записи — английская база, перевод при показе (AttrChips.getChipTitleHTML, ключ 'Parent' / 'Order|chip')
                                doc: { groupDescriptions: [{ title: 'Parent', binding: 'parent' }] } },
                            { segment: 'CHIP-Order', title: 'Order', meta: { use: true, pi: 'pi-sort' },   // IE 2026 09 24 / ODOO-341407: то же
                                doc: { sortDescriptions: [{ binding: 'order', direction: 'ASC' }, { binding: 'title', direction: 'ASC' }] } },
                        ]
                        // IE 2026 08 20 (заказ Игоря): показывать ТОЛЬКО текущее дерево —
                        // серверный отбор поддерева; снятие чипса показывает все деревья
                        if (action.tree_root?.id) {
                            chips.push({ segment: 'CHIP-TreeRoot', title: action.tree_root.title,
                                meta: { use: true, pi: 'pi-sitemap' }, doc: { root: action.tree_root.id } })
                        }
                        widget_init.fieldsMapping.push({ leftValue: 'doc.viewParams.dataSheet.CHIPS', rightValue: { value: chips, valueAsIs: true } })
                    }

                    store.widget_open(widget_init, vueObj)
                    break
                } case 'onAttrClear__Click': {
                    break
                } case 'onJS_deep__Click': {
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    attr_vueObj.JS_deep = action.params.JS_deep
                    let content = store.JS_parse(attr_vueObj.content_str)
                    attr_vueObj.content_str = store.JS_stringify(content, attr_vueObj.JS_deep)
                    break
                } case 'onOpenMyProfile__Click': {
                    store.widget_open({
                        widget_class: 'widget_USER',
                        parentAction: action,
                        record: {
                            id: store.user.id,
                            title: store.user.title,
                        },
                        props: {
                            id: store.user.id
                        },
                    });
                    break
                } case 'onOpenSecurity__Click': {   // Odoo 350042: свои способы двухфакторного входа
                    store.mfaSecurity_open = true
                    break
                } case 'onLogOut__Click': {
                    store.logout(null, null, true)
                    break
                } case 'set_process_model': {
                    if (action.method === 'onChoice') {
                        const item = vueObj.get_selectedRow(action_binding)?.dataItem
                        if (item) {
                            action.process_model = item.id
                        }
                        store.widget_close(vueObj.widget_id)
                    }

                    // pmKeepView (просьба Igor 2026-08-07): стол НЕ пересобирается —
                    // те же виджеты (включая несохранённые настройки) и глобальные
                    // чипсы, обновляются только данные под новую модель.
                    // Выкл: window.fastEntry.set('pmKeepView', false) — прежний reload
                    if (store.fastEntry.pmKeepView !== false && store.activeWORKSPACE
                        && action.process_model !== store.process_model_record?.id) {
                        store.switch_process_model(action.process_model)
                        break
                    }

                    const workspace = store.activeWORKSPACE?.workspace
                    const page = store.activeWORKSPACE.active_page
                    const WORKSPACE = store.WORKSPACES[workspace]
                    const PAGE = WORKSPACE.PAGES[page]
                    // ODOO-3749: выбор ТЕКУЩЕЙ модели даёт чистый адрес (дефолт в URL
                    // не пишется). Store сбрасываем, чтобы гвард не дописал прежнюю
                    // модель обратно и ушёл в setup — тот перезагрузит контекст.
                    const _isCurrent = action.process_model === store.process_model_current
                    if (action.process_model !== store.process_model_record?.id) {
                        store.process_model_record = { id: '' }
                    }
                    store.router.push({ name:'db',
                        params: {
                            dbid: store.user.database.dbid,
                            process_model: action.process_model,
                            workspace: workspace,
                            page: page,
                            action: action,
                        },
                        query: {
                            ...(_isCurrent ? {} : { process_model: action.process_model }),
                            workspace: workspace,
                            page: page,
                    }})

                    PAGE.refresh_needed = true
                    // store.updateRelatedWidgets(workspace, page)

                    break
                } case 'switch_database': {
                    store.process_model_record = { id: '' }
                    store.process_model_current = '' // ODOO-3749: current — атрибут базы
                    store.recentWorkspaces = []     // ODOO-3749: последние столы — тоже
                    store.menuTree = []
                    store.WORKSPACES = {}
                    store.database_attrs = []
                    store.router.push({ name: IS_NEW_INFRA ? 'selectDatabase' : 'login' })
                    break
                } case 'set_database': {
                    // Switch straight into the selected database (ODOO-3484) — do NOT
                    // bounce to the selector. Mirrors DatabaseSelector.selectDatabase:
                    // reset context, align X-Database BEFORE navigation, then route to
                    // /<dbid>; the router guard runs the full re-init (process model /
                    // params / workspaces) without a page reload.
                    const dbid = action.dbid
                    if (dbid && dbid !== store.user.database.dbid) {
                        store.dbSwitching_start(action.title || dbid)
                        // Reset state
                        store.user.database = { dbid: dbid, id: dbid, name: action.title || dbid, title: action.title || '' }
                        store.process_model_record = { id: '' }
                        store.process_model_current = '' // ODOO-3749: current — атрибут базы
                        store.recentWorkspaces = []     // ODOO-3749: последние столы — тоже
                        store.menuTree = []
                        store.WORKSPACES = {}
                        store.database_attrs = []
                        // ODOO-3705: активный workspace/дефолты — ТОЖЕ от прошлой базы.
                        // Без сброса router.beforeEach подставлял activeWORKSPACE прошлой
                        // базы в query целевой (напр. workspace-databases из coredatabases),
                        // где такой записи нет → workspace_open отдавал ошибку и пустой
                        // ответ → вечный спиннер. Всегда стартуем с дефолтов целевой базы.
                        store.activeWORKSPACE = null
                        store.user_defaults = null

                        // Copy session cookie for new database (router guard finds it)
                        const sk = store.getCookie('session_key')
                        if (sk) document.cookie = 'session_key_' + dbid + '=' + sk + '; path=/'

                        if (IS_NEW_INFRA) {
                            // ODOO-3241: set X-Database BEFORE navigation — the setup
                            // XHRs fire from router.beforeEach while location.hash is
                            // still stale, so ajaxPrefilter can't derive the header.
                            $.ajaxSetup({
                                headers: {
                                    'X-Company': store.extractCompany('', dbid),
                                    'X-Database': dbid,
                                    'X-CSRFToken': store.getCookie('csrftoken'),
                                },
                                xhrFields: { withCredentials: true },
                            })
                            // No process_model in the query — let the backend pick the
                            // database default (ODOO-3488). Workspace тоже НЕ подставляем:
                            // карточка несёт дефолт БАЗЫ, а явный ?workspace= в URL сильнее
                            // ЛИЧНОГО дефолта (Set workspace as my default) — цепочку
                            // приоритетов (личный > ядро > база) целиком решает бек
                            // (get_user_defaults, ODOO-3705)
                            store.router.push('/' + dbid)
                        } else {
                            // Old infra (compatibility): selector-less login path.
                            store.router.push({ name: 'dbLogin', params: { dbid: dbid } })
                        }
                    }
                    break
                } case 'dounloadFile': {
                    let link = document.createElement("a");
                    link.download = action.fileName_dounloadToFrontend;
                    link.href = encodeURI(action.file_dounloadToFrontend);
                    link.click();
                    break
                } case 'copyToClipboard': {   // IE 2026 11 03 / ODOO-349799 (clipboard target): тот же пакет, что у dounloadFile, — в буфер обмена (запасной путь textarea), тост с числом записей и размером
                    clipboardCommand(action, { navigator: typeof navigator !== 'undefined' ? navigator : null, document: typeof document !== 'undefined' ? document : null }, t)   // IE 2026 11 03 / ODOO-349799 (clipboard target)
                        .then(r => store.TERMINAL(WIDGET, null, { text: r.text, status: r.status }))   // IE 2026 11 03 / ODOO-349799 (clipboard target)
                        .catch(e => store.TERMINAL(WIDGET, null, { text: String(e?.message || e), status: 'error' }))   // IE 2026 11 03 / ODOO-349799 (clipboard target)
                    break   // IE 2026 11 03 / ODOO-349799 (clipboard target)
                } case 'updateDoc_ifChanged': {
                    let attr_vueObj = vueObj.get_vueObj('dataSheet')
                    if (attr_vueObj.backendProcessed) {
                        if (!this.hide_console) console.log(`[${WIDGET.id}][${action.action_id_front}]${action.command} ${action.method} BREAK, because backendProcessed`)
                        break
                    }

                    attr_vueObj.undoStack.length = 0
                    attr_vueObj.redoStack && (attr_vueObj.redoStack.length = 0)
                    attr_vueObj.changesStack = {}

                    if (!store.updateDoc_ifChanged(WIDGET.record._doc.data, action.record._doc?.data || [])) {
                        WIDGET.record._doc.data = action.record._doc.data
                        // attr_vueObj.flex.collectionView.refresh()
                        attr_vueObj.content_Changed()
                        // content_Changed сам перерисует грид одним обновлением —
                        // немедленный flex.refresh() давал лишний кадр со старыми
                        // данными до отложенной пересборки = мерцание
                    } else {
                        attr_vueObj.flex.refresh()
                    }

                    break
                } case 'gridSaved': {
                    // Правка ячеек ушла в фоновый пересчёт: данные грида НЕ перечитываем
                    // (select со старыми витринами стирал введённые цифры — «мигание»),
                    // снимаем только dirty-состояние; свежие данные привезёт select
                    // из poll_cell_edits по завершении каскада
                    // IE 2026 09 05 / ODOO-336379 (план ускорения M03, шаг 4): тот же ответ с action.save_delta —
                    // запись прошла без пересчёта, полного re-select не будет: грид остаётся как отредактирован,
                    // снимаем пометки правленых строк и обновляем командную панель (жёлтый Save гаснет)
                    let attr_vueObj = vueObj.get_vueObj('dataSheet')
                    if (!attr_vueObj?.undoStack && action.save_delta) attr_vueObj = vueObj.get_vueObj(action_binding || '_doc.data')
                    // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P3: в сохранённой пачке была правка флажка согласования (флажковый ввод, цикл начат) — бэк провёл переход единицы строки
                    // (Draft → In review → Approved, следующий шаг открылся), а дельта-ответ статусов строк не несёт: после очистки стеков статусы, пилюли, чипс и замки перечитываются обычным select
                    // (как кнопка Update data). Выключатели: fe.ux.approval (весь блок согласования), fe.ux.approvalRefreshAfterSave (только это перечитывание), по умолчанию вкл.
                    const _apprRefresh = !!action.save_delta && store.setting('fe.ux.approval', true) !== false && store.setting('fe.ux.approvalRefreshAfterSave', true) !== false
                        && (!!WIDGET?._apprFlagSave || approval_flagEdited(approval_doc(WIDGET?.record?.doc), attr_vueObj?.undoStack))
                    if (WIDGET) delete WIDGET._apprFlagSave
                    if (attr_vueObj) {
                        if (action.save_delta) {
                            for (const rowStack of attr_vueObj.undoStack || []) {
                                const di = rowStack?.irow >= 0 ? attr_vueObj.flex?.rows?.[rowStack.irow]?.dataItem : null
                                if (di?._meta) di._meta.modified = false
                            }
                            // IE 2026 09 05 / ODOO-336379: python-пересчёт после правки помечает modified и производные строки
                            // (бренд, соседние меры — 34 строки на одну правку в M03); бэк их принял и ничего не менял (иначе
                            // ветка delta не выбирается), поэтому снимаем пометку со ВСЕХ строк — как сделал бы полный select.
                            // Живая проверка на ветке 1BPC_002-br1: без этого после save оставалось 33 modified-строки.
                            const _clearMeta = (it) => { if (it?._meta?.modified) it._meta.modified = false; if (Array.isArray(it?.attrs)) it.attrs.forEach(_clearMeta) }
                            for (const row of attr_vueObj.flex?.rows || []) _clearMeta(row.dataItem)
                            try { (attr_vueObj.data000 || attr_vueObj.cache2_data000 || []).forEach(_clearMeta) } catch (e) { /* дерево данных недоступно — строки грида уже очищены */ }
                        }
                        attr_vueObj.undoStack.length = 0
                        attr_vueObj.redoStack && (attr_vueObj.redoStack.length = 0)
                        attr_vueObj.changesStack = {}
                        attr_vueObj.modified = false
                        if (action.save_delta) {
                            try { attr_vueObj.set_commandPanel?.() } catch (e) { /* панель обновится следующим действием */ }
                            if (!store.hide_console) console.log(`[${WIDGET.id}] save delta: no re-select`, action.save_delta)
                        }
                        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P3: чипс «Corrections» считается по undo-стеку и обновляется только при правке / откате — после дельта-ответа (стек очищен выше) «сохранённая» правка висела в чипсе
                        try { attr_vueObj.corrChip_schedule?.() } catch (e) { /* чипс обновится следующим действием */ }
                    }
                    // IE 2026 10 15 / ODOO-5800 (Igor 15.10: целостность флагов по годам): бэк поставил / снял флажки соседних лет (cascade_rows) — чекбоксы в гриде сразу, re-select статусов ниже — как раньше
                    const _casc = approval_cascadeRows(action)
                    if (_casc.length && attr_vueObj?.approvalCascade_apply) { try { attr_vueObj.approvalCascade_apply(_casc) } catch (e) { console.warn('[approval] cascade_rows', e) } }
                    if (_apprRefresh && WIDGET?.vueObj) {
                        if (!store.hide_console) console.log(`[${WIDGET.id}] save delta: approval flag saved — re-select of the statuses`)
                        store.executeStoreMethod(WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                    }
                    break
                } case 'updateWidget': {
                    if ('WIDGET' in action) {
                        if (action.WIDGET.debug_console) {
                            action.WIDGET.debug_console = action.WIDGET.debug_console + `\n--------------------------------------------------------------------------------\n` + (WIDGET.debug_console || '')
                        }
                        store.reportCellForm_closeOnReload(WIDGET, action)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114842: форма ячейки закрывается при обновлении отчёта)
                        store.preserve_itemsSourcesView(WIDGET, action.WIDGET.record)
                        delete action.WIDGET.styleWidget // IE 2026 08 19: рект — фронтовый, эхо не применяем
                        Object.assign(WIDGET, action.WIDGET)
                        adf_kick(WIDGET)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): D1 — audit_diff пришёл в сырой WIDGET, бейдж «⇄ N» формы — сразу при открытии
                    }
                    vueObj.content_Changed(null, null, null, rowForm_contentOpts(action))   // IE 2026 10 13 / ODOO-5800: фоновый ответ — формы строк остаются открытыми
                    store.sync_WORKSPACE(WIDGET, '>>WORKSPACE')

                    break
                } case 'updateWIDGET': {
                    store.reportCellForm_closeOnReload(WIDGET, action)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114842: форма ячейки закрывается при обновлении отчёта)
                    graphPayload_take(action.WIDGET?.record)   // webscm 2026 10 26 / ODOO-348733: данные сетевого графа — без глубокой реактивности (utils/graphPayload.js)
                    store.preserve_itemsSourcesView(WIDGET, action.WIDGET?.record)
                    docsNav_dropStaleCaps(WIDGET, action.WIDGET)   // IE 2026 09 28 / ODOO-342342 (ревью п.5): признак читалки — только из этого ответа (reload)
                    store.updateWIDGET(WIDGET, action.WIDGET)
                    docsNav_applyTitle(store, WIDGET)   // IE 2026 09 28 / ODOO-342342: читалка документации — заголовок H1 документа и после перечитывания
                    store.guide_personalTake(WIDGET)   // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): перечитанная форма кейса — личное итогом слоёв, как в навигаторе

                    WIDGET.attrs_vueObj.WIDGET.set_commandPanel()
                    WIDGET.attrs_vueObj?.WIDGET?.settingsList_onRecordReplaced?.()   // IE 2026 09 10 / ODOO-…: панель Settings tree открыта — список заново

                    // content_Changed до set_nonEmptyWidget: у видимых гридов взводится
                    // need_content_Changed_afterTimeout → set_nonEmptyWidget их пропустит
                    // (пересборка сама применит CHIPS), иначе мутации row.visible на старом
                    // CollectionView дают лишний wijmo-refresh = лишний кадр
                    vueObj.content_Changed(null, null, null, rowForm_contentOpts(action))   // IE 2026 10 13 / ODOO-5800: фоновый ответ — формы строк остаются открытыми
                    store.set_nonEmptyWidget(WIDGET)
                    store.set_isMappedWidget(WIDGET)
                    
                    store.widget_checkLoading(WIDGET.vueObj)
                    store.sync_WORKSPACE(WIDGET, '>>WORKSPACE')

                    break
                } case 'updateDoc': {
                    if (store.cellView_takeAnswer(WIDGET, action)) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): ответ select_cell_views — слияние в ячейки, без замены записи и перерисовки
                        for (const action_after of action.actions_after || []) store.executeStoreMethod(vueObj, action_after)
                        action.actions_after = []
                        break
                    }
                    store.reportCellForm_closeOnReload(WIDGET, action)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114842: форма ячейки закрывается при обновлении отчёта)
                    // updates — таблица точечных обновлений [{binding, value}]: значения
                    // применяются к текущему record, полная замена record из action
                    // при этом НЕ выполняется (record в ответе игнорируется)
                    const updates = 'updates' in action ? (action.updates || []) : null
                    // webscm 2026 10 26 / ODOO-348733: ответ сетевого графа — строки по ссылкам на узлы / рёбра (копиями), данные графа — markRaw;
                    // до записи в стор и до любого чтения строк (utils/graphPayload.js)
                    if (!updates && action.record) graphPayload_take(action.record)
                    // реестр _doc.itemsSourcesView присылается бэком только если изменился;
                    // отсутствие ключа в новой _doc = «не менялся» — переносим прежний
                    if (!updates) store.preserve_itemsSourcesView(WIDGET, action.record);
                    ['record', 'title', 'tooltip', 'pi2', 'widget_cache_key'].forEach(key => {
                        if (key in action) {
                            if (key === 'record' && updates) return
                            if (key === 'title' && WIDGET._multiply?.title && !shortcutTitle_take(WIDGET, action, (k, d) => store.setting(k, d))) return   // IE 2026 09 15 / ODOO-… (заказ Игоря): заголовок экземпляра тиража; IE 2026 11 02 / ODOO-349799 (shortcut-title): явный title ответа на своё действие окна (toggle / swap) принимается; IE 2026 11 03 / ODOO-349799 (updateDoc title for multiply window): окно ярлыка (_multiply без key тиража) — любой явный title ответа (utils/shortcutTitle.js)
                            WIDGET[key] = action[key]
                        }
                    })
                    if (!updates && action.record) store.tasksBar_fromRecord(WIDGET.record)   // IE 2026 09 23 / ODOO-… (заказ Игоря: панель задач в шапке): Update data формы стола → снимок
                    if (!updates && action.record) docsNav_applyTitle(store, WIDGET)   // IE 2026 09 28 / ODOO-342342: читалка документации — заголовок H1 документа (запись пришла целиком)
                    if (!updates && action.record) store.guide_personalTake(WIDGET)   // IE 2026 09 29 / ODOO-342342 (приёмка ie-growth7 З1): форма кейса (запись пришла целиком) — личное итогом слоёв
                    if (updates) {
                        for (const r of updates) {
                            store.set_value(WIDGET, r.binding, r.value)
                        }
                        for (const r of updates) store.lazyTab_afterData(WIDGET, r.binding)   // IE 2026 10 16 / ODOO-5800: данные ленивой вкладки — панель чинит свой грид (utils/lazyTabReveal.js)
                    }
                    // R19 (openLean): ключ снят бэком как дубль того, что уже в WIDGET.
                    // Присваивать нечего (там ТОТ ЖЕ объект), но побочные эффекты ниже
                    // висят на факте прихода ключа — их выполняем как при обычном ответе
                    const sameAsWIDGET = action.same_as_WIDGET || []
                    if ('view' in action) {
                        store.updateAttrs(WIDGET.view, action.view)

                        WIDGET.attrs_vueObj.WIDGET.set_commandPanel()
                    } else if (sameAsWIDGET.includes('view')) {
                        WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.()
                    }
                    // изменившиеся куски формы: бэк не гоняет всё описание
                    // виджета на каждый ответ, а присылает путь узла и сам узел
                    if (Array.isArray(action.view_patch) && WIDGET.view) {
                        store.applyViewPatch(WIDGET.view, action.view_patch)
                        WIDGET.attrs_vueObj.WIDGET.set_commandPanel()
                    }
                    if ('set_value' in action) {
                        for (const r of action.set_value) {
                            store.set_value(WIDGET, r.binding, r.value)
                        }
                    }
                    if ('refresh_itemsSource' in action) {
                        store.refresh_itemsSource(action.refresh_itemsSource.segment)
                    }
                    vueObj.content_Changed(null, null, null, rowForm_contentOpts(action))   // IE 2026 10 13 / ODOO-5800: фоновый ответ — формы строк остаются открытыми
                    // content_Changed до set_nonEmptyWidget — см. комментарий в updateWIDGET
                    if ('record' in action || 'view' in action || 'set_value' in action || updates
                            || sameAsWIDGET.length) {
                        store.set_nonEmptyWidget(WIDGET)
                        store.set_isMappedWidget(WIDGET)
                    }
                    // this.widgetResize(vueObj)

                    if (!updates && action.record) store.cellView_afterDoc(WIDGET)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): новый основной ответ — версия отложенных данных видов, запрос активного вида без данных
                    if (typeof action.selectTab === 'string' && selectTab_on((k, d) => store.setting(k, d))) store.widget_selectTab(WIDGET, action.selectTab)   // IE 2026 10 30 / ODOO-349799: бэк переключает вкладку (кнопка Graph вкладки Addons)
                    for (const action_after of action.actions_after || []) {
                        store.executeStoreMethod(vueObj, action_after)
                    }
                    action.actions_after = []

                    store.sync_WORKSPACE(WIDGET, '>>WORKSPACE')

                    // store.rightArea_hide()

                    break
                // } case 'onEditAttrs__Click': {
                //     WIDGET.editAttrs = !WIDGET.editAttrs
                //     if (!WIDGET.editAttrs) {
                //         let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
                //         let PAGE = WORKSPACE.PAGES[WIDGET.page]
                //         let rightArea = PAGE.rightArea

                //         store.attr_active = null;
                //         store.attr_activeEl = null;

                //         // close WIDGETS
                //         if (rightArea.WIDGET) {
                //             store.rightArea_hide()
                //         }
                //     }
                //     break
                } case 'plus-click': {
                    let tree = vueObj.get_flex(action_binding),
                        attrs = tree.itemsSource,
                        node = tree.selectedNode,
                        attr_new = store.attr_new(attrs, action)
                    if (action.clone && node) { // clone_Click
                        attr_new.title = store.increment_name(node.dataItem.title)
                        attr_new.attr_type = node.dataItem.attr_type
                    }
                    if (node && node.parentNode) {
                        tree.selectedNode = node.parentNode.addChildNode(node.index + 1, attr_new)
                        this.tree_WidgetatItem(tree, tree.selectedNode)
                    } else if (node) {
                        tree.selectedNode = tree.addChildNode(node.index + 1, attr_new)
                        this.tree_WidgetatItem(tree, tree.selectedNode)
                    } else {
                        tree.itemsSource.push(attr_new)
                        tree.loadTree(true);
                        tree.selectedItem = tree.itemsSource[0]
                    }
                    break
                } case 'plus-child-click': {
                    let tree = vueObj.get_flex(action_binding),
                        attrs = tree.itemsSource,
                        node = tree.selectedNode,
                        attr_new = store.attr_new(attrs, action)
                    if (node) {
                        let i = node.nodes ? node.nodes.length : 0;
                        tree.selectedNode = node.addChildNode(i, attr_new)
                        this.tree_WidgetatItem(tree, tree.selectedNode)
                    } else {
                        tree.itemsSource.push(attr_new)
                        tree.loadTree(true);
                        tree.selectedItem = tree.itemsSource[0]
                    }
                    break
                } case 'minus-click': {
                    let tree = vueObj.get_flex(action_binding),
                        node = tree.selectedNode
                    if (node) {
                        node.remove()
                    }
                    break
                } case 'set-binding': {
                    const binding_ = store.get_value(WIDGET.record, action.source)
                    if (binding_) {
                        let attr_ = store.get_field(WIDGET.view, action.target_name)
                        attr_.binding = binding_
                        const attr_vueObj = WIDGET.attrs_vueObj[attr_.id]
                        attr_vueObj.content_Changed()
                    }
                    break
                } case 'changeAttrState': {
                    for (const attr of action.attrs_newState) {
                        const attr_ = store.get_field(WIDGET.view, attr.name)
                        if (attr_) {
                            for (let key in attr) {
                                attr_[key] = attr[key]
                            }
                        }
                    }
                    if (action.defaultSeriesVisibility) {
                        store.executeStoreMethod(WIDGET.vueObj, { 'command':'set_visibleChart', 'defaultSeriesVisibility':true })
                    }
                    vueObj.content_Changed(null, 'changeAttrState')
                    break
                } case 'set_viewParam': {
                    let value
                    if (form_attr?.attr_type === 'AttrNumber') {
                        value = store.attr_get(WIDGET, form_attr)
                    } else if (action.setValue !== null && action.setValue !== undefined) {
                        value = action.setValue
                    } else if (form_attr === null) { // from commandPanel_topLeft
                        let active = action.active || false
                        active = !active // invert
                        value = active ? action.checkValue : action.default;
                    } else {
                        value = store.attr_get(WIDGET, form_attr)
                        
                    }

                    if (action_binding.startsWith('doc.viewParams.')) {
                        let parts = (action_binding||'').split('.'),
                        name = parts[2],
                        param = parts[3]

                        const attr_vueObj = vueObj.get_vueObj(name)
                        if (attr_vueObj?.set_viewParam) {
                            attr_vueObj.set_viewParam(param, value)
                        } else {
                            store.set_viewParam(WIDGET, name, param, value)
                        }
                    } else {
                        store.attr_set(WIDGET, action, value)
                    }

                    break
                } case 'set_visibleChart': {
                    let attr_data = store.get_field(WIDGET.view, 'dataSheet')
                    if (attr_data) {
                        let vueSheet = WIDGET.attrs_vueObj[attr_data.id]
                        for (let item of WIDGET.record._doc.dataSheet) {
                            if (action.defaultSeriesVisibility) {
                                item.visibleChart = (item.measure=='M_baseLine' || item.measure=='M_forecast')
                            } else {
                                item.visibleChart = false
                            }
                            vueSheet.set_visibleChart(item.visibleChart, item.measure)
                        }
                    }
                    break
                } case 'onAddFilterOnSelectedCells__Click': {
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    attr_vueObj.addFilterOnSelectedCells()
                    break
                } case 'onClearFilter__Click': {
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    attr_vueObj.clearFilter()
                    break
                } case 'drilldown_refresh': {
                    // IE 2026 08 18 / ODOO-5555: смена выделения в отчёте-источнике —
                    // обновить открытые на странице расшифровочные виджеты с refresh,
                    // если фильтры ячейки изменились (where_key бэка)
                    for (const t of action.targets || []) {
                        if (!t?.refresh || !t.widget) continue
                        const target = store.drilldown_findOpen(t.widget)
                        if (!target) continue
                        if (target._drilldown_where_key === t.where_key) continue
                        store.drilldown_applyToWidget(target, t.fieldsMapping, { source_widget_id: action.source_widget_id, refresh: true, where_key: t.where_key, period: t.drilldown_period }, false)
                    }
                    break
                } case 'set_nonEmptyWidget': {
                    let attr = store.get_field0(WIDGET.groupMenu?.commandPanel, 'non-empty-widget', 'name')
                    attr.active = !attr.active

                    // hideHeader hideTabs hideGridPanel
                    if (!attr.active) {
                        WIDGET.styleWidget.show_hidden = true
                    }

                    // commandPanel рендерит копии groupMenu (updateCommandPanelInPlace) — синхронизируем active
                    WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.()
                    store.set_nonEmptyWidget(WIDGET)
                    break
                } case 'set_isMappedWidget': {
                    let attr = store.get_field0(WIDGET.groupMenu?.commandPanel, 'isMapped-widget', 'name')
                    attr.active = !attr.active

                    WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.()
                    store.set_isMappedWidget(WIDGET)
                    break

                } case 'onAttrJSON_toggleEdit__Click': {
                    let attr_vueObj
                    if (action.isDropdown) {
                        attr_vueObj = store.dropdown.vueObj_content
                    } else {
                        attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    }
                    
                    if (!attr_vueObj) break
                    if (!attr_vueObj.editMode) attr_vueObj._editSnapshot = attr_vueObj.content_str
                    attr_vueObj.editMode = !attr_vueObj.editMode
                    attr_vueObj.set_commandPanel()
                    break
                } case 'onAttrJSON_cancel__Click': {
                    let attr_vueObj
                    if (action.isDropdown) {
                        attr_vueObj = store.dropdown.vueObj_content
                    } else {
                        attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    }
                    
                    if (!attr_vueObj) break
                    attr_vueObj.content_str = attr_vueObj._editSnapshot ?? attr_vueObj.content_str0
                    attr_vueObj.isError = false
                    attr_vueObj.editMode = false
                    attr_vueObj.set_commandPanel()
                    break
                } case 'onAttrJSON_apply__Click': {
                    let attr_vueObj
                    if (action.isDropdown) {
                        attr_vueObj = store.dropdown.vueObj_content
                    } else {
                        attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    }
                    
                    if (!attr_vueObj || attr_vueObj.isError) break

                    let newContent
                    try {
                        if (action.isCSS) {
                            newContent = store.CSS_parse(attr_vueObj.content_str)
                        } else {
                            newContent = store.JS_parse(attr_vueObj.content_str)
                        }
                    } catch (e) {
                        attr_vueObj.isError = true
                        break
                    }

                    // IE 2026 09 04 / ODOO-336283 (заказ Игоря): поле формы (AttrTabGrid, строка с полем AttrCSS —
                    // Style строки лэйаута) хранит CSS СТРОКОЙ: словарь из CSS_parse уходил в attr.value/valueStr
                    // как объект («[object Object]», значение не записывалось) — для формы отдаём строку
                    // IE 2026 09 04 / ODOO-336283: тип поля берём из строки формы (dropdown.V) — parent_attr в живой форме
                    // не всегда AttrTabGrid; тип значения сохраняем: строка остаётся строкой, словарь — словарём
                    // IE 2026 09 04 / ODOO-336283: конвертация ДО ветвления — запись из формы идёт веткой attr_set
                    if (action.isCSS) {
                        const _tgt = attr_vueObj.attr || {}
                        const _formRow = store.dropdown?.V?.attr_type === 'AttrCSS' || store.dropdown?.parent_attr?.attr_col?.attr_type === 'AttrCSS'
                        const _curV = action.isDropdown ? store.dropdown.value : _tgt.value
                        const _isCssField = _formRow || _tgt.attr_type === 'AttrCSS'
                        // тип значения сохраняем: строка (или пусто в строке формы) → строка; словарь → словарь
                        // тип исходного значения помнит сам редактор (AttrCSS._valueIsString); запасной путь — по текущему значению
                        const _strMode = attr_vueObj._valueIsString !== undefined ? attr_vueObj._valueIsString : (typeof _curV === 'string' || (_curV == null && _formRow))
                        if (_isCssField && _strMode) newContent = store.CSS_toLine(newContent)
                    }
                    if (action.isDropdown) {
                        if (store.dropdown.value !== newContent) {
                            store.dropdown.value = newContent
                            store.dropdown.onInput_value()
                        }
                    } else {
                        store.attr_set(WIDGET, attr_vueObj.attr, newContent)
                    }
                    attr_vueObj.isError = false
                    attr_vueObj.editMode = false
                    attr_vueObj.set_commandPanel()

                    if (WIDGET.widget === 'widget-row') {
                        const _meta = WIDGET.record._meta
                        const parentWIDGET = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
                        if (parentWIDGET) {
                            if (_meta.type === 'widget-row-chip') {
                                store.set_chip(parentWIDGET, _meta, newContent || {})
                            } else if (_meta.type === 'widget-row-viewParams') {
                                const parentAttr_vueObj = parentWIDGET.vueObj?.get_vueObj(_meta.name)
                                if (attr_vueObj.attr.binding === '_widget.record._record') {
                                    for (const [key, val] of Object.entries(newContent)) {
                                        if (key === 'attrs') {
                                            12
                                        }
                                        if (parentAttr_vueObj?.set_viewParam) {
                                            parentAttr_vueObj.set_viewParam(key, val)
                                        } else {
                                            store.set_viewParam(parentWIDGET, _meta.name, key, val)
                                        }
                                    }
                                } else if (attr_vueObj.attr.binding === '_widget.record._data') {
                                    // if (!Array.isArray(newContent)) {
                                    //     newContent = []
                                    // }
                                    store.set_value(parentWIDGET.record, _meta.binding, newContent || [])
                                }
                                parentWIDGET.vueObj?.content_Changed_attr_vueObj?.(_meta.name)

                            } else if (_meta.type === 'widget-row' || _meta.type === 'widget-row-cell') {
                                if (attr_vueObj.attr.binding === '_widget.record._record') {
                                    for (const [key, val] of Object.entries(newContent)) {
                                        if (key.startsWith('_') || key === '$cutMarker') continue
                                        store.attr_set(WIDGET, { binding: key }, val, null, null, false)
                                    }
                                }
                                parentWIDGET.vueObj?.content_Changed_attr_vueObj?.(_meta.binding)
                            }
                        }
                    }
                    break

                } case 'onFold_deep__Click': {
                    const attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    if (!attr_vueObj?.unfoldAll && !attr_vueObj?.foldToLevel) break
                    const level = action.params?.fold_deep
                    if (level === Infinity) {
                        attr_vueObj.unfoldAll?.()
                    } else {
                        attr_vueObj.foldToLevel?.(level)
                    }
                    break
                } case 'validateAll_isMappedWidget': {
                    store.set_isMappedWidgets(WIDGET)
                    break
                } case 'close_childrenWidgets': {
                    store.close_childrenWidgets(WIDGET)
                    break
                } case 'toggleDarkMode': {
                    vueObj.$appState.darkTheme = !vueObj.$appState.darkTheme
                    store.darkThemePref = vueObj.$appState.darkTheme
                    store.saveColorSettings(vueObj)
                    break
                } case 'setColorScheme': {
                    store.applyColorScheme(action.colorScheme)
                    store.saveColorSettings(vueObj)
                    break
                } case 'variants_saveFilters': { // IE 2026 09 14 / ODOO-… (заказ Игоря: варианты страниц и фильтров стола): команды панели вариантов (Commands → Filters / Widgets)
                    store.variants_saveFilters({ private: !!action.private })
                    break
                } case 'variants_saveWidgets': {
                    store.variants_saveWidgets({ private: !!action.private })
                    break
                } case 'variants_save': {
                    store.variants_save(action.kind)
                    break
                } case 'variants_useCurrent': {
                    store.variants_useCurrent(action.kind)
                    break
                } case 'setIconScheme': { // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок) — независимо от гаммы
                    store.applyIconScheme(action.iconScheme)
                    store.saveColorSettings(vueObj)
                    break
                } case 'restoreLastClosedWidget': {
                    store.restoreLastClosedWidget()
                    break
                } case 'freeWidgetsMode': { // IE 2026 09 08 / ODOO-… (заказ Игоря): меню Widgets → Behavior
                    freeWidgets.setMode(action.mode)
                    break
                } case 'setLanguage': {   // IE 2026 09 23 / ODOO-341407: пункт меню пользователя «Language»
                    store.set_language(action.language)
                    break
                } case 'showTooltip': {
                    store.showTooltip = !store.showTooltip
                    break
                } case 'navigator_toggle': case 'navigator_open': case 'navigator_close': {   // demo-webscm 2026 11 02 / ODOO-350612: правый док навигатора (кнопка шапки, Alt N, команды)
                    if (!navigator_on(store)) break
                    const open = action.command === 'navigator_open' ? true : action.command === 'navigator_close' ? false : !store.navigator.open
                    store.navigator_set({ open, ...(action.params || {}) })
                    break
                } case 'navigator_mode': {   // demo-webscm 2026 11 02 / ODOO-350612: dock | free | strip
                    if (NAVIGATOR_MODES.includes(action.mode)) store.navigator_set({ mode: action.mode, open: true })
                    break
                } case 'navigatorAtStart': {   // demo-webscm 2026 11 02 / ODOO-350612: флажок меню пользователя «Open navigator at start» — настройка USER (бэк user_settings_save)
                    store.navigatorAtStart_save(typeof action.on === 'boolean' ? action.on : !store.navigatorAtStart)
                    break
                } case 'menuHoverOpen': {   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл): флажок меню пользователя (on — значение флажка; без него — переключение, пункт wj-menu)
                    store.menuHoverOpen = typeof action.on === 'boolean' ? action.on : !store.menuHoverOpen   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
                    break
                } case 'showSQL': {
                    store.showSQL = !store.showSQL
                    break
                } case 'profiling_params_use': {
                    const profiling_params = store.profiling_params
                    profiling_params.use = !profiling_params.use

                    if (profiling_params.use) {
                        WIDGET.record._doc = WIDGET.record._doc || {}
                        WIDGET.record._doc.line_summary = []
                        WIDGET.record._doc.call_tree = []
                        WIDGET.record._doc.call_summary = []

                        // vueObj.content_Changed()
                    }

                    if (profiling_params.type === 'fe') {
                        if (profiling_params.use) {
                            this.cg.start()
                        } else {
                            this.cg.stop()
                            const {call_tree_text, call_tree, call_summary} = this.cg.render_tree(profiling_params)

                            WIDGET.record._doc.line_summary = []
                            WIDGET.record._doc.call_tree = call_tree
                            WIDGET.record._doc.call_summary = call_summary

                            // vueObj.content_Changed()
                            vueObj?.content_Changed_attr_vueObj?.('_doc.line_summary')
                            vueObj?.content_Changed_attr_vueObj?.('_doc.call_summary')
                            vueObj?.content_Changed_attr_vueObj?.('_doc.call_tree')
                        }
                    }
                    break

                } case 'copyPaste': {
                    if (action.method === 'importRecords') { store.importRecords_fromClipboard(); break }   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: импорт записей — меню и вставка)
                    if (action.method === 'importRecordsFile') { store.importRecords_fromFile(); break }   // IE 2026 10 28 / ODOO-349799 (PR5): пункт «Import records from file»
                    const record = WIDGET.record
                    const attr_vueObj = vueObj.get_vueObj(action.source_name || action_binding)
                    const flex = vueObj.get_flex(action_binding)
                    let binding = (form_attr?.binding || 'data') // .replace(/\./g, '-')
                    let binding_last = (form_attr?.binding || 'data').split('.').pop()
                    
                    const mode = action.method.startsWith('import') ? 'import' : 'paste'
                    const target = action.method.replace(/^import|^paste/i, '').toLowerCase() // widget/record/items
                    
                    let meta = {
                        schema: "webscm.export.v1",
                        exportedAt: new Date().toISOString(),
                        exportedFrom: "WebSCM",

                        exportedBy: {
                            id: store.user?.id,
                            title: store.user?.title,
                        },

                        source: {
                            database: {
                                id: store.user.database.dbid,
                                title: store.user.database.title,
                            },
                            company: {
                                id: store.user.company.id,
                            },
                            process_model: {
                                id: store.process_model_record.id,
                                title: store.process_model_record.title,
                            },
                            workspace: {
                                id: store.activeWORKSPACE.workspace,
                                title: store.activeWORKSPACE.title,
                            },
                            widget: {
                                id: WIDGET?.id,
                                title: WIDGET?.title,
                            },
                            record: {
                                id: record?.id,
                                segment: record?.segment,
                                version: record?.version,
                                title: record?.title,
                            },
                            field: {
                                binding: binding,
                                title: form_attr?.title || binding,
                            },
                        },
                    }

                    let chip, fileName
                    if (['copyWidget', 'exportWidget'].includes(action.method)) {
                        fileName = `${store.sanitizeFileName(WIDGET.title)} -- widget -- ${record.id} -- ${record.segment}` + (record.version ? ` -- ${record.version}` : '')
                        chip = {
                            title: WIDGET.title || '',
                            segment: "CHIP-Widget",
                            meta: meta,
                            doc: {
                                WIDGET: store.copyWidget_JSON(WIDGET),
                            }
                        }
                        // this.remove_keys_in_place(chip, ['_widget', '_quantity_map', '_fe']) // , 'meta' LOOK , meta.iroot, modified
                    
                    } else if (['copyRecord', 'exportRecord'].includes(action.method)) {
                        fileName = `${store.sanitizeFileName(WIDGET.title)} -- record -- ${record.id} -- ${record.segment}` + (record.version ? ` -- ${record.version}` : '')
                        chip = {
                            title: WIDGET.record.title || '',
                            segment: "CHIP-Record",
                            meta: meta,
                            doc: {
                                record: WIDGET.record, // -meta, -_fe
                            },
                        }
                        // this.remove_keys_in_place(chip, ['_widget', '_quantity_map', '_fe']) // , 'meta' LOOK , meta.iroot, modified
                    
                    } else if (['copyItems', 'exportItems'].includes(action.method)) {
                        fileName = `${store.sanitizeFileName(WIDGET.title)} -- data -- ${binding} -- ${record.id} -- ${record.segment}` + (record.version ? ` -- ${record.version}` : '')
                        
                        let attr_vueObj = vueObj.get_vueObj(action.source_name || action.binding)

                        let data = attr_vueObj.copy_selectedItems() || flex.itemsSource.items || []
                        data = JSON.parse(JSON.stringify(data))

                        for (let row of data) {
                            // delete row._cells
                            // row._fe = {
                            //     row: row._fe?.row_number,
                            // }
                            // delete row.MD
                        }

                        const selectedCells = attr_vueObj.get_selectedRanges()
                        const cells = selectedCells.map(cell => ({
                            col: cell.icol + 1,
                            row: cell.irow + 1,
                            value: cell.value ?? '',
                            binding: cell.attr_col.binding, 
                            title: cell.attr_col.title || cell.attr_col.binding, 
                        }))

                        const WHERE = record.doc?.params?.WHERE || []
                        const fieldsMapping = record.doc?.params?.fieldsMapping || []
                        
                        let sourse_attr = form_attr || vueObj.get_vueObj?.(action.source_name || action.binding).attr
                        chip = {
                            title: sourse_attr?.title || sourse_attr?.name || binding,
                            // titles: [...new Set(cells.map(c => c.title || c.binding))].join(', '),

                            segment: "CHIP-Rows",
                            meta: meta,
                            doc: {
                                data: data,
                                cells: cells,
                                fields: sourse_attr.attrs,
                                WHERE: WHERE,
                                fieldsMapping: fieldsMapping,
                                // WHERE = dl2.get_where_many(self.WIDGET, cells, ss, addWidgetWHERE)
                            },
                        }

                        if (action.method2 === 'copyCell') {
                            chip.segment = "CHIP-Cell"
                        } else if (action.method2 === 'deepCopy') {
                            chip.segment = "CHIP-Records"
                        } else if (action.method2 === 'copyCellAndWidgetsFilters') {
                            chip.segment = "CHIP-CellAndWidgetsFilters"
                        } else if (action.method2 === 'copyCellValues') {
                            chip.segment = "CHIP-CellValues"
                        }
                    }
                    
                    if (['copyWidget', 'copyRecord', 'copyItems'].includes(action.method)) {
                        const chipOut = store.copyPaste_cleanEmpty ? store.deepCleanEmpty(chip) : chip
                        // IE 2026 09 23 / ODOO-341407: i18n (что скопировано + тосты)
                        const method2Labels = { copyCell: t('cell'), copyCellFilters: t('cell filters'), copyCellAndWidgetsFilters: t('cell&widget filters'), copyCellValues: t('values') }
                        const copyLabel = action.method === 'copyWidget' ? t('widget') : action.method === 'copyRecord' ? t('record') : (method2Labels[action.method2] ?? t('rows', null, 'copied'))   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)

                        const writeToClipboard = (chipFinal) => {
                            let text = store.jsObjectToPythonLiteral(chipFinal)
                            navigator.clipboard.writeText(text)
                                .then(() => store.show_notification({ text: t('Copied {what} to clipboard!', { what: copyLabel }) }))
                                .catch(err => store.show_notification({ text: t('Failed to copy to clipboard: {error}', { error: err.message }), status: 'error' }))
                        }

                        if (action.method2 === 'deepCopy') {
                            store.executeBackendMethod(vueObj, {
                                method: 'records_deepCopy',
                                params: { chip: chipOut },
                            }, (answer) => {
                                writeToClipboard(answer.chip ?? chipOut)
                            })
                        } else {
                            writeToClipboard(chipOut)
                        }
                    
                    } else if (['exportWidget', 'exportRecord', 'exportItems'].includes(action.method)) {
                        const chipOut = store.copyPaste_cleanEmpty ? store.deepCleanEmpty(chip) : chip
                        let text = store.jsObjectToPythonLiteral(chipOut)
                        saveFile(text, `${fileName}.json`);

                    } else if (action.method === 'exportGrid') {
                        const fileName = `${store.sanitizeFileName(WIDGET.title)} -- data -- ${binding} -- ${record.id} -- ${record.segment}` + (record.version ? ` -- ${record.version}` : '')

                        // мульти-вертикальная таблица печати: выгрузка со СКЛЕЙКОЙ секций
                        // (xlsx — базовые колонки + объединения, pdf — секции подряд).
                        // компонент группы — по биндингу СЕКЦИИ (_doc.printX[i].attrs ->
                        // _doc.printX через _mvtObjs): _mvtPrint один на виджет, и в
                        // объединённой вкладке печати его перетирал ленивый Template
                        // (isMulti false) — экспорт превью падал в обычную ветку,
                        // где у гридов секций нет vueObj/flex (TypeError)
                        const _mvtB = String(action_binding || '').replace(/\[\d+\]\.attrs$/, '')
                        const _mvt = WIDGET._mvtObjs?.[_mvtB] || WIDGET._mvtPrint
                        if (_mvt?.isMulti && String(action_binding || '').startsWith('_doc.print')
                                && ['xlsx', 'pdf'].includes(action.params.format)) {
                            if (action.params.format === 'xlsx') {
                                _mvt.mvt_exportXlsx(fileName)
                            } else {
                                _mvt.mvt_exportPdf(fileName)
                            }
                        } else if (!flex) {
                            // грид не смонтирован (напр. ленивая вкладка) — не роняем UI
                            store.show_notification({ text: t('Nothing to export'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n
                        } else if (action.params.format === 'xlsx') {
                            let exportWithHeaderFooter = false
                            if (exportWithHeaderFooter) {
                                // 1) получаем книгу из грида (с колонками заголовков)
                                const book = wjcGridXlsx.FlexGridXlsxConverter.save(
                                    flex,
                                    {
                                        includeColumnHeaders: true,
                                        includeRowHeaders: true,
                                        formatItem: attr_vueObj.formatItemXlsx,
                                    },
                                );

                                const sheet = book.sheets[0];
                                const colCount = (sheet.columns && sheet.columns.length) || theGrid.columns.length || 1;

                                // 2) строим шапку (две верхние строки)
                                const headerTitle = {
                                    cells: [{
                                        value: vueObj.WIDGET?.title,
                                        colSpan: colCount,
                                        style: {
                                            font: { bold: true, size: 16 },
                                            hAlign: wjcXlsx.HAlign.Center,
                                            vAlign: wjcXlsx.VAlign.Center
                                        }
                                    }],
                                    height: 28
                                };

                                const headerSub = {
                                    cells: [{
                                        value: `Date: ${new Date().toLocaleDateString()}`,
                                        colSpan: colCount,
                                        style: {
                                            font: { italic: true },
                                            hAlign: wjcXlsx.HAlign.Center
                                        }
                                    }],
                                    height: 20
                                };

                                // вставляем шапку перед существующими строками
                                // rows уже заполнен FlexGridXlsxConverter.save(...) — можно мутировать
                                const rows = sheet.rows || []; // если вдруг пусто, rows будет []
                                // Вставляем шапку в начало, сдвигая остальные строки (заголовки колонок + данные)
                                rows.splice(0, 0, headerTitle, headerSub);

                                // 3) подвал (последняя строка)
                                const footer = {
                                    cells: [{
                                    value: 'WebSCM',
                                    colSpan: colCount,
                                    style: {
                                        font: { size: 10, italic: true },
                                        hAlign: wjcXlsx.HAlign.Right
                                    }
                                    }],
                                    height: 18
                                };
                                sheet.rows.push(footer);

                                // 4) по желанию – заморозить строки, чтобы заголовки грида не «уехали»
                                // если FlexGrid-колонки экспортировались с includeColumnHeaders:true,
                                // то реальные заголовки грида окажутся на 3-й строке (после наших двух).
                                // Заморозим верхние 3 строки:
                                sheet.frozenPane = { rows: 3, columns: 0 };

                                // 5) сохранить файл
                                book.saveAsync(`${fileName}.xlsx`);
                            } else {
                                const isPrint = (String(action_binding || '').startsWith('_doc.print') || action_binding === 'doc.printTemplate' || action_binding === 'doc.printCells')
                                // R15 xlsxAsync: книга собирается порциями строк (batchSize) вместо одного
                                // синхронного прохода — вкладка не «зависает» на больших гридах, а прогресс
                                // виден в нотификации. Выкл: window.fastEntry.set('xlsxAsync', false)
                                const _xlsxAsync = store.fastEntry.xlsxAsync !== false
                                const _t0 = performance.now()
                                let _lastPct = -1
                                // R15b (dm 2026 08 04): порция — по числу ЯЧЕЕК, а не фикс. 300 строк.
                                // На широких отчётах (сотни колонок) порция в 300 строк = сотни тысяч
                                // ячеек одним синхронным куском: вкладка блокировалась на десятки секунд,
                                // прогресс не отрисовывался. Целимся в ~2500 ячеек на порцию.
                                // R15c (dm 2026 08 04): цена генерации ~1-4 мс/ячейку (замер СНГ$ 04.08),
                                // порция ~400 ячеек ≈ 0.4-1.5 с блока — UI дышит, прогресс успевает рисоваться
                                const _batchRows = Math.min(100, Math.max(2, Math.round(store.setting('fe.data.xlsxBatchCells', 400) / Math.max(1, flex.columns.length))))   // IE 2026 09 05 / ODOO-336330
                                // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): по умолчанию скрытые строки (чипсы поиска / фильтра, свёрнутые группы)
                                // и скрытые колонки (свёрнутые группы колонок, use=false) в файл НЕ идут — цикл конвертера их не обходит (utils/xlsxVisibleOnly:
                                // подмена статика _saveContentToWorksheet; замер 24.09 dev02 «Purchase Balance» 448 строк / 17 видимых: 43,8 с → см. коммит), колонки —
                                // штатная опция includeColumns. Команда «Export (XLSX) · including hidden rows and columns» (params.hidden) и настройка базы
                                // fe.ux.exportVisibleOnly = false — прежняя выгрузка: скрытые строки / колонки в файле как hidden. Неподдержанная сборка wijmo —
                                // xlsxVisibleOnly_supported() = false → прежняя выгрузка (один console.warn)
                                const _withHidden = !!action.params?.hidden
                                const _voSetting = store.setting('fe.ux.exportVisibleOnly', true)
                                const _visibleOnly = !_withHidden && !(_voSetting === false || _voSetting === 'false' || _voSetting === 0)
                                    && xlsxVisibleOnly_install(wjcGridXlsx, wjcGrid, wjcXlsx, wjcCore) && xlsxVisibleOnly_supported()
                                const _hiddenCounts = xlsxVisibleOnly_hiddenCounts(flex)
                                let _voStats = null
                                // IE 2026 09 23 / ODOO-341407: i18n (тосты экспорта)
                                if (_xlsxAsync) {
                                    store.show_notification({ text: t('Exporting to Excel… 0%'), status: 'info', timeout: null })
                                    // R15c: штатная полоса виджета как прогресс-бар экспорта
                                    if (WIDGET) { WIDGET.loadingPct = 0; WIDGET.loadingText = t('Exporting to Excel') }
                                }
                                const _xlsxDone = () => {
                                    const _s = ((performance.now() - _t0) / 1000).toFixed(1)
                                    if (WIDGET) { WIDGET.loadingPct = null; WIDGET.loadingText = null }
                                    // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): число ВЫГРУЖЕННЫХ строк данных (скрытые не считаются)
                                    store.show_notification({ text: t('Excel export done ({rows}, {sec}s)', { rows: tn(_voStats ? _voStats.exportedRows : flex.rows.length, '{n} row', '{n} rows'), sec: _s }), status: 'success' })
                                }
                                const _xlsxFail = (err) => {
                                    if (WIDGET) { WIDGET.loadingPct = null; WIDGET.loadingText = null }
                                    store.show_notification({ text: t('Excel export failed: {error}', { error: err?.message || err }), status: 'error' })
                                }
                                xlsxVisibleOnly_end()   // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): режим прошлой (в т.ч. отменённой) выгрузки не должен пережить её
                                if (_visibleOnly) _voStats = xlsxVisibleOnly_begin(flex)
                                attr_vueObj?.mergeBack_exportOff?.(true)   // IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»): объединение «назад» выключено, пока конвертер читает грид
                                try {
                                wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
                                    flex,
                                    {
                                        includeColumnHeaders: !isPrint,
                                        includeRowHeaders: !isPrint,
                                        includeColumns: _visibleOnly ? xlsxVisibleOnly_includeColumns(flex) : undefined,   // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): скрытые колонки не выгружаются
                                        formatItem: attr_vueObj?.formatItemXlsx,
                                        // includeStyles: false,
                                        // formatItem: store.customContent
                                        //     ? store.exportFormatItem
                                        //     : null
                                    },
                                    // файл сохраняем сами в onSaved: перед записью добавляется
                                    // лист INFO (паспорт отчёта + ссылка). Выкл: fastEntry.xlsxInfo
                                    undefined,
                                    (base64, workbook) => {
                                        const _vo = xlsxVisibleOnly_end()   // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): книга собрана — режим снят, статистика в уведомление
                                        attr_vueObj?.mergeBack_exportOff?.(false)   // IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»)
                                        if (_vo) _voStats = _vo
                                        try {
                                            if (workbook?.sheets && store.fastEntry.xlsxInfo !== false) {
                                                workbook.sheets.push(store.xlsx_infoSheet(WIDGET, { hidden: { included: !_visibleOnly, rows: _hiddenCounts.rows, cols: _hiddenCounts.cols } }))
                                            }
                                            // скрытых строк среди закреплённых в книге нет — закреплённая область короче на их число (конвертер считает по flex.rows.frozen)
                                            if (_vo?.skippedFrozen && workbook?.sheets?.[0]?.frozenPane?.rows > 0) workbook.sheets[0].frozenPane.rows = Math.max(0, workbook.sheets[0].frozenPane.rows - _vo.skippedFrozen)
                                        } catch (e) { console.warn('xlsx INFO sheet skipped:', e) }
                                        if (workbook?.saveAsync) {
                                            workbook.saveAsync(`${fileName}.xlsx`, () => _xlsxDone(), (err) => _xlsxFail(err))
                                        } else {
                                            // фолбэк: книги нет — скачать собранный base64 как есть
                                            const a = document.createElement('a')
                                            a.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64
                                            a.download = `${fileName}.xlsx`
                                            a.click()
                                            _xlsxDone()
                                        }
                                    },
                                    (err) => { xlsxVisibleOnly_end(); attr_vueObj?.mergeBack_exportOff?.(false); _xlsxFail(err) },   // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок); IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»)
                                    (pct) => {
                                        // onProgress: 0..100 (0..50 сборка книги, 51..100 упаковка xlsx)
                                        if (!_xlsxAsync) return
                                        if (WIDGET) WIDGET.loadingPct = pct  // R15c: полоса виджета
                                        if (pct - _lastPct >= 5 || pct >= 100) {
                                            _lastPct = pct
                                            const _es = Math.round((performance.now() - _t0) / 1000)
                                            store.show_notification({ text: t('Exporting to Excel… {pct}% ({sec}s)', { pct: Math.round(pct), sec: _es }), status: 'info', timeout: null })
                                        }
                                    },
                                    _xlsxAsync,  // asyncWorkbook: сборка книги без блокировки UI
                                    _xlsxAsync ? _batchRows : undefined,  // R15b: строк на порцию — адаптивно по ширине
                                );
                                } catch (e) { xlsxVisibleOnly_end(); attr_vueObj?.mergeBack_exportOff?.(false); _xlsxFail(e) }   // IE 2026 09 24 / ODOO-… (заказ Игоря: выгрузка без скрытых строк и колонок): исключение конвертера — режим снят, уведомление; IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»)
                            }
                        } else if (action.params.format === 'csv') {
                            let rng = new CellRange(0, 0, flex.rows.length - 1, flex.columns.length - 1),
                            csv = flex.getClipString(rng, ClipStringOptions.CSV, true, false);
                            saveFile(csv, `${fileName}.csv`);

                        } else if (action.params.format === 'pdf') {
                            attr_vueObj?.mergeBack_exportOff?.(true)   // IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»): грид в PDF рисуется синхронно внутри export()
                            try {
                            gridPdf.FlexGridPdfConverter.export(flex, `${fileName}.pdf`, {
                                maxPages: 10,
                                exportMode: gridPdf.ExportMode.All,
                                // кириллица: встроенные PDF-шрифты её не содержат
                                embeddedFonts: [{ source: '/fonts/DejaVuSans.ttf', name: 'dejavu' }],
                                // scaleMode: gridPdf.ScaleMode.ActualSize,
                                documentOptions: {
                                    pageSettings: {
                                        layout: pdf.PdfPageOrientation.Portrait
                                    },
                                    header: {
                                        declarative: {
                                            text: '\t&[Page]\\&[Pages]'
                                        }
                                    },
                                    footer: {
                                        declarative: {
                                            text: '\t&[Page]\\&[Pages]'
                                        }
                                    }
                                },
                                styles: {
                                    cellStyle: {
                                        font: { family: 'dejavu' },
                                        backgroundColor: '#ffffff',
                                        borderColor: '#c6c6c6'
                                    },
                                    altCellStyle: {
                                        backgroundColor: '#f9f9f9'
                                    },
                                    groupCellStyle: {
                                        backgroundColor: '#dddddd'
                                    },
                                    headerCellStyle: {
                                        backgroundColor: '#eaeaea'
                                    }
                                }
                            });
                            } finally { attr_vueObj?.mergeBack_exportOff?.(false) }   // IE 2026 09 24 / ODOO-… (замечание Игоря: подписи строк в xlsx при объединении «назад»)

                        }
                    
                    } else if (['pasteWidget', 'pasteRecord', 'pasteItems'].includes(action.method)) {
                        // IE 2026 09 23 / ODOO-341407: i18n (тосты вставки)
                        navigator.clipboard.readText()
                            .then((text) => {
                                if (!text) {
                                    store.show_notification({ text: t('Clipboard is empty'), status: 'warning' })
                                    return
                                }

                                if (['pasteWidget'].includes(action.method)) {
                                    store.pasteAction(vueObj, action, text, t('Clipboard'), { text: t('Pasted widget from clipboard!') })
                                } else if (['pasteRecord'].includes(action.method)) {
                                    store.pasteAction(vueObj, action, text, t('Clipboard'), { text: t('Pasted record from clipboard!') })
                                } else if (['pasteItems'].includes(action.method)) {
                                    store.pasteAction(vueObj, action, text, t('Clipboard'), { text: t('Pasted items from clipboard!') })
                                }
                            })
                            .catch(err => {
                                // console.error('Failed to paste: ', err)
                                store.show_notification({ text: t('Failed to paste from clipboard: {error}', { error: err.message }), status: 'error' })
                            })

                    } else if (['importWidget', 'importRecord', 'importItems'].includes(action.method)) {
                        // Диалог выбора файла + чтение + pasteAction(...)
                        store.pickTextFile({
                            accept: '.json,.txt,.py,application/json,text/plain',
                            multiple: false,
                        })
                            .then(({ text, file }) => {
                                if (!text) {
                                    store.show_notification({ text: t('Selected file is empty'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n (тосты импорта)
                                    return
                                }

                                // можно прокинуть имя файла в action, если удобно для логов/меты
                                action._importFileName = file?.name

                                store.pasteAction(vueObj, action, text, t('File'), { text: t('Imported from file: {name}', { name: file?.name || t('file') }) })
                            })
                            .catch(err => {
                                // если пользователь отменил выбор — не считаем ошибкой
                                if (err && err.code === 'USER_CANCEL') return

                                // console.error('Failed to import: ', err)
                                store.show_notification({ text: t('Failed to import from file: {error}', { error: err.message }), status: 'error' })
                            })

                    }

                    break
                } case 'copyWidgets': {
                    // бывший «Copy page» (п.3.1): JSON отображённых виджетов с layout;
                    // asLink (ит.3 п.4.2) — URL маршрута + widgets=base64url(тот же JSON)
                    const WORKSPACE = store.activeWORKSPACE
                    if (!WORKSPACE) break
                    const widgets = store.get_pageWidgets_layout(WORKSPACE.workspace, WORKSPACE.active_page)
                    let text
                    if (action.asLink) {
                        text = window.location.href.replace(/&widgets=[^&]*/g, '')
                        if (widgets.length) {
                            text += `&widgets=${store.encode_base64url(JSON.stringify(widgets))}`
                        }
                    } else {
                        text = JSON.stringify(widgets, null, 2)
                    }
                    navigator.clipboard.writeText(text)
                        .then(() => {
                            store.show_notification({text: t('Copied to clipboard!')})   // IE 2026 09 23 / ODOO-341407: i18n
                        })
                        .catch(err => {
                            store.show_notification({ text: t('Failed to copy to clipboard: {error}', { error: err.message }), status: 'error' })
                        })
                    break
                } case 'defaults_save': {
                    store.defaults_save(action)
                    break
                } case 'apply_page_widgets': {
                    // клиентская команда (be ит.4 п.1): action_afterChange грида
                    // «Page widgets» — применить record.doc.pages к экрану
                    store.apply_pageWidgets(WIDGET)
                    break
                } case 'externalLink': {
                    if (action.externalLinkPage) {
                        const WORKSPACE = store.activeWORKSPACE
                        const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WORKSPACE.active_page)
                        if (WIDGETS.length === 0) {
                            store.externalLink({method:action.method})
                        } else if (WIDGETS.length === 1) {
                            store.externalLink({method:action.method, action_id:WIDGETS[0].record._meta.action_id})
                        } else {
                            const actions = []
                            for (const WIDGET2 of WIDGETS.values()) {
                                if (WIDGET2.widget !== 'widget-row' && WIDGET2.widget !== 'widget-raw-record') {
                                    actions.push({
                                        action_name:'action-front-2025-01-31-2',
                                        command:'widget_open',
                                        widget:'widget-record',
                                        item:{
                                            id: WIDGET2.record._meta.action_id,
                                            _meta: { collection: 'workflow.activities' },
                                            doc: {
                                                widthMin_rem: WIDGET2.record?.doc?.widthMin_rem,
                                                heightMin_rem: WIDGET2.record?.doc?.heightMin_rem,
                                            },
                                        },
                                    })
                                }
                            }
                            store.executeBackendMethod(this, {
                                method: 'get_externalLink',
                                callback_method: action.method,
                                params: {
                                    actions,
                                }
                            }, this.externalLink, FRONTEND_start)
                        }                                        

                    } else {
                        store.externalLink({
                            method: action.method,
                            action_id: vueObj.WIDGET.record._meta.action_id,
                            // родной стол виджета — ссылка должна вести на него, а не на активный
                            workspace: vueObj.WIDGET.workspace,
                            page: vueObj.WIDGET.page,
                        })
                    }
                    break
                } case 'executeBackendMethod': {
                    // IE 2026 10 30 / ODOO-345618 (apply_branch: conflict override dialog): бэк отказал в слиянии из-за конфликтов (answer.branch_conflicts) — диалог «Apply anyway (branch wins)?», согласие повторяет команду с params.conflict_override (fe.ux.branchApplyConflictDialog)
                    if (action.method === 'apply_branch') {
                        store.executeBackendMethod(vueObj, action, (answer) => {
                            try {
                                const info = branchConflict_fromAnswer(answer, (k, d) => store.setting(k, d))
                                if (!info) return
                                const retry = branchConflict_retryAction(action)
                                store.App.$confirm.require({
                                    header: t('Apply branch'),
                                    message: branchConflict_message(info, t),
                                    icon: 'pi pi-exclamation-triangle',
                                    acceptClass: 'p-button-danger',
                                    accept: () => store.executeStoreMethod(vueObj, retry),
                                    reject: () => {},
                                })
                            } catch (e) { /* диалог — надстройка: при сбое остаётся тост ошибки */ }
                        })
                        break
                    }
                    store.executeBackendMethod(vueObj, action)
                    break
                }
            }
        },
        // ── история значений чипсов воркспейс-фильтра ─────────────────────────
        // per пользователь+база, живёт в localStorage (переживает refresh).
        // Ключ чипса — binding левой части строки WHERE (напр. 'object').
        // Захват — в workspace_applySelector: туда сходятся ВСЕ применения
        // (правка чипса, соло-клики грида, R12) — история полна независимо от входа
        chipHistory_storageKey() {
            const u = this.user?.id || this.user?.email || 'user'
            const db = this.user?.database?.dbid || ''
            return `chipHistory:${u}:${db}`
        },
        // IE 2026 08 26 / ODOO-5800 (заказ Игоря «слетают все чипсы»): снимок чипсов стола
        // (пользовательские строки doc.params.WHERE, без служебных hidden/calc) — в localStorage
        // на базу+пользователя+стол; восстанавливается при открытии стола (workspace_show_widgets)
        chipsKeep_key(workspace) {
            const u = this.user?.id || this.user?.email || 'user'
            const db = this.user?.database?.dbid || ''
            return `chipsKeep:${u}:${db}:${workspace}`
        },
        chipsKeep_save(WORKSPACE) {
            if (this.chipsKeep?.enabled === false || !WORKSPACE?.workspace) return
            try { if (guidePlay_chipsKeepHeld(this, WORKSPACE.workspace)) return } catch (e) { /* без удержания — как раньше */ }   // IE 2026 09 28 / ODOO-342342 (ревью З4): чипсы показа — не в снимок
            try {
                const rows = (WORKSPACE.record?.doc?.params?.WHERE || []).filter(r => r && !r.hidden)
                localStorage.setItem(this.chipsKeep_key(WORKSPACE.workspace), JSON.stringify({ t: Date.now(), lang: getLanguage(), WHERE: rows }))   // IE 2026 09 23 / ODOO-341407: язык снимка — под него бэк локализовал подписи строк
            } catch (e) { /* quota/приватный режим — снимок best effort */ }
        },
        chipsKeep_read(workspace) {
            if (this.chipsKeep?.enabled === false) return null
            try {
                const s = JSON.parse(localStorage.getItem(this.chipsKeep_key(workspace)) || 'null')
                if (!Array.isArray(s?.WHERE)) return null
                // IE 2026 09 23 / ODOO-341407: язык снимка (свойство массива, не строки) — chipsKeep_applyRows перелокализует подписи, если язык сменился.
                // Ключ хранилища языком НЕ дополняем намеренно: чипсы пользователя пережили бы смену языка только под старым языком
                Object.defineProperty(s.WHERE, '_lang', { value: s.lang || '', enumerable: false })
                return s.WHERE
            } catch (e) { return null }
        },
        chipsKeep_clear(workspace) {
            try { localStorage.removeItem(this.chipsKeep_key(workspace)) } catch (e) { /* no-op */ }
        },
        // применить снимок к params стола: пользовательские строки — из снимка, служебные
        // (hidden/calc) — из свежей записи; метка селекторов снимается (пересчитает applySelector)
        chipsKeep_applyRows(params, rows) {
            if (!params || !Array.isArray(rows)) return false
            const service = (params.WHERE || []).filter(r => r?.hidden)
            // IE 2026 08 27 (Igor, селектор ABC): строки стола, которых в снимке нет (новые селекторы), — добавляем,
            // иначе снимок вкладки навсегда прятал бы новые чипсы (calc*-строки пересчитает applySelector)
            const lvOf = r => (r && r.leftValue && typeof r.leftValue === 'object') ? String(r.leftValue.value || '') : String(r?.leftValue || '')
            const have = new Set(rows.map(lvOf).filter(Boolean))
            const missing = (params.WHERE || []).filter(r => r && !r.hidden && lvOf(r) && !have.has(lvOf(r)) && !lvOf(r).startsWith('calc'))
            if ('_lang' in rows && rows._lang !== getLanguage()) this.chipsKeep_relabel(rows, params.WHERE, lvOf)   // IE 2026 09 23 / ODOO-341407: снимок chipsKeep другого языка — подписи к текущему (строки ссылки/варианта без _lang не трогаем)
            params.WHERE = [...JSON.parse(JSON.stringify(rows)), ...JSON.parse(JSON.stringify(missing)), ...service]
            delete params.calc_selectors_mark
            this.update_CHIPS_from_WHERE?.(params)
            return true
        },
        // IE 2026 09 23 / ODOO-341407: снимок чипсов сделан под другим языком — подписи строк приводим к текущему, ЗНАЧЕНИЯ отбора не трогаем (история
        // пользователя переживает смену языка). Бэк (attrs._i18n_set) при локализации хранит исходник в `<key>_en` и язык в `_i18n`:
        // заголовок поля (leftValue) — из свежей строки стола того же binding (бэк уже локализовал её под текущий язык), иначе к английской
        // базе; значения (rightValue, attrs[]) — к английской базе, если бэк их переводил (ответ бэка их не возвращает — перевести нечем).
        // Строка периода (valueStr 'Period') переводится при показе (AttrChips._resolveTitle), её title пересчитывает periodSel_default
        chipsKeep_relabel(rows, freshWHERE, lvOf) {
            const lang = getLanguage()
            const fresh = new Map((freshWHERE || []).filter(r => r && !r.hidden && lvOf(r)).map(r => [lvOf(r), r]))
            const toBase = o => {   // снять локализацию бэка: `<key>_en` → key ('' = ключа не было), пометку _i18n снять
                if (!o || typeof o !== 'object' || !o._i18n || o._i18n === lang) return
                for (const k of Object.keys(o)) {
                    if (!k.endsWith('_en') || k === '_en') continue
                    const key = k.slice(0, -3), src = o[k]
                    delete o[k]
                    if (src === '') delete o[key]; else if (typeof src === 'string') o[key] = src
                }
                delete o._i18n
            }
            for (const row of rows) {
                if (!row || typeof row !== 'object') continue
                const lv = row.leftValue, f = fresh.get(lvOf(row))?.leftValue
                if (lv && typeof lv === 'object' && f && typeof f === 'object' && typeof f.valueStr === 'string' && f.valueStr) {
                    lv.valueStr = f.valueStr
                    if ('valueStr_en' in f) lv.valueStr_en = f.valueStr_en; else delete lv.valueStr_en
                    if (f._i18n) lv._i18n = f._i18n; else delete lv._i18n
                } else toBase(lv)
                toBase(row); toBase(row.rightValue)
                for (const a of row.attrs || []) { if (a && typeof a === 'object') { toBase(a); toBase(a.leftValue); toBase(a.rightValue) } }
                // заголовок чипса периода считает фронт (periodSel_title, язык снимка); periodSel_default идёт РАНЬШЕ восстановления снимка
                // (workspace_show_widgets) — пересчитываем здесь, иначе в полосе чипсов остаётся «Period: 2027-08» под украинским
                if (row.period && row.rightValue?.value) row.title = this.periodSel_title(row.rightValue.value, row.rightValue.valueTo)
            }
        },
        chipHistory_read() {
            try { return JSON.parse(localStorage.getItem(this.chipHistory_storageKey()) || '{}') } catch (e) { return {} }
        },
        chipHistory_forBinding(binding) {
            if (!binding) return []
            return this.chipHistory_read()[binding] || []
        },
        chipHistory_capture(WHERE) {
            try {
                const all = this.chipHistory_read()
                let changed = false
                for (const row of WHERE || []) {
                    const binding = row?.leftValue?.value
                    if (!binding || typeof binding !== 'string') continue
                    if (row.chip_segment === 'CHIP-Metric') continue   // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»): историю своих отборов чипс метрик ведёт сам
                    const values = []
                    if (row.rightValue?.value || row.rightValue?.valueStr) values.push(row.rightValue)
                    for (const r of row.attrs || []) {
                        if (r?.rightValue?.value || r?.rightValue?.valueStr) values.push(r.rightValue)
                    }
                    if (!values.length) continue
                    const sig = JSON.stringify(values.map(v => v.value || v.valueStr))
                    const title = values.map(v =>
                        (v.relation_segment && this.itemsSource[v.relation_segment]?.ids?.[v.value]?.title)
                        || v.title || v.valueStr || v.value).join(', ')
                    const list = all[binding] || []
                    if (list[0]?.sig === sig) continue // текущее уже в голове
                    const entry = { sig, title, condition: row.condition || '',
                        rightValue: JSON.parse(JSON.stringify(row.rightValue || {})),
                        attrs: JSON.parse(JSON.stringify(row.attrs || [])), ts: Date.now() }
                    all[binding] = [entry, ...list.filter(e => e.sig !== sig)].slice(0, 8)
                    changed = true
                }
                if (changed) localStorage.setItem(this.chipHistory_storageKey(), JSON.stringify(all))
            } catch (e) { /* история — best effort, не мешаем применению отбора */ }
        },
        workspace_applySelector(workspace, page, WIDGET=null, action={}) {
            const store = this
            let WORKSPACE = store.WORKSPACES[workspace]
            store.chipHistory_capture(WORKSPACE?.record?.doc?.params?.WHERE)
            store.chipsKeep_save(WORKSPACE) // IE 2026 08 26 / ODOO-5800: снимок чипсов — сюда сходятся ВСЕ применения
            let PAGE = WORKSPACE.PAGES[page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === page)

            const events = store.get_events(WORKSPACE.record)
            const rowEvent = events?.workspace?.workspace_applySelector
            if (rowEvent) {
                let vueObj
                // if (WORKSPACE.WIDGET) {
                //     vueObj = WORKSPACE.WIDGET.vueObj
                // } else {
                    vueObj = {
                        WIDGET: {
                            // record: { // WORKSPACE.record,
                            //     id: workspace,
                            //     doc: {
                            //         params: workspace_params,
                            //     }
                            // },
                            workspace: workspace,
                            widget_class: 'widget_WORKSPACE',
                            id: -1,
                        }
                    }
                // }

                return store.executeWidgetMethod(vueObj, {
                    command: 'executeWidgetMethod',
                    method: 'workspace_applySelector',
                    record_sendToBackend_exclude: ['_doc'],
                    widget_id: WIDGET?.id,
                    // хук «бэк применил отбор» — для цепочек, требующих строгого
                    // порядка (открытие виджета по ссылке ПОСЛЕ пересчёта селекторов)
                    _onResponse: action._onResponse,
                    actions_after: [{
                        command: 'updateRelatedWidgets',
                    }],
                })
            } else {
                store.updateRelatedWidgets(workspace, page, WIDGET, action)
                action._onResponse?.()
            }
        },
        updateRelatedWidgets(workspace, page, WIDGET=null, action={}) {
            const store = this
            let WORKSPACE = store.WORKSPACES[workspace]
            page = page || WORKSPACE.active_page
            let PAGE = WORKSPACE.PAGES[page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === page)

            if (WIDGET) WORKSPACE.selector_version = (WORKSPACE.selector_version ?? 0) + 1
            PAGE.last_refresh_selector_version = WORKSPACE.selector_version ?? 0
            // IE 2026 09 16 (замечание Игоря): какие строки чипсов стола изменились с прошлого применения — виджет, который эти поля
            // ТОЛЬКО ставит (Selection → Fields: Set без Get — серии графиков «by …», узлы пузырьков), не перечитывается: чипс его не режет
            // (workspace_params_for), а флаги отбора его строк обновляются на фронте (selectorFlags_refresh)
            const changed = store.whereChanged_take(WORKSPACE)

            // let workspaceWidget = WORKSPACE.workspaceWidget
            let test = 1 // TEST
            while (test--) {
                for (const WIDGET2 of WIDGETS.values()) {
                    // АН 2026 08 15 / ODOO-4997: битый виджет (вставленный из буфера,
                    // без fields) кидал из content_Changed и обрывал каскад — виджеты
                    // дальше по циклу (Selectors, отчёты) не обновлялись
                    try {
                    // IE 2026 08 18 / ODOO-4997: участие — по табличной части selection_fields (Selector get)
                    // IE 2026 09 26 / ODOO-5800: + список с вкладкой «Gantt of movements» — участник и без Selector get (ganttMoves_followsChips)
                    if (WIDGET2 !== WIDGET && WIDGET2.workspace === workspace && (store.selFields_has(WIDGET2, 'selector_get') || store.ganttMoves_followsChips(WIDGET2))) {
                        if (WIDGET2._softClosed) {
                            WIDGET2._selector_refresh_needed = true
                            continue
                        }
                        if (changed && changed.size && (store.selSetOnly_covers(WIDGET2, changed) || store.metricChipG_tableCovers(WIDGET2, changed))) {   // IE 2026 09 16: только свои Set-поля — без запроса (и после ответа бэка на событие стола, где WIDGET не передаётся); IE 2026 09 19: чипс метрик у виджета с приёмом «над таблицей»
                            if (store.selectorFlags_refresh(WIDGET2)) store.selectorFlags_repaint(WIDGET2)   // IE 2026 09 22 (замечание Игоря): флажки списка — с перерисовкой
                            continue
                        }
                        if (WIDGET2.record?.doc?.offset) {
                            WIDGET2.record.doc.offset = 0
                        }
                        // WIDGET2.workspace_record = WORKSPACE.record 2024-07-31
                        store.executeStoreMethod(WIDGET2.vueObj, {
                            command: 'executeWidgetMethod',
                            method: 'select',
                            record_sendToBackend_exclude: ['_doc'],
                            updateDoc_ifChanged: action.updateDoc_ifChanged,
                            ...(action[KEEP_ROW_FORMS_MARK] === true && { [KEEP_ROW_FORMS_MARK]: true }),   // IE 2026 10 13 / ODOO-5800: select финиша прогона — фоновый, формы строк не закрывает

                            // widget_cache_key не используется при page activation (WIDGET=null): CHIPS хранятся в record и теряются, если бек восстанавливает из кэша
                            ...(WIDGET && {widget_cache_key: WIDGET2.widget_cache_key}),

                            record_sendToFrontend_exclude: [],
                        })

                    } else if (WIDGET2 !== WIDGET && WIDGET2.workspace === workspace && WIDGET2.widget === 'widget-selectors') {
                        const WSelectors = WIDGET2
                        WSelectors.record.doc.params.WHERE = WORKSPACE.record.doc.params.WHERE
                        WSelectors.vueObj?.content_Changed?.(null, null, null, rowForm_contentOpts(action))   // IE 2026 10 13 / ODOO-5800

                    } else if (WORKSPACE.record.id === WIDGET2.record?.id) {
                        const WWidget = WIDGET2
                        WWidget.record.doc.params = WORKSPACE.record.doc.params
                        WWidget.vueObj?.content_Changed?.(null, null, null, rowForm_contentOpts(action))   // IE 2026 10 13 / ODOO-5800
                    }
                    } catch (e) {
                        console.warn('updateRelatedWidgets: widget skipped', WIDGET2?.id, e)
                    }
                }
            }
            store.multiply_refresh(workspace, page)   // IE 2026 09 15 / ODOO-… (заказ Игоря): тираж — строки источника по новым отборам
        },
        // IE 2026 08 17 / ODOO-4997 (решение Игоря, вариант «строго»): участие
        // виджета в обмене ВЫДЕЛЕНИЕМ ПО ИЗМЕРЕНИЯМ (канал wscm-dim-highlight:
        // subject/object/… между гридом, графом и баблом) — по спискам
        // doc.params.selection_set_fields (что отдаём) / selection_get_fields
        // (что принимаем). ПУСТОЙ список = виджет молчит / не реагирует.
        // Датные поля списка к измерениям не относятся (их обрабатывает канал
        // периода selectedDates), слово 'date' — тоже.
        // IE 2026 08 18 / ODOO-4997 (заказ Игоря): строки табличной части
        // doc.params.selection_fields (use / binding=Field / source / selector_set /
        // selector_get / selection_get / selection_set) — вместо четырёх текстовых
        // списков. source — биндинг глобальной шины (пусто = binding). При
        // открытии: таблицы нет и легаси-ключей нет — дефолтная строка date
        // (selection set+get); легаси-ключи есть — собираем таблицу из них
        // (записи до миграции be-2026-08-18-2); в существующей таблице нет
        // строки date — добавляем (заказ Игоря; отключение — снятием use).
        // строка таблицы со ВСЕМИ ключами колонок — AttrGrid прячет колонки,
        // которых нет ни в одной строке данных (Source, Selector set/get)
        selFields_normRow(row) {
            row.use = row.use !== false
            row.binding = row.binding ?? ''
            row.source = row.source ?? ''
            for (const f of ['selector_set', 'selector_get', 'selection_get', 'selection_set']) row[f] = !!row[f]
            return row
        },
        selFields_rows(WIDGET) {
            const p = WIDGET?.record?.doc?.params
            if (!p) return []
            let rows = p.selection_fields
            if (!Array.isArray(rows)) {
                const LEG = [
                    ['selection_set_fields', 'selection_set'], ['selection_get_fields', 'selection_get'],
                    ['selection_set_date_fields', 'selection_set'], ['selection_get_date_fields', 'selection_get'],
                    ['selector_set_fields', 'selector_set'], ['selector_get_fields', 'selector_get'],
                ]
                if (!LEG.some(([k]) => k in p)) {
                    rows = [this.selFields_normRow({ binding: 'date', selection_set: true, selection_get: true })]
                } else {
                    const idx = {}; rows = []
                    for (const [key, flag] of LEG) {
                        if (!(key in p)) continue
                        for (const name of String(p[key] ?? '').split(/[,;&]/).map(x => x.trim()).filter(Boolean)) {
                            // IE 2026 08 18 / ODOO-4997 (заказ Игоря): маркер '...'
                            // прежнего Get dimensions — булев params.selector_get
                            if (name === '...' && flag === 'selector_get') { p.selector_get = true; continue }
                            let r = idx[name]
                            if (!r) { r = idx[name] = this.selFields_normRow({ binding: name }); rows.push(r) }
                            r[flag] = true
                        }
                    }
                    // сознательное «пусто» легаси не включаем обратно — date-строка без флагов
                    if (!idx['date']) rows.push(this.selFields_normRow({ binding: 'date' }))
                }
                p.selection_fields = rows
            } else if (!rows.some(r => r && (String(r.binding || '').trim() === 'date' || String(r.source || '').trim() === 'date'))) {
                rows.push(this.selFields_normRow({ binding: 'date', selection_set: true, selection_get: true }))
            }
            return rows.filter(r => r && r.use !== false)
        },
        // имена шины (Source или Field) строк с флагом flag
        selFields_names(WIDGET, flag) {
            const names = []
            for (const r of this.selFields_rows(WIDGET)) {
                if (!r[flag]) continue
                const n = String(r.source || r.binding || '').trim()
                if (n && !names.includes(n)) names.push(n)
            }
            return names
        },
        selFields_has(WIDGET, flag) {
            // IE 2026 08 18 / ODOO-4997 (заказ Игоря): булев Refresh by selectors
            // (params.selector_get, экс Get dimensions='...') — участие без строк
            if (flag === 'selector_get' && WIDGET?.record?.doc?.params?.selector_get) return true
            return this.selFields_names(WIDGET, flag).length > 0
        },
        selDims_of(WIDGET, kind) {
            return this.selFields_names(WIDGET, kind === 'set' ? 'selection_set' : 'selection_get').filter(x => x !== 'date')
        },
        // фильтр значений сигнала по списку измерений виджета: остаются значения
        // с kind из списка; kind 'date' проходит только если в списке есть 'date'
        // либо датная мера (проверяется вызывающим — передаёт allowDate)
        selDims_filter(WIDGET, kind, values, allowDate=false) {
            const dims = this.selDims_of(WIDGET, kind)
            if (!dims.length && !allowDate) return []
            // узлы графа / РЦ — субъектной природы: kind 'subject' проходит и при
            // поле 'workcenter' в списке (МWC/Гант держат РЦ в workcenter/subject)
            const kindOk = (k) => dims.includes(k) || (k === 'subject' && dims.includes('workcenter'))
            return (values || []).filter(v => v?.kind === 'date' ? allowDate : kindOk(String(v?.kind || '')))
        },
        // IE 2026 08 18 / ODOO-4997 (замечание Игоря: D&S с пустым Set всё равно
        // двигал Chart, а Chart с пустым Get реагировал): канал ПЕРИОДА
        // (selectionWorkspace.selectedDates) — тоже строго по спискам
        // selection_set_fields / selection_get_fields. Флаги вида
        // set/getSelectionWorkspace_date остаются лишь «умеет ли компонент»;
        // УЧАСТИЕ виджета — только по списку: ПУСТО = не отдаёт / не принимает.
        // requireWord=true — нужен именно 'date' (график, прочие компоненты);
        // грид проверяет колонки сам (мера IN/OUT или 'date') → requireWord=false
        selDate_of(WIDGET, kind) {
            // IE 2026 08 18 / ODOO-4997: имена — из табличной части selection_fields
            return this.selFields_names(WIDGET, kind === 'set' ? 'selection_set' : 'selection_get')
        },
        selDate_ok(WIDGET, kind, requireWord=true) {
            const list = this.selDate_of(WIDGET, kind)
            if (!list.length) return false
            if (list.includes('date')) return true
            return !requireWord
        },
        setSelectionWorkspace_date(WIDGET=null, selectionWorkspace=null) {
            const store = this
            let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            // стол снесён (смена процессной модели/базы), событие от осиротевшего
            // грида — до сих пор guard стоял ниже первого обращения и не спасал
            if (!WORKSPACE) return
            // публикация периода — только от виджета с непустым Set fields
            // IE 2026 09 15 / ODOO-… (заказ Игоря: чипс периода): виджет-селектор периода (selector_set date) отдаёт выбранный интервал
            // (график / строки таблицы) в чипс периода стола, а не в обмен выделением между виджетами страницы
            if (selectionWorkspace !== null && store.periodSel_has(WIDGET)) {
                // IE 2026 09 26 / ODOO-5800 (ie-demo7: ⊗ на чипсе Period не держится, пока выделена ячейка месяца — через ~3 с чипс возвращается): после
                // перечитывания грид возвращает ПРЕЖНЕЕ выделение (AttrGrid.getSelectionWorkspace_date / set_itemsSource: selectedRanges_BEFORE), и это
                // не выбор пользователя — период из него в чипс не ставится; чипс ставит только новое выделение (клик, клавиши).
                // Выключатель fe.ux.periodSelSkipRestore (дефолт ВКЛ)
                if (selectionWorkspace._restore && store.setting('fe.ux.periodSelSkipRestore', true) !== false) return
                const sd = selectionWorkspace.selectedDates || {}
                const d1 = sd.col1?.date, d2 = sd.col2?.date
                if (d1 && d2) store.periodSel_set(WIDGET, d1 <= d2 ? d1 : d2, d1 <= d2 ? d2 : d1)
                return
            }
            if (selectionWorkspace !== null && !store.selDate_ok(WIDGET, 'set', false)) return
            let PAGE = WORKSPACE.PAGES[WIDGET.page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET.page)

            if (selectionWorkspace !== null) {
                WORKSPACE.selectionWorkspace = WORKSPACE.selectionWorkspace || {}
                WORKSPACE.selectionWorkspace.selectedDates = selectionWorkspace.selectedDates
            }

            if (WORKSPACE.selectionWorkspace?.selectedDates) {
                for (const WIDGET2 of WIDGETS.values()) {
                    // приём периода — только виджетами с непустым Get fields
                    if (WIDGET2 !== WIDGET && WIDGET2.getSelectionWorkspace_date && store.selDate_ok(WIDGET2, 'get', false)) {
                        WIDGET2.getSelectionWorkspace_date()
                    }
                }
            }

            // if (PAGE.leftArea.WIDGET && PAGE.leftArea.WIDGET !== WIDGET) {
            // }
        },
        // IE 2026 09 15 / ODOO-… (заказ Игоря): ЧИПС ПЕРИОДА — глобальный селектор интервала дат стола на механике селекторов.
        // Строка WHERE стола {leftValue date, condition 'between', rightValue {value: с, valueTo: по}, widget: виджет-селектор периода};
        // бэк (attrs.selector_text) у виджетов-потребителей (строка «date in selector») превращает её в date >= … AND date <= ….
        // Виджет-селектор периода — виджет с selection_fields date: selector_set (selection_set включён — выбор на графике / в строках
        // таблицы публикуется сюда, а не в обмен выделением; selection_get выключен — чужие выделения его не двигают); подсветка
        // интервала — из чипса (AttrChart.periodSel_highlight). Форма чипса (AttrChips) — быстрая правка границ «с … по».
        // По умолчанию при открытии стола (пустая строка): от фактической даты (params.date_fact_stock, иначе date_to) до конца
        // горизонта планирования (date_report_to).
        periodSel_row(WORKSPACE, create = false, widget = '') {
            const params = WORKSPACE?.record?.doc?.params
            if (!params) return null
            params.WHERE = params.WHERE || []
            let row = params.WHERE.find(r => r && r.condition === 'between' && (r.leftValue?.value ?? r.leftValue) === 'date')
            if (!row && create) {
                row = { use: true, attr_type: 'AttrChipWhere', condition: 'between', pi: 'pi-calendar', title: t('Period'), period: true,   // IE 2026 09 23 / ODOO-341407: i18n (заголовок далее пересчитывает periodSel_title)
                    // IE 2026 09 23 / ODOO-341407: leftValue.valueStr 'Period' — английская БАЗА, не подпись: valueStr_fix → бэк (attrs._i18n_apply, literal='node') переводит её
                    // своим словарём, фронт — AttrChips._resolveTitle (t('Period')); переведённый текст в данных (снимок chipsKeep, запись стола) сломал бы оба словаря
                    leftValue: { pi: '', value: 'date', valueStr: 'Period', attr_type: 'AttrLink', component: 'AttrLink', valueStr_fix: true, relation_segment: '' },
                    rightValue: { value: '', valueTo: '', valueStr: '', attr_type: 'AttrDate', component: 'AttrLink', relation_segment: '' },
                    attrs: [], widget: widget || '' }
                params.WHERE.push(row)
            }
            return row
        },
        periodSel_has(WIDGET) { return !!WIDGET && this.selFields_names(WIDGET, 'selector_set').includes('date') },
        periodSel_get(workspace) {
            const row = this.periodSel_row(this.WORKSPACES[workspace])
            if (!row || row.use === false) return null
            const rv = row.rightValue || {}
            return rv.value ? { from: rv.value, to: rv.valueTo || rv.value, row } : null
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря): заголовок чипа периода по-человечески — границы, совпадающие с границами месяцев,
        // показываем месяцами («2026-12 – 2027-03», один месяц — «2026-12», целый год — «2026»); иначе полные даты
        periodSel_title(from, to) {   // IE 2026 09 23 / ODOO-341407: i18n (локальная t → tm, чтобы не затенять словарную t())
            const f = this.periodSel_month(from, true), tm = this.periodSel_month(to, false)
            if (f && tm) {
                if (f === tm) return t('Period: {period}', { period: f })
                if (f.slice(5) === '01' && tm.slice(5) === '12' && f.slice(0, 4) === tm.slice(0, 4)) return t('Period: {period}', { period: f.slice(0, 4) })
                return t('Period: {from} – {to}', { from: f, to: tm })
            }
            return t('Period: {from} – {to}', { from: from || '…', to: to || '…' })
        },
        // месяц «YYYY-MM» границы периода: начало — 1-е число, конец — 1-е или последнее число месяца (выбор на месячном графике даёт 1-е)
        periodSel_month(d, isFrom) {
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''))
            if (!m) return ''
            const day = +m[3], last = new Date(Date.UTC(+m[1], +m[2], 0)).getUTCDate()
            return (day === 1 || (!isFrom && day === last)) ? `${m[1]}-${m[2]}` : ''
        },
        periodSel_default(WORKSPACE) {
            const row = this.periodSel_row(WORKSPACE)
            if (!row) return
            const rv = row.rightValue = row.rightValue || {}
            if (rv.value) { row.title = this.periodSel_title(rv.value, rv.valueTo); return }   // IE 2026 09 15: заголовок сохранённого периода — в актуальном формате
            const p = WORKSPACE.record.doc.params
            const from = p.date_fact_stock || p.date_to || p.date_report_from || ''
            const to = p.date_report_to || ''
            if (!from && !to) return
            rv.value = from; rv.valueTo = to; rv.valueStr = from; rv.attr_type = 'AttrDate'
            row.title = this.periodSel_title(from, to); row.pi = row.pi || 'pi-calendar'; row.use = true
        },
        periodSel_set(WIDGET, from, to, workspace = null) {
            const store = this
            const ws = workspace || WIDGET?.workspace || store.activeWORKSPACE?.workspace
            const WORKSPACE = store.WORKSPACES[ws]
            if (!WORKSPACE) return
            if (from && to && from > to) [from, to] = [to, from]
            const row = store.periodSel_row(WORKSPACE, true, WIDGET?.widget || '')
            if (WIDGET?.widget) row.widget = WIDGET.widget
            const rv = row.rightValue = row.rightValue || {}
            rv.value = from || ''; rv.valueTo = to || ''; rv.valueStr = from || ''; rv.attr_type = 'AttrDate'
            row.title = store.periodSel_title(from, to); row.pi = row.pi || 'pi-calendar'
            row.use = !!(from || to)
            store.update_CHIPS_from_WHERE?.(WORKSPACE.record.doc.params)
            store.periodSel_apply(ws, WORKSPACE.active_page, WIDGET || null)   // IE 2026 09 15 (замечание Игоря): только потребители периода
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря): смена периода обновляет ТОЛЬКО потребителей периода — виджеты со строкой WHERE
        // «<поле периода> in selector» (selector_binding) или Selector get по полю периода; остальные виджеты страницы (списки-селекторы
        // Filters) не перезапрашиваются, событие стола workspace_applySelector (пересчёт производных селекторов) не вызывается — период
        // на них не влияет. Потребители на других страницах помечаются (_period_refresh_needed) и перечитываются при активации страницы;
        // сам виджет-селектор периода только подсвечивает интервал (getSelectionWorkspace_date → periodSel_highlight).
        periodSel_consumes(WIDGET, field = 'date') {
            if (!WIDGET?.record?.doc?.params || this.periodSel_has(WIDGET)) return false
            const WHERE = WIDGET.record.doc.params.WHERE || []
            if (WHERE.some(r => r && r.use !== false && r.condition === 'in selector' && String(r.selector_binding || r.leftValue?.value || '') === field)) return true
            return this.selFields_names(WIDGET, 'selector_get').includes(field)
        },
        periodSel_apply(workspace, page, WIDGET = null) {
            const store = this
            const WORKSPACE = store.WORKSPACES[workspace]
            if (!WORKSPACE) return
            store.chipHistory_capture?.(WORKSPACE.record?.doc?.params?.WHERE)
            store.chipsKeep_save?.(WORKSPACE)
            const field = String(store.periodSel_row(WORKSPACE)?.leftValue?.value || 'date')
            for (const W of (WORKSPACE.ALL_WIDGETS ?? [])) {
                if (W.close || W.workspace !== workspace) continue
                if (store.periodSel_has(W)) {
                    for (const v of Object.values(W.attrs_vueObj || {})) {
                        if (v && typeof v.periodSel_highlight === 'function') { try { v.getSelectionWorkspace_date?.() } catch (e) { console.warn('[period] highlight:', e) } }
                    }
                    continue
                }
                if (!store.periodSel_consumes(W, field)) continue
                if (W._softClosed) { W._selector_refresh_needed = true; continue }
                if (W.page !== page) { W._period_refresh_needed = true; continue }
                store.periodSel_select(W, WIDGET)
            }
        },
        periodSel_select(W, WIDGET = null) {
            if (!W?.vueObj) return
            if (W.record?.doc?.offset) W.record.doc.offset = 0
            this.executeStoreMethod(W.vueObj, {
                command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'],
                ...(WIDGET && { widget_cache_key: W.widget_cache_key }), record_sendToFrontend_exclude: [],
            })
        },
        use_selectorMeasures(WIDGET=null, selectedMeasures=null) {
            const store = this
            let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            let PAGE = WORKSPACE.PAGES[WIDGET.page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET.page)

            if (selectedMeasures !== null) {
                PAGE.selectedMeasures = selectedMeasures
            }

            if (PAGE.selectedMeasures) {
                for (const WIDGET2 of WIDGETS.values()) {
                    if (WIDGET2.record?.params?.use_selectorMeasures) { // WIDGET2 !== WIDGET && 
                        // dataSheet
                        let attr_vueObjSheet = WIDGET2.vueObj?.get_vueObj('dataSheet')
                        if (attr_vueObjSheet?.attr?.use_selectorMeasures && attr_vueObjSheet?.attr?.attrs) {
                            let isChanged = false
                            for (let item of attr_vueObjSheet.flex.rows) {
                                if (item.dataItem?.measure in PAGE.selectedMeasures) {
                                    let selector = PAGE.selectedMeasures[item.dataItem.measure]
                                    if (item.dataItem.selector !== selector) {
                                        item.dataItem.selector = selector
                                        isChanged = true
                                    }
                                }
                            }
                            if (isChanged) {
                                attr_vueObjSheet.flex.refresh()
                            }
                        }

                        // dataChart
                        let attr_vueObjChart = WIDGET2.vueObj?.get_vueObj('dataChart')
                        if (attr_vueObjChart?.flex?.series) {
                            for (let series of attr_vueObjChart.flex.series) {
                                if (series.binding in PAGE.selectedMeasures) {
                                    let visibility = null
                                    if (PAGE.selectedMeasures[series.binding]) {
                                        // visibility = 1 // Plot
                                        visibility = 0 // Visible
                                    } else {
                                        // visibility = 3 // Hidden
                                        visibility = 2 // Legend
                                    }
                                    if (series.visibility !== visibility) {
                                        series.visibility = visibility
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        JS_stringifyHtml(value_dict, deep=0) {
            const store = this
            let html = ''
            // keyLevel = deep === 0 ? '' : '2'  // ${keyLevel}
        
            for (let key in value_dict) {
                if (store.isinstance_dict(value_dict[key])) {
                    const value = this.JS_stringifyHtml(value_dict[key], deep+1)
                    if (value) {
                        html += `<b class='json-key'>${key}:</b> { ${value} } `
                    }
                } else {
                    const value = value_dict[key]
                    if (value) {
                        html += `<b class='json-key'>${key}:</b> ${value} `
                        // html += `<b class='json-key'>${key}:</b> <b class='json-value'>${value_dict[key]}</b>`
                    }
                }
            }
        
            return html
        },
        // IE 2026 08 23: безопасный JSON.stringify для JS_stringify — attr'ы
        // несут циклы (initialAttr -> vueObj), голый stringify падал
        JSON_stringify_safe(value) {
            const seen = new WeakSet()
            try {
                return JSON.stringify(value, (k, v) => {
                    if (k === 'vueObj') return undefined
                    if (typeof v === 'object' && v !== null) {
                        if (seen.has(v)) return '[Circular]'
                        seen.add(v)
                    }
                    return v
                })
            } catch (e) {
                return '"[Unserializable]"'
            }
        },
        JS_stringify(value_dict, JS_deep = 2, space = 4, tab = '', sort=false, isRoot=true) {
            const store = this,
            validIdentifier = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/
            let value_dict2 = value_dict
            if (sort) {
                value_dict2 = store.JSON_sort(value_dict)
            }
        
            // return JSON.stringify(value_dict2, null, space)
        
            // Check if the value is an object (and not an array)
            if (JS_deep && store.isinstance_dict(value_dict2)) {
                let s = []

                // Iterate over the object's keys
                for (let key in value_dict2) {
                    if (Object.prototype.hasOwnProperty.call(value_dict2, key)) {
                        if (!validIdentifier.test(key)) {
                            s.push(`${tab}'${key}'`)
                        } else {
                            s.push(`${tab}${key}`)
                        }
                        s.push(': ')

                        // Handle arrays
                        if (JS_deep > 1 && Array.isArray(value_dict2[key])) {
                            s.push('[\n')
                            value_dict2[key].forEach((item, index) => {
                                if (JS_deep === 2) {
                                    let subValue = store.JSON_stringify_safe(item)
                                    s.push(`${tab}    ${subValue},\n`)
                                } else {
                                    let subValue = store.JS_stringify(item, JS_deep - 1, space, `${tab}        `, sort, false)
                                    if (store.isinstance_dict(item)) {
                                        s.push(`${tab}    {\n`)
                                        s.push(`${subValue}`)
                                        s.push(`${tab}    },\n`)
                                    } else {
                                        s.push(`${tab}    ${subValue},\n`)
                                    }
                                }
                            })
                            s.push(`${tab}],\n`)  // Closing array bracket

                        // Handle nested objects
                        } else if (JS_deep > 1 && typeof value_dict2[key] === "object" && value_dict2[key] !== null) {
                            let subValue = store.JS_stringify(value_dict2[key], JS_deep - 1, space, `${tab}    `, sort, false)
                            s.push(`{\n${subValue}`)
                            s.push(`${tab}},\n`)

                        // Handle undefined values
                        } else if (value_dict2[key] === undefined) {
                            s.push('undefined')
                            s.push(',\n')

                        // Handle all other values
                        } else {
                            s.push(store.JSON_stringify_safe(value_dict2[key]))
                            s.push(',\n')
                        }
                    }
                }
                return s.join('')

            } else if (JS_deep && Array.isArray(value_dict2)) {
                // Handle case when the passed value is an array
                let s = ['[\n']
                value_dict2.forEach((item) => {
                    if (typeof item === "object" && item !== null) {
                        let subValue = store.JS_stringify(item, JS_deep - 1, space, `${tab}    `, sort, false)
                        s.push(`${tab}    {\n`)
                        s.push(`${subValue}`)
                        s.push(`${tab}    },\n`)
                    } else {
                        let subValue = store.JSON_stringify_safe(item)
                        s.push(`${tab}    ${subValue},\n`)
                    }
                })
                s.push(`${tab}]`)  // Closing array bracket
                return s.join('')
                
            } else if (isRoot) {
                return store.JSON_stringify_safe(value_dict2).slice(1, -1)
            } else {
                // If not an object and not an array, return the value as it is
                return store.JSON_stringify_safe(value_dict2)
            }
        },
        JS_parse(value_str) {
            //return JSON.parse(value_str)
            let r3 = {},
            r2 = null

            try {
                r2 = eval(`r3={ ${value_str} }`)
            } catch (error) {
                r2 = eval(`r3={ array:${value_str} }`).array
            }

            return r2
        },

        CSS_parse(value_str) {
            return (value_str || '').split('\n').reduce((acc, line) => {
                const [prop, value] = line.split(':').map(s => s?.trim());
                if (prop && value) acc[prop] = value.replace(/;$/, '');
                return acc;
            }, {});
        },
        CSS_stringify(value_dict) {
            return Object.entries(value_dict)
                .map(([k, v]) => `${k}: ${v};`)
                .join('\n');
        },
        // IE 2026 09 04 / ODOO-336283: CSS одной строкой («prop: v; prop2: v2») — для полей формы, которые
        // хранят стиль строкой (Style строки лэйаута); словарь → строка, строка — как есть (trim)
        CSS_toLine(value) {
            if (value == null) return ''
            if (typeof value === 'string') return value.trim()
            if (typeof value === 'object') {
                return Object.entries(value).filter(([, v]) => v != null && v !== '').map(([k, v]) => `${k}: ${v}`).join('; ')
            }
            return String(value)
        },

        widgetResize(vueObj, timeout = 400) {
            // if (!this.hide_console) console.log('store widgetResize')
            const store = this
            // компонент мог быть создан до регистрации стола в сторе (смена
            // процессной модели / открытие страницы с PM в URL) — перерезолвим
            if (!vueObj.WIDGET && vueObj.widget_id) vueObj.WIDGET = store.findWidget(vueObj.widget_id).WIDGET
            const WIDGET = vueObj.WIDGET;
            if (!WIDGET) return
            if (WIDGET.timerId) {
                clearTimeout(WIDGET.timerId)
                WIDGET.timerId = null
            }
            WIDGET.timerId = window.$cg.setTimeout(vueObj, "store.widgetResize", () => {
                store.widgetResize_afterTimer(vueObj)
            }, timeout)
        },
        widgetResize_afterTimer(vueObj) {
            // if (!this.hide_console) console.log('widgetResize afterTimer')
            const store = this
            const WIDGET = vueObj.WIDGET
            const elementForm = document.getElementById(`WIDGET${WIDGET.id}`)

            if (elementForm) {
                if (!store.dropdown?.pinned && !store.dropdown?.chartDrill_keepOnResize?.(WIDGET, elementForm)
                    && !store.dropdown?.cellForm_keepOnResize?.()) store.dropdown.hide()   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷 не гаснет при ресайзе виджетов): форму ячейки, выведенную пользователем, прячет только потеря ячейки (Dropdown.cellForm_keepOnResize / cellForm_follow); fe.ux.cellFormKeepOnResize = false — прежнее прятание   // IE 2026 09 22 / ODOO-5800: закреплённая форма ячейки при изменении размера виджета остаётся (она не привязана к ячейке) · IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): форма точки графика — при изменении размера других виджетов и своего на ≤ 4 px (Dropdown.chartDrill_keepOnResize)

                WIDGET.timerId = null
                WIDGET.Rect = elementForm.getBoundingClientRect()

                for (let attrResize of WIDGET.attrsResize) {
                    attrResize()
                }
            
                // стол мог быть пересоздан (смена процессной модели) — таймер ресайза
                // приходит позже: без ?. это TypeError и обрыв рендера страницы
                const PAGE = store.WORKSPACES[WIDGET.workspace]?.PAGES?.[WIDGET.page]
                if (PAGE) {
                    if (WIDGET.attrs_vueObj.WIDGET.isManuallyResizing) {
                        let stylePage = PAGE.stylePage,
                        styleWidget = WIDGET.styleWidget,
                        currentWidth_rem = Math.max(1, Math.min(stylePage.width_rem, WIDGET.Rect.width / stylePage.widthWidget)),
                        currentHeight_rem = Math.max(1, Math.min(stylePage.height_rem, WIDGET.Rect.height / stylePage.heightWidget))

                        if (currentWidth_rem > styleWidget.width_rem) {
                            currentWidth_rem = Math.ceil(currentWidth_rem)
                        } else {
                            currentWidth_rem = Math.floor(currentWidth_rem)
                        }
                        if (WIDGET.record.doc.widthMin_rem !== currentWidth_rem) {
                            WIDGET.record.doc.widthMin_rem = currentWidth_rem
                        }

                        if (currentHeight_rem > styleWidget.height_rem) {
                            currentHeight_rem = Math.ceil(currentHeight_rem)
                        } else {
                            currentHeight_rem = Math.floor(currentHeight_rem)
                        }
                        if (WIDGET.record.doc.heightMin_rem !== currentHeight_rem) {
                            WIDGET.record.doc.heightMin_rem = currentHeight_rem
                        }
                    }

                    PAGE?.mainArea?.vueObj.checkWorkspaceScroll()
                }
            }
        },
        Scale(vueObj, params) {
            const WIDGET = vueObj.WIDGET

            if (WIDGET.styleWidget?.dock === 'popout') {
                const PAGE = this.WORKSPACES[WIDGET.workspace]?.PAGES[WIDGET.page]
                if (PAGE) {
                    const ps = this.getPAGE_size(PAGE)
                    const style = this.getWIDGET_style(WIDGET)
                    if (params.widthMin_rem) {
                        const widthPct = params.widthMin_rem / 4
                        style.width = Math.round(widthPct * ps.page_width) + 'px'
                        WIDGET.styleWidget.width_pct = widthPct
                    }
                    if (params.heightMin_rem) {
                        const heightPct = params.heightMin_rem / 2
                        style.height = Math.round(heightPct * ps.page_height) + 'px'
                        WIDGET.styleWidget.height_pct = heightPct
                    }
                    this.setWIDGET_style(WIDGET, style, false)
                }
            } else {
                // пресет сетки -> проценты в текущий layout виджета (ит.3 п.3.1);
                // запись в doc остаётся как fallback-пресет (п.3.2)
                const stylePage = this.WORKSPACES[WIDGET.workspace]?.PAGES[WIDGET.page]?.stylePage || this.def_stylePage
                const layout_pct = { ...WIDGET.styleWidget.layout_pct }
                if (params.widthMin_rem) {
                    WIDGET.record.doc.widthMin_rem = params.widthMin_rem
                    layout_pct.width = Math.min(params.widthMin_rem / stylePage.width_rem, 1) * 100
                }
                if (params.heightMin_rem) {
                    WIDGET.record.doc.heightMin_rem = params.heightMin_rem
                    layout_pct.height = Math.min(params.heightMin_rem / stylePage.height_rem, 1) * 100
                }
                if (Object.keys(layout_pct).length) {
                    WIDGET.styleWidget.layout_pct = layout_pct
                }
            }

            this.scrollInWorkspace(WIDGET)

            // const WidgetContainer = $('#WIDGET'+WIDGET.id)[0] //  document.querySelector(`#WIDGET${WIDGET.id}`) //document.getElementById(...)
            // if (!WidgetContainer) {
            //     return
            // }

            // // reset if there was a manual resizing of the WIDGET
            // if (WidgetContainer.style.width) {
            //     WidgetContainer.style.width = null
            // }
            // if (WidgetContainer.style.height) {
            //     WidgetContainer.style.height = null
            // }

            // // this.widgetResize(vueObj) 2023 03 24 look widgetResize()

            // let reverse = (!params.cssClassW || WidgetContainer.classList.contains(params.cssClassW)) && (!params.cssClassH || WidgetContainer.classList.contains(params.cssClassH))

            // const cssClassW_2024_10 = false
            // if (params.cssClassW && cssClassW_2024_10) {
            //     let allcssClassW = new Set(['widget-w1', 'widget-w2', 'widget-w3', 'widget-w4'])
            //     for (let class_ of allcssClassW) {
            //         if (class_ !== params.cssClassW) {
            //             WidgetContainer.classList.remove(class_)
            //         }
            //     }
            //     if (params.cssClassW === 'none' || reverse) {
            //         WidgetContainer.classList.remove(params.cssClassW)
            //     } else if (params.cssClassW) {
            //         WidgetContainer.classList.add(params.cssClassW)
            //     }
            // }
            // if (params.cssClassH && cssClassW_2024_10) {
            //     let allcssClassH = new Set(['widget-h0', 'widget-h1', 'widget-h2', 'widget-h3', 'widget-h4'])
            //     for (let class_ of allcssClassH) {
            //         if (class_ !== params.cssClassH) {
            //             WidgetContainer.classList.remove(class_)
            //         }
            //     }
            //     if (params.cssClassH === 'none' || reverse) {
            //         WidgetContainer.classList.remove(params.cssClassH)
            //     } else if (params.cssClassH) {
            //         WidgetContainer.classList.add(params.cssClassH)
            //     }
            // }
        },
        get_itemsSource_bySegment(segment='SEGMENTS-UNION', params_=null) {
            return this.get_itemsSource({}, {}, { relation_segment: segment }, { fetchMode: 'all', ...params_ })
        },
        // ODOO-3216: FE-словарь тайтлов admin-ссылок, фасад id→title per relation_segment.
        // Собирает нерезолвленные id (дедуп _pending_ids), батчит штатный
        // get_itemsSource(by_ids) (50ms-очередь), кэш — session-scoped store.itemsSource
        // (инвалидация — перезагрузкой вместе с CONFIG_VERSION, как у остальных кэшей).
        // Повторные запросы тех же id в сеть не ходят. Тайтл после резолва:
        // itemsSource.ids[id].title; fallback у потребителей — сырой id (текущий стиль).
        // Первый шаг ограничен ADMIN_DICT_SEGMENTS (см. константу вверху файла).
        resolveTitles(segment, ids, vueObj=null) {
            const store = this
            if (!segment || !Array.isArray(ids)) return store.itemsSource[segment] || null
            const attr = { attr_type: 'AttrLink', relation_segment: segment }
            const clean = [...new Set(ids.filter(id =>
                id && typeof id === 'string' && !id.startsWith('=') && !id.startsWith('#')))]
            if (!clean.length || !ADMIN_DICT_SEGMENTS.includes(segment)) {
                return store.get_itemsSource(vueObj || {}, {}, attr, { fetchMode: 'justGet' })
            }
            return store.get_itemsSource(vueObj || {}, {}, attr, { ids: clean })
        },
        get_itemsSource(vueObj, input, attr, params_=null) {
            const store = this, WIDGET = vueObj.WIDGET

            if (!store._itemsSource_active) store._itemsSource_active = {}
            if (!store._itemsSource_queue) store._itemsSource_queue = {}
            if (!store._itemsSource_pending_index) store._itemsSource_pending_index = 0

            const fill = params_?.fill || 'no'
            let fetchMode = params_?.fetchMode || store.fetchMode
            let ids = params_?.ids || null
            let itemsSource = null,
            need_backend = false,
            segment = store.get_segment(WIDGET, attr)

            // from attr
            if (!attr) {
                return itemsSource
            }
            if (attr.use_itemsSourcesView) {
                // приоритет 1: реестр _doc.itemsSourcesView; если реестра нет (null) —
                // fallback на inline attr.itemsSource, затем живой резолвер (§5)
                itemsSource = store.get_itemsSource_fromView(vueObj, attr)
            }
            if (itemsSource) {
                // построен из реестра — локальный, бэкенд-запросы itemsSource не нужны
                // (у ячейки может сосуществовать itemsSource_source → segment)
                fetchMode = 'justGet'
                ids = null
            } else if (attr.itemsSource && attr.itemsSource.length) {
                itemsSource = { data: attr.itemsSource, change_index: 0 }
            } else {
                itemsSource = store.itemsSource[segment]
                if (!itemsSource) {
                    itemsSource = store.itemsSource[segment] = { segment, change_index: 0 }
                    need_backend = true
                }
            }

            if (vueObj?.attr?.attr_type === 'AttrLink') {
                vueObj.itemsSource = itemsSource
            }

            if (itemsSource.data) {
                store.get_dataMap(itemsSource)
            }

            // -------------------------------------------------------
            const isRefresh = fetchMode === 'refresh'
            if (isRefresh) {
                if (!itemsSource.data) {
                    return itemsSource
                }
                fetchMode = 'by_ids'
                ids = itemsSource.data.map(item => item.id)
            } else {
                if (fetchMode === 'all' && ids !== null) {
                    ids = null
                }
                if (fetchMode === 'all' && itemsSource._all_truncated && itemsSource.data && store.setting('fe.ux.dictAllTruncated', true) !== false) {
                    fetchMode = 'justGet'   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса): неполный 'all' уже получен — повторный 'all' (каждый фокус подбора) отдал бы те же строки, недостающие идут by_ids
                }
                if (itemsSource._pending_fetchMode === 'all') {
                    // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса): 'all' ещё в очереди / в полёте — id запомнить (неполный ответ спросит их заново); полученный полный словарь — нет
                    if (fetchMode === 'by_ids' && (store._itemsSource_queue[segment] || store._itemsSource_active[segment]) && store.setting('fe.ux.dictAllTruncated', true) !== false) itemsSourceAll_remember(itemsSource, ids)
                    fetchMode = 'justGet'
                    ids = null
                }

                // unknownIds: не перезапрашивать уже запрошенные (pending) и
                // ОТСУТСТВУЮЩИЕ в справочнике id (negative-cache _missing_ids).
                // Без него id, которых бэкенд не возвращает (напр. subject_cor =
                // рабочий центр, а сегмент DS::SUBJECTS его не содержит),
                // перезапрашивались бесконечным циклом — шторм get_itemsSource
                // (132 POST/5мин по 3.2с бэкенда) и вечный «pending» виджета.
                if (fetchMode === 'by_ids' && ids !== null && (itemsSource._pending_ids || itemsSource._missing_ids || itemsSource.ids)) {
                    // .ids: уже РАЗРЕШЁННЫЕ id тоже не перезапрашиваем — словари,
                    // доставленные инлайном с данными (R2), в _pending_ids не
                    // числятся, и без этой проверки каждый грид переспрашивал их
                    ids = ids.filter(id => !itemsSource._pending_ids?.has(id) && !itemsSource._missing_ids?.has(id) && !itemsSource.ids?.[id])
                }
                if (ids !== null && !ids?.length) {
                    ids = null
                }
                if (fetchMode === 'by_ids' && ids === null) {
                    fetchMode = 'justGet'
                }
            }

            if (fetchMode !== 'justGet') {
                const queue = store._itemsSource_queue[segment]
                if (queue) {
                    const queue_params = queue.params
                    if (isRefresh) {
                        // refresh, влитый в уже стоящий в очереди запрос, не должен терять
                        // флаг замены списка — иначе ответ допишется к data (дубли по id)
                        queue_params.isRefresh = true
                    }
                    if (fetchMode === 'all' && queue_params.fetchMode === 'by_ids') {
                        if (store.setting('fe.ux.dictAllTruncated', true) !== false) itemsSourceAll_remember(itemsSource, queue_params.ids)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса): id очереди by_ids, влитой в 'all'
                        queue_params.fetchMode = 'all'
                        queue_params.ids = null
                    } else if (fetchMode === 'all' && queue_params.fetchMode === 'all') {
                        // оставляем queued=all
                    } else if (fetchMode === 'by_ids' && queue_params.fetchMode === 'all') {
                        // оставляем queued=all
                        if (store.setting('fe.ux.dictAllTruncated', true) !== false) itemsSourceAll_remember(itemsSource, ids)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса)
                    } else if (fetchMode === 'by_ids' && queue_params.fetchMode === 'by_ids') {
                        queue_params.ids = [...new Set([...queue_params.ids, ...ids])]  // merge by_ids
                    }
                    queue.vueObj = vueObj
                    
                    if (queue._timer) {
                        clearTimeout(queue._timer)
                        queue._timer = setTimeout(() => {
                            queue._timer = null
                            store.async_get_itemsSource_data(segment)
                        }, queue_params.fetchMode !== 'all' ? 50 : 0)
                    }

                    fetchMode = 'justGet'

                } else {
                    // Дедуп конкурентного запроса того же сегмента: если запрос
                    // уже УШЁЛ (active) и тянет весь справочник (fetchMode 'all'),
                    // второй 'all'/'by_ids' избыточен — активный ответ наполнит
                    // тот же itemsSource. Раньше второй запрос ставился в новую
                    // очередь и уходил повторно (в трейсе MEASURE дважды).
                    const active = store._itemsSource_active?.[segment]
                    if (active && active.params?.fetchMode === 'all') {
                        if (fetchMode === 'by_ids' && store.setting('fe.ux.dictAllTruncated', true) !== false) itemsSourceAll_remember(itemsSource, ids)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса)
                        fetchMode = 'justGet'
                    } else {
                        itemsSource._pending_fetchMode = fetchMode
                    }
                }

                if (itemsSource._pending_fetchMode === 'all' && itemsSource._pending_ids) {
                    itemsSource._pending_ids = null
                    itemsSource._missing_ids = null // negative-cache сбрасывается полной перезагрузкой
                } else if (ids) {
                    if (!itemsSource._pending_ids) itemsSource._pending_ids = new Set()
                    for (const id of ids) itemsSource._pending_ids.add(id)
                }
            }
            
            if (itemsSource.dataMap && ids === null && (fetchMode !== 'all' || !need_backend)) {
                // set itemsSource
                if (fill === 'fill.title') {
                    if (input) {
                        let bindingTiltle = `${attr.binding}.title`
                        for (let row of input) {
                            const id = store.get_value(row, attr.binding)
                            if (id && !(bindingTiltle in row)) {
                                if (itemsSource.ids[id]) {
                                    row[bindingTiltle] = itemsSource.ids[id].title
                                } else {
                                    row[bindingTiltle] = id
                                }
                            }
                        }
                    }
                } else {
                    input.itemsSource_myFreeze = true
                    if ('dataMap' in input) {
                        // AttrGrid
                        input.dataMap = itemsSource.dataMap
                        if (!attr.relation_segment) {
                            input.dataMapEditor = 1 // DropDownList,   look tplBtnAttrDoc_showDroppedDown
                        }
                    } else {
                        // AttrLink
                        const selectedValue = input.selectedValue
                        input.itemsSource = itemsSource.data
                        input.selectedValue = selectedValue
                        // input.showDropDownButton = !input.isReadOnly
                    }
                    input.itemsSource_myFreeze = false
                }

            } 
            
            if (fetchMode === 'justGet') {
                // do nothing, just return what we have, even if it's empty. Used for get
                // console.log(`!!! get_itemsSource justGet: ${segment}`)

            } else {
                if (input) {
                    input.showDropDownButton = false
                }

                if (segment) {
                    const params = { segment, fetchMode, ids, isRefresh }
                    if (store.fastEntry.idCache === false) params.id_cache = false // R4: выключенный пер-id кэш бэка
                    if (fetchMode === 'by_ids' && itemsSource.data) {
                        params.current_length = itemsSource.data.length // info
                    }

                    const entry = { vueObj, params, need_backend }
                    store._itemsSource_queue[segment] = entry

                    if (fetchMode !== 'all') {
                        entry._timer = setTimeout(() => {
                            entry._timer = null
                            store.async_get_itemsSource_data(segment)
                        }, 50)
                    } else {
                        store.async_get_itemsSource_data(segment)
                    }
                }
            }

            return itemsSource
        },
        async async_get_itemsSource_data(segment) {
            const store = this
            const print = store._print__async_get_itemsSource_data || false // this.hide_console
            const current = store._itemsSource_queue[segment]
            const vueObj = current.vueObj
            const params = current.params
            let need_backend = current.need_backend || false
            const FRONTEND_start = current.FRONTEND_start || performance.now()
            const WIDGET = vueObj.WIDGET

            if (!store.itemsSource[segment]) {
                store.itemsSource[segment] = { segment, change_index: 0 }
                need_backend = true
            }
            const itemsSource = store.itemsSource[segment]

            if (store.fetchMode !== 'all' && !need_backend) {
                need_backend = true // 2026 06 03 после перехода на использование fetchMode
            }

            params.showArchived = false
            if (!need_backend) {
                // if (!this.hide_console) console.log(`get_itemsSource delayed:${segment}`)
            } else {
                if (!params._pending_index) {
                    store._itemsSource_pending_index++
                    params._pending_index = store._itemsSource_pending_index
                }
                const log_ = `[${params._pending_index}] ${segment} ${params.fetchMode}`

                current.FRONTEND_start = FRONTEND_start
                let current_length = itemsSource.data?.length||''
                const add_length = params.ids?.length||''

                if (Object.keys(store._itemsSource_active).length >= 3 || store._itemsSource_active[segment]) {
                    if (print) console.log(`wait${log_} [${current_length}]+[${add_length}]`)
                    return
                }
                
                if (print) console.log(`+++${log_} [${current_length}]+[${add_length}]`)
                delete store._itemsSource_queue[segment]
                store._itemsSource_active[segment] = current

                const _release = (add_length) => {
                    if (current_length !== (itemsSource.data?.length||'')) {
                        current_length = itemsSource.data?.length||''
                    }
                    
                    if (!store._itemsSource_active[segment]) {
                        if (print) console.log(`!!!${log_} [${current_length}]+[${add_length}]`) // Warning: _release for segment ${segment} but it's not active
                    }
                    if (print) console.log(`---${log_} [${current_length}]+[${add_length}]`)
                    delete store._itemsSource_active[segment]
                }
                const _next = () => {
                    // ищем след без таймера
                    const nextSeg = Object.keys(store._itemsSource_queue).find(s => !store._itemsSource_queue[s]?._timer)
                    if (nextSeg) {
                        store.async_get_itemsSource_data(nextSeg)
                    }
                }

                try {
                    let send_start
                    const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    })
                    const send_packege_size = Math.round(payload.length / 1024)
                    $.ajax({
                        url: store.url_backend_api,
                        type: "POST",
                        // timeout: 50000,
                        data: JSON.stringify({
                            command: 'get_itemsSource',
                            showSQL: store.showSQL, profiling_params: store.profiling_params,
                            variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                            ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                            params: params,
                            user: store.user,
                        }),
                        contentType: "application/json",
                        dataType: 'json',
                        // async: false,

                        beforeSend: function () {
                            send_start = vueObj.time = performance.now()
                        },
                        success: function (answer, textStatus, jqXHR) {
                            store.TERMINAL(WIDGET, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                            _release(answer.data?.length||'')
                            if (!store.check_loginAfterAjax(vueObj, answer)) return
                            if (!Array.isArray(answer.data)) { mtl_answered(store, segment, params.ids || null, false); _next(); return } // !!ERROR бэкенда: ответ без data — не ронять merge   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): полям составного типа — «нет»
                            if (!store.hide_console) console.log(`get_itemsSource:${segment}, length:${answer.data.length}, time:${Math.round(performance.now() - vueObj.time) / 1000}`)

                            // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса): ответ 'all' в потолок бэка — неполный: прежние разрешённые строки остаются, словарь не «полный»
                            const _allCut = params.fetchMode === 'all' && !params.isRefresh && store.setting('fe.ux.dictAllTruncated', true) !== false && itemsSourceAll_isTruncated(answer.data)
                            if (!itemsSource.data || params.isRefresh || params.fetchMode === 'all') {
                                itemsSource.data = _allCut ? itemsSourceAll_keepResolved(itemsSource.data, answer.data) : answer.data
                            } else {
                                // merge-дедуп: id уже в кэше → элемент заменяется свежим
                                // (обновляет устаревшие тайтлы), новые id — добавляются;
                                // раньше push(...) создавал дубли по id
                                const index_byId = new Map()
                                itemsSource.data.forEach((item, i) => index_byId.set(String(item.id), i))
                                // R20: id этого долива — в журнал изменений (get_dataMap), гриды сверяют их со своими колонками
                                itemsSource._lastMergeIds = params.fetchMode === 'by_ids' ? answer.data.map(it => String(it.id)) : null
                                for (const item of answer.data) {
                                    const i = index_byId.get(String(item.id))
                                    if (i === undefined) {
                                        itemsSource.data.push(item)
                                    } else {
                                        itemsSource.data[i] = item
                                    }
                                }
                            }
                            itemsSource.fetchMode = params.fetchMode
                            // R9 (waveGuard): безрезультатный by_ids-ответ не будит вотчеры —
                            // бамп itemsSource_change_index перезапускал резолверы чипсов/полей,
                            // и те же id уходили новой волной. Холд первого кадра (R1) снимаем
                            // явно: ему ответ пришёл, ждать больше нечего
                            const _resolved_any = answer.data.length > 0
                            if (!store.fastEntry.waveGuard || _resolved_any || params.fetchMode === 'all') {
                                store.get_dataMap(itemsSource, true)
                            } else {
                                store.get_dataMap(itemsSource)
                                for (const vObj of store._titleHolders || []) {
                                    if (vObj?.titles_pending?.has(segment)) {
                                        vObj.titles_pending.delete(segment)
                                        if (!vObj.titles_pending.size) vObj.titles_release('empty-answer')
                                    }
                                }
                            }

                            // ODOO-2388: докачка тайтлов. _pending_ids исторически держал ВСЕ
                            // once-requested id (5074) и чистился только на 'all' (5071). by_ids-
                            // запрос с >5000 id обрезается бэкендом (LIMIT 5000) → неотданные id
                            // остаются в pending, навсегда фильтруются из будущих by_ids (5030) и
                            // рендерятся сырым UUID, хотя их title у BE есть. Снимаем НЕотданные
                            // id из pending для повторного запроса (до MAX попыток); отданные
                            // оставляем — не пере-запрашиваем, сохраняя дедуп. После MAX промахов
                            // (реально отсутствующий id) оставляем в pending → settle на сыром id.
                            if (params.fetchMode === 'by_ids' && params.ids?.length && itemsSource._pending_ids) {
                                // R8 (titleRefetch): ретраить есть смысл ТОЛЬКО когда ответ мог быть
                                // обрезан лимитом бэкенда (ODOO-2388) — иначе «не вернул» значит
                                // «в сегменте нет», и 5 слепых попыток на id давали волны запросов
                                const _truncated = params.ids.length >= 5000 || answer.data.length >= 5000
                                const MAX_TITLE_REFETCH = (store.fastEntry.titleRefetch && !_truncated) ? 1 : 5
                                if (!itemsSource._title_miss) itemsSource._title_miss = {}
                                for (const id of params.ids) {
                                    if (itemsSource.ids?.[id]) {
                                        delete itemsSource._title_miss[id]
                                    } else {
                                        const miss = (itemsSource._title_miss[id] || 0) + 1
                                        itemsSource._title_miss[id] = miss
                                        if (miss < MAX_TITLE_REFETCH) {
                                            itemsSource._pending_ids.delete(id)
                                        } else {
                                            // финальный промах: id в сегменте нет (напр. subject_cor =
                                            // рабочий центр вне DS::SUBJECTS) — в negative-cache, чтобы
                                            // НОВЫЕ виджеты не перегоняли те же 5 ретраев (по 3.2с
                                            // бэкенда) заново; чистится вместе с 'all'-перезагрузкой
                                            if (!itemsSource._missing_ids) itemsSource._missing_ids = new Set()
                                            itemsSource._missing_ids.add(id)
                                        }
                                    }
                                }
                            }
                            if (params.fetchMode === 'all') {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: GUID в меню чипса): неполный 'all' — поглощённые им by_ids уходят заново
                                const _again = itemsSourceAll_settle(itemsSource, _allCut)
                                if (_again.length) setTimeout(() => { try { store.get_itemsSource(vueObj || {}, {}, { attr_type: 'AttrLink', relation_segment: segment }, { fetchMode: 'by_ids', ids: _again }) } catch (e) { /* без тайтлов — id */ } }, 0)
                            }
                            mtl_answered(store, segment, params.ids || null, true)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): подписчики полей составного типа пересчитывают выбор сегмента (ответ без новых id вотчеры не будит, waveGuard)
                            _next()
                        },
                        error: function (error) {
                            store.TERMINAL(WIDGET, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                            _release('ajax error')
                            mtl_answered(store, segment, params.ids || null, false)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди): ошибка — id сегмента «нет», очередь сегментов не встаёт
                            if (WIDGET) {
                                WIDGET.loading = false
                            }
                        },
                    })
                } catch (error) {
                    store.TERMINAL(WIDGET, null, {text:error, status:'error'})
                    _release('catch error')
                }
            }
        },
        // ---- R10 (fastEntry.geomPresets): размеры docked-скелета до ответа ----
        // calculatePage берёт минимумы из WIDGET.record.doc.widthMin_rem/heightMin_rem,
        // а запись приезжает только с ответом widget_open (с R5 — вместе с расчётом,
        // 10-20с). Пресет — последние известные минимумы виджета, ключ — id конфига
        // виджета (стабилен между сеансами), хранение — localStorage 'fastEntry_geom'
        geom_preset_get(widget_id) {
            if (!widget_id) return null
            try {
                if (!this._geomPresets) this._geomPresets = JSON.parse(localStorage.getItem('fastEntry_geom') || '{}')
                return this._geomPresets[widget_id] || null
            } catch (e) { return null }
        },
        geom_preset_put(widget_id, doc) {
            if (!widget_id || !doc || (!doc.widthMin_rem && !doc.heightMin_rem)) return
            try {
                if (!this._geomPresets) this._geomPresets = JSON.parse(localStorage.getItem('fastEntry_geom') || '{}')
                const prev = this._geomPresets[widget_id]
                const next = { w: doc.widthMin_rem || 1, h: doc.heightMin_rem || 1 }
                if (prev && prev.w === next.w && prev.h === next.h) return
                this._geomPresets[widget_id] = next
                localStorage.setItem('fastEntry_geom', JSON.stringify(this._geomPresets))
            } catch (e) { /* best effort */ }
        },

        // ---- R6 (fastEntry.snapshot): stale-while-revalidate вход со снапшота ----
        _snapshot_dbOpen() {
            // ленивое открытие IndexedDB: store 'answers', значения {value, t}
            const store = this
            if (store._snapshot_dbp) return store._snapshot_dbp
            store._snapshot_dbp = new Promise((resolve, reject) => {
                const req = indexedDB.open('webscm-fastentry', 1)
                req.onupgradeneeded = () => req.result.createObjectStore('answers')
                req.onsuccess = () => resolve(req.result)
                req.onerror = () => reject(req.error)
            })
            return store._snapshot_dbp
        },
        snapshot_key(WIDGET, widget_init) {
            // стабильный ключ виджета между сеансами: база+пользователь+стол+страница+
            // identity записи. WIDGET.id НЕ включаем — он runtime-нумерованный
            const u = this.user || {}
            const identity = widget_init?.record?.id || widget_init?.props?.segment || WIDGET.widget || ''
            return `wo:${u.database?.dbid || ''}:${u.id || ''}:${WIDGET.workspace}:${WIDGET.page}:${identity}:${getLanguage()}`   // IE 2026 09 23 / ODOO-341407: язык в ключе — кадр локализован бэком под язык ответа
        },
        async snapshot_get(key) {
            try {
                const db = await this._snapshot_dbOpen()
                return await new Promise(resolve => {
                    const req = db.transaction('answers').objectStore('answers').get(key)
                    req.onsuccess = () => {
                        const rec = req.result
                        // старше 7 суток не показываем: схемы/наборы колонок могли уехать
                        resolve(rec && Date.now() - (rec.t || 0) < 7 * 86400e3 ? rec.value : null)
                    }
                    req.onerror = () => resolve(null)
                })
            } catch (e) { return null }
        },
        async snapshot_put(key, value) {
            try {
                const db = await this._snapshot_dbOpen()
                db.transaction('answers', 'readwrite').objectStore('answers').put({ value, t: Date.now() }, key)
            } catch (e) { /* снапшот — best effort */ }
        },
        workspace_snapshot_key(workspace, page) {
            const u = this.user || {}
            return `ws:${u.database?.dbid || ''}:${u.id || ''}:${workspace}:${page || ''}:${getLanguage()}`   // IE 2026 09 23 / ODOO-341407: язык в ключе
        },
        workspace_snapshot_fingerprint(WORKSPACE_data) {
            // «тот же ли каркас»: только СТРУКТУРА — стол, набор страниц и состав
            // открываемых виджетов. Версию записи намеренно не берём: сервер
            // пересчитывает селекторы и меняет её почти на каждом входе, а кадр
            // от этого не отличается — иначе пересборка срабатывала бы всегда
            const pages = WORKSPACE_data?.PAGES || {}
            const widget_ids = (attrs, out = []) => {
                for (const row of attrs || []) {
                    const w = row?.widget || (row?.node?.relation_segment ? row?.node?.value : null)
                    if (w) out.push(w)
                    if (row?.attrs) widget_ids(row.attrs, out)
                }
                return out
            }
            // IE 2026 09 01 / ODOO-335250: + группа страницы — перегруппировка рейла меняет каркас
            return JSON.stringify([WORKSPACE_data?.record?.id,
                Object.keys(pages).sort().map(p => [p, pages[p]?.group?.key || '', widget_ids(pages[p]?.attrs).sort()])])
        },
        workspace_snapshot_apply(workspace, page, answer) {
            // R6b: собрать WORKSPACE из снапшота теми же правилами, что и success
            // workspace_open, и уйти в маршрут — виджеты начнут открываться (каждый
            // со своего снапшота), не дожидаясь ответа бэкенда
            const store = this
            if (!answer?.WORKSPACE || store.WORKSPACES[workspace]) return false
            const WORKSPACE = store.WORKSPACES[workspace] = {
                notification: { header: '', text: '', status: false, visible: false, fading: false,
                    closing: false, timerId: null,
                    statuses: { info: 10001, warning: 10002, error: 10003, critical: 10004, success: 10005 } },
                selectionWorkspace: {},
                ...answer.WORKSPACE,
                _staleWS: store.workspace_snapshot_fingerprint(answer.WORKSPACE),
            }
            if (answer.process_model_current) store.process_model_current = answer.process_model_current
            if (answer.process_model_menu) store.process_model_menu = answer.process_model_menu
            if (answer.database_menu) store.database_attrs = answer.database_menu
            // R10b: минимумы виджетов из снапшота — скелеты сразу в геометрии
            if (answer.widget_geom) store._widget_geom = { ...store._widget_geom, ...answer.widget_geom }
            store.update_CHIPS_from_WHERE(WORKSPACE.record.doc.params)
            if (store.fastEntry.timings) console.log(`[fastEntry:R6b] workspace ${workspace} from snapshot`)
            store.workspace_route(workspace, store.settingsPage_on() ? settingsPage_pick(WORKSPACE, page, WORKSPACE.active_page || page) : (WORKSPACE.active_page || page))   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц)
            return true
        },
        widget_snapshot_apply(WIDGET, answer) {
            // применить снапшот widget_open (формат R5 — данные в actions_after):
            // минимальный поднабор success-ветки widget_open — без callback'ов,
            // history и activate (их сделает реальный ответ, он идёт следом)
            const store = this
            if (WIDGET._gotRealOpen || WIDGET.close || !answer?.WIDGET) return
            const t0 = performance.now()
            store.widget_reveal(WIDGET)
            if (answer.itemsSources && store.fastEntry.inlineIS) {
                store.apply_inline_itemsSources(answer.itemsSources)
            }
            // ГЕОМЕТРИЮ из снапшота НЕ применяем: styleWidget в ответе — эхо
            // клиентского состояния НА МОМЕНТ записи (мог быть popout/чужие
            // размеры) — реплей дёргал виджет в старую позицию, реальный ответ
            // возвращал обратно. Текущий styleWidget скелета уже правильный
            // (раскладка страницы + widget_geom/пресеты)
            const { styleWidget: _sw_snapshot, ...WIDGET_snapshot } = answer.WIDGET
            Object.assign(WIDGET, WIDGET_snapshot)
            adf_kick(WIDGET)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита): D1 — audit_diff пришёл в сырой WIDGET, бейдж «⇄ N» формы — сразу при открытии
            WIDGET.loading = false // данные уже в actions_after; живую цепочку запустит реальный ответ
            WIDGET._staleOpen = true // «updating…»-индикация в шапке до реального ответа
            if (store.findWidget(WIDGET.id).ind === null) return
            store.sync_WORKSPACE(WIDGET, '>>WIDGET')
            store.widget_finishSetup(WIDGET)
            for (const a of answer.actions_after || []) {
                // командам select-ответа нужен контекст виджета: WIDGET и
                // content_Changed (делегат живому компоненту, когда он смонтируется)
                const ctx = WIDGET.vueObj || { WIDGET, content_Changed: () => WIDGET.vueObj?.content_Changed?.() }
                try { store.executeStoreMethod(ctx, a) } catch (e) { console.warn('[fastEntry:R6]', e) }
            }
            if (store.fastEntry.timings) console.log(`[fastEntry:R6] snapshot ${WIDGET.id} applied +${Math.round(performance.now() - t0)}ms`)
        },
        apply_inline_itemsSources(list) {
            // R2 (fastEntry.inlineIS): словари из ответа метода виджета — в кэш ДО
            // применения данных (updateDoc). get_dataMap инкрементит
            // itemsSource_change_index → гриды подхватят dataMap своим watch'ем,
            // и первый кадр рисуется сразу с тайтлами, без волны get_itemsSource
            const store = this
            for (const pack of Array.isArray(list) ? list : []) {
                if (!pack?.segment || !Array.isArray(pack.data) || !pack.data.length) continue
                let itemsSource = store.itemsSource[pack.segment]
                if (!itemsSource) itemsSource = store.itemsSource[pack.segment] = { segment: pack.segment, change_index: 0 }
                if (!itemsSource.data) {
                    itemsSource.data = pack.data
                } else {
                    // тот же merge-дедуп по id, что в async_get_itemsSource_data
                    const index_byId = new Map()
                    itemsSource.data.forEach((item, i) => index_byId.set(String(item.id), i))
                    for (const item of pack.data) {
                        const i = index_byId.get(String(item.id))
                        if (i === undefined) itemsSource.data.push(item)
                        else itemsSource.data[i] = item
                    }
                }
                if (pack.partial && !itemsSource.fetchMode) itemsSource.fetchMode = 'by_ids'
                store.get_dataMap(itemsSource, true)
                if (store.fastEntry.timings) console.log(`[fastEntry:R2] inline ${pack.segment}: +${pack.data.length} → ${itemsSource.data.length}`)
            }
        },
        // IE 2026 08 28 / ODOO-5828 (заказ Игоря «мгновенное открытие»): плоская карта
        // record._doc.by_ids = {id: title} из ответа widget_open → пачки {segment, data}
        // штатного apply_inline_itemsSources. Сегмент каждого id восстанавливаем по вью:
        // relation_segment полей формы (значение — по binding из записи) и колонок
        // табличных частей (значения — из строк всех массивов дока по имени биндинга).
        // Id, не привязанные к сегменту вью, не вливаются — их добирает прежний ленивый
        // путь (50мс-очередь get_itemsSource), поведение не хуже прежнего.
        // IE 2026 08 29 / ODOO-5828: просить ли обогащение для ЭТОЙ записи. Обогащение стоит
        // серверного времени (резолв + лишний обход дока), а окупается только когда закрывает ВСЕ
        // ссылки формы: у записей, где часть ссылок ведёт на сущности, не загруженные в WebSCM
        // (заказ поставщику: 5 из 45, серия: 11 из 24), сырые guid остаются при любом флаге, и
        // платить за обогащение незачем. Первое открытие типа записи — обучающее: apply_record_byIds
        // считает непокрытые ссылки и заносит сегмент в список «не просить» (живёт в сеансе вкладки).
        recordOpenTitles_ask(WIDGET) {
            const store = this
            if (store.recordOpenTitles?.enabled === false || WIDGET.widget !== 'widget-record') return false
            if (store.recordOpenTitles?.adaptive === false) return true
            const seg = WIDGET.record?.segment || WIDGET.props?.segment || ''
            return !(seg && store._recordOpenTitlesSkip?.has(seg))
        },
        apply_record_byIds(record, view) {
            const store = this
            if (store.recordOpenTitles?.enabled === false) return
            const by_ids = record?._doc?.by_ids
            if (!by_ids || typeof by_ids !== 'object' || !Object.keys(by_ids).length) return
            const t0 = performance.now()
            const packs = {}   // segment → Map(id → title)
            const claimed = new Set()
            const unresolved = new Set()   // ссылки формы, которых бэк не нашёл (сущности вне WebSCM)
            const guidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
            const claim = (segment, v) => {
                if (typeof v !== 'string' || !v) return
                if (!(v in by_ids)) {
                    if (guidRe.test(v)) unresolved.add(v)
                    return
                }
                let m = packs[segment]
                if (!m) m = packs[segment] = new Map()
                m.set(v, by_ids[v])
                claimed.add(v)
            }
            const doc = record.doc || {}
            const rowsArrays = Object.values(doc)
                .filter(a => Array.isArray(a) && a.length && a.length <= 5000 && store.isinstance_object(a[0]))
            const walk = (attrs) => {
                for (const attr of Array.isArray(attrs) ? attrs : []) {
                    if (!attr || typeof attr !== 'object') continue
                    const seg = attr.relation_segment
                    const b = typeof attr.binding === 'string' ? attr.binding : ''
                    if (seg && b && !b.startsWith('=')) {
                        const direct = store.get_value(record, b) ?? store.get_value(doc, b)
                        for (const v of Array.isArray(direct) ? direct : [direct]) claim(seg, v)
                        const key = b.replace(/^doc\./, '')
                        for (const rows of rowsArrays) {
                            for (const row of rows) {
                                const rv = row?.[key]
                                if (rv == null) continue
                                for (const v of Array.isArray(rv) ? rv : [rv]) claim(seg, v)
                            }
                        }
                    }
                    if (Array.isArray(attr.attrs)) walk(attr.attrs)
                }
            }
            walk(view)
            // ТИХИЙ влив — НЕ через apply_inline_itemsSources: тот делает get_dataMap(force) с
            // инкрементом itemsSource_change_index на КАЖДЫЙ сегмент, а среди сегментов формы есть
            // словари гридов страницы (DS::OBJECTS, DS::SUBJECTS, segment-5…) — шторм вотчеров
            // перепривязывал гриды страницы в критическое окно рендера формы (+0.7–1.4 с к fe_data
            // на заказе-370/серии-292). Форме пробуждение не нужно: влив происходит ДО её рендера,
            // AttrLink/AttrGrid создадутся уже над полными data/ids. Гридам страницы новые id не
            // нужны вовсе. dataMap пересоздаём только там, где он уже был (тихо, без change_index).
            for (const [segment, m] of Object.entries(packs)) {
                let its = store.itemsSource[segment]
                if (!its) its = store.itemsSource[segment] = { segment, change_index: 0 }
                if (!its.data) its.data = []
                if (!its.ids) its.ids = {}
                const index_byId = new Map()
                its.data.forEach((item, i) => index_byId.set(String(item.id), i))
                for (const [id, title] of m.entries()) {
                    const item = { id, title: title || '' }
                    const i = index_byId.get(String(id))
                    if (i === undefined) its.data.push(item)
                    else if (!its.data[i].title) its.data[i].title = item.title
                    if (!its.ids[id]) its.ids[id] = its.data[i === undefined ? its.data.length - 1 : i]
                }
                if (its.dataMap) its.dataMap = new wjGrid.DataMap(its.data, 'id', 'title')
                if (!its.fetchMode) its.fetchMode = 'by_ids'
            }
            const st = store._recordOpenTitlesStats
            st.opens++
            st.ids_applied += claimed.size
            st.ids_unmatched += Object.keys(by_ids).length - claimed.size
            st.ms += Math.round(performance.now() - t0)
            // обучающий проход: остались ссылки, которых бэк не нашёл → обогащение для этого типа
            // записи не окупается (мигание guid'ов всё равно останется), больше не просим
            const seg = record.segment || ''
            if (seg && unresolved.size && store.recordOpenTitles?.adaptive !== false
                    && !store._recordOpenTitlesSkip.has(seg)) {
                store._recordOpenTitlesSkip.add(seg)
                st.skipped_segments = store._recordOpenTitlesSkip.size
            }
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): профиль клиента в запросе (widget_open / executeWidgetMethod):
        // по client.mobile бэк берёт лимиты settings › Mobile (get_limits); без ключа — прежнее поведение.
        // Выкл: window.mobileUi.set('dataLimits', false)
        // IE 2026 09 19 / ODOO-5800 (Igor: измерение horizon в ключе метрики): client.metric_horizon — фронт умеет ключ метрики из четырёх частей
        // '<grade>|<metric>|<reason>|<horizon>'; только с этим признаком бэк (ie-dm7, be-ie c58323347) отдаёт такие ключи в словаре метрик,
        // отметках строк, таблице статистики и словаре витрины. Выключатель fe.ux.metricHorizon (false — всё как до измерения horizon)
        // ===== IE 2026 09 28 / ODOO-5800: ФОРМА НАСТРОЕК ВИДЖЕТА ПО ТРЕБОВАНИЮ (utils/settingsFormLazy.js) =====
        // у виджета есть вкладки-заглушки (каркас формы: содержимое вкладок настроек не приходило)
        settingsForm_pending(W) { return sfl_stubs(W).length > 0 },
        // вкладка node уже загружена (не заглушка, есть содержимое), а stub — заглушка той же вкладки
        settingsForm_loadedTab(node, stub) {
            if (!node || typeof node !== 'object' || node.lazyForm || !Array.isArray(node.attrs) || !node.attrs.length) return false
            const id = (t) => String(t?.name || t?.tooltip || t?.title || '')
            return id(node) === id(stub)
        },
        // признак каркаса в widget_init открытия: по заглушкам вида виджета (форма загружена — false, reload сразу с полной формой)
        settingsForm_widgetInit(WIDGET, widget_init) {
            try {
                if (!settingsFormLazy_on(this) || !Array.isArray(WIDGET?.view) || !WIDGET.view.length) return widget_init
                return { ...widget_init, settings_form_lazy: sfl_stubs(WIDGET).length > 0 }
            } catch (e) { return widget_init }
        },
        settingsForm_ownerOfView(view) {
            if (!view) return null
            try {
                for (const WS of Object.values(this.WORKSPACES || {})) {
                    const all = WS?.ALL_WIDGETS || []
                    const W = (Array.isArray(all) ? all : Object.values(all)).find(x => x && x.view === view)
                    if (W) return W
                }
            } catch (e) { /* стол пересоздаётся */ }
            return null
        },
        // замер открытий: каркас / полная форма у списков и отчётов
        settingsForm_countOpen(W, answer, jqXHR) {
            try {
                const cls = W?.widget_class
                if (cls !== 'widget_LIST' && cls !== 'widget_REPORT2') return
                const n = sfl_stubs(W).length, bytes = jqXHR?.responseText?.length || 0
                if (n) { sfl_count('opensLazy'); sfl_count('opensLazyBytes', bytes); sfl_count('opensLazyStubs', n) } else { sfl_count('opensFull'); sfl_count('opensFullBytes', bytes) }
            } catch (e) { /* замер не мешает открытию */ }
        },
        // полоса вкладок виджета видна (не мобильный профиль, не свёрнут, табы не скрыты либо показаны наведением на угол)
        settingsForm_tabsVisible(W) {
            const sw = W?.styleWidget || {}
            return !this.mobileUi?.on && !sw.minMode && (!sw.hideTabs || !!sw.show_hidden)
        },
        // полоса вкладок видна — форма настроек фоном (после основных запросов страницы, очередь P2): бейджи вкладок настроек и скрытие пустых
        // вкладок (Hide empty) — как с полной формой. now — сразу (пользователь сам показал полосу / оверлей вкладок)
        settingsForm_prefetchIfVisible(W, reason, now = false) {
            try {
                if (!W || !sfl_stubs(W).length || !settingsFormPrefetch_on(this) || !this.settingsForm_tabsVisible(W)) return
                if (now) { this.settingsForm_ensure(W, reason); return }
                if (W._sflPrefetchQueued || W._sflPromise) return
                W._sflPrefetchQueued = true
                this.schedule_deferredAction(W.vueObj || { WIDGET: W }, { command: 'settingsForm_prefetch', reason, deferred: true })
            } catch (e) { /* догрузка — при открытии вкладки */ }
        },
        // вкладки показаны пользователем явно (оверлей вкладок при скрытой полосе) — догрузить сразу, если догрузка при видимых вкладках включена
        settingsForm_prefetchNow(W, reason) {
            try { if (W && sfl_stubs(W).length && settingsFormPrefetch_on(this)) this.settingsForm_ensure(W, reason) } catch (e) { /* при открытии вкладки */ }
        },
        // догрузить полную форму настроек (метод виджета settings_form): один запрос на виджет, повторные вызовы ждут его же.
        // Ответ — view_patch заглушек (updateDoc); запись виджета ответ не трогает (у фронта она новее: выборка, правки пользователя)
        settingsForm_ensure(W0, reason) {
            const store = this
            const W = store.findWidget(W0?.id)?.WIDGET || W0   // реактивная обёртка: заглушка → вкладка перерисовывается
            if (!W || W.close) return Promise.resolve(false)
            if (!sfl_stubs(W).length) return Promise.resolve(true)
            if (W._sflPromise) return W._sflPromise
            if (sfl_denyByRole(store, W)) return Promise.resolve(false)   // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F1): роль «только чтение», политика бэка settings_form не разрешает — не шлём, без тоста, вкладка не висит на «Loading…»
            W._sflPrefetchQueued = false
            sfl_reason(reason)
            const t0 = performance.now()
            W._sflState = 'loading'
            const vueObj = W.vueObj || { WIDGET: W, content_Changed: () => W.vueObj?.content_Changed?.() }
            const action = { command: 'executeWidgetMethod', method: 'settings_form', record_sendToBackend_exclude: ['_doc'] }
            let payload
            try {
                const [wt] = store.get_widget_to_transfer(vueObj, action)
                payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(), command: 'executeWidgetMethod', method: 'settings_form',
                    action_id_front: store.net_actionId(++store.action_id_front), ...store.net_requestParams(), record_sendToBackend_exclude: ['_doc'],
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                    ...store.dl2_requestParams(), ...store.client_requestParams(),
                    process_model: store.process_model_record?.id, workspace: W.workspace,
                    WIDGET: wt, user: store.user,
                })
            } catch (e) {
                W._sflState = 'error'; sfl_count('loadsFailed')
                console.warn('settingsForm_ensure: payload', e)
                return Promise.resolve(false)
            }
            const fail = (why) => {
                W._sflPromise = null
                W._sflState = 'error'
                sfl_count('loadsFailed')
                if (!store.hide_console) console.warn(`[${W.id}] settings form not loaded: ${why}`)
                return false
            }
            W._sflPromise = new Promise(resolve => {
                $.ajax({
                    url: store.url_backend_api, type: 'POST', data: payload, contentType: 'application/json', dataType: 'json',
                    success(answer, textStatus, jqXHR) {
                        try {
                            if (W.close) { W._sflPromise = null; return resolve(false) }
                            if (!answer || typeof answer !== 'object') return resolve(fail('empty answer (' + (jqXHR?.status || '?') + ')'))   // 204: запрос отменён на бэке
                            store.TERMINAL(W, answer, null, t0, t0, Math.round(payload.length / 1024), jqXHR)
                            if (!store.check_loginAfterAjax(null, answer)) { W._sflPromise = null; return resolve(false) }
                            if (!answer || (!Array.isArray(answer.view_patch) && !Array.isArray(answer.view))) return resolve(fail('no view in the answer'))
                            let upd = { command: 'updateDoc', ...(Array.isArray(answer.view_patch) ? { view_patch: answer.view_patch } : { view: answer.view }) }
                            // IE 2026 10 10 / ODOO-341407 (бой: гриды страницы, открытой на uk, пустеют): «вид целиком» (каркас разошёлся с формой бэка по
                            // локализованному заголовку вкладки) — только вкладки-заглушки; вкладки содержимого (грид данных с колонками выборки) не трогаем.
                            // Выкл: window.feSettings.set('fe.widget.settingsFormWholeViewGuard', false) — прежнее применение вида целиком
                            if (!Array.isArray(answer.view_patch) && Array.isArray(answer.view) && store.setting(FLAG_WHOLE_VIEW_GUARD, true) !== false) {   // IE 2026 10 10 / ODOO-341407
                                const vp = sfl_wholeViewPatch(W.view, answer.view)   // IE 2026 10 10 / ODOO-341407
                                if (!vp) { sfl_count('wholeViewRefused'); return resolve(fail('whole view does not match the tabs of the form — not applied')) }   // IE 2026 10 10 / ODOO-341407
                                sfl_count('wholeViewGuarded')   // IE 2026 10 10 / ODOO-341407
                                if (!store.hide_console) console.log(`[${W.id}] settings form: whole view from the backend reduced to ${vp.length} stub tab(s)`)   // IE 2026 10 10 / ODOO-341407
                                upd = { command: 'updateDoc', view_patch: vp }   // IE 2026 10 10 / ODOO-341407
                            }
                            if (answer.widget_cache_key) upd.widget_cache_key = answer.widget_cache_key
                            store.executeStoreMethod(W.vueObj || vueObj, upd)
                            W.settings_form_lazy = false
                            W._sflState = 'done'
                            W._sflPromise = null
                            store.set_nonEmptyWidget(W)
                            store.set_isMappedWidget(W)
                            sfl_count('loads'); sfl_count('loadsMs', performance.now() - t0); sfl_count('loadsBackendMs', (answer.BACKEND_duration || 0) * 1000)
                            sfl_count('loadsBytes', jqXHR?.responseText?.length || 0)
                            if (!store.hide_console) console.log(`[${W.id}] settings form loaded (${reason}): ${Math.round(performance.now() - t0)} ms, backend ${answer.BACKEND_duration} s, stubs ${answer.settings_form?.stubs}`)
                            resolve(true)
                        } catch (e) { resolve(fail(String(e))) }
                    },
                    error(xhr, textStatus) { resolve(fail(textStatus || 'error')) },
                })
            })
            return W._sflPromise
        },
        client_requestParams() {
            const client = {}
            if (this.mobileUi?.on && this.mobileUi.dataLimits !== false) client.mobile = true
            if (this.metricHorizon_on()) client.metric_horizon = true
            if (this.metricStatus_on()) client.metric_status = true   // IE 2026 09 21 / ODOO-5800 (Igor: измерение «статус документа» в ключе метрики): фронт умеет хвост статуса '…|s:<status>'
            if (this.calcSlim_on()) client.calc_slim = true
            // IE 2026 09 21 / ODOO-5800 (Igor: «Пометка "NOT covered" стоит в конце строки. После числа читалось бы лучше, но для этого нужна правка фронта»): фронт ставит ссылки и
            // метки строк паспорта ячейки по их МЕСТУ (pos, utils/cellPassport.js), а не по первому вхождению подстроки — с этим признаком бэк (be-ie cell_passport._Text) называет
            // место числом и ставит пометку непокрытого сразу за количеством. Выключатель fe.ux.cellPassportPos (false — прежний ответ паспорта)
            try { if (this.setting('fe.ux.cellPassportPos', true) !== false) client.passport_pos = true } catch (e) { /* настройки ещё не прочитаны */ }
            if (this.metricSelector_on()) client.metric_selector = true   // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector)
            if (settingsFormLazy_on(this)) client.settings_form_lazy = true   // IE 2026 09 28 / ODOO-5800: фронт догружает форму настроек виджета (utils/settingsFormLazy.js)
            // IE 2026 09 28 / ODOO-342342 (ревью Д1): фронт умеет форму кейсов — вкладку Contents (AttrUseCaseMenu), команду guide_play и отметки. Без признака
            // (прежний фронт или выключенный fe.guide.cases) бэк не отдаёт ни вкладку, ни кнопки кейса (be guide.fe_supports)
            try { if (guideCases_on(this)) client.use_cases = true } catch (e) { /* настройки ещё не прочитаны */ }
            // IE 2026 09 30 / ODOO-343435: фронт умеет действия guided-тура (utils/guidePlay runTourStep, utils/guideTarget); без признака бэк их не шлёт
            try { if (guideCases_tourOn(this)) client.use_cases_tour = true } catch (e) { /* настройки ещё не прочитаны */ }
            try { if (this.setting('fe.activity.ping', true) !== false) client.tab_id = activityPing_tabId() } catch (e) { /* без sessionStorage */ }   // IE 2026 11 03 / ODOO-350449 (activity ping): вкладка в событиях LOGS-usage
            return Object.keys(client).length ? { client } : {}
        },
        // IE 2026 09 19 / ODOO-5800 (замер ie-dm7: широкий глобальный чипс метрик на ~4 тыс. узлов — 28 каналов calc*, 105 тыс. id, тело КАЖДОГО запроса
        // виджета 7,2 МБ при трёх различных наборах): client.calc_slim — фронт умеет ОБЛЕГЧЁННЫЕ КАНАЛЫ ГРАНЕЙ. С этим признаком бэк (be-ie 1009a7172) не
        // пишет канал calc::<грань>::false у грани без действующего чипса (это копия общего набора), а общий набор кладёт одной строкой calc_all —
        // её берёт workspace_params_for, когда строки канала своей грани нет. Замер: 7,18 → 0,91 МБ. Выключатель fe.data.calcSlim (false — наборы как прежде)
        calcSlim_on() { return this.setting('fe.data.calcSlim', true) !== false },
        metricHorizon_on() { return this.setting('fe.ux.metricChip', true) !== false && this.setting('fe.ux.metricHorizon', true) !== false },
        // IE 2026 09 21 / ODOO-5800 (Igor: измерение «статус документа» в ключе метрики) — Igor 21.09: «к измерениям метрик добавим "статус документа" … показывай эту колонку [во вкладке Metrics] и в чипсах-метрик».
        // client.metric_status — фронт умеет помеченный хвост статуса документа в ключе метрики (бэк ie-dm7: attrs.METRIC_STATUS_TAG; без признака ключи, словарь, вкладка Metrics —
        // как до измерения). Только вместе с режимом горизонта. Выключатель fe.ux.metricStatus
        metricStatus_on() { return this.metricHorizon_on() && this.setting('fe.ux.metricStatus', true) !== false },
        // IE 2026 09 19 / ODOO-5800 (Igor: Use вкладки Metrics = оформление метрики видно в таблице, состав чипса — колонка Selector): client.metric_selector — фронт умеет новое назначение колонок
        // вкладки Metrics (бэк ie-dm7 be-ie 28ea3b058: без признака вкладка приходит как раньше — Use = состав чипса). Выключатель fe.ux.metricSelector
        metricSelector_on() { return this.setting('fe.ux.metricChip', true) !== false && this.setting('fe.ux.metricSelector', true) !== false },
        fast_entry_requestParams() {
            // R2/R3: блок fast_entry для запроса метода виджета. known_itemsSources —
            // декларация уже имеющихся словарей (R3): источник истины — клиент, а не
            // серверная память о сеансе (session_key не различает вкладки и не
            // согласован с жизнью фронт-кэша — после F5 кэш пуст, а сервер «помнил» бы)
            const store = this
            const fe = { inlineIS: true, inlineIS_doc: !!store.fastEntry.inlineIS_doc, idCache: store.fastEntry.idCache !== false }
            if (store.fastEntry.knownIS) {
                const known = {}
                for (const segment in store.itemsSource) {
                    const is = store.itemsSource[segment]
                    if (!is?.data?.length) continue
                    if (is.fetchMode === 'all') known[segment] = { full: true }
                    else if (is.data.length <= 500) known[segment] = { ids: is.data.map(r => r.id) }
                    // >500 точечных id не декларируем: дубли в ответе дешевле мегабайта в запросе
                }
                if (Object.keys(known).length) fe.known_itemsSources = known
            }
            return fe
        },
        // IE 2026 11 02 / ODOO-350449 (дефект боя webscm #125565 по p194: p213 — словники лише при наборі, ліміт, серверний пошук для великих сегментів)
        // серверный поиск поля полосы чипсов (AttrChips.barSearch_server): name_search сегмента с потолком limit; ответ НЕ вливается в словарь
        // store.itemsSource (иначе неполный словарь выглядел бы загруженным), повтор того же текста — без кэша async_name_search. Возвращает jqXHR (abort — отмена)
        chipsBar_nameSearch(vueObj, segment, search, limit, onDone) {
            const store = this
            return $.ajax({
                url: store.url_backend_api,
                type: "POST",
                data: JSON.stringify({
                    command: 'get_itemsSource',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                    ...store.dl2_requestParams(),
                    params: { segment, fetchMode: 'name_search', search, limit },
                    user: store.user,
                }),
                contentType: "application/json",
                dataType: 'json',
                success: function(answer) {
                    if (!store.check_loginAfterAjax(vueObj, answer)) return
                    onDone(Array.isArray(answer?.data) ? answer.data : [], answer)
                },
                error: function(xhr, status) {
                    if (status === 'abort') return
                    onDone([], null)
                },
            })
        },
        async_name_search(vueObj, segment, search, onComplete, limit = 20) {   // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов): limit — проба малого сегмента (utils/linkDropdownSmallAll)
            const store = this
            const itemsSource = store.itemsSource[segment]
            if (!itemsSource || !segment) return
            if (!store._name_search_cache) store._name_search_cache = {}
            if (!store._name_search_cache[segment]) store._name_search_cache[segment] = new Set()
            // IE 2026 10 28 / ODOO-5800 (p079b): проба малого сегмента (limit ≠ 20) кэш повторов не берёт — пустой ответ кэша [] выглядел бы «сегмент малый»;
            // повтор пробы и так один на словарь сегмента (_smallAll, utils/linkDropdownSmallAll)
            const useCache = limit === 20
            if (useCache && store._name_search_cache[segment].has(search)) {
                if (onComplete) onComplete([])
                return
            }
            if (useCache) store._name_search_cache[segment].add(search)
            $.ajax({
                url: store.url_backend_api,
                type: "POST",
                data: JSON.stringify({
                    command: 'get_itemsSource',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    params: { segment, fetchMode: 'name_search', search, limit },   // IE 2026 10 28 / ODOO-5800 (просьба ie-dm7: выпадающий список ссылки при открытии — полный для малых сегментов)
                    user: store.user,
                }),
                contentType: "application/json",
                dataType: 'json',
                success: function(answer) {
                    if (!store.check_loginAfterAjax(vueObj, answer)) return
                    const newItems = answer.data || []
                    const existingIds = new Set((itemsSource.data || []).map(i => i.id))
                    const fresh = newItems.filter(i => !existingIds.has(i.id))
                    if (fresh.length) {
                        if (!itemsSource.data) itemsSource.data = []
                        itemsSource.data.push(...fresh)
                        if (!itemsSource.ids) itemsSource.ids = {}
                        for (const item of fresh) itemsSource.ids[item.id] = item
                        // get_dataMap намеренно не вызывается: его вызов инкрементирует
                        // store.itemsSource_change_index, что через watch закрывает открытый dropdown.
                        // DataMap перестроится при следующей обычной загрузке itemsSource.
                    }
                    if (onComplete) onComplete(newItems, answer)   // IE 2026 10 28 / ODOO-5800 (p079b): ответ целиком — проба отличает ошибку бэка от пустого сегмента
                },
            })
        },
        // IE 2026 08 27 (Igor, Inventory Policy › Replenishment model): пункт, выбранный в дропдауне-редакторе, кладём в
        // словарь сегмента стора. Грид резолвит тайтлы ссылочных ячеек только по нему (inline-словарь несёт лишь id из
        // загруженных строк), а список дропдауна — отдельный поиск; без этого ячейка показывала сырой id до перечитывания.
        itemsSource_addItem(vueObj, attr, item) {
            const store = this
            if (!item || !item.id || !attr?.relation_segment) return false
            const itemsSource = store.get_itemsSource(vueObj, {}, attr, { fetchMode: 'justGet' })
            if (!itemsSource || !Array.isArray(itemsSource.data)) return false
            if (!itemsSource.ids) itemsSource.ids = {}
            if (itemsSource.ids[item.id]) {
                // IE 2026 08 28 / ODOO-5800 (баг Игоря: выбранный «opt-max» показывался сырым id):
                // id уже долит в словарь (поиск дропдауна / тихий влив) БЕЗ пересоздания карты —
                // wijmo DataMap держит индекс над прежним составом массива и отдаёт сырой id.
                // Проверяем резолв и при промахе пересоздаём карту (get_dataMap force разбудит вотчеры)
                let _disp = null
                try { _disp = itemsSource.dataMap ? itemsSource.dataMap.getDisplayValue(item.id) : null } catch (e) { _disp = null }
                if (_disp === null || _disp === item.id) store.get_dataMap(itemsSource, true)
                return false
            }
            const it = { id: item.id, title: item.title || item.id }
            for (const k of ['code', 'cssClass', 'parent', 'attrs', 'valueStr']) if (item[k] !== undefined) it[k] = item[k]
            itemsSource.data.push(it)
            itemsSource.ids[item.id] = it
            itemsSource._pending_ids?.delete?.(item.id)
            itemsSource._missing_ids?.delete?.(item.id)
            store.get_dataMap(itemsSource, true)   // dataMap + itemsSource_change_index → вотчеры гридов перерисуют ячейки
            return true
        },
        get_dataMap(itemsSource, force=false) {
            const store = this
            if (!itemsSource.data) return
            if (!itemsSource.dataMap || force) {
                itemsSource.dataMap = new wjGrid.DataMap(itemsSource.data, 'id', 'title');

                // if (!itemsSource.ids && itemsSource.segment=='SEGMENTS') {
                itemsSource.ids = {}
                for (let item of itemsSource.data) {
                    itemsSource.ids[item.id] = item
                }

                if (itemsSource.segment) {
                    // IE 2026 09 25 / ODOO-341407 (switchDictsCoalesce): словарь перечитывается живым переключением языка — бамп (перерисовка гридов по
                    // вотчеру itemsSource_change_index) откладывается до ответа ВСЕХ словарей переключения, одной волной (relocalize._releaseHold)
                    if (itemsSource._i18nHold && store._i18nHeldSegs) {
                        store._i18nHeldSegs.add(itemsSource.segment)
                        itemsSource._lastMergeIds = null
                    } else {
                        store.itemsSource_bump(itemsSource)
                    }
                }

                itemsSource.change_index++
            }
        },
        // бамп журнала изменений словарей: вотчеры 'store.itemsSource_change_index' (гриды, чипсы) перечитают сегмент
        // IE 2026 09 25 / ODOO-341407: вынесено из get_dataMap — им же снимается удержание словарей живого переключения
        itemsSource_bump(itemsSource) {
            const store = this
            if (!itemsSource || !itemsSource.segment) return
            store.itemsSource.change_type = itemsSource.segment
            store.itemsSource_change_index++
            // R20: ids — состав by_ids-долива (null — словарь заменён / состав неизвестен: менялось всё)
            store.itemsSource_change_log.push({ index: store.itemsSource_change_index, segment: itemsSource.segment, ids: itemsSource._lastMergeIds || null })
            itemsSource._lastMergeIds = null
            if (store.itemsSource_change_log.length > 100) {
                store.itemsSource_change_log.splice(0, store.itemsSource_change_log.length - 100)
            }
        },
        // R20: id, пришедшие по сегменту между срабатываниями вотчера: Set | null (null — состав неизвестен, считать изменённым всё)
        get_itemsSource_changedIds(newVal, oldVal, segment) {
            const log = this.itemsSource_change_log
            if (!log.length || log[0].index > oldVal + 1) return null
            const set = new Set()
            for (const entry of log) {
                if (entry.index > oldVal && entry.index <= newVal && entry.segment === segment) {
                    if (!entry.ids) return null
                    for (const id of entry.ids) set.add(id)
                }
            }
            return set
        },
        get_itemsSource_changedSet(newVal, oldVal) {
            // сегменты, изменившиеся между срабатываниями watch 'store.itemsSource_change_index':
            // Vue батчит вотчеры, за один тик может измениться несколько сегментов,
            // а itemsSource.change_type хранит только последний — события терялись.
            // null = журнал не покрывает диапазон, считать изменённым любой сегмент
            const log = this.itemsSource_change_log
            if (!log.length || log[0].index > oldVal + 1) {
                return null
            }
            const set = new Set()
            for (const entry of log) {
                if (entry.index > oldVal && entry.index <= newVal) {
                    set.add(entry.segment)
                }
            }
            return set
        },
        // ---------------- CSS-CLASS: реестр классов оформления полей ----------------
        // Кэш на сессию (in-memory, инвалидация — перезагрузкой вместе с CONFIG_VERSION,
        // как остальные конфигурационные данные): id записи CSS-CLASS → {name, styles}.
        // Неизвестные id копятся и запрашиваются одним батчем get_cssClasses (дебаунс,
        // по образцу get_itemsSource). До ответа класс применяется по значению id —
        // для предопределённых записей id == имя класса, визуально ничего не ломается.
        resolve_cssClasses(list) {
            // табличная часть cssClasses/cssClasses_columnHeader → строка имён классов
            const store = this
            if (!Array.isArray(list) || !list.length) return ''
            const names = []
            let unknown = null
            for (const row of list) {
                if (!row || row.use === false || !row.cssClass) continue
                const id = row.cssClass
                const known = store.cssClasses[id]
                if (known) {
                    if (known.name) names.push(known.name)
                } else {
                    names.push(id)
                    if (!unknown) unknown = []
                    unknown.push(id)
                }
            }
            if (unknown) store.queue_cssClasses(unknown)
            return names.join(' ')
        },
        queue_cssClasses_fromAttr(attr) {
            // сбор ссылок классов из табличных частей определения поля (при получении вьюхи)
            if (Array.isArray(attr?.cssClasses)) this.resolve_cssClasses(attr.cssClasses)
            if (Array.isArray(attr?.cssClasses_columnHeader)) this.resolve_cssClasses(attr.cssClasses_columnHeader)
        },
        // IE 2026 09 18 / ODOO-… (заказ Игоря: именованные стили — «менять централизованно»): ВЕСЬ реестр стилей — одним запросом
        // на сеанс (get_cssClasses {all: true}): стили, на которые ссылаются правила оформления, зарегистрированы до первой
        // отрисовки (правила несут только ИМЕНА классов — по одному их никто не запрашивал), вкладка Styles знает заголовки и
        // группы. Бэк без режима all (ответ без признака all) — остаётся прежний путь: неизвестные id пачками.
        // Возвращает true, пока реестр грузится (ids придержаны и после ответа уйдут только оставшиеся неизвестными)
        cssClasses_loadAll(holdIds = null) {
            const store = this
            if (store._cssAll === 'done' || store._cssAll === 'unsupported') return false
            if (holdIds?.length) { store._cssAll_held = store._cssAll_held || new Set(); for (const id of holdIds) store._cssAll_held.add(id) }
            if (store._cssAll === 'loading') return true
            if (!store.url_backend_api || !store.user) return false
            store._cssAll = 'loading'
            const finish = (state) => {
                store._cssAll = state
                const held = [...(store._cssAll_held || [])].filter(id => !store.cssClasses[id])
                store._cssAll_held = null
                if (held.length) store.queue_cssClasses(held)
            }
            $.ajax({
                url: store.url_backend_api,
                type: "POST",
                data: JSON.stringify({ command: 'get_cssClasses', params: { all: true }, user: store.user, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }) }),
                contentType: "application/json",
                dataType: 'json',
                success: function (answer) {
                    if (!answer || answer.all !== true) { finish('unsupported'); return }
                    for (const item of answer.data || []) store.cssClass_put(item)
                    store.cssClasses_change_index++
                    finish('done')
                },
                error: function () { finish('unsupported') },
            })
            return true
        },
        cssClass_put(item) {
            const store = this
            if (!item?.id) return
            store.cssClasses[item.id] = item
            store.cssClassesByName[item.name || item.id] = item
            store.register_cssClass_styles(item)
        },
        // стиль по имени класса (или id записи): {title, group, map_color, …} либо null
        cssClass_info(name) {
            return this.cssClassesByName[name] || this.cssClasses[name] || null
        },
        queue_cssClasses(ids) {
            const store = this
            if (store.cssClasses_loadAll(ids)) return
            if (!store._cssClasses_pending) store._cssClasses_pending = new Set()
            if (!store._cssClasses_queue) store._cssClasses_queue = new Set()
            let queued = false
            for (const id of ids) {
                if (store._cssClasses_pending.has(id)) continue
                store._cssClasses_pending.add(id)
                store._cssClasses_queue.add(id)
                queued = true
            }
            if (!queued) return
            if (store._cssClasses_timer) clearTimeout(store._cssClasses_timer)
            store._cssClasses_timer = setTimeout(() => {
                store._cssClasses_timer = null
                const batch = [...store._cssClasses_queue]
                store._cssClasses_queue.clear()
                store.async_get_cssClasses(batch)
            }, 50)
        },
        async_get_cssClasses(ids) {
            const store = this
            if (!ids.length) return
            $.ajax({
                url: store.url_backend_api,
                type: "POST",
                data: JSON.stringify({
                    command: 'get_cssClasses',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    params: { ids },
                    user: store.user,
                }),
                contentType: "application/json",
                dataType: 'json',
                success: function (answer) {
                    if (!store.check_loginAfterAjax(null, answer)) return
                    for (const item of answer.data || []) store.cssClass_put(item)   // IE 2026 09 18: + индекс по имени класса
                    store.cssClasses_change_index++
                },
                error: function () {
                    // ошибка — снять отметку «запрошен», чтобы id можно было запросить повторно
                    for (const id of ids) store._cssClasses_pending?.delete(id)
                },
            })
        },
        register_cssClass_styles(item) {
            // styles записи CSS-CLASS — переопределение стилей класса: отдельный <style>
            // на класс, (пере)добавляемый в конец <head> — позже базовых стилей, поэтому
            // выигрывает при равной специфичности; повторное получение заменяет содержимое.
            // Регистрация по имени класса — действует и там, где класс пришёл строкой
            // (легаси cssClass, условия cssStyle-CONDITIONS)
            const store = this
            const name = item.name || item.id
            // IE 2026 09 18 / ODOO-… (заказ Игоря: именованные стили — централизованно, с вариантами по цветовым схемам):
            // styles — объявления CSS («background-color: …; color: …») либо полный CSS (есть «{»); объявления оборачиваются
            // в селектор класса. schemes — варианты стиля по цветовым схемам: body.cscheme-<id> …, 'dark' — .dark-theme …
            const esc = (window.CSS && CSS.escape) ? CSS.escape(name) : name
            const wrap = (css, prefix) => {
                css = String(css || '').trim()
                if (!css) return ''
                if (css.includes('{')) return css
                // имя класса повторено: именованный стиль обязан пробивать правила фронта с большей специфичностью
                // (приглушённый тон .wj-cell.cell-info и его варианты по гаммам body[class*="cscheme-style"] … — 0,3,1 / 0,4,1),
                // как это делают отдельные правила для cell-background-* (грейд-раскраска Δ%-ячеек сравнения)
                const c4 = `.${esc}`.repeat(4), c2 = `.${esc}`.repeat(2)
                return `${prefix}.wj-cell${c4}, ${prefix}${c2} { ${css} }`
            }
            const parts = [wrap(item.styles, '')]
            for (const v of (Array.isArray(item.schemes) ? item.schemes : [])) {
                const sch = String(v?.scheme || '').trim()
                if (!sch || !/^[\w-]+$/.test(sch)) continue
                parts.push(wrap(v.styles, sch === 'dark' ? '.dark-theme ' : `body.cscheme-${sch} `))
            }
            const styles = parts.filter(Boolean).join('\n')
            if (!store._cssClasses_styleEls) store._cssClasses_styleEls = {}
            let el = store._cssClasses_styleEls[name]
            if (!styles) {
                if (el) {
                    el.remove()
                    delete store._cssClasses_styleEls[name]
                }
                return
            }
            if (!el) {
                el = document.createElement('style')
                el.setAttribute('data-css-class', name)
                store._cssClasses_styleEls[name] = el
            }
            el.textContent = styles
            document.head.appendChild(el)
            // превью-дельты классов считаются по computed style — пересчитать
            cfClassDeltaInvalidate(name)
        },
        // ---------------- itemsSourcesView: реестр полей источников виджета ----------------
        // Реестр (record._doc.itemsSourcesView) приходит один раз при widget_open и никогда не
        // отправляется обратно на бэкенд (вместе с _doc); при изменении бэкенд присылает новый
        // в ответе (updateDoc и др.) — фронт просто заменяет копию, кэш сбрасывается по ссылке.
        get_itemsSourcesView_owner(WIDGET, need_registry=true) {
            // владелец реестра: сам виджет или родитель popup-строки (widget-row §3) —
            // popup реестром не владеет, его локальная копия в _doc служит только
            // данными вкладки-реестра (§6) и здесь игнорируется;
            // для popup строки источника (source_segments) реестр фильтруется до этой строки
            const store = this
            let rowFilter = null, iter = 0
            while (WIDGET && WIDGET.widget === 'widget-row' && iter++ < 5) {
                if (!rowFilter && String(WIDGET.record?._meta?.binding || '').endsWith('source_segments')) {
                    const row = WIDGET.record?._record || WIDGET.record || {}
                    if (row.name || row.segment) {
                        rowFilter = { name: row.name || '', segment: row.segment || '' }
                    }
                }
                if (WIDGET.parentWIDGET?.id === undefined) break
                WIDGET = store.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
            }
            if (WIDGET?.record?._doc?.itemsSourcesView?.length) return { owner: WIDGET, rowFilter }
            // локальный источник ({binding} — поля из записи владельца): бэк-реестр
            // не обязателен, достаточно записи владельца
            return (!need_registry && WIDGET?.record) ? { owner: WIDGET, rowFilter } : null
        },
        preserve_itemsSourcesView(WIDGET, record_new) {
            // ответы бэка заменяют record/_doc; отсутствие ключа itemsSourcesView в новой _doc
            // означает «реестр не менялся», а НЕ «очистить» — переносим прежний реестр.
            // Popup-строки (widget-row) реестром не владеют — их локальная копия (§6)
            // перестраивается из родителя при визуализации, переносить её нельзя
            if (WIDGET.widget === 'widget-row') return
            const prev = WIDGET.record?._doc?.itemsSourcesView
            if (!prev || !record_new || record_new === WIDGET.record) return
            if (record_new._doc?.itemsSourcesView) return // пришёл новый реестр — используем его
            record_new._doc = record_new._doc || {}
            record_new._doc.itemsSourcesView = prev
        },
        exclude_itemsSourcesView(record) {
            // реестр не отправляется на бэкенд: копия record без _doc.itemsSourcesView
            // (для команд, где record уходит без record_sendToBackend_exclude: ['_doc']);
            // _target — копия target-реестра popup-а (ит.4 §3)
            // IE 2026 09 20 / ODOO-5800 (Igor: «раскраску в ячейке ожидаю не от форматирования, а от метрик» — опция отчёта «Metric data in cells»):
            // таблица деталей метрик record._doc.metric_data — данные ответа select (как _doc.data), на бэк не отсылается
            if (record?._doc?.itemsSourcesView || record?._doc?.itemsSourcesView_target || record?._doc?.metric_data) {
                record = { ...record, _doc: { ...record._doc } }
                delete record._doc.itemsSourcesView
                delete record._doc.itemsSourcesView_target
                if (record._doc.metric_data) delete record._doc.rules   // IE 2026 09 20 / ODOO-5800 (Igor: «для каждой ячейки иметь привязку к применимым правилам … показать в форме drilldown — применимые правила»): словарь правил приходит вместе с таблицей деталей и на бэк тоже не отсылается
                delete record._doc.metric_data
            }
            return record
        },
        get_itemsSourcesView_sources(ctx) {
            // источники реестра по правилам §3/§5.1: use != false (#meta — всегда),
            // для popup строки-источника — только её корень (binding == name строки
            // или source_field.value == segment строки);
            // ит.4: extra-корни — только при явном выборе (ctx.select) по сегменту
            // (source_field.value) или по roots: 'main_sources' (§3.1)
            const { owner, rowFilter } = ctx
            if (ctx.select?.binding) {
                // локальный источник ({binding}) — один синтетический корень
                // из массива полей записи владельца (напр. doc.viewList);
                // ит.5: только ветки с use (отфильтрованная копия из ctx)
                return [{ binding: ctx.select.binding,
                    title: ctx.select.title || ctx.select.binding, attrs: ctx.selectRowsFiltered }]
            }
            return owner.record._doc.itemsSourcesView.filter(source => {
                const is_meta = source.binding === '#meta'
                if (is_meta) return true
                if (ctx.select) {
                    // ит.4 §3.1: 'main_sources' — основные корни (не extra, не is_join)
                    if (ctx.select.roots === 'main_sources') return !source.extra && !source.is_join
                    // ит.4 §2: явный выбор по сегменту — extra/use/rowFilter не важны
                    return source.source_field?.value === ctx.selectSegment
                }
                if (source.extra) return false // ит.4 §1: только при явном выборе
                if (source.use === false) return false
                if (rowFilter
                    && !(rowFilter.name && source.binding === rowFilter.name)
                    && !(rowFilter.segment && source.source_field?.value === rowFilter.segment)) {
                    return false
                }
                return true
            })
        },
        filter_itemsSourcesView_use(attrs) {
            // ит.5: локальный источник ({binding}) — в подбор попадают только ветки с use:
            // строка с use === false исключается вместе со всем поддеревом attrs,
            // отсутствующий use = включено, рекурсивно (зеркало бэкового _filter_use_fields);
            // исходный массив не мутируется — узлы с детьми копируются
            const store = this, out = []
            for (const field of attrs || []) {
                if (field.use === false) continue
                if ((field.attrs || []).length) {
                    out.push({ ...field, attrs: store.filter_itemsSourcesView_use(field.attrs) })
                } else {
                    out.push(field)
                }
            }
            return out
        },
        sig_itemsSourcesView_use(attrs) {
            // подпись состава включённых строк для инвалидации кэшей: переключение use
            // не меняет ни ссылку на массив, ни его длину
            let sig = ''
            for (const field of attrs || []) {
                sig += (field.binding || '') + ';'
                if ((field.attrs || []).length) sig += '(' + this.sig_itemsSourcesView_use(field.attrs) + ')'
            }
            return sig
        },
        get_itemsSourcesView_select(vueObj) {
            // ит.4 §2/§3: конфиг явного выбора корней реестра ({segment_binding} или
            // {roots: 'main_sources'}, плюс target_bindings для _target) —
            // на узле грида (ячейки/кнопка самого грида), на _record popup-а
            // (скопирован при widget_open) или на узле грида-источника родительского
            // popup-а (Row-popup строки / каскад widget-row → widget-row)
            const store = this
            const key = vueObj?.attr?.name === 'grid-itemsSourcesView-target'
                ? 'itemsSourcesView_target' : 'itemsSourcesView_source'
            if (vueObj?.attr?.[key]) return vueObj.attr[key]
            let W = vueObj?.WIDGET, iter = 0
            while (W && W.widget === 'widget-row' && iter++ < 5) {
                if (W.record?._record?.[key]) return W.record._record[key]
                const parent = W.parentWIDGET?.id !== undefined
                    ? store.findWidget(W.parentWIDGET.id)?.WIDGET : null
                const binding = W.record?._meta?.binding
                if (binding && parent?.view) {
                    const gridAttr = store.get_field0(parent.view, binding)
                    if (gridAttr?.[key]) return gridAttr[key]
                }
                W = parent
            }
            return null
        },
        resolve_itemsSourcesView_select(ctx, WIDGET, select) {
            // разрешение segment_binding (ит.4 §2): 'doc.' — из записи виджета-владельца
            // реестра; относительный — из записи текущей строки (_record ближайшего
            // Row-popup-а, в каскаде — родительского); Multi {value, valueStr} → value
            const store = this
            const binding = select?.segment_binding
            if (!binding) return ''
            let raw
            if (String(binding).startsWith('doc.')) {
                raw = store.get_value(ctx.owner.record, binding)
            } else {
                let W = WIDGET, iter = 0
                while (W && W.widget === 'widget-row' && iter++ < 5) {
                    const row = W.record?._record
                    const v = row ? store.get_value(row, binding) : undefined
                    if (v !== undefined) { raw = v; break }
                    if (W.parentWIDGET?.id === undefined) break
                    W = store.findWidget(W.parentWIDGET.id)?.WIDGET
                }
            }
            if (raw && typeof raw === 'object') raw = raw.value
            return (raw === undefined || raw === null) ? '' : String(raw)
        },
        get_itemsSourcesView_ctx(vueObj) {
            // owner + rowFilter (ит.1 §3) + явный выбор корня (ит.4 §2/§3)
            // или локальный источник ({binding} — массив полей записи владельца,
            // напр. doc.viewList);
            // null, если реестра нет или явный выбор не разрешается в существующий
            // корень (сегмент не заполнен / реестр устарел) — «как без реестра»
            const store = this
            const select = store.get_itemsSourcesView_select(vueObj)
            const ctx = store.get_itemsSourcesView_owner(vueObj?.WIDGET, !select?.binding)
            if (!ctx) return null
            if (select) {
                ctx.select = select
                if (select.binding) {
                    // локальный источник: поля из записи владельца — бэк-реестр
                    // не используется; пусто/не массив — «как без реестра»;
                    // ит.5: только ветки с use — всё выключено = тоже «как без реестра»
                    const rows = store.get_value(ctx.owner.record, select.binding)
                    if (!Array.isArray(rows) || !rows.length) return null
                    const filtered = store.filter_itemsSourcesView_use(rows)
                    if (!filtered.length) return null
                    ctx.selectRows = rows
                    ctx.selectRowsFiltered = filtered
                    ctx.selectSig = store.sig_itemsSourcesView_use(filtered)
                } else if (select.roots === 'main_sources') {
                    // ит.4 §3.1: валиден, пока в реестре есть хоть один основной корень
                    if (!ctx.owner.record._doc.itemsSourcesView.some(
                        s => s.binding !== '#meta' && !s.extra && !s.is_join)) {
                        return null
                    }
                } else {
                    ctx.selectSegment = store.resolve_itemsSourcesView_select(ctx, vueObj.WIDGET, select)
                    if (!ctx.selectSegment || !ctx.owner.record._doc.itemsSourcesView.some(
                        s => s.binding !== '#meta' && s.source_field?.value === ctx.selectSegment)) {
                        return null
                    }
                }
            }
            return ctx
        },
        flatten_itemsSourcesView(attrs, items, prefix='', prefixTitle='') {
            // правило бэкенда attrs_set_parent_binding / fields_to_itemsSource:
            // элемент — для каждого узла с непустым binding; префикс биндинга/заголовка
            // добавляют детям только узлы AttrGrid, обычные группировки передают его как есть
            const store = this, lang = store.get_lang()
            for (const field of attrs || []) {
                const translated = lang ? field['title_' + lang] : ''
                const field_title = (typeof translated === 'string' && translated)
                    || field.title || field.binding || ''
                let id = '', title = ''
                if (field.binding) {
                    id = prefix ? `${prefix}.${field.binding}` : field.binding
                    title = prefixTitle ? `${prefixTitle} . ${field_title}` : field_title
                    const item = { id, title: title || id }
                    if (field.attr_type) item.attr_type = field.attr_type
                    if (field.relation_segment) item.relation_segment = field.relation_segment
                    items.push(item)
                }
                if ((field.attrs || []).length) {
                    if (field.attr_type === 'AttrGrid' && id) {
                        store.flatten_itemsSourcesView(field.attrs, items, id, title || id)
                    } else {
                        store.flatten_itemsSourcesView(field.attrs, items, prefix, prefixTitle)
                    }
                }
            }
        },
        get_itemsSource_fromView(vueObj, attr) {
            // itemsSource ячейки с use_itemsSourcesView: true — из реестра itemsSourcesView;
            // inline attr.itemsSource даёт только служебные #-элементы (#and, #fields, ...)
            const store = this
            const ctx = store.get_itemsSourcesView_ctx(vueObj)
            if (!ctx) return null
            const { owner, rowFilter } = ctx
            const registry = owner.record._doc?.itemsSourcesView

            let cache = owner._itemsSourcesView_cache
            if (!cache || cache.registry !== registry || cache.lang !== store.get_lang()) {
                cache = owner._itemsSourcesView_cache = { registry, lang: store.get_lang(), flat: {}, byAttr: new WeakMap() }
            }

            const filterKey = ctx.select ? `#select::${ctx.select.roots || ctx.select.binding || ctx.selectSegment}`
                : (rowFilter ? `${rowFilter.name}::${rowFilter.segment}` : '')
            let flat = cache.flat[filterKey]
            if (flat && ctx.selectRows && (cache.local?.[filterKey]?.rows !== ctx.selectRows
                || cache.local?.[filterKey]?.n !== ctx.selectRows.length
                || cache.local?.[filterKey]?.sig !== ctx.selectSig)) {
                // локальный источник живёт в записи и правится на месте —
                // пересборка при замене массива, изменении числа строк или
                // состава включённых (use) строк (ит.5: длина от use не меняется)
                flat = null
            }
            if (!flat) {
                const items = [], seen = new Set()
                for (const source of store.get_itemsSourcesView_sources(ctx)) {
                    const source_items = []
                    store.flatten_itemsSourcesView(source.attrs, source_items)
                    for (const item of source_items) {
                        if (!seen.has(item.id)) { // дедупликация по id, первое вхождение выигрывает
                            seen.add(item.id)
                            items.push(item)
                        }
                    }
                }
                flat = cache.flat[filterKey] = items
                if (ctx.selectRows) {
                    (cache.local = cache.local || {})[filterKey] =
                        { rows: ctx.selectRows, n: ctx.selectRows.length, sig: ctx.selectSig }
                }
            }

            let entry = cache.byAttr.get(attr)
            if (!entry || entry.flat !== flat) {
                const service_items = (attr.itemsSource || []).filter(item => String(item.id ?? '').startsWith('#'))
                entry = { flat, itemsSource: { data: [...service_items, ...flat], change_index: 0 } }
                cache.byAttr.set(attr, entry)
            }
            return entry.itemsSource
        },
        async_get_link_fields(vueObj, segment, onComplete) {
            // expandLinkFields: поля сегмента-справочника для lazy-раскрытия Link-поля;
            // ответ — определения полей как есть (формат строк реестра itemsSourcesView)
            const store = this
            $.ajax({
                url: store.url_backend_api,
                type: "POST",
                data: JSON.stringify({
                    command: 'get_link_fields',
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    params: { segment },
                    user: store.user,
                }),
                contentType: "application/json",
                dataType: 'json',
                success: function (answer) {
                    if (!store.check_loginAfterAjax(vueObj, answer)) return
                    onComplete(answer.fields || [])
                },
                error: function () {
                    store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    onComplete(null)
                },
            })
        },
        refresh_itemsSource(segment, new_item=null) {
            const store = this

            if (new_item) {
                const new_id = String(new_item.id)
                const update_segment = (segment, allow_push) => {
                    const itemsSource = store.itemsSource[segment]
                    if (!itemsSource || !Array.isArray(itemsSource.data)) return
                    let changed = false, first = -1
                    for (let i = 0; i < itemsSource.data.length; i++) {
                        if (String(itemsSource.data[i].id) !== new_id) continue
                        if (first === -1) {
                            first = i
                            if (itemsSource.data[i].title !== new_item.title) {
                                itemsSource.data[i].title = new_item.title
                                changed = true
                            }
                        } else {
                            // id должен быть уникален — дубли убираем
                            itemsSource.data.splice(i, 1)
                            i--
                            changed = true
                        }
                    }
                    if (first === -1 && allow_push) {
                        itemsSource.data.push(new_item)
                        changed = true
                    }
                    if (changed) store.get_dataMap(itemsSource, true)
                }

                update_segment(segment, true)

                const seen = new Set([segment])
                let parent_segment = store.itemsSource['SEGMENTS']?.ids?.[segment]?.parent
                while (parent_segment && !seen.has(parent_segment)) {
                    seen.add(parent_segment)
                    update_segment(parent_segment, false)
                    parent_segment = store.itemsSource['SEGMENTS']?.ids?.[parent_segment]?.parent
                }

                // та же запись может лежать в других кэшированных источниках под тем же id
                // (объединения вида SEGMENTS-UNION и т.п.) — обновляем тайтл и там,
                // иначе ячейки/дропдауны этих источников остаются со старым тайтлом
                for (const key of Object.keys(store.itemsSource)) {
                    if (seen.has(key)) continue
                    const src = store.itemsSource[key]
                    if (!src || typeof src !== 'object' || !Array.isArray(src.data)) continue
                    update_segment(key, false)
                }
                return
            }

            function refresh_itemsSource2(segment) {
                if (store.itemsSource[segment]) {
                    // // delete store.itemsSource[segment]
                    // delete store.itemsSource[segment].itemsSource
                    // delete store.itemsSource[segment].dataMap
                    // delete store.itemsSource[segment].ids
                    store.get_itemsSource_bySegment(segment, {fetchMode: 'refresh'})
                }
                
                const parent_segment = store.itemsSource['SEGMENTS']?.ids?.[segment]?.parent
                if (parent_segment) {
                    refresh_itemsSource2(parent_segment)
                }
            }

            refresh_itemsSource2(segment)

            // let itemsSource = store.itemsSource[segment],
            //     find = false
            // if (itemsSource) {
            //     for (let item of itemsSource.data) {
            //         if (item.id === new_item.id) {
            //             item.title = new_item.title
            //             find = true
            //             break
            //         }
            //     }
            //     // if is new 
            //     if (!find) {
            //         itemsSource.data.push(new_item)
            //     }
            //     itemsSource.dataMap = new wjGrid.DataMap(itemsSource.data, 'id', 'title');
            // }
        },
        set_itemsSource_newItem(attr, item) {
            let itemsSource = this.get_itemsSource({}, {}, attr, { fetchMode: 'justGet' })
            if (!itemsSource) return
            if (!itemsSource.data) itemsSource.data = []
            if (!itemsSource.ids)  itemsSource.ids  = {}
            const existing = itemsSource.data.find(i => String(i.id) === String(item.id))
            if (existing) {
                // id уже в кэше — обновляем тайтл вместо добавления дубля
                if (item.title && existing.title !== item.title) {
                    existing.title = item.title
                    this.get_dataMap(itemsSource, true)
                }
                return
            }
            itemsSource.data.push(item)
            itemsSource.ids[item.id] = item
        },
        open_widgetList_forAttr(record_id, attr, action, vueObj, initial_search) {
            const store = this
            const segment = store.get_segment(vueObj.WIDGET, attr)

            // Set CHIP-Search in dataSheet CHIPS, clearing any previous CHIP-Search chips
            const set_search_chips = (WIDGET) => {
                const chips = (store.get_value(WIDGET.record, 'doc.viewParams.dataSheet.CHIPS') || [])
                    .filter(c => c.segment !== 'CHIP-Search')
                if (initial_search) {
                    chips.push({ segment: 'CHIP-Search', title: initial_search, meta: { use: true, pi: 'pi-search' } })
                }
                store.set_value(WIDGET.record, 'doc.viewParams.dataSheet.CHIPS', chips)
            }

            if (initial_search) {
                // Reuse existing widget-list for same segment from same parent
                const WORKSPACE = store.activeWORKSPACE
                if (WORKSPACE) {
                    const PAGE = WORKSPACE.activePAGE
                    const existingWidget = (WORKSPACE.ALL_WIDGETS ?? []).find(w =>
                        w.page === PAGE.page &&
                        w.widget === 'widget-list' &&
                        w.parentWIDGET?.id === vueObj.WIDGET.id &&
                        w.record?.doc?.params?.segment === segment
                    )
                    if (existingWidget) {
                        if (existingWidget?._softClosed) {
                            store._widget_restoreSoftClosed(existingWidget)
                        }

                        set_search_chips(existingWidget)
                        nextTick(() => {
                            for (const id in existingWidget.applys_CHIPS || {}) {
                                existingWidget.applys_CHIPS[id].apply_CHIPS(null, { check_nonEmptyWidget: false })
                            }
                        })

                        store.widget_activate(existingWidget, 'open_widgetList_forAttr::reuse', true, true)
                        return
                    }
                }
            }

            let widget_init = {
                widget: 'widget-list',
                parentAction: action,
                parent_attr: attr,
                props: {},
                fieldsMapping:[
                    { attr:{'binding':'doc.params.segment', 'value':segment} },
                    { attr:{'binding':'doc.params.record_id', 'value':record_id} },
                ],
            }
            if (initial_search) {
                // Callback fires after BE responds, before Vue mounts —
                // AttrGrid reads CHIPS at init and calls apply_CHIPS automatically
                store.widget_open(widget_init, vueObj, (WIDGET) => { set_search_chips(WIDGET) }, { before_setup: true })
            } else {
                store.widget_open(widget_init, vueObj)
            }
        },
        get_segment(WIDGET, attr) {
            let iter = 0
            while (WIDGET?.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 5) {
                const parent = this.findWidget(WIDGET.parentWIDGET.id)
                WIDGET = parent.WIDGET
            }

            if (!attr) {
                return ''
            } else if (attr.attr_col?.itemsSource_source?.is_fieldLink) {
                attr.attr_col.relation_segment = this.get_relation_segment(WIDGET, attr.attr_col)
            } else if (attr.itemsSource_source?.is_fieldLink) {
                attr.relation_segment = this.get_relation_segment(WIDGET, attr)
            }

            if (attr.attr_col && 'relation_segment' in attr.attr_col) {
                return attr.attr_col.relation_segment
            } else if ('relation_segment' in attr) {
                return attr.relation_segment
            }
        },
        get_relation_segment(WIDGET, attr) {
            let record = WIDGET.record;
            let itemsSourceParams = {};
        
            let itemsSourceSource = attr.itemsSource_source || {};
            let segmentBinding = itemsSourceSource.segment_binding || '';
            let sourceBinding = segmentBinding.replace('segment', '');
        
            if (segmentBinding) {
                let segment = this.get_value(record, segmentBinding);
                if (segment) {
                    itemsSourceParams.segment = segment;
        
                    let gridBinding = itemsSourceSource.grid_binding;
                    if (!gridBinding) {
                        let gridBindingBinding = itemsSourceSource.grid_binding_binding;
                        gridBinding = gridBindingBinding ? this.get_value(record, gridBindingBinding) : '';
                        gridBinding = getValueAttrMulti(WIDGET, gridBinding); // TODO
                    }
        
                    if (gridBinding) {
                        itemsSourceParams.grid_binding = gridBinding;
                    }
        
                    // Перебираем нужные параметры и добавляем в itemsSourceParams
                    ['header_included', 'is_fieldLink', 'hierarchy', 'include', 'itemsSource_leftValue'].forEach(param => {
                        let value = param === 'header_included' 
                            ? this.get_value(record, sourceBinding + param) 
                            : itemsSourceSource[param];
                        
                        if (value) {
                            itemsSourceParams[param] = value;
                        }
                    });
                }
            }
        
            return JSON.stringify(itemsSourceParams);
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-17 activateVisible — активировать первый виджет страницы, попавший в кадр (карточка пересекает окно
        // под топбаром; DOM-порядок = порядок ленты). Дебаунс на серию ответов виджетов; если активный уже в кадре или
        // пользователь после нашей авто-активации выбрал другой виджет — не трогаем
        mobileActivateVisible_schedule(WIDGET) {
            const store = this
            clearTimeout(store._mobActVisTimer)
            store._mobActVisTimer = setTimeout(() => {
                store._mobActVisTimer = null
                try { store.mobileActivateVisible(WIDGET) } catch (e) { console.warn('activateVisible', e) }
            }, 120)
        },
        mobileActivateVisible(WIDGET) {
            const store = this
            if (!store.mobileUi?.on) return
            const ws = WIDGET?.workspace, pg = WIDGET?.page
            if (!ws || !pg || store.activeWORKSPACE?.workspace !== ws || store.activeWORKSPACE?.active_page !== pg) return
            const key = ws + '/' + pg
            const tb = (document.querySelector('.topbar') || document.querySelector('.layout-topbar'))?.getBoundingClientRect().bottom || 0
            const inView = (el) => { const r = el?.getBoundingClientRect(); return !!r && r.height > 0 && r.bottom > tb && r.top < window.innerHeight }
            const act = store.activeWIDGET
            if (act && !act.close && !act._softClosed && act.workspace === ws && act.page === pg) {
                if (inView(document.getElementById('WIDGET' + act.id))) return // активный уже в кадре
                const auto = store._mobActVis
                if (auto && auto.key === key && auto.id !== act.id) return // пользователь выбрал сам — не перебивать
            }
            const all = store.WORKSPACES[ws]?.ALL_WIDGETS ?? []
            let target = null
            for (const el of document.querySelectorAll('.main-area > .WIDGET')) {
                if (!inView(el)) continue
                const id = parseInt(String(el.id).replace('WIDGET', ''), 10)
                const W = all.find(w => w.id === id && w.page === pg && !w.close && !w._softClosed)
                if (W) { target = W; break }
            }
            if (!target) target = WIDGET
            if (!target || target.close || target._softClosed) return
            store._mobActVis = { key, id: target.id }
            if (store.activeWIDGET !== target) store.widget_activate(target, 'mobileActivateVisible', true, false)
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-05 / P-12 pageSwitchYield — состояние загрузки плитки страницы (класс page-loading у плитки,
        // body.mob-page-loading — полоса под топбаром); снимается в workspace_activate новой страницы, страховка 15 с
        mobilePageLoading_set(workspace, page) {
            const store = this
            clearTimeout(store._mobPageLoadingTimer)
            store._mobPageLoading = { workspace, page }
            document.body.classList.add('mob-page-loading')
            store._mobPageLoadingTimer = setTimeout(() => store.mobilePageLoading_clear(), 15000)
        },
        mobilePageLoading_clear() {
            const store = this
            clearTimeout(store._mobPageLoadingTimer); store._mobPageLoadingTimer = null
            if (store._mobPageLoading) store._mobPageLoading = null
            document.body.classList.remove('mob-page-loading')
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-08 menuExclusive — открытие одного навигационного меню закрывает остальные (рейл страниц,
        // список виджетов, «⋮», гамбургер). runtime-флаги moreOpen/sidebarOpen зеркалят AppTopbar.mobileMenu / App.mobileMenuActive.
        // Выкл: window.mobileUi.set('menuExclusive', false)
        mobileMenus_closeOthers(keep) {
            const m = this.mobileUi
            if (!m?.on || m.menuExclusive === false) return
            if (keep !== 'rail' && m.railOpen) m.railOpen = false
            if (keep !== 'widgets' && m.widgetsOpen) m.widgetsOpen = false
            if (keep !== 'more' && m.moreOpen) m.moreOpen = false
            if (keep !== 'sidebar' && m.sidebarOpen) m.sidebarOpen = false
        },
        scrollInWorkspace(WIDGET) {
            const store = this
            // const WidgetContainer = $('#WIDGET'+WIDGET.id)[0]
            // const active_WidgetRect = WidgetContainer.getBoundingClientRect()

            if (WIDGET.styleWidget.dock !== 'popout') {
                WIDGET.styleWidget.dock = 'dock'
            }
            WIDGET.styleWidget.setVisible = true
            
            const PAGE = store.WORKSPACES[WIDGET.workspace].PAGES[WIDGET.page]
            PAGE.mainArea?.vueObj.setStyle()
    
            // // if (WidgetContainer) {
            // //     WidgetContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
            // // }

            // const AppTopBar = $('.topbar')[0].getBoundingClientRect() // $('#AppTopBar')
            // const pageYOffset = window.scrollY

            // if (active_WidgetRect.top < AppTopBar.bottom) {
            //     // scroll up
            //     window.scrollTo({
            //         top: pageYOffset - (AppTopBar.bottom - active_WidgetRect.top),
            //         left: 0,
            //         behavior: 'smooth'
            //     })
            // } else if (window.innerHeight < active_WidgetRect.bottom) {
            //     let min_height = 200,
            //     bottom = active_WidgetRect.bottom
            //     if (active_WidgetRect.bottom - active_WidgetRect.top < min_height) {
            //         bottom += min_height
            //     }
            //     // scroll down
            //     window.scrollTo({
            //         top: pageYOffset + (bottom - window.innerHeight),
            //         left: 0,
            //         behavior: 'smooth'
            //     })
            // }
        },
        title_toUpperCase(str) {
            if (!str) return str;
            return str[0].toUpperCase() + str.slice(1);
        },
        createElementFromHTML(htmlString) {
            var div = document.createElement('div');
            div.innerHTML = htmlString.trim();

            // Change this to div.childNodes to support multiple top-level nodes.
            return div.firstChild;
        },
        deepCopyWithoutKeys(obj, excludedKeys = []) {
            if (Array.isArray(obj)) {
                return obj.map(item => this.deepCopyWithoutKeys(item, excludedKeys));
            }
        
            if (obj !== null && typeof obj === 'object') {
                const result = {};
                for (const key in obj) {
                    if (excludedKeys.includes(key)) continue;
        
                    result[key] = this.deepCopyWithoutKeys(obj[key], excludedKeys);
                }
                return result;
            }
        
            return obj;
        },
        remove_keys_in_place(obj, keysToRemove, level=0) {
            if (Array.isArray(obj)) {
                if (obj.length) {
                    obj.forEach(item => this.remove_keys_in_place(item, keysToRemove, level+1))
                }
            } else if (obj !== null && typeof obj === 'object') {
                for (const key in obj) {
                    if (keysToRemove.includes(key) && level > 0) {
                        delete obj[key];
                    } else {
                        this.remove_keys_in_place(obj[key], keysToRemove, level+1);
                    }
                }
            }
        },
        get_record_to_transfer(vueObj, record, action) {
            let record_to_transfer;
            if (action.record_sendToBackend_exclude || action.record_stayOnFront) {
                record_to_transfer = {}
                for (let key in record) {
                    if (action.record_stayOnFront?.includes(key)) {
                        doc_stayOnFront[key] = record[key]
                    } else if (action.record_sendToBackend_exclude?.includes(key)) {
                        // pass
                    } else {
                        record_to_transfer[key] = record[key]
                    }
                }
                if (action.record_sendToBackend_exclude?.includes('not _meta.modified data.row')) {
                    // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P3: record_to_transfer._doc — ТОТ ЖЕ объект, что record._doc (копия записи выше поверхностная), и присваивание data ниже
                    // подменяло ЖИВЫЕ данные отчёта массивом «только изменённые строки»; дельта-ответ бэка (gridSaved) данных не возвращает, а опрос каскада (updateDoc → content_Changed) во время save
                    // перестраивал грид из этого огрызка — пустая таблица, свёрнутые группы. Save с правкой флажка согласования (после него идёт select) отправляет копию _doc — живые данные целы.
                    // Выключатели: fe.ux.approval, fe.ux.approvalRefreshAfterSave; остальные save — как были
                    if (action.method === 'save' && this.setting('fe.ux.approval', true) !== false && this.setting('fe.ux.approvalRefreshAfterSave', true) !== false
                            && approval_flagEdited(approval_doc(vueObj?.WIDGET?.record?.doc), vueObj?.get_vueObj?.(action.source_name || action.binding)?.undoStack)) {
                        record_to_transfer._doc = { ...record_to_transfer._doc }
                    }
                    record_to_transfer._doc.data = record_to_transfer._doc.data.filter(row => row._meta?.modified)
                 
                    let attr_vueObj = vueObj.get_vueObj(action.source_name || action.binding)
                    for (let record of attr_vueObj.deletedItems) {
                        if (record.id) {
                            record_to_transfer._doc.data.push(record)
                        }
                    }
                    // IE 2026 10 06 / ODOO-341407 (R3 §4.4, DESIGN §3.4 п.5): строка предопределённой записи под uk / ru несёт словарный meta.title_<L> с пометкой
                    // meta._i18n_auto (бэк localize_record_meta) — update_data бэка заменяет meta целиком, и словарь лёг бы в базу как ручной перевод.
                    // В запрос — копии строк без неправленых словарных ключей и без пометки (правка снимает пометку: i18n_autoUnmark); строки в памяти
                    // не меняются. Есть что снимать — свой _doc у копии записи; нечего — как было
                    const _sent = record_to_transfer._doc.data, _clean = _sent.map(row => i18nFields_stripAutoForSave(row))
                    if (_clean.some((row, i) => row !== _sent[i])) record_to_transfer._doc = { ...record_to_transfer._doc, data: _clean }
                }
            } else {
                record_to_transfer = record
            }

            // реестр _doc.itemsSourcesView не отправляется даже без exclude ['_doc']
            record_to_transfer = this.exclude_itemsSourcesView(record_to_transfer)

            this.remove_keys_in_place(record_to_transfer, ['_widget', '_quantity_map', '_fe']) // , '_meta' LOOK , _meta.iroot, modified

            return record_to_transfer
        },
        // IE 2026 09 04 / ODOO-336331 (заказ Игоря): переключатель механизма вариантов настроек (правило 8:
        // дефолт ВКЛ; выключение — клиентское, через localStorage; бэк получает variants_off в каждом запросе).
        // Консоль: window.settingsVariants.get() / .set(false) / .reset()
        settingsVariants_off() {
            try { return localStorage.getItem('settings_variants_off') === '1' } catch (e) { return false }
        },
        settingsVariants_console() {
            if (typeof window === 'undefined' || window.settingsVariants) return
            const store = this
            window.settingsVariants = {
                get: () => !store.settingsVariants_off(),
                set: (on) => { try { if (on === false) localStorage.setItem('settings_variants_off', '1'); else localStorage.removeItem('settings_variants_off') } catch (e) { /* хранилище недоступно */ } return !store.settingsVariants_off() },
                reset: () => { try { localStorage.removeItem('settings_variants_off') } catch (e) { /* хранилище недоступно */ } return true },
            }
        },
        // IE 2026 09 04 / ODOO-336379 (Игорь: M03, вставка 12 ячеек — до 30 с на слабых машинах): флаги
        // производительности грида живут в ОБЩЕМ хранилище perf-flags (правило 8 — одно место: window.perf,
        // localStorage 'perf-flags', URL ?perf-<флаг>=false); window.gridPerf — срез по гриду + замеры вставки
        // (AttrGrid.pasteBatch_* / gridPerf_touch). Дефолты ВКЛ. Флаги: paste_batch — вставка одним батчем;
        // css_invalidate_scoped — py-CSS пересчитывается только у изменённых строк; css_memo_rowsig — мемо get_cssClass
        // по хэшу строки; frozen_clip_batch — одна rAF на волну для фиксированных ячеек; css_py_raw — сырой объект
        // строки в python (все — AttrGrid, блок «волны py-CSS»). Консоль: window.gridPerf.get() / .set('paste_batch', false)
        // / .reset() / .stats(n) — последние n вставок с раскладкой времени / .css(n) — последние волны py-CSS / .clear()
        gridPerf_on(name, WIDGET = null) {
            return this.perf_flag_widget(WIDGET, name, true)
        },
        // IE 2026 09 05 / ODOO-336379 (заказ Игоря): выключатели фронтовых доработок НА УРОВНЕ ЗАПИСИ отчёта —
        // настройки виджета → Params → Frontend (doc.params.fe_*_off, AttrBool). Галочка в записи имеет приоритет над
        // глобальными perf-флагами (localStorage/URL): пусто = по флагам (дефолт ВКЛ). Один параметр гасит группу флагов.
        perf_flag_widget(WIDGET, name, def_ = true) {
            const params = WIDGET?.record?.doc?.params
            if (params) {
                const param = FE_OFF_BY_FLAG[name]
                if (param && params[param]) return false
            }
            return this.perf_flag(name, def_)
        },
        FE_OFF_PARAMS() { return FE_OFF_PARAMS }, // для консоли/скриптов: window.gridPerf.recordParams()
        // IE 2026 09 26 / ODOO-5800 (замер ie-bio7 #45023: Гант движений рисует ~42 % строк ответа, ответ по всей витрине роняет вкладку): попросить бэк
        // оставить в ответе select списка только строки, которые рисует вкладка Gantt of movements (бэк: common_modules/gantt_moves.py — остаются и строки,
        // от которых зависят порядок в месяце и подсветка связей, картинка та же). Просим, пока открыта вкладка Ганта главной панели: при widget_open —
        // по selectTab / вкладке раскладки (пусто — решает вкладка записи на бэке), дальше — по живой панели вкладок; переход на другую вкладку
        // (таблица, чарт, настройки…) перечитывает полные строки (AttrTabPanel.selectedIndexChanged, признак record._doc.gantt_rows_only).
        // Выключатель fe.gantt.serverFilter (feSettings.set('fe.gantt.serverFilter', false) или ?fe.gantt.serverFilter=false), дефолт ВКЛ;
        // бэк без этой доработки ключ запроса не знает и отдаёт все строки — Гант отбирает их сам, как раньше
        ganttMoves_requestParams(WIDGET, method) {
            try {
                if (method && method !== 'select') return {}
                if (this.setting('fe.gantt.serverFilter', true) === false) return {}
                const TAB = 'tabGanttMoves'
                const tp = (Array.isArray(WIDGET?.view) ? WIDGET.view : []).find(a => a?.attr_type === 'AttrTabPanel')
                const vo = tp?.id != null ? WIDGET?.attrs_vueObj?.[tp.id] : null
                if (vo?.tabPanel) {
                    const cur = (vo.tabAttrs || [])[vo.tabPanel.selectedIndex]?.name
                    return cur === TAB ? { gantt_moves: this.ganttMoves_ask(cur) } : {}
                }
                if (tp) return {}   // панель вкладок пришла, но не смонтирована — открытая вкладка неизвестна
                const tab = WIDGET?.selectTab || WIDGET?.layoutTab || ''
                return tab && tab !== TAB ? {} : { gantt_moves: this.ganttMoves_ask(tab) }
            } catch (e) { return {} }
        },
        // IE 2026 09 27 / ODOO-5800 (сигнал ie-webscm7 #46807: страница 1EiJ_001 DM без чипса Object — Гант движений тянет всю сеть, 42,8 МБ / 238 МБ JSON, страница
        // замирает ≈40 с у каждого пользователя): ключ gantt_moves запроса select — + потолок строк бэка (common_modules/gantt_moves.py, секция cap): бэк читает
        // не больше max+1 строк, при превышении строк не отдаёт, а кладёт признак record._doc.gantt_cap {rows, max, text}; Гант рисует плашку «выберите объект»
        // (fe.gantt.capNotice, AttrGanttMoves.capInfo) и перечитывается по чипсу (fe.gantt.followChips). Клиентские выключатели (feSettings / ?fe.…=… в URL), дефолты ВКЛ:
        //   fe.gantt.cap = false      → 'not-gantt_moves_cap': бэк без потолка (все строки, как до 27.09);
        //   fe.gantt.capMax = N       → max: N — свой потолок этого клиента (A/B, 0 = без лимита); без него бэк берёт параметр gantt_moves_max (виджет ← стол) или свой дефолт;
        //   fe.gantt.capNotice = false → плашки нет (пустой Гант + предупреждение виджета от бэка, как у старого фронта); cap_notice в запросе = плашку рисуем сами
        ganttMoves_ask(tab) {
            const o = { rows_only: true, tab }
            try {
                if (this.setting('fe.gantt.cap', true) === false) o['not-gantt_moves_cap'] = true
                const mx = this.setting('fe.gantt.capMax', '')
                if (mx !== '' && mx !== null && mx !== undefined && Number.isFinite(Number(mx)) && Number(mx) >= 0) o.max = Math.floor(Number(mx))
                if (this.setting('fe.gantt.capNotice', true) !== false) o.cap_notice = true
            } catch (e) { /* ключ без выключателей */ }
            return o
        },
        // IE 2026 09 26 / ODOO-5800 (ie-demo7, страница «Purchase balance + graph»: флажок Object в ⌄ — Гант движений остаётся на всей сети, снятие чипса —
        // остаётся на объекте; с чипсом Гант виден только после F5): Гант движений — движения ОТБОРА, его строки бэк режет чипсами стола при каждом запросе
        // (строка WHERE «id in selector calc» виджета), а перечитывание при смене чипсов (updateRelatedWidgets) шло только участникам Selector get
        // (selection_fields / «Refresh by selectors») — у виджетов Ганта (копии списка оборотов bNH_001) он выключен. Список с включённой вкладкой
        // «Gantt of movements» (viewParams.tabGanttMoves.use — тот же признак, что у бэка gantt_moves.wanted) перечитывается при смене чипсов стола
        // как участник: select везёт отбор строк под Гант (ganttMoves_requestParams, fe.gantt.serverFilter), скрытая неоткрытая вкладка соберёт модель
        // из новых строк при показе (fe.ux.tabsLazyHidden). Выключатель fe.gantt.followChips (feSettings.set('fe.gantt.followChips', false) или
        // ?fe.gantt.followChips=false), дефолт ВКЛ
        ganttMoves_followsChips(WIDGET) {
            try {
                if (WIDGET?.record?.doc?.viewParams?.tabGanttMoves?.use !== true) return false
                return this.setting('fe.gantt.followChips', true) !== false
            } catch (e) { return false }
        },
        // IE 2026 09 27 / ODOO-5800 (ie-dm-app7 #47092, бой DM после doc.limit = 20000 у 585_001-gantt-moves*): без чипса Гант показывает плашку потолка,
        // клик «List» перечитывает строки без признака Ганта (AttrTabPanel, b7b215927) — 20 000 из 341 885 (record.doc._limit_truncated), а возврат на вкладку
        // Ганта запроса не делал: Гант молча рисовал частичную выборку списка (5 447 полос) — ровно то, от чего защищает потолок. Показ вкладки Ганта главной
        // панели (AttrTabPanel.selectedIndexChanged): строки пришли НЕ запросом Ганта (нет признаков ответа Ганта — record._doc.gantt_rows_only / gantt_cap,
        // бэк common_modules/gantt_moves.py apply / cap_mark; ответ select заменяет запись целиком, признаки прежнего ответа не переживают) и выборка неполная
        // (utils/listLimit: _limit_truncated бэка, у прежнего — doc.limit и _limit_total_count) → true: перечитать запросом Ганта (select с gantt_moves, как по
        // чипсу) — бэк вернёт плашку потолка или строки Ганта. Выборка полная (с чипсом Object) — false, Гант рисует её как есть, без запроса. Тоже false:
        // запрос Ганта не отличался бы от прошлого (fe.gantt.serverFilter = false) и этот же срез уже перечитан запросом Ганта, а бэк признаков не дал (бэк без
        // отбора / отбор отказан) — иначе лишний select на каждый показ; метка среза снимается, когда главная панель уходит с Ганта на строках Ганта (AttrTabPanel).
        // Быстрый возврат: перечитывание «List» ещё в пути (WIDGET._ganttListRead — запись, на которой его послали) — true: его поздний ответ Гант нарисовал бы
        // молча, запрос Ганта его заменяет (executeWidgetMethod обрывает незавершённый запрос виджета). Метки запросов — на WIDGET (на бэк не уходят), «в пути»,
        // пока запись не заменена ответом. Выключатель fe.gantt.rereadAfterTruncatedList (feSettings.set('fe.gantt.rereadAfterTruncatedList', false) или
        // ?fe.gantt.rereadAfterTruncatedList=false), дефолт ВКЛ; выкл — прежнее: Гант рисует строки списка
        ganttMoves_rereadOnShow(WIDGET) {
            try {
                if (this.setting('fe.gantt.rereadAfterTruncatedList', true) === false) return false
                const rec = WIDGET?.record, _doc = rec?._doc
                if (!rec || !this.ganttMoves_requestParams(WIDGET, 'select').gantt_moves) return false   // запрос ушёл бы без gantt_moves — тот же ответ
                if (WIDGET._ganttListRead === rec) return true   // перечитывание «List» ещё в пути — заменить запросом Ганта
                if (!_doc || typeof _doc !== 'object' || _doc.gantt_rows_only || _doc.gantt_cap) return false   // строки — ответ запроса Ганта
                const info = listLimitInfo(rec)
                if (!info) return false   // выборка полная — рисовать как есть
                const sig = listLimitSig(info)
                if (WIDGET._ganttRereadSig === sig && WIDGET._ganttReread !== rec) return false   // срез уже перечитан Гантом, ответ пришёл без признаков; запись та же — ответа не было, повтор
                WIDGET._ganttRereadSig = sig
                return true
            } catch (e) { return false }
        },
        // IE 2026 09 27 / ODOO-5800: перечитывание запросом Ганта (ganttMoves_rereadOnShow) в пути — запись виджета ещё та, на которой его послали; Гант до ответа
        // модель из строк списка не строит (AttrGanttMoves.rereadPending), уход с Ганта на другую вкладку заменяет его запросом полных строк (AttrTabPanel)
        ganttMoves_rereadPending(WIDGET) {
            return !!WIDGET?.record && WIDGET._ganttReread === WIDGET.record
        },
        // IE 2026 09 04 / ODOO-336283 (Игорь: полоса Ex-Distr — до следующей полосы): флаг dl2_band_span в том же
        // хранилище perf-flags; бэк (data_layout2.create_childs) получает выключатель В ЗАПРОСЕ — переключение целиком
        // клиентское, без рестарта (правило 8). Дефолт ВКЛ: window.gridPerf.set('dl2_band_span', false) + обновить виджет
        dl2_requestParams() {
            const out = this.perf_flag('dl2_band_span', true) ? {} : { dl2_band_span_off: true }
            // IE 2026 09 18 / ODOO-5800 (Igor: скорость Purchase Balance): выключатели оптимизаций раскладки DL2 — в том же
            // хранилище perf-flags, бэк получает их В ЗАПРОСЕ (правило 8, дефолт ВКЛ): скомпилированный WHERE уровней
            // (dl2_where_compiled), предфильтр отбора узла до группировки (dl2_prefilter), исправленный in-memory like
            // (dl2_like_fix). Консоль: window.gridPerf.set('dl2_prefilter', false) + обновить виджет
            if (!this.perf_flag('dl2_where_compiled', true)) out.dl2_where_compiled_off = true
            if (!this.perf_flag('dl2_prefilter', true)) out.dl2_prefilter_off = true
            if (!this.perf_flag('dl2_like_fix', true)) out.dl2_like_fix_off = true
            // IE 2026 09 18 / ODOO-5800: поля выключенных групп опций вне SELECT источников (dl2_og_fields), построчная копия
            // сырых строк источника для кэша реюза (dl2_src_copy_fast) — be-ie a8cd41233
            if (!this.perf_flag('dl2_og_fields', true)) out.dl2_og_fields_off = true
            if (!this.perf_flag('dl2_src_copy_fast', true)) out.dl2_src_copy_fast_off = true
            // IE 2026 09 18 / ODOO-5800 (Igor «делай», предложение ie-rust7): пустой ключ группы DL2 в один вид — значение '' → None,
            // адрес пустой части ключа «!set» (be-ie ie-dm7/empty-key-norm, правила dl2rs v3). Дефолт ВКЛ
            if (!this.perf_flag('dl2_empty_key_norm', true)) out.dl2_empty_key_norm_off = true
            // IE 2026 09 30 / ODOO-343432: выключатель кэша чисел What-if Scorecard (бэк pm_scorecard.aggregates; window.scorecard.set(false)), дефолт ВКЛ
            if (!this.perf_flag('scorecard_cache', true)) out.scorecard_cache_off = true
            return out
        },
        gridPerf_push(rec) {
            const list = (this._gridPerfStats = this._gridPerfStats || [])
            list.push(rec)
            if (list.length > 200) list.splice(0, list.length - 200)
        },
        gridPerf_cssPush(rec) { // IE 2026 09 04 / ODOO-336379: паспорт волны py-CSS (AttrGrid.cssWave_end)
            const list = (this._gridPerfCssStats = this._gridPerfCssStats || [])
            list.push(rec)
            if (list.length > 200) list.splice(0, list.length - 200)
        },
        // IE 2026 09 04 / ODOO-335315 (Игорь: флажок МД в M03 «сам снимается» молча): выключатель
        // уведомлений об отклонённой правке грида — в том же хранилище perf-flags (правило 8: одно
        // место, без рестарта). Дефолт ВКЛ. Консоль: window.rejectNotify.get() / .set(false) / .reset();
        // URL: ?perf-reject_notify=false
        rejectNotify_on() {
            return this.perf_flag('reject_notify', true)
        },
        dl2Engine_console() { // IE 2026 09 04 / ODOO-336658: window.dl2Engine.get()/set()/reset()
            if (typeof window === 'undefined' || window.dl2Engine) return
            const store = this
            const save = () => { try { localStorage.setItem('dl2Engine', JSON.stringify(store.dl2Engine)) } catch (e) { /* хранилище недоступно — флаг живёт до перезагрузки */ } }
            window.dl2Engine = {
                get: (k) => (k ? store.dl2Engine[k] : { ...store.dl2Engine }),
                set: (k, v) => { store.dl2Engine[k] = (typeof v === 'boolean') ? v : v !== 'false' && v !== '0' && !!v; save(); return { ...store.dl2Engine } },
                reset: () => { store.dl2Engine.rust = true; store.dl2Engine.parallelSelect = true; store.dl2Engine.strict = false; store.dl2Engine.pgJitOff = true; store.dl2Engine.qfView = true; store.dl2Engine.pyParallel = true; store.dl2Engine.slimSelect = true; /* IE 2026 09 05 / ODOO-336658 */ delete store.dl2Engine.metricData; /* IE 2026 09 20 / ODOO-5800: флаг запроса опции «Metric data in cells» — по записи отчёта */ try { localStorage.removeItem('dl2Engine') } catch (e) { /* хранилище недоступно */ } return { ...store.dl2Engine } },
            }
        },
        // IE 2026 09 05 / ODOO-336379 (план ускорения M03, шаг 4): «дельта после save» — бэк не гоняет полный
        // re-select после записи ячеек отчёта. Тот же perf-flags (правило 8: дефолт ВКЛ, без рестарта):
        // window.saveDelta.get() / .set(false) / .reset(); URL ?perf-save_delta=false. Бэк получает
        // report_save_delta_off в запросе save и отвечает как раньше (полный select).
        saveDelta_console() {
            if (typeof window === 'undefined' || window.saveDelta) return
            const store = this
            window.saveDelta = {
                get: () => store.perf_flag('save_delta', true),
                set: (on) => { window.perf?.set('save_delta', on !== false); return store.perf_flag('save_delta', true) },
                reset: () => {
                    delete store._perfFlags.save_delta
                    try { localStorage.setItem('perf-flags', JSON.stringify(store._perfFlags)) } catch (e) { /* хранилище недоступно */ }
                    return store.perf_flag('save_delta', true)
                },
            }
        },
        rejectNotify_console() {
            if (typeof window === 'undefined' || window.rejectNotify) return
            const store = this
            window.rejectNotify = {
                get: () => store.perf_flag('reject_notify', true),
                set: (on) => { window.perf?.set('reject_notify', on !== false); return store.perf_flag('reject_notify', true) },
                reset: () => {
                    delete store._perfFlags.reject_notify
                    try { localStorage.setItem('perf-flags', JSON.stringify(store._perfFlags)) } catch (e) { /* хранилище недоступно */ }
                    return store.perf_flag('reject_notify', true)
                },
            }
        },
        gridPerf_rejectPush(rec) { // IE 2026 09 04 / ODOO-336379: паспорт отклонённой правки (AttrGrid.readOnly_rejectFlush)
            const list = (this._gridPerfRejectStats = this._gridPerfRejectStats || [])
            list.push(rec)
            if (list.length > 200) list.splice(0, list.length - 200)
        },
        gridPerf_warmPush(rec) { // IE 2026 09 05 / ODOO-336379: паспорт прогрева brand-прохода в idle (AttrGrid.pyWarm_run)
            const list = (this._gridPerfWarmStats = this._gridPerfWarmStats || [])
            list.push(rec)
            if (list.length > 200) list.splice(0, list.length - 200)
        },
        gridPerf_pyPush(rec) { // IE 2026 09 05 / ODOO-336379: паспорт пакета python-пересчёта в воркерах (AttrGrid.pyRecalc_batch)
            const list = (this._gridPerfPyStats = this._gridPerfPyStats || [])
            list.push(rec)
            if (list.length > 200) list.splice(0, list.length - 200)
        },
        pyWorkerPool() {
            // IE 2026 09 05 / ODOO-336379: единственный на приложение пул Web Worker'ов с pyodide (модули отчётов грузятся
            // в воркеры по требованию, кэш по сигнатуре кода); размер = min(hardwareConcurrency - 1, 4), не меньше 1.
            // Создаётся лениво при первом прогреве грида с python-кодом M03 (AttrGrid.pyWorker_warm)
            if (this._pyWorkerPool) return this._pyWorkerPool
            if (typeof Worker === 'undefined' || typeof window === 'undefined') return null
            const store = this
            let utilsUrl = ''
            try { utilsUrl = new URL(`${process.env.BASE_URL || '/'}py/utils.py`, window.location.href).href } catch (e) { utilsUrl = '' }
            this._pyWorkerPool = new PyWorkerPool({
                size: pyWorker_poolSize(),
                utilsText: store.utilsPyText || '',
                utilsUrl,
                log: (s) => console.log(s),
                onErr: (s) => store.show_notification({ text: s, status: 'error' }),
            })
            return this._pyWorkerPool
        },
        gridPerf_console() {
            if (typeof window === 'undefined' || window.gridPerf) return
            const store = this, FLAGS = ['paste_batch', 'css_invalidate_scoped', 'css_memo_rowsig', 'frozen_clip_batch', 'css_py_raw', 'css_py_batch', /* css_py_batch — волна py-CSS пачками одним python-вызовом (IE 2026 09 05 / ODOO-336379) */ 'dl2_band_span', 'dl2_tabheader_merge' /* IE 2026 09 05 / ODOO-336283 */, 'afterEdit_scope_sku', 'afterEdit_scope_warm', 'afterEdit_scope_multi', 'afterEdit_warm_idle', 'afterEdit_warm_main' /* multi-SKU scope + idle warm-up (worker; main — дефолт выкл) (IE 2026 09 05 / ODOO-336379) */, 'save_delta', 'response_gzip' /* шаг 4: дельта после save и gzip ответов (IE 2026 09 05 / ODOO-336379) */, 'page_activate_selector_refresh' /* обновление участников селекторов при возврате на страницу (IE 2026 09 07 / ODOO-4997) */, 'dropdown_bool' /* dropdown на чекбокс-ячейках: история правки и оформление (IE 2026 09 07 / ODOO-5512) */, 'reject_in_beginning_edit', 'reject_flash_direct', 'py_worker', 'py_worker_pool', 'py_worker_reaggr', 'py_worker_json' /* py_worker* — python-пересчёт после правки в Web Worker / пул воркеров; py_worker_json — JSON вместо structured clone, только замер, дефолт ВЫКЛ (IE 2026 09 05 / ODOO-336379) */] // reject_* — отказ до редактора и флеш без перерисовки (IE 2026 09 04 / ODOO-336379) // IE 2026 09 04 / ODOO-336379; dl2_band_span — IE 2026 09 04 / ODOO-336283; afterEdit_scope_* — python-пересчёт только правленого SKU (IE 2026 09 04 / ODOO-336379)
            const DEF = (f) => !['py_worker_json', 'afterEdit_warm_main'].includes(f) // IE 2026 09 05 / ODOO-336379: флаги с дефолтом ВЫКЛ (режим замера; прогрев на главном потоке)
            const get = (k) => k ? store.perf_flag(k, DEF(k)) : Object.fromEntries(FLAGS.map(f => [f, store.perf_flag(f, DEF(f))]))
            window.gridPerf = {
                flags: FLAGS,
                get,
                set: (k, on) => { window.perf?.set(k, on !== false); return get() },
                reset: () => {
                    for (const f of FLAGS) delete store._perfFlags[f]
                    try { localStorage.setItem('perf-flags', JSON.stringify(store._perfFlags)) } catch (e) { /* хранилище недоступно */ }
                    return get()
                },
                stats: (n) => (store._gridPerfStats || []).slice(-(n || 20)),
                css: (n) => (store._gridPerfCssStats || []).slice(-(n || 20)), // IE 2026 09 04 / ODOO-336379: последние волны py-CSS
                rejects: (n) => (store._gridPerfRejectStats || []).slice(-(n || 20)), // IE 2026 09 04 / ODOO-336379: отклонённые правки (path/flash/agg ms)
                warm: (n) => (store._gridPerfWarmStats || []).slice(-(n || 20)), // IE 2026 09 05 / ODOO-336379: прогревы brand-прохода в idle
                py: (n) => (store._gridPerfPyStats || []).slice(-(n || 20)),
                recordParams: () => FE_OFF_PARAMS, // IE 2026 09 05 / ODOO-336379: какие флаги гасит каждый выключатель записи (Params → Frontend) // IE 2026 09 05 / ODOO-336379: пакеты python-пересчёта в воркерах (worker/transfer/compute/apply ms)
                workers: () => (store._pyWorkerPool ? store._pyWorkerPool.info() : null), // IE 2026 09 05 / ODOO-336379: состояние пула воркеров pyodide
                clear: () => { for (const k of ['_gridPerfStats', '_gridPerfCssStats', '_gridPerfWarmStats', '_gridPerfPyStats']) if (store[k]) store[k].length = 0; return [] }, // IE 2026 09 05 / ODOO-336379
            }
        },
        get_widget_to_transfer(vueObj, action) {
            const store = this, WIDGET = vueObj.WIDGET
            const widget_to_transfer = {
                title: WIDGET.title,
                id: WIDGET.id,
                executeWidgetMethod_id: WIDGET.executeWidgetMethod_id,
                widget: WIDGET.widget,
                widget_class: WIDGET.widget_class,
                parentWIDGET: WIDGET.parentWIDGET,
                variant_explicit: WIDGET.variant_explicit || undefined, // IE 2026 09 04 / ODOO-336331: явный выбор из дерева — без подмены на основной вариант
                settings_main: WIDGET.settings_main || undefined, // IE 2026 10 08 / ODOO-5800: запись открыта подменой основной — после save бэк сохраняет панели её основную
                // fieldsMapping: WIDGET.fieldsMapping, CHECK is need to saveRecord()?
            }
            // IE 2026 09 28 / ODOO-5800: форма настроек по требованию — у фронта каркас (заглушки вкладок): бэк при пересборке вида строит каркас;
            // форма загружена — полную (reload после загрузки сразу несёт полную форму)
            {
                const _sflN = sfl_stubs(WIDGET).length
                if (_sflN || settingsFormLazy_on(store)) widget_to_transfer.settings_form_lazy = _sflN > 0
            }
            // ИЕ 2026 08 13: у тяжёлых отчётов view — мегабайты (D&S Balance: 4-19 МБ),
            // а save/поллинги на бэке его не читают (проверено по widgets.py: save и
            // poll_cell_edits — ноль обращений, select_report_audit — закомментировано).
            // Не возим: save группы с дневной зоной рвался по размеру запроса.
            const _noViewMethods = new Set(['save', 'poll_cell_edits', 'select_report_audit'])
            // IE 2026 09 05 / ODOO-336658 (заказ Игоря): select отчёта (Update data) без view — вид с колонками весит 4–5 МБ
            // (Purchase Ukraine · Tab col: 4,5 из 4,8 МБ запроса, 0,8 с отправки); бэк на select без view строит его сам
            // (widget_REPORT2._select_impl: set_view → set_menu) и присылает изменившиеся ветки view_patch. Флаг store.dl2Engine.slimSelect
            // (дефолт ВКЛ; window.dl2Engine.set('slimSelect', false) — прежнее поведение); бэку уходит признак view_on_frontend.
            const _slimSelect = action.method === 'select' && WIDGET.widget_class === 'widget_REPORT2' && store.dl2Engine?.slimSelect !== false
            // IE 2026 09 20 / ODOO-5800 (приёмка этапа 3 ie-dm7: флаг чипса оформления там, где оформляет бэк; облегчённый cf_stats; названия метрик правил):
            // статистика правил оформления (метод cf_stats, отчёты и списки) на бэке живёт без вида — замер ie-dm7: запрос отчёта 4,79 → 0,73 МБ, списка
            // 2,33 → 0,27 МБ, ответы совпали. Выключатель fe.data.cfStatsSlim
            const _slimStats = action.method === 'cf_stats' && store.setting('fe.data.cfStatsSlim', true) !== false
            if (_slimSelect || _slimStats) {
                widget_to_transfer.view_on_frontend = true
            } else if (!action.widget_sendToBackend_exclude?.includes('view')
                    && !_noViewMethods.has(action.method)) {
                widget_to_transfer.view = WIDGET.view
            }

            const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            if (WORKSPACE.record) { // LOOK await 'router.beforeEach'.saveRecord()
                widget_to_transfer.workspace = WORKSPACE.record.id
                widget_to_transfer.workspace_params = store.workspace_params_for(WIDGET, WORKSPACE.record.doc.params) // << WHERE << selector 2025-02-16; IE 2026 09 15: тираж — без своего селектора
                // IE 2026 09 19 / ODOO-5800 (находка при приёме чипса метрик отчётом): запрос уходит с ВАРИАНТОМ параметров стола (без своего поля селектора / без чипса метрик) —
                // ответ с пересчитанными под этот вариант наборами не должен менять наборы стола (см. мерж workspace_params в ответе)
                action._wsParamsVariant = widget_to_transfer.workspace_params !== WORKSPACE.record.doc.params
            }
            const doc_stayOnFront = {}

            if (action.record) {
                widget_to_transfer.record = action.record
                delete action.record
            } else {
                widget_to_transfer.record = store.get_record_to_transfer(vueObj, WIDGET.record, action)
            }
            // IE 2026 09 20 / ODOO-5800 (Igor через ie-dm7 #32448: команда «открыть список правил» блока RULES формы ячейки): чипс «правила ячейки» едет на бэк только с методами, которые ЧИТАЮТ
            // данные (select, reload, выгрузка …); любой другой метод (save и всё незнакомое) получает запись без него — чипс не должен попасть в сохранение
            if (!CELL_RULES_DATA_METHODS.includes(action.method)) widget_to_transfer.record = cellRulesChip_strip(widget_to_transfer.record)
            if (!CELL_RULES_DATA_METHODS.includes(action.method)) widget_to_transfer.record = listHistoryDs_overlayStripRecord(widget_to_transfer.record)   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): оверлей «Show in list» — только с читающими методами (select, reload …)
            // IE 2026 10 30 / ODOO-5800 (p099: pm_history record slim): запрос «Історія змін» без view — запись урезанной копией (viewList / viewParams / тяжёлые ключи params, data_layout2 — скелет);
            // с view запись не трогаем (бэк кэширует виджет с записью как прислана). Выключатель fe.data.pmHistoryRecordSlim (дефолт ВКЛ)
            if (action.method === 'pm_history') widget_to_transfer.record = pmHistory_recordForRequest(action.method, widget_to_transfer, (k, d) => store.setting(k, d))
            // IE 2026 09 24 / ODOO-5800: reload от переключения групп опций (mainStore.optionGroup_send) — бэк берёт запись как прислана,
            // без перечитывания из БД и без переворота группы (views.py widget_open: widget_init.doc_take_from_front)
            if (action._doc_take_from_front) widget_to_transfer.doc_take_from_front = true

            if (action.record_sendToBackend) {
                for (let key of action.record_sendToBackend) {
                    if (key === '_widget.command_line') {
                        widget_to_transfer.command_line = WIDGET.command_line
                    } else if (key === '_widget.debug_console') {
                        widget_to_transfer.debug_console = WIDGET.debug_console
                    }
                }
            }
            if (action.record_sendToBackend_undoStack) {
                let attr_vueObj = vueObj.get_vueObj(action.source_name || action.binding)
                // бэку уходят только правки ЯЧЕЕК: структурные записи (rows/props)
                // не имеют координат — get_cell по ним падал
                // ИЕ 2026 08 13: косвенные строки undo-группы декомпозиции (indirect:
                // aggEdit-маркер и пересчитанные предки) на бэк НЕ уходят — по замыслу
                // ac5636a5 они «skip every backend-write channel», но этот канал отправки
                // не фильтровался. У тяжёлых агрегатов (строка Uncovered с DL2-поддеревом
                // причин) их $item раздувал запрос до RangeError: Invalid string length
                // на JSON.stringify. Бэку — только детальные правки ячеек; $item — балласт
                // фронтового undo, в запросе не нужен (клоним строку, чтобы не портить стек).
                // IE 2026 08 27 / ODOO-11316: no-op ячейки (итог = исходному) отфильтрованы гридом — AttrGrid.undoStack_forSave
                const undoStack = widget_to_transfer.undoStack = (typeof attr_vueObj.undoStack_forSave === 'function' ? attr_vueObj.undoStack_forSave() : attr_vueObj.undoStack)
                    .filter(rowStack => rowStack.col_binding != null && rowStack.irow >= 0
                        && !rowStack.indirect)
                    .map(rowStack => {
                        if (!('$item' in rowStack)) return rowStack
                        const { $item, ...rest } = rowStack
                        return rest
                    })
                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P3: в отправляемой пачке есть правка флажка согласования (флажковый ввод, цикл начат) — запоминаем ДО ответа: дельта-ответ бэка
                // (gridSaved) приходит, когда стеки правок уже могли очиститься (опрос каскада → updateDoc → content_Changed во время save), и по стеку правку флажка было бы не узнать
                if (action.method === 'save') { if (approval_flagEdited(approval_doc(WIDGET.record?.doc), undoStack)) WIDGET._apprFlagSave = true; else delete WIDGET._apprFlagSave }
                // ИЕ 2026 08 13 (вторая часть фикса payload): cell.dataItem тянет через
                // parents_/children фактически весь грид — save группы весил ~50 МБ и
                // рвался на медленном канале («Backend error» при фактически принятой
                // правке). Бэкенду из cell нужны только WHERE-цепочки и мета строки
                // (get_where: attr_col.where + parents_.where; dataItem.measure/measure_/
                // _DLRow.where*/parents_ с их _DLRow и титулами) — массивы грида
                // (children/data/items/_cells) в запросе не читаются, режем их.
                // IE 2026 08 18 / ODOO-5512: '_cells' из среза УБРАН — это переопределения
                // ячеек строки (маленький словарь), их читает save_record на бэке;
                // с '_cells' в срезе правка сохранялась без переопределения и
                // затиралась первым же пересчётом (M03)
                const _slimDrop = new Set(['data', 'items', 'children', 'cells', 'view', 'rows',
                    // _kidsCollapsed — фронтовый кэш свёрнутых колонок band'а: по ~415 КБ
                    // на родителя, в мартовском группе-save давал 1 МБ на КАЖДУЮ строку стека
                    '_kidsCollapsed'])
                // WHERE-узлы (leftValue/rightValue/condition) хранят вложенность в 'attrs' —
                // их не трогаем целиком; 'attrs' режем только у ГРИД-узлов (там это дети-строки).
                // Урок 13.08: слепое вырезание 'attrs' обрубало WHERE-деревья, бэкенд собирал
                // «measure in ()» и селекты падали синтаксисом.
                const _isWhereNode = (o) => !!o && ('leftValue' in o || 'rightValue' in o
                    || 'condition' in o || 'WHERE' in o)
                const _slim = (o, inWhere) => {
                    if (!o || typeof o !== 'object') return o
                    if (Array.isArray(o)) return o.map(v => _slim(v, inWhere))
                    const where = inWhere || _isWhereNode(o)
                    const out = {}
                    for (const k of Object.keys(o)) {
                        if (!where && (_slimDrop.has(k) || k === 'attrs')) continue
                        const v = o[k]
                        out[k] = (v && typeof v === 'object') ? _slim(v, where) : v
                    }
                    return out
                }
                for (let rowStack of undoStack) {
                    rowStack.cell = _slim(attr_vueObj.get_cell(rowStack.irow, rowStack.icol))
                }
                // АН 2026 08 08: флаги fastRecalc едут с сохранением правок —
                // переключение каскада целиком клиентское (без рестарта бэка)
                widget_to_transfer.fast_recalc = { ...store.fastRecalc }
            }

            // IE 2026 09 04 / ODOO-336658: флаги Rust-движка раскладки отчётов — в каждом запросе виджета
            // (бэк читает их только у WIDGET-REPORT2; объект маленький)
            widget_to_transfer.dl2_engine = { ...store.dl2Engine }
            // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T2): активный вид ячеек — бэку (считает спутники только этого вида; '' — «Числа»). Вид ещё не задан (кнопок не было) или флаг
            // fe.ux.cellStatusPie ВЫКЛ — ключа нет: бэк действует по-старому (строка Options use)
            if (typeof WIDGET._cellView === 'string' && cellPie_flagOn((k, d) => store.setting(k, d))) widget_to_transfer.cell_view = cellView_activeOf(WIDGET)

            // // packege_size
            // const raw = JSON.stringify(widget_to_transfer);
            // const gzipped = pako.gzip(raw);
            // console.log("Raw (KB):", Math.round(new TextEncoder().encode(raw).length / 1024));
            // console.log("Gzipped (KB):", Math.round(gzipped.length / 1024));

            return [widget_to_transfer, doc_stayOnFront]
        },
        // ===== IE 2026 08 28 / ODOO-5828 (заказ Игоря): клиентский прогон тестов данных — в ТЕКУЩЕЙ вкладке
        // пользователя: чистка кэшей приложения, открытие цели, замер (открытие/первые данные/стабилизация,
        // эвристика headless-харнесса pw_fe_open), опц. горячий проход, запись результата на бэк (client_test_result)
        clientTest_call(vueObj, method, extra = {}) {
            const store = this
            return new Promise(resolve => {
                let done = false
                const finish = (a) => { if (!done) { done = true; resolve(a) } }
                store.executeWidgetMethod(vueObj, { command: 'executeWidgetMethod', method,
                    record_sendToBackend_exclude: ['_doc'], no_del_last_backend_action: true,
                    ...extra, _response_callback: finish })
                setTimeout(() => finish(null), 120000)
            })
        },
        clientTest_clearCaches() {
            // IE 2026 08 28 / ODOO-5828 (замер форка D): холодная метрика должна мерить открытие ЭЛЕМЕНТА,
            // а не восстановление структурных кэшей приложения. Чистим только словари ДАННЫХ (сегменты
            // записей, DS::*, inbound-*, словари значений полей); структурные (виды/поля/статусы/доступ/
            // календарь/платформенные реестры) НЕ трогаем — они не зависят от данных теста и в реальной
            // работе всегда тёплые, их «восстановление» тонуло в замере волнами перезапросов.
            // HTTP-кэш браузера из JS не чистится — это уходит в note замера
            const KEEP = /^(ATTR|FIELDS|SEGMENTS|CSS|ACCESS|VERSION|PROCESS-MODEL|PAGE|WORKSPACE|STATUS|CLASS|SCHEDULE|WIDGET|TASKS|LOGS|TEST|CHIP|USER|DS-Measure)/
            const store = this
            let cleared = 0, kept = 0
            for (const seg of Object.keys(store.itemsSource || {})) {
                if (!seg || KEEP.test(seg)) { kept++; continue }
                delete store.itemsSource[seg]
                if (store._itemsSource_queue) delete store._itemsSource_queue[seg]
                if (store._itemsSource_active) delete store._itemsSource_active[seg]
                cleared++
            }
            store.itemsSource_change_index++
            return { cleared, kept }
        },
        clientTest_browser() {
            const ua = navigator.userAgent
            const b = ua.match(/(Firefox|Edg|Chrome|Safari)[/](\d+)/)
            const os = /Mac OS X/.test(ua) ? 'macOS' : /Windows/.test(ua) ? 'Windows' : /Linux/.test(ua) ? 'Linux' : ''
            return (b ? (b[1] === 'Edg' ? 'Edge' : b[1]) + ' ' + b[2] : 'browser') + (os ? ' · ' + os : '')
        },
        clientTest_findNew(before, test) {
            const all = this.activeWORKSPACE?.ALL_WIDGETS || []
            return all.find(W => !before.has(W.id) && (W.widget === test.source_id || W.record?.id === test.source_id))
        },
        async clientTest_pass(vueObj, test, mode, note) {
            const store = this
            const isRecord = !['report-run', 'list-run'].includes(test.test_type)
            const before = new Set((store.activeWORKSPACE?.ALL_WIDGETS || []).map(W => W.id))
            const t0 = performance.now()
            const action = isRecord
                ? { command: 'widget_open', widget: 'widget-record', new: true,
                    item: { id: test.source_id, segment: test.source_segment, version: test.source_version || '', title: t('client test') } }   // IE 2026 09 23 / ODOO-341407: i18n
                : { command: 'widget_open', widget: test.source_id, new: true, title: t('client test'),
                    fieldsMapping: (test.params && test.params.WHERE) ? [{ attr: { binding: 'doc.params.WHERE', value: test.params.WHERE } }] : [] }
            store.executeStoreMethod(vueObj, action)
            const guidRe = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g
            let W = null, opened = 0, firstData = 0, stableSince = 0, lastCount = -1, raw = 0, rawFirst = null
            for (let i = 0; i < 100; i++) {
                await new Promise(res => setTimeout(res, 300))
                if (!W) W = store.clientTest_findNew(before, test)
                const el = W?.vueObj?.$el
                if (!el) continue
                if (!opened) opened = performance.now()
                const txt = el.innerText || ''
                raw = (txt.match(guidRe) || []).length
                if (!firstData && txt.length > 200) { firstData = performance.now(); rawFirst = raw } // IE 2026 08 28: «titles at first paint»
                const spin = (W.loading || el.querySelector('.p-progress-spinner, .loading, .wj-loading')) ? 1 : 0
                if (raw === lastCount && !spin) {
                    if (!stableSince) stableSince = performance.now()
                    if (performance.now() - stableSince > 2500) break // сами 2.5 с ожидания в замер не входят
                } else { stableSince = 0; lastCount = raw }
                if (i === 99 && !stableSince) stableSince = performance.now() // таймаут 30 с — фиксируем как есть
            }
            const pass = {
                mode,
                fe_open: opened ? Math.round(opened - t0) / 1000 : null,
                fe_data: firstData ? Math.round(firstData - t0) / 1000 : null,
                fe_duration: stableSince ? Math.round(stableSince - t0) / 1000 : null,
                raw_guids: raw,
                note: note + ' · raw guids at first paint: ' + (rawFirst ?? '—'),
            }
            if (W) store.clientTest_closeTarget(W)
            return pass
        },
        clientTest_closeTarget(W) {
            // IE 2026 08 28 / ODOO-5828: hardClose копии REPORT2 иногда оставляет живой DOM-узел (из ALL_WIDGETS
            // виджет удалён) — прячем узел явно, чтобы не мусорить вкладку пользователя
            const el = W?.vueObj?.$el?.closest?.('.WIDGET') || W?.vueObj?.$el || document.getElementById('WIDGET' + W?.id)
            this.widget_close(W.id, false, true)
            setTimeout(() => { if (el && el.isConnected) el.style.display = 'none' }, 400)
        },
        clientTest_stateHash(W) {
            return this.clientTest_snapshotOf(W).hash
        },
        clientTest_snapshotOf(W) {
            // IE 2026 08 28 / ODOO-5828 (дефект пилота, итерация 2): у чарт-виджета ЕСТЬ пустой служебный грид —
            // ветвление «грид или данные» слепло. Слепок = ячейки гридов С ДАННЫМИ + точки всех wijmo-чартов
            // (collectionView.items: имя точки + числовые поля, округлённые до целого); count = строки + точки;
            // если ни того ни другого — фолбэк на данные записи
            const el = W?.vueObj?.$el
            const djb2 = (txt) => { let h = 5381; for (let i = 0; i < txt.length; i++) h = ((h << 5) + h + txt.charCodeAt(i)) | 0; return (h >>> 0).toString(16) + ':' + txt.length }
            let txt = ''
            let count = 0
            const grid = this.clientTest_grid(W)
            if (grid && grid.flex.rows.length && el) {
                txt += [...el.querySelectorAll('.wj-cells')].map(e => e.innerText || '').join('|').replace(/\s+/g, ' ').trim()
                count += grid.flex.rows.length
            }
            const pointTxt = (it) => {
                const name = String(it.date ?? it.title ?? it.name ?? it.id ?? '')
                const vals = []
                for (const k of Object.keys(it)) { const v = it[k]; if (typeof v === 'number' && isFinite(v)) vals.push(k + ':' + Math.round(v)) }
                return name + '=' + vals.join(',')
            }
            for (const host of (el ? el.querySelectorAll('.wj-flexchart') : [])) {
                const items = host['$WJ-CTRL']?.collectionView?.items || []
                for (const it of items) txt += '|' + pointTxt(it)
                count += items.length
            }
            if (!txt) {
                const rows = []
                const walk = (arr) => { for (const r of arr || []) { if (r && typeof r === 'object') { rows.push(r); walk(r.attrs || r.children) } } }
                walk(W?.record?._doc?.data || W?.record?.doc?.data || [])
                for (const r of rows) { txt += '|' + pointTxt(r); for (const k of Object.keys(r)) { if (typeof r[k] === 'number' && isFinite(r[k])) count++ } }
            }
            return { hash: djb2(txt), count }
        },
        clientTest_recalcState() {
            // состояние авто-пересчёта (как штатный autoRecalc_check): running/last_done по версии стола/ветки
            const store = this
            const WORKSPACE = store.activeWORKSPACE
            const wsId = WORKSPACE?.workspace || WORKSPACE?.record?.id
            const version = store.process_model_record?.doc?.branch?.version || WORKSPACE?.record?.doc?.params?.version || ''
            return new Promise(resolve => {
                if (!wsId || !version) return resolve(null)
                $.ajax({ url: store.url_backend_api, type: 'POST', contentType: 'application/json', dataType: 'json',
                    data: JSON.stringify({ command: 'executeBackendMethod', method: 'auto_recalc_state',
                        params: { workspace: wsId, version, process_model: store.process_model_record?.id || '' },
                        workspace: wsId, process_model: store.process_model_record?.id || '', user: store.user }),
                    success: (a) => resolve(a || null), error: () => resolve(null) })
            })
        },
        async clientTest_waitRecalc(capMs = 300000) {
            // IE 2026 08 28 / ODOO-5828 (дефект пилота: save_s упирался в потолок): реальное завершение
            // каскада после записи — poll auto_recalc_state; два подряд «не running» = завершено; cap — страховка
            const t0 = performance.now()
            let idle = 0
            while (performance.now() - t0 < capMs) {
                await new Promise(res => setTimeout(res, 2500))
                const a = await this.clientTest_recalcState()
                if (a && a.running) { idle = 0; continue }
                idle++
                if (idle >= 2) return { duration_s: Math.round(performance.now() - t0) / 1000, timeout: false }
            }
            return { duration_s: Math.round(performance.now() - t0) / 1000, timeout: true }
        },
        clientTest_grid(W) {
            const el = W?.vueObj?.$el
            let best = null
            for (const h of (el ? el.querySelectorAll('.wj-flexgrid') : [])) {
                let c = h.__vueParentComponent
                for (let i = 0; i < 12 && c; i++) {
                    if (c.proxy?.flex && c.proxy?.attr) {
                        if (!best || (c.proxy.flex.rows?.length || 0) > (best.flex.rows?.length || 0)) best = c.proxy
                        break
                    }
                    c = c.parent
                }
            }
            return best
        },
        async clientTest_waitStable(W, t0, maxMs = 30000) {
            // затишье: guid-счётчик и длина текста не меняются, нет спиннера 2.5 с подряд (сами 2.5 с не в замере)
            const guidRe = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g
            let opened = 0, firstData = 0, stableSince = 0, lastKey = '', raw = 0
            const tEnd = performance.now() + maxMs
            while (performance.now() < tEnd) {
                await new Promise(res => setTimeout(res, 300))
                const el = W?.vueObj?.$el
                if (!el) continue
                if (!opened) opened = performance.now()
                const txt = el.innerText || ''
                if (!firstData && txt.length > 200) firstData = performance.now()
                raw = (txt.match(guidRe) || []).length
                const spin = (W.loading || el.querySelector('.p-progress-spinner, .loading, .wj-loading')) ? 1 : 0
                const key = raw + ':' + txt.length
                if (key === lastKey && !spin) {
                    if (!stableSince) stableSince = performance.now()
                    if (performance.now() - stableSince > 2500) {
                        return { fe_open: opened ? Math.round(opened - t0) / 1000 : null,
                            fe_data: firstData ? Math.round(firstData - t0) / 1000 : null,
                            stable_s: Math.round(stableSince - t0) / 1000, raw_guids: raw, timeout: false }
                    }
                } else { stableSince = 0; lastKey = key }
            }
            return { fe_open: opened ? Math.round(opened - t0) / 1000 : null,
                fe_data: firstData ? Math.round(firstData - t0) / 1000 : null,
                stable_s: Math.round(performance.now() - t0) / 1000, raw_guids: raw, timeout: true }
        },
        async clientTest_gotoPage(workspace, page) {
            // IE 2026 08 28 / ODOO-5828 (блокер пилота): источник открывается ТОЛЬКО на странице теста —
            // параметры виджета (даты ПМ и пр.) рендерятся при открытии на своей странице; вне её
            // afterOpen источника падал (M03: int(None[5:7])). Навигация роутером, ожидание активации
            const store = this
            if (!workspace) return true
            if (store.activeWORKSPACE?.workspace === workspace && (!page || store.activeWORKSPACE?.active_page === page)) return true
            const pm = store.process_model_record?.id || ''
            store.router.replace({ name: 'db', params: { dbid: store.user.database.dbid },
                query: { ...(pm && pm !== store.process_model_current ? { process_model: pm } : {}), workspace, ...(page ? { page } : {}) } }).catch(() => {})
            for (let i = 0; i < 60; i++) {
                await new Promise(res => setTimeout(res, 500))
                if (store.activeWORKSPACE?.workspace === workspace && (!page || store.activeWORKSPACE?.active_page === page)) {
                    await new Promise(res => setTimeout(res, 2000)) // дать странице поднять виджеты
                    return true
                }
            }
            return false
        },
        async clientTest_switchPm(pm) {
            const store = this
            if (!pm || store.process_model_record?.id === pm) return true
            store.switch_process_model(pm)
            for (let i = 0; i < 60; i++) {
                await new Promise(res => setTimeout(res, 500))
                if (store.process_model_record?.id === pm) { await new Promise(res => setTimeout(res, 1500)); return true }
            }
            return false
        },
        async clientTest_openTargetW(vueObj, test) {
            const store = this
            const isRecord = !['report-run', 'list-run', 'edit-run'].includes(test.test_type)
                || (test.test_type === 'edit-run' && test.source_segment && !['WIDGET-REPORT2', 'WIDGET-LIST'].includes(test.source_segment))
            const before = new Set((store.activeWORKSPACE?.ALL_WIDGETS || []).map(W => W.id))
            const action = isRecord
                ? { command: 'widget_open', widget: 'widget-record', new: true,
                    item: { id: test.source_id, segment: test.source_segment, version: test.source_version || '', title: t('client test') } }   // IE 2026 09 23 / ODOO-341407: i18n
                : { command: 'widget_open', widget: test.source_id, new: true, title: t('client test'),
                    fieldsMapping: (test.params && test.params.WHERE) ? [{ attr: { binding: 'doc.params.WHERE', value: test.params.WHERE } }] : [] }
            store.executeStoreMethod(vueObj, action)
            for (let i = 0; i < 100; i++) {
                await new Promise(res => setTimeout(res, 300))
                const W = store.clientTest_findNew(before, test)
                if (W?.vueObj?.$el) return W
            }
            return null
        },
        clientTest_httpDispatch(W, action, timeoutMs = 120000) {
            // IE 2026 10 01 / ODOO-5800 (дефект пилота test-scen-maltofer-pilot, логи бэка 30.08: save списка «проходил», а записи на
            // сервере не было): действие виджета тем же путём, каким его шлёт кнопка (AttrButton.onClick → executeStoreMethod(WIDGET.vueObj,
            // attr)), и ДОКАЗАТЕЛЬСТВО HTTP. Прежний диспатч ждал _response_callback — его зовёт любой ответ 200, в том числе ответ бэка
            // об исключении ({notification: critical}); отсутствие запроса вообще было неотличимо от медленного ответа. Теперь: запрос,
            // порождённый этим вызовом, — новый WIDGET._activeRequest (executeWidgetMethod ставит его синхронно: до $.ajax в нём нет await);
            // исход — по самому jqXHR (статус, длительность, ответ уже применён success-обработчиком). Запрос не породился — причина:
            // исключение сборки запроса (unhandledrejection async-метода), отказ роли «только чтение» (_onResponse(null) без запроса),
            // закрытый виджет, ошибка в плашке виджета. Итог: { sent, ok, status, ms, answer, error }
            const store = this
            const WIDGET = W?.vueObj?.WIDGET || W
            return new Promise(resolve => {
                const t0 = performance.now()
                let done = false, rejection = '', refused = false
                const onRejection = (ev) => { if (!rejection) rejection = String(ev?.reason?.message || ev?.reason || '').slice(0, 200) }
                const fin = (r) => {
                    if (done) return
                    done = true
                    window.removeEventListener('unhandledrejection', onRejection)
                    resolve({ sent: false, ok: false, status: 0, answer: null, error: '', ...r, ms: Math.round(performance.now() - t0) })
                }
                if (!WIDGET || !W?.vueObj) return fin({ error: 'no HTTP request was sent — the widget is not mounted' })
                window.addEventListener('unhandledrejection', onRejection)
                const prev = toRaw(WIDGET._activeRequest || null)
                let xhr = null
                const cancelled204 = 'HTTP 204 — the request was cancelled on the backend (superseded by a newer request of the widget)'
                // хуки executeWidgetMethod — страховка: бросит применение ответа в success-обработчике — до .done/.fail дело не
                // дойдёт (jQuery зовёт их после него в том же списке), а итог нужен; в обычном случае .done/.fail успевают раньше
                action._onResponse = (a) => {
                    if (a !== null) return
                    if (!xhr) { refused = true; return }
                    setTimeout(() => fin({ sent: true, status: xhr.status || 0, error: `HTTP ${xhr.status || 0} ${xhr.statusText || 'error'}` }), 0)
                }
                action._response_callback = (answer) => {
                    setTimeout(() => fin(xhr?.status === 204 ? { sent: true, status: 204, error: cancelled204 }
                        : { sent: true, ok: true, status: xhr?.status || 200, answer: answer ?? null }), 0)
                }
                try {
                    store.executeStoreMethod(W.vueObj, action)
                } catch (e) {
                    return fin({ error: 'no HTTP request was sent — dispatch threw: ' + String(e?.message || e).slice(0, 200) })
                }
                const cur = toRaw(WIDGET._activeRequest || null)
                if (cur && cur !== prev) xhr = cur
                if (!xhr) {
                    // запрос не ушёл: unhandledrejection приходит после микрозадач — даём им отработать и называем причину
                    setTimeout(() => {
                        const nt = WIDGET.notification
                        const ntErr = nt?.visible && ['error', 'critical'].includes(nt.status) ? String(nt.text || '').slice(0, 160) : ''
                        fin({ error: 'no HTTP request was sent — ' + (rejection || ntErr || (WIDGET.close ? 'the widget is closed'
                            : refused ? 'refused before sending (read-only role?)' : 'the action did not reach executeWidgetMethod')) })
                    }, 300)
                    return
                }
                xhr.done((answer, textStatus, jq) => {
                    const status = jq?.status ?? xhr.status ?? 200
                    if (status === 204) fin({ sent: true, status, error: cancelled204 })
                    else fin({ sent: true, ok: true, status, answer: answer ?? null })
                }).fail((jq, textStatus, err) => {
                    fin({ sent: true, status: jq?.status ?? 0, error: textStatus === 'abort'
                        ? 'the request was aborted on the frontend (a newer request of the widget replaced it)'
                        : `HTTP ${jq?.status ?? 0} ${textStatus || ''}${err ? ' — ' + String(err).slice(0, 120) : ''}`.trim() })
                })
                setTimeout(() => fin({ sent: true, error: `no HTTP answer in ${Math.round(timeoutMs / 1000)} s` }), timeoutMs)
            })
        },
        clientTest_saveButton(W) {
            // IE 2026 10 01 / ODOO-5800: кнопка Save виджета — тот самый attr, который рисует панель его грида (список: widget_LIST.set_menu →
            // attrGrid.groupMenu.commandPanel; отчёт: groupMenu грида dataSheet вида WIDGET-REPORT2): executeWidgetMethod / save, binding _doc.data
            const found = []
            const walk = (arr, depth) => {
                if (!Array.isArray(arr) || depth > 12) return
                for (const a of arr) {
                    if (!a || typeof a !== 'object') continue
                    if (a.command === 'executeWidgetMethod' && a.method === 'save') found.push(a)
                    walk(a.attrs, depth + 1)
                    walk(a.commandPanel, depth + 1)
                    walk(a.groupMenu?.commandPanel, depth + 1)
                }
            }
            walk(W?.groupMenu?.commandPanel, 0)
            walk(W?.view, 0)
            return found.find(a => (a.binding || '_doc.data') === '_doc.data') || found[0] || null
        },
        clientTest_rowsById(data) {
            // строки ответа сервера (дерево: children / attrs / items) по id
            const map = new Map()
            const walk = (arr, depth) => {
                if (!Array.isArray(arr) || depth > 20) return
                for (const r of arr) {
                    if (!r || typeof r !== 'object') continue
                    if (r.id != null && r.id !== '' && !map.has(r.id)) map.set(r.id, r)
                    for (const k of ['children', 'attrs', 'items']) if (Array.isArray(r[k])) walk(r[k], depth + 1)
                }
            }
            walk(data, 0)
            return map
        },
        clientTest_valSame(a, b) {
            // значение ячейки == значению шага: значение шага приходит строкой таблицы Steps, у сервера — число / ссылка {value}
            const json = (v) => { try { return JSON.stringify(v) } catch (e) { return String(v) } }
            const norm = (v) => (v && typeof v === 'object') ? (v.value ?? v.id ?? json(v)) : v
            const num = (v) => typeof v === 'number' ? v : (typeof v === 'string' && v.trim() !== '' ? Number(v) : NaN)
            const x = num(norm(a)), y = num(norm(b))
            if (isFinite(x) && isFinite(y)) return Math.abs(x - y) <= 1e-9 * Math.max(1, Math.abs(x), Math.abs(y))
            return String(norm(a) ?? '') === String(norm(b) ?? '')
        },
        clientTest_saveSign(answer, cells = []) {
            // IE 2026 10 01 / ODOO-5800: признак записи в ответе save. Ответ save списка — уже перечитывание с сервера ПОСЛЕ записи
            // (widget_LIST.save → select): правленные строки (row_key шагов edit_cell) обязаны вернуться с записанными значениями —
            // это и есть «изменённые id»; вернулись со старыми — записи не было. Явные признаки: count_save / ok / gridSaved (дельта
            // отчёта, save_delta). refresh_itemsSource без правленных строк в ответе — путь записи списка пройден, но число записанных
            // неизвестно: слабый признак, решает перечитывание после каскада
            const store = this
            if (!answer || typeof answer !== 'object') return { sign: '', note: 'empty answer' }
            const rows = store.clientTest_rowsById(answer.record?._doc?.data)
            let found = 0
            const stale = []
            for (const c of cells) {
                const r = c.row_key ? rows.get(c.row_key) : null
                if (!r) continue
                found++
                const v = store.get_value(r, c.col)
                if (!store.clientTest_valSame(v, c.value)) stale.push(`${c.row_key}/${c.col}: ${v} ≠ ${c.value}`)
            }
            if (found && stale.length) return { sign: '', stale: true, note: 'the server returned the edited rows with the old values — ' + stale.slice(0, 3).join('; ') }
            if (found) return { sign: 'rows', count: found }
            const n = (v) => Number(v) || 0
            const cnt = n(answer.count_save) || n(answer.record?._meta?.count_save) || n(answer.save_delta?.docs_saved) || n(answer.save_delta?.cells)
            if (cnt > 0) return { sign: 'count_save', count: cnt }
            if (answer.ok === true) return { sign: 'ok' }
            if ((answer.actions_after || []).some(a => a && a.command === 'gridSaved')) return { sign: 'gridSaved' }
            if (answer.refresh_itemsSource) return { sign: 'refresh_itemsSource', weak: true }
            return { sign: '', note: 'the answer carries no save sign (count_save / ok / gridSaved / edited rows with the written values)' }
        },
        clientTest_pageEl() {
            const WS = this.activeWORKSPACE
            const el = WS?.PAGES?.[WS?.active_page]?.vueObj?.$el || document.querySelector('.main-container') || document.body
            return { vueObj: { $el: el }, loading: false }
        },
        clientTest_findOpenW(ref) {
            const all = this.activeWORKSPACE?.ALL_WIDGETS || []
            return all.filter(W => !W.close && (W.widget === ref || W.record?.id === ref)).pop() || null
        },
        async clientTest_scenarioRun(vueObj, test, idArg = {}) {
            // IE 2026 08 28 / ODOO-5828 (приёмка Игоря): исполнение записанного сценария (scenario-run) по
            // таблице Steps мастер-контракта; опц. под What-if веткой; чипсы ставятся как пользователь и
            // снимаются в конце; фазы и снапшоты уходят в client_test_result
            const store = this
            const phases = {}
            const steps_result = []
            const snapshots = {}
            const tTot0 = performance.now()
            const brArg = { ...(idArg || {}), ...(test.id ? { test_id: test.id } : {}) }
            const oldPm = store.process_model_record?.id || ''
            const oldWs = store.activeWORKSPACE?.workspace || ''
            const oldPage = store.activeWORKSPACE?.active_page || ''
            const opened = []
            const editedCells = [] // IE 2026 08 28 / ODOO-5828: {widgetId, row_key, col, value} — сверка после save по ПРАВЛЕННЫМ ячейкам
            let chipsBackup = null
            let br = null
            const addPh = (k, v) => { phases[k] = Math.round(((phases[k] || 0) + (v || 0)) * 1000) / 1000 }
            if (!Array.isArray(test.steps) || !test.steps.length) {
                // бэк не отдал шаги (prepare без doc.steps) — пустой прогон не логируем
                store.show_notification({ text: t('Scenario test: prepare returned no steps — check the test record / backend prepare'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции)
                return null
            }
            try {
                if (test.workspace && !await store.clientTest_gotoPage(test.workspace, test.page)) throw new Error('navigation to the test page timed out')
                if (test.branch_use) {
                    store.show_notification({ text: t('Scenario: creating a What-if branch…'), status: 'pending' })
                    const tBr = performance.now()
                    br = await store.clientTest_call(vueObj, 'client_test_branch_create',
                        { ...brArg, ensure_mvs: test.branch_ensure_mvs !== false })
                    phases.branch_create_s = br?.duration_s ?? Math.round(performance.now() - tBr) / 1000
                    if (!br?.branch_pm) throw new Error('branch create failed')
                    if (!await store.clientTest_switchPm(br.branch_pm)) throw new Error('switch to branch PM timed out')
                }
                const steps = (test.steps || []).filter(st => st && st.use !== false)
                for (let i = 0; i < steps.length; i++) {
                    const st = steps[i]
                    const act = st.action || ''
                    store.show_notification({ text: t('Scenario step {i}/{n} — {step}', { i: i + 1, n: steps.length, step: act + (st.widget ? ' ' + st.widget : '') }), status: 'pending' })
                    const t0 = performance.now()
                    const sr = { n: st.n ?? (i + 1), mode: act, duration: null, fe_feedback_s: null, consistent: null, deviation: null, state_hash: '' }
                    if (act === 'goto_page') {
                        await store.clientTest_gotoPage(test.workspace || store.activeWORKSPACE?.workspace, st.page)
                    } else if (act === 'wait') {
                        await new Promise(res => setTimeout(res, Math.min(60, Number(st.value) || 1) * 1000))
                    } else if (act === 'set_chips') {
                        const WS = store.activeWORKSPACE
                        const params = WS?.record?.doc?.params
                        if (!params) throw new Error('set_chips: no workspace params')
                        if (!chipsBackup) chipsBackup = JSON.parse(JSON.stringify(params.WHERE || []))
                        const chips = JSON.parse(st.value || '[]')
                        params.WHERE = params.WHERE || []
                        for (const c of chips) {
                            let row = params.WHERE.find(r => (r.leftValue || {}).value === c.binding)
                            if (!row) {
                                row = { use: true, attr_type: 'AttrChipWhere', condition: c.condition || 'in',
                                    leftValue: { value: c.binding, valueStr: c.binding, attr_type: 'AttrLink', component: 'AttrLink' },
                                    rightValue: { value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink' }, attrs: [] }
                                params.WHERE.push(row)
                            }
                            row.use = (c.values || []).length > 0
                            row.attrs = (c.values || []).map(v => ({ use: true, rightValue: { value: v.value, valueStr: v.valueStr || '', attr_type: 'AttrLink', component: 'AttrLink' } }))
                        }
                        store.workspace_applySelector(WS.workspace, WS.active_page)
                        const q = await store.clientTest_waitStable(store.clientTest_pageEl(), t0, 60000)
                        addPh('chips_s', q.stable_s)
                    } else if (act === 'open_widget') {
                        const t = st.widget === 'widget-record' || st.widget === 'widget-row'
                            ? { test_type: 'record-open', source_id: st.row_key, source_segment: st.comment || '', source_version: '' }
                            : { test_type: 'report-run', source_id: st.widget, params: {} }
                        const W = await store.clientTest_openTargetW(vueObj, t)
                        if (!W) throw new Error('open_widget ' + (st.widget || st.row_key) + ' failed')
                        opened.push(W)
                        const q = await store.clientTest_waitStable(W, t0, 90000)
                        addPh('open_s', q.stable_s)
                        sr.state_hash = store.clientTest_stateHash(W)
                    } else if (act === 'snapshot') {
                        const W = store.clientTest_findOpenW(st.widget || st.snapshot_name) || opened[opened.length - 1]
                        if (W) {
                            const snap = store.clientTest_snapshotOf(W) // chart-aware: без грида — слепок данных
                            snapshots[st.snapshot_name || st.widget || ('step' + sr.n)] =
                                { hash: snap.hash, count: snap.count, note: '' }
                            sr.state_hash = snap.hash
                        }
                    } else if (act === 'click_cell') {
                        // IE 2026 09 05 / ODOO-336379 (заказ Игоря): клик мышью по ячейке — как пользователь по флажку
                        // «Утверждено» (ПМ/БЮМ/МД). Правка может быть отклонена правами: это нормально, шаг фиксирует,
                        // что было в ячейке до и после, а следующий шаг check_render ловит артефакт отрисовки.
                        const W = store.clientTest_findOpenW(st.widget) || opened[opened.length - 1]
                        if (!W) throw new Error('click_cell: target widget not open')
                        const grid = store.clientTest_grid(W)
                        if (!grid?.flex) throw new Error('click_cell: no grid')
                        const flex = grid.flex
                        const ci = /^\d+$/.test(String(st.col)) ? Number(st.col) : [...flex.columns].findIndex(c => (c.binding || '') === String(st.col))
                        const irow = Number(st.row)
                        if (!(ci >= 0) || !(irow >= 0) || irow >= flex.rows.length) throw new Error(`click_cell: cell ${st.row}/${st.col} not found`)
                        // строка может быть скрыта свёрнутой группой — раскрываем дерево, потом ждём отрисовки
                        for (let k = 0; k < 10; k++) { let n = 0; for (const rr of flex.rows) if (rr.hasChildren && rr.isCollapsed) { rr.isCollapsed = false; n++ } if (!n) break }
                        let el = null
                        for (let k = 0; k < 8 && !el; k++) { flex.scrollIntoView(irow, ci); flex.refresh(false); await store.sleep(300); el = flex.cells.getCellElement(irow, ci) }
                        if (!el) throw new Error(`click_cell: cell ${irow}/${ci} is not rendered (row visible: ${flex.rows[irow]?.isVisible}, column visible: ${flex.columns[ci]?.visible})`)
                        sr.value_before = String(flex.getCellData(irow, ci, true) ?? '')
                        const r = el.getBoundingClientRect()
                        const ev = (type) => el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, clientX: r.x + r.width / 2, clientY: r.y + r.height / 2 }))
                        ev('mousedown'); ev('mouseup'); ev('click')
                        await store.sleep(Number(st.value) > 0 ? Number(st.value) * 1000 : 3000)
                        sr.value_after = String(flex.getCellData(irow, ci, true) ?? '')
                    } else if (act === 'check_render') {
                        // IE 2026 09 05 / ODOO-336379 (заказ Игоря, артефакт M03 после клика по флажку): в ОТРИСОВАННОЙ
                        // ячейке пусто, хотя в данных значение есть. Проверяются видимые строки; ячейки с элементами
                        // управления (флажок) и картинками пропускаются — там текста нет по определению.
                        const W = store.clientTest_findOpenW(st.widget) || opened[opened.length - 1]
                        if (!W) throw new Error('check_render: target widget not open')
                        const grid = store.clientTest_grid(W)
                        if (!grid?.flex) throw new Error('check_render: no grid')
                        const flex = grid.flex, vr = flex.viewRange
                        const cols = [...flex.columns].filter(c => c.visible)
                        const blanks = []
                        let checked = 0
                        for (let r = Math.max(0, vr.topRow); r <= Math.min(vr.bottomRow, flex.rows.length - 1); r++) {
                            for (const c of cols) {
                                const el = flex.cells.getCellElement(r, c.index)
                                if (!el || el.querySelector('input, img, svg, .wj-glyph-check, [class*="pi-"]')) continue
                                checked++
                                if ((el.innerText || '').trim()) continue
                                let d = null
                                try { d = flex.getCellData(r, c.index, true) } catch (e) { d = null }
                                if (d != null && String(d).trim() !== '' && typeof d !== 'boolean') blanks.push(`${r}:${c.binding || c.header}='${String(d).slice(0, 20)}'`)
                            }
                        }
                        sr.note = `check_render: ${checked} rendered cells, ${blanks.length} blank`
                        if (blanks.length) throw new Error(`check_render: ${blanks.length} rendered cells are blank while the data has values — ${blanks.slice(0, 8).join(', ')}`)
                    } else if (act === 'edit_cell' || act === 'edit') {
                        const W = store.clientTest_findOpenW(st.widget) || opened[opened.length - 1]
                        if (!W) throw new Error('edit: target widget not open')
                        const grid = store.clientTest_grid(W)
                        if (!grid) throw new Error('edit: no grid')
                        let irow = -1, colBinding = ''
                        if (act === 'edit') { irow = Number(st.row); colBinding = grid.flex.columns[Number(st.col)]?.binding }
                        else {
                            // IE 2026 08 28 / ODOO-5828 (пилот №6): колонка в шаге может быть коротким именем поля
                            // ('minDOS'), полным binding ('doc.minDOS') или заголовком — резолвим толерантно
                            const cols = [...grid.flex.columns]
                            const byB = (b) => cols.some(c => c.binding === b) ? b : ''
                            colBinding = byB(st.col) || byB('doc.' + st.col)
                                || (cols.find(c => (grid.attr_by_binding?.[c.binding]?.title || '') === st.col) || {}).binding
                                || (st.col_title && (cols.find(c => (grid.attr_by_binding?.[c.binding]?.title || '') === st.col_title) || {}).binding) || ''
                            if (st.row_key) irow = grid.flex.rows.findIndex(r => r.dataItem?.id === st.row_key)
                            if (irow < 0 && st.row_hint) irow = grid.flex.rows.findIndex(r => JSON.stringify(r.dataItem || {}).includes(st.row_hint))
                            if (irow < 0 && st.row !== '' && st.row != null) irow = Number(st.row)
                        }
                        const it = grid.flex.rows[irow]?.dataItem
                        if (!it || !colBinding) throw new Error('edit: row/col not found (' + (st.row_key || st.row) + '/' + (st.col) + ')')
                        const oldVal = grid.store.get_value(it, colBinding)
                        // IE 2026 09 05 / ODOO-336379 (набор тестов M03: python-пересчёт падал «unsupported operand
                        // type(s) for /: 'str' and 'str'»): значение шага приходит СТРОКОЙ из таблицы Steps; для
                        // числовой ячейки (число в данных или числовая колонка) приводим к числу, как редактор грида
                        const colObj = grid.flex.columns.find(c => c.binding === colBinding)
                        const isNumCell = typeof oldVal === 'number' || (colObj && colObj.dataType === 2)
                        const newVal = (isNumCell && typeof st.value === 'string' && st.value.trim() !== '' && isFinite(Number(st.value)))
                            ? Number(st.value) : st.value
                        // IE 2026 10 01 / ODOO-5800: было ли что менять — ячейка уже со значением шага строку не помечает, и save списка
                        // потом честно падает «нет изменённых строк»; в шаге видно почему
                        sr.value_before = (oldVal && typeof oldVal === 'object') ? String(oldVal.value ?? oldVal.id ?? '') : String(oldVal ?? '')
                        sr.changed = !store.clientTest_valSame(oldVal, newVal)
                        grid.set_value(irow, it, colBinding, oldVal, newVal)
                        const fb = await store.clientTest_waitStable(W, t0, 60000)
                        sr.fe_feedback_s = fb.stable_s
                        const cellNow = String(grid.store.get_value(grid.flex.rows[irow]?.dataItem || {}, colBinding))
                        sr.consistent = cellNow === String(st.value)
                        sr.state_hash = store.clientTest_stateHash(W)
                        addPh('steps_s', fb.stable_s)
                        editedCells.push({ widgetId: W.id, row_key: st.row_key || it.id || '', col: colBinding, value: st.value })
                    } else if (act === 'save') {
                        const W = store.clientTest_findOpenW(st.widget) || opened[opened.length - 1]
                        if (!W) throw new Error('save: target widget not open')
                        const grid = store.clientTest_grid(W)
                        const hashPresave = store.clientTest_stateHash(W)
                        sr.hash_presave = hashPresave
                        // IE 2026 10 01 / ODOO-5800: провал записи — шаг в результате (причина в deviation, HTTP, хэш), затем стоп сценария
                        const failSave = (msg) => {
                            sr.consistent = false
                            sr.deviation = String(msg).slice(0, 300)
                            sr.duration = Math.round((performance.now() - t0)) / 1000
                            steps_result.push(sr)
                            throw new Error(msg)
                        }
                        // IE 2026 08 28 / ODOO-5828 (страховка после инцидента probe-save): отправляем ТОЛЬКО фильтрованные
                        // строки, и их не может быть больше, чем сделано edit_cell-шагов — иначе шаг снимается без отправки
                        const myCells = editedCells.filter(c => c.widgetId === W.id)
                        const modRows = (W.record?._doc?.data || []).filter(r => r && r._meta && r._meta.modified)
                        if (modRows.length > myCells.length) {
                            sr.consistent = false
                            sr.save_aborted = 'modified rows (' + modRows.length + ') exceed edit steps (' + myCells.length + ') — not sent'
                            sr.deviation = sr.save_aborted
                            steps_result.push(sr)
                            sr.duration = Math.round((performance.now() - t0)) / 1000
                            continue
                        }
                        // IE 2026 10 01 / ODOO-5800 (дефект пилота test-scen-maltofer-pilot, логи бэка 30.08: между client_test_branch_create и
                        // client_test_branch_delete ни одного save, триггер on_batch_saved не сработал, chart_after == chart, а consistent давал
                        // ложный плюс): СПИСОК (widget_LIST) пишется только своей кнопкой Save — тот же attr из панели грида и тот же vueObj, что
                        // у клика (AttrButton.onClick), без подмешанного source_name и без фолбэка на чужую форму; запрос обязан уйти и
                        // вернуться (clientTest_httpDispatch: статус, длительность), ответ — нести признак записи (clientTest_saveSign: правленные
                        // строки с записанными значениями / count_save / ok / gridSaved); нет — шаг падает «save produced no server write».
                        // ОТЧЁТ и прочие — как раньше (IE 2026 08 28 / ODOO-5828): кнопка Save вида с source_name грида, фолбэк — форма отчёта с
                        // undoStack, повтор другой формой, если ответа нет; ответ дополнительно пишется в шаг (статус, признак)
                        const isList = (W.widget_class || W.vueObj?.WIDGET?.widget_class) === 'widget_LIST'
                        const btn = store.clientTest_saveButton(W)
                        let tries
                        if (isList) {
                            if (!modRows.length) failSave('save produced no server write: the edit steps left no modified rows in the list (the cells already had the step values?) — nothing to send')
                            if (!btn) failSave('save: the list has no Save button in its command panel (the list is not editable) — nothing to press')
                            sr.save_rows = modRows.length
                            tries = [['list-save-button', { ...btn }]]
                        } else {
                            const shapeBtn = btn ? { ...JSON.parse(JSON.stringify(btn)), source_name: btn.source_name || grid?.attr?.name } : null
                            const shapeReport = { command: 'executeWidgetMethod', method: 'save', binding: '_doc.data',
                                source_name: grid?.attr?.name, record_sendToBackend_exclude: ['not _meta.modified data.row'],
                                record_sendToBackend_undoStack: true }
                            tries = shapeBtn ? [['view-button', shapeBtn], ['report-shape', shapeReport]] : [['report-shape', shapeReport]]
                        }
                        let sv = null
                        for (const [label, shape] of tries) {
                            sv = await store.clientTest_httpDispatch(W, shape, isList ? 180000 : 120000)
                            sr.save_shape = label
                            if (sv.ok) break
                        }
                        sr.save_http_status = sv.status
                        sr.save_http_s = sv.ms / 1000
                        if (!sv.ok) failSave('save: ' + sv.error + (tries.length > 1 ? ' (tried ' + tries.map(x => x[0]).join(', ') + ')' : ''))
                        const nt = sv.answer?.notification
                        const ntBad = !!nt && ['error', 'critical'].includes(nt.status)
                        if (ntBad) sr.save_notification = (nt.status + ': ' + String(nt.text || nt.header || '')).slice(0, 200)
                        const sign = store.clientTest_saveSign(sv.answer, myCells)
                        sr.save_sign = sign.sign || (sign.stale ? 'stale' : 'none')
                        if (sign.count) sr.save_count = sign.count
                        if (isList) {
                            if (ntBad) failSave('save produced no server write: the backend answered ' + sr.save_notification)
                            if (!sign.sign) failSave('save produced no server write: ' + sign.note)
                            // ответ save списка применён — состояние, которое сервер вернул сразу после записи (до каскада)
                            await store.clientTest_waitStable(W, performance.now(), 60000)
                            sr.hash_saved = store.clientTest_stateHash(W)
                        }
                        // конец каскада ПО ФАКТУ (poll auto_recalc_state), cap 300 с
                        const rc = await store.clientTest_waitRecalc(300000)
                        addPh('save_s', Math.round(performance.now() - t0) / 1000)
                        sr.save_timeout = rc.timeout
                        sr.recalc_wait_s = rc.duration_s
                        // консистентность — принудительное перечитывание С СЕРВЕРА (select мимо гарда несохранённых правок — данные
                        // только из ответа бэка), сверка правленных ячеек: у списка — в ответе сервера И в отрисованном гриде, у отчёта —
                        // в гриде; снимки до записи и после перечитывания — оба в шаге
                        const tSel = performance.now()
                        const rr = await store.clientTest_httpDispatch(W, { command: 'executeWidgetMethod', method: 'select',
                            record_sendToBackend_exclude: ['_doc'], _unsaved_ok: true }, 120000)
                        sr.reread_http_status = rr.status
                        sr.reread_http_s = rr.ms / 1000
                        await store.clientTest_waitStable(W, tSel, 60000)
                        const pq = await store.clientTest_waitStable(store.clientTest_pageEl(), performance.now(), 30000)
                        addPh('recalc_s', pq.stable_s)
                        sr.state_hash = sr.hash_reread = store.clientTest_stateHash(W)
                        // IE 2026 08 28 / ODOO-5828 (решение координатора по Q2): consistent = «МОИ правки пережили
                        // запись и пересчёт» — сверка по правленным ячейкам; смену остального (suggest/draft от
                        // каскада) держим информативным флагом cascade_changed, это не фейл
                        const serverRows = (isList && rr.ok) ? store.clientTest_rowsById(rr.answer?.record?._doc?.data) : null
                        const g2 = store.clientTest_grid(W)
                        const mismatches = []
                        for (const c of myCells) {
                            if (serverRows) {
                                const r = serverRows.get(c.row_key)
                                const v = r ? store.get_value(r, c.col) : undefined
                                if (!r) mismatches.push(c.row_key + '/' + c.col + ': row not in the server answer')
                                else if (!store.clientTest_valSame(v, c.value)) mismatches.push(c.row_key + '/' + c.col + ': server ' + v + ' ≠ ' + c.value)
                            }
                            const row = g2 ? [...g2.flex.rows].find(r => r.dataItem?.id === c.row_key) : null
                            const now = row ? g2.store.get_value(row.dataItem, c.col) : '(row not found)'
                            if (!row || !store.clientTest_valSame(now, c.value)) mismatches.push(c.row_key + '/' + c.col + ': ' + now + ' ≠ ' + c.value)
                        }
                        sr.cells_checked = myCells.length
                        if (mismatches.length) sr.cells_mismatch = mismatches.slice(0, 5)
                        if (isList && sign.weak && (!rr.ok || mismatches.length)) {
                            failSave('save produced no server write: the save answer had no edited rows and the server re-read does not show the written values — '
                                + (rr.ok ? mismatches.slice(0, 3).join('; ') : rr.error))
                        }
                        sr.consistent = rr.ok && !mismatches.length
                        if (!sr.consistent) sr.deviation = ((rr.ok ? '' : 'server re-read: ' + rr.error + (mismatches.length ? '; ' : '')) + mismatches.slice(0, 3).join('; ')).slice(0, 300)
                        sr.snapshot_equal = sr.hash_reread === hashPresave
                        sr.cascade_changed = !sr.snapshot_equal
                    } else if (act === 'measure') {
                        const W = store.clientTest_findOpenW(st.widget) || opened[opened.length - 1]
                        if (!W) throw new Error('measure: target widget not open')
                        store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                        const q = await store.clientTest_waitStable(W, t0, 120000)
                        addPh('measure_s', q.stable_s)
                        sr.state_hash = store.clientTest_stateHash(W)
                    }
                    sr.duration = Math.round((performance.now() - t0)) / 1000
                    steps_result.push(sr)
                }
            } catch (e) {
                phases.error = String(e && e.message || e).slice(0, 200)
                store.show_notification({ text: t('Scenario: {error}', { error: phases.error }), status: 'error' })
            } finally {
                for (const W of opened) { try { store.clientTest_closeTarget(W) } catch (e) { /* уже закрыт */ } }
                if (chipsBackup) {
                    const WS = store.WORKSPACES?.[test.workspace] || store.activeWORKSPACE
                    if (WS?.record?.doc?.params) {
                        WS.record.doc.params.WHERE = chipsBackup
                        try { store.workspace_applySelector(WS.workspace, WS.active_page) } catch (e) { /* страница могла смениться */ }
                        // IE 2026 08 28 / ODOO-5828 (пилот №5: чипсы транзиентно всплывали после возврата):
                        // снимок chipsKeep перезаписывается чистым состоянием ЯВНО — applySelector мог
                        // оборваться до своего сохранения, и переоткрытие стола поднимало чипсы прогона
                        try { store.chipsKeep_save(WS) } catch (e) { /* best effort */ }
                    }
                }
                if (br?.branch_pm) {
                    const tDel = performance.now()
                    const del = await store.clientTest_call(vueObj, 'client_test_branch_delete', { ...brArg, branch_pm: br.branch_pm })
                    phases.branch_delete_s = del?.duration_s ?? Math.round(performance.now() - tDel) / 1000
                    await store.clientTest_switchPm(oldPm)
                }
                if (oldWs) await store.clientTest_gotoPage(oldWs, oldPage)
            }
            phases.total_s = Math.round(performance.now() - tTot0) / 1000
            await store.clientTest_call(vueObj, 'client_test_result',
                { ...brArg, phases, steps_result, snapshots, fe_server: location.host, browser: store.clientTest_browser() })
            store.show_notification({ text: phases.error
                ? t('Scenario test logged with error: {error}', { error: phases.error })
                : t('Scenario test logged: total {sec}s, {steps}, {snapshots}', { sec: phases.total_s,
                    steps: tn(steps_result.length, '{n} step', '{n} steps'), snapshots: tn(Object.keys(snapshots).length, '{n} snapshot', '{n} snapshots') }),
                status: phases.error ? 'error' : 'success' })
            return { phases, steps_result, snapshots }
        },
        async clientTest_editRun(vueObj, test, idArg = {}) {
            // IE 2026 08 28 / ODOO-5828 (заказ Игоря, задача 7): тест «внесение корректировок» — всё ПОД What-if
            // веткой: создать ветку → открыть цель под ПМ ветки → шаги правок (замер отклика) → запись →
            // перечит и сверка с состоянием до записи → удалить ветку; рабочая ПМ вкладки восстанавливается
            const store = this
            const phases = {}
            const steps_result = []
            const tTotal0 = performance.now()
            const oldPm = store.process_model_record?.id || ''
            const brArg = { ...(idArg || {}), ...(test.id ? { test_id: test.id } : {}) }
            store.show_notification({ text: t('Edit test: creating a What-if branch…'), status: 'pending' })   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции)
            const tBr = performance.now()
            const br = await store.clientTest_call(vueObj, 'client_test_branch_create', brArg)
            phases.branch_create_s = br?.duration_s ?? br?.duration ?? Math.round(performance.now() - tBr) / 1000
            if (!br?.branch_pm) {
                store.show_notification({ text: t('Edit test: branch create failed'), status: 'error' })
                return null
            }
            store.show_notification({ text: t('Edit test: branch created {sec}s — opening the target…', { sec: phases.branch_create_s }), status: 'pending' })
            let W = null
            let hashPresave = ''
            const oldWs = store.activeWORKSPACE?.workspace || ''
            const oldPage = store.activeWORKSPACE?.active_page || ''
            try {
                // страница теста из паспорта — параметры виджета-источника рендерятся только на ней
                if (test.workspace && !await store.clientTest_gotoPage(test.workspace, test.page)) throw new Error('navigation to the test page timed out')
                if (!await store.clientTest_switchPm(br.branch_pm)) throw new Error('switch to branch PM timed out')
                const tOpen = performance.now()
                W = await store.clientTest_openTargetW(vueObj, test)
                if (!W) throw new Error('target did not open')
                const stab = await store.clientTest_waitStable(W, tOpen, 60000)
                phases.open_before_s = stab.stable_s
                phases.state_hash_before = store.clientTest_stateHash(W)
                let hashPrev = phases.state_hash_before
                const steps = test.steps || []
                for (let i = 0; i < steps.length; i++) {
                    const stp = steps[i]
                    store.show_notification({ text: t('Edit test: step {i}/{n} — {value} → ({row},{col})', { i: i + 1, n: steps.length, value: stp.value, row: stp.row, col: stp.col_binding || stp.col }), status: 'pending' })
                    const grid = store.clientTest_grid(W)
                    if (!grid) throw new Error('no grid in the target')
                    const col_binding = stp.col_binding || grid.flex.columns[stp.col]?.binding
                    const irow = Number(stp.row)
                    const dataItem = grid.flex.rows[irow]?.dataItem
                    if (!dataItem || !col_binding) throw new Error('step ' + (i + 1) + ': row/col not found')
                    const oldVal = grid.store.get_value(dataItem, col_binding)
                    const tStep = performance.now()
                    grid.set_value(irow, dataItem, col_binding, oldVal, stp.value)
                    const fb = await store.clientTest_waitStable(W, tStep, 60000)
                    const cellNow = String(grid.store.get_value(grid.flex.rows[irow]?.dataItem || {}, col_binding))
                    const hashStep = store.clientTest_stateHash(W)
                    // контракт бэка: n/action/row/col/value/duration_s/consistent/state_before/state_after/fe_feedback_s
                    const sr = { n: i + 1, action: 'edit', row: irow, col: stp.col, col_binding, value: stp.value,
                        fe_feedback_s: fb.stable_s, feedback_timeout: fb.timeout,
                        state_before: hashPrev, state_after: hashStep,
                        value_visible: cellNow === String(stp.value), state_changed: hashStep !== hashPrev,
                        consistent: cellNow === String(stp.value) && hashStep !== hashPrev }
                    hashPrev = hashStep
                    phases.steps_s = Math.round(((phases.steps_s || 0) + (fb.stable_s || 0)) * 1000) / 1000
                    if (stp.save_after) {
                        hashPresave = hashStep
                        const tSave = performance.now()
                        store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'save', binding: '_doc.data',
                            source_name: grid.attr?.name, record_sendToBackend_exclude: ['not _meta.modified data.row'],
                            record_sendToBackend_undoStack: true })
                        const sv = await store.clientTest_waitStable(W, tSave, 120000)
                        sr.save_s = sv.stable_s
                        sr.save_timeout = sv.timeout
                        phases.save_s = Math.round(((phases.save_s || 0) + (sv.stable_s || 0)) * 1000) / 1000
                    }
                    sr.duration_s = Math.round(((fb.stable_s || 0) + (sr.save_s || 0)) * 1000) / 1000
                    steps_result.push(sr)
                }
                phases.state_hash_presave = hashPresave || hashPrev
                store.show_notification({ text: t('Edit test: reselect and consistency check…'), status: 'pending' })
                const tRes = performance.now()
                store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
                const rs = await store.clientTest_waitStable(W, tRes, 120000)
                phases.reselect_s = rs.stable_s
                phases.state_hash_after = store.clientTest_stateHash(W)
                phases.reselect_matches_presave = phases.state_hash_after === phases.state_hash_presave
                const refHash = test.final_state_hash || test.reference_final_state_hash || (test.reference || {}).final_state_hash
                if (refHash) phases.matches_reference = phases.state_hash_after === refHash
            } catch (e) {
                phases.error = String(e && e.message || e).slice(0, 200)
                store.show_notification({ text: t('Edit test: {error}', { error: phases.error }), status: 'error' })
            } finally {
                if (W) store.clientTest_closeTarget(W)
                const tDel = performance.now()
                const del = await store.clientTest_call(vueObj, 'client_test_branch_delete', { ...brArg, branch_pm: br.branch_pm })
                phases.branch_delete_s = del?.duration_s ?? del?.duration ?? Math.round(performance.now() - tDel) / 1000
                await store.clientTest_switchPm(oldPm)
                if (oldWs) await store.clientTest_gotoPage(oldWs, oldPage) // вернуть пользователю его стол/страницу
            }
            phases.total_s = Math.round(performance.now() - tTotal0) / 1000
            await store.clientTest_call(vueObj, 'client_test_result',
                { ...idArg, phases, steps_result, fe_server: location.host, browser: store.clientTest_browser() })
            store.show_notification({ text: phases.error
                ? t('Edit test logged with error: {error}', { error: phases.error })
                : t('Edit test logged: total {sec}s, steps {n}', { sec: phases.total_s, n: steps_result.length })
                    + (phases.reselect_matches_presave === false ? ' ' + t('— RESELECT DIFFERS from pre-save state!') : ''),
                status: phases.error ? 'error' : (phases.reselect_matches_presave === false ? 'warning' : 'success') })
            return { phases, steps_result }
        },
        // ===== IE 2026 08 30 / ODOO-5828 (заказ Игоря): открытие СТРАНИЦЫ на холодных кэшах —
        // сколько на странице виджетов и сколько времени фронт тратит до ГОТОВОГО интерфейса:
        // все догрузки закончены, приложение простаивает и ждёт действий пользователя
        clientTest_pageWidgets(workspace, page, excludeId = '') {
            // виджеты страницы — тем же правилом, каким их считает сам стол (workspace_activate),
            // без закрытых и свёрнутых soft-close
            // IE 2026 08 30 / ODOO-5828 (найдено на прогоне страницы Filters): окно САМОГО теста,
            // открытое поверх страницы, числится её виджетом — его нельзя ни закрывать в холодной
            // фазе (иначе якорь прогона уничтожен и client_test_result уходит в никуда: лог не
            // пишется), ни считать составом страницы. Исключаем ТОЧЕЧНО по id окна-якоря: фильтр
            // по сегменту TEST-DATA был бы шире и срезал бы настоящие виджеты страницы (регистр
            // тестов на странице Filters — это её штатный виджет)
            const WS = this.WORKSPACES?.[workspace] || this.activeWORKSPACE
            return (WS?.ALL_WIDGETS || []).filter(w => w && w.page === page && !w.close && !w._softClosed
                && !(excludeId && w.id === excludeId))
        },
        clientTest_otherPage(workspace, page) {
            // страница, с которой стартует холодное открытие: холодным считается ПОСТРОЕНИЕ страницы,
            // а на активной странице повторная навигация — no-op, виджеты не пересоздаются
            const WS = this.WORKSPACES?.[workspace] || this.activeWORKSPACE
            const loaded = Object.keys(WS?.PAGES || {}).filter(p => p && p !== page)
            if (loaded.length) return loaded[0]
            // IE 2026 09 01 / ODOO-335250: строка без ссылки с attrs = группа страниц — спускаемся
            // внутрь, иначе заголовок группы вернулся бы как «страница»
            const flatPages = (rows, out = []) => {
                for (const p of rows || []) {
                    if (!p || p.use === false) continue
                    if (p?.node?.relation_segment || p?.page) out.push(p?.node?.value || p?.page)
                    else if (Array.isArray(p?.attrs)) flatPages(p.attrs, out)
                }
                return out
            }
            const declared = flatPages(WS?.record?.doc?.pages).filter(p => p && p !== page)
            return declared[0] || ''
        },
        clientTest_pageBusy(workspace, page, excludeId = '') {
            // «фронт ещё работает» — по СЧЁТЧИКАМ приложения, а не по затишью DOM: P0 (_primary_inflight,
            // данные виджетов), P1 (очередь словарей get_itemsSource), P2 (_deferred_actions, отложенное
            // второстепенное), плюс loading самих виджетов, их живые xhr и спиннер В ПРЕДЕЛАХ страницы.
            // Ровно по этим счётчикам приложение само решает, что оно простаивает (flush_deferredActions)
            const store = this
            const widgets = store.clientTest_pageWidgets(workspace, page, excludeId)
            const primary = store._primary_inflight || 0
            const dicts = Object.keys(store._itemsSource_active || {}).length
                + Object.keys(store._itemsSource_queue || {}).length
            const deferred = (store._deferred_actions || []).length
            const loading = widgets.filter(w => w.loading).length
            const xhr = widgets.filter(w => [w._openRequest, w._activeRequest, w._pollActiveRequest]
                .some(r => r && r.readyState !== 4)).length
            const pageEl = store.clientTest_pageEl()?.vueObj?.$el
            const spinner = pageEl && pageEl.querySelector('.p-progress-spinner, .wj-loading') ? 1 : 0
            return { busy: !!(primary || dicts || deferred || loading || xhr || spinner),
                primary, dicts, deferred, loading, xhr, spinner, widgets: widgets.length }
        },
        async clientTest_waitPageReady(workspace, page, t0, maxMs = 180000, quietMs = 1500, excludeId = '') {
            // готовность = quietMs подряд без единого признака занятости; сами эти секунды тишины
            // в замер НЕ входят (как в clientTest_waitStable). Попутно отмечаем, когда «доехал»
            // каждый виджет — момент, с которого он отрисован и больше не грузится
            const store = this
            const readyAt = new Map()
            const tEnd = performance.now() + maxMs
            let quietSince = 0, last = null, sig = '', sigSince = performance.now()
            while (performance.now() < tEnd) {
                await new Promise(res => setTimeout(res, 250))
                const st = store.clientTest_pageBusy(workspace, page, excludeId)
                last = st
                for (const W of store.clientTest_pageWidgets(workspace, page, excludeId)) {
                    if (!readyAt.has(W.id) && !W.loading && W.vueObj?.$el) readyAt.set(W.id, performance.now())
                }
                const s = [st.primary, st.dicts, st.deferred, st.loading, st.xhr, st.spinner].join('/')
                if (s !== sig) { sig = s; sigSince = performance.now() }
                // залипший счётчик не должен ронять тест: у самого приложения на этот случай есть
                // потолок ожидания P2 (~20 с в flush_deferredActions). Если ВИДИМОЙ работы нет
                // (виджеты не грузятся, xhr закрыты, спиннера нет), а абстрактный счётчик не
                // меняется дольше 20 с — считаем интерфейс готовым и помечаем это в результате
                const visibleBusy = st.loading || st.xhr || st.spinner
                const stalled = st.busy && !visibleBusy && performance.now() - sigSince > 20000
                // пустая страница (виджетов нет вовсе) не должна висеть до таймаута — даём ей 20 с
                const built = st.widgets > 0 || performance.now() - t0 > 20000
                if ((!st.busy || stalled) && built) {
                    if (!quietSince) quietSince = performance.now()
                    if (performance.now() - quietSince >= quietMs) {
                        return { ready_s: Math.round(quietSince - t0) / 1000, timeout: false, readyAt, state: st,
                            stalled: stalled ? sig : '' }
                    }
                } else {
                    quietSince = 0
                }
            }
            return { ready_s: Math.round(performance.now() - t0) / 1000, timeout: true, readyAt, state: last, stalled: '' }
        },
        async clientTest_pageOpen(vueObj, test, idArg = {}) {
            // IE 2026 08 30 / ODOO-5828 (заказ Игоря): вид теста page-open — холодное открытие страницы
            const store = this
            const phases = {}
            const tTot0 = performance.now()
            const arg = { ...(idArg || {}), ...(test.id ? { test_id: test.id } : {}) }
            const oldWs = store.activeWORKSPACE?.workspace || ''
            const oldPage = store.activeWORKSPACE?.active_page || ''
            const ws = test.workspace || oldWs
            const page = test.page || ''
            // IE 2026 08 30 / ODOO-5828: окно, ИЗ которого запущен тест (карточка теста поверх страницы),
            // не относится к составу страницы и не должно закрываться холодной фазой — иначе прогон
            // теряет якорь и отчёт не уходит на бэк (поймано на прогоне страницы Filters)
            const anchorId = (() => {
                for (const W of (store.WORKSPACES?.[ws]?.ALL_WIDGETS || store.activeWORKSPACE?.ALL_WIDGETS || [])) {
                    if (W && (W.vueObj === vueObj || (test.id && W.record?.id === test.id))) return W.id
                }
                return ''
            })()
            const widgets = []
            let widgets_count = 0
            let note = ''
            try {
                if (!ws || !page) throw new Error('page-open test has no workspace/page in its passport')
                // 1) ХОЛОДНЫЕ КЭШИ: уходим с целевой страницы, сносим её виджеты (иначе активация
                // страницы их только освежит) и чистим словари данных приложения
                const tCold = performance.now()
                store.show_notification({ text: t('Page open test: cooling caches…'), status: 'pending' })   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции)
                if (store.activeWORKSPACE?.workspace === ws && store.activeWORKSPACE?.active_page === page) {
                    const other = store.clientTest_otherPage(ws, page)
                    if (other) await store.clientTest_gotoPage(ws, other)
                }
                if (test.cold === false) {
                    note = 'warm run (cold=false): caches and widgets kept'
                } else {
                    // IE 2026 08 30 / ODOO-5828: карточка теста, открытая НА тестируемой странице, остаётся
                    // её виджетом в ALL_WIDGETS — страница считается построенной и после холодного закрытия
                    // НЕ пересобирается (замер вышел бы «0 виджетов»). Честно предупреждаем: запускать такой
                    // тест надо с другой страницы
                    const anchorW = (store.WORKSPACES?.[ws]?.ALL_WIDGETS || []).find(w => w && w.id === anchorId)
                    if (anchorW && anchorW.page === page) {
                        store.show_notification({ text: t('Page open test: run it from another page — the test card is open on the page being measured'),
                            status: 'warning' })
                        note = 'test card is open on the measured page: the page is not rebuilt, composition/timing are not comparable; '
                    }
                    let closed = 0
                    for (const W of store.clientTest_pageWidgets(ws, page, anchorId)) {
                        try { store.widget_close(W.id, false, true); closed++ }
                        catch (e) { console.warn('page-open: widget_close', W.id, e) }
                    }
                    const cc = store.clientTest_clearCaches()
                    note = 'cold: page widgets closed ' + closed + ', data dictionaries cleared ' + cc.cleared
                        + ' (structural kept ' + cc.kept + '); browser HTTP cache not cleared'
                }
                phases.cold_clear_s = Math.round(performance.now() - tCold) / 1000
                // 2) открытие страницы — отсюда идёт время, которое видит пользователь
                const t0 = performance.now()
                store.show_notification({ text: t('Page open test: opening the page…'), status: 'pending' })
                const nav = await store.clientTest_gotoPage(ws, page)
                phases.nav_s = Math.round(performance.now() - t0) / 1000
                if (!nav) throw new Error('navigation to the test page timed out')
                // 3) готовность интерфейса
                const maxMs = Math.max(30, Number(test.timeout_s) || 180) * 1000
                const rd = await store.clientTest_waitPageReady(ws, page, t0, maxMs, 1500, anchorId)
                phases.ready_s = rd.ready_s
                if (rd.stalled) note += ' · counters stalled (primary/dicts/deferred/loading/xhr/spinner = ' + rd.stalled + ')'
                // 4) состав страницы: что открылось и когда доехал каждый виджет
                const list = store.clientTest_pageWidgets(ws, page, anchorId)
                widgets_count = list.length
                for (const W of list) {
                    const grid = store.clientTest_grid(W)
                    const at = rd.readyAt.get(W.id)
                    const data = W.record?._doc?.data
                    widgets.push({
                        id: String(W.record?.id || W.widget || W.id || ''),
                        title: String(W.title || W.record?.title || W.widget || '').slice(0, 120),
                        type: String(W.widget_class || W.record?.segment || W.widget || ''),
                        rows: grid?.flex?.rows?.length ?? (Array.isArray(data) ? data.length : null),
                        duration_s: at ? Math.round(at - t0) / 1000 : null,
                    })
                }
                widgets.sort((a, b) => (b.duration_s ?? 0) - (a.duration_s ?? 0))
                if (rd.timeout) {
                    const s = rd.state || {}
                    throw new Error('page is still busy after ' + Math.round(maxMs / 1000) + 's (primary ' + (s.primary ?? '?')
                        + ', dictionaries ' + (s.dicts ?? '?') + ', deferred ' + (s.deferred ?? '?')
                        + ', widgets loading ' + (s.loading ?? '?') + ')')
                }
            } catch (e) {
                phases.error = String(e && e.message || e).slice(0, 200)
                store.show_notification({ text: t('Page open test: {error}', { error: phases.error }), status: 'error' })
            } finally {
                // вернуть пользователю его стол/страницу
                if (oldWs && (oldWs !== ws || oldPage !== page)) await store.clientTest_gotoPage(oldWs, oldPage)
            }
            phases.total_s = Math.round(performance.now() - tTot0) / 1000
            await store.clientTest_call(vueObj, 'client_test_result',
                { ...arg, phases, widgets_count, widgets, note,
                    fe_server: location.host, browser: store.clientTest_browser() })
            store.show_notification({ text: phases.error
                ? t('Page open test logged with error: {error}', { error: phases.error })
                : t('Page open test logged: {widgets}, ready in {ready}s (total {total}s)', { widgets: tn(widgets_count, '{n} widget', '{n} widgets'),
                    ready: phases.ready_s, total: phases.total_s }),
                status: phases.error ? 'error' : 'success' })
            return { phases, widgets_count, widgets }
        },
        async clientTest_runOne(vueObj, testId = null) {
            const store = this
            const idArg = testId ? { test_id: testId } : {}
            const prep = await store.clientTest_call(vueObj, 'client_test_prepare', idArg)
            const test = prep?.test
            if (!test) {
                store.show_notification({ text: t('Client test: prepare failed (no test in response)'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции)
                return null
            }
            // IE 2026 08 28 / ODOO-5828 (заказ Игоря, задача 7): вид «внесение корректировок» — свой поток
            if (test.test_type === 'edit-run') {
                return store.clientTest_editRun(vueObj, test, idArg)
            }
            // IE 2026 08 28 / ODOO-5828: записанный сценарий — исполнение таблицы Steps
            if (test.test_type === 'scenario-run') {
                return store.clientTest_scenarioRun(vueObj, test, idArg)
            }
            // IE 2026 08 30 / ODOO-5828 (заказ Игоря): холодное открытие страницы — свой раннер
            if (test.test_type === 'page-open') {
                return store.clientTest_pageOpen(vueObj, test, idArg)
            }
            const cc = store.clientTest_clearCaches()
            const passes = []
            passes.push(await store.clientTest_pass(vueObj, test, 'cold',
                'app data dictionaries cleared: ' + cc.cleared + ' (structural kept: ' + cc.kept + '; backend: ' + (prep.cleared ?? 0) + '); browser HTTP cache not cleared'))
            if (test.hot_run) {
                await new Promise(res => setTimeout(res, 300))
                passes.push(await store.clientTest_pass(vueObj, test, 'hot', 'no cache clearing (hot pass)'))
            }
            await store.clientTest_call(vueObj, 'client_test_result',
                { ...idArg, passes, fe_server: location.host, browser: store.clientTest_browser() })
            const hot = passes.find(x => x.mode === 'hot')
            store.show_notification({ text: t('Client test logged: cold {cold}s', { cold: passes[0]?.fe_duration ?? '?' })
                + (hot ? ' · ' + t('hot {hot}s', { hot: hot.fe_duration ?? '?' }) : ''), status: 'success' })
            return passes
        },
        async clientTest_run(vueObj) {
            const store = this
            if (store._clientTest_running) { store._clientTests_abort = true; return }
            store._clientTest_running = true
            try { await store.clientTest_runOne(vueObj) } finally { store._clientTest_running = false }
        },
        async clientTests_run(vueObj) {
            const store = this
            if (store._clientTest_running) {
                store._clientTests_abort = true
                store.show_notification({ text: t('Client tests: stopping after the current test…'), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции; цикл: t → tst)
                return
            }
            const list = await store.clientTest_call(vueObj, 'client_tests_list')
            const tests = list?.tests || []
            if (!tests.length) { store.show_notification({ text: t('Client tests: the task has no tests to run'), status: 'warning' }); return }
            store._clientTest_running = true
            store._clientTests_abort = false
            const onKey = (e) => { if (e.key === 'Escape') store._clientTests_abort = true }
            window.addEventListener('keydown', onKey)
            let done = 0
            try {
                for (const tst of tests) {
                    if (store._clientTests_abort) break
                    done++
                    store.show_notification({ text: t('Client tests: {done}/{total} — {title}', { done, total: tests.length, title: tst.title || tst.id }), status: 'pending' })
                    await store.clientTest_runOne(vueObj, tst.id)
                    await new Promise(res => setTimeout(res, 300))
                }
            } finally {
                window.removeEventListener('keydown', onKey)
                store._clientTest_running = false
            }
            store.show_notification({ text: store._clientTests_abort
                ? t('Client tests: stopped by user after {done}/{total}', { done, total: tests.length })
                : t('Client tests: finished {done}/{total} (see the task logs)', { done, total: tests.length }), status: store._clientTests_abort ? 'warning' : 'success' })
        },
        async executeWidgetMethod(vueObj, action, form_attr=null, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            // console.log(`executeWidgetMethod prepare1: ${Math.round(performance.now() - FRONTEND_start) / 1000} sec`)
            const timeStart0 = performance.now()
            const store = this
            let WIDGET = vueObj.WIDGET
            if (WIDGET.close) { return }
            if (store.readonly_denyAction(action, 'executeWidgetMethod')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — метод записи / запуска не шлём (тост; фоновый вызов — молча)
            // новый запрос отменяет прежний запрет отрисовки (Stop во время построения)
            if (!action._isPoll && WIDGET._renderStopped) WIDGET._renderStopped = false
            if (!action._isPoll && !action.no_del_last_backend_action) WIDGET.loading = true
            // R17 (dm 2026 08 04): прогресс формирования отчёта — ключ в params + поллинг
            if (!action._isPoll && action.method === 'select' && /REPORT2/.test(WIDGET.widget_class || WIDGET.record?.segment || '')) {
                const _rpKey = store.report_progress_start(WIDGET, vueObj)
                if (_rpKey) action.params = { ...(action.params || {}), _progress_key: _rpKey }
            }
            WIDGET.executeWidgetMethod_id = store.nextExecuteWidgetMethod_id++
            WIDGET.notification = WIDGET.notification || {}
            if (!action._isPoll && !action.no_del_last_backend_action) store.notification_softClear(WIDGET)

            // If there is a previous unfinished request, delete it
            let del_last_backend_action = null
            const _writeGuardOn = saveTruncatedRetry_on((k, d) => store.setting(k, d))   // IE 2026 10 13 / ODOO-5800: флаг fe.ux.saveTruncatedRetry
            if (!action._isPoll && WIDGET._activeRequest && WIDGET._activeRequest.readyState !== 4
                && !action.no_del_last_backend_action
                && abort_allowed(WIDGET._activeRequest, _writeGuardOn)   // IE 2026 10 13 / ODOO-5800: сохранение в полёте следующий запрос не обрывает и на бэке не отменяет
            ) {
                try {
                    WIDGET._activeRequest.abort()
                    WIDGET.last_backend_action
                    // if (!store.hide_console) {
                        console.log(`[${WIDGET.id}] previous request cancelled`)
                    // }
                    del_last_backend_action = WIDGET.last_backend_action
                } catch (e) {
                    console.warn("Error canceling request:", e)
                }
                WIDGET._pollTask = null
                if (WIDGET._pollActiveRequest && WIDGET._pollActiveRequest.readyState !== 4) {
                    WIDGET._pollActiveRequest.abort()
                }
            }

            let action_binding = action.binding
            if (!action_binding && form_attr !== null) {
                action_binding = action.binding = form_attr.binding
            }
            // Reload виджета: превью печати — клиентская проекция (_doc в reload
            // не участвует) и без сброса оставалось бы устаревшим (смена подписи
            // пользователя/шаблона). Сбрасываем: видимая вкладка печати сама
            // перезапросит get_print (вотчер AttrGridGroup), скрытая — при показе
            if (action.method === 'reload' && WIDGET.record?._doc?.printPreview) {
                delete WIDGET.record._doc.printPreview
            }
            // IE 2026 09 06 / ODOO-336658 (заказ Игоря): Update data отчёта — с ключом серверного кэша виджета, как обновление
            // по чипу (ветка ниже): бэк мержит request.WIDGET поверх redis-копии и берёт view (а без правок записи — и record)
            // из кэша вместо set_view+set_menu (0,25–0,5 с на каждый select без view). При потере кэша бэк отвечает
            // repeatFullRequest → полный запрос (обработчик ниже). Тот же флаг dl2Engine.slimSelect; ключ берём свежий
            // из WIDGET на каждый клик (объект команды переиспользуется между кликами).
            if (action.method === 'select' && WIDGET.widget_class === 'widget_REPORT2' && store.dl2Engine?.slimSelect !== false) {
                if (WIDGET.widget_cache_key) action.widget_cache_key = WIDGET.widget_cache_key
                else delete action.widget_cache_key
            }
            // IE 2026 09 25 / ODOO-341407 (замер dev02 25.09: после живого переключения языка каждый отчёт сначала получал repeatFullRequest — ключ
            // серверного кэша выдан под прежний язык (widgets.widget_cache_key_lang_ok бэка), — и только вторым запросом строился; под нагрузкой
            // лишний круг стоил 4–10 с): ключ под другой язык снимается ДО запроса — сразу полный запрос. Выкл: window.i18nSwitch.set('switchNoRepeat', false)
            if (action.widget_cache_key && i18n_cacheKeyLangStale(action.widget_cache_key, store.user?.language) && i18n_switchFlag(store, 'switchNoRepeat')) {
                delete action.widget_cache_key
                if (i18n_cacheKeyLangStale(WIDGET.widget_cache_key, store.user?.language)) delete WIDGET.widget_cache_key
                store._i18nNoRepeat = (store._i18nNoRepeat || 0) + 1
            }
            let [widget_to_transfer, doc_stayOnFront] = store.get_widget_to_transfer(vueObj, action)
            // IE 2026 09 19 / ODOO-5800 (находка ie-dm7 #30048: гонка ответов применения селекторов): номер отправки и состав чипсов стола на этот момент — в замыкании
            // (объект action переиспользуется между вызовами); вариант параметров запроса — тоже
            const _wsSent = (() => {
                const WS0 = store.WORKSPACES?.[WIDGET.workspace]
                if (!WS0?.record?.doc?.params) return null
                try { store.whereFront_stamp(WS0); return { seq: store._wsSeq = (store._wsSeq || 0) + 1, sig: store.whereUser_sig(WS0), variant: !!action._wsParamsVariant } } catch (e) { return null }
            })()
            if (action.widget_cache_key) {
                // Фронтовые чипсы (CHIP-Search и пр., кроме CHIP-Selector) добавляются мутацией
                // массива doc.viewParams.*.CHIPS на месте, минуя set_value → _meta.modified НЕ
                // взводится. Бек такие чипсы в кэше не держит (регенерит из запроса только
                // CHIP-Selector), поэтому восстановление из устаревшего кэша их теряет.
                const vp = WIDGET.record?.doc?.viewParams
                const has_frontChips = !!vp && Object.values(vp).some(
                    p => Array.isArray(p?.CHIPS) && p.CHIPS.some(c => c && c.segment !== 'CHIP-Selector')
                )
                const _ogDirty = store.setting('fe.data.optionGroupsSyncRecord', true) !== false ? (WIDGET._ogFrontDirty || 0) : 0   // IE 2026 09 19 / ODOO-…: группы строк переключались на фронте — запись новее серверного кэша
                if (WIDGET.record?._meta?.modified) {
                    // Модифицирован → сбрасываем cache_key → полная
                    // пересборка из настроек. Данные отчёта (record._doc) не шлём — только настройки,
                    // бек пересоберёт данные.
                    delete action.widget_cache_key
                    if (widget_to_transfer.record && '_doc' in widget_to_transfer.record) {
                        widget_to_transfer.record = { ...widget_to_transfer.record }
                        delete widget_to_transfer.record._doc
                    }
                } else if (has_frontChips || _ogDirty) {   // IE 2026 09 19 / ODOO-…: + группы строк, переключённые на фронте (mainStore.optionGroup_toggleFast)
                    // Фронтовые чипсы БЕЗ модификации записи: cache_key ОСТАВЛЯЕМ, шлём record
                    // (настройки + CHIPS, без _doc) и НЕ шлём view — бек мержит request.WIDGET
                    // поверх кэша ({**widget_cache, **request.WIDGET}): record с чипсами берётся
                    // из запроса, view — из серверного кэша. Раньше здесь сбрасывался cache_key и
                    // фронт слал полный view ~1 МБ несжатым POST'ом на каждый select при
                    // поиске/фильтре (ODOO-3268, ODOO-2733). При потере кэша бек вернёт
                    // repeatFullRequest → фронт повторит полный запрос (обработчик ниже).
                    delete widget_to_transfer.view
                    if (widget_to_transfer.record && '_doc' in widget_to_transfer.record) {
                        widget_to_transfer.record = { ...widget_to_transfer.record }
                        delete widget_to_transfer.record._doc
                    }
                } else {
                    // widget_to_transfer = {}
                    delete widget_to_transfer.record
                    delete widget_to_transfer.view
                }
            }
            // IE 2026 09 19 / ODOO-…: select повёз запись с состоянием групп строк, переключённых на фронте, — отметку снимет его ответ
            const _ogDirtySent = (WIDGET._ogFrontDirty && widget_to_transfer.record && action.method === 'select') ? WIDGET._ogFrontDirty : 0
            const request = {}
            if (action.get_selectedRanges) {
                request.selectedRanges = vueObj.get_selectedRanges(action_binding)
            }
            if (action.get_feSelected && vueObj.get_feSelected) {
                request.feSelected = vueObj.get_feSelected(action_binding)
            }
            if (action.get_currentRow && vueObj.get_currentRow) {
                request.currentRow = vueObj.get_currentRow(action_binding)
            }
            if (action.get_currentRow && vueObj.get_currentGroup) {   // IE 2026 11 03 / ODOO-349799 (group-records)
                const _cg = vueObj.get_currentGroup(action_binding)   // IE 2026 11 03 / ODOO-349799 (group-records)
                if (_cg) request.currentGroup = _cg   // IE 2026 11 03 / ODOO-349799 (group-records): строка-группа выделена — отдельный ключ, currentRow остаётся []
            }
            if (!action._isPoll && !action.no_del_last_backend_action) WIDGET.last_backend_action = action.action_id_front
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    ...store.client_requestParams(), // IE 2026 09 04 / ODOO-336291 (mobile UX): client.mobile → мобильные лимиты данных
                    ...(action._isPoll ? {} : store.ganttMoves_requestParams(WIDGET, action.method)), // IE 2026 09 26 / ODOO-5800: select списка — строки только для Ганта движений (fe.gantt.serverFilter)
                    ...graphRowsRef_requestParams(WIDGET, action, (k, d) => store.setting(k, d)), // webscm 2026 10 26 / ODOO-348733: select сетевого графа — строки без второй копии узлов / рёбер (utils/graphPayload.js; fe.perf.graphRowsRef)
                    // IE 2026 09 05 / ODOO-336379 (план ускорения M03, шаг 4): выключатель «дельты после save» —
                    // бэк без полного re-select отвечает gridSaved; off → прежний полный select (window.saveDelta.set(false))
                    ...(action.method === 'save' && !store.perf_flag_widget(WIDGET, 'save_delta', true) ? { report_save_delta_off: true } : {}), // IE 2026 09 05 / ODOO-336379: + выключатель записи (Params → Frontend)
                    // IE 2026 09 05 / ODOO-336379 (шаг 4): выключатель gzip больших ответов бэка — off → response_gzip_off в каждом запросе (window.perf.set('response_gzip', false))
                    ...(!store.perf_flag('response_gzip', true) ? { response_gzip_off: true } : {}),
                    // R2/R3: попросить бэк приложить словари ссылочных колонок к ответу
                    // (#77.3: selectorsOnce=false — выключатель одного пересчёта селекторов)
                    ...(store.fastEntry.inlineIS || store.fastEntry.selectorsOnce === false ? { fast_entry: {
                        ...(store.fastEntry.inlineIS ? store.fast_entry_requestParams() : {}),
                        ...(store.fastEntry.selectorsOnce === false ? { selectorsOnce: false } : {}),
                    } } : {}),
                    ...action,
                    ...(heatmapStep_on((k, d) => store.setting(k, d)) ? heatmap_period_requestParams(WIDGET._heatmapPeriod, action) : {}),   // IE 2026 10 31 / ODOO-5800 (заказ Игоря: группировка по місяцях і роках, період): select списка с выбранным на вкладке Heatmap шагом / периодом — request.params.heatmap = { step, days } (кнопка Update data, чипсы — тоже); fe.ux.heatmapStepSwitch
                    // IE 2026 08 19 / ODOO-5512 (заказ Игоря): «Update data» (⟳) у виджета-
                    // расшифровки = пересобрать кэш источников на бэке, а не читать снимок
                    ...(action.method === 'select' && WIDGET._drilldown_source != null && !action.drilldown_cache
                        && !action._isPoll ? { drilldown_cache: true, drilldown_cache_reset: true } : {}),
                    // IE 2026 08 19 / ODOO-5512: период расшифровки — с каждым select цели
                    ...(action.method === 'select' && WIDGET.drilldown_period ? { drilldown_period: WIDGET.drilldown_period } : {}),
                    ...(action._isPoll && WIDGET._pollTask ? { last_sequence_id: WIDGET._pollTask.sequence_id ?? null } : {}),
                    ...request,
                    process_model: store.process_model_record.id,
                    workspace: WIDGET.workspace,
                    ...saveAsTest_params(WIDGET, action),   // IE 2026 09 28 / ODOO-342342 (п.14): «Save as data test» — страница виджета в request.page; IE 2026 09 29 / ODOO-342342 (ревью п.5): входы — грид и форма записи, у формы ячейки пункта нет
                    // command: 'executeWidgetMethod', 
                    // method: action.method, 
                    WIDGET: widget_to_transfer,
                    user: store.user,
                    action_id_front: store.net_actionId(action.action_id_front), // IE 2026 09 26 / ODOO-5800: '<вкладка>-<N>' (fe.net.actionIdUnique); внутри фронта — число
                    del_last_backend_action: store.net_actionId(del_last_backend_action, 'cancel'), // IE 2026 09 26 / ODOO-5800
                    ...store.net_requestParams(), // IE 2026 09 26 / ODOO-5800: выключатель ключа отмены бэка (fe.net.cancelKeyScoped)
                })
                const send_packege_size = Math.round(payload.length / 1024)
                // console.log(`executeWidgetMethod prepare2: ${Math.round(performance.now() - timeStart0) / 1000} sec`)
                
                if (action.sendBeacon) {
                    // console.log(`executeWidgetMethod sendBeacon: ${Math.round(performance.now() - timeStart0) / 1000} sec`)
                    // navigator.sendBeacon(store.url_backend_api, payload)
                    $.ajax({
                        url: store.url_backend_api,
                        type: "POST",
                        data: payload,
                        contentType: "application/json",
                        dataType: 'json',
                        async: true,
                            success: null,
                            error: null
                        });
                    WIDGET.loading = false
                    store.report_progress_stop(WIDGET) // R17
                    const _pollKey = JSON.stringify([action.pollTask?.method, action.pollTask?.params ?? null])
                    // дедуп: эта задача уже поллится (save и select кладут одинаковый
                    // pollTask; повторные select — ещё) — второй цикл не заводим,
                    // иначе отставшие ответы оживляют pending-плашку после финала
                    if (action.pollTask && WIDGET._pollTask?.key === _pollKey) { /* уже поллится */ } else if (action.pollTask) {
                        const startTime = Date.now()
                        const interval  = action.pollTask.interval ?? store.setting('fe.polling.pollTaskIntervalMs', 5000)   // IE 2026 09 05 / ODOO-336330
                        const maxTime   = action.pollTask.maxTime  ?? store.setting('fe.polling.pollTaskMaxMin', 30) * 60 * 1000
                        const pollAction = {
                            ...action.pollTask,
                            _isPoll: true,
                            _pollMeta: { startTime, interval, maxTime },
                        }
                        WIDGET._pollTask = { startTime, sequence_id: null, key: _pollKey }
                        if (!action.no_notification) {
                            WIDGET.notification = WIDGET.notification || {}
                            WIDGET.notification.text = t('Waiting for task...')   // IE 2026 09 23 / ODOO-341407: i18n
                            WIDGET.notification.status = 'pending'
                            WIDGET.notification.visible = true
                        }
                        window.$cg.setTimeout(vueObj, 'pollTask', () => {
                            if (WIDGET._pollTask) store.executeWidgetMethod(vueObj, pollAction)
                        }, interval)
                    }
                    return
                }

                
                let _ewm_counted = false
                const _ewm_bg = request_isBackground(action)   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0): фоновый запрос (порция предзагрузки) — не P0 и не _activeRequest
                if (!action._isPoll && !_ewm_bg) {   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0)
                    // P0-запрос виджета в полёте — отложенная очередь (P2) ждёт.
                    // Счёт в замыкании (не на action): action переиспользуется
                    // между повторными вызовами одного метода виджета.
                    if (action._preCounted) {
                        // loading-select уже зарезервировал primary-слот синхронно
                        // в widget_checkLoading (до async-окна) — здесь только
                        // перенимаем владение слотом, повторно не считаем.
                        delete action._preCounted
                    } else {
                        store._primary_inflight = (store._primary_inflight || 0) + 1
                    }
                    _ewm_counted = true
                }
                const _release_primary = () => {
                    if (_ewm_counted) {
                        _ewm_counted = false
                        store._primary_inflight = Math.max(0, (store._primary_inflight || 1) - 1)
                    }
                }
                const _jqXHR = $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        _release_primary()
                        if (WIDGET.close) { return }
                        // IE 2026 09 26 / ODOO-5800: 204 — запрос отменён на бэке, а фронт его не обрывал (свой отменённый обрывается abort'ом): без TypeError, из загрузки;
                        // ответ устаревшего запроса (виджет ждёт более нового) — молча (fe.net.cancel204Safe)
                        if (jqXHR?.status === 204 && store.net_on204(WIDGET, { where: 'executeWidgetMethod', action,
                            superseded: !action._isPoll && WIDGET.last_backend_action > action.action_id_front })) return
                        // ответ поллинга, чей цикл уже завершён (финал пришёл в
                        // параллельном цикле): его pending перекрашивал плашку ПОСЛЕ
                        // итога и висел вечно — гасить его больше некому
                        if (action._isPoll && !WIDGET._pollTask && answer?.notification?.status === 'pending') {
                            delete answer.notification
                        }
                        // IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Н1): тихий метод (личные отметки кейсов: бэк не принял — значение остаётся в браузере) —
                        // уведомление ошибки бэка тостом не показываем; сам ответ (status / error) вызывающий получает как есть
                        if (action.quiet_errors && answer && typeof answer === 'object' && ['error', 'critical', 'warning'].includes(answer.notification?.status)) {
                            answer.notification_quiet = answer.notification
                            delete answer.notification
                        }
                        // IE 2026 11 03 / ODOO-5800 (заказ Игоря 30.10 «по рекомендациям»: утверждение планов из Баланса, этап B — правки по пробе p239): вызывающий сам показывает итог ответа
                        // (dry plan_decision — только окно подтверждения, utils/planApproval.planApproval_call): уведомление бэка — не тостом, в notification_quiet; панель «#» (answer.TERMINAL) прежняя.
                        // Только у действия с хуком _muteNotification(answer) → true; прочие вызовы — как были
                        if (typeof action._muteNotification === 'function' && answer && typeof answer === 'object' && answer.notification) {
                            try { if (action._muteNotification(answer)) { answer.notification_quiet = answer.notification; delete answer.notification } } catch (e) { /* хук не роняет ответ */ }
                        }
                        // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P5: ответ команды согласования — служебный префикс статуса бэка («!!ERROR » / «!WARNING » / «!!!CRITICAL ») в тексте тоста
                        // не показываем (уровень уже в notification.status — цвет плашки); панель «#» (answer.TERMINAL) прежняя. Выключатель fe.ux.approval
                        if (answer && typeof answer === 'object' && answer.notification && /^approval_/.test(String(action.method || '')) && store.setting('fe.ux.approval', true) !== false) answer.notification = approval_notification(answer.notification)
                        store.TERMINAL(WIDGET, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (answer && typeof answer === 'object') graphRowsRef_restore(answer.record)   // webscm 2026 10 26 / ODOO-348733: строки ответа сетевого графа (ссылки graph_rows_ref) — сразу, до любого читателя ответа (колбэк клиентских тестов, updateDoc)
                        // IE 2026 08 28 / ODOO-5828: промис-обёртке клиентских тестов нужен сам ответ (в payload колбэк не уходит — JSON.stringify функции отбрасывает)
                        if (typeof action._response_callback === 'function') { try { action._response_callback(answer) } catch (e) { console.warn('client-test callback:', e) } }
                        if (!store.check_loginAfterAjax(vueObj, answer)) return
                        if (!action._isPoll && WIDGET.last_backend_action > action.action_id_front) {
                            if (!store.hide_console) console.log(`[${WIDGET.id}][${action.action_id_front}]${action.command} ${action.method} BREAK: ${Math.round(performance.now() - send_start) / 1000}`)
                            return
                        }
                        // IE 2026 09 24 / ODOO-5800: ответ reload по устаревшему поколению групп опций (после отправки переключали ещё) — не применяем
                        if (action._ogSeq != null && WIDGET._ogSeq !== action._ogSeq) {
                            if (!store.hide_console) console.log(`[${WIDGET.id}][${action.action_id_front}] option groups reload #${action._ogSeq} BREAK: generation ${WIDGET._ogSeq} is newer`)
                            return
                        }
                        if (!store.hide_console) console.log(`[${WIDGET.id}][${action.action_id_front}]${action.command} ${action.method} FINISH: ${Math.round(performance.now() - send_start) / 1000}`)

                        if (answer.repeatFullRequest) {
                            delete action.widget_cache_key
                            delete action.record_sendToFrontend_exclude
                            delete WIDGET.widget_cache_key

                            return store.executeWidgetMethod(vueObj, action)
                        }

                        // IE 2026 09 19 / ODOO-…: запись с состоянием групп строк дошла до бэка (виджет перекеширован) — отметка снята, если группы с тех пор не трогали
                        if (_ogDirtySent && WIDGET._ogFrontDirty === _ogDirtySent && answer.record) delete WIDGET._ogFrontDirty
                        for (let key in doc_stayOnFront) {
                            answer.record[key] = doc_stayOnFront[key]
                        }

                        if (answer.workspace_params) {
                            // гейт от гонки PM-контекстов: ответ запроса, ушедшего до
                            // переключения модели, несёт селекторы ЧУЖОЙ PM (метка
                            // calc_selectors_mark = '<pm_id>·<version>') — не даём ему
                            // перетереть стор текущей модели
                            const _mark = String(answer.workspace_params.calc_selectors_mark || '')
                            const _curPm = store.process_model_record?.id || ''
                            if (_mark && _curPm && _mark.split('·')[0] !== _curPm) {
                                console.warn('workspace_params ignored: mark', _mark, 'vs current PM', _curPm)
                                answer.workspace_params = null
                            }
                        }
                        if (answer.workspace_params) {
                            // АН 2026 08 15 / ODOO-4997 (критичный баг Игоря): поздний ответ
                            // волны открытия приносил params из ЗАПИСИ стола и затирал
                            // ЛИЧНЫЕ чипсы («Save filters as my defaults»), применённые при
                            // открытии. Пользовательские (не calc*) строки WHERE в сторе —
                            // истина фронта: если они уже есть и НЕПУСТЫЕ, из ответа
                            // принимаем только calc*-строки (их считает бэк), остальные
                            // params-ключи — из ответа.
                            const _isCalcRow = (r) => String((r?.leftValue || {}).value || '').startsWith('calc')
                            // IE 2026 09 27 / ODOO-… (дефект: rel_* селекторы после ответа): core #46293 — связанные виджеты кокпита
                            // workspace-databases перестали фильтроваться. Служебные строки селекторов, которые считает БЭК, — такие же производные, как calc*:
                            // hidden (workspaces.set_row_selector ставит hidden всем строкам, что пишет сам) и rel_<SEGMENT> (admin_methods.workspace_related_selector —
                            // связанные множества id по чипсам стола; на select бэк их не пересчитывает — selectors_stale смотрит только calc*). Фронт такие строки
                            // не создаёт и чипсами не показывает. Защита от эха (15.08 / 27.08) при действующих чипсах брала из ответа только calc* и строки, которых
                            // в сторе нет: rel_* из записи стола (use false) оставались в сторе, и select-ы связанных виджетов уходили без отбора. Теперь служебные
                            // строки ответа принимаются так же, как calc* (та же проверка: набор посчитан под нынешний состав строк стола и это не эхо варианта
                            // параметров), и «значениями пользователя» не считаются. Выключатель fe.data.wsParamsServiceRows (false — прежнее поведение);
                            // счётчик store._svcRows {taken, kept}
                            const _svcKeys = new Set()
                            if (store.setting('fe.data.wsParamsServiceRows', true) !== false) {
                                const _lvK = (r) => String((r?.leftValue || {}).value || '')
                                const _wsRows = store.WORKSPACES[WIDGET.workspace]?.record?.doc?.params?.WHERE
                                const _curRows = new Map((Array.isArray(_wsRows) ? _wsRows : []).filter(r => _lvK(r)).map(r => [_lvK(r), r]))
                                for (const r of [...(Array.isArray(answer.workspace_params.WHERE) ? answer.workspace_params.WHERE : []), ..._curRows.values()]) {
                                    const k = _lvK(r)
                                    if (!k || k.startsWith('calc')) continue
                                    // служебная: rel_*; hidden-строка стора; hidden-строка ответа, которой в сторе нет (пользовательская строка стора hidden не бывает —
                                    // её эхо с пометкой hidden служебной не станет)
                                    if (k.startsWith('rel_') || (_curRows.has(k) ? _curRows.get(k)?.hidden === true : r?.hidden === true)) _svcKeys.add(k)
                                }
                            }
                            const _isComputedRow = (r) => _isCalcRow(r) || (_svcKeys.size > 0 && _svcKeys.has(String((r?.leftValue || {}).value || '')))
                            const _svcCount = (k, rows) => { if (!_svcKeys.size) return; const n = (rows || []).filter(r => r && _svcKeys.has(String((r.leftValue || {}).value || ''))).length; if (n) { store._svcRows = store._svcRows || { taken: 0, kept: 0 }; store._svcRows[k] += n } }
                            // IE 2026 09 19 / ODOO-5800: у строки чипса метрик условия вложенные (rightValue на втором уровне) — она тоже «значение»
                            const _hasUserValues = (rows) => (rows || []).some(r => r && !_isComputedRow(r)   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                && (r.use !== false) && ((r.attrs || []).some(a2 => (a2?.rightValue || {}).value)
                                    || (r.rightValue || {}).value || (r.chip_segment === 'CHIP-Metric' && (r.attrs || []).length)))
                            // IE 2026 09 19 / ODOO-5800 (находка ie-dm7 #30048: гонка ответов применения селекторов) (описание — у mainStore.whereFront_stamp)
                            const _WS1 = store.WORKSPACES[WIDGET.workspace]
                            const _guardOn = !!_wsSent && !!_WS1 && store.setting('fe.data.wsParamsStaleGuard', true) !== false
                            const _front = _guardOn ? store.whereFront_stamp(_WS1) : null
                            const _lvOf = (r) => String((r?.leftValue || {}).value || '')
                            const _staleRow = (r) => !!_front && (_front.seq[_lvOf(r)] || 0) > _wsSent.seq   // строку меняли на фронте после отправки этого запроса
                            const _calcStale = _guardOn && store.whereUser_sig(_WS1) !== _wsSent.sig   // состав чипсов стола с момента отправки изменился
                            const _noteTaken = (rows) => { if (!_front) return; for (const r of rows || []) { const k = _lvOf(r); if (!k || k.startsWith('calc')) continue; _front.sig[k] = store.whereRow_sig(r); _front.seq[k] = Math.max(_front.seq[k] || 0, _wsSent.seq) } }
                            const _count = (k, n) => { if (n) { store._staleGuard = store._staleGuard || { rows: 0, calc: 0 }; store._staleGuard[k] += n } }
                            const _mergeParams = (curParams) => {
                                const cur = curParams?.WHERE
                                if (!_hasUserValues(cur)) {
                                    // прежнее «принять параметры ответа целиком» — кроме строк, изменённых на фронте после отправки запроса
                                    // (и строк стора, появившихся позже запроса, которых в ответе нет), и наборов под прежний состав чипсов
                                    const ans = answer.workspace_params
                                    if (!_guardOn) return ans
                                    const ansRows0 = ans.WHERE || []
                                    const keep = new Map((cur || []).filter(r => r && !_isComputedRow(r)).map(r => [_lvOf(r), r]))   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    let nStale = 0
                                    const userRows = ansRows0.filter(r => r && !_isComputedRow(r)).map(r => { if (_staleRow(r) && keep.has(_lvOf(r))) { nStale++; return keep.get(_lvOf(r)) } return r })   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    const ansKeys = new Set(ansRows0.map(_lvOf))
                                    const later = (cur || []).filter(r => r && !_isComputedRow(r) && !ansKeys.has(_lvOf(r)) && _staleRow(r))   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    const calcRows = _calcStale ? (cur || []).filter(_isComputedRow) : ansRows0.filter(_isComputedRow)   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    const out = { ...ans, WHERE: userRows.concat(later).concat(calcRows) }
                                    if (_calcStale) for (const k of ['calc_selectors_mark', 'calc_empty', 'calc_empty_facets']) { if (k in (curParams || {})) out[k] = curParams[k]; else delete out[k] }
                                    _count('rows', nStale + later.length); _count('calc', _calcStale ? 1 : 0)
                                    _svcCount(_calcStale ? 'kept' : 'taken', calcRows)   // IE 2026 09 27 / ODOO-… (дефект: rel_* селекторы после ответа)
                                    _noteTaken(userRows.filter(r => !keep.has(_lvOf(r)) || keep.get(_lvOf(r)) !== r))
                                    return out
                                }
                                const merged = { ...answer.workspace_params }
                                const ansRows = answer.workspace_params.WHERE || []
                                // IE 2026 09 19 / ODOO-5800 (находка при приёме чипса метрик отчётом): метка наборов (calc_selectors_mark) несёт дайджест действующих чипсов. Запрос с вариантом
                                // параметров (workspace_params_for выключает строку своего поля селектора) бэк считает устаревшим: пересчитывает
                                // наборы calc ПОД ВАРИАНТ и возвращает их. Замер dev02 (page-ex-dos-managers, чипс main_buyer): после select графика
                                // «by managers» наборы стола подменялись вариантом «без чипса» (calc 188 узлов → выключен, метка без дайджеста) —
                                // до следующего запроса другого виджета, который заставлял бэк считать всё обратно. Наборы и метку варианта
                                // в стор не берём; новые / производные строки ответа принимаются как раньше. Выкл: fe.data.wsParamsVariantEchoGuard
                                const _variantEcho = !!(_wsSent ? _wsSent.variant : action._wsParamsVariant) && store.setting('fe.data.wsParamsVariantEchoGuard', true) !== false
                                const _keepCalc = _variantEcho || _calcStale   // наборы ответа посчитаны не под нынешний состав чипсов стола
                                if (_keepCalc) {
                                    for (const k of ['calc_selectors_mark', 'calc_empty', 'calc_empty_facets']) { if (k in (curParams || {})) merged[k] = curParams[k]; else delete merged[k] }
                                    if (_variantEcho) store._variantEchoGuard = (store._variantEchoGuard || 0) + 1
                                    else _count('calc', 1)
                                }
                                const calcNew = _keepCalc ? (cur || []).filter(_isComputedRow) : ansRows.filter(_isComputedRow)   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                _svcCount(_keepCalc ? 'kept' : 'taken', calcNew)   // IE 2026 09 27 / ODOO-… (дефект: rel_* селекторы после ответа)
                                // IE 2026 08 27 / ODOO-5800 (критично, Игорь): при активных чипсах защита от «эха»
                                // выбрасывала и НОВЫЕ строки ответа — производный селектор («Derived selector by
                                // dimensions/values», строка selector_map::<widget>, type selector_map_*) не появлялся.
                                // Из ответа принимаем ещё: активные производные селекторы (use=true — заменяют
                                // свою прежнюю строку) и строки, которых в сторе нет вовсе
                                const _lv = (r) => String((r?.leftValue || {}).value || '')
                                const _isDerived = (r) => String(r?.type || '').startsWith('selector_map') || _lv(r).startsWith('selector_map::')
                                const curUser = (cur || []).filter(r => !_isComputedRow(r))   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                const curKeys = new Set(curUser.map(_lv))
                                const takeNew = ansRows.filter(r => r && !_isComputedRow(r) && !_staleRow(r)   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    && ((_isDerived(r) && r.use !== false) || !curKeys.has(_lv(r))))
                                _count('rows', ansRows.filter(r => r && !_isComputedRow(r) && _staleRow(r) && ((_isDerived(r) && r.use !== false) || !curKeys.has(_lv(r)))).length)   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                _noteTaken(takeNew)
                                const takeKeys = new Set(takeNew.map(_lv))
                                merged.WHERE = curUser.filter(r => !takeKeys.has(_lv(r))).concat(takeNew).concat(calcNew)
                                // IE 2026 08 28 / ODOO-5828 (заказ Игоря): разметку out_of_scope считает бэк на СВОЕЙ копии
                                // строк — переносим её на сохранённые строки фронта (матч по биндингу и первому значению)
                                const _firstVal = (r) => String(((r?.attrs || []).find(a2 => a2 && a2.use !== false)?.rightValue || {}).value || '')
                                for (const r of merged.WHERE) {
                                    if (_isComputedRow(r) || r.use === false) continue   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    const a2 = ansRows.find(x => x && !_isComputedRow(x) && _lv(x) === _lv(r) && _firstVal(x) === _firstVal(r))   // IE 2026 09 27 / ODOO-…: + служебные строки бэка (hidden / rel_*)
                                    if (!a2) continue
                                    if (a2.out_of_scope?.length) r.out_of_scope = a2.out_of_scope
                                    else if (r.out_of_scope) delete r.out_of_scope
                                }
                                if (!store.hide_console) console.log('workspace_params: user chips protected from echo, calc rows merged:', calcNew.length, '| new/derived rows taken:', takeNew.length)
                                return merged
                            }
                            const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
                            if (WORKSPACE) {
                                WORKSPACE.record.doc.params = _mergeParams(WORKSPACE.record.doc.params)
                                store.update_CHIPS_from_WHERE(WORKSPACE.record.doc.params)
                                // IE 2026 08 28 / ODOO-5828 (заказ Игоря): пустое пересечение чипсов — раньше
                                // молча показывало ВСЁ; теперь бэк шлёт sentinel + флаг, предупреждаем тостом
                                const _ce = !!WORKSPACE.record.doc.params.calc_empty   // IE 2026 09 19: признак — из принятых параметров (у ответа на вариант он относится к варианту)
                                store._calcEmptyByWs = store._calcEmptyByWs || {}
                                if (_ce && store._calcEmptyByWs[WIDGET.workspace] !== true) {
                                    const _fx = (answer.workspace_params.calc_empty_facets || []).join(', ')
                                    store.show_notification({   // IE 2026 09 23 / ODOO-341407: i18n
                                        text: t('Selectors: no records match all chips')
                                            + (_fx ? ' ' + t('(empty: {facets})', { facets: _fx }) : '')
                                            + ' ' + t('— widgets show empty results. Remove or change a chip.'),
                                        status: 'warning', timeout: 9000,
                                    })
                                }
                                store._calcEmptyByWs[WIDGET.workspace] = _ce
                            }
                            if (WORKSPACE?.WIDGET) {
                                WORKSPACE.WIDGET.record.doc.params = WORKSPACE ? WORKSPACE.record.doc.params : answer.workspace_params

                                if (WORKSPACE.WIDGET.vueObj) {
                                    WORKSPACE.WIDGET.vueObj.content_Changed()
                                }
                            }
                        }

                        if (answer.widget_id) {
                            WIDGET = store.findWidget(answer.widget_id).WIDGET
                            if (!WIDGET) {
                                return
                            }
                            vueObj = WIDGET.vueObj
                        }

                        // // 2026-07-13 требует тестирования
                        // // ветки record, исключённые из отправки (record_sendToBackend_exclude:
                        // // ['doc', ...]) и не пришедшие в ответе, бэк не видел и не менял —
                        // // переносим прежние, чтобы замена record командами частичного
                        // // обновления их не затирала
                        // if (action.record_sendToBackend_exclude?.length && WIDGET.record) {
                        //     for (const answer_action of [answer, ...(answer.actions_after || [])]) {
                        //         if (!['updateDoc', 'updateDoc_ifChanged', 'updateWidget', 'updateWIDGET'].includes(answer_action.command)) continue
                        //         const record_new = answer_action.record || answer_action.WIDGET?.record
                        //         if (!record_new) continue
                        //         for (const key of action.record_sendToBackend_exclude) {
                        //             if (!(key in record_new) && key in WIDGET.record) {
                        //                 record_new[key] = WIDGET.record[key]
                        //             }
                        //         }
                        //     }
                        // }

                        // command=='dounloadFile'
                        WIDGET.loading = false
                        if (!action._isPoll) store.report_progress_stop(WIDGET) // R17
                        // The initial (non-poll) START request now returns immediately
                        // (widget_TASK.start runs the task asynchronously), so it comes
                        // back with the task still running (task_done=false). Keep the
                        // poll loop armed in that case — only stop polling here if the
                        // task already finished. Stopping unconditionally (the old sync
                        // behaviour) killed _pollTask before the first poll tick, freezing
                        // the status row on "Waiting for task...".
                        if (!action._isPoll && action.pollTask && answer.task_done) {
                            WIDGET._pollTask = null
                            // снимаем только «ожидание» — итог прогона (success/error)
                            // должен остаться на экране
                            if (WIDGET.notification?.status === 'pending') store.notification_softClear(WIDGET)
                            if (WIDGET._pollActiveRequest && WIDGET._pollActiveRequest.readyState !== 4) {
                                WIDGET._pollActiveRequest.abort()
                            }
                        }
                        if (answer.updateChatMsg) {
                            for (const attrVueObj of Object.values(WIDGET.attrs_vueObj || {})) {
                                attrVueObj?.applyUpdateChatMsg?.(answer.updateChatMsg)
                            }
                        }
                        if (action._pollMeta && WIDGET._pollTask) {
                            const { startTime, interval, maxTime } = action._pollMeta
                            if (answer.updateChatMsg) {
                                WIDGET._pollTask.sequence_id = answer.sequence_id ?? answer.updateChatMsg?.sequence_id ?? WIDGET._pollTask.sequence_id
                            }
                            if (answer.task_done) {
                                WIDGET._pollTask = null
                                // Итог прогона (Title лога, success/error) НЕ гасим по таймеру:
                                // его снимает следующее действие с виджетом (executeWidgetMethod)
                                // или крестик. Авто-скрытие оставлено только для pending —
                                // без финального статуса плашка «идёт пересчёт» висела бы вечно
                                // и выглядела как незавершённый расчёт.
                                if (WIDGET.notification?.status === 'pending') {
                                    const _n = WIDGET.notification
                                    window.$cg.setTimeout(vueObj, "pollTaskDone", () => {
                                        if (!WIDGET._pollTask && _n === WIDGET.notification
                                                && _n.status === 'pending') _n.visible = false
                                    }, store.setting('fe.polling.pollTaskDoneToastMs', 6000))   // IE 2026 09 05 / ODOO-336330
                                }
                            } else if (Date.now() - startTime < maxTime) {
                                window.$cg.setTimeout(vueObj, 'pollTask', () => {
                                    if (WIDGET._pollTask) store.executeWidgetMethod(vueObj, action)
                                }, interval)
                            } else {
                                WIDGET._pollTask = null
                                store.notification_softClear(WIDGET)
                                store.TERMINAL(WIDGET, null, { text: t('Task polling stopped: {min} min timeout', { min: maxTime / 60000 }), status: 'warning' })   // IE 2026 09 23 / ODOO-341407: i18n
                            }
                        }
                        // R2: словари ссылочных колонок пришли вместе с данными —
                        // применить ДО updateDoc, чтобы первый кадр был сразу с тайтлами
                        if (answer.itemsSources && store.fastEntry.inlineIS) {
                            store.apply_inline_itemsSources(answer.itemsSources)
                        }
                        if (action[KEEP_ROW_FORMS_MARK] === true && answer && typeof answer === 'object') answer[KEEP_ROW_FORMS_MARK] = true   // IE 2026 10 13 / ODOO-5800: фоновый запрос — его ответ (updateDoc / updateWidget) формы строк не закрывает
                        if (answer && typeof answer === 'object' && WIDGET?._multiply?.title && shortcutTitle_ownMethod(action.method) && shortcutTitle_on((k, d) => store.setting(k, d))) answer._ownTitle = true   // IE 2026 11 02 / ODOO-349799 (shortcut-title): ответ на своё действие окна ярлыка (toggle / swap) — его title явный
                        store.executeStoreMethod(vueObj, answer)

                        for (const action_after of answer.actions_after || []) {
                            if (action_after.deferred) { store.schedule_deferredAction(vueObj, action_after); continue }
                            store.executeStoreMethod(vueObj, action_after)
                        }

                        // IE 2026 10 09 / ODOO-345618 (F2): история единиц согласования (approval_history) — окно «History»; выключатель fe.ux.approval
                        if (Array.isArray(answer?.approval_history) && store.setting('fe.ux.approval', true) !== false) {
                            try { store.approvalHistory_open(answer.approval_history, WIDGET) } catch (e) { console.warn('approval history', e) }
                        }

                        // формирование отчёта вернуло пустой результат — дружелюбное
                        // предупреждение в шапке виджета (та же плашка, что ошибки бэка,
                        // но статусом warning); ошибку/критику бэка не перекрываем
                        if (!action._isPoll && action.method === 'select'
                                && /REPORT2/.test(WIDGET.widget_class || WIDGET.record?.segment || '')
                                && Array.isArray(WIDGET.record?._doc?.data)) {
                            if (!WIDGET.record._doc.data.length
                                    && !(WIDGET.notification?.visible && ['error', 'critical'].includes(WIDGET.notification.status))) {
                                WIDGET.notification = {
                                    ...(WIDGET.notification || {}),
                                    header: '',
                                    text: t('The report returned no data. Check selectors, filters and period settings.'),   // IE 2026 09 23 / ODOO-341407: i18n
                                    status: 'warning',
                                    visible: true,
                                }
                            } else if (WIDGET.record._doc.data.length
                                    && WIDGET.notification?.visible && WIDGET.notification.status === 'warning') {
                                // данные появились — снимаем прошлое «пусто» (warning на
                                // виджет-плашку ставит только этот код, чужое не заденем)
                                store.notification_softClear(WIDGET)
                            }
                        }

                        // конец цепочки первичной загрузки (обработали ответ + actions_after,
                        // следующий запрос не ушёл — loading не взведён) — снять «фриз» тела
                        if (WIDGET._firstLoading && !WIDGET.loading) {
                            WIDGET._firstLoading = false
                        }
                        // сигнал вызывающему: бэк ответил, ответ и actions_after обработаны
                        // (промис async-функции резолвится на ОТПРАВКЕ — для цепочек
                        // «дождаться применения» нужен явный хук; см. workspace_applySelector)
                        try { action._onResponse?.(answer) } catch (e) { /* хук не роняет ответ */ }
                    },
                    error: function (error, textStatus) {
                        _release_primary()
                        // IE 2026 10 13 / ODOO-5800: запись оборвана / не принята (отмена браузером, обрыв, 400 body_truncated) — не молча: «Save interrupted — not saved» и один повтор через 2 с
                        if (_writeGuardOn && request_isWrite(action) && !WIDGET.close) {
                            const _so = saveOutcome_error(error, textStatus, { on: true, attempt: action._saveAttempt || 0 })   // IE 2026 10 13 / ODOO-5800
                            if (_so.retry) {   // IE 2026 10 13 / ODOO-5800
                                WIDGET.loading = false
                                store.TERMINAL(WIDGET, null, { text: t('Not saved') + (_so.text ? ': ' + _so.text : '') + '. ' + t('Retrying in 2 s…'), status: 'warning' })   // IE 2026 10 13 / ODOO-5800
                                const _again = { ...action, _saveAttempt: (action._saveAttempt || 0) + 1 }   // IE 2026 10 13 / ODOO-5800
                                setTimeout(() => { if (!WIDGET.close) store.executeWidgetMethod(vueObj, _again, form_attr, null) }, SAVE_RETRY_DELAY_MS)   // IE 2026 10 13 / ODOO-5800
                                return
                            }
                            if (textStatus === 'abort') {   // IE 2026 10 13 / ODOO-5800: повтор уже был — сказать, что не сохранено
                                WIDGET.loading = false
                                store.TERMINAL(WIDGET, null, { text: t(_so.text || 'Save interrupted — not saved'), status: 'error' })   // IE 2026 10 13 / ODOO-5800
                                try { action._onAbort?.() } catch (e) { /* хук не роняет обработку */ }   // IE 2026 10 13 / ODOO-5800: полоса Save ленивого грида — снять «сохраняется»
                                return
                            }
                        }
                        if (textStatus === "abort") { // << _activeRequest / _pollActiveRequest
                            store.optionGroup_aborted(WIDGET, action)   // IE 2026 09 24 / ODOO-5800: reload групп опций оборван не новым кликом — набор к применённому
                            try { action._onAbort?.() } catch (e) { /* хук не роняет обработку */ }   // IE 2026 10 13 / ODOO-5800: полоса Save ленивого грида — снять «сохраняется»
                            return
                        }
                        try { action._onResponse?.(null) } catch (e) { /* хук не роняет обработку */ }
                        if (!action._isPoll && action.pollTask) {
                            WIDGET._pollTask = null
                            if (WIDGET._pollActiveRequest && WIDGET._pollActiveRequest.readyState !== 4) {
                                WIDGET._pollActiveRequest.abort()
                            }
                        }
                        // IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7 Н1): тихий метод — без тоста «Backend error» (вызывающий узнаёт об ошибке из _onResponse(null))
                        store.TERMINAL(WIDGET, null, action.quiet_errors ? null : { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                        WIDGET.loading = false
                        if (!action._isPoll) store.report_progress_stop(WIDGET) // R17
                        WIDGET._firstLoading = false // ошибка — «фриз» не держим
                    },
                });
                if (action._isPoll) {
                    WIDGET._pollActiveRequest = _jqXHR
                } else if (_ewm_bg) {   // IE 2026 11 03 / ODOO-350449 (Игорь: предзагрузка цепочек сигналов; BE ie-dm7 #1009; ревью: порция не в P0): фоновый — не _activeRequest: select / Save пользователя его не обрывают, он их — тоже
                } else {
                    WIDGET._activeRequest = _jqXHR
                    try { _jqXHR._isWrite = request_isWrite(action) } catch (e) { /* метка — вспомогательная */ }   // IE 2026 10 13 / ODOO-5800: запись в полёте не обрывается следующим запросом (abort_allowed)
                    WIDGET._activeMethod = action.method   // IE 2026 09 24 / ODOO-5800: метод запроса в полёте (mainStore.optionGroup_dataInFlight)
                    const _pollKey = JSON.stringify([action.pollTask?.method, action.pollTask?.params ?? null])
                    // дедуп: эта задача уже поллится (save и select кладут одинаковый
                    // pollTask; повторные select — ещё) — второй цикл не заводим,
                    // иначе отставшие ответы оживляют pending-плашку после финала
                    if (action.pollTask && WIDGET._pollTask?.key === _pollKey) { /* уже поллится */ } else if (action.pollTask) {
                        const startTime = Date.now()
                        const interval  = action.pollTask.interval ?? store.setting('fe.polling.pollTaskIntervalMs', 5000)   // IE 2026 09 05 / ODOO-336330
                        const maxTime   = action.pollTask.maxTime  ?? store.setting('fe.polling.pollTaskMaxMin', 30) * 60 * 1000
                        const pollAction = {
                            ...action.pollTask,
                            _isPoll: true,
                            _pollMeta: { startTime, interval, maxTime },
                        }
                        WIDGET._pollTask = { startTime, sequence_id: null, key: _pollKey }
                        if (!action.no_notification) {
                            WIDGET.notification = WIDGET.notification || {}
                            WIDGET.notification.text = t('Waiting for task...')   // IE 2026 09 23 / ODOO-341407: i18n
                            WIDGET.notification.status = 'pending'
                            WIDGET.notification.visible = true
                        }
                        window.$cg.setTimeout(vueObj, 'pollTask', () => {
                            if (WIDGET._pollTask) store.executeWidgetMethod(vueObj, pollAction)
                        }, interval)
                    }
                }
            } catch (error) {
                store.TERMINAL(WIDGET, null, {text:error, status:'error'});
            }
        },
        async executeWorkspaceMethod(vueObj, action, form_attr=null, FRONTEND_start=null) {
            // TODO


            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            // console.log(`executeWorkspaceMethod prepare1: ${Math.round(performance.now() - FRONTEND_start) / 1000} sec`)
            const timeStart0 = performance.now()
            const store = this
            if (store.readonly_denyAction(action, 'executeWorkspaceMethod')) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение»

            WIDGET.loading = true
            WIDGET.executeWidgetMethod_id = store.nextExecuteWidgetMethod_id++

            WIDGET.last_backend_action = action.action_id_front
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    ...action,
                    ...request,
                    process_model: store.process_model_record.id,
                    workspace: WIDGET.workspace,
                    // command: 'executeWidgetMethod', 
                    // method: action.method, 
                    WIDGET: widget_to_transfer,
                    user: store.user,
                    del_last_backend_action
                })
                const send_packege_size = Math.round(payload.length / 1024)
                // console.log(`executeWidgetMethod prepare2: ${Math.round(performance.now() - timeStart0) / 1000} sec`)
                
                if (action.sendBeacon) {
                    // console.log(`executeWidgetMethod sendBeacon: ${Math.round(performance.now() - timeStart0) / 1000} sec`)
                    // navigator.sendBeacon(store.url_backend_api, payload)
                    $.ajax({
                        url: store.url_backend_api,
                        type: "POST",
                        data: payload,
                        contentType: "application/json",
                        dataType: 'json',
                        async: true,
                            success: null,
                            error: null
                        });
                    WIDGET.loading = false
                    store.report_progress_stop(WIDGET) // R17
                    return
                }

                
                 WIDGET._activeRequest = $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {                        
                        if (WIDGET.close) { return }            
                        store.TERMINAL(WIDGET, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (!store.check_loginAfterAjax(vueObj, answer)) return
                        if (WIDGET.last_backend_action > action.action_id_front) {
                            if (!store.hide_console) console.log(`[${WIDGET.id}][${action.action_id_front}]${action.command} ${action.method} BREAK: ${Math.round(performance.now() - send_start) / 1000}`)
                            return
                        }
                        if (!store.hide_console) console.log(`[${WIDGET.id}][${action.action_id_front}]${action.command} ${action.method} FINISH: ${Math.round(performance.now() - send_start) / 1000}`)

                        if (answer.repeatFullRequest) {
                            delete action.widget_cache_key
                            delete action.record_sendToFrontend_exclude
                            delete WIDGET.widget_cache_key
                            
                            return store.executeWidgetMethod(vueObj, action)
                        }

                        for (let key in doc_stayOnFront) {
                            answer.record[key] = doc_stayOnFront[key]
                        }

                        // command=='dounloadFile'
                        WIDGET.loading = false
                        store.executeStoreMethod(vueObj, answer)

                        for (const action_after of answer.actions_after || []) {
                            if (action_after.deferred) { store.schedule_deferredAction(vueObj, action_after); continue }
                            store.executeStoreMethod(vueObj, action_after)
                        }
                    },
                    error: function (error, textStatus) {
                        if (textStatus === "abort") { // << _activeRequest
                            return
                        }
                        store.TERMINAL(WIDGET, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                        WIDGET.loading = false
                    },
                });
            } catch (error) {
                store.TERMINAL(WIDGET, null, {text:error, status:'error'});
            }
        },
        // R17 (dm 2026 08 04): прогресс формирования отчёта REPORT2 на полосе виджета.
        // Бэк пишет % после каждого блока data_layout2.report() (ключ report_progress:<key>),
        // фронт поллит лёгким executeBackendMethod и двигает WIDGET.loadingPct (та же полоса,
        // что у Excel-экспорта). Выкл: window.fastEntry.set('reportProgress', false)
        report_progress_start(WIDGET, vueObj) {
            const store = this
            if (store.fastEntry.reportProgress === false) return null
            vueObj = vueObj || {} // widget_open-путь: компонент ещё не смонтирован
            store.report_progress_stop(WIDGET)
            const key = `rp-${WIDGET.id || WIDGET.record?.id || 'w'}-${Date.now()}`
            WIDGET._progressEmpty = 0
            WIDGET._progressTimer = setInterval(() => {
                if (WIDGET._progressBusy && Date.now() - WIDGET._progressBusy < 5000) return
                WIDGET._progressBusy = Date.now()
                store.executeBackendMethod(vueObj, { method: 'get_report_progress', params: { _progress_key: key } }, (answer) => {
                    WIDGET._progressBusy = false
                    if (!WIDGET._progressTimer) return // уже остановлен — не оживляем полосу
                    const p = answer?.progress
                    if (p && p.pct != null) {
                        WIDGET._progressEmpty = 0
                        if (WIDGET.loadingPct !== p.pct) {
                            WIDGET.loadingPct = p.pct
                            WIDGET.loadingText = t('Loading')   // IE 2026 09 23 / ODOO-341407: i18n
                            // первое открытие: loadingPct пишется в ещё сырой (нереактивный)
                            // WIDGET — без пинка компонент полосу не отрисует.
                            // Пинаем ТОЛЬКО при смене процента: постоянный $forceUpdate
                            // мерцал вкладками и телом виджета
                            WIDGET.vueObj?.$forceUpdate?.()
                        }
                    } else if (++WIDGET._progressEmpty > 5) {
                        // widget_open-путь стартует полл до того, как известен класс виджета:
                        // не-отчёты (и не начавшиеся select'ы) сами гаснут по пустым ответам
                        store.report_progress_stop(WIDGET)
                    }
                })
            }, store.setting('fe.polling.reportProgressMs', 700))   // IE 2026 09 05 / ODOO-336330
            return key
        },
        report_progress_stop(WIDGET) {
            if (!WIDGET) return
            if (WIDGET._progressTimer) { clearInterval(WIDGET._progressTimer); WIDGET._progressTimer = null }
            WIDGET._progressBusy = false
            if (WIDGET.loadingPct != null) {
                WIDGET.loadingPct = null; WIDGET.loadingText = null
                // WIDGET первого открытия может быть ещё сырым (нереактивным):
                // без пинка компонент не уберёт полосу/кнопку Stop
                WIDGET.vueObj?.$forceUpdate?.()
            }
        },
        async executeBackendMethod(vueObj, action, callback, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            if (!this.hide_console) console.log(`executeBackendMethod ${action.command}`)
            const store = this
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — метод записи не шлём (тост); action.command переопределяет команду запроса (user_settings_save …); окно прогресса снимаем
            if (store.readonly_deny(action.command || 'executeBackendMethod', action.method || '', { flags: action })) { if (action.progress) store.hide_progress(); return }
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    command: 'executeBackendMethod',
                    ...action,
                    ...(action.action_id_front != null ? { action_id_front: store.net_actionId(action.action_id_front) } : {}), // IE 2026 09 26 / ODOO-5800: '<вкладка>-<N>'
                    ...store.net_requestParams(), // IE 2026 09 26 / ODOO-5800

                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    user: store.user,
                })
                const send_packege_size = Math.round(payload.length / 1024)

                if (action.sendBeacon) {
                    $.ajax({
                        url: store.url_backend_api,
                        type: "POST",
                        data: payload,
                        contentType: "application/json",
                        dataType: 'json',
                        async: true,
                            success: null,
                            error: null
                        });
                    return
                }

                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    // xhrFields: { withCredentials: true },
                    // crossDomain: true,

                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        if (action.progress) store.hide_progress() // IE 2026 08 23 / ODOO-5884
                        // IE 2026 09 26 / ODOO-5800: 204 — отменён на бэке: как ошибка, но без TypeError и без красной плашки (fe.net.cancel204Safe)
                        if (jqXHR?.status === 204 && store.net_on204(null, { where: 'executeBackendMethod', action })) return
                        store.TERMINAL(null, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        
                        callback?.(answer)

                        let actions_after = answer.actions_after || []
                        for (const action_after of actions_after) {
                            store.executeStoreMethod(vueObj, action_after)
                        }
                    },
                    error: function (error) {
                        if (action.progress) store.hide_progress() // IE 2026 08 23 / ODOO-5884
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n
                    },
                });
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'});
            }           
        },
        async executeWidgetMethod_inNewWidget(vueObj, request, action, FRONTEND_start=null) {
            if (!FRONTEND_start) {
                FRONTEND_start = performance.now()
            }
            const store = this, WIDGET = vueObj.WIDGET
            if (store.readonly_deny('executeWidgetMethod_inNewWidget', request?.method || action?.method || '', { flags: action })) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — START и прочие методы записи в новом виджете не шлём
            let actions_after = action.actions_after || [],
            action_after1 = actions_after[0]
            if (action_after1 && action_after1.timeout) {
                if (vueObj.timerId) {
                    if (!this.hide_console) console.log("setTimeout: clear")
                    clearTimeout(vueObj.timerId);
                    vueObj.timerId = null
                }
                action_after1.executeCoount = 2
                if (!this.hide_console) console.log("setTimeout: set")
                vueObj.timerId = window.$cg.setTimeout(vueObj, "store.executeWidgetMethod_inNewWidget", store.executeStoreMethod_afterTimer, action_after1.timeout, vueObj, action_after1)
                actions_after = []
            }
            try {
                let send_start
                const payload = JSON.stringify({
                    frontend_sent_timestamp: Date.now(),
                    showSQL: store.showSQL, profiling_params: store.profiling_params,
                    variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }), // IE 2026 09 05 / ODOO-336379: выключатель gzip ответов бэка (шаг 4) во всех запросах // IE 2026 09 04 / ODOO-336331: клиентский выключатель вариантов настроек
                    ...store.dl2_requestParams(), // IE 2026 09 04 / ODOO-336283: выключатель ленточной семантики полос DL2 (dl2_band_span)
                    ...request,
                    process_model: store.process_model_record.id,
                    workspace: store.activeWORKSPACE.record.id,
                    command: 'executeWidgetMethod_inNewWidget',
                    user: store.user,
                })
                const send_packege_size = Math.round(payload.length / 1024)
                $.ajax({
                    url: store.url_backend_api,
                    type: "POST",
                    // timeout: 50000,
                    data: payload,
                    contentType: "application/json",
                    dataType: 'json',
                    // async: false,

                    beforeSend: function () {
                        send_start = vueObj.time = performance.now()
                    },
                    success: function (answer, textStatus, jqXHR) {
                        if (WIDGET.close) { return }            
                        store.TERMINAL(vueObj.WIDGET, answer, null, send_start, FRONTEND_start, send_packege_size, jqXHR)
                        if (!store.check_loginAfterAjax(vueObj, answer)) return
                        if (!this.hide_console) console.log(request.widget_init.title + ' executeWidgetMethod_inNewWidget time: ', Math.round(performance.now() - vueObj.time) / 1000)
                        for (let statistics_key in answer.statistics)
                            if (!this.hide_console) console.log(statistics_key + ': ' + answer.statistics[statistics_key])

                        if (vueObj.timerId) {
                            if (!this.hide_console) console.log("setTimeout: clear")
                            clearTimeout(vueObj.timerId);
                            vueObj.timerId = null
                        }
                        actions_after += answer.actions_after || []
                        for (const action_after of actions_after) {
                            store.executeStoreMethod(vueObj, action_after)
                        }
                    },
                    error: function (error) {
                        store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' })   // IE 2026 09 23 / ODOO-341407: i18n

                        if (vueObj.timerId) {
                            if (!this.hide_console) console.log("setTimeout: clear")
                            clearTimeout(vueObj.timerId);
                            vueObj.timerId = null
                        }
                        for (const action_after of actions_after) {
                            store.executeStoreMethod(vueObj, action_after)
                        }
                    },
                })
            } catch (error) {
                store.TERMINAL(null, null, {text:error, status:'error'})
            }
        },
        executeStoreMethod_afterTimer(vueObj, action_after1) {
            const store = this
            if (!this.hide_console) console.log("setTimeout: execute")
            vueObj.timerId = null
            store.executeStoreMethod(vueObj, action_after1)

            if (action_after1.executeCoount) {
                action_after1.executeCoount--
                vueObj.timerId = window.$cg.setTimeout(vueObj, "store.executeStoreMethod_afterTimer", store.executeStoreMethod_afterTimer, action_after1.timeout, vueObj, action_after1)
            }
        },
        attr_get(WIDGET, attr, row = null, col = null) {
            const store = this
            
            let binding = attr.binding, iter=0
            // _doc.itemsSourcesView / _target — локальные копии реестра popup-а
            // (вкладки-реестры §6 / ит.4 §3), читаются/пишутся в собственный record, а не через родителя
            while (WIDGET.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && !binding?.startsWith('_widget.record._record') && binding !== '_widget.record._data' && binding !== '_doc.itemsSourcesView' && binding !== '_doc.itemsSourcesView_target' && iter++ < 5) {
                const parent = store.findWidget(WIDGET.parentWIDGET.id)
                let meta = WIDGET.record._meta

                if (meta.type === 'widget-row-viewParams') {
                    // АН 2026 08 11: doc.params.* — из РОДИТЕЛЬСКОЙ записи (см. attr_get_link)
                    if (binding?.startsWith('doc.params.')) {
                        return store.get_value(parent.WIDGET.record, binding, attr.defaultValue)
                    }
                    const name = meta.name
                    const param = binding
                    let value

                    const attr_vueObj = parent.WIDGET.vueObj.get_vueObj(name)
                    // IE 2026 09 30 / ODOO-343621 (Игорь: ⚙ таблицы — пустая форма свойств): поле карточки строки над списком колонок ⚙ ('attrs.<iroot>.<поле>') — из ЖИВОГО списка
                    // колонок (те же объекты, что правит сам список), а не из doc.viewParams.<грид>.attrs.<iroot>.<поле>
                    if (typeof param === 'string' && param.startsWith('attrs.')) {
                        const list = attr_vueObj?.get_viewParam ? attr_vueObj.get_viewParam('attrs', null) : store.get_viewParam(parent.WIDGET, name, 'attrs', null)
                        return store.get_value({ attrs: Array.isArray(list) ? list : [] }, param, attr.defaultValue)
                    }
                    if (attr_vueObj?.get_viewParam) {
                        value = attr_vueObj.get_viewParam(param, attr.defaultValue)
                    } else {
                        value = store.get_viewParam(parent.WIDGET, name, param, attr.defaultValue)
                    }
                    if ((value === undefined || value === false) && param === 'attrs' && WIDGET.record._record?.attrs) {
                        // синтетические конфиги (список ячеек печати): attr с таким name
                        // в view родителя нет, attrs переданы при открытии в _record
                        value = WIDGET.record._record.attrs
                    }
                    return value
                }

                binding = meta.binding + '.' + meta.iroot + '.' + binding
                
                WIDGET = parent.WIDGET
            }

            if (binding?.startsWith('_widget.')) {
                return store.get_value(WIDGET, store.substringAfterDot(binding), row = row, col = col)
            } else if (binding?.startsWith('_store.')) {
                return store.get_value(store, store.substringAfterDot(binding), row = row, col = col)
            } else if (attr.translate) {
                return store.get_value_localized(WIDGET.record, binding, attr.binding)
            } else {
                return store.get_value(WIDGET.record, binding, row = row, col = col)
            }
        },
        attr_get_link(WIDGET, attr, row = null, col = null) {
            const store = this;
            // виджета нет (стол пересоздан) — связывать не с чем
            if (!WIDGET) return [{}, attr?.binding]

            let binding = attr.binding, iter=0
            while (WIDGET.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 5) {
                if (binding?.startsWith('doc.viewParams')) {
                    return [{}, binding] // TODO
                }

                const parent = store.findWidget(WIDGET.parentWIDGET.id)
                let meta = WIDGET.record._meta
                // АН 2026 08 11: поля doc.params.* в форме viewParams (шестерёнка
                // графа: node_roles, graph_*) — настройки РОДИТЕЛЬСКОЙ записи;
                // резолвим от записи родителя без переписывания биндинга
                if (meta?.type === 'widget-row-viewParams' && binding?.startsWith('doc.params.')) {
                    WIDGET = parent.WIDGET
                    continue
                }
                binding = meta.binding + '.' + meta.iroot + '.' + binding

                WIDGET = parent.WIDGET
            }

            // переводимое поле: для отображения/редактирования линкуем перевод, если он непустой;
            // attr_set при этом пишет в базовый биндинг, а sync_translation обновляет перевод
            if (attr.translate && !binding?.startsWith('_widget.') && !binding?.startsWith('_store.')) {
                const lang = store.get_lang()
                if (lang) {
                    const binding_lang = store.localize_binding(binding, lang, attr.binding)
                    const translated = store.get_value(WIDGET.record, binding_lang)
                    if (translated && typeof translated === 'string') {
                        binding = binding_lang
                    }
                }
            }

            let value = WIDGET.record
            if (binding?.startsWith('_store.')) {
                return [store, store.substringAfterDot(binding)]
            } else if (binding?.includes('.')) {
                let bindingLast = ''
                let aBinding = this._parse_binding(binding)
                for (let iBinding = 0; iBinding < aBinding.length; iBinding++) {
                    bindingLast = aBinding[iBinding]
                    if (!(bindingLast in value)) {
                        if (iBinding == aBinding?.length - 1) {
                            if (attr.attr_type === 'AttrBool') {
                                value[bindingLast] = false
                            } else {
                                value[bindingLast] = ''
                            }
                        } else {
                            value[bindingLast] = {}
                        }
                    }
                    if (iBinding != aBinding?.length - 1) {
                        if (!value[bindingLast]) {
                            value[bindingLast] = {}
                        }
                        value = value[bindingLast]
                    }
                }
                return [value, bindingLast]
            }
            return [value, binding]
        },
        aggAll_afterAttrSet(WIDGET, binding) {
            // сводные таблицы (AttrGrid > aggAll_*: правила усл. оформления,
            // поля лэйаута): WIDGET/binding — уже разрешённые до корневой
            // записи (цепочка widget-row пройдена в attr_set). Правка
            // агрегата — его write-back, правка источников (строки и их
            // владельцы) — пересборка агрегатов
            if (typeof binding !== 'string') return
            for (const vueObj of Object.values(WIDGET.attrs_vueObj || {})) {
                const a = vueObj?.attr
                if (!a?.agg_sources || !vueObj.aggAll_afterChange) continue
                if (binding.startsWith(a.binding)) {
                    // биндинг в _doc.*_all — правка копии агрегата (скаляры
                    // попапа строки сводной), в identity-режиме тоже write-back
                    vueObj.aggAll_afterChange(true)
                } else if (!vueObj._aggAll_writingBack
                    && a.agg_sources.some(s => binding.startsWith(String(s.binding || '').split('[].')[0]))) {
                    vueObj.aggAll_scheduleRebuild()
                }
            }
        },
        get_keys(record) {
            if (record === null || record === undefined) {
                return []
            } else if (typeof record === 'object') {
                return Object.keys(record)
            } else if (Array.isArray(record)) {
                return record.map((_, index) => index.toString())
            } else {
                return [] // For primitive types, return an empty array
            }
        },
        _parse_binding(binding) {
            // 1) гарды
            if (typeof binding !== 'string' || binding.length === 0) return [];

            // 2) кэш
            let aBinding = this.PATH_CACHE.get(binding);
            if (aBinding) return aBinding; // считаем, что снаружи не мутируют. Если хочешь железобетон, см. freeze ниже.

            // 3) разбиение
            aBinding = binding.split('.').map(s => s.trim());

            // 4) быстрый выход — нет индексов
            if (binding.indexOf('[') !== -1) {
                for (let i = 0; i < aBinding.length; i++) {
                    const seg = aBinding[i];
                    // один индекс вида key[123]
                    const match = seg.match(/^(.+?)\[(\d+)\]$/);
                    if (match) {
                        aBinding[i] = [ match[1], parseInt(match[2], 10) ];
                    }
                    // если хочешь поддержать цепочки типа key[1][2],
                    // можно распарсить циклом, но это уже расширение логики.
                }
            }

            // 5) положить в кэш
            this.PATH_CACHE.set(binding, aBinding);

            // (опционально) защитить кэш от мутаций снаружи
            // for (let i = 0; i < aBinding.length; i++) {
            //   if (Array.isArray(aBinding[i])) Object.freeze(aBinding[i]);
            // }
            // Object.freeze(aBinding);

            return aBinding;
        },
        get_value(record, binding, default_ = null, setdefault = false, row = null, col = null) {
            let doc0 = record
            // if (!binding?.includes('.')) {
            //     doc0 = record[binding]
            // } else 
            if (record === null) {
                return default_
            } else if (typeof record === 'string' || typeof record === 'number' || typeof record === 'boolean') {
                // IE 2026 10 05 / ODOO-5800 (fe-80; prod_check18 A): запись — не объект (id записи строкой из списка id: doc.causes / doc.signals) — оператор `in`
                // по строке бросал «Cannot use 'in' operator to search for '…' in uncovered_demand»; у скаляра полей нет — значение по умолчанию
                return default_
            } else if (binding in record) {
                doc0 = record[binding]
            } else {
                let value = record,
                aBinding = this._parse_binding(binding),
                bindingLast = ''
                for (let iBinding = 0; iBinding < aBinding.length; iBinding++) {
                    bindingLast = aBinding[iBinding];
                    if (!this.isinstance_object(value)) {
                        return default_
                    } 
                    
                    // let match = bindingLast.match(/^(.+?)\[(\d+)\]$/);
                    if (Array.isArray(bindingLast)) {
                        let key = bindingLast[0];
                        let index = bindingLast[1];

                        if (key in value && Array.isArray(value[key]) && value[key].length > index) {
                            value = value[key][index];
                        } else {
                            return default_;
                        }
                    } else if (bindingLast in value) {
                        value = value[bindingLast]
                    } else {
                        if (setdefault) {
                            this.set_value(record, binding, default_)
                        }
                        return default_
                    }
                }
                doc0 = value
            }
            if (row === null) {
                return doc0
            } else {
                if (row in doc0 && col === null) {
                    return doc0[row]
                } else if (row in doc0 && col in doc0[row]) {
                    return doc0[row][col]
                } else {
                    return default_
                }
            }
        },
        attr_set(WIDGET, attr, value, row = null, col = null, run_actions=true) {
            const store = this
            
            const WIDGET0 = WIDGET
            let binding = attr.binding, iter=0
            // _doc.itemsSourcesView / _target — локальные копии реестра popup-а (§6 / ит.4 §3), см. attr_get
            while (WIDGET.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && !binding?.startsWith('_widget.record._record') && binding !== '_widget.record._data' && binding !== '_doc.itemsSourcesView' && binding !== '_doc.itemsSourcesView_target' && iter++ < 5) {
                const parent = store.findWidget(WIDGET.parentWIDGET.id)
                let meta = WIDGET.record._meta

                if (meta.type === 'widget-row-viewParams') {
                    // АН 2026 08 11: doc.params.* — прямая настройка родительской записи
                    if (binding?.startsWith('doc.params.')) {
                        return store.attr_set(parent.WIDGET, { ...attr, binding }, value, null, null, run_actions)
                    }
                    const name = meta.name
                    const param = binding

                    const parentAttr_vueObj = parent.WIDGET.vueObj.get_vueObj(name)
                    // IE 2026 09 30 / ODOO-343621 (Игорь: ⚙ таблицы — пустая форма свойств): карточка строки над списком колонок ⚙ писала свои пустые начальные значения в
                    // doc.viewParams.<грид>.attrs.<iroot>.<поле> — attrs записи отчёта становился объектом, после сохранения ⚙ давал пустую
                    // форму и пустую таблицу. Теперь: правка — в живую колонку (как в самом списке); пустое значение поля, которого у колонки
                    // нет, — никуда не пишется
                    if (typeof param === 'string' && param.startsWith('attrs.')) {
                        const list = parentAttr_vueObj?.get_viewParam ? parentAttr_vueObj.get_viewParam('attrs', null) : store.get_viewParam(parent.WIDGET, name, 'attrs', null)
                        if (!Array.isArray(list)) return
                        const box = { attrs: list }
                        const NONE = {}   // get_value(.., undefined) вернул бы null (параметр по умолчанию) — отличаем «поля нет» меткой
                        const cur = store.get_value(box, param, NONE)
                        const isEmpty = v => v === undefined || v === null || v === '' || v === false || (Array.isArray(v) && !v.length) || (store.isinstance_dict(v) && !Object.keys(v).length)
                        if (cur === NONE && isEmpty(value)) return
                        const dot = param.lastIndexOf('.')
                        const item = store.get_value(box, param.slice(0, dot), null)
                        if (!store.isinstance_object(item)) return
                        if (item[param.slice(dot + 1)] !== value) {
                            item[param.slice(dot + 1)] = value
                            parentAttr_vueObj?.content_Changed_afterTimeout?.()
                        }
                        return
                    }
                    if (parentAttr_vueObj?.set_viewParam) {
                        parentAttr_vueObj.set_viewParam(param, value)
                    } else {
                        store.set_viewParam(parent.WIDGET, name, param, value)
                    }

                    const parentWIDGET = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
                    if (WIDGET.parentWIDGET?.widget_class === 'widget_LIST') {
                        store.set_value(WIDGET.parentWIDGET.record, 'doc.viewList', value)
                        WIDGET.parentWIDGET.vueObj?.content_Changed?.()
                    }
                    
                    return
                }

                if (binding?.startsWith('doc.viewParams')) {
                    return // TODO
                }

                const relBinding = binding
                binding = meta.binding + '.' + meta.iroot + '.' + binding

                WIDGET = parent.WIDGET

                // история Undo/Redo родительского грида: правка через карточку
                // строки (widget-row над строкой) идёт мимо vueObj грида —
                // фиксируем запись сами (только ближайший грид-родитель)
                if (iter === 1 && run_actions) {
                    try {
                        const gridObj = WIDGET.vueObj?.get_vueObj?.(meta.binding || meta.name)
                        // _undoApplying: во время undo/redo карточка пере-синхронизирует
                        // поля тем же путём — эти записи не действия пользователя
                        if (gridObj?.undoStack && gridObj.pushStack && !gridObj._undoApplying
                            && relBinding && !store.is_serviceBinding(relBinding)) {
                            const dataItem = store.get_value(WIDGET.record, meta.binding + '.' + meta.iroot)
                            const oldVal = store.get_value(WIDGET.record, binding)
                            // объекты сверяем ПО СОДЕРЖИМОМУ: синхронизация карточки пишет
                            // равное значение новым объектом — это не изменение
                            const changed = (oldVal !== value) && !(
                                oldVal && value && typeof oldVal === 'object' && typeof value === 'object'
                                && JSON.stringify(oldVal) === JSON.stringify(value)
                            )
                            if (dataItem && changed) {
                                const cp = (v) => (v && typeof v === 'object') ? store.deepCopy(v) : v
                                const last = gridObj.undoStack[gridObj.undoStack.length - 1]
                                if (last && last.$item === dataItem && last.col_binding === relBinding && last.method === 'val' && last.label) {
                                    last.newVal = cp(value) // серия правок одного поля карточки — одна запись
                                } else {
                                    gridObj.pushStack({
                                        method: 'val', actionStack: gridObj.actionStack,
                                        irow: -1, icol: -1, $item: dataItem, col_binding: relBinding,
                                        val: cp(oldVal), newVal: cp(value),
                                        label: t('Edit "{field}" (row card)', { field: attr.title || relBinding }),   // IE 2026 09 23 / ODOO-341407: i18n
                                    })
                                    gridObj.actionStack++
                                }
                            }
                        }
                    } catch (e) { /* история не должна ломать запись значения */ }
                }

                if ( meta.range && run_actions && attr.raw_binding ) {
                    const attr_vueObjSheet = WIDGET.vueObj?.get_vueObj(WIDGET.record._meta.binding)
                    const flex = attr_vueObjSheet?.flex
                    
                    let { irow1, irow2, icol1, icol2 } = meta.range;

                    // если выделена одна ячейка — ничего не делаем
                    if (irow1 !== irow2 | icol1 !== icol2) {
                        for (let irow = irow1; irow <= irow2; irow++) {
                            for (let icol = icol1; icol <= icol2; icol++) {
                                let binding2 = attr.raw_binding.replace("{col_binding}", attr_vueObjSheet.get_attr_col(icol).binding)
                                store.set_value(flex.rows[irow].dataItem, binding2, value)
                            }
                        }
                    }
                }
            }

            if (binding?.startsWith('_widget.')) {
                store.set_value(WIDGET, store.substringAfterDot(binding), value, row, col)

                const _meta = WIDGET.record?._meta
                if (_meta?.type === 'widget-row-chip') {
                    if (binding === '_widget.record._record.title') {
                        WIDGET.title = value
                        WIDGET.record.title = value
                    }

                    const parentWIDGET = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
                    store.set_chip(parentWIDGET, _meta, WIDGET.record._record)

                    parentWIDGET?.attrs_vueObj?.[`${_meta.binding}-CHIPS`]?.emitChips()
                }


            } else if (binding?.startsWith('_store.')) {
                store.set_value(store, store.substringAfterDot(binding), value, row, col)
            } else {
                // if (attr.attr_type === 'AttrMulti') { 2025 01 18
                //     store.set_value(WIDGET.record, binding + '.valueStr', attr.valueStr, row, col)
                //     binding += '.value'
                // }
                store.set_value(WIDGET.record, binding, value, row, col)
                if (attr.translate) {
                    store.sync_translation(WIDGET.record, binding, value, attr.binding)
                }
                if (binding === 'title') {
                    WIDGET.title = value
                }
                // if (WIDGET.widget_class === 'rightArea.WIDGET') {
                //     store.rightArea_editEnded(WIDGET, attr)
                // }
                // сводная таблица правил усл. оформления: правка её агрегата
                // (_doc.conditional_format_all, скалярные поля попапа правила) —
                // write-back в источники; правка правил/строк-владельцев на
                // местах — пересборка агрегата (AttrGrid > aggAll_*)
                store.aggAll_afterAttrSet(WIDGET, binding)
                // визуальная таблица настроек печати (_doc.printTemplate —
                // эфемерная проекция): правка её путей (попапы ячейки: поля,
                // стили) → write-back в канон doc.printTemplate
                // (AttrGridGroup > printTpl_*)
                if (typeof binding === 'string' && binding.startsWith('_doc.')) {
                    for (const _mvt of Object.values(WIDGET._mvtObjs || {})) {
                        const _b = String(_mvt?.attr?.binding || '')
                        if (_b && _mvt?.printTpl_afterChange && binding.startsWith(_b)) {
                            _mvt.printTpl_afterChange()
                        }
                    }
                }
                // поле с Source-мэппингом на запись владельца (= workspace.* и т.п.):
                // значение пишет бэкенд (processing_fieldsMapping), но запись-владелец
                // логически изменилась → ставим ей флаг modified, чтобы основной виджет
                // показал признак сохранения
                store.markSourceMappingModified(WIDGET, attr)
            }

            if (!run_actions) {
                return
            }
            // afterEdit
            WIDGET = WIDGET0; iter = 0
            if (WIDGET.widget === 'widget-row' && WIDGET.parentWIDGET?.id !== undefined && iter++ < 5) {
                const WIDGET00 = WIDGET
                const parent = store.findWidget(WIDGET.parentWIDGET.id)
                WIDGET = parent.WIDGET

                let attr_vueObjSheet = WIDGET.vueObj?.get_vueObj(WIDGET00.record._meta.binding)
                if (attr_vueObjSheet?.flex?.refresh) {
                    attr_vueObjSheet.flex.refresh()
                }
            }
            if (attr.action_afterChange && !attr.is_customValueWarning && WIDGET.vueObj) {
                store.executeStoreMethod(WIDGET.vueObj, attr.action_afterChange, attr)
            }
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — цепочка «правка → метод виджета» (save и пересчёт) не стартует: readonly_allows пропускает только методы чтения; без роли — как было
            if (attr.executeWidgetMethod_afterEdit && store.readonly_allows('executeWidgetMethod', attr.executeWidgetMethod_afterEdit)) {
                store.executeStoreMethod(WIDGET.vueObj, { 
                    command: 'executeWidgetMethod', 
                    method: attr.executeWidgetMethod_afterEdit,
                    record_sendToBackend_exclude: ['_doc'],
                })
            }
        },
        markSourceMappingModified(WIDGET, attr) {
            // Source-мэппинг поля на запись владельца: = workspace.* / = workspace_params.*
            // → запись текущего workspace; = process_model_params.* → запись process_model.
            // Правка такого поля в FE не пишет значение (это делает бэкенд по
            // fieldsMapping), но владелец логически изменён — помечаем его modified,
            // иначе основной виджет не покажет признак модификации (задача: freq_data).
            const store = this
            let src = attr?.source_field?.value ?? attr?.source_field ?? attr?.source
            if (typeof src !== 'string') return
            const m = src.trim().match(/^=\s*(workspace|workspace_params|process_model_params)\b/)
            if (!m) return
            const rec = m[1] === 'process_model_params'
                ? store.process_model_record
                : store.WORKSPACES?.[WIDGET?.workspace]?.record
            if (rec && rec.id) {
                (rec._meta = rec._meta || {}).modified = true
            }
        },
        is_serviceBinding(binding) {
            // служебный путь: сегмент с префиксом «_» в начале или внутри пути
            // (_fe, _meta, _data, ...) — запись по нему не делает запись модифицированной
            return binding.startsWith('_') || binding.includes('._')
        },
        set_value(record, binding, value, row = null, col = null, findRow = null, set_modified=null, add=false) {
            set_modified = set_modified === null ? true : set_modified
            if (add) {
                value += this.get_value(record, binding, 0)
            }
            if (binding === '' || binding === undefined) {
                for (const key in value) {
                    record[key] = value[key];
                }
            } else {
                // bindingLast //
                let doc0 = record
                let bindingLast = binding
                if (binding?.includes('.')) {
                    bindingLast = ''

                    let aBinding = this._parse_binding(binding)
                    for (let iBinding = 0; iBinding < aBinding.length; iBinding++) {
                        if (bindingLast !== '') {
                            // let match = bindingLast.match(/^(.+?)\[(\d+)\]$/);
                            if (Array.isArray(bindingLast)) {
                                let key = bindingLast[0];
                                let index = bindingLast[1];
        
                                if (!(key in doc0) 
                                    || !Array.isArray(doc0[key])) {
                                    doc0[key] = [];
                                }
                                while (doc0[key].length <= index) {
                                    doc0[key].push({});
                                }
                                doc0 = doc0[key][index];
                            } else if (bindingLast in doc0) {
                                if (!this.isinstance_object(doc0[bindingLast])) {
                                    doc0[bindingLast] = {}
                                }
                                doc0 = doc0[bindingLast]
                            } else {
                                doc0 = doc0[bindingLast] = {}
                            }
                        }
                        bindingLast = aBinding[iBinding]
                    }
                }

                // set
                if (row === null && findRow === null) {
                    if (doc0[bindingLast] !== value) {
                        if (!this.is_serviceBinding(binding) && binding !== 'doc.viewParams.dataSheet.isReadOnly' && (doc0[bindingLast] || !this.isEmpty(value)) && set_modified) {
                            record._meta = record._meta || {}
                            record._meta.modified = true
                            // if (!this.hide_console) console.log(`record._meta.modified = true`)
                        }
                        // if (!this.hide_console) console.log(`attr_set ${binding} ${value.title}`)
                        doc0[bindingLast] = value
                    }
                } else {
                    if (findRow !== null) {
                        row = doc0[bindingLast].findIndex(rowData => {
                            return Object.keys(findRow).every(key => rowData[key] === findRow[key])
                        })
                        if (row === -1) {
                            return false
                        }
                    }
                    if (!doc0[bindingLast][row]) {
                        doc0[bindingLast].push({})
                    }
                    if (doc0[bindingLast][row][col] !== value) {
                        if (!this.is_serviceBinding(binding) && (doc0[bindingLast][row][col] || value) && set_modified) {
                            record._meta = record._meta || {}
                            record._meta.modified = true
                        }
                        doc0[bindingLast][row][col] = value
                    }
                }

                return value
            }
        },
        get_chip(WIDGET, _meta) {
            const record = WIDGET.record
            const chips = this.get_value(record, _meta.binding) || []
            const chip = chips.filter(c => !c.hidden)[_meta.index]
            return chip
        },
        set_chip(WIDGET, _meta, value) {
            const record = WIDGET.record
            const chips = this.get_value(record, _meta.binding) || []
            const chip = chips.filter(c => !c.hidden)[_meta.index]

            if (!chip) return
            const i = chips.indexOf(chip)
            chips.splice(i, 1, value)
            record._meta ||= {}
            record._meta.modified = true
            return chip
        },
        findMatch(query, itemsSource) {
            let bestMatch = -1;
            let bestMatchScore = 0;
            let m_query = query.split(' ')

            for (let i = 0; i < itemsSource.length; i++) {
                let score = 0;
                const name = itemsSource[i].title.toLowerCase();

                // Calculate the points for each row
                for (let j = 0; j < m_query.length; j++) {
                    const substring = m_query[j].toLowerCase();
                    if (name.includes(substring)) {
                        score++;
                    }
                }

                // If a line with a high score is found, update the best result
                if (score > bestMatchScore) {
                    bestMatch = i;
                    bestMatchScore = score;
                }
            }

            return bestMatch;
        },
        // IE 2026 08 30 / ODOO-5800 (разбор рендера ie-triage7/core: 12,1 с блокировки main
        // thread): widget_attr искал узел ЛИНЕЙНЫМ рекурсивным обходом всего дерева view на
        // каждый вызов, а зовут его на каждую ячейку/колонку — CPU-профиль загрузки Purchase:
        // widget_attr 586 мс self плюс заметная доля reactive-proxy get (902 мс) на обходах.
        // Теперь на дерево строится индекс id -> {attr, parent}; он живёт в WeakMap (не в
        // реактивном WIDGET) и инвалидируется ЭПОХОЙ, которую двигают все точки правки дерева
        // (updateAttrs / applyViewPatch / updateWIDGET). Промах индекса = обычный обход, так
        // что худший случай — прежнее поведение. Откат: window.perf.set('attrIndex', false)
        perf_flag(name, def_ = true) {
            const store = this
            if (!store._perfFlags) {
                let saved = {}
                try { saved = JSON.parse(localStorage.getItem('perf-flags') || '{}') } catch (e) { /* приватный режим / чужой формат — флаги по умолчанию */ }
                try {
                    // IE 2026 08 30 / ODOO-5800: роутер hash-овый — параметры живут и в
                    // location.search, и в хвосте location.hash (…/#/db?workspace=…&perf-x=false)
                    const qs = [location.search || '']
                    const h = location.hash || ''
                    if (h.includes('?')) qs.push('?' + h.slice(h.indexOf('?') + 1))
                    for (const q of qs) {
                        for (const [k, v] of new URLSearchParams(q).entries()) {
                            if (k.startsWith('perf-')) saved[k.slice(5)] = v !== 'false' && v !== '0'
                        }
                    }
                } catch (e) { /* нечитаемый URL — флаги по умолчанию */ }
                store._perfFlags = saved
                store.settingsVariants_console() // IE 2026 09 04 / ODOO-336331
                store.gridPerf_console() // IE 2026 09 04 / ODOO-336379
                store.rejectNotify_console() // IE 2026 09 04 / ODOO-335315
                store.saveDelta_console() // IE 2026 09 05 / ODOO-336379
                store.dl2Engine_console() // IE 2026 09 04 / ODOO-336658
                if (typeof window !== 'undefined' && !window.perf) {
                    window.perf = {
                        get: (k) => (k ? store.perf_flag(k) : { ...store._perfFlags }),
                        set: (k, v) => {
                            store._perfFlags[k] = !!v
                            try { localStorage.setItem('perf-flags', JSON.stringify(store._perfFlags)) } catch (e) { /* хранилище недоступно — флаг живёт до перезагрузки */ }
                            store._attrEpoch = (store._attrEpoch || 0) + 1
                            return store._perfFlags
                        },
                        reset: () => {
                            store._perfFlags = {}
                            try { localStorage.removeItem('perf-flags') } catch (e) { /* хранилище недоступно */ }
                            return {}
                        },
                    }
                }
            }
            const v = store._perfFlags[name]
            return v === undefined ? def_ : !!v
        },
        widget_attr_index(WIDGET) {
            const store = this
            if (!store._attrIndexWM) store._attrIndexWM = new WeakMap()
            const epoch = store._attrEpoch || 0
            const hit = store._attrIndexWM.get(WIDGET)
            if (hit && hit.epoch === epoch) return hit.map
            const map = new Map()
            const walk = (attrs, parent) => {
                if (!attrs) return
                for (const attr of attrs) {
                    if (attr == null) continue
                    if (attr.id != null && !map.has(attr.id)) map.set(attr.id, { attr, parent })
                    if (attr.attrs) walk(attr.attrs, attr)
                    if (attr.groupMenu) for (const keyMenu in attr.groupMenu) walk(attr.groupMenu[keyMenu], attr)
                }
            }
            if (WIDGET.groupMenu?.commandPanel) walk(WIDGET.groupMenu.commandPanel, WIDGET.groupMenu)
            if (WIDGET.record && WIDGET.view) walk(WIDGET.view, WIDGET)
            store._attrIndexWM.set(WIDGET, { epoch, map })
            return map
        },
        widget_attr(WIDGET, attr_id, attrs = null, parent = null) {
            const store = this;
            let attr_inContent = null;
            // attr_id == null совпал бы с первым же attr без id (undefined === undefined)
            if (!WIDGET || attr_id == null) return null;

            if (attrs === null) {
                if (store.perf_flag('attrIndex')) {
                    const found = store.widget_attr_index(WIDGET).get(attr_id)
                    if (found) return found
                }
                if (WIDGET.groupMenu?.commandPanel) {
                    attr_inContent = store.widget_attr(WIDGET, attr_id, WIDGET.groupMenu.commandPanel, WIDGET.groupMenu);
                    if (attr_inContent) {
                        return attr_inContent;
                    }
                }
                if (WIDGET.record && WIDGET.view) {
                    attr_inContent = store.widget_attr(WIDGET, attr_id, WIDGET.view, WIDGET);
                }
                return attr_inContent;
            }
        
            for (let attr of attrs) {
                if (attr.id === attr_id) {
                    return { attr, parent }
                }
            }
        
            for (let attr of attrs) {
                if (attr.attrs) {
                    attr_inContent = store.widget_attr(WIDGET, attr_id, attr.attrs, attr);
                    if (attr_inContent) {
                        return attr_inContent;
                    }
                }
                if (attr.groupMenu) {
                    for (let keyMenu in attr.groupMenu) {
                        attr_inContent = store.widget_attr(WIDGET, attr_id, attr.groupMenu[keyMenu], attr);
                        if (attr_inContent) {
                            return attr_inContent;
                        }
                    }
                }
            }
            return null;
        },
        // IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2): ответ ленивой вкладки (updateDoc updates record._doc.<x>) — панели вкладок виджета, у которых есть вкладка с этой
        // lazyBinding, проверяют свой грид (AttrTabPanel.lazyTab_afterData); прочие привязки — ничего
        lazyTab_afterData(WIDGET, binding) {
            const b = lazyTab_binding(binding)
            if (!b || !WIDGET?.attrs_vueObj) return
            for (const v of Object.values(WIDGET.attrs_vueObj)) {
                if (!v || typeof v.lazyTab_afterData !== 'function' || !Array.isArray(v.tabAttrs) || !v.tabAttrs.some(t => t && t.lazyBinding === b)) continue
                try { v.lazyTab_afterData(b) } catch (e) { console.warn('lazyTab_afterData', e) }
            }
        },
        widget_attr_set(vueObj, set__attrs_vueObj = true) {
            const store = this
            if (vueObj.attr_id == null) {
                // без id: attr задаёт initialAttr; в реестр не пишем (ключ был бы 'undefined')
                return
            }
            if (!vueObj.WIDGET) {
                // Компонент мог быть создан в момент, когда виджета ещё/уже не было в
                // сторе (смена процессной модели пересоздаёт рабочую область, смена базы — IE 2026 11 02 / ODOO-349799 (workspace-wording)
                // весь store): created() записал WIDGET=null и компонент оставался
                // «мёртвым» — attr не выставлялся, а шаблон падал на attr.cssClass.
                // Перерезолвим по id: после пересоздания стола виджет с тем же id уже есть.
                vueObj.WIDGET = vueObj.widget_id ? store.findWidget(vueObj.widget_id).WIDGET : null
            }
            if (!vueObj.WIDGET) {
                // виджета действительно нет — регистрировать нечего
                // (тот же приём, что в attr_deregister ниже)
                return
            }
            const attr_inContent = store.widget_attr(vueObj.WIDGET, vueObj.attr_id)
            vueObj.attr = attr_inContent?.attr
            vueObj.parent_attr = attr_inContent?.parent
            if (set__attrs_vueObj) {
                // IE 2026 10 17 / ODOO-5800 (бой 17.10: пустой грид Transitions после Terms/Steps — см. utils/stalePage.js): экземпляр из поддерева ДЕАКТИВИРОВАННОЙ
                // KeepAlive-страницы (второй Page того же стола в кэше роутера рендерит те же виджеты в отцепленный DOM) реестр не перезаписывает —
                // рассылка content_Changed и lazyTab_afterData остаются у компонента на экране. attr/parent_attr ему выставлены выше, как раньше
                if (stalePageGuard_on((k, d) => store.setting?.(k, d)) && inDeactivatedTree(vueObj)) return   // IE 2026 10 17 / ODOO-5800
                vueObj.WIDGET.attrs_vueObj[vueObj.attr_id] = vueObj
                // IE 2026 10 16 / ODOO-5800 (utils/lazyTabReveal.js): все живые экземпляры attr (реестр хранит последний; при пересозданном в отцепленный DOM
                // поддереве последний — невидимый, а видимый на экране — прежний экземпляр, по-прежнему живой). Снимается в attr_deregister
                try { const live = vueObj.WIDGET._attrsLive || (vueObj.WIDGET._attrsLive = {}); (live[vueObj.attr_id] || (live[vueObj.attr_id] = new Set())).add(vueObj) } catch (e) { /* нет реестра */ }
            }
        },
        attr_deregister(vueObj) {
            // зомби-записи размонтированных vueObj продолжают получать broadcast'ы
            // и писать hide/countItems по устаревшим данным; `=== vueObj` — чтобы
            // не снести регистрацию нового экземпляра при ремоунте
            const WIDGET = vueObj.WIDGET
            if (!WIDGET) return
            for (const key of [vueObj.attr_id, vueObj.attr?.id, vueObj._applysKey]) {   // IE 2026 09 10 / ODOO-…: ключ полосы AttrTabGridLanes (html_id)
                if (key == null) continue
                if (WIDGET.attrs_vueObj?.[key] === vueObj) { delete WIDGET.attrs_vueObj[key] }
                if (WIDGET.applys_CHIPS?.[key] === vueObj) { delete WIDGET.applys_CHIPS[key] }
                if (WIDGET._attrsLive?.[key]) { WIDGET._attrsLive[key].delete(vueObj); if (!WIDGET._attrsLive[key].size) delete WIDGET._attrsLive[key] }   // IE 2026 10 16 / ODOO-5800
            }
        },
        get_field0(attrs, value = '', key = 'binding') {
            const store = this
            if (attrs) {
                for (let attr of attrs) {
                    if (attr[key] === value && !(attr.attr_type === 'AttrButton' && key === 'binding')) {
                        return attr
                    }
                }
                for (let attr of attrs) {
                    if (attr.attrs && !(attr.binding && key === 'binding' && attr.attr_type !== 'AttrTabGrid')) {
                        let attr_ = store.get_field0(attr.attrs, value, key)
                        if (attr_) {
                            return attr_
                        }
                    }
                }
            }
            return null
        },
        get_field(attrs, value, keys = ['name', 'binding']) {
            const store = this
            for (let key of keys) {
                let result = store.get_field0(attrs, value, key)
                if (result) {
                    return result
                }
            }
            return null
        },
        get_fieldAll(attrs, value=null, key = '', foundAttrs = null) {
            const store = this
            if (foundAttrs === null) {
                foundAttrs = []
            }
            for (let attr of attrs) {
                if (key in attr && (value === null || attr[key] === value)) {
                    foundAttrs.push(attr)
                }
            }
            for (let attr of attrs) {
                if (attr.attrs) {
                    store.get_fieldAll(attr.attrs, value, key, foundAttrs)
                }
            }
            return foundAttrs
        },
        attr_length(attrs) {
            const store = this;
            let length = attrs.length
            for (const attr of attrs) {
                if (attr.attrs) {
                    length += store.attr_length(attr.attrs)
                }
            }
            return length;
        },
        attr_new(attrs, action) {
            const store = this;
            let i = store.attr_length(attrs) + 1,
                // IE 2026 09 23 / ODOO-341407: title 'field' здесь — не подпись, а семя binding нового поля (field-N, латиница) — намеренно без t()
                default_forNewRow = action.default_forNewRow || { attr_type: 'AttrStr', title: 'field' },
                binding_new = `${default_forNewRow.title}-${i}`
            while (store.get_field(attrs, binding_new)) {
                binding_new = `${default_forNewRow.title}-${++i}`
            }
            return {
                binding: binding_new,
                title: store.title_toUpperCase(binding_new),
                attr_type: default_forNewRow.attr_type,
                _meta: {
                    modified: true,
                }
            }
        },
        get_dblclick_action(vueObj, attr, execute = true) {
            const store = this, WIDGET = vueObj.WIDGET
            let dblclick_action = null
            // find first action
            while (!dblclick_action) {
                if (vueObj.WIDGET.groupMenu) {
                    dblclick_action = store.find_dblclick(vueObj, attr.binding, WIDGET.groupMenu.commandPanel); if (dblclick_action) break
                    dblclick_action = store.find_dblclick(vueObj, attr.binding, WIDGET.groupMenu.actionMenu); if (dblclick_action) break
                }
                if (attr?.groupMenu) {
                    // if (attr && attr.groupMenu.dblclick_action?.length) { TODEL
                    //     dblclick_action = attr.groupMenu.dblclick_action[0]; if (dblclick_action) break
                    // }
                    dblclick_action = store.find_dblclick(vueObj, attr.binding, attr.groupMenu.commandPanel); if (dblclick_action) break
                    dblclick_action = store.find_dblclick(vueObj, attr.binding, attr.groupMenu.actionMenu); if (dblclick_action) break
                    dblclick_action = store.find_dblclick(vueObj, attr.binding, attr.groupMenu.cell_buttons); if (dblclick_action) break
                }
                if (!dblclick_action) return null
            }
            if (dblclick_action && execute) {
                store.executeStoreMethod(vueObj, dblclick_action)
            }
            return dblclick_action
        },
        find_dblclick(vueObj, binding, menuTREE) {
            const store = this
            // run first action
            if (menuTREE && menuTREE.length) {
                for (let action of menuTREE) {
                    if (action.binding == binding && (action.dblClick || (action.title && action.title.includes('dblClick')))) {
                        // store.executeStoreMethod(vueObj, action)
                        return action
                    }
                }
            }
            return null
        },
        getSearchList(attrs, searchList, path) {
            // set defaults
            if (searchList == null) searchList = [];
            if (path == null) path = '';

            // add attrs and sub-attrs
            if (attrs) {
                for (var i = 0; i < attrs.length; i++) {
                    var attr = attrs[i];
                    searchList.push({
                        attr: attr,
                        path: path + attr.title,
                        keywords: attr.keywords
                    });
                    if (attr.attrs) {
                        this.getSearchList(attr.attrs, searchList, path + attr.title + ' / ');
                    }
                }
            }
            return searchList;
        },
        get_measureRow(WIDGET, measure) {
            for (let measureRow of WIDGET.record.doc.measures) {
                if (measureRow.measure === measure)
                    return measureRow
            }
        },
        tree_WidgetatItem(tree, node) {
            // tree.onWidgetatItem(node)
            // if (node.nodes)
            //     for (let sub_node of node.nodes) {
            //         this.tree_WidgetatItem(tree, sub_node)
            //     }
        },
        parseDateString(dateString) {
            let parseDate = wjcCore.Globalize.parseDate
            if (dateString && (dateString.length === 1 || dateString.length === 2)) {
                let today = new Date();
                let currentMonth = today.getMonth() + 1;
                let currentYear = today.getFullYear();
                dateString = currentYear + '-' + currentMonth + '-' + dateString
            }
            for (let format of this.dateFormats) {
                let date = parseDate(dateString, format) // parseDate tryParseExact
                if (date) {
                    return date
                }
            }
            return null
            // let year = date.getFullYear(),
            //     month = ('0' + (date.getMonth() + 1)).slice(-2),
            //     day = ('0' + date.getDate()).slice(-2),
            //     formattedDate = year + '-' + month + '-' + day
        },
        increment_name(baseTitle, existingTitles) {
            const copyRegex = /(.*)\s\(Clone\s(\d+)\)$/
            const match = baseTitle.match(copyRegex)
            const root = match ? match[1] : baseTitle

            if (existingTitles?.length) {
                // find max Clone N among existing titles with same root
                let maxNum = 0
                for (const title of existingTitles) {
                    const m = title.match(copyRegex)
                    if (m && m[1] === root) {
                        maxNum = Math.max(maxNum, parseInt(m[2]))
                    } else if (title === root) {
                        maxNum = Math.max(maxNum, 0)
                    }
                }
                return `${root} (Clone ${maxNum + 1})`
            }

            if (match) {
                return `${root} (Clone ${parseInt(match[2]) + 1})`
            }
            return `${baseTitle} (Clone 1)`
        },
        clear_modified(data) {
            for (let row of data||[]) {
                if (row._meta?.modified) {
                    delete row._meta.modified
                }
                if (row.attrs) {
                    this.clear_modified(row.attrs)
                }
            }
        },
        prepare_attr(attr, attr_ind, attr_prefics = 'rootFront', parent_binding = '', parent_attr_type = '') {
            if (!attr.attr_type) {
                // if (attr.attrs?.length) {
                //     attr.attr_type = 'AttrMenu'
                // } else
                if (!attr.title && !attr.tooltip && !attr.command) {
                    attr.attr_type = 'AttrSeparator'
                } else {
                    attr.attr_type = 'AttrButton'
                }
            }
            attr.component = attr.component || attr.attr_type
            // multi-column AttrTabGrid (columnsLayout): рендер через координатор полос;
            // без columnsLayout — компонент как раньше (AttrGrid), нулевая регрессия
            if (attr.attr_type === 'AttrTabGrid' && attr.columnsLayout) {
                attr.component = 'AttrTabGridLanes'
            }
            const attr_id = attr.id || (attr.name
                ? `${attr_prefics}_${attr.name}_${attr.attr_type.split('_').pop()}`
                : `${attr_prefics}_${attr_ind}_${attr.attr_type.split('_').pop()}`)
            if (this.tabs_noId && parent_attr_type === 'AttrTabPanel'
                && (attr.attr_type === 'AttrTab' || attr.attr_type === 'AttrTabRow')) {
                // вкладке панели id не ставим (tabs_noId): она резолвится объектом
                // (initialAttr), а не поиском; html_id оставляем — это ключ v-for
                attr.html_id = attr.html_id || attr_id
            } else {
                attr.id = attr.html_id = attr_id
            }

            this.prepare_attrs(attr.attrs || [], attr_id, attr.binding || parent_binding, attr.attr_type)
        },
        updateCommandPanelInPlace(oldPanel, newPanel) {
            const oldMap = new Map()
            for (const item of oldPanel) {
                const key = item.id || item.action_name || `${item.title}_${item.command}`
                if (key) oldMap.set(key, item)
            }

            const result = []
            for (const newItem of newPanel) {
                const key = newItem.id || newItem.action_name || `${newItem.title}_${newItem.command}`
                const oldItem = key ? oldMap.get(key) : null
                if (oldItem) {
                    for (const prop of Object.keys(oldItem)) {
                        if (!(prop in newItem)) delete oldItem[prop]
                    }
                    Object.assign(oldItem, newItem)
                    result.push(oldItem)
                } else {
                    result.push(newItem)
                }
            }

            if (result.length !== oldPanel.length || result.some((item, i) => item !== oldPanel[i])) {
                oldPanel.length = 0
                oldPanel.push(...result)
            }
        },
        prepare_attrs(attrs, attr_prefics = 'rootFront', parent_binding = '', parent_attr_type = '') {
            // нумерация по позиции (не по use-фильтру): переключение use не сдвигает
            // индексы соседей, и use:false attrs тоже получают id — иначе после
            // use:false→true они остаются без id и ловятся на undefined === undefined
            attrs.forEach((attr, attr_ind) => {
                this.prepare_attr(attr, attr_ind, attr_prefics, parent_binding, parent_attr_type)
            })
        },
        get_buttons_innerHTML(attrs) {
            let innerHTML = ''
            for (let attr of attrs) {
                innerHTML +=
                    `<span wj-part="btn" class="wj-input-group-btn">
                    <button class="wj-btn wj-btn-default attr-doc-button my-text-shadow p-2" id="${attr.html_id}" tabindex="-1" type="button" aria-label="${attr.tooltip}" v-wjTooltip="${attr.tooltip}">
                        <i class="${attr.cssClass}" id="${attr.html_id}"></i>
                        ${attr.title ? attr.title : ''}
                    </button>
                </span>`
            }
            return innerHTML
        },
        executeCommand_by_html_id(vueObj, attrs, html_id) {
            for (let attr of attrs) {
                if (attr.html_id === html_id) {
                    vueObj.store.executeStoreMethod(vueObj, attr)
                }
            }
        },
        get_rowGROUP(params) {
            for (let rowGROUP of params.GROUP || []) {
                if (rowGROUP.use === undefined || rowGROUP.use) {
                    return rowGROUP
                }
            }
            return {} // {binding:'object'}
        },
        get_rowWHERE(WIDGET, params, fieldSelector) {
            if (!params.WHERE) {
                params.WHERE = []
            }

            // condition-based search (and/or/where_text)
            if (fieldSelector.condition && !fieldSelector.leftValue) {
                for (let rowWHERE of params.WHERE) {
                    if (rowWHERE.condition === fieldSelector.condition) {
                        rowWHERE.widget = WIDGET.widget
                        rowWHERE['widget-segment'] = WIDGET.record.segment
                        return rowWHERE
                    }
                }
                let rowWHERE = {
                    use: true,
                    condition: fieldSelector.condition,
                    attrs: [],
                    widget: WIDGET.widget,
                }
                params.WHERE.push(rowWHERE)
                return rowWHERE
            }

            // legacy: leftValue.value search
            for (let rowWHERE of params.WHERE) {
                if (rowWHERE.leftValue?.value === fieldSelector.leftValue?.value) {
                    rowWHERE.widget = WIDGET.widget
                    return rowWHERE
                }
            }
            let rowWHERE = {
                use: true,
                leftValue: fieldSelector.leftValue,
                DS: fieldSelector.DS_selector,
                condition: 'in',
                rightValue: {
                    attr_type: fieldSelector.attr_type,
                    relation_segment: fieldSelector.relation_segment,
                },
                attrs: [],
                widget: WIDGET.widget,
            }
            params.WHERE.push(rowWHERE)
            return rowWHERE
        },

        tooltip_html_fromFields(currentRecord, attrs) {
            // tooltip_source = [
            //     {'title':'Country', 'binding':'country'},
            //     {'title':'Past', 'attr_type':'AttrTab', 'attrs': [
            //         {'title':'IN', 'binding':'past.IN'},
            //         {'title':'OUT', 'binding':'past.OUT'},
            //     ]},
            //     {'title':'Now', 'attr_type':'AttrTab', 'attrs': [
            //         {'title':'Stock', 'binding':'D.open_balance::now'},
            //         {'title':'DOS', 'binding':'D.DOS::now'},
            //     ]},
            //     {'title':'Lead time', 'attr_type':'AttrTab', 'attrs': [
            //         {'title':'IN', 'binding':'D.IN::lt'},
            //         {'title':'OUT', 'binding':'D.OUT::lt'},
            //         {'title':'Stock', 'binding':'D.open_balance::lt'},
            //         {'title':'DOS', 'binding':'D.DOS::lt'},
            //         {'title':'Date', 'binding':'D.lead_time_date'},
            //     ]},
            //     {'title':'Replenishment cycle', 'attr_type':'AttrTab', 'attrs': [
            //         {'title':'IN', 'binding':'D.IN::rc'},
            //         {'title':'OUT', 'binding':'D.OUT::rc'},
            //         {'title':'Stock', 'binding':'D.open_balance::rc'},
            //         {'title':'DOS', 'binding':'D.DOS::rc'},
            //         {'title':'Date', 'binding':'D.replenishment_date'},
            //     ]},
            // ]

            let html = ''
            for (let attr of attrs) {
                if (attr.use === false) continue
                let value = this.get_value(currentRecord, attr.binding)
                if (value === undefined) value = ''
                if (attr.attr_type === 'AttrTab') {
                    const html1 = this.tooltip_html_fromFields(currentRecord, attr.attrs||[])
                    if (html1) {
                        html += `${html ? '<br>' : ''}<b class='tooltip-header'>${attr.title}</b><div class='tooltip-tab'>${html1}</div>`
                    }
                    continue
                } else if (attr.attr_type === 'AttrDate') {
                    value = this.formatDateHTML(value||'', attr.utc_to_local)
                } else if (attr.attr_type === 'AttrTime') {
                    value = this.formatTimeHTML(value||'', attr)
                } else if (attr.attr_type === 'AttrDays') {
                    value = this.formatDaysHTML(value||'', attr)
                } else if (attr.attr_type === 'AttrNumber') {
                    value = this.formatNumberHTML(value||0)
                } else if (attr.attr_type === 'AttrBool') {
                    value = value ? t('Yes') : t('No')   // IE 2026 09 23 / ODOO-341407: i18n
                }
                if (value) {
                    if (!(['AttrDate', 'AttrTime', 'AttrDays', 'AttrNumber'].includes(attr.attr_type))) {
                        value = `<b class='tooltip-text'> ${value}</b>`
                    }
                    const title = attr.title + (!attr.title.includes('<') ? ':' : '')
                    html += `<div class='tooltip-row'><b class='tooltip-header'>${title}</b>${value}</div>`
                }
                if (attr.attrs) {
                    const html1 = this.tooltip_html_fromFields(currentRecord, attr.attrs)
                    if (html1) {
                        html += `<div class='tooltip-tab'>${html1}</div>`
                    }
                }
            }
            return html
        },

        notification_softClear(WIDGET) {
            // ИЕ 2026 08 13 (просьба Игоря): бар «notification-widget» после появления
            // программно НЕ схлопывали — только очищали текст (пробел держал полосу),
            // иначе отчёт мерцал двойной перевёрсткой (добавили бар — убрали бар).
            // IE 2026 08 18 / ODOO-5512 (заказ Игоря): плашка теперь ПАРИТ над
            // виджетом (position:absolute, контент не перевёрстывается) — пустую
            // болванку держать незачем: при очистке сообщений плашку ЗАКРЫВАЕМ
            const n = WIDGET?.notification
            if (!n || !n.visible) return
            n.text = ''
            n.header = ''
            n.status = ''
            n.visible = false
        },
        // IE 2026 09 07 / ODOO-337259: подсказки видны при включённом Show tooltips ИЛИ при зажатом Alt (altTooltip)
        tooltips_on() {
            return this.showTooltip || altTooltip.held
        },
        // ==== IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): кнопки-действия в подсказках (utils/tipActions.js) ====
        // выключатель настройки базы: fe.ux.tooltipActions = false — прежние подсказки без кнопок
        tipActions_on() { return this.setting('fe.ux.tooltipActions', true) !== false },
        // общие строители подсказок: панель страниц в шапке = рейл страниц (Page.vue), список столов (RailMenu.vue)
        pageTip_fn(workspace, pageId) { return pageTip_fn(this, workspace, pageId) },
        pageGroupTip_fn(workspace, groupKey) { return pageGroupTip_fn(this, workspace, groupKey) },
        workspaceTip_fn(item, cat) { return workspaceTip_fn(this, item, cat) },
        categoryTip_fn(cat) { return categoryTip_fn(cat) },
        // блок кнопок к подсказке ссылочного поля формы (tooltip_attr: AttrLink с relation_segment и значением; мультиссылка — первый id)
        tipActions_linkField(vueObj) {
            try {
                if (!this.tipActions_on()) return ''
                const attr = vueObj?.attr
                if (!attr || !attr.relation_segment || attr.attr_type !== 'AttrLink' || typeof vueObj.onButtonOpen__Click !== 'function') return ''
                const id = this.tipActions_linkId(vueObj)
                if (!id) return ''
                const token = tipActions_bind((act) => this.linkField_action(vueObj, act), `field:${vueObj.WIDGET?.id}:${attr.id ?? attr.html_id ?? attr.binding}`)
                return tipActions_html(recordActions({ cb: token }, { openTitle: t('Open') }))
            } catch (e) { return '' }
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: запись-значение ссылочного поля формы (AttrLink с relation_segment) — { id, segment, title } | null
        recordHelp_linkTarget(vueObj) {
            try {
                const attr = vueObj?.attr
                if (!attr || attr.attr_type !== 'AttrLink' || !attr.relation_segment) return null
                const id = this.tipActions_linkId(vueObj)
                return id ? { id, segment: String(attr.relation_segment), title: String(vueObj.input?.text || id) } : null
            } catch (e) { return null }
        },
        tipActions_linkId(vueObj) {
            let id = this.attr_get(vueObj.WIDGET, vueObj.attr)
            if (Array.isArray(id)) id = id[0]
            if (id && typeof id === 'object') id = id.value ?? id.id
            return (id === undefined || id === null || id === '' || typeof id === 'object') ? '' : String(id)
        },
        // действие кнопки у поля: открыть — штатная кнопка поля; ссылка / новая вкладка — тот же widget_open с externalLink_method (виджет не открывается)
        linkField_action(vueObj, act) {
            if (act === 'open') { vueObj.onButtonOpen__Click(); return true }
            const method = act === 'copy' ? 'copyToClipboard' : (act === 'newtab' ? 'openInNewTab' : '')
            if (!method) return false
            const id = this.tipActions_linkId(vueObj)
            if (!id) return false
            this.widget_open({
                doc: { id, segment: vueObj.attr.relation_segment, relation_binding: vueObj.attr.relation_binding },
                widget: 'widget-record',
                parentAction: { 'action_name': 'action-front-2026-09-23-tip', method: 'AttrLink.onButtonOpen__Click' },
                externalLink_method: method,
            }, vueObj)
            return true
        },
        // действие кнопки подсказки (tipActions.onClick → store.tipAction_run): arg.cb — замыкание компонента (ячейка грида, поле формы, пункт панели);
        // иначе цель по arg.kind: record (id + segment) / page / pagewidget (страница + &widgets=) / workspace / text; paste — tipPaste
        tipAction_run(act, arg = {}) {
            const store = this
            if (arg.cb) { const fn = tipActions_callback(arg.cb); if (fn) { fn(act, arg); return true } return false }
            const vueObj = store.activeWIDGET?.vueObj || store.App
            const link = (method) => {
                if (arg.kind === 'record') {
                    const item = { id: arg.id }; if (arg.segment) item.segment = arg.segment; if (arg.title) item.title = arg.title
                    store.executeStoreMethod(vueObj, { action_name: 'action-front-2026-09-23-tip-link', command: 'widget_open', widget: 'widget-record', item, externalLink_method: method })
                } else if (arg.kind === 'page') {
                    store.externalLink({ method, workspace: arg.workspace, page: arg.page })
                } else if (arg.kind === 'pagewidget') {
                    store.externalLink({ method, workspace: arg.workspace, page: arg.page, widgets: [{ widget: arg.widget, title: arg.title || undefined }] })
                } else if (arg.kind === 'workspace') {
                    store.externalLink({ method, workspace: arg.id, page: '' })
                } else return false
                return true
            }
            switch (act) {
                case 'copy': return link('copyToClipboard')
                case 'newtab': return link('openInNewTab')
                case 'open': {
                    if (!['record', 'pagewidget', 'workspace'].includes(arg.kind)) return false
                    const id = arg.kind === 'pagewidget' ? arg.widget : arg.id
                    if (!id) return false
                    if (arg.segment) {
                        const item = { id, segment: arg.segment }; if (arg.title) item.title = arg.title
                        store.executeStoreMethod(vueObj, { action_name: 'action-front-2026-09-23-tip-open', command: 'widget_open', widget: 'widget-record', _activate: true, open_in_children_widget: true, item })
                    } else {
                        // сегмент неизвестен — запись по id (как «Settings» страницы в панели Commands)
                        store.executeStoreMethod(vueObj, { action_name: 'action-front-2026-09-23-tip-open', command: 'widget_open', widget: id, _activate: true })
                    }
                    return true
                }
                case 'settings': {
                    if (!arg.page) return false
                    store.executeStoreMethod(vueObj, { action_name: 'action-front-2026-09-23-tip-settings', command: 'widget_open', widget: arg.page, _activate: true })
                    return true
                }
                case 'copytext': {
                    const text = String(arg.text || '')
                    if (!text) return false
                    navigator.clipboard.writeText(text)
                        .then(() => store.show_notification({ text: t('Copied to clipboard!') }))
                        .catch(err => store.show_notification({ text: t('Failed to copy to clipboard: {error}', { error: err.message }), status: 'error' }))
                    return true
                }
                case 'paste': { store.tipPaste(arg); return true }
                case 'edithelp': { recordHelp.edit(arg); return true }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: действие edithelp — «Edit description» (админ): элемент реестра RECORD-HELP в форме записи
                default: return false
            }
        },
        // вставка строк из буфера в список, который представляет элемент (страница → грид Pages записи стола, виджет под страницей → грид виджетов
        // записи страницы, задача → дерево Tasks записи стола): открыть / активировать запись, показать вкладку с гридом, встать на строку элемента и
        // вставить тем же путём, что Alt V в гриде (pasteAction → insertAction: строки после выбранной, запись «изменена», сохраняет пользователь —
        // автосохранения нет). Буфер без строк — те же предупреждения, что у грида
        async tipPaste(arg) {
            const store = this
            let text = ''
            try { text = await navigator.clipboard.readText() } catch (e) { store.show_notification({ text: t('Clipboard error: {error}', { error: e?.message || String(e) }), status: 'error' }); return false }
            if (!text || !String(text).trim()) { store.show_notification({ text: t('Clipboard is empty'), status: 'warning' }); return false }
            const tgt = store.tipPaste_target(arg)
            if (!tgt) return false
            const W = await store.tipPaste_openRecord(tgt)
            if (!W) { store.show_notification({ text: t('Cannot open the record for pasting'), status: 'error' }); return false }
            const grid = await store.tipPaste_findGrid(W, tgt)
            if (!grid) { store.show_notification({ text: t('The target list was not found'), status: 'error' }); return false }
            try {
                const rows = grid.flex.rows
                let idx = -1
                for (let i = 0; i < rows.length; i++) { if (tgt.match(rows[i].dataItem)) { idx = i; break } }
                if (idx >= 0) { grid.flex.select(idx, 0); try { grid.flex.scrollIntoView(idx, 0) } catch (e) { /* без прокрутки */ } }
            } catch (e) { /* строка не найдена — вставка на текущую позицию */ }
            store.pasteAction(W.vueObj, { method: 'pasteItems', source_name: grid.attr.name, binding: grid.attr.binding }, text)
            return true
        },
        tipPaste_target(arg) {
            const store = this
            const s = v => String(v ?? '')
            const rowId = d => s(d?.widget ?? d?.node?.value ?? '')
            if (arg.target === 'page') {
                const ws = s(arg.workspace); const WS = store.WORKSPACES?.[ws]
                if (!ws || !arg.page) return null
                return { recordId: s(WS?.record?.id || ws), segment: s(WS?.record?.segment || ''), names: ['pages'], bindings: ['doc.pages'], match: d => rowId(d) === s(arg.page) }
            }
            if (arg.target === 'pagewidget') {
                if (!arg.page || !arg.widget) return null
                return { recordId: s(arg.page), segment: '', names: ['pages'], bindings: ['doc.pages'], match: d => rowId(d) === s(arg.widget) }
            }
            if (arg.target === 'task') {
                if (!arg.record || !arg.id) return null
                return { recordId: s(arg.record), segment: s(arg.segment || ''), names: ['data_tasks'], bindings: ['doc.data_tasks', '_doc.data_tasks'], match: d => s(d?.node?.value ?? '') === s(arg.id) }
            }
            return null
        },
        tipPaste_findRecordWidget(tgt) {
            for (const ws of Object.values(this.WORKSPACES || {})) {
                for (const w of (ws?.ALL_WIDGETS || [])) {
                    if (!w || w.close || w.widget === 'widget-row' || !w.record) continue
                    if (String(w.record.id || '') !== tgt.recordId) continue
                    if (tgt.segment && w.record.segment && w.record.segment !== tgt.segment) continue
                    return w
                }
            }
            return null
        },
        async tipPaste_openRecord(tgt) {
            const store = this
            let W = store.tipPaste_findRecordWidget(tgt)
            if (W) {
                if (W._softClosed) store._widget_restoreSoftClosed(W)
                store.widget_activate(W, 'tipPaste', true, false)
            } else {
                const vueObj = store.activeWIDGET?.vueObj || store.App
                store.executeStoreMethod(vueObj, { action_name: 'action-front-2026-09-23-tip-paste', command: 'widget_open', widget: tgt.recordId, _activate: true })
            }
            const t0 = Date.now()
            while (Date.now() - t0 < 30000) {
                await new Promise(r => setTimeout(r, 250))
                W = store.tipPaste_findRecordWidget(tgt)
                if (W && W.vueObj && !W.loading && W.record?.doc && W.view) return W
            }
            return null
        },
        // грид по имени / биндингу среди смонтированных attrs_vueObj; вкладка с гридом смонтирована лениво — активировать панели вкладок на пути к нему
        async tipPaste_findGrid(W, tgt) {
            const wanted = a => !!a && /^Attr(Grid|Tree)/.test(String(a.attr_type || '')) && (tgt.names.includes(a.name) || tgt.bindings.includes(a.binding))
            // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках) · v3: устаревшие экземпляры (перерисованный / восстановленный после мягкого закрытия виджет) не берём — хост грида должен быть в DOM; видимый — первым
            const isGrid = v => v && v.attr && v.flex && v.flex.hostElement && v.flex.hostElement.isConnected && wanted(v.attr)
            for (let i = 0; i < 16; i++) {
                const gs = Object.values(W.attrs_vueObj || {}).filter(isGrid)
                const g = gs.find(v => v.flex.hostElement.offsetParent) || (i >= 8 ? gs[0] : null)
                if (g) return g
                const path = this.tipPaste_attrPath(W.view, wanted)
                if (!path) return null
                const tabIds = new Set(path.filter(a => a.attr_type === 'AttrTab' && a.id != null).map(a => a.id))
                for (const p of Object.values(W.attrs_vueObj || {})) {
                    if (!p?.tabPanel || !p.tabAttrs) continue
                    const idx = p.tabAttrs.findIndex(t_ => t_ && tabIds.has(t_.id))
                    if (idx >= 0 && p.tabPanel.selectedIndex !== idx) { try { p.tabPanel.selectedIndex = idx } catch (e) { /* панель без вкладок */ } }
                }
                await new Promise(r => setTimeout(r, 400))
            }
            return null
        },
        tipPaste_attrPath(tree, pred, path = []) {
            for (const a of (tree || [])) {
                if (!a || typeof a !== 'object') continue
                if (pred(a)) return path.concat(a)
                const sub = this.tipPaste_attrPath(a.attrs, pred, path.concat(a))
                if (sub) return sub
            }
            return null
        },
        // IE 2026 09 24 / ODOO-341407 (второй обход dev02: Alt-подсказки «Type: / Title: / ID: / Widget class:» заголовков виджетов и кнопок —
        // 146+60+59 контекстов): строки подсказки бэк отдаёт готовым HTML (attrs.tooltip_html: <b class='tooltip-header'>Ключ:</b>) — подписи
        // строк переводим при показе по словарю фронта (ID остаётся ID); значения строк — данные записи, не трогаем
        i18n_tooltipHeader(html) {
            if (typeof html !== 'string' || !html || !this.get_lang() || !html.includes('tooltip-header')) return html || ''
            return html.replace(/<b class='tooltip-header'>([^<>:]{1,60}):<\/b>/g, (m, key) => `<b class='tooltip-header'>${t(key)}:</b>`)
        },
        tooltip_html(params, header='') {
            let html = this.i18n_tooltipHeader(header)   // IE 2026 09 24 / ODOO-341407: подписи строк заголовка бэка — по словарю
            for (let key in params) {
                const value = this.formatCount(params[key])
                if (value === '') continue
                
                html += `${html ? '<br>' : ''}<b class='tooltip-header'>${key}:</b> <b class='tooltip-text'> ${value}</b>`
            }
            return html
        },
        tooltip_attr(vueObj, tooltip2='') {
            const store = this
            let params = {}
            
            // IE 2026 09 23 / ODOO-341407: i18n (подписи-ключи tooltip_html)
            params[t('Field')] = vueObj.attr.binding
            if (vueObj.attr.title) params[t('Title')] = vueObj.attr.title
            if (vueObj.attr.tooltip) params[t('Tooltip')] = vueObj.attr.tooltip
            
            if (vueObj.attr?.isReadOnly) {
                params[t('isReadOnly')] = `<input type="checkbox" checked disabled>`
            }
            
            const fieldMapping = vueObj.attr?.fieldMapping
            if (fieldMapping) {
                params[t('Field mapping')] = store.attr_html(vueObj.WIDGET, vueObj.attr_id, 'fieldMapping.use', fieldMapping.use)
                params[t('... source value')] = fieldMapping['rightValue-title']
                params[t('... from')] = store.value_AttrMulti(fieldMapping.rightValue)
            }
            
            // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): у ссылочного поля с значением — кнопки открыть / ссылка в буфер / новая вкладка
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснения записей) · R2: ссылочное поле — объяснение записи-значения (About / Purpose / How to use; подсказка статичная: строки только из кэша,
            // запрос — по наведению AttrLink.recHelp_warm) и «Edit description» админу — перед кнопками
            const _recT = store.recordHelp_linkTarget(vueObj)
            const _rec = _recT ? recordHelp.cachedRowsHtml(_recT.id, _recT.segment) + recordHelp.editHtml(_recT) : ''
            return store.tooltip_html(params, (vueObj.attr.tooltip||'') + tooltip2) + _rec + store.tipActions_linkField(vueObj)
        },
        tooltipChange(WIDGET, e, tooltip_element_id) {
            const store = this
            const checkbox = e.target,
            attr_e = store.attr_html_splitID(tooltip_element_id)

            if (attr_e.binding === 'fieldMapping.use') { // checkbox && checkbox.type === 'checkbox' && 
                const isChecked = checkbox.checked,
                vueObj = WIDGET.attrs_vueObj[attr_e.attr_id]

                vueObj.attr.fieldMapping.use = isChecked
                let leftValue = store.value_AttrMulti(vueObj.attr.fieldMapping.leftValue)
                store.set_value(vueObj.WIDGET.record, 'doc.params.fieldsMapping', isChecked, null, 'use', {binding:leftValue})

                // restore rightValue-title
                if (vueObj.attr.fieldMapping?.use && 'rightValue-title' in vueObj.attr.fieldMapping) {
                    store.set_value(vueObj.WIDGET.record, vueObj.attr.binding, vueObj.attr.fieldMapping['rightValue-title'])
                }
            } else if (attr_e.binding === 'noupdate') {
                WIDGET.record.meta.noupdate = checkbox.checked
                if (!this.hide_console) console.log(WIDGET.record.meta.noupdate)
            }
        },
        tooltip_attachListeners(content) {
            const store = this

            const idRegex = /id=['"]([^'"]+)['"]/g
            const matches = content.matchAll(idRegex)
            const ids = Array.from(matches, match => match[1])
        
            if (ids.length) {
                for (let tooltip_element_id of ids) {
                    const checkbox = document.getElementById(tooltip_element_id),
                    attr_e = store.attr_html_splitID(tooltip_element_id)
        
                    if (checkbox) {
                        const WIDGET = store.findWidget(attr_e.widget_id).WIDGET
                        // let vueObj = WIDGET.attrs_vueObj[attr_e.attr_id]
                        checkbox.addEventListener('change', (event) => {
                            store.tooltipChange(WIDGET, event, tooltip_element_id)
                            // vueObj.tooltipChange.call(vueObj, event, tooltip_element_id)
                        })
                    }
                }
            }
        },
        attr_html(WIDGET, attr_id, binding, value) {
            const tooltip_element_id = `${WIDGET.id}-${attr_id}-${binding}`,
            checkbox = `<input type="checkbox" id='${tooltip_element_id}' ${value ? 'checked' : ''}  @change="tooltipChange">`
            return checkbox
        },
        attr_html_splitID(id) {
            const parts = id.split('-')
            return {
                widget_id: Number(parts[0]),
                attr_id: parts[1],
                binding: parts[2],
            }
        },
        get_hierarchy(data, childItemsPath = 'childs') {
            const dataHierarchy = []
            const dataParents = {
                '-1': {[childItemsPath]: dataHierarchy}
            };
        
            data.forEach(row => {
                const level = row.level | 0
                delete row.level
                if (dataParents[level - 1]) {
                    if (!dataParents[level - 1][childItemsPath]) {
                        dataParents[level - 1][childItemsPath] = []
                    }
                    dataParents[level - 1][childItemsPath].push(row)
                }
                dataParents[level] = row
            });
        
            return dataHierarchy
        },
        updateDoc_ifChanged(data_to, data_from) {
            if (data_to.length !== data_from.length) {
                return false
            }
        
            for (let i = 0; i < data_from.length; i++) {
                const row = data_from[i]
                for (const key in row) {
                    if (key === 'childs' || key === 'attrs') {
                        if (!this.updateDoc_ifChanged(data_to[i][key], row[key])) {
                            return false
                        }
                    } else if (data_to[i][key] !== row[key]) {
                        data_to[i][key] = row[key]
                    }
                }
        
                for (const key in data_to[i]) {
                    if (!(key in row)) {
                        delete data_to[i][key]
                    }
                }
            }
        
            return true
        },
        applyViewPatch(view, patch) {
            this._attrEpoch = (this._attrEpoch || 0) + 1   // IE 2026 08 30 / ODOO-5800
            // путь — индексы вложенных attrs: [0, 3, 1]; scalar — у узла
            // поменялся он сам, а не дети (их куски приходят отдельно)
            for (const item of patch) {
                let node = view[item.path[0]]
                for (let i = 1; i < item.path.length && node; i++) {
                    node = node.attrs?.[item.path[i]]
                }
                if (!node) continue
                // IE 2026 09 28 / ODOO-5800: заглушка вкладки (каркас формы настроек) не затирает уже загруженную вкладку
                if (item.node?.lazyForm && this.settingsForm_loadedTab(node, item.node)) { sfl_count('stubKept'); continue }
                if (item.scalar) {
                    for (const key in item.node) {
                        if (node[key] !== item.node[key]) node[key] = item.node[key]
                    }
                    for (const key in node) {
                        if (key !== 'attrs' && !(key in item.node)) delete node[key]
                    }
                } else {
                    this.updateAttrs([node], [item.node])
                }
            }
        },
        updateAttrs(data_to, data_from) {
            this._attrEpoch = (this._attrEpoch || 0) + 1   // IE 2026 08 30 / ODOO-5800: индекс widget_attr протух
            if (data_to?.length !== data_from?.length) {
                data_to.length = 0
                data_to.push(...data_from)
            }
        
            for (let i = 0; i < data_from.length; i++) {
                const row = data_from[i]
                // IE 2026 09 28 / ODOO-5800: заглушка вкладки (каркас формы настроек) из ответа не затирает уже загруженную вкладку
                if (row?.lazyForm && data_to[i] !== row && this.settingsForm_loadedTab(data_to[i], row)) { sfl_count('stubKept'); continue }
                for (const key in row) {
                    if (key === 'attrs') {
                        if (data_to[i][key] === undefined) {
                            data_to[i][key] = row[key]
                        }
                        this.updateAttrs(data_to[i][key], row[key])
                    } else if (data_to[i][key] !== row[key]) {
                        data_to[i][key] = row[key]
                    }
                }
        
                for (const key in data_to[i]) {
                    if (!(key in row)) {
                        delete data_to[i][key]
                    }
                }
            }
        },
        updateWIDGET(WIDGET_to, WIDGET_from) {
            this._attrEpoch = (this._attrEpoch || 0) + 1   // IE 2026 08 30 / ODOO-5800
            for (const key in WIDGET_from) {
                if (key === 'styleWidget') continue // IE 2026 08 19: рект/док — фронтовое состояние, эхо бэка не применяем
                if (key === 'view') {
                    if (WIDGET_to[key] === undefined) {
                        WIDGET_to[key] = WIDGET_from[key]
                    }
                    this.updateAttrs(WIDGET_to[key], WIDGET_from[key])
                } else if (WIDGET_to[key] !== WIDGET_from[key]) {
                    WIDGET_to[key] = WIDGET_from[key]
                }
            }
    
            // for (const key in WIDGET_to) {
            //     if (!(key in WIDGET_from)) {
            //         delete WIDGET_to[key]
            //     }
            // }
        },
        widget_checkLoading(vueObj) {
            const store = this
            if (vueObj.WIDGET.loading) {
                if (typeof vueObj.WIDGET.loading === 'object') {
                    // (b) view уже отрисован (widget_open вернул виджет без данных),
                    // сейчас пойдёт data-select. Резервируем primary-слот СИНХРОННО,
                    // до async-окна executeWidgetMethod: иначе отложенная очередь
                    // (P2) могла проскочить в зазоре между widget_open и отправкой
                    // ajax этого select-а. Слот снимет _release_primary по ответу.
                    store._primary_inflight = (store._primary_inflight || 0) + 1
                    vueObj.WIDGET.loading._preCounted = true
                    store.executeStoreMethod(vueObj, vueObj.WIDGET.loading)
                }
                // else {
                //     store.widget_getData(vueObj);
                // }
            }
        },
        isEmpty(value) {
            return (
                value === null ||
                value === undefined ||
                value === 0 ||
                value === 0.0 ||
                value === '0' ||
                value === false ||
                value === '' ||
                value === '00000000-0000-0000-0000-000000000000' ||
                value === '0001-01-01T00:00:00' ||
                (Array.isArray(value) && value.length === 0) ||
                (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
            )
        },
        scan_selector_values(data, rowWHERE, fieldSelector) {
            const store = this
            for (let row of data) {
                for (let icol = 1; icol < 6; icol++) {
                    let cell_doc = row[`c${icol}`];
                    if (cell_doc && cell_doc.selector) {
                        let value = cell_doc[fieldSelector.binding]
                        // ODOO-3724: пустое значение измерения → маркер <isempty>
                        if (value == null || value === '' || value === '00000000-0000-0000-0000-000000000000') {
                            value = EMPTY_VALUE_MARKER
                        }

                        rowWHERE.use = true
                        rowWHERE.attrs.push({
                            use: true,
                            rightValue: {
                                value:value,
                                attr_type: fieldSelector.attr_type,
                                relation_segment: fieldSelector.relation_segment,
                            }
                        })
                    }
                }
                if (row.attrs) {
                    store.scan_selector_values(row.attrs, rowWHERE, fieldSelector)
                }
            }
        },
        substringAfterDot(str) {
            const parts = str.split('.')
            if (parts.length < 2) {
                return ''
            }
            return parts.slice(1).join('.')
        },
        // ---------- отложенная очередь второстепенных данных (P2) ----------
        // Второстепенные подгрузки (cell_edits и др. — action.deferred с бэка)
        // не конкурируют за сеть/main thread с primary-данными виджетов (P0)
        // и словарями get_itemsSource (P1): копятся здесь и выполняются, когда
        // P0-запросы завершены и очередь словарей пуста. Акцент — быстрая
        // отрисовка виджетов; второстепенное доезжает следом.
        schedule_deferredAction(vueObj, action) {
            const store = this
            if (!store._deferred_actions) store._deferred_actions = []
            store._deferred_actions.push({ vueObj, action })
            store._deferred_waits = 0
            if (!store._deferred_timer) {
                store._deferred_timer = setInterval(() => store.flush_deferredActions(), store.setting('fe.polling.deferredFlushMs', 400))   // IE 2026 09 05 / ODOO-336330
            }
        },
        flush_deferredActions() {
            const store = this
            if (!store._deferred_actions?.length) {
                if (store._deferred_timer) { clearInterval(store._deferred_timer); store._deferred_timer = null }
                return
            }
            const busy_primary = (store._primary_inflight || 0) > 0
            const busy_items = Object.keys(store._itemsSource_active || {}).length > 0
                || Object.keys(store._itemsSource_queue || {}).length > 0
            // Страховка от залипшего счётчика: не держим P2 дольше ~20с (50×400мс).
            // Если primary/словари реально идут — они за это время сменятся; если
            // слот утёк, второстепенное всё равно доедет, а не потеряется.
            store._deferred_waits = (store._deferred_waits || 0) + 1
            if ((busy_primary || busy_items) && store._deferred_waits < 50) return
            clearInterval(store._deferred_timer); store._deferred_timer = null
            const queue = store._deferred_actions
            store._deferred_actions = []
            if (!store.hide_console) console.log(`deferred flush: ${queue.length} actions (primary=${store._primary_inflight || 0})`)
            for (const { vueObj, action } of queue) {
                delete action.deferred // выполнить обычным путём, не зациклиться
                store.executeStoreMethod(vueObj, action)
            }
        },

        // {page_id: число незакрытых дел} → бейджи страниц во всех открытых столах.
        // Считает бек (workspaces.page_badge); фронт только раскладывает.
        apply_page_badges(badges) {
            for (const WORKSPACE of Object.values(this.WORKSPACES || {})) {
                for (const page in badges) {
                    const PAGE = WORKSPACE.PAGES?.[page]
                    if (PAGE) PAGE.badge = badges[page]
                }
            }
        },
        // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): чипс шапки стола «Regimen paused until 05:00 UTC (3 nodes)» (utils/scheduleChip.js, выключатель fe.ux.scheduleHeaderChip).
        // Бэк кладёт header_chips (список, [] — нечего показывать) и schedule_stamp (штамп набора окон, под который посчитан чипс) в WORKSPACE при workspace_open и в ответ метода schedule_header_chip;
        // рисует чипс AttrChips (режим Page, CHIP-Info, без ⊗). apply_header_chips кладёт список на стол (workspace не назван — активный) и взводит ОДИН таймер на ближайший refresh_at активного стола.
        // Перечитывают чипс: таймер, штамп опроса auto_recalc_state (scheduleHeaderChip_onStamp), возврат к столу позже минуты (scheduleHeaderChip_activate), смена языка. Старый бэк ключей не шлёт —
        // стол «не знает» чипс (scheduleChip_supported): ни запросов, ни сравнения штампов. Ответ без списка header_chips снимает чипс и гасит стол (_scheduleOff) — опрос не гоняет ошибку каждые 12 с
        apply_header_chips(list, stamp, workspace, lang) {   // lang — язык, на котором бэк построил тексты (язык запроса); не назван — текущий
            const store = this
            const WS = workspace ? store.WORKSPACES?.[workspace] : store.activeWORKSPACE
            if (!WS) return
            WS.header_chips = scheduleChip_list(list)
            if (typeof stamp === 'string') WS.schedule_stamp = stamp
            else if (typeof WS.schedule_stamp !== 'string') WS.schedule_stamp = ''
            WS._scheduleAt = Date.now()
            WS._scheduleLang = lang || getLanguage()
            store.scheduleHeaderChip_arm(WS)
        },
        scheduleHeaderChip_arm(WS) {   // один таймер на приложение: на ближайший refresh_at АКТИВНОГО стола; прочие столы перечитываются при возврате к ним
            const store = this
            if (!WS || WS.workspace !== store.activeWORKSPACE?.workspace) return   // ответ по неактивному столу таймер активного не трогает
            clearTimeout(store._scheduleChipTimer)
            store._scheduleChipTimer = null
            if (!scheduleChip_on(store) || !scheduleChip_supported(WS)) return
            const d = scheduleChip_delay(WS.header_chips, Date.now(), WS._scheduleRetry || 0)
            WS._scheduleRetry = d && d.past ? (WS._scheduleRetry || 0) + 1 : 0   // конец уже в прошлом по часам браузера — повтор реже и реже (utils/scheduleChip.scheduleChip_delay)
            if (!d) return
            const ws = WS.workspace
            store._scheduleChipTimer = setTimeout(() => { store._scheduleChipTimer = null; store.scheduleHeaderChip_request(ws) }, d.ms)
        },
        scheduleHeaderChip_request(workspace, force) {   // метод бэка schedule_header_chip (чтение): ответ — полная замена списка, [] — снять; force — без паузы между запросами (смена языка)
            const store = this
            const WS = store.WORKSPACES?.[workspace]
            if (!scheduleChip_on(store) || !scheduleChip_canAsk(WS, Date.now(), force)) return false
            WS._scheduleReqAt = Date.now()
            const lang = getLanguage()   // текст бэк строит на языке запроса — по нему и помечаем ответ (смена языка в полёте не потеряется)
            Promise.resolve(store.executeBackendMethod({}, { method: 'schedule_header_chip', params: { workspace }, workspace }, (answer) => {
                try {
                    const r = scheduleChip_answer(answer), W = store.WORKSPACES?.[workspace]
                    if (W && r.off) W._scheduleOff = true
                    store.apply_header_chips(r.chips, r.stamp, workspace, lang)
                } catch (e) { console.warn('schedule header chip:', e) }
            })).catch(e => console.warn('schedule header chip:', e))
            return true
        },
        scheduleHeaderChip_init(workspace, answerWS) {   // стол построен из ответа workspace_open (answerWS — подтверждён после снапшота): запомнить момент и язык ответа, взвести таймер
            try {
                const store = this, WS = store.WORKSPACES?.[workspace], src = answerWS || WS
                if (WS && Array.isArray(src.header_chips) && typeof src.schedule_stamp === 'string') store.apply_header_chips(src.header_chips, src.schedule_stamp, workspace)
            } catch (e) { console.warn('schedule header chip:', e) }
        },
        scheduleHeaderChip_activate(WS) {   // стол стал активным (смена стола / страницы): таймер на его refresh_at; чипс старше минуты (или на другом языке) — один перезапрос
            try {
                const store = this
                clearTimeout(store._scheduleChipTimer)   // активным стал другой стол (или другая страница) — таймер прежнего не нужен
                store._scheduleChipTimer = null
                if (!WS || !scheduleChip_on(store) || !scheduleChip_supported(WS)) return
                store.scheduleHeaderChip_arm(WS)
                if (scheduleChip_stale(WS, Date.now(), getLanguage())) store.scheduleHeaderChip_request(WS.workspace)
            } catch (e) { console.warn('schedule header chip:', e) }
        },
        scheduleHeaderChip_onStamp(workspace, stamp) {   // штамп из опроса auto_recalc_state: набор окон изменился (началось / кончилось / продлено) — перечитать чипс этого стола
            try {
                const store = this
                if (scheduleChip_on(store) && scheduleChip_stampChanged(store.WORKSPACES?.[workspace], stamp)) store.scheduleHeaderChip_request(workspace)
            } catch (e) { console.warn('schedule header chip:', e) }
        },
        scheduleHeaderChip_langChanged() {   // язык интерфейса сменился: тексты чипса бэк строит на языке запроса — у активного стола перечитать (прочие — при возврате, scheduleChip_stale)
            try {
                const store = this, WS = store.activeWORKSPACE
                if (WS && scheduleChip_on(store) && scheduleChip_supported(WS) && WS.header_chips.length) store.scheduleHeaderChip_request(WS.workspace, true)
            } catch (e) { console.warn('schedule header chip:', e) }
        },
        TERMINAL(WIDGET, answer, notification_frontend=null, send_start=null, FRONTEND_start=null, send_packege_size=null, jqXHR=null) { // just_WIDGET=false
            const store = this
            // IE 2026 09 29 / ODOO-342781: отказ роли «только чтение» уже показан понятным тостом (options.error в $.ajaxPrefilter) — общий «Backend error» обработчика ошибки не дублируем
            if (store._roMuteBackendError && notification_frontend && notification_frontend.text === t('Backend error')) notification_frontend = null
            let isError
            // Живой бейдж: шаг чеклиста закрывается на СОСЕДНЕЙ странице, стол при
            // этом не переоткрывается — поэтому бек кладёт page_badges в любой ответ
            if (answer?.page_badges) store.apply_page_badges(answer.page_badges)
            // IE 2026 09 04 / ODOO-336330: тем же путём приезжают глобальные настройки базы
            // (workspace_open кладёт их рядом с database_menu — смена базы обновляет их здесь)
            if (answer?.settings) store.settings_apply(answer.settings)
            if (WIDGET) {
                if (answer?.debug) {
                    WIDGET.debug = answer.debug
                }
                if (!WIDGET.TERMINAL) {
                    WIDGET.TERMINAL = ''
                } else {
                    WIDGET.TERMINAL = WIDGET.TERMINAL.slice(-store.setting('fe.data.terminalMaxChars', 100000)) + '\n' + '-'.repeat(80) // + WIDGET.TERMINAL.length; IE 2026 09 05 / ODOO-336330
                }
            }
            let timeInfo = ''
            // IE 2026 09 28 / ODOO-342342 (ревью З5): ответ-не-объект (тело null) — без замеров: иначе TypeError здесь, и колбэк ответа не вызывается
            if (send_start !== null && answer && typeof answer === 'object') {
                const request_duration = Math.round(performance.now() - send_start) / 1000
                answer.BACKEND_duration = answer.BACKEND_duration||0
                // плечи передачи — ТОЛЬКО по часам браузера: answer.send_duration
                // приходит как разница часов двух машин и при их расхождении даёт
                // отрицательное время приёма. Resource Timing описывает тот же
                // запрос: до responseStart идут отправка и работа бэка, после —
                // приём ответа; без записи тайминга показываем одно число
                let send_duration = 0
                let resive_duration = Math.round((request_duration - answer.BACKEND_duration) * 1000) / 1000
                try {
                    const entries = performance.getEntriesByType('resource')
                        .filter(e => e.initiatorType === 'xmlhttprequest' && e.responseEnd
                                     && e.startTime >= send_start - 50 && e.responseStart)
                    const entry = entries.sort((a, b) =>
                        Math.abs(a.startTime - send_start) - Math.abs(b.startTime - send_start))[0]
                    if (entry) {
                        const download = (entry.responseEnd - entry.responseStart) / 1000
                        const upload = (entry.responseStart - (entry.requestStart || entry.startTime)) / 1000
                                       - answer.BACKEND_duration
                        send_duration = Math.round(Math.max(0, upload) * 1000) / 1000
                        resive_duration = Math.round(download * 1000) / 1000
                    }
                } catch (e) { /* тайминги недоступны — остаётся одно число */ }
                if (resive_duration < 0) resive_duration = 0
                const packege_size = Math.round(jqXHR.responseText.length / 1024)

                // // packege_size
                // const raw = jqXHR.responseText // JSON.stringify(answer);
                // const gzipped = pako.gzip(raw);
                // console.log("Raw (KB):", Math.round(new TextEncoder().encode(raw).length / 1024));
                // console.log("Gzipped (KB):", Math.round(gzipped.length / 1024));
                
                const total_kb = send_packege_size + packege_size;
                const transfer_duration = resive_duration + send_duration;
                const transfer_speed_mbps = transfer_duration > 0
                    ? Math.round(((total_kb * 8) / 1024) / transfer_duration * 10) / 10
                    : 0;

                // const encoding = jqXHR.getResponseHeader("Content-Encoding");
                // console.log("Content-Encoding:", encoding);
                
                timeInfo = `${answer.BACKEND_duration}s backend${answer.BACKEND_engine ? '-' + answer.BACKEND_engine : ''} ` // IE 2026 09 05 / ODOO-336658: «backend-rust» / «backend-rust-fetch» — движок отчёта (response.BACKEND_engine)

                if (FRONTEND_start !== null) {
                    let FRONTEND_duration = Math.round(performance.now() - FRONTEND_start) / 1000
                    FRONTEND_duration =  Math.round((FRONTEND_duration - answer.BACKEND_duration - (resive_duration + send_duration)) * 1000) / 1000
                    
                    if (store.show_JSON_parseTime && jqXHR) {
                        let t0 = performance.now();
                        let data = JSON.parse(jqXHR.responseText);
                        const JSON_parse_time = Math.round(performance.now() - t0) / 1000
                        
                        FRONTEND_duration =  Math.round((FRONTEND_duration - JSON_parse_time) * 1000) / 1000
                        
                        timeInfo += `+ ${ JSON_parse_time }s JSON_parse_time `;
                    }

                    timeInfo += `+ ${FRONTEND_duration}s frontend_before `
                }
                
                timeInfo += `+ (${send_duration} + ${resive_duration})s ${t('transfer')} (${send_packege_size} + ${packege_size})KB = ${transfer_speed_mbps}${t('Mbps')} `   // IE 2026 09 24 / ODOO-341407: i18n (строка тайминга в уведомлении виджета)

                if (WIDGET && !WIDGET.startTime) {
                    WIDGET.startTime = performance.now()
                }
            }
            let notification = notification_frontend
            if (answer?.TERMINAL) {
                // const callerInfo = new Error().stack.split('\n')[2]?.trim()
                if (!this.hide_console) console.log(timeInfo + answer.TERMINAL)
                if (WIDGET) {
                    if (WIDGET.TERMINAL !== '') {
                        WIDGET.TERMINAL += '\n';
                    }
                    WIDGET.TERMINAL += timeInfo + answer.TERMINAL
                } else {
                    // IE 2026 08 17 / ODOO-4997 (заказ Игоря): не спамить консоль
                    // "log-id: …" на каждый вызов без виджета — гейт как у строк выше
                    if (!this.hide_console) console.log(answer.TERMINAL)
                    // if (['error', 'critical'].includes(notification?.status)) {
                    //     store.error = answer.TERMINAL
                    // }
                }
            }
            if (notification) {
                if (!this.hide_console) console.log(notification.text)
                if (WIDGET) {
                    if (WIDGET.TERMINAL !== '') {
                        WIDGET.TERMINAL += '\n';
                    }
                    WIDGET.TERMINAL += (notification.header||'')
                    WIDGET.TERMINAL += notification.text
                }
            }
            if (answer?.notification) {
                if (!notification || notification.status === 'info') {
                    notification = answer.notification
                }
            }
            // ODOO-4334: уведомления, которые ЭТОТ фронт рисует сам, он же и глушит.
            // Бэкенд шлёт признак «граф ссылок не построен» ВСЕГДА — иначе видимый
            // признак есть только у выкаченного фронта, а порядок выката защищает
            // нас лишь дисциплиной (на Bio она уже не сработала). Панель показывает
            // это состояние текстом, поэтому здесь всплывашка лишняя. Глушим ПО
            // КОДУ, а не по совпадению текста: формулировку однажды перепишут, и
            // подавление по тексту молча отвалится. В TERMINAL запись остаётся.
            // IE 2026 10 08 / ODOO-335246 (Igor): жёлтое «Calculation cascade: N dirty node(s) …» — не всплывашка (хватает бейджа каскада в шапке виджета
            // и его Alt-подсказки, она читает WIDGET.notification); вернуть: настройка fe.ux.cascadeStaleBanner = true. Глушим ПО КОДУ, запись в TERMINAL остаётся
            const _cascadeToastMuted = notification?.code === 'cascade_stale_sources' && store.setting('fe.ux.cascadeStaleBanner', false) !== true   // IE 2026 10 08 / ODOO-335246
            if (notification?.text && notification.code !== 'refs_graph_not_ready' && !_cascadeToastMuted) {   // IE 2026 10 08 / ODOO-335246
                if (!this.hide_console) console.log(notification.text)
                if (notification.owner === 'workspace') {
                    // let workspace_record = store.activeWORKSPACE.record
                    // if (workspace_record && workspace_record.notification) {
                    //     workspace_record.notification.header = notification.header
                    //     workspace_record.notification.text = notification.text
                    //     workspace_record.notification.status = notification.status
                    //     workspace_record.notification.visible = true
                    // }
                } else if (['error', 'critical', 'success', 'pending'].includes(notification.status)) {
                    if (WIDGET?.notification) {
                        WIDGET.notification.header = notification.header || ''
                        // IE 2026 08 19: text из ответа бывает НЕ строкой (объект) —
                        // рендер плашки падал на .trim; приводим к строке здесь
                        WIDGET.notification.text = typeof notification.text === 'string'
                            ? notification.text : JSON.stringify(notification.text ?? '')
                        WIDGET.notification.status = notification.status || 'info'
                        WIDGET.notification.visible = true
                    }
                }
                store.show_notification(notification)
            }
            if (store.testRecording.active) testRecorder.onResponse(store, WIDGET, answer)
            if (WIDGET?.vueObj) {
                WIDGET.vueObj?.content_Changed_attr_vueObj?.('TERMINAL', {fold:true})
            }
        },
        // ---- версия фронта: не устарела ли вкладка -------------------------
        // Сервер отдаёт index.html с meta fe-config-version (запекается из .env
        // при сборке). Сравниваем со своей — если разошлись, значит выкатили
        // новый бандл, а вкладка живёт на старом коде: показываем плашку.
        // Выключение: window.fastEntry.set('versionCheck', false)
        async check_frontend_version() {
            const store = this
            if (store.fastEntry?.versionCheck === false) return
            if (!store.version_frontend) return // версия не запечена — сравнивать не с чем
            try {
                const base = process.env.BASE_URL || '/'
                const r = await fetch(`${base}index.html?_v=${Date.now()}`, {
                    cache: 'no-store', headers: { 'Cache-Control': 'no-cache' },
                })
                if (!r.ok) return
                const html = await r.text()
                const served = (html.match(/name="fe-config-version"[^>]*content="([^"]*)"/) || [])[1]
                if (!served) return // старый index.html без метки — молчим
                store.version_frontend_served = served
                if (served !== store.version_frontend) {
                    // новая выкатка после того, как плашку закрыли, — показать снова
                    if (store.version_outdated_served_shown !== served) {
                        store.version_outdated_hidden = false
                        store.version_outdated_served_shown = served
                    }
                    store.version_outdated = true
                } else {
                    store.version_outdated = false
                }
            } catch (e) {
                // сеть/сервер недоступны — не наше дело, проверим в следующий раз
            }
        },
        // IE 2026 08 24 / ODOO-5884 (заказ Игоря): поллинг авто-пересчёта — по завершении прогона
        // обновить виджеты активной страницы с Refresh by selectors (params.selector_get) и показать
        // тост со сводкой. Выключатели: window.autoRecalc (poll / refresh / toast), дефолты ВКЛ
        // IE 2026 09 11 / ODOO-335246 (Igor): пошаговая отладка каскада — вызов бэка cascade_debug (on / off / state / step);
        // ответ шага (prev — что сделано: узлы, задачи, секунды; next — что сделает следующий клик) — в cascadeDebug.last
        cascadeDebug_call(action, cb) {
            const store = this
            const ws = store.activeWORKSPACE
            store.cascadeDebug.busy = true
            store.executeBackendMethod({}, { method: 'cascade_debug', params: {
                action, workspace: ws?.workspace || ws?.record?.id || '', process_model: store.process_model_record?.id || '' } }, (answer) => {
                store.cascadeDebug.busy = false
                if (answer && typeof answer === 'object') {
                    store.cascadeDebug.last = answer
                    if (typeof answer.on === 'boolean') store.cascadeDebug.on = answer.on   // IE 2026 09 12 (Igor): истина — состояние базы (в т.ч. отказ не-админу)
                    if (answer.error) store.TERMINAL_error?.(answer.error)
                }
                cb && cb(answer)
            })
        },
        // IE 2026 09 12 (Igor): при старте / смене базы — состояние режима из settings этой базы
        cascadeDebug_sync() {
            if (!this.user?.rights?.['access-admin'] || this.readonly_on()) { this.cascadeDebug.on = false; return }   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — режим отладки каскада не опрашиваем (cascade_debug бэк отказывает)
            this.cascadeDebug_call('state', () => { this.cascadeDebug.last = null })
        },
        cascadeDebug_toggle() {
            const want = !this.cascadeDebug.on
            this.cascadeDebug.last = null
            this.cascadeDebug_call(want ? 'on' : 'off')
        },
        // IE 2026 09 11 (Igor): лог последнего шага — стадия: её лог задачи (LOGS-task-run), иначе лог прогона (LOGS-task-cascade-run)
        cascadeDebug_logRef() {
            const last = this.cascadeDebug?.last
            if (!last) return null
            const sid = (last.prev?.logs || []).find(Boolean)
            if (sid) return { id: sid, segment: 'LOGS-task-run' }
            if (last.log) return { id: last.log, segment: 'LOGS-task-cascade-run' }
            return null
        },
        cascadeDebug_openLog() {
            const ref = this.cascadeDebug_logRef()
            if (!ref) return
            this.widget_open({ widget: 'widget-record', id: ref.id, segment: ref.segment,
                record: { id: ref.id, segment: ref.segment, _meta: { segment: ref.segment, collection: 'work.logs' } } })
        },
        cascadeDebug_step() {
            if (this.cascadeDebug.busy) return
            this.cascadeDebug_call('step', () => { try { this.autoRecalc_check() } catch (e) { /* поллинг не критичен */ } })
        },
        autoRecalc_check() {
            const store = this
            const f = store.autoRecalc || {}
            if (f.enabled === false || f.poll === false) return
            if (document.visibilityState !== 'visible') return
            // IE 2026 09 12 / ODOO-335246 (Igor): состояние режима отладки каскада — из settings ТЕКУЩЕЙ базы, раз на базу
            try { const dbid_ = store.user?.database?.dbid || ''; if (dbid_ && store._cascadeDebugSyncedFor !== dbid_) { store._cascadeDebugSyncedFor = dbid_; store.cascadeDebug_sync() } } catch (e) { /* не критично */ }
            const WORKSPACE = store.activeWORKSPACE
            const wsId = WORKSPACE?.workspace || WORKSPACE?.record?.id
            // версия: ветка текущей процессной модели приоритетнее версии из записи стола —
            // свежезагруженный стол может ещё нести базовую версию (веточную вычисляет fieldsMapping)
            const version = store.process_model_record?.doc?.branch?.version
                || WORKSPACE?.record?.doc?.params?.version || ''
            if (!wsId || !version) return
            try {
                $.ajax({
                    url: store.url_backend_api, type: 'POST', contentType: 'application/json', dataType: 'json',
                    data: JSON.stringify({
                        command: 'executeBackendMethod', method: 'auto_recalc_state',
                        params: { workspace: wsId, version, process_model: store.process_model_record?.id || '' },
                        workspace: wsId, process_model: store.process_model_record?.id || '',
                        user: store.user,
                    }),
                    success: (answer) => {
                        store.scheduleHeaderChip_onStamp(wsId, answer?.schedule_stamp)   // IE 2026 10 10 / ODOO-345813 (заказ Игоря: окна остановок регламента): штамп набора окон изменился — перечитать чипс «Regimen paused until …» этого стола
                        // IE 2026 09 11 / ODOO-335246 (Igor): штамп каскада (пометки / снятие драфтов) изменился — перечитать
                        // индикаторы каскада открытых форм (запись-узел, задача, DS, список / отчёт): cascade_state_refresh → updateDoc
                        try {
                            const st = answer?.cascade_stamp
                            if (st !== undefined && st !== store._cascadeStamp) {
                                const first = store._cascadeStamp === undefined
                                store._cascadeStamp = st
                                if (!first) for (const WS of Object.values(store.WORKSPACES || {})) for (const W of (WS?.ALL_WIDGETS || [])) {
                                    if (W.close || !W.vueObj || !W.record?._doc || !('cascade_badge' in W.record._doc)) continue
                                    // IE 2026 09 11 (Igor): id записей узлов открытых графов формы — бэк вернёт счётчики грязных узлов (cascade_dirty_ids)
                                    const gids = new Set()
                                    for (const gk of ['cascade_graph', 'cascade_graph_fields', 'data_graph']) for (const n of (W.record._doc[gk]?.nodes || [])) { const id = n?.attributes?.doc?.id; if (id) gids.add(String(id)) }
                                    store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'cascade_state_refresh', record_sendToBackend_exclude: ['_doc'], no_notification: true, _isPoll: true, [KEEP_ROW_FORMS_MARK]: true, graph_ids: [...gids] })   // IE 2026 09 11 (Igor): фоновый опрос — без индикатора загрузки виджета; IE 2026 10 13 / ODOO-5800: + маркер «формы строк не закрывать»
                                }
                            }
                        } catch (e) { console.warn('cascade stamp refresh:', e) }
                        // IE 2026 08 25 / ODOO-5884 (заказ Игоря): ссылка Open log в тостах
                        // старта и финиша — item как в тостах веток (branch.backend_method)
                        const mkLogAction = (lg) => (lg && lg.id) ? { title: t('Open log'), command: 'widget_open',   // IE 2026 09 23 / ODOO-341407: i18n (тосты автопересчёта)
                            widget: 'widget-record', _activate: true,
                            item: { id: lg.id, segment: lg.segment || 'LOGS-task-run', title: lg.title || '',
                                _meta: { collection: 'work.logs', segment: lg.segment || 'LOGS-task-run' } } } : null
                        // IE 2026 08 25 / ODOO-5884 (заказ Игоря): тост о СТАРТЕ прогона
                        // IE 2026 08 26 (заказ Игоря «не скрывай сообщение, пока не закончено — обновляй ход»):
                        // тост ЛИПКИЙ (timeout null — конвенция pending) и живёт до финиша; текст обновляется
                        // прогрессом из title лога (auto_recalc_state отдаёт его свежим), опрос при беге — чаще
                        const run = answer?.running_info || null
                        // IE 2026 08 26 / ODOO-5800 (заказ Игоря «те же сообщения, что при ручном запуске»):
                        // текст тоста = живой Title лога прогона («left:… min, N out of M records processed;
                        // K out of L batches done»), без префикса; задача — в шапке её виджета (как pollTask)
                        const runProgress = () => run?.progress || run?.log?.title || t('{task}: running…', { task: run?.task_title || t('Auto-recalc') })
                        // ход выполнения (0..100) из Title лога: записи — 70% шкалы, after_all-подзадачи — 30%
                        const runPct = (txt) => {
                            const m = /(\d+)\s+out of\s+(\d+)\s+records/i.exec(txt || '')
                            const s = /(\d+)\s+out of\s+(\d+)\s+(?:sub-tasks|batches|segments)/i.exec(txt || '')
                            const rec = m && +m[2] > 0 ? Math.min(+m[1] / +m[2], 1) : null
                            const sub = s && +s[2] > 0 ? Math.min(+s[1] / +s[2], 1) : null
                            if (rec == null && sub == null) return null
                            if (rec == null) return Math.round(100 * sub)
                            return Math.round(100 * (rec * 0.7 + (sub == null ? 0 : sub * 0.3)))
                        }
                        // виджет задачи прогона на столе (по id задачи из run_info, иначе по названию) —
                        // строка хода в его шапке, как при ручном START
                        const taskWidget = () => (WORKSPACE?.ALL_WIDGETS || []).find(w => !w.close && w.record
                            && ((run?.task && w.record.id === run.task) || (run?.task_title && w.record.title === run.task_title)))
                        const pushWidgetProgress = (text, status) => {
                            const W = taskWidget(); if (!W) return
                            W.notification = { ...(W.notification || {}), visible: true, status, header: '', text }
                            W.vueObj?.$forceUpdate?.()
                        }
                        const showSticky = () => {
                            store.show_notification({ text: runProgress(), status: 'pending', timeout: null,
                                action: mkLogAction(run.log), progress: runPct(runProgress()) })
                            store._autoRecalcSticky = { version, at: run.started_at, closed: false }
                        }
                        if (answer?.running && run?.started_at && store._autoRecalcRun?.[version] !== run.started_at) {
                            (store._autoRecalcRun = store._autoRecalcRun || {})[version] = run.started_at
                            if (f.toast !== false) showSticky()
                            pushWidgetProgress(runProgress(), 'pending')
                        } else if (answer?.running && run?.started_at && f.toast !== false
                                && store._autoRecalcSticky?.at === run.started_at) {
                            pushWidgetProgress(runProgress(), 'pending')
                            if (store.notification.visible && store.notification.status === 'pending' && !store.notification.closing) {
                                // наш липкий тост на экране — обновить ход
                                store.notification.text = runProgress()
                                store.notification.progress = runPct(runProgress())
                                if (!store.notification.action && run.log?.id) store.notification.action = mkLogAction(run.log)
                            } else if (!store._autoRecalcSticky.closed && !store.notification.visible) {
                                // тост перекрыли другим сообщением и оно ушло — вернуть ход прогона
                                // (закрыт крестиком пользователем — не воскрешаем)
                                showSticky()
                            }
                        }
                        // при живом прогоне — доопрос быстрее штатных 12 с (window.autoRecalc.pollRunningMs)
                        clearTimeout(store._autoRecalcFastT)
                        if (answer?.running) store._autoRecalcFastT = setTimeout(() => store.autoRecalc_check(), f.pollRunningMs || 3000)
                        const done = answer?.last_done || {}
                        const doneAt = done.at || ''
                        const prev = store._autoRecalcLast[version]
                        store._autoRecalcLast[version] = doneAt
                        // первый опрос версии — только запомнить (исторический прогон не показываем)
                        if (!doneAt || prev === undefined || prev === doneAt) return
                        if (f.refresh !== false) {
                            try {
                                store.updateRelatedWidgets(wsId, WORKSPACE.active_page, null, { [KEEP_ROW_FORMS_MARK]: true })   // IE 2026 10 13 / ODOO-5800: фоновое обновление — открытые формы строк не закрывать
                                // IE 2026 08 25 / ODOO-5884 (Игорь: «перешёл на вкладку с отчётом —
                                // норматив не применился»): finish обновляет только активную страницу;
                                // остальные страницы стола помечаем PAGE.refresh_needed — активация
                                // вкладки переформирует их виджеты с Refresh by selectors штатно
                                for (const [pid, PAGE] of Object.entries(WORKSPACE.PAGES || {})) {
                                    if (pid !== WORKSPACE.active_page && PAGE) PAGE.refresh_needed = true
                                }
                            }
                            catch (e) { console.warn('autoRecalc refresh:', e) }
                        }
                        if (f.toast !== false) {
                            // IE 2026 08 26: финиш снимает липкий прогресс-тост (success перекрывает pending)
                            store._autoRecalcSticky = null
                            store.show_notification({ text: t('Auto-recalc finished: {summary}. Widgets refreshed.', { summary: done.summary || t('done') }),
                                status: 'success', timeout: 10000, action: mkLogAction(done.log) })
                        }
                        // IE 2026 08 26 / ODOO-5800 (заказ Игоря): итог — в шапку виджета задачи (как pollTask) и
                        // перечитать его список логов, чтобы строка прогона появилась без ручного Refresh
                        try {
                            const W = (WORKSPACE?.ALL_WIDGETS || []).find(w => !w.close && w.record
                                && ((done.task && w.record.id === done.task) || (done.task_title && w.record.title === done.task_title)
                                    || (w.notification?.status === 'pending' && w.record.doc?.params?.calculation_measures)))
                            if (W) {
                                W.notification = { ...(W.notification || {}), visible: true, status: 'success', header: '',
                                    text: done.summary || t('Auto-recalc finished') }
                                W.vueObj?.$forceUpdate?.()
                                if (W.vueObj) store.executeStoreMethod(W.vueObj, { command: 'executeWidgetMethod', method: 'select',
                                    record_sendToBackend_exclude: ['_doc'], no_notification: true })
                            }
                        } catch (e) { console.warn('autoRecalc: task widget refresh skipped', e) }
                    },
                })
            } catch (e) { /* сеть недоступна — проверим в следующий раз */ }
        },
        autoRecalc_poll_start() {
            const store = this
            if (store._autoRecalcTimer) return
            const every = store.autoRecalc?.pollMs || store.setting('fe.polling.autoRecalcPollMs', 12000)   // IE 2026 09 05 / ODOO-336330
            store._autoRecalcTimer = setInterval(() => store.autoRecalc_check(), every)
        },
        version_check_start() {
            const store = this
            if (store._versionCheckTimer) return
            // IE 2026 09 04 / ODOO-336330: интервал — настройка базы fe.polling.versionCheckMs
            // (кодовый дефолт 600000 = 10 мин); window.fastEntry.set('versionCheckMs', N) по-прежнему сильнее
            const every = store.fastEntry?.versionCheckMs ?? store.setting('fe.polling.versionCheckMs', 600000)
            store.check_frontend_version()
            store._versionCheckTimer = setInterval(() => store.check_frontend_version(), every)
            // возврат на вкладку — самый частый момент «а что там выкатили»
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') store.check_frontend_version()
            })
        },
        show_notification(notification) {
            const store = this

            if (!notification.text) {
                return
            }
            // IE 2026 08 26 / ODOO-5800 (заказ Игоря «сообщение о ходе не должно исчезать»): приоритет —
            // отдельно от таймаутов (statuses); pending (липкий прогресс) выше info/warning, ниже error/critical/success —
            // раньше statuses.pending=null ломал сравнение: любой info перекрывал ход прогона, а сам pending не показывался
            const _prio = { info: 1, warning: 2, pending: 2.5, error: 3, critical: 4, success: 5 }
            if (store.notification.visible && !store.notification.closing
                    && (_prio[store.notification.status] || 0) > (_prio[notification.status || 'info'] || 0)) {
                // Skipped because the current message is more important
                return
            }

            store.notification.header = notification.header
            store.notification.text = notification.text
            store.notification.status = notification.status || 'info'
            // IE 2026 09 05 / ODOO-336330: общий потолок тоста — настройка базы fe.ux.toastTimeoutMs (пусто = по статусу ~10 с;
            // pending всегда липкий; действие со своим timeout его сохраняет)
            store.notification.timeout = notification.timeout || (store.notification.status !== 'pending' && store.setting('fe.ux.toastTimeoutMs', null)) || store.notification.statuses[store.notification.status]
            store.notification.closing = false
            // IE 2026 08 26 / ODOO-5800: ход выполнения (0..100) — полоса над текстом тоста; null — без полосы
            store.notification.progress = (typeof notification.progress === 'number') ? notification.progress : null
            // IE 2026 08 23 / ODOO-5884 (заказ Игоря): ссылка в тосте — action с бэка ({title, command, …})
            store.notification.action = (notification.action && typeof notification.action === 'object') ? notification.action : null

            store.restore_notification()
            if (store.notification.timeout !== null) store.fadeOut_notification()
        },
        // IE 2026 08 23 / ODOO-5884 (заказ Игоря): клик по ссылке тоста — выполнить action (widget_open лога и т.п.)
        notification_action_open() {
            const store = this, action = store.notification.action
            if (!action) return
            store.close_notification()
            const vueObj = store.activeWIDGET?.vueObj || store.AppTopbar || store.App
            store.executeStoreMethod(vueObj, { ...action })
        },
        confirmInput_accept() {
            const store = this, ci = store.confirmInput
            const action = ci._action, vueObj = ci._vueObj
            // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): обязательный комментарий / обязательная категория — окно остаётся открытым, незаполненное подсвечено
            if (action && ((ci.required && !String(ci.value || '').trim()) || (ci.optionsRequired && (ci.options || []).length && !(ci.options || []).some(o => o.checked)))) { ci.invalid = true; return }
            ci.visible = false
            ci._action = null; ci._vueObj = null
            if (!action) return
            const field = action.confirm_input?.field || 'title'
            action.params = { ...(action.params || {}), [field]: (ci.value || '').trim() }
            if (ci.date && ci.date.field) action.params[ci.date.field] = String(ci.date.value || '').slice(0, 10)   // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE1-ci2 FE1: дата окна ('' — снять срок)
            // IE 2026 08 24 / ODOO-5884: отмеченные чекбоксы — списками по их field (full_copy: ['calc','mvs'])
            const _optFields = {}
            for (const o of (ci.options || [])) {
                if (!o.field) continue
                if (!_optFields[o.field]) _optFields[o.field] = []
                if (o.checked) _optFields[o.field].push(o.value)
            }
            for (const f in _optFields) action.params[f] = ci.exclusive ? (_optFields[f][0] ?? '') : _optFields[f]   // IE 2026 10 09 / ODOO-345618: exclusive — одна категория строкой
            action._confirm_accepted = true
            store.executeStoreMethod(vueObj || store.AppTopbar || store.App, action)
        },
        // IE 2026 10 09 / ODOO-345618: отметка чекбокса категории снимает прочие (confirm_input.exclusive) и гасит подсветку незаполненного
        confirmInput_pick(oi) {
            const ci = this.confirmInput, o = (ci.options || [])[oi]
            if (ci.exclusive && o && o.checked) (ci.options || []).forEach((x, i) => { if (i !== oi) x.checked = false })
            ci.invalid = false
        },
        confirmInput_cancel() {
            const store = this
            store.confirmInput.visible = false
            store.confirmInput._action = null
            store.confirmInput._vueObj = null
        },
        // IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте, F2): ответ команды approval_history (answer.approval_history = события единиц) — окно «History» на приложении.
        // Пустой список — тост «нет событий»; модель — utils/approval.approvalHistoryModel (категории возврата — из doc._approval виджета)
        approvalHistory_open(list, WIDGET) {
            const store = this
            const g = Object.values(WIDGET?.attrs_vueObj || {}).find(v => v && v.flex && v.attr && v.attr.name === 'dataSheet')   // таблица отчёта: названия мер — из её колонок
            const units = approvalHistoryModel(list, { da: approval_doc(WIDGET?.record?.doc), measureTitle: g ? (m) => approval_measureTitle(g.flex.columns, (b, c) => ((g.attr_by_binding && g.attr_by_binding[b]) || {}).title || c.header, m) : null })
            if (!units.length) { store.show_notification({ text: t('No approval events yet'), status: 'warning' }); return }
            store.approvalHistory.units = units
            store.approvalHistory.current = 0
            store.approvalHistory.visible = true
        },
        approvalHistory_close() {
            this.approvalHistory.visible = false
            this.approvalHistory.units = []
        },
        show_progress(progress) {
            const store = this
            store.progress.header = progress?.header || ''
            store.progress.text = progress?.text || t('Loading…')   // IE 2026 09 23 / ODOO-341407: i18n
            store.progress.visible = true
        },
        hide_progress() {
            this.progress.visible = false
        },
        restore_notification() {
            const store = this
            if (store.notification.closing) {
               return
            }
            if (store.notification.timerId) {
                clearTimeout(store.notification.timerId);
                store.notification.timerId = null
            }
            store.notification.fading = false
            store.notification.visible = true
        },
        fadeOut_notification() {
            const store = this
            // IE 2026 08 26 / ODOO-5800: липкий тост (timeout null — ход прогона) по уходу мыши не гасим:
            // setTimeout(fn, null) срабатывал сразу и «сообщение о ходе исчезало» после наведения
            if (store.notification.timeout === null) return
            store.notification.timerId = window.$cg.setTimeout(this, "store.fadeOut_notification", () => {
                store.close_notification()
            }, store.notification.timeout)
        },
        close_notification(byUser = false) {
            const store = this
            // IE 2026 08 26 / ODOO-5800: крестик на липком тосте прогона — не воскрешать его до финиша
            if (byUser === true && store.notification.status === 'pending' && store._autoRecalcSticky) {
                store._autoRecalcSticky.closed = true
            }
            if (store.notification.timerId) {
                clearTimeout(store.notification.timerId);
                store.notification.timerId = null
            }

            store.notification.fading = true
            store.notification.closing = true
            store.notification.timerId = window.$cg.setTimeout(this, "store.close_notification", () => {
                store.notification.visible = false
            }, 1000)
        },
        isinstance_dict(value) {
            return value !== null && typeof value === 'object' && !Array.isArray(value)
        },
        isinstance_list(value) {
            return value !== null && typeof value === 'object' && Array.isArray(value)
        },
        isinstance_object(value) {
            return value !== null && typeof value === 'object'
        },

        // ---------------- AttrMulti ------------------------
        check_AttrMulti(attr_col, dataItem) {
            const store = this,
            binding = attr_col.binding
            let V = store.get_value(dataItem, binding)
            if (!V) {
                V = store.new_valueMulti(attr_col)
                // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395: grid autocomplete — detached value, Enter, arrows): get_value(record, binding, V) НЕ записывает V (setdefault=false) —
                // значение оставалось отдельным объектом, строка {} (выбор из автодополнения в пустой ячейке не сохранялся); привязываем к строке явно, без пометки modified (как до 293dc5c56)
                if (store.isinstance_object(dataItem)) store.set_value(dataItem, binding, V, null, null, null, false)
            } else if (!store.isinstance_dict(V)) {
                let value = V
                V = store.new_valueMulti(attr_col)
                V.value = value
                V.valueStr = String(value)
                if (store.isinstance_object(dataItem)) store.set_value(dataItem, binding, V, null, null, null, false)   // IE 2026 10 10 / ODOO-341407 (Andrey via core #74395): то же — привязать к строке
            }
            if (!V.attr_type) {
                // тип по умолчанию: без relation_segment/itemsSource ссылку не из
                // чего резолвить — тип по значению (число/текст, просьба Игоря);
                // ссылка — когда есть источник или значение ещё пустое (выбор)
                const _hasSource = V.relation_segment || attr_col.relation_segment
                    || (Array.isArray(V.itemsSource) && V.itemsSource.length)
                    || (Array.isArray(attr_col.itemsSource) && attr_col.itemsSource.length)
                if (!_hasSource && V.value != null && V.value !== '' && typeof V.value !== 'object') {
                    const _num = typeof V.value === 'number'
                        || (String(V.value).trim() !== '' && !isNaN(+String(V.value).replace(',', '.')))
                    V.attr_type = _num ? 'AttrNumber' : 'AttrStr'
                } else {
                    V.attr_type = 'AttrLink'
                }
                if (!V.component) V.component = V.attr_type
            }
            return V
        },
        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): значение ссылки формы — название пункта (старая запись): однозначный пункт → id в запись (без признака правки,
        // select уходит с id); в словаре 'by_ids' названия нет — один name_search на (сегмент, значение), ответ перерисовывает грид
        linkLegacy_fix(vueObj, V) {
            const store = this
            const seg = V.relation_segment
            const IS = store.itemsSource[seg]
            if (!IS || typeof V.value !== 'string') return false
            if (!linkLegacyTitleToId_on(store)) return false   // IE 2026 10 30 / ODOO-5800 (p103: legacy link title → id via name_search, ie-dm7 #117621): выключатель и для отложенной перепроверки
            const apply = (r) => {
                if (!r) return false
                const [doc, b] = store.attr_get_link(vueObj.WIDGET, V)
                if (!doc || !b || store.get_value(doc, b) !== V.value) return false
                store.set_value(doc, b, r.id, null, null, null, false)
                V.value = r.id
                V.valueStr = r.title
                delete V.is_customValueWarning
                store._linkLegacyFixed = (store._linkLegacyFixed || 0) + 1   // счётчик для проб
                return true
            }
            if (apply(linkLegacyResolve(IS, V.value))) return true
            if (IS.ids && Object.prototype.hasOwnProperty.call(IS.ids, V.value)) return false
            // IE 2026 10 30 / ODOO-5800 (p103: legacy link title → id via name_search, ie-dm7 #117621): значение в _pending_ids — id ещё в пути (by_ids) ИЛИ это название, которое by_ids
            // (запрошенное как id) не нашёл. Различаем по ответу by_ids: _missing_ids / _title_miss ≥ 1 — в сегменте такого id нет, значит это название → name_search.
            // Ответа ещё нет — перепроверяем через 0,5 с (до 6 раз; форма — снимок значений, перерисовки prepare_AttrMulti на ответ словаря нет), после — спрашиваем в любом случае
            const _val = V.value
            const _answered = () => !IS._pending_ids?.has?.(_val) || IS._missing_ids?.has?.(_val) || (IS._title_miss?.[_val] || 0) >= 1
            if (!_answered()) {
                if (!store._linkLegacyWait) store._linkLegacyWait = {}
                const wkey = seg + '\u0001' + _val
                const tries = store._linkLegacyWait[wkey] || 0
                if (tries < 6) {
                    store._linkLegacyWait[wkey] = tries + 1
                    setTimeout(() => { try { store.linkLegacy_fix(vueObj, V) } catch (e) { console.warn('linkLegacy_fix', e) } }, 500)
                    return false
                }
            }
            if (!store._linkLegacyAsked) store._linkLegacyAsked = new Set()   // отрицательный кэш: одно значение сегмента — один name_search за сессию стора
            const key = seg + '\u0001' + _val
            if (store._linkLegacyAsked.has(key)) return false
            store._linkLegacyAsked.add(key)
            const _V = V
            store.async_name_search(vueObj, seg, _val, (newItems) => {
                if (_V.value !== _val) return
                const r = linkResolveText(newItems, _val) || linkLegacyResolve(store.itemsSource[seg], _val)
                if (r && String(r.id) !== _val && apply(r)) { vueObj?.flex?.invalidate?.(); return }
                // чтение, не ввод: без тоста; пусто или неоднозначно — значение остаётся текстом
                if (!store.hide_console) console.log(`[linkLegacy] ${seg}: «${_val}» — name_search не дал единственного совпадения, остаётся текстом`)
            })
            return false
        },
        prepare_AttrMulti(vueObj, attr_col, dataItem, parentsList, checkValue=false) {
            const store = this

            let V = store.check_AttrMulti(attr_col, dataItem)

            const refresh_value = vueObj.attr?.attr_type === 'AttrTabGrid'
            if (V?.binding && refresh_value) {
                V.value = store.attr_get(vueObj.WIDGET, V)
            }
            // IE 2026 09 04 / ODOO-336283 (заказ Игоря): поле AttrCSS в форме (Style строки лэйаута) —
            // подпись ячейки всегда CSS-текст: строка как есть, словарь (палитра rowStyleButtons /
            // старые записи) → «prop: v; prop2: v2», а не «[object Object]»
            if (refresh_value && V?.attr_type === 'AttrCSS' && V.value != null && V.value !== '') {
                V.valueStr = store.CSS_toLine(V.value)
            }

            // AttrTabGrid (widget-row): V — копия описания поля, а значение — multi-словарь
            // записи {value, valueStr, attr_type, relation_segment, ...}; переносим его
            // отображаемые поля в V — в гриде V и есть этот словарь, рендер совпадает.
            // Повторные prepare (prepare_AttrMulti_all): V.attr_type уже подменён типом из
            // словаря, а refresh_value снова кладёт словарь в V.value — поэтому маркер
            // _valueMulti, иначе словарь ушёл бы как id в get_itemsSource (SQL error на бэке)
            if ((V.attr_type === 'AttrMulti' || V._valueMulti) && store.isinstance_dict(V.value) && 'value' in V.value) {
                V._valueMulti = true
                const VM = V.value
                V.value = VM.value
                if (VM.valueStr) V.valueStr = String(VM.valueStr)
                if (VM.attr_type) {
                    V.attr_type = VM.attr_type
                    V.component = VM.component || VM.attr_type
                }
                if (VM.relation_segment) V.relation_segment = VM.relation_segment
            }

            // AttrLinkChips = AttrLink по данным и резолву подписи (чипс-пилюля —
            // отрисовка колонок, applyStatusChip по relation_segment STATUS*);
            // без нормализации значение в мульти-шапке остаётся сырым id
            if (V.attr_type === 'AttrLinkChips') {
                V.attr_type = 'AttrLink'
                V.component = 'AttrLink'
            }

            if (!V.component && V.attr_type) {
                V.component = V.attr_type
            }
            if (!V.relation_segment && V.relation_segment_binding) {
                V.relation_segment = store.get_value(dataItem, V.relation_segment_binding)
                               || store.get_value(vueObj.WIDGET?.record, V.relation_segment_binding)
            }
            if (!V.relation_version && V.relation_version_binding) {
                V.relation_version = store.get_value(dataItem, V.relation_version_binding)
                               || store.get_value(vueObj.WIDGET?.record, V.relation_version_binding)
            }
            // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): форма AttrTabGrid, ссылка на сегмент — (1) старая запись с НАЗВАНИЕМ вместо id: однозначный пункт словаря сегмента
            // (или ответа name_search, один раз на значение) → id в запись без признака правки (fe.data.linkLegacyTitleToId);
            // (2) несопоставленный текст правки — только подпись с предупреждением, значением он не становится (fe.data.linkTextToId)
            const _ltiRef = refresh_value && linkIsRef(V)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
            if (_ltiRef && V.value && linkLegacyTitleToId_on(store)) store.linkLegacy_fix(vueObj, V)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
            const _ltiKeep = _ltiRef && !V.value && V.is_customValueWarning && linkTextToId_on(store)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва)
            if (!V.value && !_ltiKeep) {   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #116081, дефект Igor: процесна модель — id, не назва): _ltiKeep
                if (V.valueStr) {
                    V.value = V.valueStr
                } else {
                    V.valueStr = ''
                }
            }
            
            if (checkValue && V.value) {
                const valueMulti = store.get_valueMulti_byStr(vueObj, V.value, V, attr_col)
                if (valueMulti !== null && V.value !== valueMulti.value) {
                    V.value = valueMulti.value
                    V.valueStr = valueMulti.valueStr
                }
            }

            // i18n: непустой valueStr_{lang} отображается вместо valueStr;
            // при изменении значения пользователем переводы сбрасываются (reset_valueStr_translations)
            const valueStr_translated = store.get_valueStr_translated(V)
            if (valueStr_translated && V.valueStr !== valueStr_translated) {
                V.valueStr = valueStr_translated
            }

            if (V.attr_type === 'AttrLink' || V.attr_type === 'AttrMulti') {
                if (!V.valueStr_fix || !V.valueStr) {
                    let founded
                    // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b: строка-поле формы составного типа (relation_segments без relation_segment) — название из сегмента, где id найден первым
                    const _mtlSegs = (V.attr_type === 'AttrLink' && !attr_col?.relation_segment) ? mtl_segments(V, store) : null
                    if (_mtlSegs) {
                        founded = mtl_valueMulti(store, V, _mtlSegs, vueObj)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b
                    } else if (V.attr_type === 'AttrLink') {
                        founded = store.get_valueStr(vueObj, V, V, attr_col, parentsList)
                    } else if (V.attr_type === 'AttrMulti') {
                        if (store.isinstance_dict(V.value)) {
                            V.value = V.value?.value
                        }
                        founded = store.get_valueStr(vueObj, V, V)
                        if (!V.valueStr && V.value != null && V.value !== '') V.valueStr = String(V.value)
                    }
                    if (attr_col.customValueWarning && (V.attr_type === 'AttrLink' || V.attr_type === 'AttrMulti')) {
                        if (founded && V.is_customValueWarning) {
                            delete V.is_customValueWarning
                        } else if (!founded && V['valueStr-new']) {
                            V.valueStr = V['valueStr-new']
                            delete V.is_customValueWarning
                        } else if (!founded && !V.is_customValueWarning && V.value && !String(V.value).startsWith('#') && !String(V.value).startsWith('=')
                                // warning только когда резолвить есть чем: без
                                // relation_segment/itemsSource значение самодостаточно —
                                // строка/число (напр. статический текст ячейки печати)
                                // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b: составной тип, id не найден ни в одном сегменте — пометка как у одиночной ссылки
                                && (V._mtlState === 'missing' || V.relation_segment || attr_col.relation_segment
                                    || (Array.isArray(attr_col.itemsSource) && attr_col.itemsSource.length)
                                    || (Array.isArray(V.itemsSource) && V.itemsSource.length)
                                    || attr_col.use_itemsSourcesView || attr_col.itemsSource_source)) {
                            V.is_customValueWarning = true
                        } else if (V.is_customValueWarning && !mtl_keepWarning(V, founded)) {   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048d: составной тип — пометку «нигде нет» снимает только найденное; пересборка / ожидание ответа — нет
                            delete V.is_customValueWarning
                        }
                    } else if (V.is_customValueWarning) {
                        delete V.is_customValueWarning
                    }
                    
                    if (V.attr_type === 'AttrLink' && V.relation_segment) {
                        V.pi = store.get_value_segment(V.relation_segment, 'pi', "pi pi-arrow-right")
                    } else {
                        V.pi = ''
                    }
                }
                // pi не зависит от valueStr: когда valueStr уже пришёл с бэка (reload),
                // блок выше пропускается и без этого кадр пересборки рендерится без иконки —
                // она «доезжала» отдельным кадром после пересчёта по itemsSource
                if (!V.pi && V.attr_type === 'AttrLink' && V.relation_segment) {
                    V.pi = store.get_value_segment(V.relation_segment, 'pi', "pi pi-arrow-right")
                }
                if (!V.pi && V.attr_type === 'AttrLink' && !V.relation_segment && V._mtlSeg) V.pi = store.get_value_segment(V._mtlSeg, 'pi', "pi pi-arrow-right")   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b: стрелка — по найденному сегменту (открытие: mtl_segmentOf в onButtonOpen__Click)
            } else if (V.attr_type === 'AttrLinkOdoo') {
                const itemOdoo = V.value
                if (Array.isArray(itemOdoo)) {
                    V.value = itemOdoo[0] ?? '';
                    V.valueStr = itemOdoo[1] ?? '';
                } else {
                    // webscm 2026 10 23 / ODOO-348737: пустую ссылку (many2one) Odoo отдаёт как false — в форме пусто, а не текст «false»
                    V.value = itemOdoo === false ? '' : itemOdoo;
                    V.valueStr = V.value;
                }
            // } else if (V.attr_type === 'AttrMulti') { until 2024 12 05
            //     V.valueStr = String(V.value?.valueStr || '')
            //     // V.value = V.value.value || ''
            //     // Object.assign(V, V.value)

            } else if (V.attr_type === 'AttrGrid' && Array.isArray(V.value)) {
                // IE 2026 09 05 / ODOO-336330 (репорт Игоря): табличное поле формы (AttrGrid, напр. Tablespaces) —
                // строки показаны деревом ниже, текст в ячейке значения не нужен (String([...]) давал «[object Object],…»)
                V.valueStr = ''
            } else {
                // IE 2026 09 28 / ODOO-342342 (приёмка Д4): у узла с переводами подписи (valueStr_{lang}) valueStr — базовое название: на языке без перевода
                // (en) показываем его, а не value — этап пути был «stage-1», раздел инструкции — «docs:docs/…#…» (и эта подпись уходила в запись)
                V.valueStr = gridText_multiDisplay(V, valueStr_translated)
                if (V.is_customValueWarning) {
                    delete V.is_customValueWarning
                }
            }
        },
        get_valueStr(vueObj, V, attr, attr_col=null, parentsList=[]) { // return founded
            const store = this
            if (store.is_eval(V.value)) {
                V.valueStr = V.value
                return true
            }
            if (attr_col !== null && (attr_col.itemsSource || attr_col.relation_segment || attr_col.use_itemsSourcesView)) {
                if (store.get_valueStr(vueObj, V, attr_col, null, parentsList)) {
                    return true
                }
            }
            if (attr.use_itemsSourcesView) {
                // список из реестра itemsSourcesView (+ служебные #-элементы)
                const itemsSource = store.get_itemsSource(vueObj, {}, attr, { fetchMode:'justGet' })
                if (itemsSource?.data) {
                    const foundItem = itemsSource.ids?.[V.value]
                    V.valueStr = foundItem ? foundItem.title : (V.valueStr || V.value)
                    return !!foundItem
                }
            }
            if (attr.relation_segment && V.value) {
                let itemsSource = store.get_itemsSource(vueObj, {}, attr, { ids:[ V.value ] })
                V.valueStr = itemsSource.ids?.[V.value]?.title || V.valueStr || V.value
                return !!(itemsSource.ids?.[V.value]?.title)
            } else if (attr.itemsSource) {
                let itemsSource_data = attr.itemsSource
                if (parentsList.length) {
                    let foundItem_parent = itemsSource_data.find(item => item.id === parentsList[0].value)
                    itemsSource_data = foundItem_parent?.attrs||[]
                }

                const foundItem = itemsSource_data.find(item => item.id === V.value)
                V.valueStr = foundItem ? foundItem.title : (V.valueStr || V.value)
                return !!foundItem
            }
            return false
        },
        get_valueMulti_byStr(vueObj, subTitle, attr, attr_col, previous_title='', parentsList=[]) {
            const store = this
            if (attr_col !== null) {
                let valueMulti = store.get_valueMulti_byStr(vueObj, subTitle, attr_col, null, previous_title, parentsList)
                if (valueMulti !== null) {
                    return valueMulti
                }
            }
            let itemsSource = store.get_itemsSource(vueObj, {}, attr, { fetchMode:'justGet'})
            if (itemsSource?.ids) {
                let foundItem,
                subTitle_lowerCase = String(subTitle).trim().toLowerCase(),
                itemsSource_data = itemsSource.data
                
                if (parentsList.length && !attr_col) {
                    let foundItem_parent = itemsSource_data.find(item => item.id === parentsList[0].value)
                    itemsSource_data = foundItem_parent?.attrs||[]
                    // itemsSource_parent = get_itemsSource_parent(itemsSource_data, parentsList)
                }
                
                if (!parentsList.length && subTitle in itemsSource.ids) {
                    foundItem = itemsSource.ids[subTitle]
                }

                foundItem = foundItem || itemsSource_data.find(item => item?.title === subTitle)
                foundItem = foundItem || itemsSource_data.find(item => item?.code === subTitle)
                foundItem = foundItem || itemsSource_data.find(item => item?.code === subTitle)
                // IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С, поиск по всем языкам): введённое название на другом языке — вариант названия строки
                // справочника (titles_alt: база, meta.title_{lang}; бэк get_itemsSource) точно или без учёта регистра
                foundItem = foundItem || itemsSource_data.find(item => Array.isArray(item?.titles_alt) && item.titles_alt.includes(subTitle))
                foundItem = foundItem || itemsSource_data.find(item => Array.isArray(item?.titles_alt) && item.titles_alt.some(v => String(v).toLowerCase() === subTitle_lowerCase))

                // foundItems = itemsSource_data.filter(item => item.title.startsWith(subTitle))
                foundItem = foundItem || itemsSource_data.find(item => item?.title?.startsWith(subTitle))
                foundItem = foundItem || itemsSource_data.find(item => item?.title?.toLowerCase().startsWith(subTitle_lowerCase))
                foundItem = foundItem || itemsSource_data.find(item => item?.title?.toLowerCase().includes(subTitle_lowerCase))
                foundItem = foundItem || itemsSource_data.find(item => Array.isArray(item?.titles_alt) && item.titles_alt.some(v => String(v).toLowerCase().includes(subTitle_lowerCase)))   // IE 2026 09 25 / ODOO-341407

                // for (let item of itemsSource_data) {
                //     if (item.title.includes(subTitle)) {
                //         foundItem = item
                //         break
                //     }
                // }

                if (foundItem) {
                    return { value:foundItem.id, valueStr:foundItem.title, attr_type:'AttrLink', relation_segment:itemsSource.segment||'' }
                }
            }

            return null
        },
        get_itemsSource_byStr(vueObj, subTitle, attr, attr_col, previous_title, parentsList, maxItems=10) {
            const store = this
            if (attr_col !== null) {
                let [valueMulti, itemsSource] = store.get_itemsSource_byStr(vueObj, subTitle, attr_col, null, previous_title, parentsList, maxItems)
                if (valueMulti !== null) {
                    return [valueMulti, itemsSource]
                }
            }
            let itemsSource = store.get_itemsSource(vueObj, {}, attr, { fetchMode:'justGet'})
            if (itemsSource?.ids) {
                let itemsSource_data = itemsSource.data
                const subTitle_lowerCase = String(subTitle).trim().toLowerCase()
                
                if (parentsList.length && !attr_col) { // TODO TASKS-transform.fields
                    let foundItem_parent = itemsSource_data.find(item => item.id === parentsList[0].value)
                    itemsSource_data = foundItem_parent?.attrs||[]
                    // itemsSource_parent = get_itemsSource_parent(itemsSource_data, parentsList)
                }
                
                // if (!parentsList.length && subTitle in itemsSource.ids) {
                //     foundItem = itemsSource.ids[subTitle]
                // }

                let foundItems = []
                store.add_foundItems1(itemsSource_data, subTitle, foundItems, 'title', maxItems)
                store.add_foundItems1(itemsSource_data, subTitle, foundItems, 'code', maxItems)
                store.add_foundItems1(itemsSource_data, subTitle, foundItems, 'id', maxItems)

                store.add_foundItems2(itemsSource_data, subTitle_lowerCase, foundItems, 'title', maxItems)
                store.add_foundItems2(itemsSource_data, subTitle_lowerCase, foundItems, 'code', maxItems)
                store.add_foundItems2(itemsSource_data, subTitle_lowerCase, foundItems, 'id', maxItems)

                store.add_foundItems3(itemsSource_data, subTitle_lowerCase, foundItems, 'title', maxItems)
                store.add_foundItems3(itemsSource_data, subTitle_lowerCase, foundItems, 'code', maxItems)
                store.add_foundItems3(itemsSource_data, subTitle_lowerCase, foundItems, 'id', maxItems)
                store.add_foundItemsAlt(itemsSource_data, subTitle_lowerCase, foundItems, maxItems)   // IE 2026 09 25 / ODOO-341407: названия на других языках

                return [foundItems, itemsSource]
            }

            return [null, null]
        },
        add_foundItems1(itemsSource_data, subTitle, foundItems, binding, maxItems) {
            // Add items matching the exact case first
            if (foundItems.length < maxItems) {
                let additionalItems = itemsSource_data
                    .filter(item => 
                        item[binding] && item[binding].startsWith(subTitle)
                        && !foundItems.some(found => found[binding] === item[binding])
                    )
                    .slice(0, maxItems - foundItems.length)
                foundItems.push(...additionalItems)
            }
        },
        add_foundItems2(itemsSource_data, subTitle, foundItems, binding, maxItems) {
            // Add items matching case-insensitive startsWith, avoiding clones
            if (foundItems.length < maxItems) {
                let additionalItems = itemsSource_data
                    .filter(item => 
                        item[binding] && item[binding].toLowerCase().startsWith(subTitle)
                        && !foundItems.some(found => found[binding] === item[binding])
                    )
                    .slice(0, maxItems - foundItems.length)
                foundItems.push(...additionalItems)
            }
        },
        // IE 2026 09 25 / ODOO-341407 (этап 2 переводов данных 1С, поиск по всем языкам): строки справочника, у которых введённый текст есть в названии на другом
        // языке (titles_alt — бэк get_itemsSource: база, meta.title_{lang}); идут после совпадений по показанному названию / коду / id
        add_foundItemsAlt(itemsSource_data, subTitle, foundItems, maxItems) {
            if (!subTitle || foundItems.length >= maxItems) return
            const have = new Set(foundItems.map(found => found?.id))
            for (const item of itemsSource_data) {
                if (foundItems.length >= maxItems) break
                if (!item || have.has(item.id) || !Array.isArray(item.titles_alt)) continue
                if (item.titles_alt.some(v => String(v).toLowerCase().includes(subTitle))) { foundItems.push(item); have.add(item.id) }
            }
        },
        add_foundItems3(itemsSource_data, subTitle, foundItems, binding, maxItems) {
            // Add items containing the substring, avoiding clones
            if (foundItems.length < maxItems) {
                let additionalItems = itemsSource_data
                    .filter(item => 
                        item[binding] && item[binding].toLowerCase().includes(subTitle)
                        && !foundItems.some(found => found[binding] === item[binding])
                    )
                    .slice(0, maxItems - foundItems.length)
                foundItems.push(...additionalItems)
            }
        },
        get_itemsSource_parent(itemsSource_data, parentsList, iParent=0) {
            if (parentsList.length > iParent) {
                const value = parentsList[iParent],
                foundItem = itemsSource_data.find(item => item.id === value)
                return foundItem ? get_itemsSource_parent(foundItem, parentsList, iParent+1) : []

            }
            return itemsSource_data
        },
        value_AttrMulti(V) {
            const store = this
            if (store.isinstance_dict(V)) {
                return V.value
            } else {
                return V
            }
        },
        new_valueMulti(attr_col) {
            if (attr_col.default) {
                return { ...attr_col.default }
            } else {
                return {
                    title:'',
                    value:'',
                    valueStr:'',
                    attr_type:'AttrLink',
                    component:'AttrLink',
                }
            }
        },
        is_eval(evaluated_value) {
            return typeof evaluated_value === 'string' && evaluated_value.trim().startsWith('=');
        },
        eval_value(WIDGET, evaluated_value, eval_params = {}, attr) {
            const store = this
            if (!evaluated_value) {
                return true
            }

            try {
                eval_params.WIDGET = WIDGET
                eval_params.get_viewParam = (name, param) => store.get_viewParam(WIDGET, name, param)
                eval_params.get_value = (binding) => store.get_value(WIDGET.record, binding)

                const keys = Object.keys(eval_params)
                const values = Object.values(eval_params)
            
                const func = new Function(...keys, `return ${evaluated_value};`)
                return func(...values)
            } catch (error) {
                // console.error(`Error evaluating value: ${evaluated_value}`, error);
                return false
            }
        },
        truncateText(text, length) {
            if (!text) {
                return ''
            } else if (text.length > length) {
                return text.substring(0, length) + '...'
            }
            return text
        },

        // ----------------------------------- non-empty-widget -----------------------------------
        set_nonEmptyWidget(WIDGET) {
            const store = this
            let attr_nonEmptyWidget = store.get_field0(WIDGET.groupMenu?.commandPanel, 'non-empty-widget', 'name')
            // IE 2026 09 06 / ODOO-336330: панели вкладок — предварительная оценка по данным (ответ widget_open, updateWIDGET, Alt+A):
            // вкладки, чьи данные подтвердились, появляются; не смонтированные пустые остаются скрытыми
            for (const v of Object.values(WIDGET.attrs_vueObj || {})) { try { v?.tabsPrecheck?.() } catch (e) { /* панель в перестройке */ } }
            if (attr_nonEmptyWidget) {
                for (let attr_id in WIDGET.applys_CHIPS) {
                    let vueObj =  WIDGET.applys_CHIPS[attr_id]
                    if (vueObj.need_content_Changed_afterTimeout) {
                        // пересборка запланирована — она сама применит CHIPS; но у грида
                        // скрытой вкладки afterTimeout не наступит, пока вкладка спрятана —
                        // hide пересчитываем сразу, иначе выключение кнопки её не возвращает
                        vueObj.check_attrTab?.(vueObj.data)
                        continue
                    }
                    vueObj.apply_CHIPS(null, {check_nonEmptyWidget:false})
                }
                store.check_nonEmptyWidget(WIDGET)
                for (let attr_id in WIDGET.applys_CHIPS) {
                    let vueObj = WIDGET.applys_CHIPS[attr_id]
                    if (vueObj.need_content_Changed_afterTimeout) continue // пересборка запланирована
                    try {
                        const row = vueObj.flex.selectedRanges?.[0]?.row
                        const col = vueObj.flex.selectedRanges?.[0]?.col
                        if (row) {
                            vueObj.flex.scrollIntoView(row, col ?? -1)
                        }
                    } catch { /* flex may not be ready */ }
                }
            }
        },
        check_nonEmptyWidget(WIDGET) {
            if (this.check_nonEmptyWidget_timeout) { clearTimeout(this.check_nonEmptyWidget_timeout) }
            this.check_nonEmptyWidget_timeout = window.$cg.setTimeout(WIDGET, "store.check_nonEmptyWidget", () => {
                this.check_nonEmptyWidget_afterTimeout(WIDGET)
                this.check_nonEmptyWidget_timeout = null
            }, 100)
        },
        check_nonEmptyWidget_afterTimeout(WIDGET) { // calc countItems
            const store = this
            let attr_nonEmptyWidget = store.get_field0(WIDGET.groupMenu?.commandPanel, 'non-empty-widget', 'name')
            if (attr_nonEmptyWidget) {
                attr_nonEmptyWidget.hide = !Object.keys(WIDGET.applys_CHIPS).length

                attr_nonEmptyWidget.countItems = 0
                if (!attr_nonEmptyWidget.hide && attr_nonEmptyWidget.active) {
                    for (let attr_id in WIDGET.applys_CHIPS) {
                        let vueObj =  WIDGET.applys_CHIPS[attr_id]
                        attr_nonEmptyWidget.countItems += (vueObj.count_empty_rows || 0) + (vueObj.count_empty_columns || 0) + (vueObj.count_empty_tab || 0)
                    }
                }

                // commandPanel рендерит копии groupMenu (updateCommandPanelInPlace) — синхронизируем active/hide/countItems
                WIDGET.attrs_vueObj?.WIDGET?.set_commandPanel?.()
            }
        },

        clear_frontend_markers(record) {
            if (this.isinstance_dict(record)) {
                for (let binding in record) {
                    if (typeof binding === 'string' && binding?.startsWith('@@')) {
                        delete record[binding]
                    } else if (this.isinstance_list(record[binding])) {
                        for (let row of record[binding]) {
                            this.clear_frontend_markers(row)
                        }
                    }
                }
            }
        },

        // ----------------------------------- isMapped-widget -----------------------------------
        set_isMappedWidgets(WIDGET0, timeout=100) {
            if (this.set_isMappedWidgets_timeout) { clearTimeout(this.set_isMappedWidgets_timeout) }
            this.set_isMappedWidgets_timeout = window.$cg.setTimeout(WIDGET0, "store.set_isMappedWidgets", () => {
                this.set_isMappedWidgets_afterTimeout(WIDGET0)
                this.set_isMappedWidgets_timeout = null
            }, timeout)
        },
        set_isMappedWidgets_afterTimeout(WIDGET0) {
            // 1. set_isMappedWidget >> addEdge()
            // 2. validateAttrsToGrid_isMappedWidget
            // 3. flex.refresh() >> refreshed() >> refreshe_svg()

            const store = this
            let WORKSPACE = store.WORKSPACES[WIDGET0.workspace],
            PAGE = WORKSPACE.PAGES[WIDGET0.page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET0.page)

            for (const WIDGET of WIDGETS) {
                store.set_isMappedWidget(WIDGET, true)
                store.validateAttrsToGrid_isMappedWidget(WIDGET)
            }

            if (PAGE.WIDGET_transfer) {
                const attr_grid = store.get_field0(PAGE.WIDGET_transfer.attrs, 'fields-target-source', 'name')
                PAGE.WIDGET_transfer.attrs_vueObj?.[attr_grid?.id]?.flex?.refresh()
            }
        },

        set_isMappedWidget(WIDGET, from_All=false) {
            const store = this
            if (WIDGET.page === 'page-store') return

            let attr_isMappedWidget = WIDGET.attr_isMappedWidget = store.get_field0(WIDGET.groupMenu?.commandPanel, 'isMapped-widget', 'name')

            let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            // рабочая область могла быть пересоздана (смена процессной модели) — отложенный — IE 2026 11 02 / ODOO-349799 (workspace-wording)
            // вызов приходит, когда его в сторе уже нет: тихо выходим, а не падаем
            if (!WORKSPACE) return
            let PAGE = WORKSPACE.PAGES[WIDGET.page]
            // IE 2026 09 09 / ODOO-… (замечание Игоря): задача трансформации, закрытая «мягко» (крестик виджета / галочка Open
            // в «Page widgets»), остаётся в ALL_WIDGETS с _softClosed — раньше она по-прежнему считалась WIDGET_transfer
            // страницы, и формы сегментов продолжали штриховать ячейки привязки. Привязку держит только ОТКРЫТАЯ задача
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET.page && !w.close && !w._softClosed)

            // check WIDGET_transfer
            let change_WIDGET_transfer = false
            if (attr_isMappedWidget || WIDGET.record?.segment === 'TASKS-transform') {
                const WIDGET_transfer = WIDGETS.find(widget => widget.record?.segment === 'TASKS-transform') || null;
                if (PAGE.WIDGET_transfer !== WIDGET_transfer) {
                    PAGE.WIDGET_transfer = WIDGET_transfer
                    change_WIDGET_transfer = true
                }
            }
            if (change_WIDGET_transfer && !from_All) {
                this.set_isMappedWidgets_afterTimeout(WIDGET)
                return
            }

            if (attr_isMappedWidget) {
                // set
                if (PAGE.WIDGET_transfer && PAGE.WIDGET_transfer !== WIDGET && !WIDGET.attr_isMappedWidget.check_binding) {
                    const target_segment = PAGE.WIDGET_transfer.record?.doc?.params?.target_segment,
                    source_segment = PAGE.WIDGET_transfer?.record?.doc?.params?.source_segment

                    let check_segment
                    if (WIDGET.widget_class === 'widget_LIST') {
                        check_segment = WIDGET.record.doc.params?.segment
                    } else {
                        check_segment = WIDGET.record.segment
                    }

                    if (check_segment === target_segment) {
                        attr_isMappedWidget.check_binding = 'target_field'
                        attr_isMappedWidget.mapped_binding = 'source_field'
                        attr_isMappedWidget.pi = 'pi-angle-double-right'
                        attr_isMappedWidget.pi2 = 'pi-angle-double-up'
                    } else if (check_segment === source_segment) {
                        attr_isMappedWidget.check_binding = 'source_field'
                        attr_isMappedWidget.mapped_binding = 'target_field'
                        attr_isMappedWidget.pi = 'pi-angle-double-left'
                        attr_isMappedWidget.pi2 = 'pi-angle-double-down'
                    }
                } 
                
                // unset
                if (!PAGE.WIDGET_transfer && WIDGET.attr_isMappedWidget.check_binding) {
                    attr_isMappedWidget.check_binding = ''
                }

                // validateFieldsToAttrs
                attr_isMappedWidget.hide = !(attr_isMappedWidget.check_binding || WIDGET.record?.segment === 'TASKS-transform')
                attr_isMappedWidget.countItems = 0
                attr_isMappedWidget.countItems_noMapped = 0
                if (!attr_isMappedWidget.hide) {
                    let WORKSPACE = store.WORKSPACES[WIDGET.workspace],
                    PAGE = WORKSPACE.PAGES[WIDGET.page],
                    fields = PAGE.WIDGET_transfer?.record?.doc?.params?.fields || [],
                    attrs = WIDGET.view || []

                    if (WIDGET.widget_class === 'widget_LIST') {
                        let attr = store.get_field(WIDGET.view, 'dataSheet')
                        if (attr && attr.attrs && Array.isArray(attr.attrs) && attr.attrs.length) {
                            this.validateFieldsToAttrs(PAGE, PAGE.WIDGET_transfer, WIDGET, fields, attr.attrs)
                        }
                    } else {
                        this.validateFieldsToAttrs(PAGE, PAGE.WIDGET_transfer, WIDGET, fields, attrs)
                    }

                    // if (attr_isMappedWidget.active) {
                    //     for (let attr_id in WIDGET.applys_CHIPS) {
                    //         let vueObj =  WIDGET.applys_CHIPS[attr_id]
                    //         attr_isMappedWidget.countItems += (vueObj.count_empty_rows || 0) + (vueObj.count_empty_columns || 0) + (vueObj.count_empty_tab || 0)
                    //     }
                    // }
                }

                const state_new = !attr_isMappedWidget.hide && attr_isMappedWidget.active,
                change_check_binding = attr_isMappedWidget.state_before !== state_new
                if (change_check_binding) {
                    if (attr_isMappedWidget.state_before !== undefined) {
                        WIDGET.vueObj.content_Changed()
                    }
                    attr_isMappedWidget.state_before = state_new
                }
            }
        },
        validateAttrsToGrid_isMappedWidget(WIDGET) {
            const store = this
            let WORKSPACE = store.WORKSPACES[WIDGET.workspace],
            PAGE = WORKSPACE.PAGES[WIDGET.page],
            attr_isMappedWidget = store.get_field0(WIDGET.groupMenu?.commandPanel, 'isMapped-widget', 'name')
            if (attr_isMappedWidget && !attr_isMappedWidget.hide) {
                for (let vueObj of Object.values(WIDGET.attrs_vueObj)) {
                    if (vueObj.isMappedWidget_cols) { // AttrTabGrid
                        let hashChanges = 0
                        for (let row of vueObj.flex.rows) {
                            if (row.dataItem?.attr?.binding) {
                                let attr = store.get_field(vueObj.attr.attrs, row.dataItem.attr.binding, ['binding']) // attrsTabGrid 2024 11 28
                                if (attr?.isMapped) {
                                    if (row.dataItem.attr.isMapped !== attr.isMapped) {
                                        row.dataItem.attr.isMapped = attr.isMapped
                                        hashChanges += 1
                                    }
                                    if (row.dataItem.attr['@@node_key'] !== attr['@@node_key']) {
                                        if (row.dataItem.attr['@@node_key']) {
                                            PAGE.vueObj.removeNode(row.dataItem.attr['@@node_key'])
                                            delete row.dataItem.attr['@@node_key']
                                        }
                                        row.dataItem.attr['@@node_key'] = attr['@@node_key']
                                        hashChanges += 1
                                    }
                                    if (row.dataItem.attr.mapped_binding !== attr.mapped_binding) {
                                        row.dataItem.attr.mapped_binding = attr.mapped_binding
                                        hashChanges += 1
                                    }
                                    if (row.dataItem.attr.mapped_title !== attr.mapped_title) {
                                        row.dataItem.attr.mapped_title = attr.mapped_title
                                        hashChanges += 1
                                    }
                                } else if (row.dataItem.attr.isMapped) {
                                    row.dataItem.attr.isMapped = 0
                                    row.dataItem.attr.mapped_binding = ''
                                    row.dataItem.attr.mapped_title = ''
                                    if (row.dataItem.attr['@@node_key']) {
                                        PAGE.vueObj.removeNode(row.dataItem.attr['@@node_key'])
                                    }
                                    delete row.dataItem.attr['@@node_key']
                                    hashChanges += 1
                                }
                            }
                        }
                        if (hashChanges) {
                            vueObj.flex.refresh()
                        }
                    }
                    if (vueObj.isMappedWidget_rows) {  // AttrGrid
                        vueObj.flex.refresh()
                    }
                }
            }
        },
        validateFieldsToAttrs(PAGE, WIDGET_fields, WIDGET_attrs, fields, attrs, parent_binding='') {
            const attr_isMappedWidget = WIDGET_attrs.attr_isMappedWidget
            for (let attr of attrs) {
                if (attr.binding && attr.attr_type !== 'AttrTabGrid') {
                    // // clear_frontend_markers
                    // if (attr['@@node_key']) {
                    //     delete attr['@@node_key']
                    // }

                    attr.isMapped = 0
                    attr.mapped_binding = ''
                    attr.mapped_title = ''
                    let field = fields.find(field => field[attr_isMappedWidget.check_binding]?.value === attr.binding) || null;
                    if (field) {
                        attr.isMapped += 1
                        attr.mapped_binding = field[attr_isMappedWidget.mapped_binding]?.value
                        attr.mapped_title = field[attr_isMappedWidget.mapped_binding]?.valueStr || attr.mapped_binding
                        attr_isMappedWidget.countItems += 1

                        PAGE.vueObj.addEdge(attr, field[attr_isMappedWidget.check_binding], field[attr_isMappedWidget.mapped_binding], WIDGET_attrs, WIDGET_fields)
                    } else {
                        attr_isMappedWidget.countItems_noMapped += 1
                    }
                    if (attr.attrs && Array.isArray(attr.attrs) && attr.attrs.length) {
                        this.validateFieldsToAttrs(PAGE, WIDGET_fields, WIDGET_attrs, (field||{}).attrs || [], attr.attrs)
                    } 
                } else {
                    if (attr.attrs && Array.isArray(attr.attrs) && attr.attrs.length) {
                        this.validateFieldsToAttrs(PAGE, WIDGET_fields, WIDGET_attrs, fields, attr.attrs)
                    }
                }
            }
        },

        // ----------------------------------- childWidgets -----------------------------------
        check_childWidgets(WIDGET, childrenWIDGET=null) {
            const store = this

            if (childrenWIDGET) {
                if ('parentWIDGET' in childrenWIDGET) {
                    const parent = store.findWidget(childrenWIDGET.parentWIDGET.id)
                    WIDGET = parent.WIDGET
                }
            }
            if (WIDGET?.page === 'page-store') return

            // IE 2026 08 21 (заказ Игоря, pageFocus): компонент виджета может быть ещё
            // не смонтирован (fast-entry реплей, перезапрос страницы при возврате) —
            // панели нет, кнопку child-widget довесит set_commandPanel при монтировании
            if (WIDGET && !WIDGET.attrs_vueObj?.WIDGET?.commandPanel_Scale?.[1]) return
            if (WIDGET) {
                // let attr_childWidgets = store.get_field0(WIDGET.groupMenu?.commandPanel, 'child-widget', 'name')
                let attr_childWidgets = store.get_field0(WIDGET.attrs_vueObj.WIDGET.commandPanel_Scale[1], 'child-widget', 'name')
                if (!attr_childWidgets) {
                    attr_childWidgets = { 'name':'child-widget', 'hide':true, 'active':true, 'tooltip': t('Close child widgets'), 'command': 'close_childrenWidgets', 'cssClass':'pi btn-widget-close p-button-white pi-sign-out', uiHelp: 'widget.form.closeChildren' }   // IE 2026 09 23 / ODOO-341407: i18n; IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3
                    this.prepare_attr(attr_childWidgets, 99, WIDGET.id, 'commandPanel')
                    WIDGET.attrs_vueObj.WIDGET.commandPanel_Scale[1].push(attr_childWidgets)
                }

                this.update_childrenWidgets(WIDGET)
                attr_childWidgets.countItems = WIDGET.childrenWidgets.length
                attr_childWidgets.hide = !attr_childWidgets.countItems
            }
        },
        update_childrenWidgets(WIDGET) {
            const store = this
            let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            if (!WORKSPACE) {
                if (!WIDGET.childrenWidgets) WIDGET.childrenWidgets = []
                return
            }
            let PAGE = WORKSPACE.PAGES[WIDGET.page]
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === WIDGET.page)

            WIDGET.childrenWidgets = []
            for (let i = WIDGETS.length - 1; i >= 0; i--) {
                if (WIDGETS[i] !== WIDGET && WIDGETS[i].parentWIDGET?.id === WIDGET.id) {
                    WIDGET.childrenWidgets.push(WIDGETS[i].id)
                    // addEdgeWIDGET(WIDGET, WIDGETS[i])
                }
            }

            function addEdgeWIDGET(WIDGET1, WIDGET2) {
                const node_key1 = WIDGET1['@@node_key'] = '' + WIDGET1.id
                const node1 = PAGE.nodes_svg[node_key1] = WIDGET1.nodes_svg[node_key1] = {
                    key: node_key1,
                    widget_id: WIDGET1.id,
                    WIDGET: WIDGET1,
                    div: $('#WIDGET'+WIDGET1.id)[0],
                    edges_svg: {},
                };

                const node_key2 = WIDGET2['@@node_key'] = '' + WIDGET2.id
                const node2 = PAGE.nodes_svg[node_key2] = WIDGET2.nodes_svg[node_key2] = {
                    key: node_key2,
                    widget_id: WIDGET2.id,
                    WIDGET: WIDGET2,
                    div: $('#WIDGET'+WIDGET2.id)[0],
                    edges_svg: {},
                };

                const edge_key = node_key1 + ';' + node_key2;
                const edge = PAGE.edges_svg[edge_key] = {
                    type: 'edgeWIDGET',
                    key: edge_key,
                    source_key: node_key1,
                    target_key: node_key2,
                };

                if (!node1.edges_svg[edge_key]) {
                    node1.edges_svg[edge_key] = edge
                }
                if (!node2.edges_svg[edge_key]) {
                    node2.edges_svg[edge_key] = edge
                }
            }
        },
        addEdgeWidgetRecord(parentWIDGET, WIDGET) {
            const store = this
            const WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            const PAGE = WORKSPACE?.PAGES?.[WIDGET.page]
            if (!PAGE?.vueObj) return

            const listData = parentWIDGET.record?._doc?.data || []
            const recordIndex = listData.findIndex(row => row.id === WIDGET.record?.id)
            if (recordIndex < 0) return

            const iroot = String(recordIndex)
            const binding = '_doc.data.' + iroot + '._fe.@@node_key'

            // Remove old source nodes from parentWIDGET (preserve its target node key = id)
            for (const key of Object.keys(parentWIDGET.nodes_svg || {})) {
                if (key !== '' + parentWIDGET.id) PAGE.vueObj.removeNode(key)
            }
            // Remove old target node from WIDGET
            if (WIDGET.nodes_svg?.['' + WIDGET.id]) PAGE.vueObj.removeNode('' + WIDGET.id)

            const node_key1 = parentWIDGET['@@node_key'] = '' + parentWIDGET.id + '-_doc.data.' + iroot
            store.set_value(parentWIDGET.record, binding, node_key1)
            parentWIDGET.nodes_svg = parentWIDGET.nodes_svg || {}
            const node1 = PAGE.nodes_svg[node_key1] = parentWIDGET.nodes_svg[node_key1] = {
                type: 'nodeRow',
                key: node_key1,
                widget_id: parentWIDGET.id,
                WIDGET: parentWIDGET,
                binding,
                edges_svg: {},
            }

            const node_key2 = WIDGET['@@node_key'] = '' + WIDGET.id
            WIDGET.nodes_svg = WIDGET.nodes_svg || {}
            const node2 = PAGE.nodes_svg[node_key2] = WIDGET.nodes_svg[node_key2] = {
                key: node_key2,
                widget_id: WIDGET.id,
                WIDGET: WIDGET,
                div: $('#WIDGET' + WIDGET.id)[0],
                join: 'widget',
                edges_svg: {},
            }

            const edge_key = node_key1 + ';' + node_key2
            const edge = PAGE.edges_svg[edge_key] = {
                type: 'edgeWidgetRow',
                key: edge_key,
                source_key: node_key1,
                target_key: node_key2,
            }
            node1.edges_svg[edge_key] = edge
            node2.edges_svg[edge_key] = edge

            const attrVueObj = parentWIDGET.vueObj?.get_vueObj('_doc.data')
            if (attrVueObj?.flex?.refresh) attrVueObj.flex.refresh()
            PAGE.vueObj.refreshe_svg()
        },

        addEdgeWidgetRow(WIDGET, WRow, _meta) {
            const store = this
            let WORKSPACE = store.WORKSPACES[WIDGET.workspace]
            let PAGE = WORKSPACE.PAGES[WIDGET.page]

            // Remove only WIDGET's old SOURCE nodes (key = "id-binding.iroot") to preserve
            // its TARGET node (key = "id") which anchors the parent→WIDGET edge in cascade.
            for (const key of Object.keys(WIDGET.nodes_svg || {})) {
                if (key !== '' + WIDGET.id) PAGE.vueObj.removeNode(key)
            }
            // Remove only WRow's old TARGET node to preserve its SOURCE nodes (WRow's children).
            const wrow_target_key = '' + WRow.id
            if (WRow.nodes_svg?.[wrow_target_key]) PAGE.vueObj.removeNode(wrow_target_key)

            const node_key1 = WIDGET['@@node_key'] = '' + WIDGET.id + '-' + _meta.binding + '.' + _meta.iroot

            const binding = _meta.binding + '.' + _meta.iroot + '._fe.@@node_key'
            // ключ — прямо в dataItem строки-источника: для каскада Row→Row путь
            // binding в record родителя-попапа не резолвится (см. attr_get),
            // и ячейка грида не находила свой узел → связь не рисовалась.
            // Только при открытии по строке (есть iroot): viewParams/chip открываются
            // кнопкой — их якорь x,y (шестерёнка/чип), маркер в строку не писать
            const edge_dataItem = _meta.iroot != null ? store.get_widgetRow_currentItem(_meta, WIDGET) : null
            if (edge_dataItem) {
                if (!edge_dataItem._fe) edge_dataItem._fe = {}
                edge_dataItem._fe['@@node_key'] = node_key1
            } else {
                store.set_value(WIDGET.record, binding, node_key1)
            }
            
            const node1 = PAGE.nodes_svg[node_key1] = WIDGET.nodes_svg[node_key1] = {
                type: 'nodeRow',
                key: node_key1,
                widget_id: WIDGET.id,
                WIDGET: WIDGET,
                // attr: _meta,
                binding,
                // div: $('#WIDGET'+WIDGET.id)[0],
                edges_svg: {},
            };

            if (_meta.x) {
                node1.div = $('#WIDGET'+WIDGET.id)[0];
                node1.x = _meta.x
                node1.y = _meta.y
                node1.join = 'x,y'
            }

            const node_key2 = WRow['@@node_key'] = '' + WRow.id
            const node2 = PAGE.nodes_svg[node_key2] = WRow.nodes_svg[node_key2] = {
                key: node_key2,
                widget_id: WRow.id,
                WIDGET: WRow,
                div: $('#WIDGET'+WRow.id)[0],
                join: 'widget',
                edges_svg: {},
            };

            const edge_key = node_key1 + ';' + node_key2;
            const edge = PAGE.edges_svg[edge_key] = {
                type: 'edgeWidgetRow',
                key: edge_key,
                source_key: node_key1,
                target_key: node_key2,
            };

            if (!node1.edges_svg[edge_key]) {
                node1.edges_svg[edge_key] = edge
            }
            if (!node2.edges_svg[edge_key]) {
                node2.edges_svg[edge_key] = edge
            }

            PAGE.edge_key_WRow = edge_key

            // refresh
            let attr_vueObjSheet = WIDGET.vueObj?.get_vueObj(_meta.binding)
            if (attr_vueObjSheet?.flex?.refresh) {
                attr_vueObjSheet.flex.refresh()
            }
            PAGE.vueObj.refreshe_svg()
        },
        // clearEdgeWidgetRow(WIDGET, WRow) {
        // },
        close_childrenWidgets(WIDGET, filter_widget=null, skip_meta_type=null) {
            const store = this

            store.update_childrenWidgets(WIDGET)
            for (const widget_id of [...WIDGET.childrenWidgets]) {
                let result = store.findWidget(widget_id, WIDGET.workspace)
                if (!filter_widget || result.WIDGET.widget === filter_widget) {
                    if (skip_meta_type && result.WIDGET.record?._meta?.type === skip_meta_type) continue
                    store.close_childrenWidgets(result.WIDGET)
                    store.widget_close(widget_id, false, true)
                }
            }
            store.check_childWidgets(WIDGET)
        },
        get_childrenWidget(WIDGET, filter_widget=null) {
            const store = this

            store.update_childrenWidgets(WIDGET)
            for (const widget_id of [...WIDGET.childrenWidgets]) {
                let result = store.findWidget(widget_id, WIDGET.workspace)
                if (!filter_widget || result.WIDGET.widget === filter_widget) {
                    return result.WIDGET
                }
            }
            return null
        },
        get_widgetRow(filter_widget='widget-row') {
            const store = this
            const WORKSPACE = store.activeWORKSPACE
            const PAGE = WORKSPACE.activePAGE
            const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)

            const widgetsRow = WIDGETS.filter(w => w?.widget === filter_widget);
            if (widgetsRow.length) {
                return widgetsRow[0]
            }
            return null
        },
        set_widgetRecord_nav_shortTitle(WIDGET) {
            const store = this
            const nav = WIDGET._nav
            if (!nav?.siblings?.length) return
            // Save base shortTitle once, after backend has set it
            if (!('shortTitle_base' in nav)) {
                if (!WIDGET.shortTitle) return
                nav.shortTitle_base = WIDGET.shortTitle
            }
            // Compute visible position from parent list's sorted/filtered view
            const parentWidget = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
            let label = nav.currentIndex + 1  // 1-based fallback
            if (parentWidget?.vueObj) {
                const flex = parentWidget.vueObj.get_flex()  // default: _doc.data
                const items = flex?.collectionView?.items
                if (items?.length) {
                    const visibleIdx = items.findIndex(item => item.id === WIDGET.record?.id)
                    if (visibleIdx >= 0) label = visibleIdx + 1
                }
            }
            WIDGET.shortTitle = `${nav.shortTitle_base}[${label}]`
        },

        get_widgetRow_currentItem(meta, parentWidget) {
            // dataItem строки, по которой открыт Row-попап, — из данных грида родителя:
            // для каскада Row→Row биндинг в record родителя-попапа не резолвится
            // напрямую (нужна цепочка родителей, как в attr_get)
            const store = this
            if (!meta?.binding) return null
            const data = parentWidget?.vueObj?.get_vueObj?.(meta.binding)?.data
            if (Array.isArray(data)) {
                return store.get_value({ d: data }, 'd.' + (meta.iroot || '0'))
            }
            return store.get_value(parentWidget?.record, meta.binding + '.' + (meta.iroot || '0'))
        },
        set_widgetRow_shortTitle(WIDGET, _meta) {
            const store = this
            const metaType = _meta?.type || WIDGET.record?._meta?.type
            let label
            WIDGET._rowPath = ''   // IE 2026 09 24 / ODOO-341407: путь каскада Row→Row — только у формы строки (тот же попап переиспользуется под «View» / чипс)
            if (metaType === 'widget-row-viewParams') {
                label = t('View')   // IE 2026 09 23 / ODOO-341407: i18n
            } else if (metaType === 'widget-row-chip') {
                label = t('Chip[{n}]:{type}', { n: _meta.index + 1, type: _meta.type_title })
            } else {
                let rowNum = null
                const parentWidget = store.findWidget(WIDGET.parentWIDGET?.id)?.WIDGET
                if (parentWidget?.vueObj && _meta?.binding && _meta?.iroot != null) {
                    const flex = parentWidget.vueObj.get_flex(_meta.binding)
                    if (flex?.rows?.length) {
                        // номер = плоский индекс строки в гриде (как в шапке: e_row + 1),
                        // для иерархии — по полному iroot, без учёта уровня вложенности
                        const currentItem = store.get_widgetRow_currentItem(_meta, parentWidget)
                        if (currentItem) {
                            const visibleIdx = flex.rows.findIndex(r => r.dataItem === currentItem)
                            if (visibleIdx >= 0) rowNum = visibleIdx + 1
                        }
                    }
                }
                // IE 2026 09 24 / ODOO-341407 (проверка dev02: шапка формы строки «Row[1]» под uk / ru): служебное слово — по словарю
                // (t('Row'): uk «Рядок», ru «Строка»), номер строки — как был; путь каскада — в WIDGET._rowPath ('[5][3]'), а не разбором
                // shortTitle родителя по английскому слову (переведённое слово регулярка не узнавала бы)
                const word = t('Row'), num = `[${rowNum ?? store.get_iroot_numbers(_meta.iroot || '')}]`
                label = word + num
                WIDGET._rowPath = num
                // каскад Row→Row: путь по номерам строк родительских попапов —
                // Row[5][3] = строка 3 попапа, открытого из строки 5 Row-попапа;
                // путь ближайшего Row-родителя (_rowPath; запасной путь — его shortTitle) уже полный
                if (parentWidget?.widget === 'widget-row') {
                    let path = typeof parentWidget._rowPath === 'string' ? parentWidget._rowPath : ''
                    if (!path) {
                        const m = new RegExp('^(?:Row|' + word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')((?:\\[[^\\]]*\\])+)').exec(parentWidget.shortTitle || '')
                        if (m) path = m[1]
                    }
                    if (path) {
                        WIDGET._rowPath = path + num
                        WIDGET.shortTitle = word + WIDGET._rowPath
                        return
                    }
                }
            }
            let level = 1
            let pw = WIDGET.parentWIDGET
            while (pw?.widget === 'widget-row') {
                level++
                pw = this.findWidget(pw.id)?.WIDGET?.parentWIDGET
            }
            WIDGET.shortTitle = level > 1 ? `${label} ${level}` : label
        },

        // -----------------------------------  -----------------------------------
        formatCount(value) {
            if (value) {
                if (value >= 1e15) { // Handle quadrillions
                    return (value / 1e15).toFixed(1) + 'Q';
                } else if (value >= 1e13) { // Handle trillions
                    return (value / 1e12).toFixed(1) + 'T';
                } else if (value >= 1e10) { // Handle billions
                    return (value / 1e9).toFixed(1) + 'B';
                } else if (value >= 1e7) { // Handle millions
                    return (value / 1e6).toFixed(1) + 'M';
                } else if (value >= 100000) {
                    return (value / 1000).toFixed(0) + 'K'
                // } else if (value >= 1000) {
                //     return (value / 1000).toFixed(1) + 'K'
                }
                return value
            } else {
                return ''
            }
            // if (!isNaN(num) && num !== null) {
            //     return num.toLocaleString()
            // } else {
            //     return num;
            // }
        },
        mouse_isInside(target) {
            const store = this,
            rect = target.getBoundingClientRect()
            return (
                store.mouseX >= rect.left &&
                store.mouseX <= rect.right &&
                store.mouseY >= rect.top &&
                store.mouseY <= rect.bottom
            )
        },
        deepCopy(obj) {
            return JSON.parse(JSON.stringify(obj))
        },
        filterSerializable(obj) {
            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                try {
                    JSON.stringify(value);
                    result[key] = value;
                } catch (e) {
                    console.warn(`Key "${key}" with value is not serializable.`);
                }
            }
            return result;
        },
        isTrue(value) {
            if (value == '') {
                return null
            } else {
                return Boolean(value) && !('false'.startsWith(String(value).trim().toLowerCase())) && value != 0
            }
        },
        actionMenu_from_commandPanel(commandPanel, scope = null) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): scope — WIDGET панели (ревью #110599)
            const store = this,
            actionsMenu = []

            if (commandPanel.length) {
                const actionFolder = {titleAction: t('Toolbar'), _key: 'Command panel', attrs:[]}   // IE 2026 09 23 / ODOO-341407: i18n (_key — языконезависимый ключ избранного); IE 2026 10 31 / ODOO-5800 (заказ Игоря: названия меню виджета по смыслу)
                actionsMenu.push(actionFolder)
                for (const action of commandPanel) {
                    if (action.use !== false && action.visible !== false && action.hide !== true && store.checkAccess(action, scope)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + scope
                        actionFolder.attrs.push(store.prepare_actionMenu(action))
                    }
                }
            }

            return actionsMenu
        },
        prepare_actionMenu(attr) {
            // IE 2026 09 23 / ODOO-… (замечание Игоря: «не очень красивый элемент меню документации»): кнопка «?» (widget-docs) приходила только
            // с подсказкой «Documentation (_archive/docs/….md)» — в меню это был сырой путь в три строки. Название пункта — «Documentation»
            // (новый бэк шлёт title), путь и заголовок документа остаются в подсказке пункта
            attr.titleAction = attr.title || (attr.widget === 'widget-docs' ? t('Documentation') : '') || attr.tooltip   // IE 2026 09 23 / ODOO-341407: i18n
            if (!attr.title && attr.widget === 'widget-docs' && !attr._key) attr._key = 'Documentation'   // IE 2026 09 23 / ODOO-341407: ключ избранного (menuFav_key) — английский, не перевод
            // if (attr.cssClass) {
            //     attr.titleAction = `<span class="${attr.cssClass.replace('p-button-white','')}"></span> ${attr.titleAction}`
            // }

            attr.titleCommand = (!attr.cssClass || attr.showCommandTitle) ? attr.title : ''
            // if (attr.hotkey) {
            //     attr.titleCommand += ` (${attr.hotkey})`
            // }

            return attr
        },
        clear_attrItemsSource(attrs) {
            const attrs_ = []
            for (const attr of attrs) {
                const { itemsSource, ...attr_ } = attr
                attrs_.push(attr_)
                if ((attr_.attrs??[]).length) {
                    attr.attrs = this.clear_attrItemsSource(attr_.attrs)
                }
            }
            return attrs_
        },

        // IE 2026 09 30 / ODOO-343621 (Игорь: ⚙ таблицы — пустая форма свойств): doc.viewParams.<grid>.attrs — СПИСОК колонок. Не список (объект по индексам с пустыми
        // каркасами — его писала карточка строки над списком колонок ⚙, см. attr_get / attr_set) — берём настоящие колонки
        // (есть binding / attr_type / name / title) по порядку индексов; нет ни одной — значения как будто нет (живые attr.attrs).
        viewParams_attrsList(value) {
            if (!this.isinstance_dict(value)) return null
            const out = Object.keys(value).filter(k => /^\d+$/.test(k)).sort((a, b) => a - b).map(k => value[k])
                .filter(c => this.isinstance_dict(c) && (c.binding || c.attr_type || c.name || c.title))
            window.viewParamsAttrsFixed = (window.viewParamsAttrsFixed || 0) + 1   // счётчик срабатываний защиты
            return out.length ? out : null
        },
        get_viewParam(WIDGET, name='', param, defaultValue = false, attr=null) {
            if (!name) name = attr.name
            let value = this.get_value(WIDGET.record, `doc.viewParams.${name}.${param}`)
            if (param === 'attrs' && value !== undefined && value !== null && !Array.isArray(value)) {
                value = this.viewParams_attrsList(value)   // IE 2026 09 30 / ODOO-343621 (Игорь: ⚙ таблицы — пустая форма свойств)
            }
        
            if (value !== undefined && value !== null) {
                return value
            }

            // IE 2026 08 18 / ODOO-5512: параметры вида из fieldsMapping (binding
            // 'viewParams.<name>.<param>'). Бэкенд кладёт их в record.viewParams —
            // слой, который до клиента не доезжает (workspace_open отдаёт запись
            // без него, select запись не эхает) — поэтому M03 терял use_cells и
            // правка ячейки не писала переопределение. Читаем значение строки
            // маппинга напрямую из записи.
            const fm = WIDGET.record?.doc?.params?.fieldsMapping
            if (Array.isArray(fm) && fm.length) {
                const bind = `viewParams.${name}.${param}`
                const findRow = (rows) => {
                    for (const row of rows || []) {
                        if (row?.use !== false && row?.attr?.binding === bind) return row
                        if (row?.use !== false && row?.attrs?.length) {
                            const sub = findRow(row.attrs)
                            if (sub) return sub
                        }
                    }
                    return null
                }
                const v = findRow(fm)?.attr?.value
                if (v !== undefined && v !== null && v !== '') {
                    return v
                }
            }

            if (!attr) {
                attr = this.get_field0(WIDGET.view, name, 'name')
            }
            if (attr?.[param] !== undefined) {
                return attr[param]
            } else {
                return defaultValue
            }
        },
        set_viewParam(WIDGET, name='', param, value, attr=null, set_modified=null) {
            if (!name) name = attr.name
            const prev_vaue = this.get_viewParam(WIDGET, name, param, null, attr)
            if (value !== prev_vaue) {
                if (set_modified === null) {
                    set_modified = !((prev_vaue === null || prev_vaue === undefined) && (value === '' || value === 0 || value === false))
                }
                this.set_value(WIDGET.record, `doc.viewParams.${name}.${param}`, value, null, null, null, set_modified)
            }
            if (!attr) {
                attr = this.get_field0(WIDGET.view, name, 'name')
            }
            if (attr && attr[param] !== value) {
                attr[param] = value
            }
        },
        check_CHIPS_highlighted(WIDGET, title, CHIPS, isCheck=false, cssClass='wj-state-match') {
            let check = false;
            let highlightedTitle = title

            if (title) {
                // IE 2026 09 12 / ODOO-… (заказ Игоря): текст поиска — набор частей (через пробел): подсвечиваем каждую найденную в этой
                // ячейке часть (остальные могут быть в других ячейках строки); чипс в режиме опечаток (_fuzzy) — приближённые
                // вхождения получают класс <cssClass>-fuzzy. Выражения «= …» не подсвечиваем
                let ranges = null
                for (let ifilter = 0; ifilter < CHIPS.length; ifilter++) {
                    const chip = CHIPS[ifilter]
                    if (chip.segment !== 'CHIP-Search') continue
                    const t0 = String(chip.title || '').trim()
                    if (!t0 || t0.startsWith('=') || t0.startsWith('style:')) continue   // IE 2026 09 18: «style:…» — отбор по стилям, не текст
                    // IE 2026 09 21 / ODOO-… (замечание Игоря: фраза поиска целиком главнее частей): чипс в режиме фразы (решение грида —
                    // AttrGrid.searchPhrase_decide: фраза есть в данных) подсвечивает только её; отдельные слова («LLC» в «Vaga-Farm LLC») — нет
                    const _rawChip = chip._raw || chip
                    const _ph = (_rawChip._phrase === true && _rawChip._phraseFor === t0) ? searchPhrase(t0) : null
                    const found = _ph ? phraseRanges(title, _ph) : foundTerms(title, searchTerms(t0), _rawChip._fuzzy || 0)   // _fuzzy — ступень опечаток
                    // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): чипс, найденный последней ступенью (_extra — AttrGrid.searchExtra_decide), подсвечивает найденное как приближённое
                    if (found.length) ranges = (ranges || []).concat((_rawChip._extra && _rawChip._extraFor === t0) ? found.map(r => ({ ...r, fuzzy: true })) : found)
                }
                if (ranges) {
                    check = true
                    return highlightRanges(highlightedTitle, ranges, { cls: cssClass, fuzzyCls: cssClass + '-fuzzy' })
                }
                if (WIDGET?.widget_class === 'widget_SEARCH') {
                    const filterChip = String(WIDGET.title)
                    if (title.toLowerCase().indexOf(filterChip.trim().toLowerCase()) >= 0) {
                        check = true
                        highlightedTitle = highlightedTitle.replace(
                            new RegExp(`(${filterChip})`, 'gi'),
                            `<span class="${cssClass}">$1</span>`
                        )
                        return highlightedTitle
                    }
                }
            }

            if (isCheck) {
                return check ? highlightedTitle : false
            } else {
                return highlightedTitle
            }
        },
        check_eval_highlighted(WIDGET, eval_value, itemsSource) {
            const cssClass='eval-field'
            let check = false;
            let highlightedTitle = eval_value

            if (eval_value) {
                const regex = /(get_value\(row,\s*'([^']+)'\s*(?:,\s*([^)\s]+))?\))/g;
                let expressions = [];
                let match;
            
                while ((match = regex.exec(eval_value)) !== null) {
                    expressions.push({
                        fullMatch: match[1],
                        binding: match[2]
                    });
                }

                for (let expression of expressions) {
                    const title = itemsSource.ids?.[expression.binding]?.title
                    if (title) {
                        check = true
                        highlightedTitle = highlightedTitle.replace(
                           expression.fullMatch,
                            `<span class="${cssClass}">${title}</span>`
                        )
                    }
                }

                if (check) {
                    return highlightedTitle
                }
            }
        },
        convertToPlainText(highlightedTitle, itemsSource) {
            const regex = /<span class="eval-field">([^<]+)<\/span>/g;
            let plainText = highlightedTitle;
        
            let match;
            while ((match = regex.exec(highlightedTitle)) !== null) {
                let title = match[1];
        
                let bindingEntry = Object.entries(itemsSource.ids).find(([key, value]) => value.title === title);
                if (bindingEntry) {
                    let binding = bindingEntry[0];
                    let defaultValue = bindingEntry[1]?.default || "0";
        
                    plainText = plainText.replace(match[0], `get_value(row, '${binding}')`);
                }
            }
        
            return plainText;
        },
        // base64url (RFC 4648 §5) для URL-параметра widgets (ит.3 п.4)
        encode_base64url(str) {
            const bytes = new TextEncoder().encode(str)
            let bin = ''
            for (const b of bytes) {
                bin += String.fromCharCode(b)
            }
            return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
        },
        decode_base64url(str) {
            let s = String(str).replace(/-/g, '+').replace(/_/g, '/')
            while (s.length % 4) s += '='
            const bytes = Uint8Array.from(atob(s), c => c.charCodeAt(0))
            return new TextDecoder().decode(bytes)
        },
        // параметр widgets из ссылки «Copy widgets as link» -> массив строк
        // формата get_pageWidgets_layout; null, если параметр битый
        decode_urlWidgets(param) {
            let widgets = null
            try {
                widgets = JSON.parse(this.decode_base64url(param))
            } catch (e) {
                try { // запасная кодировка encodeURIComponent
                    widgets = JSON.parse(decodeURIComponent(param))
                } catch (e2) { /* битый параметр — игнорируем */ }
            }
            return Array.isArray(widgets) && widgets.length ? widgets : null
        },

        // пользовательские чипсы стола → параметр ссылки &where=base64
        // (восстанавливает workspace_show_widgets при открытии по ссылке)
        where_linkParam(workspace = null) {
            try {
                const ws = (workspace && this.WORKSPACES[workspace]) || this.activeWORKSPACE
                // IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»): выключенную строку чипса метрик в ссылку не берём (заглушка без chip_segment открылась бы пустым чипсом)
                const _isMetric = r => r.chip_segment === 'CHIP-Metric'
                const rows = (ws?.record?.doc?.params?.WHERE || []).filter(r => r && !r.hidden && !(_isMetric(r) && r.use === false))
                if (!rows.length) return ''
                // строки WHERE в живом сторе тяжёлые (служебные поля, ссылки) —
                // сериализуем только значимое: полный ряд ломал лимит/JSON и
                // параметр МОЛЧА выпадал из ссылки (реальный случай dev02)
                const pickV = (V) => V ? {
                    value: V.value, valueStr: V.valueStr, title: V.title,
                    attr_type: V.attr_type, component: V.component,
                    relation_segment: V.relation_segment, hideTitle: V.hideTitle, pi: V.pi,
                } : undefined
                // IE 2026 09 13 / ODOO-335246 (разбор с ie-dm7): widget строки ОБЯЗАТЕЛЕН — без него бэк (workspace_applySelector) строку
                // пропускал, calc-наборы не считались и отчёты с «in selector» шли без отбора; ссылка &where= его теряла
                const _metricFull = r => { const c = JSON.parse(JSON.stringify(r)); delete c._fe; delete c.out_of_scope; return c }
                const full = r => _isMetric(r) ? _metricFull(r) : ({
                    use: r.use !== false, condition: r.condition || '',
                    attr_type: r.attr_type, selector_binding: r.selector_binding, ...(r.widget ? { widget: r.widget } : {}),
                    leftValue: pickV(r.leftValue), rightValue: pickV(r.rightValue),
                    attrs: (r.attrs || []).map(x => ({ condition: x?.condition || '', rightValue: pickV(x?.rightValue) })),
                })
                // identity-заглушка выключенного чипа: сам чип сохраняется, значение — нет
                // (реальный кейс dev02: 19 чипсов ~17k, из них use:true один; раздувают
                // именно выключенные — их attrs/rightValue в ссылке не нужны)
                const stub = r => ({
                    use: false, condition: '', attr_type: r.attr_type, ...(r.widget ? { widget: r.widget } : {}),   // IE 2026 09 13 / ODOO-335246
                    selector_binding: r.selector_binding, leftValue: pickV(r.leftValue), attrs: [],
                })
                // ступени: полный состав → заглушки для выключенных → только включённые
                const variants = [
                    () => rows.map(full),
                    () => rows.map(r => r.use !== false ? full(r) : stub(r)),
                    () => rows.filter(r => r.use !== false).map(full),
                ]
                for (const v of variants) {
                    const enc = btoa(unescape(encodeURIComponent(JSON.stringify(v()))))
                    if (enc.length < 6000) return `&where=${encodeURIComponent(enc)}`
                }
                console.warn('[link] where= skipped: too large even for used-only rows')
                return ''
            } catch (e) { console.warn('[link] where= failed:', e?.message); return '' }
        },
        externalLink(action) {
            const store = this
            let url
            if (action.workspace) {
                // URL строим явно от workspace/page ВИДЖЕТА (эталон — ссылка XLSX INFO):
                // window.location показывает АКТИВНЫЙ стол — для виджета другого стола
                // ссылка уводила не туда и несла чужие фильтры
                const pm = store.process_model_record || {}
                const dbid = store.user?.database?.dbid || ''
                const _pmPart = pm.id ? `process_model=${pm.id}&` : ''
                url = `${window.location.origin}${window.location.pathname}#/${dbid}?${_pmPart}workspace=${action.workspace}&page=${action.page || ''}`
                    + store.where_linkParam(action.workspace)
            } else {
                url = window.location.href
                // текущие фильтры стола — в ссылку: иначе новый таб открывается без чипсов
                if (!/[?&]where=/.test(url)) url += store.where_linkParam()
            }
            if (action.action_id) {
                url += `&action=${action.action_id}`
            }
            if (action.record_id) {
                url += `&record=${action.record_id}`
            }
            // IE 2026 09 23 / ODOO-… (заказ Игоря: кнопки в подсказках): ссылка на страницу с набором виджетов (виджет под страницей в панели страниц) — как «Copy widgets as link» (&widgets=)
            if (Array.isArray(action.widgets) && action.widgets.length) {
                url += `&widgets=${store.encode_base64url(JSON.stringify(action.widgets))}`
            }
            if (action.method === 'copyToClipboard') {
                // IE 2026 08 20 / ODOO-336291 (mobile UX) (Safari/iPhone): системный share sheet —
                // AirDrop/Mail/мессенджеры; отмена шита не ошибка; фолбэк — буфер
                if (store.mobileUi?.on && store.mobileUi.share !== false && navigator.share) {
                    navigator.share({ url }).catch(err => {
                        if (err?.name === 'AbortError') return
                        navigator.clipboard.writeText(url)
                            .then(() => store.show_notification({text: t('Copied to clipboard!')}))   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции)
                            .catch(() => {})
                    })
                    return
                }
                navigator.clipboard.writeText(url)
                    .then(() => {
                        store.show_notification({text: t('Copied to clipboard!')})
                    })
                    .catch(err => {
                        // console.error('Failed to copy: ', err)
                        store.show_notification({ text: t('Failed to copy to clipboard: {error}', { error: err.message }), status: 'error' })
                    });
            } else if (action.method === 'openInNewTab') {
                window.open(url, '_blank')
            }
        },
        dropdown_copyRawValue() {
            // сырое значение открытого dropdown ячейки → буфер (кнопка и ⌥⌘C)
            const store = this
            const raw = String(store.dropdown?.value ?? '')
            navigator.clipboard.writeText(raw)
                .then(() => store.show_notification({text: t('Copied: {value}', { value: raw.slice(0, 60) || t('(empty)') })}))   // IE 2026 09 23 / ODOO-341407: i18n
                .catch(err => store.show_notification({text: t('Failed to copy: {error}', { error: err.message }), status: 'error'}))
        },
        structuredCloneWithoutKeys(obj, keysToExclude) {
            const filteredObj = Object.fromEntries(
                Object.entries(obj).filter(([key]) => !keysToExclude.includes(key)) // Исключаем ключи
            );
            return structuredClone(filteredObj);
        },
        structuredCloneWithSelectedKeys_OLD(obj, keysToKeep) {
            const filteredObj = Object.fromEntries(
                Object.entries(obj).filter(([key]) => keysToKeep.includes(key))
            );
            return structuredClone(filteredObj);
        },
        structuredCloneWithSelectedKeys(obj, keysToKeep) {
            const raw = (typeof toRaw === 'function') ? toRaw(obj) : obj; // если Vue доступен
            const filtered = Object.fromEntries(
                Object.entries(raw).filter(([k]) => keysToKeep.includes(k))
            );

            const seen = new WeakSet();

            const sanitize = (v) => {
                if (v === null || v === undefined) return v;

                // primitives
                const t = typeof v;
                if (t === 'string' || t === 'number' || t === 'boolean' || t === 'bigint') return v;

                // drop functions
                if (t === 'function') {
                    console.log(t) // TODO clear in DS >> for clear clone
                    return undefined;
                }

                // drop window/document
                if (v === window || v === document) return undefined;

                // DOM / events
                if (typeof Node !== 'undefined' && v instanceof Node) return undefined;
                if (typeof EventTarget !== 'undefined' && v instanceof EventTarget) return undefined;

                // requests
                if (typeof XMLHttpRequest !== 'undefined' && v instanceof XMLHttpRequest) return undefined;

                // avoid cycles
                if (t === 'object') {
                if (seen.has(v)) return undefined;
                seen.add(v);

                // arrays
                if (Array.isArray(v)) return v.map(sanitize).filter(x => x !== undefined);

                // plain objects
                const out = {};
                for (const [kk, vv] of Object.entries(v)) {
                    const sv = sanitize(vv);
                    if (sv !== undefined) out[kk] = sv;
                }
                return out;
                }

                return undefined;
            };

            const clean = sanitize(filtered);

            return structuredClone(clean);
        },

        get_value_segment(segment, binding = "recordTitle", defaultValue = "") {
            let stack = 0,
            itemsSource_segments = this.get_itemsSource_bySegment('SEGMENTS')

            while (segment && stack < 10) {
                let segmentRecord = itemsSource_segments?.ids?.[segment] || {}
        
                let value = segmentRecord[binding];
                if (value) {
                    return value;
                }
        
                let parentSegment = segmentRecord.parent || "";
                if (!parentSegment || parentSegment === "SEGMENTS") {
                    return defaultValue;
                }
        
                segment = parentSegment;
                stack++;
            }
            return defaultValue;
        },
        get_bindingAttrMulti(binding) {
            return binding.split('.').slice(0, -1).join('.') + '.valueStr'
        },
        updateCellText(cell, newText, oldText) {
            cell.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE && (!oldText || node.nodeValue === oldText)) {
                    node.nodeValue = newText;
                } else {
                    this.updateCellText(node, newText, oldText);
                }
            });
        },
        sync_WORKSPACE(WIDGET, direct='>>WORKSPACE') {
            if (!WIDGET) return
            const WORKSPACE = this.WORKSPACES[WIDGET.workspace] || this.activeWORKSPACE
            if (!WORKSPACE?.record) return   // стол пересоздаётся (смена процессной модели)
            if (WORKSPACE.record.id === WIDGET.record?.id && !WIDGET.record?._meta?.audit_id) { // 2025-02-16
                const WWidget = WIDGET
                if (direct === '>>WORKSPACE') {
                    WORKSPACE.record.doc.params = WWidget.record.doc.params
                } else { // >>WIDGET
                    WWidget.record.doc.params = WORKSPACE.record.doc.params
                    WORKSPACE.WIDGET = WWidget
                }
            }
            if (WIDGET.widget === 'widget-selectors') {
                const WSelectors = WIDGET
                if (direct === '>>WORKSPACE') {
                    WORKSPACE.record.doc.params.WHERE = WSelectors.record.doc.params?.WHERE||[]
                    this.update_CHIPS_from_WHERE(WORKSPACE.record.doc.params)
                    this.workspace_applySelector(WSelectors.workspace, WSelectors.page, WSelectors)
                } else { // >>WIDGET
                    WSelectors.record.doc.params = WSelectors.record.doc.params || {}
                    WSelectors.record.doc.params.WHERE = WORKSPACE.record.doc.params?.WHERE||[]
                }
            }
            // WIDGET.process_model_record = store.process_model_record 2024-07-31
        },
        update_CHIPS_from_WHERE(params) {
            const use = false
            if (use) {
                const WHERE = params.WHERE || []
                if (!params.CHIPS) params.CHIPS = []

                const nonSelectorChips = params.CHIPS.filter(c => c.segment !== 'CHIP-Selector')
                const existingByKey = {}
                for (const c of params.CHIPS) {
                    if (c.segment === 'CHIP-Selector') {
                        const key = c.doc?.WHERE?.[0]?.leftValue?.value
                        if (key != null) existingByKey[key] = c
                    }
                }

                const selectorChips = WHERE.map(rowWHERE => {
                    const key = rowWHERE.leftValue?.value
                    const existing = key != null ? existingByKey[key] : null
                    if (existing) {
                        existing.doc = existing.doc || {}
                        existing.doc.WHERE = [rowWHERE]
                        existing.meta = existing.meta || {}
                        existing.meta.use = rowWHERE.use !== false
                        return existing
                    }
                    return {
                        segment: 'CHIP-Selector',
                        title: rowWHERE.leftValue?.valueStr || rowWHERE.leftValue?.value || '',
                        meta: { use: rowWHERE.use !== false },
                        doc: { WHERE: [rowWHERE] },
                    }
                })

                params.CHIPS = [...nonSelectorChips, ...selectorChips]
            }
        },
        fieldsNoHierarchy(fields) {
            let fields2 = [];

            // АН 2026 08 15 / ODOO-4997: виджет с неполным doc (вставка из буфера)
            // приходит без fields — не роняем content_Changed вызвавшего атрибута
            if (!fields) return fields2;

            fields.forEach(field => {
                if (field.binding) {
                    fields2.push(field);
                } 
                if (field.attrs) {
                    fields2 = fields2.concat(this.fieldsNoHierarchy(field.attrs));
                }
            });
                
            return fields2;
        },
        applyColorScheme(scheme) {
            // класс вешаем на body, а не на корневой div приложения: wijmo рендерит
            // выпадающие меню/редакторы порталом прямо в body — иначе правила до них не дойдут
            this.colorScheme = normalizeColorScheme(scheme)   // валидация + миграция 'style2' → 'style2o'
            const body = document.body
            if (!body) return
            // сначала снимаем ВСЕ прежние cscheme-* классы, затем вешаем актуальный —
            // иначе при переключении на body копились бы классы нескольких схем
            COLOR_SCHEMES.forEach(s => body.classList.remove(`cscheme-${s.id}`))
            body.classList.add(`cscheme-${this.colorScheme}`)
        },
        // ============ IE 2026 09 14 / ODOO-… (заказ Игоря: варианты страниц и фильтров стола) ============
        // Вариант страницы — запись PAGE с variant_of (свой набор виджетов), вариант фильтров — запись FILTERS с workspace
        // (снимок чипсов). Дефолты «для всех / для меня» хранит бэк; здесь — выбор на сессию, команды панели и применение.
        // перечитать стол с бэка БЕЗ сброса объекта стола (страница и роутер живут): виджеты страницы закрываются жёстко,
        // строки страницы (виджеты варианта), запись стола (чипсы) и метки вариантов подменяются, виджеты открываются заново
        workspace_reopen(workspace, page) {
            const store = this
            const WS = store.WORKSPACES[workspace]
            if (!WS) return store.workspace_open(workspace, page)
            const payload = JSON.stringify({
                frontend_sent_timestamp: Date.now(), command: 'workspace_open',
                showSQL: store.showSQL, profiling_params: store.profiling_params,
                variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                ...store.dl2_requestParams(),
                process_model: store.process_model_record.id,
                workspace_init: {
                    workspace, active_page: page, workspaceClass: 'workspace_main',
                    ...(store.pageVariants[workspace] ? { page_variants: store.pageVariants[workspace] } : {}),
                    ...(store.filtersVariant[workspace] !== undefined ? { filters_variant: store.filtersVariant[workspace] } : {}),
                },
                user: store.user,
            })
            $.ajax({
                url: store.url_backend_api, type: 'POST', data: payload, contentType: 'application/json', dataType: 'json', xhrFields: { withCredentials: true },
                success: function (answer) {
                    if (!store.check_loginAfterAjax(null, answer)) return
                    if (answer?.notification && ['error', 'critical'].includes(answer.notification.status)) store.TERMINAL(null, answer, null)
                    const NW = answer?.WORKSPACE
                    const NP = NW?.PAGES?.[page]
                    if (!NW || !NP) return
                    const cur = store.WORKSPACES[workspace]
                    if (!cur || !cur.PAGES?.[page]) return
                    for (const W of (cur.ALL_WIDGETS || []).filter(w => w.page === page && !w.close)) {
                        try { if (W.record?._meta) W.record._meta.modified = false; store.widget_close(W.id, false, true) } catch (e) { /* уже закрыт */ }
                    }
                    cur.record = NW.record
                    store.update_CHIPS_from_WHERE(cur.record.doc.params)
                    cur.filters_variant = NW.filters_variant || null
                    cur.selector_version = NW.selector_version ?? cur.selector_version
                    // страница — на месте (объект держат компоненты): строки виджетов и метка варианта из ответа
                    Object.assign(cur.PAGES[page], { attrs: NP.attrs || [], variant: NP.variant || null, _layoutGroups: undefined })
                    cur.active_page = page
                    cur.activePAGE = cur.PAGES[page]
                    store.workspace_show_widgets(workspace, page)
                    store.variantsEpoch++
                },
                error: function () { store.TERMINAL(null, null, { text: t('Backend error'), status: 'error' }) },   // IE 2026 09 23 / ODOO-341407: i18n
            })
        },
        // ---- IE 2026 10 01 / ODOO-5800 (слово Игоря: «Когда показываем вариант страницы — то берём список виджетов, которые открываем, из него; а меню нужно брать
        // из основной страницы») ----
        // Вариант страницы (бэк page_variants.apply_at_open) подменяет строки страницы PAGE.attrs: группа «Widgets» — строки варианта, прочие группы — основной
        // без onOpening. Набор ОТКРЫТИЯ остаётся из PAGE.attrs (scan_widgets_onOpening, page_openSet, панель страниц); МЕНЮ шапки страницы (AppTopbar.menuTree,
        // горячие клавиши пунктов) — строки ОСНОВНОЙ страницы: WS._menuMain[page] — строки ответа, где страница пришла без варианта (обычное открытие, выбор
        // «основна»); стол открылся сразу с вариантом — фоновый workspace_open того же стола с page_variants {page: ''}: из ответа берутся только строки этой
        // страницы, стол, чипсы и виджеты не трогаются, выбор варианта (pageVariants) не меняется. Выключатель fe.ux.variantMenuFromMain (false — меню варианта, как было)
        variantMenu_on() { return this.setting('fe.ux.variantMenuFromMain', true) !== false },
        variantMenu_sync(workspace, page) {
            const WS = this.WORKSPACES?.[workspace]
            if (!WS?.PAGES) return
            const cache = { ...(WS._menuMain || {}) }
            for (const [pid, P] of Object.entries(WS.PAGES)) {
                if (P && !P.variant && Array.isArray(P.attrs)) cache[pid] = P.attrs
            }
            WS._menuMain = cache
            if (WS.PAGES[page]?.variant && !cache[page] && this.variantMenu_on()) this.variantMenu_fetch(workspace, page)
        },
        // строки меню страницы: у варианта — основной (если уже известны), иначе строки самой страницы
        variantMenu_rows(WS, page) {
            const PAGE = WS?.PAGES?.[page]
            if (!PAGE) return []
            if (PAGE.variant && this.variantMenu_on()) {
                const main = WS._menuMain?.[page]
                if (main) return main
                this.variantMenu_fetch(WS.workspace, page)
            }
            return PAGE.attrs || []
        },
        variantMenu_fetch(workspace, page) {
            const store = this
            const WS = store.WORKSPACES?.[workspace]
            if (!WS || !page) return
            const key = `${workspace}|${page}`
            store._variantMenuPending = store._variantMenuPending || {}
            if (store._variantMenuPending[key]) return
            store._variantMenuPending[key] = true
            const payload = JSON.stringify({
                frontend_sent_timestamp: Date.now(), command: 'workspace_open',
                showSQL: store.showSQL, profiling_params: store.profiling_params,
                variants_off: store.settingsVariants_off() || undefined, ...(store.perf_flag('response_gzip', true) ? {} : { response_gzip_off: true }),
                ...store.dl2_requestParams(),
                process_model: store.process_model_record.id,
                workspace_init: {
                    workspace, active_page: page, workspaceClass: 'workspace_main',
                    page_variants: { ...(store.pageVariants[workspace] || {}), [page]: '' },
                    ...(store.filtersVariant[workspace] !== undefined ? { filters_variant: store.filtersVariant[workspace] } : {}),
                },
                user: store.user,
            })
            $.ajax({
                url: store.url_backend_api, type: 'POST', data: payload, contentType: 'application/json', dataType: 'json', xhrFields: { withCredentials: true },
                success: function (answer) {
                    if (!answer || !store.check_loginAfterAjax(null, answer)) return
                    const NP = answer?.WORKSPACE?.PAGES?.[page]
                    const cur = store.WORKSPACES[workspace]
                    if (!NP || NP.variant || !cur || cur !== WS) return
                    cur._menuMain = { ...(cur._menuMain || {}), [page]: NP.attrs || [] }
                    if (!store.hide_console) console.log(`variantMenu: menu of page ${page} taken from the main page (${(NP.attrs || []).length} rows)`)
                },
                complete: function () { setTimeout(() => { delete store._variantMenuPending[key] }, 3000) },   // повтор не чаще раза в 3 с (ответ без строк / ошибка)
            })
        },
        variants_ctx() {
            const WS = this.activeWORKSPACE
            return WS ? { WS, workspace: WS.workspace, page: WS.active_page, PAGE: WS.PAGES?.[WS.active_page] } : null
        },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): ВРЕМЕННАЯ страница стола — нумерованная страница плитки «+» рейла
        // (Page.checkNewPage: копия служебной page-new с id '1', '2', … по счётчику WORKSPACE.last_newPage). Живёт только во фронте: записи PAGE и строки в списке
        // страниц записи стола у неё нет — вариант делать не от чего, «в саму страницу» сохранять некуда (бэк page_save_variant: «… has no record (temporary page)»).
        // Признак: id — число не больше счётчика и строки с таким id в doc.pages записи стола нет (через группы: узел без relation_segment со вложенными attrs)
        page_isTemp(workspace, page) {
            const WS = this.WORKSPACES?.[workspace]
            const id = String(page ?? '')
            if (settingsPage_isTemp(WS, id)) return true   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): клон шаблона страницы настроек (_temp = 'settings') — строки в списке страниц стола нет
            if (!WS || !/^\d+$/.test(id) || !WS.PAGES?.[id]) return false
            if (Number(id) > Number(WS.last_newPage || 0)) return false
            const inRows = (rows) => (rows || []).some(r => r && (String(r.node?.value ?? r.page ?? '') === id || (Array.isArray(r.attrs) && !r.node?.relation_segment && inRows(r.attrs))))
            return !inRows(WS.record?.doc?.pages)
        },
        // IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): страница настроек стола открывается из меню задач (AppTopbar.tasksPanelPick) и по адресу …&page=page-settings:
        // в списке страниц стола её нет (бэк снял строку и отдал шаблон WORKSPACE.settings_page) — клон шаблона кладётся в PAGES последней страницей (перед «+»,
        // utils/settingsPage.settingsPage_materialize), временной (page_isTemp); страница ещё в столе — открывается она же. Выключатель fe.ux.settingsPageInMenu
        settingsPage_on() { return settingsPage_on(this) },
        settingsPage_ensure(workspace) {
            const WS = this.WORKSPACES?.[workspace]
            if (!WS || !this.settingsPage_on()) return false
            return settingsPage_materialize(WS)
        },
        settingsPage_open(workspace) {
            if (!this.settingsPage_ensure(workspace)) return null
            return this.workspace_open(workspace, SETTINGS_PAGE_ID)
        },
        // выключатель: false — на временной странице кнопки группы Page панели Commands ведут себя как на обычной (прежнее поведение: «+» — новый вариант, ошибка бэка)
        tempPagePlus_on() { return this.setting('fe.ux.tempPagePlusSaves', true) !== false },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице): стол пересобирается с нуля (delete WORKSPACES[ws] + workspace_open — defaults_save:
        // «Save as new page», клон страницы, сброс фильтров) — страницы, открытые до этого, лежат в кэше KeepAlive с ПРЕЖНИМ объектом стола; номер пересборки
        // в ключе страниц (App.routeViewKey) создаёт их заново. Выключатель fe.ux.wsReopenFreshPages=false — как было (возврат показывал устаревшую страницу)
        wsReopen_mark(workspace) {
            if (!workspace || this.setting('fe.ux.wsReopenFreshPages', true) === false) return
            this.wsReopenSerial = { ...(this.wsReopenSerial || {}), [workspace]: (this.wsReopenSerial?.[workspace] || 0) + 1 }
        },
        variants_call(method, params, cb) {
            const store = this
            if (store.readonly_deny('executeBackendMethod', method)) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — варианты страниц и фильтров не сохраняем
            store.executeBackendMethod({}, { method, params }, (answer) => {
                if (answer && answer.status !== 'error') store.variantsEpoch++
                if (cb) cb(answer)
            })
        },
        // ---- IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик») ----
        // Глобальный чипс метрик = строка чипсов стола канала selector_map::metric_chip (chip_segment 'CHIP-Metric', doc {grades, metrics,
        // combos}); условия над витриной (attrs) и наборы calc считает бэк ie-dm7 (методы workspace_metricChip / metric_chip_keys есть у
        // любого виджета бэка). Запрос везёт «виджет стола» — как штатное событие workspace_applySelector: живому виджету-носителю ответ
        // принёс бы побочные эффекты (updateDoc его записи, loading, отмена его собственного запроса). Форма чипса — AttrChips (mode Page)
        metricChipG_row(workspace) {
            const WS = workspace ? this.WORKSPACES?.[workspace] : this.activeWORKSPACE
            return (WS?.record?.doc?.params?.WHERE || []).find(r => r && (r.chip_segment === 'CHIP-Metric' || (r.leftValue?.value ?? r.leftValue) === 'selector_map::metric_chip')) || null
        },
        // отчёт метрик, через который резолвится чипс: строка чипса → параметр стола → открытый виджет с selector_map и полями метрик
        metricChipG_report(workspace) {
            const WS = workspace ? this.WORKSPACES?.[workspace] : this.activeWORKSPACE
            const row = this.metricChipG_row(WS?.workspace)
            const known = String(row?.widget || WS?.record?.doc?.params?.metric_chip_widget || '')
            if (known) return known
            const W = (WS?.ALL_WIDGETS || []).find(w => w && !w.close && w.record?.doc?.params?.selector_map
                && ['grade', 'metric'].every(b => (w.record.doc.viewList || []).some(f => f && f.binding === b)))
            return W?.record?.id || ''
        },
        _metricChipG_call(method, params, onAnswer, onFail = null) {
            const WS = this.activeWORKSPACE
            if (!WS?.workspace) return false
            const report = params?.widget || this.metricChipG_report(WS.workspace)
            const vueObj = { WIDGET: { workspace: WS.workspace, widget_class: 'widget_WORKSPACE', id: -1 } }
            this.executeWidgetMethod(vueObj, { command: 'executeWidgetMethod', method, params: { ...(params || {}), ...(report ? { widget: report } : {}) },
                record_sendToBackend_exclude: ['_doc'], no_del_last_backend_action: true, _response_callback: onAnswer,
                ...(onFail ? { _onResponse: (a) => { if (a === null) onFail() } } : {}) })   // IE 2026 10 11 / ODOO-5800: ошибка запроса (_onResponse(null)) — очередь словаря чистим сразу
            return true
        },
        // поставить / сменить чипс. cb(true) — строка стола обновлена и селекторы применяются; cb(false) — бэк чипс не принял.
        // Снятие чипса — на фронте (строка use false + применение селекторов): ответ бэка с выключенной строкой фронт не принимает
        // (защита пользовательских чипсов от «эха» ответов)
        // widget — отчёт метрик, через который резолвится чипс (пусто — отчёт чипса стола, metricChipG_report)
        metricChipG_set(doc, cb, widget = '') {
            const store = this, WS = this.activeWORKSPACE
            const seq = this._metricChipG_seq = (this._metricChipG_seq || 0) + 1
            // IE 2026 10 04 / ODOO-5800 (fe-78; модель сигналов v2): список причин doc.reasons бэк этапа A не знает — отбор с причинами уходит явными комбинациями по словарю стола
            // (utils/metricChip.metricChip_wire); настройка fe.signals.reasonsWire = 'raw' — списком как есть (когда бэк научится). Отбор без причин — тот же объект
            doc = metricChip_wire(doc, this._metricChipG_cache?.[WS?.workspace]?.keys || [], this.setting('fe.signals.reasonsWire', 'expand'))
            return this._metricChipG_call('workspace_metricChip', { doc: { grades: [...(doc?.grades || [])], metrics: [...(doc?.metrics || [])], horizons: [...(doc?.horizons || [])], statuses: [...(doc?.statuses || [])], combos: [...(doc?.combos || [])],
                ...((doc?.kinds || []).length ? { kinds: [...doc.kinds] } : {}), ...((doc?.signals || []).length ? { signals: [...doc.signals] } : {}), ...((doc?.reasons || []).length ? { reasons: [...doc.reasons] } : {}) /* IE 2026 10 04 / ODOO-5800 (fe-78) */ },   // IE 2026 10 04 / ODOO-5800 (fe-74): виды / сигналы чипса сигналов — только непустые (прежний бэк их не знает)
            ...(widget ? { widget } : {}) }, (answer) => {
                if (!answer) { if (cb) cb(false); return }
                // цепочку ответа (applySelector от имени носителя → updateRelatedWidgets) заменяем штатным применением селекторов стола:
                // у «виджета стола» id -1, а ответ с таким widget_id обрывается до updateRelatedWidgets
                answer.actions_after = []
                if (seq !== store._metricChipG_seq) { answer.workspace_params = null; return }   // ответ устаревшего запроса: новый уже в пути
                const ok = !!answer.workspace_params
                setTimeout(() => {   // после мержа параметров стола из ответа (он идёт сразу за колбэком)
                    if (ok && store.activeWORKSPACE === WS) store.workspace_applySelector(WS.workspace, WS.active_page)
                    if (cb) cb(ok)
                }, 0)
            })
        },
        // ---- IE 2026 09 19 / ODOO-5800 (заказ Игоря «глобальный чипс-метрик»: приём чипса отчётом) ----
        // Слова Игоря: глобальный чипс-метрик «принимался в отчет как чипс-метрик над основной таблицей, чтобы показывать статистику, и так же
        // мог приниматься в отчет как чипс-метрик, фильтрующий на входе формирования выборки отчета». Настройка виджета
        // doc.params.metric_chip_accept (форма Selection → Settings, бэк ie-dm7): input — отчёт режется на входе выборки
        // строками «id in selector [calc]»; table — выборка НЕ режется, чипс зеркалится над таблицей (AttrGrid.metricMirror_*); both — и то и то.
        // IE 2026 09 19 / ODOO-5800 (решение Игоря 19.09: «если пусто — то table по умолчанию»): пустая настройка = table (было input).
        // Следствие: виджет без словаря метрик (график, список без правил-метрик) при пустой настройке глобальный чипс метрик не замечает —
        // резать его выборку = поставить Input filter в его настройках. Выключатель fe.ux.metricChipAcceptTable (false — пусто = input, как было)
        // IE 2026 09 19 / ODOO-5800 (решение Игоря 19.09 по предложению ie-webscm7: «пусто = Table chip только у виджетов со словарём метрик, у остальных —
        // Input»): виджет БЕЗ словаря метрик при пустой настройке принимает чипс как Input filter — его выборка режется наборами стола, а не остаётся вовсе
        // без внимания к чипсу. Есть ли словарь, говорит бэк статическим признаком record._doc.metric_dict (be-ie a1a441194: при открытии и в ответах select
        // списков и отчётов). Признака нет (прежний бэк, иной класс виджета) — как прежде, table. Выключатель fe.ux.metricChipAcceptByDict
        metricChipG_accept(WIDGET, widget_init = null) {
            if (this.setting('fe.ux.metricChip', true) === false || this.setting('fe.ux.metricChipGlobal', true) === false) return 'input'
            const raw = WIDGET?.record?.doc?.params?.metric_chip_accept
            const v = String((raw && typeof raw === 'object' ? (raw.value ?? raw.id) : raw) || '').trim()
            if (v === 'input' || v === 'table' || v === 'both') return v
            if (this.setting('fe.ux.metricChipAcceptTable', true) === false) return 'input'
            if (this.setting('fe.ux.metricChipAcceptByDict', true) !== false) {
                if (this.metricDict_of(WIDGET, widget_init) === false) return 'input'
                // IE 2026 09 19 / ODOO-5800 (идея ie-dm7 #30920, слово Игоря): словарь метрик «в сеансе». Признак бэка статичен — считается по записи на момент
                // ответа; группы строк, переключённые на фронте, и выключенные precache-группы могут спрятать ВСЕ строки с отметками метрик: словаря у
                // таблицы по сути нет (зеркало отбирало бы по невидимым отметкам — оставались одни родители) → как у виджета без словаря, приём Input.
                // Поправку ведёт грид данных (AttrGrid.metricDict_frontSync). Выкл: fe.ux.metricChipAcceptSessionDict = false
                if (WIDGET?._metricDictFrontOff && this.setting('fe.ux.metricChipAcceptSessionDict', true) !== false) return 'input'
            }
            return 'table'
        },
        // признак словаря метрик виджета: из записи (record._doc.metric_dict), иначе — запомненный по id виджета. Память нужна дважды: пока виджет ещё
        // ОТКРЫВАЕТСЯ (записи нет, а копию параметров запроса уже надо выбрать — иначе каждое открытие под чипсом метрик кончалось бы перечитыванием,
        // metricChipG_openMismatch) и когда очередной ответ принёс _doc без признака. Хранится и в localStorage (feMetricDict) — переживает перезагрузку
        metricDict_key(WIDGET, widget_init = null) {
            return String(WIDGET?.record?.id || widget_init?.record?.id || widget_init?.widget || WIDGET?.widget || '')
        },
        metricDict_of(WIDGET, widget_init = null) {
            const key = this.metricDict_key(WIDGET, widget_init)
            const v = WIDGET?.record?._doc?.metric_dict
            if (!this._metricDict) {
                this._metricDict = {}
                try { Object.assign(this._metricDict, JSON.parse(localStorage.getItem('feMetricDict') || '{}')) } catch (e) { /* приватный режим */ }
            }
            if (typeof v === 'boolean') {
                if (key && this._metricDict[key] !== v) {
                    this._metricDict[key] = v
                    try { localStorage.setItem('feMetricDict', JSON.stringify(this._metricDict)) } catch (e) { /* приватный режим */ }
                }
                return v
            }
            return key && typeof this._metricDict[key] === 'boolean' ? this._metricDict[key] : undefined
        },
        // действующий отбор глобального чипса метрик стола (null — чипса нет, он выключен или пуст)
        metricChipG_docActive(workspace) {
            const row = this.metricChipG_row(workspace)
            if (!row || row.use === false || !row.doc) return null
            // IE 2026 10 04 / ODOO-5800 (fe-76): + виды / сигналы чипса сигналов v2 — отбор только из них (Kind = Problem) считался пустым: отчёт его не зеркалил,
            // хотя наборы узлов стола бэк по нему резал. При выключателе fe.metricChips.signalsV2 = false списки не действуют — как раньше
            const lists = ['grades', 'metrics', 'horizons', 'statuses', 'combos', ...(this.setting('fe.metricChips.signalsV2', true) !== false ? ['kinds', 'signals'] : []), ...(this.setting('fe.signals.modelV2', true) !== false ? ['reasons'] : [])]   // IE 2026 10 04 / ODOO-5800 (fe-78): + причины
            return lists.some(k => Array.isArray(row.doc[k]) && row.doc[k].length) ? row.doc : null
        },
        // accept = table: запросы виджета везут копию параметров стола, где набор calc взят БЕЗ чипса метрик — канал бэка
        // calc::selector_map::metric_chip::false (пересечение прочих чипсов); когда чипс метрик единственный, такого канала нет —
        // строка calc выключается («без отбора»). Свои Set-поля виджета (ниже) подменяют calc своим каналом calc::<поле>::false:
        // у виджета с тем и другим сразу главнее своё поле (канала «без обеих граней» у бэка нет).
        // ⚠ Саму строку чипса в копии НЕ выключаем: метка наборов calc_selectors_mark несёт дайджест действующих чипсов стола, и запрос
        // с другим составом чипсов бэк считает устаревшим — пересчитывает наборы под него и возвращает workspace_params, которые фронт
        // кладёт в стор (наборы calc стола подменились бы вариантом «без чипса метрик» до следующего запроса другого виджета)
        // IE 2026 09 19 / ODOO-5800 (после «пусто = table»: запрос стола — не table-виджет). Замер dev02 после правки «пустая настройка = table» (ie-dm7 edf69625): у «виджета стола»
        // (носитель события workspace_applySelector и методов чипса, id -1, записи нет) настройка пуста → он считался table-виджетом, его
        // запрос уходил с подменённым calc, а ответ с наборами отбрасывала защита вариантов — наборы calc стола переставали обновляться
        // (после постановки чипса calc оставался 40 вместо 14, метка пустая). Запрос стола всегда везёт параметры стола как есть.
        // Виджет, который ещё ОТКРЫВАЕТСЯ (записи нет), идёт по умолчанию пустой настройки; что предположили — помним
        // (_metricAcceptAtOpen): если запись придёт с другим приёмом, виджет перечитается (metricChipG_openMismatch).
        // Канала ::false нет, а у стола действуют и другие чипсы (наборы стола ещё не пересчитаны) — calc не выключаем (виджет остался бы
        // без отбора прочими чипсами): в копии выключается строка чипса метрик, бэк сам пересчитает наборы под такой запрос
        metricChipG_paramsFor(WIDGET, params, widget_init = null) {
            if (!params?.WHERE?.length || !WIDGET || WIDGET.id === -1 || WIDGET.widget_class === 'widget_WORKSPACE') return params
            const accept = this.metricChipG_accept(WIDGET, widget_init)   // IE 2026 09 19: widget_init — id открываемого виджета для запомненного признака словаря
            const rows = params.WHERE
            const chip = rows.find(r => r && r.chip_segment === 'CHIP-Metric')
            const active = !!chip && chip.use !== false && (chip.attrs || []).length > 0
            if (!WIDGET.record && active) WIDGET._metricAcceptAtOpen = accept
            if (accept !== 'table' || !active) return params
            const excl = rows.find(r => r?.leftValue?.value === 'calc::selector_map::metric_chip::false')
            if (!excl) {
                const others = rows.some(r => r && r !== chip && r.use !== false && r.condition !== 'between' && !String(r?.leftValue?.value || '').startsWith('calc')
                    && ((r.attrs || []).some(a => a && a.use !== false && (a.rightValue || {}).value) || (r.rightValue || {}).value))
                if (others) return { ...params, WHERE: rows.map(r => r === chip ? { ...r, use: false } : r) }
            }
            return { ...params, WHERE: rows.map(r => {
                if (r?.leftValue?.value === 'calc') return excl ? { ...r, use: excl.use, attrs: excl.attrs || [] } : { ...r, use: false, attrs: [] }
                return r
            }) }
        },
        // виджет открылся под действующим чипсом метрик: запрос открытия шёл по умолчанию пустой настройки, а запись пришла с другим
        // приёмом (резать выборку / не резать) — перечитать
        metricChipG_openMismatch(WIDGET) {
            const assumed = WIDGET?._metricAcceptAtOpen
            if (!assumed) return false
            delete WIDGET._metricAcceptAtOpen
            if (!WIDGET.record || !this.metricChipG_docActive(WIDGET.workspace)) return false
            return (assumed === 'table') !== (this.metricChipG_accept(WIDGET) === 'table')
        },
        // IE 2026 09 19 / ODOO-5800 (словарь метрик «в сеансе»): приём чипса у виджета сменился посреди сеанса (table ↔ input: все строки с отметками метрик
        // спрятаны группами строк либо вернулись) — под ДЕЙСТВУЮЩИМ чипсом выборка виджета запрошена под прежний приём: перечитать один раз.
        // Петли нет: после перечитывания состояние групп то же, поправка грида не меняется — смены приёма нет
        metricChipG_acceptChanged(WIDGET, before) {
            if (!WIDGET || WIDGET.close) return false
            if ((before === 'table') === (this.metricChipG_accept(WIDGET) === 'table')) return false
            if (!WIDGET.record || !WIDGET.vueObj || !this.metricChipG_docActive(WIDGET.workspace)) return false
            clearTimeout(WIDGET._metricAcceptTimer)
            WIDGET._metricAcceptTimer = setTimeout(() => {
                delete WIDGET._metricAcceptTimer
                if (WIDGET.close || !WIDGET.vueObj) return
                this._metricAcceptRereads = (this._metricAcceptRereads || 0) + 1   // счётчик для проб
                this.executeStoreMethod(WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })
            }, 0)
            return true
        },
        // сменился только глобальный чипс метрик (и производные наборы calc), а виджет принимает его как чипс над таблицей —
        // выборка виджета от него не зависит, перечитывать нечего: зеркало над таблицей обновится само (вотчер грида)
        metricChipG_tableCovers(WIDGET, changed) {
            if (this.metricChipG_accept(WIDGET) !== 'table') return false
            let hit = false
            for (const f of changed) {
                if (f === 'calc' || f.startsWith('calc::') || f.startsWith('calc_')) continue
                if (f !== 'selector_map::metric_chip') return false
                hit = true
            }
            return hit
        },
        // словарь всей витрины метрик (форма чипса: три списка с числом узлов расчёта); считается под прочими чипсами стола
        metricChipG_keys(cb) { return this.metricChipG_dict('', cb) },
        // словарь метрик отчёта widget (пусто — отчёт чипса стола): ключи его витрины под его отборами и прочими чипсами стола.
        // maxAgeMs > 0 — годится недавний ответ (сопоставление строк с ключами: числа не нужны)
        metricChipG_dict(widget, cb, maxAgeMs = 0) {
            const ws = this.activeWORKSPACE?.workspace || '', id = ws + '|' + (widget || '')
            const memo = this._metricChipG_dictMemo = this._metricChipG_dictMemo || {}
            const wait = this._metricChipG_keysWait = this._metricChipG_keysWait || {}
            // IE 2026 10 11 / ODOO-5800 (находка ie-growth7 #71595): ошибка запроса чистит очередь сразу, а не по таймеру 45 с; выкл: window.feSettings.set('fe.ux.metricChipQueueClear', false)
            return chipDict_request({ wait, memo, id, cb, maxAgeMs, clearOnError: this.setting('fe.ux.metricChipQueueClear', true) !== false,
                send: (onKeys, onFail) => this._metricChipG_call('metric_chip_keys', widget ? { widget } : {}, (answer) => {
                    const keys = Array.isArray(answer?.metric_chip_keys) ? answer.metric_chip_keys : null
                    if (answer) { answer.command = ''; delete answer.updates }   // updateDoc ответа адресован записи виджета-носителя, у «виджета стола» её нет
                    onKeys(keys)
                }, onFail) })
        },
        metricChipG_historyKey(workspace) {
            const u = this.user?.id || this.user?.email || 'user', db = this.user?.database?.dbid || ''
            return `metricChipHistory:${u}:${db}:ws:${workspace || this.activeWORKSPACE?.workspace || ''}`
        },
        variants_panel(cb) {
            const c = this.variants_ctx()
            if (!c) return
            this.executeBackendMethod({}, { method: 'variants_panel', params: { workspace: c.workspace, page: c.page } }, cb)
        },
        // открыть под текущей страницей виджеты варианта ('' — самой страницы): выбор на сессию + переоткрытие стола
        variants_usePage(variantId) {
            const c = this.variants_ctx()
            if (!c) return
            this.pageVariants[c.workspace] = { ...(this.pageVariants[c.workspace] || {}), [c.page]: variantId || '' }
            this.workspace_reopen(c.workspace, c.page)
        },
        // применить снимок чипсов варианта фильтров ('' — фильтры стола) СРАЗУ: чипсы, селекторы, перечитать виджеты
        variants_useFilters(variantId, WHERE, title = '') {
            const c = this.variants_ctx()
            if (!c || !c.WS.record?.doc?.params) return
            this.filtersVariant[c.workspace] = variantId || ''
            this.chipsKeep_clear(c.workspace)
            this.chipsKeep_applyRows(c.WS.record.doc.params, Array.isArray(WHERE) ? WHERE : [])
            c.WS.filters_variant = variantId ? { id: variantId, title: title || variantId } : null
            const store = this
            this.workspace_applySelector(c.workspace, c.page, null, { _onResponse: () => store.updateRelatedWidgets(c.workspace, c.page) })
            this.variantsEpoch++
        },
        variants_saveFilters({ private: priv = false } = {}) {
            const c = this.variants_ctx()
            if (!c) return
            const def = `${c.WS.record?.title || c.workspace} · ${priv ? t('my filters') : t('filters')}`   // IE 2026 09 23 / ODOO-341407: i18n
            const title = window.prompt(t('Filters variant title'), def)
            if (title === null) return
            const where = c.WS.record?.doc?.params?.WHERE ?? []
            const store = this
            this.variants_call('filters_save_variant', { workspace: c.workspace, title: (title || '').trim() || def, where, private: priv, default_me: true }, (answer) => {
                if (answer?.variant) { store.filtersVariant[c.workspace] = answer.variant; c.WS.filters_variant = { id: answer.variant, title: answer.title || title } }
            })
        },
        variants_saveWidgets({ private: priv = false } = {}) {
            const c = this.variants_ctx()
            if (!c) return
            const pageTitle = c.PAGE?.node?.valueStr || c.page
            const def = `${pageTitle} · ${priv ? t('my variant') : t('variant')}`   // IE 2026 09 23 / ODOO-341407: i18n
            const title = window.prompt(t('Widgets variant title'), def)
            if (title === null) return
            const widgets = this.get_pageWidgets_layout(c.workspace, c.page)
            const store = this
            this.variants_call('page_save_variant', { workspace: c.workspace, page: c.page, title: (title || '').trim() || def, widgets, private: priv, default_me: true }, (answer) => {
                if (answer?.variant) {
                    store.pageVariants[c.workspace] = { ...(store.pageVariants[c.workspace] || {}), [c.page]: answer.variant }
                    if (c.PAGE) c.PAGE.variant = { id: answer.variant, title: answer.title || title }
                }
            })
        },
        // «Save»: в текущий вариант; без варианта — в саму страницу / стол для всех (админ)
        variants_save(kind) {
            const c = this.variants_ctx()
            if (!c) return
            if (kind === 'filters') {
                const where = c.WS.record?.doc?.params?.WHERE ?? []
                this.chipsKeep_clear(c.workspace)
                this.variants_call('filters_variant_save', { workspace: c.workspace, variant: c.WS.filters_variant?.id || '', where })
            } else {
                const widgets = this.get_pageWidgets_layout(c.workspace, c.page)
                this.variants_call('page_variant_save', { workspace: c.workspace, page: c.page, variant: c.PAGE?.variant?.id || '', widgets })
            }
        },
        // «Use current»: заново применить текущий вариант (фильтры — сразу, виджеты — переоткрыть страницу)
        variants_useCurrent(kind) {
            const c = this.variants_ctx()
            if (!c) return
            if (kind === 'filters') {
                const store = this
                this.variants_panel((answer) => {
                    const cur = c.WS.filters_variant?.id || ''
                    const row = cur ? (answer?.filters || []).find(f => f.id === cur) : null
                    store.variants_useFilters(cur, row ? row.WHERE : (answer?.workspace?.WHERE || []), row?.title || '')
                })
            } else {
                this.workspace_reopen(c.workspace, c.page)
            }
        },
        // флаги Default for all / for me у вариантов (kind: 'filters' | 'page'); clear — снять
        variants_setDefault(kind, variantId, scope, clear = false) {
            const c = this.variants_ctx()
            if (!c) return
            if (kind === 'filters') this.variants_call('filters_variant_default', { workspace: c.workspace, page: c.page, variant: variantId || '', scope, clear: !!clear })
            else this.variants_call('page_variant_default', { workspace: c.workspace, page: c.page, variant: variantId || '', scope, clear: !!clear })
        },
        // IE 2026 09 19 / ODOO-… (замечание Игоря: «нужно предусмотреть удаление для вариантов (т.е. не основных настроек)»): вариант страницы /
        // вариант фильтров уходит в архив (бэк page_variants.page_variant_delete / filters_variant_delete: владелец или админ, ссылки
        // по умолчанию на него снимаются). Удалён ТЕКУЩИЙ вариант — возвращаемся к основной: у страницы её собственные виджеты,
        // у фильтров — фильтры стола. Основную страницу и фильтры стола удалить отсюда нельзя
        variants_delete(kind, variantId, title = '', mainWHERE = null) {
            const c = this.variants_ctx()
            if (!c || !variantId) return
            if (!confirm(t('Delete the variant "{title}"? It is moved to the archive; the main {main} stays as it is',   // IE 2026 09 23 / ODOO-341407: i18n
                { title: title || variantId, main: kind === 'filters' ? t('filters') : t('page') }))) return
            const store = this
            const wasCurrent = kind === 'filters' ? c.WS.filters_variant?.id === variantId : c.PAGE?.variant?.id === variantId
            this.variants_call(kind === 'filters' ? 'filters_variant_delete' : 'page_variant_delete', { workspace: c.workspace, page: c.page, variant: variantId }, (answer) => {
                if (!answer || answer.status === 'error' || answer.deleted !== variantId || !wasCurrent) return
                if (kind === 'filters') store.variants_useFilters('', Array.isArray(mainWHERE) ? mainWHERE : (answer.workspace?.WHERE || []), '')
                else store.variants_usePage('')
            })
        },
        // страница, открываемая при открытии стола (scope all — админ, me — я)
        variants_pageDefault(pageId, scope, clear = false) {
            const c = this.variants_ctx()
            if (!c) return
            this.variants_call('page_default', { workspace: c.workspace, page: pageId, scope, clear: !!clear, current_page: c.page })
        },
        applyIconScheme(scheme) { // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): классы ischeme-<id> / ischeme-<family> на body
            this.iconScheme = normalizeIconScheme(scheme)
            applyIconSchemeClasses(this.iconScheme)
        },
        applyDarkTheme(dark) {
            this.darkThemePref = !!dark
            // $appState живёт в globalProperties; AppTopbar может ещё не быть смонтирован —
            // тогда значение подхватится из darkThemePref в его mounted()
            const appState = this.AppTopbar?.$appState
            if (appState) appState.darkTheme = this.darkThemePref
        },
        // demo-webscm 2026 11 02 / ODOO-350612 (навигатор интерфейса): состояние дока — одним объектом (реактивность computed компонентов); ширина — в границах;
        // открытие/режим/ширина запоминаются в localStorage (как размеры панелей), шаги пути — нет (их грузит NavigatorDock с бэка)
        navigator_set(patch) {
            const store = this
            store.navigator = navigator_next(store.navigator, patch, globalThis.localStorage)   // ODOO-350612 (devap -134): первый вызов сеанса — поверх сохранённого, иначе умолчание 400 затирало ширину
            // раскладку страницы под новое место справа пересчитывает App.watch.navReserve в том же такте (ODOO-350612: раньше — событие resize до обновления DOM + дебаунсы)
        },
        navigator_restore() {   // состояние прошлой сессии браузера (без open: док при входе открывает только настройка navigatorAtStart)
            this.navigator = navigator_withSaved(this.navigator, navigator_loadSaved(globalThis.localStorage))   // ODOO-350612: та же логика, что у первого navigator_set
        },
        navigator_autoOpen() {   // настройка «Відкривати навігатор при старті» — один раз за вход, после первой построенной страницы
            const store = this
            store.navigatorPageReady = true   // demo-webscm 2026 11 02 / ODOO-350612 (live48): с этого момента ответ navigator_settingsLoad зовёт автооткрытие сам
            if (store.navigatorAutoOpened || !store.navigatorAtStart || !navigator_on(store)) return
            store.navigatorAutoOpened = true
            store.navigator_restore()
            store.navigator_set({ open: true })
        },
        // demo-webscm 2026 11 02 / ODOO-350612 (live48: новый профиль браузера не открывал док и не видел отметок): вход на app.webscm.ai отвечает ядро
        // (backend-core) — в login и в сессии, которую отдаёт check_sessionKey, ключей навигатора нет, хотя они лежат в USER базы стенда.
        // После входа в базу спрашиваем их у БЭКА СТЕНДА сами, один раз за вход в базу, параллельно get_startup — командой чтения user_settings_get
        // (status ok + сохранённые ключи записи USER, без записи). Ревью PR #226: прежний путь — user_settings_save с пустыми params — ПИСАЛ запись
        // USER (бэк всегда делает db.save): каждый вход каждого пользователя переписывал её на всех стендах, устаревший снимок мог затереть настоящее
        // сохранение. Прямой $.ajax (X-Database / X-CSRFToken ставит ajaxSetup + prefilter), не executeBackendMethod: старый бэк без команды (пустой
        // ответ HTTP 200 / 403 роли «только чтение») и сеть — молча, без тоста, остаёмся на кэше браузера. localStorage остаётся кэшем. Роль «только чтение»
        // читает тоже: команда в белом списке чтения (readonly.READ_COMMANDS), а свои отметки у роли остаются локальными
        navigator_settingsLoad() {
            const store = this
            const dbid = store.user?.database?.dbid || ''
            if (!dbid || store.navigatorSettingsDb === dbid || !navigator_on(store)) return
            store.navigatorSettingsDb = dbid
            try {
                $.ajax({
                    url: store.url_backend_api, type: 'POST', contentType: 'application/json', dataType: 'json', xhrFields: { withCredentials: true },
                    data: JSON.stringify({ frontend_sent_timestamp: Date.now(), command: 'user_settings_get', params: {}, user: store.user }),
                    success: (answer) => {
                        const s = navigator_settingsFromAnswer(answer)
                        if (!s || store.user?.database?.dbid !== dbid) return   // стенд без поля / ошибка — молчим; база уже сменилась — ответ не наш
                        if ('atStart' in s) store.navigatorAtStart = s.atStart
                        if ('done' in s) store.navigatorDone = s.done   // NavigatorDock следит за store.navigatorDone и перечитывает отметки
                        if (store.navigatorPageReady) store.navigator_autoOpen()   // страница уже построена — решаем сейчас; иначе решит хук после построения
                    },
                    error: () => {},   // старый бэк / сеть — кэш браузера, без тоста
                })
            } catch (e) { /* нет jQuery / url — без запроса */ }
        },
        navigatorAtStart_save(on) {   // флажок меню пользователя → USER.doc.params.navigatorAtStart (тот же канал, что тема / язык: user_settings_save)
            const store = this
            store.navigatorAtStart = !!on
            if (store.readonly_on()) return
            store.executeBackendMethod({}, { command: 'user_settings_save', params: { navigatorAtStart: !!on } }, () => {})
        },
        navigatorDone_save(list) {   // demo-webscm 2026 11 02 / ODOO-350612 (fix 3): отметки «пройдено» → USER.doc.params.navigatorDone (тот же канал); бэк без поля молча игнорирует ключ
            const store = this
            const done = Array.isArray(list) ? list.slice() : []
            store.navigatorDone = done
            if (store.readonly_on()) return
            store.executeBackendMethod({}, { command: 'user_settings_save', params: { navigatorDone: done } }, () => {})
        },
        saveColorSettings(vueObj) {
            const store = this
            const darkTheme = store.darkThemePref ?? !!vueObj?.$appState?.darkTheme
            store.darkThemePref = darkTheme
            // localStorage — мгновенный кэш: читается в main.js до первого рендера и остаётся
            // единственным хранилищем, если бэк ещё не знает команду user_settings_save
            try {
                localStorage.setItem('webscm_colorScheme', store.colorScheme)
                localStorage.setItem('webscm_darkTheme', darkTheme ? 'true' : 'false')
                localStorage.setItem('webscm_iconScheme', store.iconScheme) // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок)
            } catch (e) { /* приватный режим / переполнение — настройка просто не переживёт перезагрузку */ }
            if (store.readonly_on()) return   // IE 2026 09 29 / ODOO-342781: роль «только чтение» — тема только локально (localStorage выше), бэк не зовём
            store.executeBackendMethod({}, {
                command: 'user_settings_save',
                params: { colorScheme: store.colorScheme, darkTheme, iconScheme: store.iconScheme }, // IE 2026 09 14 / ODOO-… (заказ Игоря: схемы иконок): iconScheme
            }, () => {})
        },
        get_user(answer) {
            let user = answer?.user || {};
            user.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // IE 2026 09 23 / ODOO-341407: явный язык из записи USER (выбран на другом устройстве) — принять один раз и перезагрузить;
            // в запросах уезжает язык, выбранный на ЭТОМ устройстве (бэк локализует подписи по user.language тела запроса)
            // IE 2026 09 26 / ODOO-341407 (fe.i18n.firstLoadHold): с флагом перезагрузка не назначается таймером — решение исполнит i18n_firstLoadHold
            // в обработчике login / check_sessionKey сразу после разбора ответа (навигация и стол не начинаются)
            const _i18nHold = i18n_switchFlag(this, 'firstLoadHold')
            // IE 2026 10 01 / ODOO-341407: выбор этого браузера, не дошедший до бэка (метка langPending), язык USER не перебивает; бэк уже отдаёт тот же язык — метка снимается
            const _i18nPk = langPendingKey(user), _i18nSrv = user.language || answer?.language, _i18nSet = !!(user.language_set ?? answer?.language_set)
            const _i18nPend = readLangPending(_i18nPk, null, { maxAgeMs: LANG_PENDING_MAX_AGE_MS })   // IE 2026 10 07 / ODOO-341407: метка старше срока (ответ сохранения так и не пришёл) — язык из USER
            if (_i18nPend && _i18nSet && _i18nPend === _i18nSrv) clearLangPending(_i18nPk, _i18nPend)
            const _i18nUser = adoptServerLanguage(_i18nSrv, _i18nSet, { hold: _i18nHold, trigger: 'get_user', pending: _i18nPend })
            if (_i18nHold && _i18nUser && typeof _i18nUser === 'object') this._i18nUserDecision = _i18nUser
            // IE 2026 09 25 / ODOO-341407: явный ли язык USER — его читает сверка с языком базы по умолчанию (settings_apply → adoptDbDefaultLanguage,
            // отложена на такт и выполняется уже после этого get_user; свойство стора вне state — $reset логина его не сбрасывает)
            this._i18nExplicit = !!(user.language_set ?? answer?.language_set)
            user.language = getLanguage()

            this.timezoneOffset = - new Date().getTimezoneOffset()
            this.navigatorAtStart = user.navigatorAtStart === true   // demo-webscm 2026 11 02 / ODOO-350612: настройка пользователя (бэк get_user_settings)
            this.navigatorDone = Array.isArray(user.navigatorDone) ? user.navigatorDone.slice() : null   // demo-webscm 2026 11 02 / ODOO-350612 (fix 3): отметки навигатора с пользователя; нет поля — null

            return user;
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана): opts.secondsIfGiven — секунды только если они есть во входе
        // (ветка utc_to_local всегда даёт seconds = "0" — непустая строка, и «2026-10-16T12:26Z» показывалась «… 14:26:00»); без opts — как прежде
        formatDateHTML(inputDate, utc_to_local=false, opts=null) {
            const hasTime = !Number.isNaN(Date.parse(inputDate)); // inputDate.includes(':') || inputDate.includes('T');
            const secondsShown = !(opts && opts.secondsIfGiven) || /\d:\d\d:\d/.test(String(inputDate ?? ''))   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
            let year, month, day, hours, minutes, seconds, milliseconds;

            // isEmpty
            if (inputDate === '0001-01-01T00:00:00' 
                || inputDate === '3000-01-01' // TEMP
            ) {
                return ''
            }

            if (hasTime && utc_to_local) {
                // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                // inputDate = new Date(inputDate + "Z").toLocaleString()

                // inputDate = new Date(inputDate + "Z").toISOString().replace("T", " ").slice(0, 23)

                // let dateObj = new Date(inputDate + "Z")
                // dateObj.setMinutes(dateObj.getMinutes() + this.timezoneOffset)
                // inputDate.toISOString().replace("T", " ").slice(0, 23)

                // IE 2026 10 10 / ODOO-345618 (заказ Игоря: согласование под ключ) — P5: время бэка согласования уже с поясом («2026-10-09T20:24:59Z», «…+03:00») — второй «Z» давал Invalid Date → «NaN-NaN-NaN» (монитор, события, форма единицы); пояс есть — не добавляем (как approvalTime)
                const dateObj = new Date(inputDate + (/(Z|[+-]\d\d:?\d\d)$/.test(String(inputDate).trim()) ? "" : "Z"))

                year = String(dateObj.getFullYear());
                month = String(dateObj.getMonth() + 1);
                day = String(dateObj.getDate());
                hours = String(dateObj.getHours()); // dateObj.getUTCHours();
                minutes = String(dateObj.getMinutes());
                seconds = String(dateObj.getSeconds());
                milliseconds = String(dateObj.getMilliseconds());

            } else {
                const parts = inputDate.split(/[-T\s:.]/);

                year = parts[0] || '';
                month = parts[1] || '';
                day = parts[2] || '';
                hours = parts[3] || '';
                minutes = parts[4] || '';
                seconds = parts[5] || '';
                milliseconds = parts.slice(6).join('') || '';
            }

            let formattedHTML = '';

            if (year) {
                formattedHTML += `<span class="date-year">${year}</span>`;
            }
            if (month) {
                formattedHTML += `-<span class="date-month">${month.padStart(2, '0')}</span>`;
            }
            if (day) {
                formattedHTML += `-<span class="date-day">${day.padStart(2, '0')}</span>`;
            }

            const h = Number(hours || 0);
            const m = Number(minutes || 0);
            const s = Number(seconds || 0);

            if (hasTime && (h || m || s)) {
                formattedHTML += ` <span class="date-time">${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}</span>`;
                if (seconds && secondsShown) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: формат даты в подписи плана)
                    formattedHTML += `:<span class="date-seconds">${seconds.padStart(2, '0')}</span>`;
                }
                // if (milliseconds) {
                //     formattedHTML += `<span class="date-milliseconds">.${milliseconds}</span>`;
                // }
            }

            return formattedHTML;
        },
        formatDate(date) {
            const pad = num => String(num).padStart(2, '0');

            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hours = pad(date.getHours());
            const minutes = pad(date.getMinutes());
            const seconds = pad(date.getSeconds());

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        formatUTC(date) {
            const pad = num => String(num).padStart(2, '0');

            return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ` +
                    `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
        },
        
        // Компактное представление больших чисел для узких колонок: 32168 -> 32K,
        // 1816960 -> 1.8M (K/M/B; <10 — один знак после точки, иначе целое).
        compactNumber(num) {
            const abs = Math.abs(num);
            const fmt = (v) => (v >= 10 ? String(Math.round(v)) : String(Math.round(v * 10) / 10));
            let out;
            if (abs >= 1e9)      out = fmt(abs / 1e9) + 'B';
            else if (abs >= 1e6) out = fmt(abs / 1e6) + 'M';
            else if (abs >= 1e3) out = fmt(abs / 1e3) + 'K';
            else                 out = String(abs);
            return (num < 0 ? '-' : '') + out;
        },
        // IE 2026 09 29 / ODOO-341407: тело — в utils/durationText.js (formatTimeText; юнит-тест без сборки), там же формат 'd' — всегда дни.
        // Опции те же: { daysInMonth = 30, precision = 1, trimZeros = true, localize = true } (localize false — канон «14m» для parseTime)
        formatTimeHTML(seconds, attr_col, opts = {}) {
            return formatTimeText(seconds, attr_col, opts)   // IE 2026 09 29 / ODOO-341407
        },
        formatAgoHTML(inputDate, attr_col) {
            // «как давно произошло событие»: длительность от события до текущего
            // момента — тем же форматтером, что длительности AttrGrid (formatTimeHTML)
            const iso = String(inputDate || '')
            if (!iso) return ''
            const hasTZ = iso.endsWith('Z') || /[+-][0-9]{2}:?[0-9]{2}$/.test(iso)
            const ts = Date.parse(hasTZ ? iso : iso + 'Z') // без зоны — трактуем как UTC (канон admin-info); IE 2026 09 23 / ODOO-341407: i18n (локальная t → ts)
            if (Number.isNaN(ts)) return ''
            let seconds = Math.max(0, Math.round((Date.now() - ts) / 1000))
            // огрубление для «ago»: >1 дня — без часов и мельче, >3 минут — без секунд
            if (seconds > 24 * 3600) seconds -= seconds % (24 * 3600)
            else if (seconds > 3 * 60) seconds -= seconds % 60
            return t('{time} ago', { time: this.formatTimeHTML(seconds, attr_col) })
        },
        // IE 2026 09 10 / ODOO-5800: секунд в единице ввода колонки (input_unit: 'd' дни, 'w' недели, 'h', 'min',
        // 'sec'/'s', 'm' месяцы, 'y' годы); null — единица не задана/неизвестна (голое число = как раньше)
        inputUnit_seconds(input_unit, daysInMonth = 30) {
            const SEC_IN_DAY = 24 * 3600, SEC_IN_MONTH = daysInMonth * SEC_IN_DAY
            return {
                d: SEC_IN_DAY, w: 7 * SEC_IN_DAY, h: 3600, min: 60, sec: 1, s: 1,
                m: SEC_IN_MONTH, y: 12 * SEC_IN_MONTH,
            }[String(input_unit || '').trim().toLowerCase()] || null
        },
        parseTime(str, attr_col, { daysInMonth = 30 } = {}) {
            if (str == null) return 0;

            const raw = String(str).trim().toLowerCase();
            if (!raw) return 0;

            const SEC_IN_DAY   = 24 * 3600;
            const SEC_IN_MONTH = daysInMonth * SEC_IN_DAY;

            // 👉 Бесконечность — sentinel ±999 месяцев (999*30*24*60*60 секунд)
            if (/^[+-]?(∞|inf(inity)?)$/.test(raw)) {
                return (raw[0] === '-' ? -1 : 1) * 999 * 30 * 24 * 3600;
            }

            // 👉 Чистое число (в т.ч. дробное)
            if (/^[\d\s]+(?:\.\d+)?$/.test(raw)) {
                const num = parseFloat(raw.replace(/\s+/g, ''));
                if (!Number.isFinite(num)) return 0;

                // IE 2026 09 10 / ODOO-5800 (заказ Игоря): семейство DOS хранится в СЕКУНДАХ (AttrTime), а
                // вводится по-прежнему днями — единицу ГОЛОГО числа задаёт input_unit колонки ('d' → ×86400);
                // без него — как раньше: месяцы при format 'm', иначе секунды
                const unitSec = this.inputUnit_seconds(attr_col?.input_unit, daysInMonth)
                if (unitSec) return num * unitSec

                return (attr_col?.format === 'm')
                    ? num * SEC_IN_MONTH   // месяцы
                    : num;                 // секунды
            }

            let totalSeconds = 0;

            // IE 2026 09 10 / ODOO-5800: годы (1y = 12m) и недели — симметрия с parseDays, который раньше
            // читал ввод DOS («1.2y»); без них суффикс молча давал 0
            for (const y of raw.matchAll(/(\d+(?:\.\d+)?)\s*y\b/g)) {
                totalSeconds += parseFloat(y[1]) * 12 * SEC_IN_MONTH;
            }
            for (const w of raw.matchAll(/(\d+(?:\.\d+)?)\s*w\b/g)) {
                totalSeconds += parseFloat(w[1]) * 7 * SEC_IN_DAY;
            }

            // Месяцы (дробные)
            for (const m of raw.matchAll(/(\d+(?:\.\d+)?)\s*m\b/g)) {
                totalSeconds += parseFloat(m[1]) * SEC_IN_MONTH;
            }

            // Дни
            for (const d of raw.matchAll(/(\d+(?:\.\d+)?)\s*d\b/g)) {
                totalSeconds += parseFloat(d[1]) * SEC_IN_DAY;
            }

            // Часы
            for (const h of raw.matchAll(/(\d+(?:\.\d+)?)\s*h\b/g)) {
                totalSeconds += parseFloat(h[1]) * 3600;
            }

            // Минуты
            for (const m of raw.matchAll(/(\d+(?:\.\d+)?)\s*min\b/g)) {
                totalSeconds += parseFloat(m[1]) * 60;
            }

            // Секунды
            for (const s of raw.matchAll(/(\d+(?:\.\d+)?)\s*sec\b/g)) {
                totalSeconds += parseFloat(s[1]);
            }

            return totalSeconds;
        },

        formatBytesText(value) {
            const num = Number(value);
            if (!Number.isFinite(num)) return String(value);
            const abs = Math.abs(num);
            const sign = num < 0 ? '-' : '';
            const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
            let i = 0, v = abs;
            while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
            const decimals = i === 0 ? 0 : (v < 10 ? 2 : v < 100 ? 1 : 0);
            return `${sign}${v.toFixed(decimals)} ${units[i]}`;
        },

        formatNumberHTML(value, attr_col) {
            if (value == null) return '';

            const num = Number(value);
            if (!Number.isFinite(num)) return String(value);
            // «жёсткий ноль» (эпсилон-драфт 1e-7) — рисуем «-»
            if (num !== 0 && Math.abs(num) < 0.0001) return '<b class="tooltip-number">-</b>';

            let cls = 'tooltip-number';

            if (num < 0) {
                cls += ' num-negative';
            } else if (num > 0) {
                // cls += ' tooltip-positive'; // опционально
            } else {
                // cls += ' tooltip-zero'; // опционально
                return '';
            }

            let str;
            if (attr_col?.format === 'bytes') {
                str = this.formatBytesText(num);
            } else {
                str = wjcCore.Globalize.format(num, attr_col?.format || 'n0') // num.toLocaleString()
            }

            return `<b class="${cls}"><span class="tooltip-number-value">${str}</span></b>`;
        },

        formatDaysHTML(
            days,
            attr_col,
            {
                daysInMonth = 30,
                monthThreshold = 30,
                forceDays = false,
                precision = 1,
                trimZeros = true,
                localize = true   // IE 2026 09 24 / ODOO-341407: false — канонический английский текст («9m», «5m 19d») для разбора (буфер обмена → parseDays)
            } = {}
        ) {
            const U = (n, u) => durUnit(n, u, localize)   // IE 2026 09 24 / ODOO-341407: единица под язык интерфейса (en — как было: «1.1y», «5m 19d»)
            const v0 = Number(days);

            if (!Number.isFinite(v0)) {
                if (attr_col?.format === 'm') {
                    return U(0, 'm');   // IE 2026 09 24 / ODOO-341407
                }
                return U(0, 'd');
            }

            // знак и модуль
            const sign = v0 < 0 ? '-' : '';
            const abs = Math.abs(v0);

            // sentinel ±999 месяцев (в секундах: 999*30*24*60*60, в днях: 999*30)
            if (abs === 999 * 30) {
                return `${sign}∞`;
            }

            // ноль — отдельно (чтобы не было "-0")
            if (abs === 0) {
                if (attr_col?.format === 'm') {
                    return U(0, 'm');   // IE 2026 09 24 / ODOO-341407
                }
                return U(0, 'd');
            }

            const formatNum = (n) => {
                const s = n.toFixed(precision);
                return trimZeros ? s.replace(/\.?0+$/, '') : s;
            };

            // длительность больше года — в годах: >3 лет целыми ("79y"),
            // >1 года с одной десятичной ("2.3y"); 1y = 12m (360 дней)
            const years_ = abs / daysInMonth / 12;
            const formatYears = () => years_ > 3   // IE 2026 09 24 / ODOO-341407: единицы — U() под язык интерфейса («1,1 р» / «1,1 г»)
                ? U(`${sign}${Math.round(years_)}`, 'y')
                : U(`${sign}${years_.toFixed(1).replace(/\.0$/, '')}`, 'y');

            // 1) Принудительно "месяцы"
            // IE 2026 09 10 / ODOO-5800 (заказ Игоря): формат 'm' = ВСЕГДА месяцы, как у длительностей AttrTime
            // (Offset в отчёте показывал «14m», а та же колонка DOS в списке — «1.2y»); правила округления те же:
            // больше 3 месяцев — целые, меньше месяца — дни, иначе одна десятичная. Годы — только без формата.
            if (attr_col?.format === 'm') {
                const months = abs / daysInMonth;
                if (months > 3) return U(`${sign}${Math.round(months)}`, 'm');   // IE 2026 09 24 / ODOO-341407
                if (months < 1) return U(`${sign}${Math.round(abs)}`, 'd');
                return U(`${sign}${formatNum(months)}`, 'm');
            }

            // 2) Принудительно в днях
            if (forceDays || abs < monthThreshold) {
                return U(`${sign}${formatNum(abs)}`, 'd');   // IE 2026 09 24 / ODOO-341407
            }

            // 3) Месяцы + остаток дней (больше года — те же годы, что и формат 'm')
            if (years_ > 1) return formatYears();
            const months = Math.floor(abs / daysInMonth);
            const restDays = abs - months * daysInMonth;

            let result = U(months, 'm');   // IE 2026 09 24 / ODOO-341407: «5m 19d» → uk «5 міс 19 дн», ru «5 мес 19 дн»
            if (restDays > 1e-9) {
                result += ' ' + U(formatNum(restDays), 'd');
            }

            return sign + result;
        },
        parseBytes(str) {
            if (str == null) return 0;
            const raw = String(str).trim().toLowerCase();
            if (!raw) return 0;

            if (/^-?[\d\s]+(?:[.,]\d+)?$/.test(raw)) {
                return parseFloat(raw.replace(/\s+/g, '').replace(',', '.')) || 0;
            }

            const units = { b: 1, kb: 1024, mb: 1024**2, gb: 1024**3, tb: 1024**4, pb: 1024**5 };
            const m = raw.match(/^(-?)\s*([\d\s]+(?:[.,]\d+)?)\s*([a-z]+)$/);
            if (!m) return 0;

            const sign = m[1] === '-' ? -1 : 1;
            const num = parseFloat(m[2].replace(/\s+/g, '').replace(',', '.'));
            const mult = units[m[3]] ?? 1;
            return sign * num * mult;
        },

        parseDays(str, attr_col, { daysInMonth = 30 } = {}) {
            if (str == null) return 0;

            const raw = String(str).trim().toLowerCase();
            if (!raw) return 0;

            // ✅ Бесконечность — sentinel ±999 месяцев (±999*30 дней)
            if (/^[+-]?(∞|inf(inity)?)$/.test(raw)) {
                return (raw[0] === '-' ? -1 : 1) * 999 * 30;
            }

            // ✅ Если только число (в т.ч. дробное)
            // - format !== 'm' => это дни
            // - format === 'm' => это месяцы
            if (/^[\d\s]+(?:\.\d+)?$/.test(raw)) {
                const num = parseFloat(raw.replace(/\s+/g, ''));
                if (!Number.isFinite(num)) return 0;

                return (attr_col?.format === 'm')
                    ? num * daysInMonth
                    : num;
            }

            let totalDays = 0;

            // ✅ Годы (в т.ч. дробные): 1y = 12m — симметрия formatDaysHTML
            const yearMatches = [...raw.matchAll(/(\d+(?:\.\d+)?)\s*y\b/g)];
            for (const y of yearMatches) {
                totalDays += parseFloat(y[1]) * 12 * daysInMonth;
            }

            // ✅ Месяцы (в т.ч. дробные)
            const monthMatches = [...raw.matchAll(/(\d+(?:\.\d+)?)\s*m\b/g)];
            for (const m of monthMatches) {
                totalDays += parseFloat(m[1]) * daysInMonth;
            }

            // ✅ Дни (в т.ч. дробные)
            const dayMatches = [...raw.matchAll(/(\d+(?:\.\d+)?)\s*d\b/g)];
            for (const d of dayMatches) {
                totalDays += parseFloat(d[1]);
            }

            return totalDays;
        },

        extractCompany(email='', dbid='') {
            if (email) {
                const parts = email.split('/').map(part => part.trim());
                return parts.length > 1 ? parts[1] : null;
            } else {
                const parts = dbid.split('_').map(part => part.trim());
                return parts.length > 1 ? parts[1] : null;
            }
        },
        set_commandActive(vueObj, command) {
            command.target_binding = vueObj.attr.binding
            if (command.binding) {
                let value
                if (command.binding.startsWith('doc.viewParams.')) {
                    const parts = (command.binding||'').split('.'),
                    name = parts[2],
                    param = parts[3]

                    value = vueObj.get_viewParam(param, null)
                    // инпуты панели читают record по binding: если viewParam не сохранён,
                    // а действует значение из view-атрибута (напр. frozenColumns=1),
                    // показывалось 0 — синхронизируем без пометки modified
                    if (value !== null && value !== undefined
                        && this.get_value(vueObj.WIDGET.record, command.binding) == null) {
                        this.set_value(vueObj.WIDGET.record, command.binding, value, undefined, undefined, undefined, false)
                    }
                } else {
                    value = this.get_value(vueObj.WIDGET.record, command.binding)
                }

                if (value === null && command.defaultValue !== null) {
                    value = command.defaultValue
                    this.set_value(vueObj.WIDGET.record, command.binding, value, undefined, undefined, undefined, false)
                }

                const active = (value === command.checkValue || (value === undefined && command.checkValue === command.default))
                if (command.active !== active) {
                    command.active = active
                }
            }
        },
        // IE 2026 08 30 / ODOO-5800 (заказ Игоря): нужен ли движок py тому, что открыто
        // СЕЙЧАС. Признак тот же, по которому виджет сам решает будить движок
        // (attr_loadPyodide): у записи есть скрипт-модули или у колонки есть code-eval.
        pyNeededNow() {
            const store = this
            const _hasCodeEval = (attrs, depth) => {
                if (!Array.isArray(attrs) || depth > 6) return false
                for (const a of attrs) {
                    if (!a || typeof a !== 'object') continue
                    if (a['code-eval']) return true
                    if (a.attrs && _hasCodeEval(a.attrs, depth + 1)) return true
                }
                return false
            }
            const _needs = (W) => !!W && (Object.keys(W.record?._import_modules || {}).length > 0
                                          || _hasCodeEval(W.view, 0))
            // виджеты стола живут в WORKSPACES[*].ALL_WIDGETS; store.WIDGETS — служебные
            // (workspace-store), их проверяем тоже, но одних их мало: именно на ALL_WIDGETS
            // лежит dataSheet отчёта с py-модулями (проверено зондом на столе Purchase).
            // Смотрим ТЕКУЩУЮ страницу активного стола — «прорабатываемые виджеты» по заказу
            // Игоря: на соседней странице py-виджет может быть, но пока её не открыли, движок
            // не нужен; при открытии виджет разбудит его сам (attr_loadPyodide)
            const _act = store.activeWORKSPACE
            const _ws = _act && store.WORKSPACES?.[_act.workspace]
            if (_ws) {
                const _page = _act.active_page
                for (const W of (_ws.ALL_WIDGETS || [])) {
                    if (_page && W?.page && W.page !== _page) continue
                    if (_needs(W)) return true
                }
            } else {
                for (const wsId in (store.WORKSPACES || {})) {
                    for (const W of (store.WORKSPACES[wsId]?.ALL_WIDGETS || [])) {
                        if (_needs(W)) return true
                    }
                }
            }
            for (const id in (store.WIDGETS || {})) {
                if (_needs(store.WIDGETS[id])) return true
            }
            return false
        },
        async loadPyodide() {
            const store = this
            // R11: идемпотентность — фоновая загрузка и запрос «по нужде» из
            // attr_loadPyodide не должны грузить движок дважды
            if (store._pyodide_loading) return store._pyodide_loading
            let _resolve_loading
            store._pyodide_loading = new Promise(r => { _resolve_loading = r })
            try {
            const PYODIDE_CDN = 'https://cdn.jsdelivr.net/pyodide/v0.23.4/full/pyodide.js'
            await new Promise((resolve, reject) => {
                const script = document.createElement('script')
                script.src = PYODIDE_CDN
                script.onload = resolve
                script.onerror = reject
                document.head.appendChild(script)
            })
          
            const pyodide = this.pyodide = await window.loadPyodide({
                indexURL: 'https://cdn.jsdelivr.net/pyodide/v0.23.4/full/'
            })
          
            // await pyodide.loadPackage(['numpy', 'pandas'])
            
            window.webscmNamespace = {
                get_value: this.get_value 
            }

            pyodide.setStdout({
                batched: (s) => {
                console.log(s);
                }
            });
            pyodide.setStderr({
                batched: (s) => {
                    console.error(s);
                    store.show_notification({ text: s, status: 'error' })
                }
            });
            
            const import_module = () => {
                12
            }
            // const store__checkAccess = (accessRoule) => {
            //     return store.checkAccess({viewAccess:accessRoule})
            // }

            pyodide.globals.set('isBackend', false)
            pyodide.globals.set('isFrontend', true)
            pyodide.globals.set('get_keys', this.get_keys)
            pyodide.globals.set('store__get_value', this.get_value)
            pyodide.globals.set('store__set_value', this.set_value)
            pyodide.globals.set('store__get_dataRows', this.get_dataRows)
            pyodide.globals.set('import_module', import_module)
            pyodide.globals.set('store__checkAccess', this.checkAccess_py)

            const base = process.env.BASE_URL || '/';

            let res = await fetch(`${base}py/utils.py`);
            store.utilsPyText = await res.text();
            this.pyodide.runPython(store.utilsPyText);

            // await pyodide.runPythonAsync(`
            // import sys, types, __main__
            // modname = "webscm_utils"
            // if modname not in sys.modules:
            //     m = types.ModuleType(modname)
            //     m.__file__ = "webscm_utils.py"

            //     # >>> прокидываем функции из __main__ в namespace модуля
            //     for _name in ("store__get_value","store__set_value","store__get_dataRows","checkAccess","import_module"):
            //         if hasattr(__main__, _name):
            //             m.__dict__[_name] = getattr(__main__, _name)

            //     src = ${JSON.stringify(store.utilsPyText)}
            //     code = compile(src, m.__file__, "exec")
            //     exec(code, m.__dict__)
            //     sys.modules[modname] = m
            // `);


            res = await fetch(`${base}py/profiling_utils.py`);
            const profiling_utils = await res.text();
            this.pyodide.runPython(profiling_utils);
            } finally {
                _resolve_loading()
            }
        },
        async attr_getPyodideModule(vueObj) {
            const pyodide = this.pyodide;
            if (!pyodide) throw new Error('Pyodide not loaded');

            // Стабильное имя модуля на виджет
            const widgetId = `${vueObj.WIDGET.id}_${vueObj.attr?.name || ''}`
            .replace(/[^a-zA-Z0-9_]/g, '_');
            const _pyModName = vueObj._pyModName = `pid_widget_${widgetId}`;
            
            // Возвращаем PyProxy модуля
            // кэш может держать уничтоженный прокси (attr_destroyPyodide при
            // пересоздании стола): любое обращение к нему бросает «Object has
            // already been destroyed» — проверяем живость и пересоздаём
            if (vueObj._pyMod) {
                try { void vueObj._pyMod.type } catch (e) { vueObj._pyMod = null }
            }
            if (!vueObj._pyMod) {
                // Создаём модуль
                await pyodide.runPythonAsync(`
                    import sys, types
                    mod = "${_pyModName}"
                    # if mod not in sys.modules:
                    m = types.ModuleType(mod)
                    sys.modules[mod] = m
                `);

                vueObj._pyMod = await pyodide.runPythonAsync(`import sys; sys.modules["${_pyModName}"]`);
            }

            return vueObj._pyMod;
        },
        async attr_loadPyodide(vueObj) {
            const store = this;

            // R11: зовётся на каждом mount виджета — сначала проверить, что py
            // вообще нужен (есть скрипт-модули), и только тогда будить движок.
            // Виджету без скриптов ждать/грузить нечего
            if (!Object.keys(vueObj.WIDGET?.record?._import_modules || {}).length
                    && !vueObj.attr?.['code-eval']) {
                vueObj.dataItem__afterEdit = null;
                vueObj.get_cssClass_py = null;
                return;
            }
            // py нужен раньше фоновой загрузки — запустить её сейчас (идемпотентно)
            if (!this.pyodide) store.loadPyodide()
            // ждать ПОЛНОЙ инициализации: this.pyodide выставляется ДО загрузки
            // globals/utils.py, и модуль виджета, созданный в эту щель, получал
            // None вместо утилит («'NoneType' object is not callable» в
            // *__get_cssClass, затем «fn is not a function» на каждой ячейке)
            if (store._pyodide_loading) await store._pyodide_loading

            // Ждём появления pyodide, если он ещё не готов
            let pyodide = this.pyodide;
            if (!pyodide) {
                // ждём максимум 50 секунд, проверяя каждые 100 мс
                let attempts = 0;
                while (!this.pyodide && attempts < 500) {
                    await store.sleep(100);
                    attempts++;
                }
                pyodide = this.pyodide;
                if (!pyodide) {
                    console.error('Pyodide not initialized after waiting.');
                    return;
                }
            }

            try {
                const _import_modules = vueObj.WIDGET?.record?._import_modules || {};
                const code_attr = vueObj.attr?.['code-eval'];
                if (code_attr) {
                    _import_modules['attr'] = code_attr;
                }

                const keys = Object.keys(_import_modules);
                if (!keys.length) {
                    vueObj.dataItem__afterEdit = null;
                    vueObj.get_cssClass_py = null;
                    return;
                }

                // имена функций, которые нам нужны
                const widget__afterClone_name = `widget__afterClone`;
                const widget__afterCreate_name = `widget__afterCreate`;
                const __afterEdit_name = `${vueObj.attr?.name}__afterEdit`;
                const __get_cssClass_name = `${vueObj.attr?.name}__get_cssClass`;

                // проверить, есть ли хотя бы одно определение таких функций в коде
                let hasRelevantCode = false;
                for (const key of keys) {
                    const code = _import_modules[key] || '';
                    if (
                        code.includes(`def ${__afterEdit_name}(`) ||
                        code.includes(`def ${__get_cssClass_name}(`) ||
                        code.includes(`def ${widget__afterClone_name}(`) ||
                        code.includes(`def ${widget__afterCreate_name}(`)
                    ) {
                        hasRelevantCode = true;
                        break;
                    }
                }

                if (!hasRelevantCode) {
                    // код есть, но функций нужных нет — смысла создавать модуль нет
                    vueObj.dataItem__afterEdit = null;
                    vueObj.get_cssClass_py = null;
                    return;
                }

                // только если нашли нужные функции — создаём/берём модуль
                const mod = await this.attr_getPyodideModule(vueObj);
                // гонка с attr_destroyPyodide (пересоздание стола): пока ждали
                // await, модуль могли уничтожить — локальный mod уже труп,
                // mod.__dict__ бросит «Object has already been destroyed».
                // Выходим тихо: новый инстанс виджета загрузит свой модуль
                if (vueObj._pyMod !== mod) return;

                mod.__dict__.set('isBackend', pyodide.globals.get('isBackend'))
                mod.__dict__.set('isFrontend', pyodide.globals.get('isFrontend'))
                mod.__dict__.set('get_keys', pyodide.globals.get('get_keys'))
                mod.__dict__.set('store__get_value', pyodide.globals.get('store__get_value'))
                mod.__dict__.set('store__set_value', pyodide.globals.get('store__set_value'))
                mod.__dict__.set('store__get_dataRows', pyodide.globals.get('store__get_dataRows'))
                // mod.__dict__.set('store__checkAccess', pyodide.globals.get('store__checkAccess'))
                mod.__dict__.set('import_module', pyodide.globals.get('import_module'))
                
                mod.__dict__.set('checkAccess', pyodide.globals.get('checkAccess'))
                mod.__dict__.set('get_value', pyodide.globals.get('get_value'))
                mod.__dict__.set('set_value', pyodide.globals.get('set_value'))
                mod.__dict__.set('get_dataRows', pyodide.globals.get('get_dataRows'))
                mod.__dict__.set('sorting_multi', pyodide.globals.get('sorting_multi'))
                mod.__dict__.set('increment_date', pyodide.globals.get('increment_date'))

                for (const key of keys) {
                    let userCode = _import_modules[key] || '';
                    // userCode = `from webscm_utils import get_value, set_value, get_dataRows, sorting_multi\n` + userCode;
                    // userCode = userCode + `\n` + store.utilsPyText;

                    await pyodide.runPythonAsync(`
                        import sys, __main__
                        _ns = sys.modules["${vueObj._pyModName}"].__dict__
                        for _k in ("import_module", "isBackend", "isFrontend", "get_keys", "store__get_value", "store__set_value", "store__get_dataRows", "checkAccess", "get_value", "set_value", "get_dataRows", "sorting_multi", "increment_date"):
                            if hasattr(__main__, _k):
                                _ns[_k] = getattr(__main__, _k)
                        del _k
                        exec(compile(${JSON.stringify(userCode)}, "${vueObj._pyModName}.py", "exec"), _ns, _ns)
                        del _ns
                    `);
                }

                // та же гонка: exec-цикл выше await-ит на каждом модуле
                if (vueObj._pyMod !== mod) return;

                // получить функции из модуля
                const widget__afterClone_def = mod.__dict__.get(widget__afterClone_name);
                const widget__afterCreate_def = mod.__dict__.get(widget__afterCreate_name);
                const __afterEdit_def = mod.__dict__.get(__afterEdit_name);
                const __get_cssClass_def = mod.__dict__.get(__get_cssClass_name);

                vueObj.widget__afterClone = typeof widget__afterClone_def === 'function' ? widget__afterClone_def : null;
                vueObj.widget__afterCreate = typeof widget__afterCreate_def === 'function' ? widget__afterCreate_def : null;
                vueObj.dataItem__afterEdit = typeof __afterEdit_def === 'function' ? __afterEdit_def : null;
                vueObj.get_cssClass_py = typeof __get_cssClass_def === 'function' ? __get_cssClass_def : null;
                // IE 2026 09 05 / ODOO-336379 (флаг afterEdit_warm_idle): полный brand-проход M03 — заранее в простое,
                // чтобы первая правка пользователя шла сразу scope=sku, а не ждала прогрева 1,6–8 с
                try { vueObj.pyWarm_schedule?.() } catch (e) { /* прогрев не критичен */ }

            } catch (err) {
                console.error(err);
            }
        },
        attr_destroyPyodide(vueObj) {
            try {
                // ссылку снимаем ПЕРЕД destroy: повторный destroy() бросает
                // «Object has already been destroyed», catch его глотал, и _pyMod
                // навсегда оставался уничтоженным прокси — все обращения к модулю
                // (cssClass/afterEdit) падали, грид оставался пустым
                const mod = vueObj._pyMod;
                vueObj._pyMod = null;
                try { mod?.destroy?.(); } catch (e) { /* уже уничтожен */ }
                vueObj.widget__afterClone = null;
                vueObj.dataItem__afterEdit = null;
                vueObj.get_cssClass_py = null;
            } catch (e) { /* noop */ }
        },

        deepToJs(value) {
            // если это Map → превращаем в объект
            if (value instanceof Map) {
              const obj = {};
              for (const [k, v] of value.entries()) {
                obj[k] = this.deepToJs(v);
              }
              return obj;
            }
            // если это массив → рекурсивно мапим
            if (Array.isArray(value)) {
              return value.map(this.deepToJs);
            }
            // для PyProxy с toJs (например, Pyodide): сначала вызываем toJs, если есть
            if (value && typeof value.toJs === 'function') {
              return this.deepToJs(value.toJs());
            }
            // если это обычный объект (не Map и не Array) → рекурсивно пролазим по полям
            if (value && typeof value === 'object') {
              const out = {};
              for (const key of Object.keys(value)) {
                out[key] = this.deepToJs(value[key]);
              }
              return out;
            }
            // всё остальное (строка, число, булево) — отдаём как есть
            return value;
        },
        get_dataRows(data, dataRows = {}, binding_row_id = 'row_id', copy = true) {
            if (!Array.isArray(data)) return dataRows;
          
            for (const row of data) {
                const row_id = row[binding_row_id];
                if (row_id) {
                    if (copy) {
                        for (const key in row) {
                            if (key === 'attrs' || key === binding_row_id) continue;
                            dataRows[row_id] = dataRows[row_id] || {};
                            dataRows[row_id][key] = row[key]
                        }
                    } else {
                        dataRows[row_id] = row;
                    }
                }
            
                const attrs = row['attrs'];
                if (Array.isArray(attrs) && attrs.length) {
                    this.get_dataRows(attrs, dataRows, binding_row_id, copy);
                }
            }
          
            return dataRows;
        },
        get_event(WIDGET, name, event){
            const events = WIDGET.record?.doc?.params?.events || []
            for (const event of events) {
                if (event.use !== false && event.name === name && event.event === event) {
                    return event.function
                }
            }
            return null
        },
        // ===== IE 2026 09 29 / ODOO-342781: роль «только чтение» (access-readonly). Признак и политика — от бэка: store.user.readonly / user.readonly_policy
        // (ответы login / check_sessionKey; бэк common_modules/readonly.py — гард диспетчера, отказ 403 read_only). Здесь — единая точка решения на фронте:
        // readonly_on / readonly_allows (запрос) / readonly_allowsAction (пункт меню, кнопка), тост отказа, предохранители отправки (saveRecord, executeXxx …)
        // и страховка $.ajaxPrefilter (initAjaxDefaults). Логика — utils/readonlyPolicy.js (юнит-тесты). Без роли ничего из этого не срабатывает.
        readonly_on() {
            return this.user?.readonly === true
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): открыта архивная ПМ (process_model_record.doc.branch.kind = 'archive') — интерфейс только для чтения (бейдж, грид без редактора,
        // без пунктов записи данных модели). Узкий список — utils/readonlyPolicy.ro_archiveAllowsAction; запись режет бэк (branch.write_guard). Выключатель fe.ux.pmArchiveReadOnly
        readonly_archive() {
            if (!ro_isArchivePm(this.process_model_record)) return false
            return this.setting('fe.ux.pmArchiveReadOnly', true) !== false
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): правка в интерфейсе выключена — роль «только чтение» ИЛИ архивная ПМ (гриды, булевы флажки, тост «editing is disabled»)
        readonly_view() {
            return this.readonly_on() || this.readonly_archive()
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ) — ревью webscm #110599: только у данных модели. scope — WIDGET (данные модели — utils/readonlyPolicy.ro_isModelDataWidget) или 'model' (меню ПМ);
        // без scope — false: формы настроек, справочники вне версии, настройки пользователя редактируются и сохраняются
        readonly_archiveData(scope) {
            if (!scope || !this.readonly_archive()) return false
            return ro_isModelDataWidget(scope, ro_pmVersions(this.process_model_record))
        },
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ) — ревью #110599: грид заперт — таблица данных виджета данных модели (или карточка / строка данных); вкладки настроек — нет
        readonly_archiveGrid(W, isDataGrid) {
            if (!W || !this.readonly_archive()) return false
            return ro_archiveLocksGrid(W, ro_pmVersions(this.process_model_record), isDataGrid)
        },
        // политика бэка в виде множеств (кэш по ссылке на user.readonly_policy); нет политики — null: тогда работают запасные списки utils/readonlyPolicy.js
        readonly_policy() {
            const raw = this.user?.readonly_policy || null
            if (this._roPolicyRaw !== raw) { this._roPolicyRaw = raw; this._roPolicyNorm = ro_normPolicy(raw) }
            return this._roPolicyNorm
        },
        // запрос на бэк (command / method — как в теле запроса): true — можно. Без роли — всегда true
        readonly_allows(command, method = '', extra = null) {
            if (!this.readonly_on()) return true
            return ro_allowsRequest(this.readonly_policy(), command, method, extra)
        },
        // действие интерфейса (attr меню / панели команд / кнопки): true — показывать и выполнять. Без роли — всегда true
        readonly_allowsAction(attr, scope = null) {
            if (!this.readonly_on()) return this.readonly_archiveData(scope) ? ro_archiveAllowsAction(attr) : true   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): только у данных модели (scope — WIDGET / 'model', ревью #110599)
            return ro_allowsAction(this.readonly_policy(), attr)
        },
        // пункты меню без записи (дерево attrs); без роли — тот же массив
        readonly_menu(items, scope = null) {
            if (!this.readonly_on()) return this.readonly_archiveData(scope) ? ro_filterMenu(items, ro_archiveAllowsAction) : items   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): только у данных модели (scope — WIDGET / 'model', ревью #110599)
            const policy = this.readonly_policy()
            return ro_filterMenu(items, (it) => ro_allowsAction(policy, it))
        },
        // один тост на серию отказов (одинаковый текст в пределах fe.ux.readonlyToastMs — иначе жёлтая плашка мигала бы на каждый клик)
        readonly_toast(text = '', kind = 'denied') {
            const store = this
            const arch = !store.readonly_on() && store.readonly_archive()   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): тот же тост с текстом архива
            const msg = text || t(kind === 'edit' ? (arch ? RO_ARCHIVE_TEXT_EDIT : RO_TEXT_EDIT) : (arch ? RO_ARCHIVE_TEXT_DENIED : RO_TEXT_DENIED))
            const now = Date.now()
            if (store._roToast && store._roToast.text === msg && now - store._roToast.at < store.setting('fe.ux.readonlyToastMs', 4000)) return
            store._roToast = { text: msg, at: now }
            store.show_notification({ text: msg, status: 'warning' })
            store._roStats = { ...(store._roStats || {}), toasts: ((store._roStats || {}).toasts || 0) + 1 }
        },
        // предохранитель отправки: запрос (command / method) при роли не разрешён — true (вызывающий выходит, ничего не шлёт); тост — если не тихий вызов.
        // opts: { flags — quiet_errors / _isPoll / no_notification действия, extra — { createNew } }
        readonly_deny(command, method = '', opts = {}) {
            const store = this
            if (!store.readonly_on()) return false
            if (store.readonly_allows(command, method, opts.extra || null)) return false
            const quiet = ro_isQuiet(command, method, opts.flags || null)
            store._roStats = { ...(store._roStats || {}), blocked: ((store._roStats || {}).blocked || 0) + 1 }
            if (!quiet) store.readonly_toast()
            if (!store.hide_console) console.log(`[readonly] blocked ${command} ${method || ''}${quiet ? ' (quiet)' : ''}`)
            return true
        },
        // то же для действия executeXxx: при отказе — хук ответа вызывающего (_onResponse(null): он ждёт ответа — гвард не должен оставить его висеть)
        readonly_denyAction(action, defaultCommand = 'executeWidgetMethod') {
            const store = this
            if (!store.readonly_on()) return false
            const a = action || {}
            if (!store.readonly_deny(a.command || defaultCommand, a.method || '', { flags: a })) return false
            try { a._onResponse?.(null) } catch (e) { /* хук не роняет отказ */ }
            return true
        },
        // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F4 + F6): начало executeStoreMethod — команды, которые при роли не выполняются (ro_storeDenies: FE_WRITE_COMMANDS + copyPaste paste / import /
        // deepCopy). Отказ до confirm / prompt и до любого изменения локального состояния; один тост на серию (readonly_toast), хук ответа вызывающего (_onResponse(null)) — как в readonly_denyAction.
        // executeWidgetMethod / executeBackendMethod сюда не входят (свои предохранители с тихим режимом). true — отказ (вызывающий выходит)
        readonly_denyStore(action) {
            const store = this
            if (!store.readonly_on()) return false
            if (!ro_storeDenies(store.readonly_policy(), action)) return false
            const a = action || {}, quiet = ro_isQuiet(a.command, a.method, a)
            store._roStats = { ...(store._roStats || {}), blocked: ((store._roStats || {}).blocked || 0) + 1 }
            if (!quiet) store.readonly_toast()
            if (!store.hide_console) console.log(`[readonly] blocked store command ${a.command} ${a.method || ''}${quiet ? ' (quiet)' : ''}`)
            try { a._onResponse?.(null) } catch (e) { /* хук не роняет отказ */ }
            return true
        },
        // ответ бэка 403 read_only (jqXHR): тост по тексту бэка (уже на языке запроса) — один, если запрос не тихий. true — это был отказ роли
        readonly_onDenied(jqXHR, quiet = false) {
            const store = this
            const d = ro_denial(jqXHR?.status, jqXHR?.responseJSON ?? jqXHR?.responseText)
            if (!d) return false
            if (!jqXHR?._roSynthetic) store._roStats = { ...(store._roStats || {}), denied403: ((store._roStats || {}).denied403 || 0) + 1 }   // IE 2026 09 29 / ODOO-342781 (ревью F3): синтетический отказ префильтра уже посчитан (aborted) — не дублируем
            if (!store.hide_console) console.log(`[readonly] 403 ${d.command} ${d.method || ''} ${d.reason || ''}${quiet ? ' (quiet)' : ''}`)
            if (!quiet) store.readonly_toast(d.text || '')
            return true
        },
        // «эпоха» копии для отметок Бизнес-кейсов в браузере (fe.guide.local_epoch — настройка базы, меняется при сбросе копии; пусто — не проверяем)
        readonly_localEpoch() {
            return this.readonly_on() ? String(this.setting('fe.guide.local_epoch', '') || '') : ''
        },
        // роль включилась / выключилась (другая база): личные отметки Бизнес-кейсов перечитать из браузера (ключ guideMarksLocal:<пользователь>:<база> уже новый, «эпоха» — по новому признаку)
        readonly_afterChange() {
            const store = this
            try { if (store.guideMarks) store.guideMarks._localKey = null } catch (e) { /* отметки перечитаются со следующим обращением */ }
            if (!store.hide_console) console.log(`[readonly] role ${store.readonly_on() ? 'on' : 'off'} for ${store.user?.database?.dbid || ''}`)
        },
        checkAccess(attr, scope = null) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): scope — WIDGET кнопки / меню (архив прячет запись только у данных модели, ревью #110599)
            // IE 2026 09 29 / ODOO-342781: роль «только чтение» — действия записи (Save, Archive, Delete, Clone, New, Start, Import, «Save as …») недоступны:
            // одно место прячет их в меню, панелях команд, кнопках, строках гридов и чипсах (attr.command / method по политике бэка и спискам фронта)
            if (this.user?.readonly === true && ro_hides(this.user, this.readonly_policy(), attr)) return false
            if (scope && attr?.command && this.process_model_record?.doc?.branch && this.readonly_archiveData(scope) && !ro_archiveAllowsAction(attr)) return false   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): архивная ПМ — без пунктов записи у ДАННЫХ МОДЕЛИ (scope); формы настроек и справочники — с Save (ревью #110599)
            return !attr.viewAccess || this.user?.rights?.[attr.viewAccess] || (this.user?.rights?.['access-admin']) || false
        },
        checkAccess_py(viewAccess, useAdminAccess = true) {
            if (!useAdminAccess) {
                console.log(viewAccess)
            }
            return !viewAccess || this.user?.rights?.[viewAccess] || (useAdminAccess && this.user?.rights?.['access-admin']) || false
        },
        get_iroot_numbers(iroot) {
            let irootNumbers = iroot
                .split(".")
                .map(part => {
                return /^\d+$/.test(part) ? String(parseInt(part, 10) + 1) : part;
                })
                .join(".");
            
            irootNumbers = irootNumbers.replace(/\.attrs\./g, "-");
            return irootNumbers;
        },
        workbookStyleToCSS(wbStyle) {
            if (!wbStyle) return {};

            const css = {};

            // 🎨 фон (fill)
            if (wbStyle.fill?.color) {
                css["background-color"] = wbStyle.fill.color;
            }

            // 🖋️ шрифт (font)
            const font = wbStyle.font || {};
            if (font.color) css["color"] = font.color;
            if (font.bold) css["font-weight"] = "bold";
            if (font.italic) css["font-style"] = "italic";
            if (font.underline) css["text-decoration"] = "underline";
            if (font.family) css["font-family"] = font.family;
            if (font.size) css["font-size"] = `${font.size}px`;

            // ⬛ бордюры
            const borderStyles = {
                0: "none",
                1: "solid",
                2: "double",
                3: "dotted",
                4: "dashed"
            };

            const borders = wbStyle.borders || {};
            const setBorder = (side) => {
                const b = borders[side];
                if (b?.style && borderStyles[b.style]) {
                css[`border-${side}`] = `1px ${borderStyles[b.style]} ${b.color || "#000"}`;
                }
            };
            ["top", "right", "bottom", "left"].forEach(setBorder);

            // 🔢 числовой формат (просто комментарий)
            if (wbStyle.format) {
                css["--number-format"] = wbStyle.format; // для справки
            }

            // 📐 выравнивание (alignment)
            const hMap = [
                'inherit',  // 0: General
                'left',     // 1: Left
                'center',   // 2: Center
                'right',    // 3: Right
                'justify',  // 4: Fill
                'justify',  // 5: Justify
                'center',   // 6: CenterAcrossSelection
                'justify'   // 7: Distributed
            ];
            const vMap = [
                'top',      // 0: Top
                'middle',   // 1: Center
                'bottom',   // 2: Bottom
                'justify',  // 3: Justify
                'baseline'  // 4: Distributed
            ];
            if (wbStyle?.hAlign != null) {
                css['text-align'] = hMap[wbStyle.hAlign] || 'inherit';
            }
            if (wbStyle?.vAlign != null) {
                css['vertical-align'] = vMap[wbStyle.vAlign] || 'top';
            }

            // display: flex;   TODO + on merge cells
            // align-items: center;
            // justify-content: center;

            return css;
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        toKebabCase(prop) {
            return prop.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
        },
        normalizeStyle(style) {
            if (!style) return {}

            // 1) Если уже объект — просто нормализуем ключи
            if (typeof style === 'object') {
                const result = {}
                for (const [key, val] of Object.entries(style)) {
                    if (val == null || val === '') continue
                    result[this.toKebabCase(key)] = String(val)
                }
                return result
            }

            // 2) Если строка CSS → парсим
            if (typeof style === 'string') {
                const result = {}
                style.split(';').forEach(rule => {
                    const [prop, val] = rule.split(':')
                    if (!prop || !val) return
                    result[prop.trim()] = val.trim()
                })
                return result
            }

            return {}
            
            // // уже объект
            // if (typeof style === 'object') {
            //     return style
            // }

            // // строка CSS: "color: red; font-size: 12px;"
            // if (typeof style === 'string') {
            //     return style
            //         .split(';')
            //         .map(r => r.trim())
            //         .filter(Boolean)
            //         .reduce((acc, rule) => {
            //             const [prop, value] = rule.split(':')
            //             if (!prop || !value) return acc

            //             const camelProp = prop
            //                 .trim()
            //                 .replace(/-([a-z])/g, (_, c) => c.toUpperCase())

            //             acc[camelProp] = value.trim()
            //             return acc
            //         }, {})
            // }

        },

        // IE 2026 10 16 / ODOO-345912: пункты process_model_menu строит бэк ТОЛЬКО по ответу workspace_open / get_startup; переход на стол из
        // store.WORKSPACES запроса не шлёт — меню (params.workspace / ws_version) остаётся от ПРЕДЫДУЩЕГО стола, и «Create What-if branch»
        // создавал ветку не того стола/версии. Перед отправкой — id и версия АКТИВНОГО стола (копия, сохранённый пункт меню не трогаем);
        // workspace кладём и в сам action: executeBackendMethod разворачивает action в запрос (request.workspace, его бэк предпочитает)
        menuActionActiveDesk(action) {
            const WS = this.activeWORKSPACE, id = WS?.record?.id
            if (!id || !action || !action.params || typeof action.params !== 'object' || !('workspace' in action.params)) return action
            const rec = WS.record
            const ver = rec.params?.version || rec.doc?.params?.version || ''
            const params = { ...action.params, workspace: id }
            if (ver) params.ws_version = ver
            else delete params.ws_version
            return { ...action, params, workspace: id }
        },
        formatMenuItem(sender, e) {
            const dataItem = e.data;
            if (!dataItem) return;
            // IE 2026 08 21 (замечание Игоря 19:45): пункт-папка (подменю) должен
            // явно читаться — класс менюшной строке, маркер рисует CSS
            if (e.item?.classList) {
                e.item.classList.toggle('menu-folder', !!dataItem.attrs?.length);
                e.item.classList.toggle('menu-folder-open', !!dataItem._menuOpen);
                // IE 2026 08 23: отступ глубины КЛАССОМ — inline padding на строках
                // wijmo где-то гасился (computed 0 при живом style-атрибуте)
                for (let _d = 1; _d <= 6; _d++) e.item.classList.toggle('mm-depth-' + _d, (dataItem._menuDepth || 0) === _d);
            }

            // РАЗДЕЛИТЕЛЬ ('-'): wijmo сам вешает элементу класс wj-separator и
            // сжимает его до высоты 1px (сама черта рисуется бордером/фоном).
            // Если продолжить обычный рендер, наша разметка (.wj-menu-item-row,
            // padding 6px) выпирает за пределы однопиксельной строки и текст '-'
            // виден чёрточкой в ЛЕВОМ ВЕРХНЕМ углу заголовка СЛЕДУЮЩЕГО пункта
            // (баг 2026-07-29, был во всех меню — formatMenuItem общий).
            // Поэтому разделителю оставляем пустое содержимое.
            if (dataItem.title === '-' || e.item?.classList?.contains('wj-separator')) {
                if (e.item) e.item.innerHTML = '';
                return;
            }

            const titleText =
                dataItem.titleAction ||
                dataItem.title ||
                dataItem.tooltip ||
                dataItem.node?.valueStr ||
                '';

            const hotkey = dataItem.hotkey || '';

            // 1) Иконка из cssClass
            let iconHtml = '';
            const cssClass = dataItem.cssClass || dataItem.node?.pi
            if (cssClass) {
                const css = cssClass.replace('p-button-white', '').trim();
                iconHtml = `<span class="${css}"></span>`;
            }

            // 2) Класс строки меню
            const rowClass = dataItem['cssClass-row']
                ? `wj-menu-item-row ${dataItem['cssClass-row']}`
                : 'wj-menu-item-row';

            // IE 2026 08 22 (замечание Игоря 20:0x): мобильный профиль — рендер
            // разметкой ГЛОБАЛЬНОГО меню (те же классы => тот же стиль везде);
            // wj-menu-item-row сохраняем: на него завязаны панельные :has-правила
            if (this.mobileUi?.on) {
                const pi = cssClass ? cssClass.replace('p-button-white', '').trim() : ''
                if (dataItem.attrs?.length) {
                    e.item.innerHTML = `
                        <div class="${rowClass} mm-row">
                            <span class="mt-label mm-folder-btn">
                                ${pi ? `<i class="${pi}"></i>` : ''}
                                <span class="mm-folder-text">${this.escapeHtml(titleText)}</span>
                                <i class="pi mm-chev ${dataItem._menuOpen ? 'pi-angle-down' : 'pi-angle-right'}"></i>
                            </span>
                        </div>
                    `
                } else {
                    e.item.innerHTML = `
                        <div class="${rowClass} mobile-tabs-row">
                            <span class="mt-icon"><i class="${/(^|\s)pi-/.test(pi) ? pi : (pi + ' pi pi-circle')}"></i></span>
                            <span class="mt-label">${this.escapeHtml(titleText)}</span>
                        </div>
                    `
                }
                return
            }

            // 3) Заголовок
            const titleHtml = `
                <span class="wj-menu-item-title">
                    ${iconHtml}
                    <span class="wj-menu-item-text">
                        ${this.escapeHtml(titleText)}
                    </span>
                </span>
            `;

            // 4) Рендер
            if (hotkey) {
                e.item.innerHTML = `
                    <div class="${rowClass}">
                        ${titleHtml}
                        <span class="wj-menu-item-hotkey">
                            ${this.escapeHtml(hotkey)}
                        </span>
                    </div>
                `;
            } else {
                e.item.innerHTML = `
                    <div class="${rowClass}">
                        ${titleHtml}
                    </div>
                `;
            }
        },

        escapeHtml(s) {
            return String(s).replace(/[&<>"']/g, m => ({
                '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
            }[m]));
        },

        runActionForHotKey(WIDGET, hotkey, evt = null, opts = {}) {   // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select): opts.onceEvent — событие клавиатуры для «одно нажатие → одно действие»
            const root = []
                .concat(WIDGET?.groupMenu?.commandPanel || [])
                .concat(WIDGET?.groupMenu?.actionMenu || []);

            // also search widget's local commandPanels (topLeft, Scale, etc.)
            const vueObj = WIDGET.attrs_vueObj.WIDGET
            if (vueObj) {
                for (const panel of (vueObj.commandPanel_topLeft1 || [])) root.push(...(panel || []))
                for (const panel of (vueObj.commandPanel_Scale || [])) root.push(...(panel || []))
            }

            // also search Page attrs (buttons on page level)
            const pageAttrs = this.activeWORKSPACE?.activePAGE?.attrs || []
            root.push(...pageAttrs)
            // IE 2026 10 01 / ODOO-5800: у варианта страницы меню — основной страницы; её пункты тоже ловят горячие клавиши
            const _menuRows = this.activeWORKSPACE ? this.variantMenu_rows(this.activeWORKSPACE, this.activeWORKSPACE.active_page) : []
            if (_menuRows !== pageAttrs) root.push(..._menuRows)

            const norm = (s) => (s || "").replace(/\s+/g, "").toLowerCase();
            const target = norm(hotkey);

            const walk = (items) => {
                for (const action of (items || [])) {
                    if (!action) continue;

                    // console.log(`Keydown ${hotkey}: checking action "${norm(action.hotkey)}" === "${target}"`);
                    if (norm(action.hotkey) === target) {
                        if (action.disabled) return false
                        // IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select): тот же keydown уже выполнил эту клавишу на этом виджете (App.vue capture + AttrGrid bubble) — второй запрос не шлём
                        if (opts?.onceEvent && !hotkeyOnce_claim(opts.onceEvent, WIDGET, hotkey, hotkeyOnce_on((k, d) => this.setting(k, d)))) return true
                        // IE 2026 09 29 / ODOO-342781: роль «только чтение» — горячая клавиша скрытого действия записи (Alt+L Clone, Save …) ничего не делает: тост, клавиша поглощена
                        if (this.readonly_on() && !this.readonly_allowsAction(action)) {
                            this.readonly_toast()
                            if (evt) { evt.preventDefault(); evt.stopPropagation() }
                            return true
                        }
                        // defaults for Page attrs
                        if (!action.command) action.command = 'widget_open'
                        if (!action.widget) action.widget = action.node?.value

                        if (action['save-before'] && WIDGET.record?._meta?.modified) {
                            const action1 = {'name':'button-Save', 'hotkey':'Alt S', 'title': t('Save'), 'viewAccess':'access-extraView', 'command': 'onSaveRecord__Click', 'params':{'closeWindow':false}, 'record_sendToBackend_exclude': ['_doc'],   // IE 2026 09 23 / ODOO-341407: i18n
                                actions_after: [ {...action} ]
                            }

                            if (evt) { evt.preventDefault(); evt.stopPropagation(); }
                            this.executeStoreMethod(WIDGET.vueObj, action1);
                            return true;
                        }

                        if (evt) { evt.preventDefault(); evt.stopPropagation(); }
                        this.executeStoreMethod(WIDGET.vueObj, action);
                        return true;
                    }

                    // wj-menu дерево: обычно subItemsPath = 'attrs'
                    if (walk(action.attrs)) return true;
                }
                return false;
            };

            return walk(root);
        },
        normalizeHotkey(event) {
            const keys = [];

            if (event.ctrlKey)  keys.push("Ctrl");
            if (event.shiftKey) keys.push("Shift");
            if (event.altKey)   keys.push("Alt");

            // Use event.code to get layout-independent key (e.g. KeyF → F)
            const code = event.code || ''
            let key = event.key
            if (code.startsWith('Key')) {
                key = code.slice(3) // KeyF → F, KeyA → A
            } else if (code.startsWith('Digit')) {
                key = code.slice(5) // Digit1 → 1
            }
            keys.push(key);

            return keys.join(" ");
        },

        pythonLiteralToJsObject(text) {
            // 1) very naive normalization
            const normalized = text
                .trim()
                .replace(/\bNone\b/g, 'null')
                .replace(/\bTrue\b/g, 'true')
                .replace(/\bFalse\b/g, 'false')
    
            // 2) try to convert single quotes to double quotes
            // WARNING: will break if strings contain quotes/escapes in complex ways
            const jsonLike = normalized
                .replace(/'/g, '"')
    
            return JSON.parse(jsonLike)
        },
        deepCleanEmpty(value) {
            if (Array.isArray(value)) {
                const cleaned = value
                    .map(item => this.deepCleanEmpty(item))
                    .filter(item => item !== null && item !== undefined && item !== '')
                return cleaned
            }
            if (value !== null && typeof value === 'object') {
                const result = {}
                for (const [k, v] of Object.entries(value)) {
                    const cleaned = this.deepCleanEmpty(v)
                    const isEmpty =
                        cleaned === null ||
                        cleaned === undefined ||
                        cleaned === '' ||
                        (Array.isArray(cleaned) && cleaned.length === 0) ||
                        (typeof cleaned === 'object' && !Array.isArray(cleaned) && Object.keys(cleaned).length === 0)
                    if (!isEmpty) result[k] = cleaned
                }
                return result
            }
            return value
        },
        jsObjectToPythonLiteral(obj) {
            let text = JSON.stringify(obj, null, 4)
            
            // text = text
            //     .replace(/\bnull\b/g, 'None')
            //     .replace(/\btrue\b/g, 'True')
            //     .replace(/\bfalse\b/g, 'False')
            //     .replace(/"/g, "'")

            return text
        },
        parseClipboardWidget(text) {
            text = this.normalizeClipboardWidgetText(text)
            // 1) JSON first
            try { return JSON.parse(text) } catch {1}
    
            // 2) optional fallback: python-ish
            try { return this.pythonLiteralToJsObject(text) } catch {2}
    
            return null
        },
        normalizeClipboardWidgetText(text) {
            if (!text) return ''
    
            let t = String(text).trim()
    
            // Убираем BOM если вдруг есть
            t = t.replace(/^\uFEFF/, '')
    
            // Убираем обёртки вида: WIDGET = ...
            // а также: const WIDGET = ..., let WIDGET = ..., var WIDGET = ...
            t = t.replace(/^(?:const|let|var)?\s*WIDGET\s*=\s*/i, '')
    
            // Убираем завершающий ; если есть
            t = t.replace(/;\s*$/, '')
    
            return t.trim()
        },
        sanitizeFileName(name) {
            const safe = String(name || 'export')
                .replace(/[\\/:*?"<>|]+/g, '-')   // запрещённые символы
                .replace(/\s+/g, ' ')
                .trim();
            return safe;
        },
        transformCellsToWHERE(cells, fields) {
            const findField = (fields, binding) => {
                if (!fields) return null
                for (const f of fields) {
                    if (f.binding0 === binding || f.binding === binding) return f
                    if (f.attrs) {
                        const found = findField(f.attrs, binding)
                        if (found) return found
                    }
                }
                return null
            }

            const byBinding = new Map()
            for (const cell of cells) {
                if (!byBinding.has(cell.binding)) byBinding.set(cell.binding, [])
                byBinding.get(cell.binding).push(cell)
            }

            const whereItems = []
            for (const [binding, bindingCells] of byBinding) {
                const field = findField(fields, binding)
                const attr_type = field?.attr_type || 'AttrStr'
                const relation_segment = field?.relation_segment
                const title = field?.title || bindingCells[0]?.title || binding

                const leftValue = {
                    value: binding,
                    valueStr: title,
                    attr_type: 'AttrLink',
                    component: 'AttrLink',
                    hideTitle: true,
                }

                const buildRightValue = (value) => {
                    const rv = { value, attr_type, component: attr_type }
                    if (relation_segment) rv.relation_segment = relation_segment
                    return rv
                }

                const uniqueCells = bindingCells.filter((cell, idx, arr) =>
                    arr.findIndex(c => c.value === cell.value) === idx
                )

                if (uniqueCells.length === 1) {
                    whereItems.push({
                        use: true,
                        attr_type: 'AttrChipWhere',
                        condition: '=',
                        leftValue,
                        rightValue: buildRightValue(uniqueCells[0].value),
                    })
                } else {
                    const baseRightValue = { attr_type, component: attr_type }
                    if (relation_segment) baseRightValue.relation_segment = relation_segment
                    whereItems.push({
                        use: true,
                        attr_type: 'AttrChipWhere',
                        condition: 'in',
                        leftValue,
                        rightValue: baseRightValue,
                        attrs: uniqueCells.map(cell => ({
                            use: true,
                            rightValue: buildRightValue(cell.value),
                        })),
                    })
                }
            }

            return whereItems
        },
        pasteAction(vueObj, action, text, parentName = t('Clipboard'), notificationOptions = { text: t('{source} content processed.', { source: parentName }) }) {   // IE 2026 09 23 / ODOO-341407: i18n (тосты функции; parentName — уже переведённая подпись источника)
            const store = this
            const WIDGET = vueObj.WIDGET
            let attr_vueObj = vueObj.get_vueObj(action.source_name || action.binding)

            if (action.method === 'pasteItems') {
                const urlPattern = /^(https?:\/\/|localhost:)\S+/;
                if (urlPattern.test(text)) {
                    const url = new URL(text);

                    const hashPart = url.hash.replace("#/", "");
        
                    const queryString = hashPart.split("?")[1] || "";
                    const params = Object.fromEntries(new URLSearchParams(queryString));

                    if (params.action) {
                        store.executeBackendMethod({}, {
                            method: 'get_action',
                            purpose: 'insertAction',
                            params: {
                                action_id: params.action,
                            }
                        }, attr_vueObj.insertAction)
                        return;
                    }

                }
            }

            if (['importItems', 'pasteItems'].includes(action.method) && String(attr_vueObj?.attr?.name || '').startsWith('chip-records')) {   // IE 2026 10 28 / ODOO-349799 (PR5): таблица Records Import — формат (CHIP-Widget / Records / Record / Rows / список / запись из predefined/) разбирает бэк   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix): и второй грид chip-records-target (приёмник-файл)
                store.importRecords_intoGrid(vueObj, attr_vueObj, text, notificationOptions, action)   // IE 2026 11 02 / ODOO-349799 (records-grid-prefix)
                return
            }

            let content
            try {
                content = store.parseClipboardWidget(text)
            } catch (e) {
                // console.error(`${parentName} is not valid JSON:`, e)
                store.show_notification({ text: t('{source} does not contain valid JSON: {error}', { source: parentName, error: e.message }), status: 'error' })
                return
            }

            if (['importWidget', 'pasteWidget'].includes(action.method)) {
                if (content.doc?.WIDGET) {
                    let WIDGET1 = content.doc.WIDGET
                    WIDGET1.page = store.activeWORKSPACE.active_page
                    WIDGET1.workspace = store.activeWORKSPACE.workspace
                    WIDGET1.process_model = store.process_model_record.id

                    store.pasteWidget_JSON(WIDGET1, 'paste') // объект
                    store.show_notification(notificationOptions)
                } else {
                    store.show_notification({ text: t('{source} does not contain valid WIDGET', { source: parentName }), status: 'error' })
                }
            
            } else if (['importRecord', 'pasteRecord'].includes(action.method)) {
                if (content.doc?.record) {
                    store.preserve_itemsSourcesView(WIDGET, content.doc.record)
                    WIDGET.record = content.doc.record
                    vueObj.content_Changed()
                    store.show_notification(notificationOptions)
                } else {
                    store.show_notification({ text: t('{source} does not contain valid record', { source: parentName }), status: 'error' })
                }
            
            } else if (['importItems', 'pasteItems'].includes(action.method)) {
                // Copy widgets (п.3.1): массив {widget, layout, ...} и строки-группы
                // {title, attr_type, onOpening, attrs} (ит.4) -> строки табличной
                // части doc.pages со ссылкой на виджет/группой и layout
                const isWidgetsList = Array.isArray(content) && content.length
                    && content.every(it => it && typeof it === 'object' && (it.widget || (it.onOpening && it.attrs)))
                if (isWidgetsList) {
                    const to_row = (it) => {
                        let row
                        if (it.widget) {
                            row = {
                                node: {
                                    value: it.widget,
                                    valueStr: it.title || it.widget,
                                    attr_type: 'AttrLink',
                                },
                                onOpening: true,
                            }
                            if (it.segment) {
                                row.node.relation_segment = it.segment
                            }
                        } else {
                            const attr_type = it.attr_type === 'AttrTab' ? 'AttrTab' : 'AttrTabRow'
                            row = {
                                title: it.title || '',
                                attr_type,
                                node: { value: it.title || '', valueStr: it.title || '', attr_type },
                                onOpening: true,
                                attrs: (it.attrs || []).map(to_row),
                            }
                        }
                        if (it.layout) {
                            row.layout = it.layout
                        }
                        return row
                    }
                    const attrs = content.map(to_row)
                    attr_vueObj.insertAction({ attrs })
                    store.show_notification(notificationOptions)
                    vueObj.content_Changed()

                } else if (attr_vueObj?.printCellsTab_isActive?.() && content.doc?.cells?.length
                        && Array.isArray(content.doc?.data)) {
                    // вкладка Cells печати: чип со скопированными ЯЧЕЙКАМИ шаблона
                    // (Alt C: CHIP-Cell / область CHIP-Rows — doc.data строки матрицы,
                    // doc.cells координаты выделения) вставляется СТРОКАМИ-узлами
                    // канона, по одной на каждую скопированную ячейку
                    const rowsIdx = [...new Set(content.doc.cells.map(c => c.row))].sort((a, b) => a - b)
                    const nodes = []
                    for (const c of content.doc.cells) {
                        if (!/^col_\d+$/.test(String(c.binding || ''))) continue
                        const r = content.doc.data[rowsIdx.indexOf(c.row)] || {}
                        const ov = r._cells?.[c.binding]
                        const f = (ov?.fields || [])[0] || {}
                        const src = f.source != null ? String(f.source) : String(c.value ?? '').trim()
                        if (!f.binding && !src && !f.title) continue // пустая ячейка
                        const node = {
                            title: f.title ?? '',
                            binding: f.binding ?? '',
                            source_field: (!f.binding && src) ? { value: src } : null,
                            attr_type: f.attr_type || 'AttrStr',
                            row: c.row,
                            col: parseInt(String(c.binding).slice(4)) || c.col,
                        }
                        if (f.format) node.format = f.format
                        if (f.relation_segment) node.relation_segment = f.relation_segment
                        if (f.style) node.style = JSON.parse(JSON.stringify(f.style))
                        if (ov?.colspan > 1) node.colspan = ov.colspan
                        if (ov?.rowspan > 1) node.rowspan = ov.rowspan
                        nodes.push(node)
                    }
                    if (nodes.length) {
                        attr_vueObj.insertAction({ attrs: nodes })
                        store.show_notification(notificationOptions)
                        vueObj.content_Changed()
                    } else {
                        store.show_notification({ text: t('No template cells in the copied range'), status: 'warning' })
                    }

                } else if (content.doc?.data) {
                    const isTargetWHERE = attr_vueObj?.attr?.name === 'viewWHERE'
                    const isSourceData = content.doc?.cells?.length > 0 && !content.doc.data?.[0]?.condition
                    if (isTargetWHERE && isSourceData) {
                        const whereItems = store.transformCellsToWHERE(content.doc.cells, content.doc.fields)
                        if (whereItems.length) {
                            attr_vueObj.insertAction({attrs: whereItems})
                            store.show_notification(notificationOptions)
                            vueObj.content_Changed()
                            return
                        }
                    }

                    attr_vueObj.insertAction({attrs:content.doc.data});
                    store.show_notification(notificationOptions)

                    // обновляем контент виджета Chart...
                    vueObj.content_Changed()

                } else if (store.copiedData) {
                    attr_vueObj.insertAction()
                    store.show_notification(notificationOptions)

                    // обновляем контент виджета Chart...
                    vueObj.content_Changed()

                } else {
                    store.show_notification({ text: t('{source} does not contain valid data', { source: parentName }), status: 'error' })
                }
            }
        },
        pickTextFile({ accept = '.json,.txt,.py', multiple = false } = {}) {
            return new Promise((resolve, reject) => {
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = accept
                input.multiple = !!multiple
                input.style.display = 'none'

                const cleanup = () => {
                    input.value = ''
                    input.remove()
                }

                input.addEventListener('change', () => {
                    const file = input.files && input.files[0]
                    if (!file) {
                        cleanup()
                        reject({ code: 'USER_CANCEL' })
                        return
                    }

                    const reader = new FileReader()
                    reader.onerror = () => {
                        cleanup()
                        reject(reader.error || new Error(t('File read failed')))   // IE 2026 09 23 / ODOO-341407: i18n
                    }
                    reader.onload = () => {
                        const text = String(reader.result || '')
                        cleanup()
                        resolve({ text, file })
                    }

                    reader.readAsText(file)
                })

                document.body.appendChild(input)
                input.click()
            })
        },
        get_events(record) {
            const params = record?.doc?.params || {};
            const events_list = params.events || [];
            const events = {};

            for (const rowEvent of events_list) {
                if (rowEvent?.use === false) continue;

                const event = rowEvent?.event;
                if (!event) continue;

                const name = rowEvent?.name || "";
                if (!events[name]) events[name] = {};

                events[name][event] = rowEvent;
            }

            return events;
        },
        getWIDGET_info(WIDGET, _depth=0) {
            const info = { 
                id: WIDGET.id,
                title: WIDGET.title,
                widget: WIDGET.widget,
                widget_class: WIDGET.widget_class,
                record: {
                    id: WIDGET.record?.id,
                    segment: WIDGET.record?.segment,
                    version: WIDGET.record?.version,
                    meta: WIDGET.record?.meta,
                    _meta: WIDGET.record?._meta,
                }
            }

            if (WIDGET.record?.segment === "WIDGET-LIST") {
                info.record.doc = {
                    params: WIDGET.record.doc?.params,
                }
            }

            // widget-row без record.segment (вложенный попап строки): включить
            // цепочку parentWIDGET вверх до первого виджета с record.segment
            // (владельца записи) включительно — бэк (widget_ROW.set_view →
            // get_field_from__meta) резолвит по ней view попапа из конфига
            if (info.widget === 'widget-row' && !info.record.segment
                && WIDGET.parentWIDGET?.id !== undefined && _depth < 20) {
                const parent = this.findWidget(WIDGET.parentWIDGET.id)?.WIDGET
                if (parent) info.parentWIDGET = this.getWIDGET_info(parent, _depth + 1)
            }

            return info
        },
        getWIDGET_style(WIDGET) {
            let WidgetContainer = $('#WIDGET'+WIDGET.id)[0]
            if (WidgetContainer) {
                return {
                    top: WidgetContainer.style.top,
                    left: WidgetContainer.style.left,
                    width: WidgetContainer.style.width,
                    height: WidgetContainer.style.height,
                    zIndex: WidgetContainer.style.zIndex,
                }
            }
            return {}
        },
        setWIDGET_style(WIDGET, style, clear=true) {
            let WidgetContainer = $('#WIDGET'+WIDGET.id)[0]
            if (WidgetContainer) {
                if (clear) {
                    // точечная очистка: убрать только свойства, которых нет в новом
                    // style (zIndex сохраняется, как раньше) — реквизиты, которые тут
                    // же будут восстановлены, не сбрасываются (без churn/reflow)
                    for (const prop of [...WidgetContainer.style]) {
                        const key = prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase())
                        // display не трогаем: им управляет v-show (widget_close/restore)
                        if (key === 'zIndex' || key === 'display' || key in style) continue
                        WidgetContainer.style.removeProperty(prop)
                    }
                }

                for (let key in style) {
                    if (WidgetContainer.style[key] !== style[key]) {
                        WidgetContainer.style[key] = style[key]
                    }
                }
            }
        },

        // pct (0..1) -> px относительно "внутренней" области страницы (page bounds)
        // axis: 'x' | 'y' | 'w' | 'h'
        pct_to_px(pct, axis, PAGE, fallback = 0) {
            const p = Number(pct);
            if (!Number.isFinite(p)) return fallback;

            const ps = this.getPAGE_size(PAGE)

            // x/y — позиция относительно inner области
            // w/h — размеры относительно inner области
            switch (axis) {
                case 'x': return Math.round(ps.page_left + p * ps.page_width);
                case 'y': return Math.round(ps.page_top  + p * ps.page_height);
                case 'w': return Math.round(p * ps.page_width);
                case 'h': return Math.round(p * ps.page_height);
                default:  return fallback;
            }
        },

        // px -> pct (0..1)
        // axis: 'x' | 'y' | 'w' | 'h'
        px_to_pct(px, axis, PAGE, fallback = 0) {
            const value = Number(px);
            if (!Number.isFinite(value)) return fallback;

            const ps = this.getPAGE_size(PAGE)

            let pct;

            switch (axis) {
                case 'x':
                    pct = (value - ps.page_left) / ps.page_width;
                break;

                case 'y':
                    pct = (value - ps.page_top) / ps.page_height;
                break;

                case 'w':
                    pct = value / ps.page_width;
                break;

                case 'h':
                    pct = value / ps.page_height;
                break;

                default:
                return fallback;
            }

            // ограничиваем 0..1
            return Math.max(0, Math.min(1, +pct.toFixed(6)));
        },

        // Возвращает размер виджета в px (и часть меты)
        // 1) если есть inline style/top/left/width/height -> берём оттуда
        // 2) если нет — берём getBoundingClientRect()
        // 3) если вообще не нашли — берём дефолты
        getWIDGET_size(WIDGET, opts = {}) {
            const {
                fallbackWidth = 320,
                fallbackHeight = 240,
                useDOM = true,
            } = opts;

            const toInt = (v) => {
                const n = parseInt(v ?? '', 10);
                return Number.isFinite(n) ? n : null;
            };

            const st = this.getStyle_WIDGET
                ? (this.getStyle_WIDGET(WIDGET) || {})
                : (WIDGET?.style || {});

            let top    = toInt(st.top);
            let left   = toInt(st.left);
            let width  = toInt(st.width);
            let height = toInt(st.height);

            let rect = null;

            if (useDOM) {
                const el = document.getElementById(`WIDGET${WIDGET?.id}`);
                if (el) {
                rect = el.getBoundingClientRect();

                if (top    == null) top    = Math.round(rect.top);
                if (left   == null) left   = Math.round(rect.left);
                if (!width)  width  = Math.round(rect.width);
                if (!height) height = Math.round(rect.height);
                }
            }

            if (!width)  width  = fallbackWidth;
            if (!height) height = fallbackHeight;
            if (top == null)  top = 0;
            if (left == null) left = 0;

            // ---------- PAGE bounds ----------
            const WORKSPACE = this.WORKSPACES[WIDGET.workspace]
            const PAGE = WORKSPACE.PAGES[WIDGET.page]
            const sp = PAGE?.stylePage || {};
            const pageW = Number(sp.width) || 0;
            const pageH = Number(sp.height) || 0;

            const ps = this.getPAGE_size(PAGE)

            // ---------- px -> pct ----------
            const left_pct   = (left - ps.page_left) / ps.page_width;
            const top_pct    = (top - ps.page_top) / ps.page_height;
            const width_pct  = width / ps.page_width;
            const height_pct = height / ps.page_height;

            const clamp01 = (v) => Math.max(0, Math.min(1, +v.toFixed(6)));

            return {
                top,
                left,
                width,
                height,

                top_pct:    clamp01(top_pct),
                left_pct:   clamp01(left_pct),
                width_pct:  clamp01(width_pct),
                height_pct: clamp01(height_pct),

                rect,
            };
        },

        getPAGE_size(PAGE) {
            // смена процессной модели или стилей: checkPopout/widget_activate успевают
            // дёрнуться, когда активной страницы уже/ещё нет — дефолтная геометрия (ODOO-3720)
            const stylePage = PAGE?.stylePage || this.def_stylePage
            const page_top = stylePage.marginTop + 10
            const page_left = stylePage.marginLeft + 10
            const page_right = stylePage.width - stylePage.marginRight - 10
            const page_bottom = stylePage.height - stylePage.marginBottom - 10
            const page_width = page_right - page_left
            const page_height = page_bottom - page_top

            return {
                page_top,
                page_left,
                page_right,
                page_bottom,
                page_width,
                page_height,
            }
        },

        rescale_popouts(scaleX, scaleY) {
            const store = this
            for (const ws of Object.values(store.WORKSPACES || {})) {
                for (const WIDGET of (ws.ALL_WIDGETS ?? [])) {
                    if (WIDGET?.styleWidget?.dock !== 'popout') continue
                    const el = document.getElementById(`WIDGET${WIDGET.id}`)
                    if (!el) continue
                    const left = parseInt(el.style.left, 10)
                    const top  = parseInt(el.style.top,  10)
                    const w    = parseInt(el.style.width, 10)
                    const h    = parseInt(el.style.height, 10)
                    if (isNaN(left) || isNaN(top) || isNaN(w) || isNaN(h)) continue
                    el.style.left   = Math.round(left * scaleX) + 'px'
                    el.style.top    = Math.round(top  * scaleY) + 'px'
                    el.style.width  = Math.round(w    * scaleX) + 'px'
                    el.style.height = Math.round(h    * scaleY) + 'px'
                }
            }
        },
        checkPopout() {
            const store = this
            if (store.activeWORKSPACE) {
                const WORKSPACE = store.activeWORKSPACE
                const PAGE = WORKSPACE.activePAGE
                const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)

                if (WIDGETS) {
                    let isChanged0 = 0
                    const ps = this.getPAGE_size(PAGE)

                    // геометрия страницы ещё не посчитана (первое открытие:
                    // calculatePage_px не отработал, stylePage без width/height) —
                    // ничего не применять и НЕ «съедать» pct-ректы: иначе стиль
                    // становится NaN, clamp сжимает окно в минимум у левого-верха,
                    // и до ответа бэка виджет висит не на своём месте (два кадра).
                    // Следующий setStyle_afterTimeout применит рект по факту замера
                    if (!Number.isFinite(ps.page_width) || ps.page_width <= 0
                        || !Number.isFinite(ps.page_height) || ps.page_height <= 0) return

                    store.minWidgetWidth = Math.round(ps.page_width * 0.2)
                    store.minWidgetHeight = Math.round(ps.page_height * 0.2)
                    store.minMode_WidgetWidth = Math.round(ps.page_width * 0.2)


                    // -------- setWidgetRect --------
                    for (const WIDGET of WIDGETS) {
                        if (WIDGET.styleWidget?.dock === 'popout' && WIDGET.styleWidget.setWidgetRect) {
                            // контейнер ещё не смонтирован — не «съедать» рект впустую:
                            // его применит checkPopout из mounted() (до первого кадра)
                            if (!document.getElementById(`WIDGET${WIDGET.id}`)) continue
                            const style = {}
                            
                            if (WIDGET.styleWidget.setWidgetRect === 'pct') {
                                style.top = ps.page_top + Math.round((WIDGET.styleWidget.top_pct||0) * ps.page_height)
                                style.left = ps.page_left + Math.round((WIDGET.styleWidget.left_pct||0) * ps.page_width)
                                style.width = Math.round((WIDGET.styleWidget.width_pct||1) * ps.page_width)
                                style.height = Math.round((WIDGET.styleWidget.height_pct||1) * ps.page_height)

                                style.top += 'px'
                                style.left += 'px'
                                style.width += 'px'
                                style.height += 'px'
                            } else if (WIDGET.styleWidget.setWidgetRect === 'px') {
                                const r = WIDGET.styleWidget._savedRect
                                if (r) {
                                    style.top = r.top
                                    style.left = r.left
                                    style.width = r.width
                                    style.height = r.height
                                }
                            }
                            store.setWIDGET_style(WIDGET, style, false)

                            WIDGET.styleWidget.setWidgetRect = ''
                            // рект применён — окно можно показывать (widget-unplaced)
                            WIDGET._placed = true

                            isChanged0++
                        }
                    }

                    // -------- 1) clamp размеров/границ --------
                    for (const WIDGET of WIDGETS) {
                        if (WIDGET.styleWidget?.dock === 'popout') {
                            let style = store.getWIDGET_style(WIDGET)
                            let isChanged = false

                            style.top = parseInt(style.top||0, 10)
                            style.left = parseInt(style.left||0, 10)
                            style.width = parseInt(style.width||0, 10)
                            style.height = parseInt(style.height||0, 10)

                            if (style.top < ps.page_top) {
                                const delta = ps.page_top - style.top
                                style.top += delta
                                style.height -= delta
                                isChanged = true
                            }
                            
                            if (style.left <= ps.page_left) {
                                const delta = ps.page_left - style.left
                                style.left += delta
                                style.width -= delta
                                isChanged = true
                            }

                            if (style.left + style.width > ps.page_right) {
                                style.width = ps.page_right - style.left
                                isChanged = true
                            }
                            if (style.top + style.height > ps.page_bottom) {
                                style.height = ps.page_bottom - style.top
                                isChanged = true
                            }

                            // if (style.top > ps.page_bottom - store.minWidgetHeight) {
                            //     style.top = ps.page_bottom - store.minWidgetHeight
                            //     isChanged = true
                            // }

                            // if (style.left > ps.page_right - store.minWidgetWidth) {
                            //     style.left = ps.page_right - store.minWidgetWidth
                            //     isChanged = true
                            // }

                            // if (style.width < store.minWidgetWidth) {
                            //     style.width = store.minWidgetWidth
                            //     isChanged = true
                            // }
                            // if (style.height < store.minWidgetHeight) {
                            //     style.height = store.minWidgetHeight
                            //     isChanged = true
                            // }

                            if (style.width < store.minWidgetWidth || style.height < store.minWidgetHeight) {
                                if (style.width < (store.minWidgetWidth * .5) || style.height < (store.minWidgetHeight * .5)) {
                                    // если виджет обрезался до минимальных размеров
                                    WIDGET.styleWidget.minMode = true
                                    if (style.width !== store.minMode_WidgetWidth) {
                                        style.width = store.minMode_WidgetWidth
                                        isChanged = true
                                    }

                                    if (style.height !== store.minMode_WidgetHeight) {
                                        style.height = store.minMode_WidgetHeight
                                        isChanged = true
                                    }
                                } else {
                                    if (style.width < store.minWidgetWidth) {
                                        style.width = store.minWidgetWidth
                                        isChanged = true
                                    }
                                    if (style.height < store.minWidgetHeight) {
                                        style.height = store.minWidgetHeight
                                        isChanged = true
                                    }
                                    WIDGET.styleWidget.minMode = false
                                }
                            } else {
                                WIDGET.styleWidget.minMode = false
                            }

                            if (style.left + style.width > ps.page_right) {
                                style.left = ps.page_right - style.width
                                isChanged = true
                            }
                            if (style.top + style.height > ps.page_bottom) {
                                style.top = ps.page_bottom - style.height
                                isChanged = true
                            }

                            if (isChanged) {
                                style.top += 'px'
                                style.left += 'px'
                                style.width += 'px'
                                style.height += 'px'

                                store.setWIDGET_style(WIDGET, style, false)
                                isChanged0++
                            }

                        }
                    }

                    store.checkPopout_zIndex()
                    // IE 2026 08 19: z попаутов изменился — слой линий связи пересчитать
                    try { store.activeWORKSPACE?.activePAGE?.vueObj?.svg_updateZ?.() } catch (e) { /* страница без линий */ }
                    store.refresh_pageWidgets(WORKSPACE.workspace, PAGE.page)

                    // -------- 2) при наложении виджетов сместить выше и левее --------
                    if (store.activeWORKSPACE) {
                        const overlap = (a, b) => {
                            const minW = store.minMode_WidgetWidth
                            const minH = store.minMode_WidgetHeight

                            // A: min-rect + margin
                            const ax0 = a.left// - store.marginWidget
                            const ay0 = a.top//  - store.marginWidget
                            const ax1 = a.left + minW// + store.marginWidget
                            const ay1 = a.top  + minH// + store.marginWidget

                            // B: min-rect + margin
                            const bx0 = b.left
                            const by0 = b.top
                            const bx1 = b.left + minW 
                            const by1 = b.top  + minH

                            // 1) обычное пересечение
                            const isOverlap = (ax0 < bx1 && ax1 > bx0 && ay0 < by1 && ay1 > by0)
                            
                            const isAMin = a.height === store.minMode_WidgetHeight
                            const isBMin = b.height === store.minMode_WidgetHeight

                            return isOverlap && isAMin && isBMin
                        }
                        const coveredByB = (a, b) => {
                            // 2) B полностью закрывает A
                            const isCoveredByB = (b.left <= a.left && b.top <= a.top && b.left + b.width >= a.left + a.width && b.top + b.height >= a.top + a.height)
                            const isCovered_equal = (b.left === a.left && b.top === a.top && b.left + b.width === a.left + a.width && b.top + b.height === a.top + a.height)
                            const isCoveredByA = (a.left <= b.left && a.top <= b.top && a.left + a.width >= b.left + b.width && a.top + a.height >= b.top + b.height)

                            const isAMin = a.height === store.minMode_WidgetHeight
                            const isBMin = b.height === store.minMode_WidgetHeight

                            return (isCoveredByB && isAMin && isBMin) || isCovered_equal
                        }

                        const clampRect = (r) => {
                            // min размеры
                            r.width  = Math.max(store.minMode_WidgetWidth,  r.width)
                            r.height = Math.max(store.minMode_WidgetHeight, r.height)

                            // "внутренние" границы с учетом store.marginWidget
                            const leftBound   = ps.page_left   + store.marginWidget
                            const topBound    = ps.page_top    + store.marginWidget
                            const rightBound  = ps.page_right  - store.marginWidget
                            const bottomBound = ps.page_bottom - store.marginWidget

                            // правая/нижняя граница (позиция)
                            if (r.left + r.width > rightBound)  r.left = rightBound - r.width
                            if (r.top  + r.height > bottomBound) r.top  = bottomBound - r.height

                            // левая/верхняя граница (позиция)
                            if (r.left < leftBound) r.left = leftBound
                            if (r.top  < topBound)  r.top  = topBound

                            // повторно (если после сдвигов ширина/высота всё равно не помещается)
                            // тут важно: правый/нижний предел уже "сжат" store.marginWidget
                            const maxW = Math.max(store.minMode_WidgetWidth,  rightBound - r.left)
                            const maxH = Math.max(store.minMode_WidgetHeight, bottomBound - r.top)

                            if (r.width > maxW)  r.width = maxW
                            if (r.height > maxH) r.height = maxH

                            isChanged0++

                            return r
                        }

                        const popouts = WIDGETS
                            .filter(w => w.styleWidget?.dock === 'popout')
                            .map((w, idx) => {
                            const s = store.getWIDGET_style(w) || {}
                            const rect = {
                                WIDGET: w,
                                order: idx,
                                z: parseInt(s.zIndex || 0, 10) || 0,
                                top: parseInt(s.top || 0, 10) || 0,
                                left: parseInt(s.left || 0, 10) || 0,
                                width: parseInt(s.width || store.minMode_WidgetWidth, 10) || store.minMode_WidgetWidth,
                                height: parseInt(s.height || store.minMode_WidgetHeight, 10) || store.minMode_WidgetHeight,
                            }
                            clampRect(rect)
                            return rect
                        })
                        // кто "выше" по zIndex — считаем уже “уложенным”, двигаем следующих
                        .sort((a, b) => (b.z - a.z) || (b.order - a.order))

                        const placed = []
                        const STEP = 5              // шаг смещения (можно 12/16/20)
                        const MAX_TRIES = 200        // защита от бесконечного цикла

                        for (const r of popouts) {
                            let tries = 0

                            // пока есть пересечение — сдвигаем вверх+влево
                            while (tries++ < MAX_TRIES) {
                                let hit = false
                                for (const p of placed) {
                                    if (overlap(r, p)) {
                                        hit = 'r'
                                        break
                                    }
                                    if (coveredByB(r, p) && p.z > r.z) {
                                        hit = 'rz'
                                        break
                                    }
                                    // if (coveredByB(p, r) && r.z > p.z) {
                                    //     hit = 'p'
                                    //     break
                                    // }
                                }
                                if (!hit) break

                                r.left -= STEP
                                r.top -= STEP
                                clampRect(r)

                                // если упёрлись в верх/лево — начнём "съезжать" только вверх или только влево
                                // (минимальное усложнение, чтобы меньше залипало)
                                if (r.left === ps.page_left && r.top === ps.page_top) break
                            }

                            placed.push(r)

                            // применяем в WIDGET если изменилось
                            const w = r.WIDGET
                            const style0 = store.getWIDGET_style(w) || {}
                            const top0 = parseInt(style0.top || 0, 10) || 0
                            const left0 = parseInt(style0.left || 0, 10) || 0
                            const width0 = parseInt(style0.width || 0, 10) || 0
                            const height0 = parseInt(style0.height || 0, 10) || 0

                            if (top0 !== r.top || left0 !== r.left || width0 !== r.width || height0 !== r.height) {
                                const style = { ...style0 }
                                style.top = r.top + 'px'
                                style.left = r.left + 'px'
                                style.width = r.width + 'px'
                                style.height = r.height + 'px'
                                
                                store.setWIDGET_style(w, style, false)
                                isChanged0++
                            }
                        }
                    }

                    if (isChanged0) {
                        PAGE.vueObj.refreshe_svg()
                    }
                }
            }
        },
        checkPopout_zIndex() {
            const store = this
            if (store.activeWORKSPACE) {
                const WORKSPACE = store.activeWORKSPACE
                const PAGE = WORKSPACE.activePAGE
                const WIDGETS = (WORKSPACE.ALL_WIDGETS ?? []).filter(w => w.page === PAGE.page)

                // ---------------- zIndex ranking for popout ----------------
                const popouts = WIDGETS.filter(w => w?.styleWidget?.dock === 'popout');
                if (popouts.length) {
                    // текущие zIndex (если нет — 0)
                    const zOf = (w) => {
                        const st = store.getWIDGET_style(w) || {};
                        const z = parseInt(st.zIndex ?? w.styleWidget?.zIndex ?? 0, 10);
                        return Number.isFinite(z) ? z : 0;
                    };

                    // сортируем: сначала неактивные (по текущему z), активный — в конец
                    const active = store.activeWIDGET;
                    const sorted = popouts
                    .slice()
                    .sort((a, b) => {
                        // widget-row поверх остальных, если его родитель — активный виджет
                        const isTopRow = (w) => {
                            if (w.widget !== 'widget-row') return 0
                            if (w === active) return 1
                            if (active && w.parentWIDGET?.id === active.id) return 1
                            return 0
                        }
                        const aRow = isTopRow(a);
                        const bRow = isTopRow(b);
                        if (aRow !== bRow) return aRow - bRow;
                        // каскад (задача 13): child widget-row всегда выше своего
                        // родителя-row, независимо от того, кто из них активен —
                        // иначе при активном родителе тай-брейк «активный выше»
                        // ставил View/Row-ребёнка ПОД родителя (после refresh этот
                        // прогон checkPopout оказывается последним и фиксирует инверсию)
                        if (aRow && bRow) {
                            const dd = (a._cascadeDepth || 0) - (b._cascadeDepth || 0);
                            if (dd !== 0) return dd;
                        }

                        const aActive = active && a === active ? 1 : 0;
                        const bActive = active && b === active ? 1 : 0;
                        if (aActive !== bActive) return aActive - bActive; // активный позже (выше)
                        return zOf(a) - zOf(b); // стабильный порядок по текущему z
                    });

                    // назначаем последовательные zIndex
                    // (при этом не трогаем top/left/width/height, только zIndex)
                    let zi = store.popout_baseZ;
                    for (const w of sorted) {
                        const style = store.getWIDGET_style(w) || {};
                        const oldZ = parseInt(style.zIndex ?? 0, 10) || 0;

                        if (oldZ !== zi) {
                            style.zIndex = zi + '';
                            // необязательно, но удобно держать и в модели:
                            w.styleWidget = w.styleWidget || {};
                            w.styleWidget.zIndex = zi;

                            // не очищать полностью style — ты уже это учёл в setWIDGET_style
                            store.setWIDGET_style(w, style, false);
                        }
                        zi += 1;
                    }
                }

                // очистим zIndex для не popout виджетов, чтобы не мешало
                const nopopouts = WIDGETS.filter(w => w?.styleWidget?.dock !== 'popout');
                if (popouts.length) {
                    for (const w of nopopouts) {
                        const style = store.getWIDGET_style(w) || {};
                        if (style.zIndex) {
                            style.zIndex = ''
                            store.setWIDGET_style(w, style, false);
                        }
                    }
                }

            }
        },

        // IE 2026 09 16 (замечание Игоря: клик по строке 52 дерева раскладки открывал окно строки 8): путь строки ищется по ТОЖДЕСТВУ
        // объекта (toRaw — строка может прийти прокси Vue), а не по маркеру $cutMarker: этот же ключ — маркер вырезанных строк грида
        // (cut / paste, Alt+drag), он попадал в сохранённые записи (17 записей dev02), и обход находил чужую помеченную строку раньше нужной
        iroot(dataItem, data, childItemsPath='attrs') {
            if (!dataItem || !Array.isArray(data)) return ''
            const target = toRaw(dataItem)
            const def_iroot = (rows) => {
                for (let irow = 0; irow < rows.length; irow++) {
                    const row = rows[irow]
                    if (!row || typeof row !== 'object') continue
                    if (row === target || toRaw(row) === target) return String(irow)
                    const kids = childItemsPath ? row[childItemsPath] : null
                    if (Array.isArray(kids) && kids.length) {
                        const iroot1 = def_iroot(kids)
                        if (iroot1) return String(irow) + '.' + childItemsPath + '.' + iroot1
                    }
                }
                return ''
            }
            return def_iroot(data)
        },
        set_widgetRow_view(WIDGET) {
            const store = this

            WIDGET.view = [
                {'attr_type':'AttrTabPanel', 'attrs':[ 
                    {'name':'AttrTab-row', 'attr_type':'AttrTab', 'tooltip': t('Line'), 'pi':'pi pi-home', 'attrs':[   // IE 2026 09 23 / ODOO-341407: i18n (подписи вида widget-row)
                        {'attr_type':'AttrTabGrid', 'name':'main-AttrTabGrid', 'attrs':[] } 
                    ]},

                    {'attr_type':'AttrTab', 'tooltip': t('JSON'), 'pi':'pi pi-database', 'attrs':[
                        {'binding':'_widget.record._record', 'attr_type':'AttrJSON'},
                    ]},

                    {'use':false, 'attr_type':'AttrTab', 'name':'tab-MasterData'},
                ]},
            ]
            
            WIDGET.groupMenu = {
                commandPanel: [
                    { 'name':'non-empty-widget', 'hotkey': 'Alt A', 'active':true, 'title': t('Hide empty rows, columns, tabs'), 'command': 'set_nonEmptyWidget', 'cssClass':'set_nonEmptyWidget pi p-button-white pi-circle'},
                    // { 'name':'isMapped-widget', 'active':true, 'title': 'Hide mapped rows, columns, tabs', 'command': 'set_isMappedWidget', 'cssClass':'pi p-button-white pi-link'}
                ],
                actionMenu: [],
            }

            store.prepare_attrs(WIDGET.view, `WRow${WIDGET.id}`)
            store.prepare_attrs(WIDGET.groupMenu.commandPanel, `WRow${WIDGET.id}`)
        },

        // зеркало бэковского _find_field_branches (common_modules/widgets.py):
        // 1-я фаза — BFS по веткам (табы/группировки), внутрь AttrGrid не
        // заходим (их attrs — колонки, view — карточка строки), ближний к
        // корню узел приоритетнее; 2-я фаза — только если по веткам не
        // нашлось — внутри отложенных AttrGrid'ов, рекурсивно с тем же
        // порядком
        findFieldBranches(nodes, binding, key = 'binding') {
            if (binding == null) return null
            const queue = [...(nodes || [])], deferred = []
            while (queue.length) {
                const node = queue.shift()
                if (!node) continue
                if (node[key] === binding) return node
                const children = [
                    ...(Array.isArray(node.attrs) ? node.attrs : []),
                    ...(Array.isArray(node.view) ? node.view : []),
                ]
                if (node.attr_type === 'AttrGrid') deferred.push(...children)
                else queue.push(...children)
            }
            for (const child of deferred) {
                const found = this.findFieldBranches([child], binding, key)
                if (found) return found
            }
            return null
        },

        set_activeAttr(view, activeAttr, WIDGET) {
            const store = this
            const binding = activeAttr.binding
            // console.log('set_activeAttr', binding, 'rowIndex:', activeAttr.rowIndex, 'view:', JSON.stringify(view?.map(a => ({name:a.name, binding:a.binding, attr_type:a.attr_type, attrs: a.attrs?.map(b => ({name:b.name, binding:b.binding, attr_type:b.attr_type}))}))))

            // каскадный (скоуповый) поиск целевого узла по пути биндингов —
            // зеркало бэковского get_field_from__meta (common_modules/widgets.py):
            // на каждом шаге поиск ТОЛЬКО внутри узла предыдущего шага (сначала
            // его view — карточка строки, потом attrs — колонки); binding —
            // основной ключ, name — запасной внутри того же скоупа. Дубли
            // name/binding в чужих ветках view так не конфликтуют.
            // path задаётся относительно переданной view: для попапа строки
            // префикс пути от сегментного виджета уже разрешён при построении
            // этой view (бэк, get_field_from__meta по цепочке parentWIDGET)
            const path = (Array.isArray(activeAttr.path) && activeAttr.path.length)
                ? activeAttr.path : [binding]
            let target = null
            let scopeView = view || [], scopeAttrs = []
            for (const b of path) {
                target = store.findFieldBranches(scopeView, b)
                    ?? store.findFieldBranches(scopeAttrs, b)
                    ?? store.findFieldBranches(scopeView, b, 'name')
                    ?? store.findFieldBranches(scopeAttrs, b, 'name')
                if (!target) break
                scopeView = Array.isArray(target.view) ? target.view : []
                scopeAttrs = Array.isArray(target.attrs) ? target.attrs : []
            }
            if (!target) {
                // IE 2026 09 28 / ODOO-5800: узел — во вкладке настроек, которая ещё не загружена (каркас формы): догрузить форму и повторить переход
                if (!activeAttr._sflRetry) {
                    const W_ = (WIDGET && WIDGET.view === view) ? WIDGET : store.settingsForm_ownerOfView(view)
                    if (W_ && sfl_stubs(W_).length) {
                        store.settingsForm_ensure(W_, 'activeAttr').then(ok => { if (ok) store.set_activeAttr(W_.view, { ...activeAttr, _sflRetry: true }, W_) })
                    }
                }
                return
            }

            // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): строка табличной части по значению поля (relation_row: row_match {field, value}) — индекс в данных записи по binding найденного грида;
            // не найдено — только вкладка (и тост); грид при загрузке пересверяет строку по своим строкам (selectRow_match — сортировка / группировка) и,
            // если open_row, открывает её карточку как карандаш строки (AttrGrid.load_data → relationRow_openSelected)
            if (activeAttr.row_match && activeAttr.rowIndex == null && (target.attr_type === 'AttrGrid' || target.attr_type === 'AttrTabGrid')) {
                const rows_ = WIDGET?.record ? store.get_value(WIDGET.record, target.binding || activeAttr.grid_binding) : null
                const idx_ = relationRow_rowIndex(rows_, activeAttr.row_match)
                if (idx_ >= 0) {
                    activeAttr = { ...activeAttr, rowIndex: idx_ }
                    target.selectRow_match = { ...activeAttr.row_match }
                    if (activeAttr.open_row) target.selectRow_openRow = true
                } else if (Array.isArray(rows_)) {
                    store.show_notification({ status: 'warning', text: t('Row {field} = {value} is not found in {table}: the record is open without a selected row.', {
                        field: activeAttr.row_match.field, value: String(activeAttr.row_match.value), table: target.title || target.name || target.binding || '' }) })
                }
            }

            const activateTab = (curTabPanel, curTabIndex) => {
                curTabPanel.selectedIndex = curTabIndex
                const tab = curTabPanel.attrs[curTabIndex]
                if (tab) {
                    tab.hide = false
                    tab.showEmpty = true
                }
                // set Wijmo TabPanel control directly
                if (WIDGET) {
                    const vueObj = WIDGET.attrs_vueObj?.[curTabPanel.id]
                    if (vueObj?.tabPanel && vueObj.tabPanel.selectedIndex !== curTabIndex) {
                        vueObj.tabPanel.selectedIndex = curTabIndex
                    }
                }
            }
            const find = (attrs, tabPanel, tabIndex) => {
                for (let i = 0; i < attrs.length; i++) {
                    const attr = attrs[i]

                    let curTabPanel = tabPanel
                    let curTabIndex = tabIndex
                    const parentPanel = tabPanel, parentIndex = tabPanel && tabPanel.attrs === attrs ? i : tabIndex   // IE 2026 10 29 / ODOO-5800 (проба p093: панель вкладок прямо в attrs другой панели — tab-approval в верхней панели; вкладка родителя не включалась)
                    if (attr.attr_type === 'AttrTabPanel') {
                        curTabPanel = attr
                        curTabIndex = null
                    }
                    if (curTabPanel && (attr.attr_type === 'AttrTab' || curTabPanel.attrs === attrs)) {
                        curTabIndex = i
                    }

                    // целевой узел уже разрешён каскадным поиском — здесь
                    // только активация цепочки вкладок до него (по ссылке)
                    if (attr === target) {
                        if (curTabPanel && curTabIndex != null) {
                            activateTab(curTabPanel, curTabIndex)
                        }
                        if (attr.attr_type === 'AttrTabPanel' && parentPanel && parentIndex != null) activateTab(parentPanel, parentIndex)   // IE 2026 10 29 / ODOO-5800 (проба p093: панель вкладок прямо в attrs другой панели — tab-approval в верхней панели; вкладка родителя не включалась)
                        if (activeAttr.rowIndex != null) {
                            // set selectRow on the AttrGrid inside this attr (or on attr itself if it's a grid)
                            const setSelectRow = (a) => {
                                if (a.attr_type === 'AttrGrid' || a.attr_type === 'AttrTabGrid') {
                                    a.selectRow = activeAttr.rowIndex
                                    if (activeAttr.rowIndex2 != null) a.selectRow2 = activeAttr.rowIndex2
                                    return true
                                }
                                if (a.attrs) {
                                    for (const child of a.attrs) {
                                        if (setSelectRow(child)) return true
                                    }
                                }
                                return false
                            }
                            setSelectRow(attr)
                        }
                        return true
                    }

                    if (attr.attrs && find(attr.attrs, curTabPanel, curTabIndex)) {
                        if (curTabPanel && curTabIndex != null) {
                            activateTab(curTabPanel, curTabIndex)
                        }
                        if (attr.attr_type === 'AttrTabPanel' && parentPanel && parentIndex != null) activateTab(parentPanel, parentIndex)   // IE 2026 10 29 / ODOO-5800 (проба p093: панель вкладок прямо в attrs другой панели — tab-approval в верхней панели; вкладка родителя не включалась)
                        return true
                    }
                }
                return false
            }
            const found = find(view||[], null, null)
            // console.log('set_activeAttr result:', found)
        },

        // ODOO-4334: сырое значение активной ячейки грида — то, что лежит в данных,
        // а не то, что нарисовано. У колонки-ссылки dataMap показывает титул, а граф
        // ссылок знает только id; getCellData(..., false) отдаёт значение до подмены.
        getGridCellRawValue(e) {
            const grid = this.findFlexGridFromEvent(e)
            const sel = grid?.selection
            if (!grid || !sel || sel.row < 0 || sel.col < 0) return ''
            const value = grid.getCellData(sel.row, sel.col, false)
            return (typeof value === 'string' || typeof value === 'number') ? String(value) : ''
        },
        // webscm 2026 10 25 / ODOO-4334 (шаг 1): на ЧТО ссылается активная ячейка — { id, segment } или null (тогда ищется сырое значение,
        // как раньше). Ссылка Odoo показывает имя (колонка '<поле>[1]'), а граф знает id и модель: id — элемент [0] значения строки, модель —
        // relation_segment колонки; ячейка id своей записи — сегмент записи. Описание колонки — у грида (AttrGrid.attr_by_binding, хост __vueGrid)
        getGridCellRef(e) {
            const grid = this.findFlexGridFromEvent(e)
            const sel = grid?.selection
            if (!grid || !sel || sel.row < 0 || sel.col < 0) return null
            const col = grid.columns[sel.col]
            const attr = (col && grid.hostElement?.__vueGrid?.attr_by_binding?.[col.binding]) || null
            // webscm 2026 10 25 / ODOO-4334 (форма записи): запись формы — тем же attr_get, которым заполнены строки формы (у widget-row — строка родителя)
            const W = grid.hostElement?.__vueGrid?.WIDGET
            const getRecord = () => (W?.record ? { id: this.attr_get(W, { binding: 'id' }), segment: this.attr_get(W, { binding: 'segment' }) } : null)
            return refs_cellRef({ attr, colBinding: col?.binding, raw: grid.getCellData(sel.row, sel.col, false),
                dataItem: grid.rows[sel.row]?.dataItem, getValue: (item, binding) => this.get_value(item, binding), getRecord })
        },
        findFlexGridFromEvent(e) {
            const target = e.target;

            if (!target) return null;

            // 1️⃣ Если внутри Wijmo grid
            const gridHost = target.closest('.wj-flexgrid');

            if (!gridHost) return null;

            // 2️⃣ Получаем сам FlexGrid инстанс
            const ctl = wjcCore.Control.getControl(gridHost);

            if (ctl && ctl instanceof wjcGrid.FlexGrid) {
                return ctl;
            }

            return null;
        },
        findWidgetFromEvent(e) {
            const el = e.target?.closest('.WIDGET');
            if (!el) return null;

            const widgetId = el.id?.replace('WIDGET', '');
            if (!widgetId) return null;

            return this.findWidget(widgetId);
        },
        checkWIDGET_dock(WIDGET, parentWIDGET=null) {
            if (WIDGET.styleWidget?.dock === 'popout' && !WIDGET.styleWidget.setWidgetRect) {
                const store = this
                const PAGE = store.activeWORKSPACE?.activePAGE
                // const parentWIDGET = store.findWidget(WIDGET.parentWIDGET?.id).WIDGET

                const min_pct_w = store.px_to_pct(store.headerWidgetHeight + store.marginWidget, 'w', PAGE)
                const min_pct_h = store.px_to_pct(store.headerWidgetHeight + store.marginWidget, 'h', PAGE)
                
                WIDGET.styleWidget.setWidgetRect = 'pct'
                
                let parent_size
                if (parentWIDGET && parentWIDGET.styleWidget?.dock === 'popout') {
                    parent_size = store.getWIDGET_size(parentWIDGET)
                }
                WIDGET.styleWidget.top_pct = (parent_size?.top_pct||0) + min_pct_h
                WIDGET.styleWidget.height_pct = .9
                WIDGET.styleWidget.left_pct = (parent_size?.left_pct||0) + min_pct_w
                WIDGET.styleWidget.width_pct = .9
            }
        },
        // ---------------- widget-row: раскладка попапа ----------------
        // ключ хранения позиции: тип источника (виджет-родитель + тип/binding
        // ячейки), а не id экземпляра — размер переживает переоткрытие родителя
        widgetRowRect_key(WIDGET) {
            const pa = WIDGET.parentAction
            return `widget-row::${WIDGET.parentWIDGET?.widget ?? ''}::${pa?.type ?? ''}::${pa?.binding ?? ''}`
        },
        // начальные размеры попапа из WIDGET.layout ответа widget_open
        // ({width, height_min, height_fit_rows} — % рабочей области);
        // сохранённое пользователем положение приоритетнее
        apply_widgetRow_layout(WIDGET) {
            const store = this,
            layout = WIDGET.layout
            if (!layout || WIDGET.styleWidget?.dock !== 'popout') return
            // компактный размер — только для попапа из AttrChart (исходный кейс
            // «ужать»); остальные Row-попапы открываются штатным размером
            if (WIDGET.parentAction?.source_attr_type !== 'AttrChart') return
            // авто-рект прошлого открытия уже применён при prime — не пересбрасывать
            // на height_min (иначе флеш «кэш → height_min → fit»); fit подстроит высоту
            const _rectKey = store.widgetRowRect_key(WIDGET)
            if (store._widgetRowRects[_rectKey] || store._widgetRowRects_auto[_rectKey]) return
            const width_pct = (Number(layout.width) || 20) / 100
            WIDGET.styleWidget.setWidgetRect = 'pct'
            WIDGET.styleWidget.width_pct = width_pct
            WIDGET.styleWidget.height_pct = (Number(layout.height_min) || 20) / 100
            if (!WIDGET.parentAction?.widgetRow_params) {
                // позиция по умолчанию — правый верх, каскад лестницей влево
                WIDGET.styleWidget.top_pct = .1
                WIDGET.styleWidget.left_pct = (1 - width_pct) - (WIDGET._cascadeDepth || 0) * width_pct
            }
            store.checkPopout()
        },
        // height_fit_rows: высота попапа по содержимому main-AttrTabGrid
        // (шапка виджета + командная панель + фактически видимые строки, с иерархией);
        // нижняя граница — layout.height_min, верхняя — рабочая область
        fit_widgetRow_height(vueObj) {
            const store = this,
            WIDGET = vueObj.WIDGET,
            layout = WIDGET.layout
            if (!layout?.height_fit_rows || WIDGET.styleWidget?.dock !== 'popout') return
            // подгонка по строкам — парная к компактному layout (только AttrChart)
            if (WIDGET.parentAction?.source_attr_type !== 'AttrChart') return
            if (store._widgetRowRects[store.widgetRowRect_key(WIDGET)]) return
            const flex = vueObj.flex,
            WidgetContainer = document.getElementById(`WIDGET${WIDGET.id}`)
            if (!flex?.hostElement || !WidgetContainer || flex.hostElement.offsetParent === null) return
            // строки ещё не построены (скелет до/во время загрузки) — не сжимать
            // к height_min: даёт «пульс» размера при (пере)открытии
            if (!flex.rows.length) return
            const PAGE = store.WORKSPACES[WIDGET.workspace]?.PAGES[WIDGET.page]
            if (!PAGE) return
            const ps = store.getPAGE_size(PAGE)
            const content_h = flex.columnHeaders.rows.getTotalSize() + flex.rows.getTotalSize() + 2
            let height = WidgetContainer.offsetHeight + Math.round(content_h - flex.hostElement.clientHeight)
            height = Math.max(height, Math.round((Number(layout.height_min) || 20) / 100 * ps.page_height))
            height = Math.min(height, ps.page_height)
            let top = parseInt(WidgetContainer.style.top || 0, 10)
            if (top + height > ps.page_bottom) {
                top = Math.max(ps.page_top, ps.page_bottom - height)
            }
            store.setWIDGET_style(WIDGET, { top: `${top}px`, height: `${height}px` }, false)
            // финальный авто-рект — в кэш: при переоткрытии попап сразу
            // рисуется этим размером, без флеша дефолт → layout → fit
            store._widgetRowRects_auto[store.widgetRowRect_key(WIDGET)] = {
                top: `${top}px`,
                left: WidgetContainer.style.left,
                width: WidgetContainer.style.width,
                height: `${height}px`,
            }
            store.checkPopout()
        },
        hashToUUID(str) {
            const h = (s, seed) => {
                let x = seed | 0
                for (let i = 0; i < s.length; i++) x = Math.imul(x ^ s.charCodeAt(i), 2654435761)
                return ((x ^ x >>> 16) >>> 0).toString(16).padStart(8, '0')
            }
            const [a, b, c, d] = [h(str, 0), h(str, 1), h(str, 2), h(str, 3)]
            const v = (parseInt(c[0], 16) & 3 | 8).toString(16)
            return `${a}-${b.slice(0,4)}-4${b.slice(4,7)}-${v}${c.slice(1,4)}-${c.slice(4)}${d}`
        },


    },
})
